(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7391"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7391"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2GWz0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1f5cee82b3f134af$export$ffb0004e005737fa; }, function (v) { return $1f5cee82b3f134af$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1f5cee82b3f134af$export$34b9dba7ce09269b; }, function (v) { return $1f5cee82b3f134af$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1f5cee82b3f134af$export$25062201e9e25d76; }, function (v) { return $1f5cee82b3f134af$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1f5cee82b3f134af$export$ffb0004e005737fa;
var $1f5cee82b3f134af$export$34b9dba7ce09269b;
var $1f5cee82b3f134af$export$25062201e9e25d76;
"use strict";

var $8SyCD = parcelRequire("8SyCD");
var $1f5cee82b3f134af$var$k = Symbol["for"]("react.element"), $1f5cee82b3f134af$var$l = Symbol["for"]("react.fragment"), $1f5cee82b3f134af$var$m = Object.prototype.hasOwnProperty, $1f5cee82b3f134af$var$n = $8SyCD.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1f5cee82b3f134af$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1f5cee82b3f134af$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1f5cee82b3f134af$var$m.call(a, b) && !$1f5cee82b3f134af$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1f5cee82b3f134af$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1f5cee82b3f134af$var$n.current
    };
}
$1f5cee82b3f134af$export$ffb0004e005737fa = $1f5cee82b3f134af$var$l;
$1f5cee82b3f134af$export$34b9dba7ce09269b = $1f5cee82b3f134af$var$q;
$1f5cee82b3f134af$export$25062201e9e25d76 = $1f5cee82b3f134af$var$q;

});
parcelRegister("8SyCD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("klqo9"));

});
parcelRegister("klqo9", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $ecfa3d0b44db3c2c$export$dca3b0875bd9a954; }, function (v) { return $ecfa3d0b44db3c2c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ecfa3d0b44db3c2c$export$16fa2f45be04daa8; }, function (v) { return $ecfa3d0b44db3c2c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ecfa3d0b44db3c2c$export$ffb0004e005737fa; }, function (v) { return $ecfa3d0b44db3c2c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ecfa3d0b44db3c2c$export$e2c29f18771995cb; }, function (v) { return $ecfa3d0b44db3c2c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ecfa3d0b44db3c2c$export$221d75b3f55bb0bd; }, function (v) { return $ecfa3d0b44db3c2c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ecfa3d0b44db3c2c$export$5f8d39834fd61797; }, function (v) { return $ecfa3d0b44db3c2c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ecfa3d0b44db3c2c$export$74bf444e3cd11ea5; }, function (v) { return $ecfa3d0b44db3c2c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ecfa3d0b44db3c2c$export$ae55be85d98224ed; }, function (v) { return $ecfa3d0b44db3c2c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ecfa3d0b44db3c2c$export$e530037191fcd5d7; }, function (v) { return $ecfa3d0b44db3c2c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ecfa3d0b44db3c2c$export$fd42f52fd3ae1109; }, function (v) { return $ecfa3d0b44db3c2c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ecfa3d0b44db3c2c$export$c8a8987d4410bf2d; }, function (v) { return $ecfa3d0b44db3c2c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $ecfa3d0b44db3c2c$export$d38cd72104c1f0e9; }, function (v) { return $ecfa3d0b44db3c2c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $ecfa3d0b44db3c2c$export$7d1e3a5e95ceca43; }, function (v) { return $ecfa3d0b44db3c2c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ecfa3d0b44db3c2c$export$257a8862b851cb5b; }, function (v) { return $ecfa3d0b44db3c2c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ecfa3d0b44db3c2c$export$a8257692ac88316c; }, function (v) { return $ecfa3d0b44db3c2c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ecfa3d0b44db3c2c$export$488013bae63b21da; }, function (v) { return $ecfa3d0b44db3c2c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ecfa3d0b44db3c2c$export$7c73462e0d25e514; }, function (v) { return $ecfa3d0b44db3c2c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ecfa3d0b44db3c2c$export$7568632d0d33d16d; }, function (v) { return $ecfa3d0b44db3c2c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $ecfa3d0b44db3c2c$export$88948ce120ea2619; }, function (v) { return $ecfa3d0b44db3c2c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ecfa3d0b44db3c2c$export$35808ee640e87ca7; }, function (v) { return $ecfa3d0b44db3c2c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ecfa3d0b44db3c2c$export$fae74005e78b1a27; }, function (v) { return $ecfa3d0b44db3c2c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ecfa3d0b44db3c2c$export$dc8fbce3eb94dc1e; }, function (v) { return $ecfa3d0b44db3c2c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ecfa3d0b44db3c2c$export$6a7bc4e911dc01cf; }, function (v) { return $ecfa3d0b44db3c2c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ecfa3d0b44db3c2c$export$6d9c69b0de29b591; }, function (v) { return $ecfa3d0b44db3c2c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $ecfa3d0b44db3c2c$export$f680877a34711e37; }, function (v) { return $ecfa3d0b44db3c2c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ecfa3d0b44db3c2c$export$d5a552a76deda3c2; }, function (v) { return $ecfa3d0b44db3c2c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ecfa3d0b44db3c2c$export$aaabe4eda9ed9969; }, function (v) { return $ecfa3d0b44db3c2c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ecfa3d0b44db3c2c$export$e5c5a5f917a5871c; }, function (v) { return $ecfa3d0b44db3c2c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ecfa3d0b44db3c2c$export$1538c33de8887b59; }, function (v) { return $ecfa3d0b44db3c2c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $ecfa3d0b44db3c2c$export$13e3392192263954; }, function (v) { return $ecfa3d0b44db3c2c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ecfa3d0b44db3c2c$export$b8f5890fc79d6aca; }, function (v) { return $ecfa3d0b44db3c2c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ecfa3d0b44db3c2c$export$60241385465d0a34; }, function (v) { return $ecfa3d0b44db3c2c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ecfa3d0b44db3c2c$export$306c0aa65ff9ec16; }, function (v) { return $ecfa3d0b44db3c2c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ecfa3d0b44db3c2c$export$7b286972b8d8ccbf; }, function (v) { return $ecfa3d0b44db3c2c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ecfa3d0b44db3c2c$export$83d89fbfd8236492; }, function (v) { return $ecfa3d0b44db3c2c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7FyBz = parcelRequire("7FyBz");
var $ecfa3d0b44db3c2c$export$dca3b0875bd9a954;
var $ecfa3d0b44db3c2c$export$16fa2f45be04daa8;
var $ecfa3d0b44db3c2c$export$ffb0004e005737fa;
var $ecfa3d0b44db3c2c$export$e2c29f18771995cb;
var $ecfa3d0b44db3c2c$export$221d75b3f55bb0bd;
var $ecfa3d0b44db3c2c$export$5f8d39834fd61797;
var $ecfa3d0b44db3c2c$export$74bf444e3cd11ea5;
var $ecfa3d0b44db3c2c$export$ae55be85d98224ed;
var $ecfa3d0b44db3c2c$export$e530037191fcd5d7;
var $ecfa3d0b44db3c2c$export$fd42f52fd3ae1109;
var $ecfa3d0b44db3c2c$export$c8a8987d4410bf2d;
var $ecfa3d0b44db3c2c$export$d38cd72104c1f0e9;
var $ecfa3d0b44db3c2c$export$7d1e3a5e95ceca43;
var $ecfa3d0b44db3c2c$export$257a8862b851cb5b;
var $ecfa3d0b44db3c2c$export$a8257692ac88316c;
var $ecfa3d0b44db3c2c$export$488013bae63b21da;
var $ecfa3d0b44db3c2c$export$7c73462e0d25e514;
var $ecfa3d0b44db3c2c$export$7568632d0d33d16d;
var $ecfa3d0b44db3c2c$export$88948ce120ea2619;
var $ecfa3d0b44db3c2c$export$35808ee640e87ca7;
var $ecfa3d0b44db3c2c$export$fae74005e78b1a27;
var $ecfa3d0b44db3c2c$export$dc8fbce3eb94dc1e;
var $ecfa3d0b44db3c2c$export$6a7bc4e911dc01cf;
var $ecfa3d0b44db3c2c$export$6d9c69b0de29b591;
var $ecfa3d0b44db3c2c$export$f680877a34711e37;
var $ecfa3d0b44db3c2c$export$d5a552a76deda3c2;
var $ecfa3d0b44db3c2c$export$aaabe4eda9ed9969;
var $ecfa3d0b44db3c2c$export$e5c5a5f917a5871c;
var $ecfa3d0b44db3c2c$export$1538c33de8887b59;
var $ecfa3d0b44db3c2c$export$13e3392192263954;
var $ecfa3d0b44db3c2c$export$b8f5890fc79d6aca;
var $ecfa3d0b44db3c2c$export$60241385465d0a34;
var $ecfa3d0b44db3c2c$export$306c0aa65ff9ec16;
var $ecfa3d0b44db3c2c$export$7b286972b8d8ccbf;
var $ecfa3d0b44db3c2c$export$83d89fbfd8236492;
"use strict";
var $ecfa3d0b44db3c2c$var$l = Symbol["for"]("react.element"), $ecfa3d0b44db3c2c$var$n = Symbol["for"]("react.portal"), $ecfa3d0b44db3c2c$var$p = Symbol["for"]("react.fragment"), $ecfa3d0b44db3c2c$var$q = Symbol["for"]("react.strict_mode"), $ecfa3d0b44db3c2c$var$r = Symbol["for"]("react.profiler"), $ecfa3d0b44db3c2c$var$t = Symbol["for"]("react.provider"), $ecfa3d0b44db3c2c$var$u = Symbol["for"]("react.context"), $ecfa3d0b44db3c2c$var$v = Symbol["for"]("react.forward_ref"), $ecfa3d0b44db3c2c$var$w = Symbol["for"]("react.suspense"), $ecfa3d0b44db3c2c$var$x = Symbol["for"]("react.memo"), $ecfa3d0b44db3c2c$var$y = Symbol["for"]("react.lazy"), $ecfa3d0b44db3c2c$var$z = Symbol.iterator;
function $ecfa3d0b44db3c2c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ecfa3d0b44db3c2c$var$z && a[$ecfa3d0b44db3c2c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ecfa3d0b44db3c2c$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $ecfa3d0b44db3c2c$var$C = Object.assign, $ecfa3d0b44db3c2c$var$D = {};
function $ecfa3d0b44db3c2c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ecfa3d0b44db3c2c$var$D;
    this.updater = e || $ecfa3d0b44db3c2c$var$B;
}
$ecfa3d0b44db3c2c$var$E.prototype.isReactComponent = {};
$ecfa3d0b44db3c2c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$ecfa3d0b44db3c2c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $ecfa3d0b44db3c2c$var$F() {}
$ecfa3d0b44db3c2c$var$F.prototype = $ecfa3d0b44db3c2c$var$E.prototype;
function $ecfa3d0b44db3c2c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ecfa3d0b44db3c2c$var$D;
    this.updater = e || $ecfa3d0b44db3c2c$var$B;
}
var $ecfa3d0b44db3c2c$var$H = $ecfa3d0b44db3c2c$var$G.prototype = new $ecfa3d0b44db3c2c$var$F;
$ecfa3d0b44db3c2c$var$H.constructor = $ecfa3d0b44db3c2c$var$G;
$ecfa3d0b44db3c2c$var$C($ecfa3d0b44db3c2c$var$H, $ecfa3d0b44db3c2c$var$E.prototype);
$ecfa3d0b44db3c2c$var$H.isPureReactComponent = !0;
var $ecfa3d0b44db3c2c$var$I = Array.isArray, $ecfa3d0b44db3c2c$var$J = Object.prototype.hasOwnProperty, $ecfa3d0b44db3c2c$var$K = {
    current: null
}, $ecfa3d0b44db3c2c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ecfa3d0b44db3c2c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$ecfa3d0b44db3c2c$var$J.call(b, d) && !$ecfa3d0b44db3c2c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $ecfa3d0b44db3c2c$var$K.current
    };
}
function $ecfa3d0b44db3c2c$var$N(a, b) {
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $ecfa3d0b44db3c2c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ecfa3d0b44db3c2c$var$l;
}
function $ecfa3d0b44db3c2c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $ecfa3d0b44db3c2c$var$P = /\/+/g;
function $ecfa3d0b44db3c2c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $ecfa3d0b44db3c2c$var$escape("" + a.key) : b.toString(36);
}
function $ecfa3d0b44db3c2c$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $7FyBz._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $ecfa3d0b44db3c2c$var$l:
                case $ecfa3d0b44db3c2c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $ecfa3d0b44db3c2c$var$Q(h, 0) : d, $ecfa3d0b44db3c2c$var$I(c) ? (e = "", null != a && (e = a.replace($ecfa3d0b44db3c2c$var$P, "$&/") + "/"), $ecfa3d0b44db3c2c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($ecfa3d0b44db3c2c$var$O(c) && (c = $ecfa3d0b44db3c2c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($ecfa3d0b44db3c2c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($ecfa3d0b44db3c2c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $ecfa3d0b44db3c2c$var$Q(k, g);
        h += $ecfa3d0b44db3c2c$var$R(k, b, e, f, c);
    }
    else if (f = $ecfa3d0b44db3c2c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $ecfa3d0b44db3c2c$var$Q(k, g++), h += $ecfa3d0b44db3c2c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $ecfa3d0b44db3c2c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $ecfa3d0b44db3c2c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $ecfa3d0b44db3c2c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result["default"];
    throw a._result;
}
var $ecfa3d0b44db3c2c$var$U = {
    current: null
}, $ecfa3d0b44db3c2c$var$V = {
    transition: null
}, $ecfa3d0b44db3c2c$var$W = {
    ReactCurrentDispatcher: $ecfa3d0b44db3c2c$var$U,
    ReactCurrentBatchConfig: $ecfa3d0b44db3c2c$var$V,
    ReactCurrentOwner: $ecfa3d0b44db3c2c$var$K
};
$ecfa3d0b44db3c2c$export$dca3b0875bd9a954 = {
    map: $ecfa3d0b44db3c2c$var$S,
    forEach: function forEach(a, b, e) {
        $ecfa3d0b44db3c2c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $ecfa3d0b44db3c2c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $ecfa3d0b44db3c2c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$ecfa3d0b44db3c2c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$ecfa3d0b44db3c2c$export$16fa2f45be04daa8 = $ecfa3d0b44db3c2c$var$E;
$ecfa3d0b44db3c2c$export$ffb0004e005737fa = $ecfa3d0b44db3c2c$var$p;
$ecfa3d0b44db3c2c$export$e2c29f18771995cb = $ecfa3d0b44db3c2c$var$r;
$ecfa3d0b44db3c2c$export$221d75b3f55bb0bd = $ecfa3d0b44db3c2c$var$G;
$ecfa3d0b44db3c2c$export$5f8d39834fd61797 = $ecfa3d0b44db3c2c$var$q;
$ecfa3d0b44db3c2c$export$74bf444e3cd11ea5 = $ecfa3d0b44db3c2c$var$w;
$ecfa3d0b44db3c2c$export$ae55be85d98224ed = $ecfa3d0b44db3c2c$var$W;
$ecfa3d0b44db3c2c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $ecfa3d0b44db3c2c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $ecfa3d0b44db3c2c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$ecfa3d0b44db3c2c$var$J.call(b, f) && !$ecfa3d0b44db3c2c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$ecfa3d0b44db3c2c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $ecfa3d0b44db3c2c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $ecfa3d0b44db3c2c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$ecfa3d0b44db3c2c$export$c8a8987d4410bf2d = $ecfa3d0b44db3c2c$var$M;
$ecfa3d0b44db3c2c$export$d38cd72104c1f0e9 = function(a) {
    var b = $ecfa3d0b44db3c2c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$ecfa3d0b44db3c2c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ecfa3d0b44db3c2c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$v,
        render: a
    };
};
$ecfa3d0b44db3c2c$export$a8257692ac88316c = $ecfa3d0b44db3c2c$var$O;
$ecfa3d0b44db3c2c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $ecfa3d0b44db3c2c$var$T
    };
};
$ecfa3d0b44db3c2c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $ecfa3d0b44db3c2c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$ecfa3d0b44db3c2c$export$7568632d0d33d16d = function(a) {
    var b = $ecfa3d0b44db3c2c$var$V.transition;
    $ecfa3d0b44db3c2c$var$V.transition = {};
    try {
        a();
    } finally{
        $ecfa3d0b44db3c2c$var$V.transition = b;
    }
};
$ecfa3d0b44db3c2c$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$ecfa3d0b44db3c2c$export$35808ee640e87ca7 = function(a, b) {
    return $ecfa3d0b44db3c2c$var$U.current.useCallback(a, b);
};
$ecfa3d0b44db3c2c$export$fae74005e78b1a27 = function(a) {
    return $ecfa3d0b44db3c2c$var$U.current.useContext(a);
};
$ecfa3d0b44db3c2c$export$dc8fbce3eb94dc1e = function() {};
$ecfa3d0b44db3c2c$export$6a7bc4e911dc01cf = function(a) {
    return $ecfa3d0b44db3c2c$var$U.current.useDeferredValue(a);
};
$ecfa3d0b44db3c2c$export$6d9c69b0de29b591 = function(a, b) {
    return $ecfa3d0b44db3c2c$var$U.current.useEffect(a, b);
};
$ecfa3d0b44db3c2c$export$f680877a34711e37 = function() {
    return $ecfa3d0b44db3c2c$var$U.current.useId();
};
$ecfa3d0b44db3c2c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $ecfa3d0b44db3c2c$var$U.current.useImperativeHandle(a, b, e);
};
$ecfa3d0b44db3c2c$export$aaabe4eda9ed9969 = function(a, b) {
    return $ecfa3d0b44db3c2c$var$U.current.useInsertionEffect(a, b);
};
$ecfa3d0b44db3c2c$export$e5c5a5f917a5871c = function(a, b) {
    return $ecfa3d0b44db3c2c$var$U.current.useLayoutEffect(a, b);
};
$ecfa3d0b44db3c2c$export$1538c33de8887b59 = function(a, b) {
    return $ecfa3d0b44db3c2c$var$U.current.useMemo(a, b);
};
$ecfa3d0b44db3c2c$export$13e3392192263954 = function(a, b, e) {
    return $ecfa3d0b44db3c2c$var$U.current.useReducer(a, b, e);
};
$ecfa3d0b44db3c2c$export$b8f5890fc79d6aca = function(a) {
    return $ecfa3d0b44db3c2c$var$U.current.useRef(a);
};
$ecfa3d0b44db3c2c$export$60241385465d0a34 = function(a) {
    return $ecfa3d0b44db3c2c$var$U.current.useState(a);
};
$ecfa3d0b44db3c2c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $ecfa3d0b44db3c2c$var$U.current.useSyncExternalStore(a, b, e);
};
$ecfa3d0b44db3c2c$export$7b286972b8d8ccbf = function() {
    return $ecfa3d0b44db3c2c$var$U.current.useTransition();
};
$ecfa3d0b44db3c2c$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("7FyBz", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $5957349561adb189$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $5957349561adb189$export$5f0017c582d45a2d; });
function $5957349561adb189$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("gcIpL", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bcc038267b15f6fa$export$ae55be85d98224ed; }, function (v) { return $bcc038267b15f6fa$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bcc038267b15f6fa$export$d39a5bbd09211389; }, function (v) { return $bcc038267b15f6fa$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bcc038267b15f6fa$export$882461b6382ed46c; }, function (v) { return $bcc038267b15f6fa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bcc038267b15f6fa$export$466bfc07425424d5; }, function (v) { return $bcc038267b15f6fa$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bcc038267b15f6fa$export$cd75ccfd720a3cd4; }, function (v) { return $bcc038267b15f6fa$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bcc038267b15f6fa$export$fa8d919ba61d84db; }, function (v) { return $bcc038267b15f6fa$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bcc038267b15f6fa$export$757ceba2d55c277e; }, function (v) { return $bcc038267b15f6fa$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bcc038267b15f6fa$export$b3890eb0ae9dca99; }, function (v) { return $bcc038267b15f6fa$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bcc038267b15f6fa$export$502457920280e6be; }, function (v) { return $bcc038267b15f6fa$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bcc038267b15f6fa$export$c78a37762a8d58e1; }, function (v) { return $bcc038267b15f6fa$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bcc038267b15f6fa$export$dc54d992c10e8a18; }, function (v) { return $bcc038267b15f6fa$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bcc038267b15f6fa$export$83d89fbfd8236492; }, function (v) { return $bcc038267b15f6fa$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $7FyBz = parcelRequire("7FyBz");
var $bcc038267b15f6fa$export$ae55be85d98224ed;
var $bcc038267b15f6fa$export$d39a5bbd09211389;
var $bcc038267b15f6fa$export$882461b6382ed46c;
var $bcc038267b15f6fa$export$466bfc07425424d5;
var $bcc038267b15f6fa$export$cd75ccfd720a3cd4;
var $bcc038267b15f6fa$export$fa8d919ba61d84db;
var $bcc038267b15f6fa$export$757ceba2d55c277e;
var $bcc038267b15f6fa$export$b3890eb0ae9dca99;
var $bcc038267b15f6fa$export$502457920280e6be;
var $bcc038267b15f6fa$export$c78a37762a8d58e1;
var $bcc038267b15f6fa$export$dc54d992c10e8a18;
var $bcc038267b15f6fa$export$83d89fbfd8236492;
"use strict";

var $8SyCD = parcelRequire("8SyCD");

var $2cSXK = parcelRequire("2cSXK");
function $bcc038267b15f6fa$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bcc038267b15f6fa$var$da = new Set, $bcc038267b15f6fa$var$ea = {};
function $bcc038267b15f6fa$var$fa(a, b) {
    $bcc038267b15f6fa$var$ha(a, b);
    $bcc038267b15f6fa$var$ha(a + "Capture", b);
}
function $bcc038267b15f6fa$var$ha(a, b) {
    $bcc038267b15f6fa$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bcc038267b15f6fa$var$da.add(b[a]);
}
var $bcc038267b15f6fa$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bcc038267b15f6fa$var$ja = Object.prototype.hasOwnProperty, $bcc038267b15f6fa$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bcc038267b15f6fa$var$la = {}, $bcc038267b15f6fa$var$ma = {};
function $bcc038267b15f6fa$var$oa(a) {
    if ($bcc038267b15f6fa$var$ja.call($bcc038267b15f6fa$var$ma, a)) return !0;
    if ($bcc038267b15f6fa$var$ja.call($bcc038267b15f6fa$var$la, a)) return !1;
    if ($bcc038267b15f6fa$var$ka.test(a)) return $bcc038267b15f6fa$var$ma[a] = !0;
    $bcc038267b15f6fa$var$la[a] = !0;
    return !1;
}
function $bcc038267b15f6fa$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $7FyBz._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bcc038267b15f6fa$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bcc038267b15f6fa$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bcc038267b15f6fa$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bcc038267b15f6fa$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bcc038267b15f6fa$var$z[b] = new $bcc038267b15f6fa$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bcc038267b15f6fa$var$ra = /[\-:]([a-z])/g;
function $bcc038267b15f6fa$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bcc038267b15f6fa$var$ra, $bcc038267b15f6fa$var$sa);
    $bcc038267b15f6fa$var$z[b] = new $bcc038267b15f6fa$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bcc038267b15f6fa$var$ra, $bcc038267b15f6fa$var$sa);
    $bcc038267b15f6fa$var$z[b] = new $bcc038267b15f6fa$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bcc038267b15f6fa$var$ra, $bcc038267b15f6fa$var$sa);
    $bcc038267b15f6fa$var$z[b] = new $bcc038267b15f6fa$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bcc038267b15f6fa$var$z.xlinkHref = new $bcc038267b15f6fa$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bcc038267b15f6fa$var$z[a] = new $bcc038267b15f6fa$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bcc038267b15f6fa$var$ta(a, b, c, d) {
    var e = $bcc038267b15f6fa$var$z.hasOwnProperty(b) ? $bcc038267b15f6fa$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bcc038267b15f6fa$var$qa(b, c, e, d) && (c = null), d || null === e ? $bcc038267b15f6fa$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bcc038267b15f6fa$var$ua = $8SyCD.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bcc038267b15f6fa$var$va = Symbol["for"]("react.element"), $bcc038267b15f6fa$var$wa = Symbol["for"]("react.portal"), $bcc038267b15f6fa$var$ya = Symbol["for"]("react.fragment"), $bcc038267b15f6fa$var$za = Symbol["for"]("react.strict_mode"), $bcc038267b15f6fa$var$Aa = Symbol["for"]("react.profiler"), $bcc038267b15f6fa$var$Ba = Symbol["for"]("react.provider"), $bcc038267b15f6fa$var$Ca = Symbol["for"]("react.context"), $bcc038267b15f6fa$var$Da = Symbol["for"]("react.forward_ref"), $bcc038267b15f6fa$var$Ea = Symbol["for"]("react.suspense"), $bcc038267b15f6fa$var$Fa = Symbol["for"]("react.suspense_list"), $bcc038267b15f6fa$var$Ga = Symbol["for"]("react.memo"), $bcc038267b15f6fa$var$Ha = Symbol["for"]("react.lazy");
Symbol["for"]("react.scope");
Symbol["for"]("react.debug_trace_mode");
var $bcc038267b15f6fa$var$Ia = Symbol["for"]("react.offscreen");
Symbol["for"]("react.legacy_hidden");
Symbol["for"]("react.cache");
Symbol["for"]("react.tracing_marker");
var $bcc038267b15f6fa$var$Ja = Symbol.iterator;
function $bcc038267b15f6fa$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bcc038267b15f6fa$var$Ja && a[$bcc038267b15f6fa$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bcc038267b15f6fa$var$A = Object.assign, $bcc038267b15f6fa$var$La;
function $bcc038267b15f6fa$var$Ma(a) {
    if (void 0 === $bcc038267b15f6fa$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bcc038267b15f6fa$var$La = b && b[1] || "";
    }
    return "\n" + $bcc038267b15f6fa$var$La + a;
}
var $bcc038267b15f6fa$var$Na = !1;
function $bcc038267b15f6fa$var$Oa(a, b) {
    if (!a || $bcc038267b15f6fa$var$Na) return "";
    $bcc038267b15f6fa$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bcc038267b15f6fa$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bcc038267b15f6fa$var$Ma(a) : "";
}
function $bcc038267b15f6fa$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bcc038267b15f6fa$var$Ma(a.type);
        case 16:
            return $bcc038267b15f6fa$var$Ma("Lazy");
        case 13:
            return $bcc038267b15f6fa$var$Ma("Suspense");
        case 19:
            return $bcc038267b15f6fa$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bcc038267b15f6fa$var$Oa(a.type, !1), a;
        case 11:
            return a = $bcc038267b15f6fa$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bcc038267b15f6fa$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bcc038267b15f6fa$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bcc038267b15f6fa$var$ya:
            return "Fragment";
        case $bcc038267b15f6fa$var$wa:
            return "Portal";
        case $bcc038267b15f6fa$var$Aa:
            return "Profiler";
        case $bcc038267b15f6fa$var$za:
            return "StrictMode";
        case $bcc038267b15f6fa$var$Ea:
            return "Suspense";
        case $bcc038267b15f6fa$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $bcc038267b15f6fa$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bcc038267b15f6fa$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bcc038267b15f6fa$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bcc038267b15f6fa$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bcc038267b15f6fa$var$Qa(a.type) || "Memo";
        case $bcc038267b15f6fa$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bcc038267b15f6fa$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bcc038267b15f6fa$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bcc038267b15f6fa$var$Qa(b);
        case 8:
            return b === $bcc038267b15f6fa$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bcc038267b15f6fa$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $7FyBz._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bcc038267b15f6fa$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bcc038267b15f6fa$var$Ua(a) {
    var b = $bcc038267b15f6fa$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bcc038267b15f6fa$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bcc038267b15f6fa$var$Ua(a));
}
function $bcc038267b15f6fa$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bcc038267b15f6fa$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bcc038267b15f6fa$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bcc038267b15f6fa$var$Ya(a, b) {
    var c = b.checked;
    return $bcc038267b15f6fa$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bcc038267b15f6fa$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bcc038267b15f6fa$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bcc038267b15f6fa$var$ab(a, b) {
    b = b.checked;
    null != b && $bcc038267b15f6fa$var$ta(a, "checked", b, !1);
}
function $bcc038267b15f6fa$var$bb(a, b) {
    $bcc038267b15f6fa$var$ab(a, b);
    var c = $bcc038267b15f6fa$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bcc038267b15f6fa$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bcc038267b15f6fa$var$cb(a, b.type, $bcc038267b15f6fa$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bcc038267b15f6fa$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bcc038267b15f6fa$var$cb(a, b, c) {
    if ("number" !== b || $bcc038267b15f6fa$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bcc038267b15f6fa$var$eb = Array.isArray;
function $bcc038267b15f6fa$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bcc038267b15f6fa$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bcc038267b15f6fa$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bcc038267b15f6fa$var$p(91));
    return $bcc038267b15f6fa$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bcc038267b15f6fa$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bcc038267b15f6fa$var$p(92));
            if ($bcc038267b15f6fa$var$eb(c)) {
                if (1 < c.length) throw Error($bcc038267b15f6fa$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bcc038267b15f6fa$var$Sa(c)
    };
}
function $bcc038267b15f6fa$var$ib(a, b) {
    var c = $bcc038267b15f6fa$var$Sa(b.value), d = $bcc038267b15f6fa$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bcc038267b15f6fa$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bcc038267b15f6fa$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bcc038267b15f6fa$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bcc038267b15f6fa$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bcc038267b15f6fa$var$mb, $bcc038267b15f6fa$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bcc038267b15f6fa$var$mb = $bcc038267b15f6fa$var$mb || document.createElement("div");
        $bcc038267b15f6fa$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bcc038267b15f6fa$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bcc038267b15f6fa$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bcc038267b15f6fa$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bcc038267b15f6fa$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bcc038267b15f6fa$var$pb).forEach(function(a) {
    $bcc038267b15f6fa$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bcc038267b15f6fa$var$pb[b] = $bcc038267b15f6fa$var$pb[a];
    });
});
function $bcc038267b15f6fa$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bcc038267b15f6fa$var$pb.hasOwnProperty(a) && $bcc038267b15f6fa$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bcc038267b15f6fa$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bcc038267b15f6fa$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bcc038267b15f6fa$var$tb = $bcc038267b15f6fa$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bcc038267b15f6fa$var$ub(a, b) {
    if (b) {
        if ($bcc038267b15f6fa$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bcc038267b15f6fa$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bcc038267b15f6fa$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bcc038267b15f6fa$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($bcc038267b15f6fa$var$p(62));
    }
}
function $bcc038267b15f6fa$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bcc038267b15f6fa$var$wb = null;
function $bcc038267b15f6fa$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bcc038267b15f6fa$var$yb = null, $bcc038267b15f6fa$var$zb = null, $bcc038267b15f6fa$var$Ab = null;
function $bcc038267b15f6fa$var$Bb(a) {
    if (a = $bcc038267b15f6fa$var$Cb(a)) {
        if ("function" !== typeof $bcc038267b15f6fa$var$yb) throw Error($bcc038267b15f6fa$var$p(280));
        var b = a.stateNode;
        b && (b = $bcc038267b15f6fa$var$Db(b), $bcc038267b15f6fa$var$yb(a.stateNode, a.type, b));
    }
}
function $bcc038267b15f6fa$var$Eb(a) {
    $bcc038267b15f6fa$var$zb ? $bcc038267b15f6fa$var$Ab ? $bcc038267b15f6fa$var$Ab.push(a) : $bcc038267b15f6fa$var$Ab = [
        a
    ] : $bcc038267b15f6fa$var$zb = a;
}
function $bcc038267b15f6fa$var$Fb() {
    if ($bcc038267b15f6fa$var$zb) {
        var a = $bcc038267b15f6fa$var$zb, b = $bcc038267b15f6fa$var$Ab;
        $bcc038267b15f6fa$var$Ab = $bcc038267b15f6fa$var$zb = null;
        $bcc038267b15f6fa$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bcc038267b15f6fa$var$Bb(b[a]);
    }
}
function $bcc038267b15f6fa$var$Gb(a, b) {
    return a(b);
}
function $bcc038267b15f6fa$var$Hb() {}
var $bcc038267b15f6fa$var$Ib = !1;
function $bcc038267b15f6fa$var$Jb(a, b, c) {
    if ($bcc038267b15f6fa$var$Ib) return a(b, c);
    $bcc038267b15f6fa$var$Ib = !0;
    try {
        return $bcc038267b15f6fa$var$Gb(a, b, c);
    } finally{
        if ($bcc038267b15f6fa$var$Ib = !1, null !== $bcc038267b15f6fa$var$zb || null !== $bcc038267b15f6fa$var$Ab) $bcc038267b15f6fa$var$Hb(), $bcc038267b15f6fa$var$Fb();
    }
}
function $bcc038267b15f6fa$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bcc038267b15f6fa$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bcc038267b15f6fa$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $7FyBz._)(c)));
    return c;
}
var $bcc038267b15f6fa$var$Lb = !1;
if ($bcc038267b15f6fa$var$ia) try {
    var $bcc038267b15f6fa$var$Mb = {};
    Object.defineProperty($bcc038267b15f6fa$var$Mb, "passive", {
        get: function get() {
            $bcc038267b15f6fa$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bcc038267b15f6fa$var$Mb, $bcc038267b15f6fa$var$Mb);
    window.removeEventListener("test", $bcc038267b15f6fa$var$Mb, $bcc038267b15f6fa$var$Mb);
} catch (a) {
    $bcc038267b15f6fa$var$Lb = !1;
}
function $bcc038267b15f6fa$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bcc038267b15f6fa$var$Ob = !1, $bcc038267b15f6fa$var$Pb = null, $bcc038267b15f6fa$var$Qb = !1, $bcc038267b15f6fa$var$Rb = null, $bcc038267b15f6fa$var$Sb = {
    onError: function onError(a) {
        $bcc038267b15f6fa$var$Ob = !0;
        $bcc038267b15f6fa$var$Pb = a;
    }
};
function $bcc038267b15f6fa$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bcc038267b15f6fa$var$Ob = !1;
    $bcc038267b15f6fa$var$Pb = null;
    $bcc038267b15f6fa$var$Nb.apply($bcc038267b15f6fa$var$Sb, arguments);
}
function $bcc038267b15f6fa$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bcc038267b15f6fa$var$Tb.apply(this, arguments);
    if ($bcc038267b15f6fa$var$Ob) {
        if ($bcc038267b15f6fa$var$Ob) {
            var l = $bcc038267b15f6fa$var$Pb;
            $bcc038267b15f6fa$var$Ob = !1;
            $bcc038267b15f6fa$var$Pb = null;
        } else throw Error($bcc038267b15f6fa$var$p(198));
        $bcc038267b15f6fa$var$Qb || ($bcc038267b15f6fa$var$Qb = !0, $bcc038267b15f6fa$var$Rb = l);
    }
}
function $bcc038267b15f6fa$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bcc038267b15f6fa$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bcc038267b15f6fa$var$Xb(a) {
    if ($bcc038267b15f6fa$var$Vb(a) !== a) throw Error($bcc038267b15f6fa$var$p(188));
}
function $bcc038267b15f6fa$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bcc038267b15f6fa$var$Vb(a);
        if (null === b) throw Error($bcc038267b15f6fa$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bcc038267b15f6fa$var$Xb(e), a;
                if (f === d) return $bcc038267b15f6fa$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bcc038267b15f6fa$var$p(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bcc038267b15f6fa$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bcc038267b15f6fa$var$p(190));
    }
    if (3 !== c.tag) throw Error($bcc038267b15f6fa$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bcc038267b15f6fa$var$Zb(a) {
    a = $bcc038267b15f6fa$var$Yb(a);
    return null !== a ? $bcc038267b15f6fa$var$$b(a) : null;
}
function $bcc038267b15f6fa$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bcc038267b15f6fa$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bcc038267b15f6fa$var$ac = $2cSXK.unstable_scheduleCallback, $bcc038267b15f6fa$var$bc = $2cSXK.unstable_cancelCallback, $bcc038267b15f6fa$var$cc = $2cSXK.unstable_shouldYield, $bcc038267b15f6fa$var$dc = $2cSXK.unstable_requestPaint, $bcc038267b15f6fa$var$B = $2cSXK.unstable_now, $bcc038267b15f6fa$var$ec = $2cSXK.unstable_getCurrentPriorityLevel, $bcc038267b15f6fa$var$fc = $2cSXK.unstable_ImmediatePriority, $bcc038267b15f6fa$var$gc = $2cSXK.unstable_UserBlockingPriority, $bcc038267b15f6fa$var$hc = $2cSXK.unstable_NormalPriority, $bcc038267b15f6fa$var$ic = $2cSXK.unstable_LowPriority, $bcc038267b15f6fa$var$jc = $2cSXK.unstable_IdlePriority, $bcc038267b15f6fa$var$kc = null, $bcc038267b15f6fa$var$lc = null;
function $bcc038267b15f6fa$var$mc(a) {
    if ($bcc038267b15f6fa$var$lc && "function" === typeof $bcc038267b15f6fa$var$lc.onCommitFiberRoot) try {
        $bcc038267b15f6fa$var$lc.onCommitFiberRoot($bcc038267b15f6fa$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bcc038267b15f6fa$var$oc = Math.clz32 ? Math.clz32 : $bcc038267b15f6fa$var$nc, $bcc038267b15f6fa$var$pc = Math.log, $bcc038267b15f6fa$var$qc = Math.LN2;
function $bcc038267b15f6fa$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bcc038267b15f6fa$var$pc(a) / $bcc038267b15f6fa$var$qc | 0) | 0;
}
var $bcc038267b15f6fa$var$rc = 64, $bcc038267b15f6fa$var$sc = 4194304;
function $bcc038267b15f6fa$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bcc038267b15f6fa$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bcc038267b15f6fa$var$tc(h) : (f &= g, 0 !== f && (d = $bcc038267b15f6fa$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bcc038267b15f6fa$var$tc(g) : 0 !== f && (d = $bcc038267b15f6fa$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bcc038267b15f6fa$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bcc038267b15f6fa$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bcc038267b15f6fa$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bcc038267b15f6fa$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bcc038267b15f6fa$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bcc038267b15f6fa$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bcc038267b15f6fa$var$yc() {
    var a = $bcc038267b15f6fa$var$rc;
    $bcc038267b15f6fa$var$rc <<= 1;
    0 === ($bcc038267b15f6fa$var$rc & 4194240) && ($bcc038267b15f6fa$var$rc = 64);
    return a;
}
function $bcc038267b15f6fa$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bcc038267b15f6fa$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bcc038267b15f6fa$var$oc(b);
    a[b] = c;
}
function $bcc038267b15f6fa$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bcc038267b15f6fa$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bcc038267b15f6fa$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bcc038267b15f6fa$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bcc038267b15f6fa$var$C = 0;
function $bcc038267b15f6fa$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bcc038267b15f6fa$var$Ec, $bcc038267b15f6fa$var$Fc, $bcc038267b15f6fa$var$Gc, $bcc038267b15f6fa$var$Hc, $bcc038267b15f6fa$var$Ic, $bcc038267b15f6fa$var$Jc = !1, $bcc038267b15f6fa$var$Kc = [], $bcc038267b15f6fa$var$Lc = null, $bcc038267b15f6fa$var$Mc = null, $bcc038267b15f6fa$var$Nc = null, $bcc038267b15f6fa$var$Oc = new Map, $bcc038267b15f6fa$var$Pc = new Map, $bcc038267b15f6fa$var$Qc = [], $bcc038267b15f6fa$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bcc038267b15f6fa$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bcc038267b15f6fa$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bcc038267b15f6fa$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bcc038267b15f6fa$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bcc038267b15f6fa$var$Oc["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bcc038267b15f6fa$var$Pc["delete"](b.pointerId);
    }
}
function $bcc038267b15f6fa$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bcc038267b15f6fa$var$Cb(b), null !== b && $bcc038267b15f6fa$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bcc038267b15f6fa$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bcc038267b15f6fa$var$Lc = $bcc038267b15f6fa$var$Tc($bcc038267b15f6fa$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bcc038267b15f6fa$var$Mc = $bcc038267b15f6fa$var$Tc($bcc038267b15f6fa$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bcc038267b15f6fa$var$Nc = $bcc038267b15f6fa$var$Tc($bcc038267b15f6fa$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bcc038267b15f6fa$var$Oc.set(f, $bcc038267b15f6fa$var$Tc($bcc038267b15f6fa$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bcc038267b15f6fa$var$Pc.set(f, $bcc038267b15f6fa$var$Tc($bcc038267b15f6fa$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bcc038267b15f6fa$var$Vc(a) {
    var b = $bcc038267b15f6fa$var$Wc(a.target);
    if (null !== b) {
        var c = $bcc038267b15f6fa$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bcc038267b15f6fa$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bcc038267b15f6fa$var$Ic(a.priority, function() {
                        $bcc038267b15f6fa$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bcc038267b15f6fa$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bcc038267b15f6fa$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bcc038267b15f6fa$var$wb = d;
            c.target.dispatchEvent(d);
            $bcc038267b15f6fa$var$wb = null;
        } else return b = $bcc038267b15f6fa$var$Cb(c), null !== b && $bcc038267b15f6fa$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bcc038267b15f6fa$var$Zc(a, b, c) {
    $bcc038267b15f6fa$var$Xc(a) && c["delete"](b);
}
function $bcc038267b15f6fa$var$$c() {
    $bcc038267b15f6fa$var$Jc = !1;
    null !== $bcc038267b15f6fa$var$Lc && $bcc038267b15f6fa$var$Xc($bcc038267b15f6fa$var$Lc) && ($bcc038267b15f6fa$var$Lc = null);
    null !== $bcc038267b15f6fa$var$Mc && $bcc038267b15f6fa$var$Xc($bcc038267b15f6fa$var$Mc) && ($bcc038267b15f6fa$var$Mc = null);
    null !== $bcc038267b15f6fa$var$Nc && $bcc038267b15f6fa$var$Xc($bcc038267b15f6fa$var$Nc) && ($bcc038267b15f6fa$var$Nc = null);
    $bcc038267b15f6fa$var$Oc.forEach($bcc038267b15f6fa$var$Zc);
    $bcc038267b15f6fa$var$Pc.forEach($bcc038267b15f6fa$var$Zc);
}
function $bcc038267b15f6fa$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bcc038267b15f6fa$var$Jc || ($bcc038267b15f6fa$var$Jc = !0, $2cSXK.unstable_scheduleCallback($2cSXK.unstable_NormalPriority, $bcc038267b15f6fa$var$$c)));
}
function $bcc038267b15f6fa$var$bd(a) {
    function b(b) {
        return $bcc038267b15f6fa$var$ad(b, a);
    }
    if (0 < $bcc038267b15f6fa$var$Kc.length) {
        $bcc038267b15f6fa$var$ad($bcc038267b15f6fa$var$Kc[0], a);
        for(var c = 1; c < $bcc038267b15f6fa$var$Kc.length; c++){
            var d = $bcc038267b15f6fa$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bcc038267b15f6fa$var$Lc && $bcc038267b15f6fa$var$ad($bcc038267b15f6fa$var$Lc, a);
    null !== $bcc038267b15f6fa$var$Mc && $bcc038267b15f6fa$var$ad($bcc038267b15f6fa$var$Mc, a);
    null !== $bcc038267b15f6fa$var$Nc && $bcc038267b15f6fa$var$ad($bcc038267b15f6fa$var$Nc, a);
    $bcc038267b15f6fa$var$Oc.forEach(b);
    $bcc038267b15f6fa$var$Pc.forEach(b);
    for(c = 0; c < $bcc038267b15f6fa$var$Qc.length; c++)d = $bcc038267b15f6fa$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bcc038267b15f6fa$var$Qc.length && (c = $bcc038267b15f6fa$var$Qc[0], null === c.blockedOn);)$bcc038267b15f6fa$var$Vc(c), null === c.blockedOn && $bcc038267b15f6fa$var$Qc.shift();
}
var $bcc038267b15f6fa$var$cd = $bcc038267b15f6fa$var$ua.ReactCurrentBatchConfig, $bcc038267b15f6fa$var$dd = !0;
function $bcc038267b15f6fa$var$ed(a, b, c, d) {
    var e = $bcc038267b15f6fa$var$C, f = $bcc038267b15f6fa$var$cd.transition;
    $bcc038267b15f6fa$var$cd.transition = null;
    try {
        $bcc038267b15f6fa$var$C = 1, $bcc038267b15f6fa$var$fd(a, b, c, d);
    } finally{
        $bcc038267b15f6fa$var$C = e, $bcc038267b15f6fa$var$cd.transition = f;
    }
}
function $bcc038267b15f6fa$var$gd(a, b, c, d) {
    var e = $bcc038267b15f6fa$var$C, f = $bcc038267b15f6fa$var$cd.transition;
    $bcc038267b15f6fa$var$cd.transition = null;
    try {
        $bcc038267b15f6fa$var$C = 4, $bcc038267b15f6fa$var$fd(a, b, c, d);
    } finally{
        $bcc038267b15f6fa$var$C = e, $bcc038267b15f6fa$var$cd.transition = f;
    }
}
function $bcc038267b15f6fa$var$fd(a, b, c, d) {
    if ($bcc038267b15f6fa$var$dd) {
        var e = $bcc038267b15f6fa$var$Yc(a, b, c, d);
        if (null === e) $bcc038267b15f6fa$var$hd(a, b, d, $bcc038267b15f6fa$var$id, c), $bcc038267b15f6fa$var$Sc(a, d);
        else if ($bcc038267b15f6fa$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bcc038267b15f6fa$var$Sc(a, d), b & 4 && -1 < $bcc038267b15f6fa$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bcc038267b15f6fa$var$Cb(e);
                null !== f && $bcc038267b15f6fa$var$Ec(f);
                f = $bcc038267b15f6fa$var$Yc(a, b, c, d);
                null === f && $bcc038267b15f6fa$var$hd(a, b, d, $bcc038267b15f6fa$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bcc038267b15f6fa$var$hd(a, b, d, null, c);
    }
}
var $bcc038267b15f6fa$var$id = null;
function $bcc038267b15f6fa$var$Yc(a, b, c, d) {
    $bcc038267b15f6fa$var$id = null;
    a = $bcc038267b15f6fa$var$xb(d);
    a = $bcc038267b15f6fa$var$Wc(a);
    if (null !== a) {
        if (b = $bcc038267b15f6fa$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bcc038267b15f6fa$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bcc038267b15f6fa$var$id = a;
    return null;
}
function $bcc038267b15f6fa$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bcc038267b15f6fa$var$ec()){
                case $bcc038267b15f6fa$var$fc:
                    return 1;
                case $bcc038267b15f6fa$var$gc:
                    return 4;
                case $bcc038267b15f6fa$var$hc:
                case $bcc038267b15f6fa$var$ic:
                    return 16;
                case $bcc038267b15f6fa$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bcc038267b15f6fa$var$kd = null, $bcc038267b15f6fa$var$ld = null, $bcc038267b15f6fa$var$md = null;
function $bcc038267b15f6fa$var$nd() {
    if ($bcc038267b15f6fa$var$md) return $bcc038267b15f6fa$var$md;
    var a, b = $bcc038267b15f6fa$var$ld, c = b.length, d, e = "value" in $bcc038267b15f6fa$var$kd ? $bcc038267b15f6fa$var$kd.value : $bcc038267b15f6fa$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bcc038267b15f6fa$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bcc038267b15f6fa$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bcc038267b15f6fa$var$pd() {
    return !0;
}
function $bcc038267b15f6fa$var$qd() {
    return !1;
}
function $bcc038267b15f6fa$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bcc038267b15f6fa$var$pd : $bcc038267b15f6fa$var$qd;
        this.isPropagationStopped = $bcc038267b15f6fa$var$qd;
        return this;
    }
    $bcc038267b15f6fa$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $7FyBz._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $bcc038267b15f6fa$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $7FyBz._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $bcc038267b15f6fa$var$pd);
        },
        persist: function persist() {},
        isPersistent: $bcc038267b15f6fa$var$pd
    });
    return b;
}
var $bcc038267b15f6fa$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bcc038267b15f6fa$var$td = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$sd), $bcc038267b15f6fa$var$ud = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$sd, {
    view: 0,
    detail: 0
}), $bcc038267b15f6fa$var$vd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$ud), $bcc038267b15f6fa$var$wd, $bcc038267b15f6fa$var$xd, $bcc038267b15f6fa$var$yd, $bcc038267b15f6fa$var$Ad = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bcc038267b15f6fa$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bcc038267b15f6fa$var$yd && ($bcc038267b15f6fa$var$yd && "mousemove" === a.type ? ($bcc038267b15f6fa$var$wd = a.screenX - $bcc038267b15f6fa$var$yd.screenX, $bcc038267b15f6fa$var$xd = a.screenY - $bcc038267b15f6fa$var$yd.screenY) : $bcc038267b15f6fa$var$xd = $bcc038267b15f6fa$var$wd = 0, $bcc038267b15f6fa$var$yd = a);
        return $bcc038267b15f6fa$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $bcc038267b15f6fa$var$xd;
    }
}), $bcc038267b15f6fa$var$Bd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Ad), $bcc038267b15f6fa$var$Cd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$Ad, {
    dataTransfer: 0
}), $bcc038267b15f6fa$var$Dd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Cd), $bcc038267b15f6fa$var$Ed = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$ud, {
    relatedTarget: 0
}), $bcc038267b15f6fa$var$Fd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Ed), $bcc038267b15f6fa$var$Gd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcc038267b15f6fa$var$Hd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Gd), $bcc038267b15f6fa$var$Id = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bcc038267b15f6fa$var$Jd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Id), $bcc038267b15f6fa$var$Kd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$sd, {
    data: 0
}), $bcc038267b15f6fa$var$Ld = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Kd), $bcc038267b15f6fa$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bcc038267b15f6fa$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bcc038267b15f6fa$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bcc038267b15f6fa$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bcc038267b15f6fa$var$Od[a]) ? !!b[a] : !1;
}
function $bcc038267b15f6fa$var$zd() {
    return $bcc038267b15f6fa$var$Pd;
}
var $bcc038267b15f6fa$var$Qd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $bcc038267b15f6fa$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bcc038267b15f6fa$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bcc038267b15f6fa$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bcc038267b15f6fa$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $bcc038267b15f6fa$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $bcc038267b15f6fa$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bcc038267b15f6fa$var$Rd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Qd), $bcc038267b15f6fa$var$Sd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bcc038267b15f6fa$var$Td = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Sd), $bcc038267b15f6fa$var$Ud = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bcc038267b15f6fa$var$zd
}), $bcc038267b15f6fa$var$Vd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Ud), $bcc038267b15f6fa$var$Wd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcc038267b15f6fa$var$Xd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Wd), $bcc038267b15f6fa$var$Yd = $bcc038267b15f6fa$var$A({}, $bcc038267b15f6fa$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bcc038267b15f6fa$var$Zd = $bcc038267b15f6fa$var$rd($bcc038267b15f6fa$var$Yd), $bcc038267b15f6fa$var$$d = [
    9,
    13,
    27,
    32
], $bcc038267b15f6fa$var$ae = $bcc038267b15f6fa$var$ia && "CompositionEvent" in window, $bcc038267b15f6fa$var$be = null;
$bcc038267b15f6fa$var$ia && "documentMode" in document && ($bcc038267b15f6fa$var$be = document.documentMode);
var $bcc038267b15f6fa$var$ce = $bcc038267b15f6fa$var$ia && "TextEvent" in window && !$bcc038267b15f6fa$var$be, $bcc038267b15f6fa$var$de = $bcc038267b15f6fa$var$ia && (!$bcc038267b15f6fa$var$ae || $bcc038267b15f6fa$var$be && 8 < $bcc038267b15f6fa$var$be && 11 >= $bcc038267b15f6fa$var$be), $bcc038267b15f6fa$var$ee = String.fromCharCode(32), $bcc038267b15f6fa$var$fe = !1;
function $bcc038267b15f6fa$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bcc038267b15f6fa$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bcc038267b15f6fa$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $bcc038267b15f6fa$var$ie = !1;
function $bcc038267b15f6fa$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bcc038267b15f6fa$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bcc038267b15f6fa$var$fe = !0;
            return $bcc038267b15f6fa$var$ee;
        case "textInput":
            return a = b.data, a === $bcc038267b15f6fa$var$ee && $bcc038267b15f6fa$var$fe ? null : a;
        default:
            return null;
    }
}
function $bcc038267b15f6fa$var$ke(a, b) {
    if ($bcc038267b15f6fa$var$ie) return "compositionend" === a || !$bcc038267b15f6fa$var$ae && $bcc038267b15f6fa$var$ge(a, b) ? (a = $bcc038267b15f6fa$var$nd(), $bcc038267b15f6fa$var$md = $bcc038267b15f6fa$var$ld = $bcc038267b15f6fa$var$kd = null, $bcc038267b15f6fa$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bcc038267b15f6fa$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bcc038267b15f6fa$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bcc038267b15f6fa$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bcc038267b15f6fa$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bcc038267b15f6fa$var$ne(a, b, c, d) {
    $bcc038267b15f6fa$var$Eb(d);
    b = $bcc038267b15f6fa$var$oe(b, "onChange");
    0 < b.length && (c = new $bcc038267b15f6fa$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bcc038267b15f6fa$var$pe = null, $bcc038267b15f6fa$var$qe = null;
function $bcc038267b15f6fa$var$re(a) {
    $bcc038267b15f6fa$var$se(a, 0);
}
function $bcc038267b15f6fa$var$te(a) {
    var b = $bcc038267b15f6fa$var$ue(a);
    if ($bcc038267b15f6fa$var$Wa(b)) return a;
}
function $bcc038267b15f6fa$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bcc038267b15f6fa$var$we = !1;
if ($bcc038267b15f6fa$var$ia) {
    var $bcc038267b15f6fa$var$xe;
    if ($bcc038267b15f6fa$var$ia) {
        var $bcc038267b15f6fa$var$ye = "oninput" in document;
        if (!$bcc038267b15f6fa$var$ye) {
            var $bcc038267b15f6fa$var$ze = document.createElement("div");
            $bcc038267b15f6fa$var$ze.setAttribute("oninput", "return;");
            $bcc038267b15f6fa$var$ye = "function" === typeof $bcc038267b15f6fa$var$ze.oninput;
        }
        $bcc038267b15f6fa$var$xe = $bcc038267b15f6fa$var$ye;
    } else $bcc038267b15f6fa$var$xe = !1;
    $bcc038267b15f6fa$var$we = $bcc038267b15f6fa$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bcc038267b15f6fa$var$Ae() {
    $bcc038267b15f6fa$var$pe && ($bcc038267b15f6fa$var$pe.detachEvent("onpropertychange", $bcc038267b15f6fa$var$Be), $bcc038267b15f6fa$var$qe = $bcc038267b15f6fa$var$pe = null);
}
function $bcc038267b15f6fa$var$Be(a) {
    if ("value" === a.propertyName && $bcc038267b15f6fa$var$te($bcc038267b15f6fa$var$qe)) {
        var b = [];
        $bcc038267b15f6fa$var$ne(b, $bcc038267b15f6fa$var$qe, a, $bcc038267b15f6fa$var$xb(a));
        $bcc038267b15f6fa$var$Jb($bcc038267b15f6fa$var$re, b);
    }
}
function $bcc038267b15f6fa$var$Ce(a, b, c) {
    "focusin" === a ? ($bcc038267b15f6fa$var$Ae(), $bcc038267b15f6fa$var$pe = b, $bcc038267b15f6fa$var$qe = c, $bcc038267b15f6fa$var$pe.attachEvent("onpropertychange", $bcc038267b15f6fa$var$Be)) : "focusout" === a && $bcc038267b15f6fa$var$Ae();
}
function $bcc038267b15f6fa$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bcc038267b15f6fa$var$te($bcc038267b15f6fa$var$qe);
}
function $bcc038267b15f6fa$var$Ee(a, b) {
    if ("click" === a) return $bcc038267b15f6fa$var$te(b);
}
function $bcc038267b15f6fa$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bcc038267b15f6fa$var$te(b);
}
function $bcc038267b15f6fa$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bcc038267b15f6fa$var$He = "function" === typeof Object.is ? Object.is : $bcc038267b15f6fa$var$Ge;
function $bcc038267b15f6fa$var$Ie(a, b) {
    if ($bcc038267b15f6fa$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bcc038267b15f6fa$var$ja.call(b, e) || !$bcc038267b15f6fa$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bcc038267b15f6fa$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bcc038267b15f6fa$var$Ke(a, b) {
    var c = $bcc038267b15f6fa$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bcc038267b15f6fa$var$Je(c);
    }
}
function $bcc038267b15f6fa$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bcc038267b15f6fa$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bcc038267b15f6fa$var$Me() {
    for(var a = window, b = $bcc038267b15f6fa$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bcc038267b15f6fa$var$Xa(a.document);
    }
    return b;
}
function $bcc038267b15f6fa$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bcc038267b15f6fa$var$Oe(a) {
    var b = $bcc038267b15f6fa$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bcc038267b15f6fa$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bcc038267b15f6fa$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bcc038267b15f6fa$var$Ke(c, f);
                var g = $bcc038267b15f6fa$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bcc038267b15f6fa$var$Pe = $bcc038267b15f6fa$var$ia && "documentMode" in document && 11 >= document.documentMode, $bcc038267b15f6fa$var$Qe = null, $bcc038267b15f6fa$var$Re = null, $bcc038267b15f6fa$var$Se = null, $bcc038267b15f6fa$var$Te = !1;
function $bcc038267b15f6fa$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bcc038267b15f6fa$var$Te || null == $bcc038267b15f6fa$var$Qe || $bcc038267b15f6fa$var$Qe !== $bcc038267b15f6fa$var$Xa(d) || (d = $bcc038267b15f6fa$var$Qe, "selectionStart" in d && $bcc038267b15f6fa$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bcc038267b15f6fa$var$Se && $bcc038267b15f6fa$var$Ie($bcc038267b15f6fa$var$Se, d) || ($bcc038267b15f6fa$var$Se = d, d = $bcc038267b15f6fa$var$oe($bcc038267b15f6fa$var$Re, "onSelect"), 0 < d.length && (b = new $bcc038267b15f6fa$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bcc038267b15f6fa$var$Qe)));
}
function $bcc038267b15f6fa$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bcc038267b15f6fa$var$We = {
    animationend: $bcc038267b15f6fa$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bcc038267b15f6fa$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bcc038267b15f6fa$var$Ve("Animation", "AnimationStart"),
    transitionend: $bcc038267b15f6fa$var$Ve("Transition", "TransitionEnd")
}, $bcc038267b15f6fa$var$Xe = {}, $bcc038267b15f6fa$var$Ye = {};
$bcc038267b15f6fa$var$ia && ($bcc038267b15f6fa$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bcc038267b15f6fa$var$We.animationend.animation, delete $bcc038267b15f6fa$var$We.animationiteration.animation, delete $bcc038267b15f6fa$var$We.animationstart.animation), "TransitionEvent" in window || delete $bcc038267b15f6fa$var$We.transitionend.transition);
function $bcc038267b15f6fa$var$Ze(a) {
    if ($bcc038267b15f6fa$var$Xe[a]) return $bcc038267b15f6fa$var$Xe[a];
    if (!$bcc038267b15f6fa$var$We[a]) return a;
    var b = $bcc038267b15f6fa$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bcc038267b15f6fa$var$Ye) return $bcc038267b15f6fa$var$Xe[a] = b[c];
    return a;
}
var $bcc038267b15f6fa$var$$e = $bcc038267b15f6fa$var$Ze("animationend"), $bcc038267b15f6fa$var$af = $bcc038267b15f6fa$var$Ze("animationiteration"), $bcc038267b15f6fa$var$bf = $bcc038267b15f6fa$var$Ze("animationstart"), $bcc038267b15f6fa$var$cf = $bcc038267b15f6fa$var$Ze("transitionend"), $bcc038267b15f6fa$var$df = new Map, $bcc038267b15f6fa$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bcc038267b15f6fa$var$ff(a, b) {
    $bcc038267b15f6fa$var$df.set(a, b);
    $bcc038267b15f6fa$var$fa(b, [
        a
    ]);
}
for(var $bcc038267b15f6fa$var$gf = 0; $bcc038267b15f6fa$var$gf < $bcc038267b15f6fa$var$ef.length; $bcc038267b15f6fa$var$gf++){
    var $bcc038267b15f6fa$var$hf = $bcc038267b15f6fa$var$ef[$bcc038267b15f6fa$var$gf], $bcc038267b15f6fa$var$jf = $bcc038267b15f6fa$var$hf.toLowerCase(), $bcc038267b15f6fa$var$kf = $bcc038267b15f6fa$var$hf[0].toUpperCase() + $bcc038267b15f6fa$var$hf.slice(1);
    $bcc038267b15f6fa$var$ff($bcc038267b15f6fa$var$jf, "on" + $bcc038267b15f6fa$var$kf);
}
$bcc038267b15f6fa$var$ff($bcc038267b15f6fa$var$$e, "onAnimationEnd");
$bcc038267b15f6fa$var$ff($bcc038267b15f6fa$var$af, "onAnimationIteration");
$bcc038267b15f6fa$var$ff($bcc038267b15f6fa$var$bf, "onAnimationStart");
$bcc038267b15f6fa$var$ff("dblclick", "onDoubleClick");
$bcc038267b15f6fa$var$ff("focusin", "onFocus");
$bcc038267b15f6fa$var$ff("focusout", "onBlur");
$bcc038267b15f6fa$var$ff($bcc038267b15f6fa$var$cf, "onTransitionEnd");
$bcc038267b15f6fa$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bcc038267b15f6fa$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bcc038267b15f6fa$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bcc038267b15f6fa$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bcc038267b15f6fa$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bcc038267b15f6fa$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bcc038267b15f6fa$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bcc038267b15f6fa$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bcc038267b15f6fa$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bcc038267b15f6fa$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bcc038267b15f6fa$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bcc038267b15f6fa$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bcc038267b15f6fa$var$lf));
function $bcc038267b15f6fa$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bcc038267b15f6fa$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bcc038267b15f6fa$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bcc038267b15f6fa$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bcc038267b15f6fa$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bcc038267b15f6fa$var$Qb) throw a = $bcc038267b15f6fa$var$Rb, $bcc038267b15f6fa$var$Qb = !1, $bcc038267b15f6fa$var$Rb = null, a;
}
function $bcc038267b15f6fa$var$D(a, b) {
    var c = b[$bcc038267b15f6fa$var$of];
    void 0 === c && (c = b[$bcc038267b15f6fa$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bcc038267b15f6fa$var$pf(b, a, 2, !1), c.add(d));
}
function $bcc038267b15f6fa$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bcc038267b15f6fa$var$pf(c, a, d, b);
}
var $bcc038267b15f6fa$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bcc038267b15f6fa$var$sf(a) {
    if (!a[$bcc038267b15f6fa$var$rf]) {
        a[$bcc038267b15f6fa$var$rf] = !0;
        $bcc038267b15f6fa$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bcc038267b15f6fa$var$mf.has(b) || $bcc038267b15f6fa$var$qf(b, !1, a), $bcc038267b15f6fa$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bcc038267b15f6fa$var$rf] || (b[$bcc038267b15f6fa$var$rf] = !0, $bcc038267b15f6fa$var$qf("selectionchange", !1, b));
    }
}
function $bcc038267b15f6fa$var$pf(a, b, c, d) {
    switch($bcc038267b15f6fa$var$jd(b)){
        case 1:
            var e = $bcc038267b15f6fa$var$ed;
            break;
        case 4:
            e = $bcc038267b15f6fa$var$gd;
            break;
        default:
            e = $bcc038267b15f6fa$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bcc038267b15f6fa$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bcc038267b15f6fa$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d["return"]; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g["return"];
            }
            for(; null !== h;){
                g = $bcc038267b15f6fa$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d["return"];
    }
    $bcc038267b15f6fa$var$Jb(function() {
        var _$d = f, _$e = $bcc038267b15f6fa$var$xb(c), g = [];
        a: {
            var h = $bcc038267b15f6fa$var$df.get(a);
            if (void 0 !== h) {
                var k = $bcc038267b15f6fa$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bcc038267b15f6fa$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bcc038267b15f6fa$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bcc038267b15f6fa$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bcc038267b15f6fa$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bcc038267b15f6fa$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bcc038267b15f6fa$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bcc038267b15f6fa$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bcc038267b15f6fa$var$Vd;
                        break;
                    case $bcc038267b15f6fa$var$$e:
                    case $bcc038267b15f6fa$var$af:
                    case $bcc038267b15f6fa$var$bf:
                        k = $bcc038267b15f6fa$var$Hd;
                        break;
                    case $bcc038267b15f6fa$var$cf:
                        k = $bcc038267b15f6fa$var$Xd;
                        break;
                    case "scroll":
                        k = $bcc038267b15f6fa$var$vd;
                        break;
                    case "wheel":
                        k = $bcc038267b15f6fa$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bcc038267b15f6fa$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bcc038267b15f6fa$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bcc038267b15f6fa$var$Kb(w, x), null != F && t.push($bcc038267b15f6fa$var$tf(w, F, u))));
                    if (J) break;
                    w = w["return"];
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bcc038267b15f6fa$var$wb && (n = c.relatedTarget || c.fromElement) && ($bcc038267b15f6fa$var$Wc(n) || n[$bcc038267b15f6fa$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $bcc038267b15f6fa$var$Wc(n) : null, null !== n && (J = $bcc038267b15f6fa$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $bcc038267b15f6fa$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bcc038267b15f6fa$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bcc038267b15f6fa$var$ue(k);
                        u = null == n ? h : $bcc038267b15f6fa$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bcc038267b15f6fa$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bcc038267b15f6fa$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bcc038267b15f6fa$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bcc038267b15f6fa$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bcc038267b15f6fa$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bcc038267b15f6fa$var$vf(t);
                                x = $bcc038267b15f6fa$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bcc038267b15f6fa$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bcc038267b15f6fa$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $bcc038267b15f6fa$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bcc038267b15f6fa$var$ve;
                else if ($bcc038267b15f6fa$var$me(h)) {
                    if ($bcc038267b15f6fa$var$we) na = $bcc038267b15f6fa$var$Fe;
                    else {
                        na = $bcc038267b15f6fa$var$De;
                        var xa = $bcc038267b15f6fa$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bcc038267b15f6fa$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $bcc038267b15f6fa$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bcc038267b15f6fa$var$cb(h, "number", h.value);
            }
            xa = _$d ? $bcc038267b15f6fa$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($bcc038267b15f6fa$var$me(xa) || "true" === xa.contentEditable) $bcc038267b15f6fa$var$Qe = xa, $bcc038267b15f6fa$var$Re = _$d, $bcc038267b15f6fa$var$Se = null;
                    break;
                case "focusout":
                    $bcc038267b15f6fa$var$Se = $bcc038267b15f6fa$var$Re = $bcc038267b15f6fa$var$Qe = null;
                    break;
                case "mousedown":
                    $bcc038267b15f6fa$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bcc038267b15f6fa$var$Te = !1;
                    $bcc038267b15f6fa$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($bcc038267b15f6fa$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bcc038267b15f6fa$var$Ue(g, c, _$e);
            }
            var $a;
            if ($bcc038267b15f6fa$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bcc038267b15f6fa$var$ie ? $bcc038267b15f6fa$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bcc038267b15f6fa$var$de && "ko" !== c.locale && ($bcc038267b15f6fa$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bcc038267b15f6fa$var$ie && ($a = $bcc038267b15f6fa$var$nd()) : ($bcc038267b15f6fa$var$kd = _$e, $bcc038267b15f6fa$var$ld = "value" in $bcc038267b15f6fa$var$kd ? $bcc038267b15f6fa$var$kd.value : $bcc038267b15f6fa$var$kd.textContent, $bcc038267b15f6fa$var$ie = !0)), xa = $bcc038267b15f6fa$var$oe(_$d, ba), 0 < xa.length && (ba = new $bcc038267b15f6fa$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bcc038267b15f6fa$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bcc038267b15f6fa$var$ce ? $bcc038267b15f6fa$var$je(a, c) : $bcc038267b15f6fa$var$ke(a, c)) _$d = $bcc038267b15f6fa$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $bcc038267b15f6fa$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $bcc038267b15f6fa$var$se(g, b);
    });
}
function $bcc038267b15f6fa$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bcc038267b15f6fa$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bcc038267b15f6fa$var$Kb(a, c), null != f && d.unshift($bcc038267b15f6fa$var$tf(a, f, e)), f = $bcc038267b15f6fa$var$Kb(a, b), null != f && d.push($bcc038267b15f6fa$var$tf(a, f, e)));
        a = a["return"];
    }
    return d;
}
function $bcc038267b15f6fa$var$vf(a) {
    if (null === a) return null;
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bcc038267b15f6fa$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bcc038267b15f6fa$var$Kb(c, f), null != k && g.unshift($bcc038267b15f6fa$var$tf(c, k, h))) : e || (k = $bcc038267b15f6fa$var$Kb(c, f), null != k && g.push($bcc038267b15f6fa$var$tf(c, k, h))));
        c = c["return"];
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bcc038267b15f6fa$var$xf = /\r\n?/g, $bcc038267b15f6fa$var$yf = /\u0000|\uFFFD/g;
function $bcc038267b15f6fa$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bcc038267b15f6fa$var$xf, "\n").replace($bcc038267b15f6fa$var$yf, "");
}
function $bcc038267b15f6fa$var$Af(a, b, c) {
    b = $bcc038267b15f6fa$var$zf(b);
    if ($bcc038267b15f6fa$var$zf(a) !== b && c) throw Error($bcc038267b15f6fa$var$p(425));
}
function $bcc038267b15f6fa$var$Bf() {}
var $bcc038267b15f6fa$var$Cf = null, $bcc038267b15f6fa$var$Df = null;
function $bcc038267b15f6fa$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bcc038267b15f6fa$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bcc038267b15f6fa$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bcc038267b15f6fa$var$Hf = "function" === typeof Promise ? Promise : void 0, $bcc038267b15f6fa$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bcc038267b15f6fa$var$Hf ? function Jf(a) {
    return $bcc038267b15f6fa$var$Hf.resolve(null).then(a)["catch"]($bcc038267b15f6fa$var$If);
} : $bcc038267b15f6fa$var$Ff;
function $bcc038267b15f6fa$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bcc038267b15f6fa$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bcc038267b15f6fa$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bcc038267b15f6fa$var$bd(b);
}
function $bcc038267b15f6fa$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bcc038267b15f6fa$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bcc038267b15f6fa$var$Nf = Math.random().toString(36).slice(2), $bcc038267b15f6fa$var$Of = "__reactFiber$" + $bcc038267b15f6fa$var$Nf, $bcc038267b15f6fa$var$Pf = "__reactProps$" + $bcc038267b15f6fa$var$Nf, $bcc038267b15f6fa$var$uf = "__reactContainer$" + $bcc038267b15f6fa$var$Nf, $bcc038267b15f6fa$var$of = "__reactEvents$" + $bcc038267b15f6fa$var$Nf, $bcc038267b15f6fa$var$Qf = "__reactListeners$" + $bcc038267b15f6fa$var$Nf, $bcc038267b15f6fa$var$Rf = "__reactHandles$" + $bcc038267b15f6fa$var$Nf;
function $bcc038267b15f6fa$var$Wc(a) {
    var b = a[$bcc038267b15f6fa$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bcc038267b15f6fa$var$uf] || c[$bcc038267b15f6fa$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bcc038267b15f6fa$var$Mf(a); null !== a;){
                if (c = a[$bcc038267b15f6fa$var$Of]) return c;
                a = $bcc038267b15f6fa$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bcc038267b15f6fa$var$Cb(a) {
    a = a[$bcc038267b15f6fa$var$Of] || a[$bcc038267b15f6fa$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bcc038267b15f6fa$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bcc038267b15f6fa$var$p(33));
}
function $bcc038267b15f6fa$var$Db(a) {
    return a[$bcc038267b15f6fa$var$Pf] || null;
}
var $bcc038267b15f6fa$var$Sf = [], $bcc038267b15f6fa$var$Tf = -1;
function $bcc038267b15f6fa$var$Uf(a) {
    return {
        current: a
    };
}
function $bcc038267b15f6fa$var$E(a) {
    0 > $bcc038267b15f6fa$var$Tf || (a.current = $bcc038267b15f6fa$var$Sf[$bcc038267b15f6fa$var$Tf], $bcc038267b15f6fa$var$Sf[$bcc038267b15f6fa$var$Tf] = null, $bcc038267b15f6fa$var$Tf--);
}
function $bcc038267b15f6fa$var$G(a, b) {
    $bcc038267b15f6fa$var$Tf++;
    $bcc038267b15f6fa$var$Sf[$bcc038267b15f6fa$var$Tf] = a.current;
    a.current = b;
}
var $bcc038267b15f6fa$var$Vf = {}, $bcc038267b15f6fa$var$H = $bcc038267b15f6fa$var$Uf($bcc038267b15f6fa$var$Vf), $bcc038267b15f6fa$var$Wf = $bcc038267b15f6fa$var$Uf(!1), $bcc038267b15f6fa$var$Xf = $bcc038267b15f6fa$var$Vf;
function $bcc038267b15f6fa$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bcc038267b15f6fa$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bcc038267b15f6fa$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bcc038267b15f6fa$var$$f() {
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf);
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$H);
}
function $bcc038267b15f6fa$var$ag(a, b, c) {
    if ($bcc038267b15f6fa$var$H.current !== $bcc038267b15f6fa$var$Vf) throw Error($bcc038267b15f6fa$var$p(168));
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$H, b);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Wf, c);
}
function $bcc038267b15f6fa$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bcc038267b15f6fa$var$p(108, $bcc038267b15f6fa$var$Ra(a) || "Unknown", e));
    return $bcc038267b15f6fa$var$A({}, c, d);
}
function $bcc038267b15f6fa$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bcc038267b15f6fa$var$Vf;
    $bcc038267b15f6fa$var$Xf = $bcc038267b15f6fa$var$H.current;
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$H, a);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Wf, $bcc038267b15f6fa$var$Wf.current);
    return !0;
}
function $bcc038267b15f6fa$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bcc038267b15f6fa$var$p(169));
    c ? (a = $bcc038267b15f6fa$var$bg(a, b, $bcc038267b15f6fa$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf), $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$H), $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$H, a)) : $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Wf, c);
}
var $bcc038267b15f6fa$var$eg = null, $bcc038267b15f6fa$var$fg = !1, $bcc038267b15f6fa$var$gg = !1;
function $bcc038267b15f6fa$var$hg(a) {
    null === $bcc038267b15f6fa$var$eg ? $bcc038267b15f6fa$var$eg = [
        a
    ] : $bcc038267b15f6fa$var$eg.push(a);
}
function $bcc038267b15f6fa$var$ig(a) {
    $bcc038267b15f6fa$var$fg = !0;
    $bcc038267b15f6fa$var$hg(a);
}
function $bcc038267b15f6fa$var$jg() {
    if (!$bcc038267b15f6fa$var$gg && null !== $bcc038267b15f6fa$var$eg) {
        $bcc038267b15f6fa$var$gg = !0;
        var a = 0, b = $bcc038267b15f6fa$var$C;
        try {
            var c = $bcc038267b15f6fa$var$eg;
            for($bcc038267b15f6fa$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bcc038267b15f6fa$var$eg = null;
            $bcc038267b15f6fa$var$fg = !1;
        } catch (e) {
            throw null !== $bcc038267b15f6fa$var$eg && ($bcc038267b15f6fa$var$eg = $bcc038267b15f6fa$var$eg.slice(a + 1)), $bcc038267b15f6fa$var$ac($bcc038267b15f6fa$var$fc, $bcc038267b15f6fa$var$jg), e;
        } finally{
            $bcc038267b15f6fa$var$C = b, $bcc038267b15f6fa$var$gg = !1;
        }
    }
    return null;
}
var $bcc038267b15f6fa$var$kg = [], $bcc038267b15f6fa$var$lg = 0, $bcc038267b15f6fa$var$mg = null, $bcc038267b15f6fa$var$ng = 0, $bcc038267b15f6fa$var$og = [], $bcc038267b15f6fa$var$pg = 0, $bcc038267b15f6fa$var$qg = null, $bcc038267b15f6fa$var$rg = 1, $bcc038267b15f6fa$var$sg = "";
function $bcc038267b15f6fa$var$tg(a, b) {
    $bcc038267b15f6fa$var$kg[$bcc038267b15f6fa$var$lg++] = $bcc038267b15f6fa$var$ng;
    $bcc038267b15f6fa$var$kg[$bcc038267b15f6fa$var$lg++] = $bcc038267b15f6fa$var$mg;
    $bcc038267b15f6fa$var$mg = a;
    $bcc038267b15f6fa$var$ng = b;
}
function $bcc038267b15f6fa$var$ug(a, b, c) {
    $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$rg;
    $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$sg;
    $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$qg;
    $bcc038267b15f6fa$var$qg = a;
    var d = $bcc038267b15f6fa$var$rg;
    a = $bcc038267b15f6fa$var$sg;
    var e = 32 - $bcc038267b15f6fa$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bcc038267b15f6fa$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bcc038267b15f6fa$var$rg = 1 << 32 - $bcc038267b15f6fa$var$oc(b) + e | c << e | d;
        $bcc038267b15f6fa$var$sg = f + a;
    } else $bcc038267b15f6fa$var$rg = 1 << f | c << e | d, $bcc038267b15f6fa$var$sg = a;
}
function $bcc038267b15f6fa$var$vg(a) {
    null !== a["return"] && ($bcc038267b15f6fa$var$tg(a, 1), $bcc038267b15f6fa$var$ug(a, 1, 0));
}
function $bcc038267b15f6fa$var$wg(a) {
    for(; a === $bcc038267b15f6fa$var$mg;)$bcc038267b15f6fa$var$mg = $bcc038267b15f6fa$var$kg[--$bcc038267b15f6fa$var$lg], $bcc038267b15f6fa$var$kg[$bcc038267b15f6fa$var$lg] = null, $bcc038267b15f6fa$var$ng = $bcc038267b15f6fa$var$kg[--$bcc038267b15f6fa$var$lg], $bcc038267b15f6fa$var$kg[$bcc038267b15f6fa$var$lg] = null;
    for(; a === $bcc038267b15f6fa$var$qg;)$bcc038267b15f6fa$var$qg = $bcc038267b15f6fa$var$og[--$bcc038267b15f6fa$var$pg], $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg] = null, $bcc038267b15f6fa$var$sg = $bcc038267b15f6fa$var$og[--$bcc038267b15f6fa$var$pg], $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg] = null, $bcc038267b15f6fa$var$rg = $bcc038267b15f6fa$var$og[--$bcc038267b15f6fa$var$pg], $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg] = null;
}
var $bcc038267b15f6fa$var$xg = null, $bcc038267b15f6fa$var$yg = null, $bcc038267b15f6fa$var$I = !1, $bcc038267b15f6fa$var$zg = null;
function $bcc038267b15f6fa$var$Ag(a, b) {
    var c = $bcc038267b15f6fa$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bcc038267b15f6fa$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bcc038267b15f6fa$var$xg = a, $bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bcc038267b15f6fa$var$xg = a, $bcc038267b15f6fa$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bcc038267b15f6fa$var$qg ? {
                id: $bcc038267b15f6fa$var$rg,
                overflow: $bcc038267b15f6fa$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bcc038267b15f6fa$var$Bg(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, $bcc038267b15f6fa$var$xg = a, $bcc038267b15f6fa$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bcc038267b15f6fa$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bcc038267b15f6fa$var$Eg(a) {
    if ($bcc038267b15f6fa$var$I) {
        var b = $bcc038267b15f6fa$var$yg;
        if (b) {
            var c = b;
            if (!$bcc038267b15f6fa$var$Cg(a, b)) {
                if ($bcc038267b15f6fa$var$Dg(a)) throw Error($bcc038267b15f6fa$var$p(418));
                b = $bcc038267b15f6fa$var$Lf(c.nextSibling);
                var d = $bcc038267b15f6fa$var$xg;
                b && $bcc038267b15f6fa$var$Cg(a, b) ? $bcc038267b15f6fa$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bcc038267b15f6fa$var$I = !1, $bcc038267b15f6fa$var$xg = a);
            }
        } else {
            if ($bcc038267b15f6fa$var$Dg(a)) throw Error($bcc038267b15f6fa$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bcc038267b15f6fa$var$I = !1;
            $bcc038267b15f6fa$var$xg = a;
        }
    }
}
function $bcc038267b15f6fa$var$Fg(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    $bcc038267b15f6fa$var$xg = a;
}
function $bcc038267b15f6fa$var$Gg(a) {
    if (a !== $bcc038267b15f6fa$var$xg) return !1;
    if (!$bcc038267b15f6fa$var$I) return $bcc038267b15f6fa$var$Fg(a), $bcc038267b15f6fa$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bcc038267b15f6fa$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bcc038267b15f6fa$var$yg)) {
        if ($bcc038267b15f6fa$var$Dg(a)) throw $bcc038267b15f6fa$var$Hg(), Error($bcc038267b15f6fa$var$p(418));
        for(; b;)$bcc038267b15f6fa$var$Ag(a, b), b = $bcc038267b15f6fa$var$Lf(b.nextSibling);
    }
    $bcc038267b15f6fa$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bcc038267b15f6fa$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bcc038267b15f6fa$var$yg = null;
        }
    } else $bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$xg ? $bcc038267b15f6fa$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bcc038267b15f6fa$var$Hg() {
    for(var a = $bcc038267b15f6fa$var$yg; a;)a = $bcc038267b15f6fa$var$Lf(a.nextSibling);
}
function $bcc038267b15f6fa$var$Ig() {
    $bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$xg = null;
    $bcc038267b15f6fa$var$I = !1;
}
function $bcc038267b15f6fa$var$Jg(a) {
    null === $bcc038267b15f6fa$var$zg ? $bcc038267b15f6fa$var$zg = [
        a
    ] : $bcc038267b15f6fa$var$zg.push(a);
}
var $bcc038267b15f6fa$var$Kg = $bcc038267b15f6fa$var$ua.ReactCurrentBatchConfig;
function $bcc038267b15f6fa$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $bcc038267b15f6fa$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $bcc038267b15f6fa$var$Mg = $bcc038267b15f6fa$var$Uf(null), $bcc038267b15f6fa$var$Ng = null, $bcc038267b15f6fa$var$Og = null, $bcc038267b15f6fa$var$Pg = null;
function $bcc038267b15f6fa$var$Qg() {
    $bcc038267b15f6fa$var$Pg = $bcc038267b15f6fa$var$Og = $bcc038267b15f6fa$var$Ng = null;
}
function $bcc038267b15f6fa$var$Rg(a) {
    var b = $bcc038267b15f6fa$var$Mg.current;
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Mg);
    a._currentValue = b;
}
function $bcc038267b15f6fa$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a["return"];
    }
}
function $bcc038267b15f6fa$var$Tg(a, b) {
    $bcc038267b15f6fa$var$Ng = a;
    $bcc038267b15f6fa$var$Pg = $bcc038267b15f6fa$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bcc038267b15f6fa$var$Ug = !0), a.firstContext = null);
}
function $bcc038267b15f6fa$var$Vg(a) {
    var b = a._currentValue;
    if ($bcc038267b15f6fa$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bcc038267b15f6fa$var$Og) {
            if (null === $bcc038267b15f6fa$var$Ng) throw Error($bcc038267b15f6fa$var$p(308));
            $bcc038267b15f6fa$var$Og = a;
            $bcc038267b15f6fa$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bcc038267b15f6fa$var$Og = $bcc038267b15f6fa$var$Og.next = a;
    }
    return b;
}
var $bcc038267b15f6fa$var$Wg = null;
function $bcc038267b15f6fa$var$Xg(a) {
    null === $bcc038267b15f6fa$var$Wg ? $bcc038267b15f6fa$var$Wg = [
        a
    ] : $bcc038267b15f6fa$var$Wg.push(a);
}
function $bcc038267b15f6fa$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bcc038267b15f6fa$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bcc038267b15f6fa$var$Zg(a, d);
}
function $bcc038267b15f6fa$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a["return"]; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
    return 3 === c.tag ? c.stateNode : null;
}
var $bcc038267b15f6fa$var$$g = !1;
function $bcc038267b15f6fa$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bcc038267b15f6fa$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bcc038267b15f6fa$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bcc038267b15f6fa$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bcc038267b15f6fa$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bcc038267b15f6fa$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bcc038267b15f6fa$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bcc038267b15f6fa$var$Zg(a, c);
}
function $bcc038267b15f6fa$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bcc038267b15f6fa$var$Cc(a, c);
    }
}
function $bcc038267b15f6fa$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bcc038267b15f6fa$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $bcc038267b15f6fa$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bcc038267b15f6fa$var$A({}, q, r);
                            break a;
                        case 2:
                            $bcc038267b15f6fa$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bcc038267b15f6fa$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bcc038267b15f6fa$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bcc038267b15f6fa$var$p(191, e));
            e.call(d);
        }
    }
}
var $bcc038267b15f6fa$var$jh = (new $8SyCD.Component).refs;
function $bcc038267b15f6fa$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bcc038267b15f6fa$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bcc038267b15f6fa$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $bcc038267b15f6fa$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $bcc038267b15f6fa$var$L(), e = $bcc038267b15f6fa$var$lh(a), f = $bcc038267b15f6fa$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bcc038267b15f6fa$var$dh(a, f, e);
        null !== b && ($bcc038267b15f6fa$var$mh(b, a, e, d), $bcc038267b15f6fa$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $bcc038267b15f6fa$var$L(), e = $bcc038267b15f6fa$var$lh(a), f = $bcc038267b15f6fa$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bcc038267b15f6fa$var$dh(a, f, e);
        null !== b && ($bcc038267b15f6fa$var$mh(b, a, e, d), $bcc038267b15f6fa$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $bcc038267b15f6fa$var$L(), d = $bcc038267b15f6fa$var$lh(a), e = $bcc038267b15f6fa$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bcc038267b15f6fa$var$dh(a, e, d);
        null !== b && ($bcc038267b15f6fa$var$mh(b, a, d, c), $bcc038267b15f6fa$var$eh(b, a, d));
    }
};
function $bcc038267b15f6fa$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bcc038267b15f6fa$var$Ie(c, d) || !$bcc038267b15f6fa$var$Ie(e, f) : !0;
}
function $bcc038267b15f6fa$var$ph(a, b, c) {
    var d = !1, e = $bcc038267b15f6fa$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $bcc038267b15f6fa$var$Vg(f) : (e = $bcc038267b15f6fa$var$Zf(b) ? $bcc038267b15f6fa$var$Xf : $bcc038267b15f6fa$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bcc038267b15f6fa$var$Yf(a, e) : $bcc038267b15f6fa$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bcc038267b15f6fa$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bcc038267b15f6fa$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bcc038267b15f6fa$var$nh.enqueueReplaceState(b, b.state, null);
}
function $bcc038267b15f6fa$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $bcc038267b15f6fa$var$jh;
    $bcc038267b15f6fa$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $bcc038267b15f6fa$var$Vg(f) : (f = $bcc038267b15f6fa$var$Zf(b) ? $bcc038267b15f6fa$var$Xf : $bcc038267b15f6fa$var$H.current, e.context = $bcc038267b15f6fa$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bcc038267b15f6fa$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bcc038267b15f6fa$var$nh.enqueueReplaceState(e, e.state, null), $bcc038267b15f6fa$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bcc038267b15f6fa$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bcc038267b15f6fa$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bcc038267b15f6fa$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $bcc038267b15f6fa$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bcc038267b15f6fa$var$p(284));
        if (!c._owner) throw Error($bcc038267b15f6fa$var$p(290, a));
    }
    return a;
}
function $bcc038267b15f6fa$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bcc038267b15f6fa$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bcc038267b15f6fa$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $bcc038267b15f6fa$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bcc038267b15f6fa$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bcc038267b15f6fa$var$xh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bcc038267b15f6fa$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $bcc038267b15f6fa$var$Ha && $bcc038267b15f6fa$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $bcc038267b15f6fa$var$sh(a, b, c), d["return"] = a, d;
        d = $bcc038267b15f6fa$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bcc038267b15f6fa$var$sh(a, b, c);
        d["return"] = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bcc038267b15f6fa$var$zh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bcc038267b15f6fa$var$Ah(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bcc038267b15f6fa$var$xh("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $bcc038267b15f6fa$var$va:
                    return c = $bcc038267b15f6fa$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $bcc038267b15f6fa$var$sh(a, null, b), c["return"] = a, c;
                case $bcc038267b15f6fa$var$wa:
                    return b = $bcc038267b15f6fa$var$zh(b, a.mode, c), b["return"] = a, b;
                case $bcc038267b15f6fa$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bcc038267b15f6fa$var$eb(b) || $bcc038267b15f6fa$var$Ka(b)) return b = $bcc038267b15f6fa$var$Ah(b, a.mode, c, null), b["return"] = a, b;
            $bcc038267b15f6fa$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $bcc038267b15f6fa$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bcc038267b15f6fa$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bcc038267b15f6fa$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bcc038267b15f6fa$var$eb(c) || $bcc038267b15f6fa$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bcc038267b15f6fa$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $bcc038267b15f6fa$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bcc038267b15f6fa$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bcc038267b15f6fa$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bcc038267b15f6fa$var$eb(d) || $bcc038267b15f6fa$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bcc038267b15f6fa$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u["delete"](null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bcc038267b15f6fa$var$Ka(h);
        if ("function" !== typeof l) throw Error($bcc038267b15f6fa$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bcc038267b15f6fa$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m["delete"](null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bcc038267b15f6fa$var$I && $bcc038267b15f6fa$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $bcc038267b15f6fa$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $bcc038267b15f6fa$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bcc038267b15f6fa$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $bcc038267b15f6fa$var$Ha && $bcc038267b15f6fa$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bcc038267b15f6fa$var$sh(a, l, f);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bcc038267b15f6fa$var$ya ? (d = $bcc038267b15f6fa$var$Ah(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = $bcc038267b15f6fa$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $bcc038267b15f6fa$var$sh(a, d, f), h["return"] = a, a = h);
                    }
                    return g(a);
                case $bcc038267b15f6fa$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bcc038267b15f6fa$var$zh(f, a.mode, h);
                        d["return"] = a;
                        a = d;
                    }
                    return g(a);
                case $bcc038267b15f6fa$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bcc038267b15f6fa$var$eb(f)) return n(a, d, f, h);
            if ($bcc038267b15f6fa$var$Ka(f)) return t(a, d, f, h);
            $bcc038267b15f6fa$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = $bcc038267b15f6fa$var$xh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bcc038267b15f6fa$var$Bh = $bcc038267b15f6fa$var$vh(!0), $bcc038267b15f6fa$var$Ch = $bcc038267b15f6fa$var$vh(!1), $bcc038267b15f6fa$var$Dh = {}, $bcc038267b15f6fa$var$Eh = $bcc038267b15f6fa$var$Uf($bcc038267b15f6fa$var$Dh), $bcc038267b15f6fa$var$Fh = $bcc038267b15f6fa$var$Uf($bcc038267b15f6fa$var$Dh), $bcc038267b15f6fa$var$Gh = $bcc038267b15f6fa$var$Uf($bcc038267b15f6fa$var$Dh);
function $bcc038267b15f6fa$var$Hh(a) {
    if (a === $bcc038267b15f6fa$var$Dh) throw Error($bcc038267b15f6fa$var$p(174));
    return a;
}
function $bcc038267b15f6fa$var$Ih(a, b) {
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Gh, b);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Fh, a);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Eh, $bcc038267b15f6fa$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bcc038267b15f6fa$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bcc038267b15f6fa$var$lb(b, a);
    }
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Eh);
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Eh, b);
}
function $bcc038267b15f6fa$var$Jh() {
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Eh);
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Fh);
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Gh);
}
function $bcc038267b15f6fa$var$Kh(a) {
    $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Gh.current);
    var b = $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Eh.current);
    var c = $bcc038267b15f6fa$var$lb(b, a.type);
    b !== c && ($bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Fh, a), $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Eh, c));
}
function $bcc038267b15f6fa$var$Lh(a) {
    $bcc038267b15f6fa$var$Fh.current === a && ($bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Eh), $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Fh));
}
var $bcc038267b15f6fa$var$M = $bcc038267b15f6fa$var$Uf(0);
function $bcc038267b15f6fa$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
var $bcc038267b15f6fa$var$Nh = [];
function $bcc038267b15f6fa$var$Oh() {
    for(var a = 0; a < $bcc038267b15f6fa$var$Nh.length; a++)$bcc038267b15f6fa$var$Nh[a]._workInProgressVersionPrimary = null;
    $bcc038267b15f6fa$var$Nh.length = 0;
}
var $bcc038267b15f6fa$var$Ph = $bcc038267b15f6fa$var$ua.ReactCurrentDispatcher, $bcc038267b15f6fa$var$Qh = $bcc038267b15f6fa$var$ua.ReactCurrentBatchConfig, $bcc038267b15f6fa$var$Rh = 0, $bcc038267b15f6fa$var$N = null, $bcc038267b15f6fa$var$O = null, $bcc038267b15f6fa$var$P = null, $bcc038267b15f6fa$var$Sh = !1, $bcc038267b15f6fa$var$Th = !1, $bcc038267b15f6fa$var$Uh = 0, $bcc038267b15f6fa$var$Vh = 0;
function $bcc038267b15f6fa$var$Q() {
    throw Error($bcc038267b15f6fa$var$p(321));
}
function $bcc038267b15f6fa$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bcc038267b15f6fa$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bcc038267b15f6fa$var$Xh(a, b, c, d, e, f) {
    $bcc038267b15f6fa$var$Rh = f;
    $bcc038267b15f6fa$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bcc038267b15f6fa$var$Ph.current = null === a || null === a.memoizedState ? $bcc038267b15f6fa$var$Yh : $bcc038267b15f6fa$var$Zh;
    a = c(d, e);
    if ($bcc038267b15f6fa$var$Th) {
        f = 0;
        do {
            $bcc038267b15f6fa$var$Th = !1;
            $bcc038267b15f6fa$var$Uh = 0;
            if (25 <= f) throw Error($bcc038267b15f6fa$var$p(301));
            f += 1;
            $bcc038267b15f6fa$var$P = $bcc038267b15f6fa$var$O = null;
            b.updateQueue = null;
            $bcc038267b15f6fa$var$Ph.current = $bcc038267b15f6fa$var$$h;
            a = c(d, e);
        }while ($bcc038267b15f6fa$var$Th);
    }
    $bcc038267b15f6fa$var$Ph.current = $bcc038267b15f6fa$var$ai;
    b = null !== $bcc038267b15f6fa$var$O && null !== $bcc038267b15f6fa$var$O.next;
    $bcc038267b15f6fa$var$Rh = 0;
    $bcc038267b15f6fa$var$P = $bcc038267b15f6fa$var$O = $bcc038267b15f6fa$var$N = null;
    $bcc038267b15f6fa$var$Sh = !1;
    if (b) throw Error($bcc038267b15f6fa$var$p(300));
    return a;
}
function $bcc038267b15f6fa$var$bi() {
    var a = 0 !== $bcc038267b15f6fa$var$Uh;
    $bcc038267b15f6fa$var$Uh = 0;
    return a;
}
function $bcc038267b15f6fa$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bcc038267b15f6fa$var$P ? $bcc038267b15f6fa$var$N.memoizedState = $bcc038267b15f6fa$var$P = a : $bcc038267b15f6fa$var$P = $bcc038267b15f6fa$var$P.next = a;
    return $bcc038267b15f6fa$var$P;
}
function $bcc038267b15f6fa$var$di() {
    if (null === $bcc038267b15f6fa$var$O) {
        var a = $bcc038267b15f6fa$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bcc038267b15f6fa$var$O.next;
    var b = null === $bcc038267b15f6fa$var$P ? $bcc038267b15f6fa$var$N.memoizedState : $bcc038267b15f6fa$var$P.next;
    if (null !== b) $bcc038267b15f6fa$var$P = b, $bcc038267b15f6fa$var$O = a;
    else {
        if (null === a) throw Error($bcc038267b15f6fa$var$p(310));
        $bcc038267b15f6fa$var$O = a;
        a = {
            memoizedState: $bcc038267b15f6fa$var$O.memoizedState,
            baseState: $bcc038267b15f6fa$var$O.baseState,
            baseQueue: $bcc038267b15f6fa$var$O.baseQueue,
            queue: $bcc038267b15f6fa$var$O.queue,
            next: null
        };
        null === $bcc038267b15f6fa$var$P ? $bcc038267b15f6fa$var$N.memoizedState = $bcc038267b15f6fa$var$P = a : $bcc038267b15f6fa$var$P = $bcc038267b15f6fa$var$P.next = a;
    }
    return $bcc038267b15f6fa$var$P;
}
function $bcc038267b15f6fa$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bcc038267b15f6fa$var$fi(a) {
    var b = $bcc038267b15f6fa$var$di(), c = b.queue;
    if (null === c) throw Error($bcc038267b15f6fa$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bcc038267b15f6fa$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bcc038267b15f6fa$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bcc038267b15f6fa$var$N.lanes |= m;
                $bcc038267b15f6fa$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bcc038267b15f6fa$var$He(d, b.memoizedState) || ($bcc038267b15f6fa$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bcc038267b15f6fa$var$N.lanes |= f, $bcc038267b15f6fa$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bcc038267b15f6fa$var$gi(a) {
    var b = $bcc038267b15f6fa$var$di(), c = b.queue;
    if (null === c) throw Error($bcc038267b15f6fa$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bcc038267b15f6fa$var$He(f, b.memoizedState) || ($bcc038267b15f6fa$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bcc038267b15f6fa$var$hi() {}
function $bcc038267b15f6fa$var$ii(a, b) {
    var c = $bcc038267b15f6fa$var$N, d = $bcc038267b15f6fa$var$di(), e = b(), f = !$bcc038267b15f6fa$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bcc038267b15f6fa$var$Ug = !0);
    d = d.queue;
    $bcc038267b15f6fa$var$ji($bcc038267b15f6fa$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bcc038267b15f6fa$var$P && $bcc038267b15f6fa$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bcc038267b15f6fa$var$li(9, $bcc038267b15f6fa$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $bcc038267b15f6fa$var$R) throw Error($bcc038267b15f6fa$var$p(349));
        0 !== ($bcc038267b15f6fa$var$Rh & 30) || $bcc038267b15f6fa$var$ni(c, b, e);
    }
    return e;
}
function $bcc038267b15f6fa$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bcc038267b15f6fa$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bcc038267b15f6fa$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bcc038267b15f6fa$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bcc038267b15f6fa$var$oi(b) && $bcc038267b15f6fa$var$pi(a);
}
function $bcc038267b15f6fa$var$ki(a, b, c) {
    return c(function() {
        $bcc038267b15f6fa$var$oi(b) && $bcc038267b15f6fa$var$pi(a);
    });
}
function $bcc038267b15f6fa$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bcc038267b15f6fa$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bcc038267b15f6fa$var$pi(a) {
    var b = $bcc038267b15f6fa$var$Zg(a, 1);
    null !== b && $bcc038267b15f6fa$var$mh(b, a, 1, -1);
}
function $bcc038267b15f6fa$var$qi(a) {
    var b = $bcc038267b15f6fa$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bcc038267b15f6fa$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bcc038267b15f6fa$var$ri.bind(null, $bcc038267b15f6fa$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bcc038267b15f6fa$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bcc038267b15f6fa$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bcc038267b15f6fa$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bcc038267b15f6fa$var$si() {
    return $bcc038267b15f6fa$var$di().memoizedState;
}
function $bcc038267b15f6fa$var$ti(a, b, c, d) {
    var e = $bcc038267b15f6fa$var$ci();
    $bcc038267b15f6fa$var$N.flags |= a;
    e.memoizedState = $bcc038267b15f6fa$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bcc038267b15f6fa$var$ui(a, b, c, d) {
    var e = $bcc038267b15f6fa$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bcc038267b15f6fa$var$O) {
        var g = $bcc038267b15f6fa$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $bcc038267b15f6fa$var$Wh(d, g.deps)) {
            e.memoizedState = $bcc038267b15f6fa$var$li(b, c, f, d);
            return;
        }
    }
    $bcc038267b15f6fa$var$N.flags |= a;
    e.memoizedState = $bcc038267b15f6fa$var$li(1 | b, c, f, d);
}
function $bcc038267b15f6fa$var$vi(a, b) {
    return $bcc038267b15f6fa$var$ti(8390656, 8, a, b);
}
function $bcc038267b15f6fa$var$ji(a, b) {
    return $bcc038267b15f6fa$var$ui(2048, 8, a, b);
}
function $bcc038267b15f6fa$var$wi(a, b) {
    return $bcc038267b15f6fa$var$ui(4, 2, a, b);
}
function $bcc038267b15f6fa$var$xi(a, b) {
    return $bcc038267b15f6fa$var$ui(4, 4, a, b);
}
function $bcc038267b15f6fa$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bcc038267b15f6fa$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bcc038267b15f6fa$var$ui(4, 4, $bcc038267b15f6fa$var$yi.bind(null, b, a), c);
}
function $bcc038267b15f6fa$var$Ai() {}
function $bcc038267b15f6fa$var$Bi(a, b) {
    var c = $bcc038267b15f6fa$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bcc038267b15f6fa$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bcc038267b15f6fa$var$Ci(a, b) {
    var c = $bcc038267b15f6fa$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bcc038267b15f6fa$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bcc038267b15f6fa$var$Di(a, b, c) {
    if (0 === ($bcc038267b15f6fa$var$Rh & 21)) return a.baseState && (a.baseState = !1, $bcc038267b15f6fa$var$Ug = !0), a.memoizedState = c;
    $bcc038267b15f6fa$var$He(c, b) || (c = $bcc038267b15f6fa$var$yc(), $bcc038267b15f6fa$var$N.lanes |= c, $bcc038267b15f6fa$var$hh |= c, a.baseState = !0);
    return b;
}
function $bcc038267b15f6fa$var$Ei(a, b) {
    var c = $bcc038267b15f6fa$var$C;
    $bcc038267b15f6fa$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bcc038267b15f6fa$var$Qh.transition;
    $bcc038267b15f6fa$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bcc038267b15f6fa$var$C = c, $bcc038267b15f6fa$var$Qh.transition = d;
    }
}
function $bcc038267b15f6fa$var$Fi() {
    return $bcc038267b15f6fa$var$di().memoizedState;
}
function $bcc038267b15f6fa$var$Gi(a, b, c) {
    var d = $bcc038267b15f6fa$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcc038267b15f6fa$var$Hi(a)) $bcc038267b15f6fa$var$Ii(b, c);
    else if (c = $bcc038267b15f6fa$var$Yg(a, b, c, d), null !== c) {
        var e = $bcc038267b15f6fa$var$L();
        $bcc038267b15f6fa$var$mh(c, a, d, e);
        $bcc038267b15f6fa$var$Ji(c, b, d);
    }
}
function $bcc038267b15f6fa$var$ri(a, b, c) {
    var d = $bcc038267b15f6fa$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcc038267b15f6fa$var$Hi(a)) $bcc038267b15f6fa$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bcc038267b15f6fa$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bcc038267b15f6fa$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bcc038267b15f6fa$var$Yg(a, b, e, d);
        null !== c && (e = $bcc038267b15f6fa$var$L(), $bcc038267b15f6fa$var$mh(c, a, d, e), $bcc038267b15f6fa$var$Ji(c, b, d));
    }
}
function $bcc038267b15f6fa$var$Hi(a) {
    var b = a.alternate;
    return a === $bcc038267b15f6fa$var$N || null !== b && b === $bcc038267b15f6fa$var$N;
}
function $bcc038267b15f6fa$var$Ii(a, b) {
    $bcc038267b15f6fa$var$Th = $bcc038267b15f6fa$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bcc038267b15f6fa$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bcc038267b15f6fa$var$Cc(a, c);
    }
}
var $bcc038267b15f6fa$var$ai = {
    readContext: $bcc038267b15f6fa$var$Vg,
    useCallback: $bcc038267b15f6fa$var$Q,
    useContext: $bcc038267b15f6fa$var$Q,
    useEffect: $bcc038267b15f6fa$var$Q,
    useImperativeHandle: $bcc038267b15f6fa$var$Q,
    useInsertionEffect: $bcc038267b15f6fa$var$Q,
    useLayoutEffect: $bcc038267b15f6fa$var$Q,
    useMemo: $bcc038267b15f6fa$var$Q,
    useReducer: $bcc038267b15f6fa$var$Q,
    useRef: $bcc038267b15f6fa$var$Q,
    useState: $bcc038267b15f6fa$var$Q,
    useDebugValue: $bcc038267b15f6fa$var$Q,
    useDeferredValue: $bcc038267b15f6fa$var$Q,
    useTransition: $bcc038267b15f6fa$var$Q,
    useMutableSource: $bcc038267b15f6fa$var$Q,
    useSyncExternalStore: $bcc038267b15f6fa$var$Q,
    useId: $bcc038267b15f6fa$var$Q,
    unstable_isNewReconciler: !1
}, $bcc038267b15f6fa$var$Yh = {
    readContext: $bcc038267b15f6fa$var$Vg,
    useCallback: function useCallback(a, b) {
        $bcc038267b15f6fa$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bcc038267b15f6fa$var$Vg,
    useEffect: $bcc038267b15f6fa$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bcc038267b15f6fa$var$ti(4194308, 4, $bcc038267b15f6fa$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $bcc038267b15f6fa$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $bcc038267b15f6fa$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $bcc038267b15f6fa$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $bcc038267b15f6fa$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bcc038267b15f6fa$var$Gi.bind(null, $bcc038267b15f6fa$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $bcc038267b15f6fa$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bcc038267b15f6fa$var$qi,
    useDebugValue: $bcc038267b15f6fa$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $bcc038267b15f6fa$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $bcc038267b15f6fa$var$qi(!1), b = a[0];
        a = $bcc038267b15f6fa$var$Ei.bind(null, a[1]);
        $bcc038267b15f6fa$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $bcc038267b15f6fa$var$N, e = $bcc038267b15f6fa$var$ci();
        if ($bcc038267b15f6fa$var$I) {
            if (void 0 === c) throw Error($bcc038267b15f6fa$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bcc038267b15f6fa$var$R) throw Error($bcc038267b15f6fa$var$p(349));
            0 !== ($bcc038267b15f6fa$var$Rh & 30) || $bcc038267b15f6fa$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bcc038267b15f6fa$var$vi($bcc038267b15f6fa$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bcc038267b15f6fa$var$li(9, $bcc038267b15f6fa$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $bcc038267b15f6fa$var$ci(), b = $bcc038267b15f6fa$var$R.identifierPrefix;
        if ($bcc038267b15f6fa$var$I) {
            var c = $bcc038267b15f6fa$var$sg;
            var d = $bcc038267b15f6fa$var$rg;
            c = (d & ~(1 << 32 - $bcc038267b15f6fa$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bcc038267b15f6fa$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bcc038267b15f6fa$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bcc038267b15f6fa$var$Zh = {
    readContext: $bcc038267b15f6fa$var$Vg,
    useCallback: $bcc038267b15f6fa$var$Bi,
    useContext: $bcc038267b15f6fa$var$Vg,
    useEffect: $bcc038267b15f6fa$var$ji,
    useImperativeHandle: $bcc038267b15f6fa$var$zi,
    useInsertionEffect: $bcc038267b15f6fa$var$wi,
    useLayoutEffect: $bcc038267b15f6fa$var$xi,
    useMemo: $bcc038267b15f6fa$var$Ci,
    useReducer: $bcc038267b15f6fa$var$fi,
    useRef: $bcc038267b15f6fa$var$si,
    useState: function useState() {
        return $bcc038267b15f6fa$var$fi($bcc038267b15f6fa$var$ei);
    },
    useDebugValue: $bcc038267b15f6fa$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bcc038267b15f6fa$var$di();
        return $bcc038267b15f6fa$var$Di(b, $bcc038267b15f6fa$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bcc038267b15f6fa$var$fi($bcc038267b15f6fa$var$ei)[0], b = $bcc038267b15f6fa$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bcc038267b15f6fa$var$hi,
    useSyncExternalStore: $bcc038267b15f6fa$var$ii,
    useId: $bcc038267b15f6fa$var$Fi,
    unstable_isNewReconciler: !1
}, $bcc038267b15f6fa$var$$h = {
    readContext: $bcc038267b15f6fa$var$Vg,
    useCallback: $bcc038267b15f6fa$var$Bi,
    useContext: $bcc038267b15f6fa$var$Vg,
    useEffect: $bcc038267b15f6fa$var$ji,
    useImperativeHandle: $bcc038267b15f6fa$var$zi,
    useInsertionEffect: $bcc038267b15f6fa$var$wi,
    useLayoutEffect: $bcc038267b15f6fa$var$xi,
    useMemo: $bcc038267b15f6fa$var$Ci,
    useReducer: $bcc038267b15f6fa$var$gi,
    useRef: $bcc038267b15f6fa$var$si,
    useState: function useState() {
        return $bcc038267b15f6fa$var$gi($bcc038267b15f6fa$var$ei);
    },
    useDebugValue: $bcc038267b15f6fa$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bcc038267b15f6fa$var$di();
        return null === $bcc038267b15f6fa$var$O ? b.memoizedState = a : $bcc038267b15f6fa$var$Di(b, $bcc038267b15f6fa$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bcc038267b15f6fa$var$gi($bcc038267b15f6fa$var$ei)[0], b = $bcc038267b15f6fa$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bcc038267b15f6fa$var$hi,
    useSyncExternalStore: $bcc038267b15f6fa$var$ii,
    useId: $bcc038267b15f6fa$var$Fi,
    unstable_isNewReconciler: !1
};
function $bcc038267b15f6fa$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $bcc038267b15f6fa$var$Pa(d), d = d["return"];
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bcc038267b15f6fa$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bcc038267b15f6fa$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bcc038267b15f6fa$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $bcc038267b15f6fa$var$Oi(a, b, c) {
    c = $bcc038267b15f6fa$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bcc038267b15f6fa$var$Pi || ($bcc038267b15f6fa$var$Pi = !0, $bcc038267b15f6fa$var$Qi = d);
        $bcc038267b15f6fa$var$Mi(a, b);
    };
    return c;
}
function $bcc038267b15f6fa$var$Ri(a, b, c) {
    c = $bcc038267b15f6fa$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bcc038267b15f6fa$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bcc038267b15f6fa$var$Mi(a, b);
        "function" !== typeof d && (null === $bcc038267b15f6fa$var$Si ? $bcc038267b15f6fa$var$Si = new Set([
            this
        ]) : $bcc038267b15f6fa$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $bcc038267b15f6fa$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bcc038267b15f6fa$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bcc038267b15f6fa$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $bcc038267b15f6fa$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a["return"];
    }while (null !== a);
    return null;
}
function $bcc038267b15f6fa$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bcc038267b15f6fa$var$ch(-1, 1), b.tag = 2, $bcc038267b15f6fa$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bcc038267b15f6fa$var$Xi = $bcc038267b15f6fa$var$ua.ReactCurrentOwner, $bcc038267b15f6fa$var$Ug = !1;
function $bcc038267b15f6fa$var$Yi(a, b, c, d) {
    b.child = null === a ? $bcc038267b15f6fa$var$Ch(b, null, c, d) : $bcc038267b15f6fa$var$Bh(b, a.child, c, d);
}
function $bcc038267b15f6fa$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bcc038267b15f6fa$var$Tg(b, e);
    d = $bcc038267b15f6fa$var$Xh(a, b, c, d, f, e);
    c = $bcc038267b15f6fa$var$bi();
    if (null !== a && !$bcc038267b15f6fa$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bcc038267b15f6fa$var$$i(a, b, e);
    $bcc038267b15f6fa$var$I && c && $bcc038267b15f6fa$var$vg(b);
    b.flags |= 1;
    $bcc038267b15f6fa$var$Yi(a, b, d, e);
    return b.child;
}
function $bcc038267b15f6fa$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bcc038267b15f6fa$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bcc038267b15f6fa$var$cj(a, b, f, d, e);
        a = $bcc038267b15f6fa$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bcc038267b15f6fa$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bcc038267b15f6fa$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $bcc038267b15f6fa$var$wh(f, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function $bcc038267b15f6fa$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bcc038267b15f6fa$var$Ie(f, d) && a.ref === b.ref) {
            if ($bcc038267b15f6fa$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bcc038267b15f6fa$var$Ug = !0);
            else return b.lanes = a.lanes, $bcc038267b15f6fa$var$$i(a, b, e);
        }
    }
    return $bcc038267b15f6fa$var$dj(a, b, c, d, e);
}
function $bcc038267b15f6fa$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$fj, $bcc038267b15f6fa$var$gj), $bcc038267b15f6fa$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$fj, $bcc038267b15f6fa$var$gj), $bcc038267b15f6fa$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$fj, $bcc038267b15f6fa$var$gj);
            $bcc038267b15f6fa$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$fj, $bcc038267b15f6fa$var$gj), $bcc038267b15f6fa$var$gj |= d;
    $bcc038267b15f6fa$var$Yi(a, b, e, c);
    return b.child;
}
function $bcc038267b15f6fa$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bcc038267b15f6fa$var$dj(a, b, c, d, e) {
    var f = $bcc038267b15f6fa$var$Zf(c) ? $bcc038267b15f6fa$var$Xf : $bcc038267b15f6fa$var$H.current;
    f = $bcc038267b15f6fa$var$Yf(b, f);
    $bcc038267b15f6fa$var$Tg(b, e);
    c = $bcc038267b15f6fa$var$Xh(a, b, c, d, f, e);
    d = $bcc038267b15f6fa$var$bi();
    if (null !== a && !$bcc038267b15f6fa$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bcc038267b15f6fa$var$$i(a, b, e);
    $bcc038267b15f6fa$var$I && d && $bcc038267b15f6fa$var$vg(b);
    b.flags |= 1;
    $bcc038267b15f6fa$var$Yi(a, b, c, e);
    return b.child;
}
function $bcc038267b15f6fa$var$ij(a, b, c, d, e) {
    if ($bcc038267b15f6fa$var$Zf(c)) {
        var f = !0;
        $bcc038267b15f6fa$var$cg(b);
    } else f = !1;
    $bcc038267b15f6fa$var$Tg(b, e);
    if (null === b.stateNode) $bcc038267b15f6fa$var$jj(a, b), $bcc038267b15f6fa$var$ph(b, c, d), $bcc038267b15f6fa$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $bcc038267b15f6fa$var$Vg(l) : (l = $bcc038267b15f6fa$var$Zf(c) ? $bcc038267b15f6fa$var$Xf : $bcc038267b15f6fa$var$H.current, l = $bcc038267b15f6fa$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bcc038267b15f6fa$var$qh(b, g, d, l);
        $bcc038267b15f6fa$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $bcc038267b15f6fa$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bcc038267b15f6fa$var$Wf.current || $bcc038267b15f6fa$var$$g ? ("function" === typeof m && ($bcc038267b15f6fa$var$kh(b, c, m, d), k = b.memoizedState), (h = $bcc038267b15f6fa$var$$g || $bcc038267b15f6fa$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bcc038267b15f6fa$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bcc038267b15f6fa$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $bcc038267b15f6fa$var$Vg(k) : (k = $bcc038267b15f6fa$var$Zf(c) ? $bcc038267b15f6fa$var$Xf : $bcc038267b15f6fa$var$H.current, k = $bcc038267b15f6fa$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bcc038267b15f6fa$var$qh(b, g, d, k);
        $bcc038267b15f6fa$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $bcc038267b15f6fa$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bcc038267b15f6fa$var$Wf.current || $bcc038267b15f6fa$var$$g ? ("function" === typeof y && ($bcc038267b15f6fa$var$kh(b, c, y, d), n = b.memoizedState), (l = $bcc038267b15f6fa$var$$g || $bcc038267b15f6fa$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bcc038267b15f6fa$var$kj(a, b, c, d, f, e);
}
function $bcc038267b15f6fa$var$kj(a, b, c, d, e, f) {
    $bcc038267b15f6fa$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bcc038267b15f6fa$var$dg(b, c, !1), $bcc038267b15f6fa$var$$i(a, b, f);
    d = b.stateNode;
    $bcc038267b15f6fa$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bcc038267b15f6fa$var$Bh(b, a.child, null, f), b.child = $bcc038267b15f6fa$var$Bh(b, null, h, f)) : $bcc038267b15f6fa$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bcc038267b15f6fa$var$dg(b, c, !0);
    return b.child;
}
function $bcc038267b15f6fa$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bcc038267b15f6fa$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bcc038267b15f6fa$var$ag(a, b.context, !1);
    $bcc038267b15f6fa$var$Ih(a, b.containerInfo);
}
function $bcc038267b15f6fa$var$mj(a, b, c, d, e) {
    $bcc038267b15f6fa$var$Ig();
    $bcc038267b15f6fa$var$Jg(e);
    b.flags |= 256;
    $bcc038267b15f6fa$var$Yi(a, b, c, d);
    return b.child;
}
var $bcc038267b15f6fa$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bcc038267b15f6fa$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bcc038267b15f6fa$var$pj(a, b, c) {
    var d = b.pendingProps, e = $bcc038267b15f6fa$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, e & 1);
    if (null === a) {
        $bcc038267b15f6fa$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bcc038267b15f6fa$var$qj(g, d, 0, null), a = $bcc038267b15f6fa$var$Ah(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = $bcc038267b15f6fa$var$oj(c), b.memoizedState = $bcc038267b15f6fa$var$nj, a) : $bcc038267b15f6fa$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bcc038267b15f6fa$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bcc038267b15f6fa$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bcc038267b15f6fa$var$wh(h, f) : (f = $bcc038267b15f6fa$var$Ah(f, g, c, null), f.flags |= 2);
        f["return"] = b;
        d["return"] = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bcc038267b15f6fa$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bcc038267b15f6fa$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bcc038267b15f6fa$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d["return"] = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bcc038267b15f6fa$var$rj(a, b) {
    b = $bcc038267b15f6fa$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b["return"] = a;
    return a.child = b;
}
function $bcc038267b15f6fa$var$tj(a, b, c, d) {
    null !== d && $bcc038267b15f6fa$var$Jg(d);
    $bcc038267b15f6fa$var$Bh(b, a.child, null, c);
    a = $bcc038267b15f6fa$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bcc038267b15f6fa$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bcc038267b15f6fa$var$Li(Error($bcc038267b15f6fa$var$p(422))), $bcc038267b15f6fa$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bcc038267b15f6fa$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bcc038267b15f6fa$var$Ah(f, e, g, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bcc038267b15f6fa$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $bcc038267b15f6fa$var$oj(g);
        b.memoizedState = $bcc038267b15f6fa$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bcc038267b15f6fa$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bcc038267b15f6fa$var$p(419));
        d = $bcc038267b15f6fa$var$Li(f, d, void 0);
        return $bcc038267b15f6fa$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bcc038267b15f6fa$var$Ug || h) {
        d = $bcc038267b15f6fa$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bcc038267b15f6fa$var$Zg(a, e), $bcc038267b15f6fa$var$mh(d, a, e, -1));
        }
        $bcc038267b15f6fa$var$uj();
        d = $bcc038267b15f6fa$var$Li(Error($bcc038267b15f6fa$var$p(421)));
        return $bcc038267b15f6fa$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bcc038267b15f6fa$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$Lf(e.nextSibling);
    $bcc038267b15f6fa$var$xg = b;
    $bcc038267b15f6fa$var$I = !0;
    $bcc038267b15f6fa$var$zg = null;
    null !== a && ($bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$rg, $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$sg, $bcc038267b15f6fa$var$og[$bcc038267b15f6fa$var$pg++] = $bcc038267b15f6fa$var$qg, $bcc038267b15f6fa$var$rg = a.id, $bcc038267b15f6fa$var$sg = a.overflow, $bcc038267b15f6fa$var$qg = b);
    b = $bcc038267b15f6fa$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bcc038267b15f6fa$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bcc038267b15f6fa$var$Sg(a["return"], b, c);
}
function $bcc038267b15f6fa$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bcc038267b15f6fa$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bcc038267b15f6fa$var$Yi(a, b, d.children, c);
    d = $bcc038267b15f6fa$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bcc038267b15f6fa$var$wj(a, c, b);
            else if (19 === a.tag) $bcc038267b15f6fa$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bcc038267b15f6fa$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bcc038267b15f6fa$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bcc038267b15f6fa$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bcc038267b15f6fa$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $bcc038267b15f6fa$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bcc038267b15f6fa$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bcc038267b15f6fa$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bcc038267b15f6fa$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bcc038267b15f6fa$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bcc038267b15f6fa$var$wh(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bcc038267b15f6fa$var$wh(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
function $bcc038267b15f6fa$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $bcc038267b15f6fa$var$lj(b);
            $bcc038267b15f6fa$var$Ig();
            break;
        case 5:
            $bcc038267b15f6fa$var$Kh(b);
            break;
        case 1:
            $bcc038267b15f6fa$var$Zf(b.type) && $bcc038267b15f6fa$var$cg(b);
            break;
        case 4:
            $bcc038267b15f6fa$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, $bcc038267b15f6fa$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bcc038267b15f6fa$var$pj(a, b, c);
                $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, $bcc038267b15f6fa$var$M.current & 1);
                a = $bcc038267b15f6fa$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, $bcc038267b15f6fa$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bcc038267b15f6fa$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, $bcc038267b15f6fa$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bcc038267b15f6fa$var$ej(a, b, c);
    }
    return $bcc038267b15f6fa$var$$i(a, b, c);
}
var $bcc038267b15f6fa$var$Aj, $bcc038267b15f6fa$var$Bj, $bcc038267b15f6fa$var$Cj, $bcc038267b15f6fa$var$Dj;
$bcc038267b15f6fa$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
$bcc038267b15f6fa$var$Bj = function Bj() {};
$bcc038267b15f6fa$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bcc038267b15f6fa$var$Ya(a, e);
                d = $bcc038267b15f6fa$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bcc038267b15f6fa$var$A({}, e, {
                    value: void 0
                });
                d = $bcc038267b15f6fa$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bcc038267b15f6fa$var$gb(a, e);
                d = $bcc038267b15f6fa$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bcc038267b15f6fa$var$Bf);
        }
        $bcc038267b15f6fa$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bcc038267b15f6fa$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bcc038267b15f6fa$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bcc038267b15f6fa$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bcc038267b15f6fa$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bcc038267b15f6fa$var$Ej(a, b) {
    if (!$bcc038267b15f6fa$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bcc038267b15f6fa$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bcc038267b15f6fa$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $bcc038267b15f6fa$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bcc038267b15f6fa$var$S(b), null;
        case 1:
            return $bcc038267b15f6fa$var$Zf(b.type) && $bcc038267b15f6fa$var$$f(), $bcc038267b15f6fa$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bcc038267b15f6fa$var$Jh();
            $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf);
            $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$H);
            $bcc038267b15f6fa$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bcc038267b15f6fa$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bcc038267b15f6fa$var$zg && ($bcc038267b15f6fa$var$Gj($bcc038267b15f6fa$var$zg), $bcc038267b15f6fa$var$zg = null));
            $bcc038267b15f6fa$var$Bj(a, b);
            $bcc038267b15f6fa$var$S(b);
            return null;
        case 5:
            $bcc038267b15f6fa$var$Lh(b);
            var e = $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bcc038267b15f6fa$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bcc038267b15f6fa$var$p(166));
                    $bcc038267b15f6fa$var$S(b);
                    return null;
                }
                a = $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Eh.current);
                if ($bcc038267b15f6fa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bcc038267b15f6fa$var$Of] = b;
                    d[$bcc038267b15f6fa$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bcc038267b15f6fa$var$D("cancel", d);
                            $bcc038267b15f6fa$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bcc038267b15f6fa$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bcc038267b15f6fa$var$lf.length; e++)$bcc038267b15f6fa$var$D($bcc038267b15f6fa$var$lf[e], d);
                            break;
                        case "source":
                            $bcc038267b15f6fa$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bcc038267b15f6fa$var$D("error", d);
                            $bcc038267b15f6fa$var$D("load", d);
                            break;
                        case "details":
                            $bcc038267b15f6fa$var$D("toggle", d);
                            break;
                        case "input":
                            $bcc038267b15f6fa$var$Za(d, f);
                            $bcc038267b15f6fa$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bcc038267b15f6fa$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bcc038267b15f6fa$var$hb(d, f), $bcc038267b15f6fa$var$D("invalid", d);
                    }
                    $bcc038267b15f6fa$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bcc038267b15f6fa$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bcc038267b15f6fa$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bcc038267b15f6fa$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bcc038267b15f6fa$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bcc038267b15f6fa$var$Va(d);
                            $bcc038267b15f6fa$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bcc038267b15f6fa$var$Va(d);
                            $bcc038267b15f6fa$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bcc038267b15f6fa$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bcc038267b15f6fa$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bcc038267b15f6fa$var$Of] = b;
                    a[$bcc038267b15f6fa$var$Pf] = d;
                    $bcc038267b15f6fa$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bcc038267b15f6fa$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bcc038267b15f6fa$var$D("cancel", a);
                                $bcc038267b15f6fa$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bcc038267b15f6fa$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bcc038267b15f6fa$var$lf.length; e++)$bcc038267b15f6fa$var$D($bcc038267b15f6fa$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bcc038267b15f6fa$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bcc038267b15f6fa$var$D("error", a);
                                $bcc038267b15f6fa$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bcc038267b15f6fa$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bcc038267b15f6fa$var$Za(a, d);
                                e = $bcc038267b15f6fa$var$Ya(a, d);
                                $bcc038267b15f6fa$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bcc038267b15f6fa$var$A({}, d, {
                                    value: void 0
                                });
                                $bcc038267b15f6fa$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bcc038267b15f6fa$var$hb(a, d);
                                e = $bcc038267b15f6fa$var$gb(a, d);
                                $bcc038267b15f6fa$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bcc038267b15f6fa$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bcc038267b15f6fa$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bcc038267b15f6fa$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bcc038267b15f6fa$var$ob(a, k) : "number" === typeof k && $bcc038267b15f6fa$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bcc038267b15f6fa$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bcc038267b15f6fa$var$D("scroll", a) : null != k && $bcc038267b15f6fa$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bcc038267b15f6fa$var$Va(a);
                                $bcc038267b15f6fa$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bcc038267b15f6fa$var$Va(a);
                                $bcc038267b15f6fa$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bcc038267b15f6fa$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bcc038267b15f6fa$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bcc038267b15f6fa$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bcc038267b15f6fa$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bcc038267b15f6fa$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bcc038267b15f6fa$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bcc038267b15f6fa$var$p(166));
                c = $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Gh.current);
                $bcc038267b15f6fa$var$Hh($bcc038267b15f6fa$var$Eh.current);
                if ($bcc038267b15f6fa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bcc038267b15f6fa$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bcc038267b15f6fa$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bcc038267b15f6fa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bcc038267b15f6fa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bcc038267b15f6fa$var$Of] = b, b.stateNode = d;
            }
            $bcc038267b15f6fa$var$S(b);
            return null;
        case 13:
            $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bcc038267b15f6fa$var$I && null !== $bcc038267b15f6fa$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bcc038267b15f6fa$var$Hg(), $bcc038267b15f6fa$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bcc038267b15f6fa$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bcc038267b15f6fa$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bcc038267b15f6fa$var$p(317));
                        f[$bcc038267b15f6fa$var$Of] = b;
                    } else $bcc038267b15f6fa$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bcc038267b15f6fa$var$S(b);
                    f = !1;
                } else null !== $bcc038267b15f6fa$var$zg && ($bcc038267b15f6fa$var$Gj($bcc038267b15f6fa$var$zg), $bcc038267b15f6fa$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bcc038267b15f6fa$var$M.current & 1) ? 0 === $bcc038267b15f6fa$var$T && ($bcc038267b15f6fa$var$T = 3) : $bcc038267b15f6fa$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bcc038267b15f6fa$var$S(b);
            return null;
        case 4:
            return $bcc038267b15f6fa$var$Jh(), $bcc038267b15f6fa$var$Bj(a, b), null === a && $bcc038267b15f6fa$var$sf(b.stateNode.containerInfo), $bcc038267b15f6fa$var$S(b), null;
        case 10:
            return $bcc038267b15f6fa$var$Rg(b.type._context), $bcc038267b15f6fa$var$S(b), null;
        case 17:
            return $bcc038267b15f6fa$var$Zf(b.type) && $bcc038267b15f6fa$var$$f(), $bcc038267b15f6fa$var$S(b), null;
        case 19:
            $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M);
            f = b.memoizedState;
            if (null === f) return $bcc038267b15f6fa$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bcc038267b15f6fa$var$Ej(f, !1);
                else {
                    if (0 !== $bcc038267b15f6fa$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bcc038267b15f6fa$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bcc038267b15f6fa$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, $bcc038267b15f6fa$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bcc038267b15f6fa$var$B() > $bcc038267b15f6fa$var$Hj && (b.flags |= 128, d = !0, $bcc038267b15f6fa$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bcc038267b15f6fa$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bcc038267b15f6fa$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bcc038267b15f6fa$var$I) return $bcc038267b15f6fa$var$S(b), null;
                    } else 2 * $bcc038267b15f6fa$var$B() - f.renderingStartTime > $bcc038267b15f6fa$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $bcc038267b15f6fa$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bcc038267b15f6fa$var$B(), b.sibling = null, c = $bcc038267b15f6fa$var$M.current, $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$M, d ? c & 1 | 2 : c & 1), b;
            $bcc038267b15f6fa$var$S(b);
            return null;
        case 22:
        case 23:
            return $bcc038267b15f6fa$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bcc038267b15f6fa$var$gj & 1073741824) && ($bcc038267b15f6fa$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bcc038267b15f6fa$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bcc038267b15f6fa$var$p(156, b.tag));
}
function $bcc038267b15f6fa$var$Jj(a, b) {
    $bcc038267b15f6fa$var$wg(b);
    switch(b.tag){
        case 1:
            return $bcc038267b15f6fa$var$Zf(b.type) && $bcc038267b15f6fa$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bcc038267b15f6fa$var$Jh(), $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf), $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$H), $bcc038267b15f6fa$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bcc038267b15f6fa$var$Lh(b), null;
        case 13:
            $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bcc038267b15f6fa$var$p(340));
                $bcc038267b15f6fa$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M), null;
        case 4:
            return $bcc038267b15f6fa$var$Jh(), null;
        case 10:
            return $bcc038267b15f6fa$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $bcc038267b15f6fa$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bcc038267b15f6fa$var$Kj = !1, $bcc038267b15f6fa$var$U = !1, $bcc038267b15f6fa$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $bcc038267b15f6fa$var$V = null;
function $bcc038267b15f6fa$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bcc038267b15f6fa$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bcc038267b15f6fa$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bcc038267b15f6fa$var$W(a, b, d);
    }
}
var $bcc038267b15f6fa$var$Oj = !1;
function $bcc038267b15f6fa$var$Pj(a, b) {
    $bcc038267b15f6fa$var$Cf = $bcc038267b15f6fa$var$dd;
    a = $bcc038267b15f6fa$var$Me();
    if ($bcc038267b15f6fa$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bcc038267b15f6fa$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bcc038267b15f6fa$var$dd = !1;
    for($bcc038267b15f6fa$var$V = b; null !== $bcc038267b15f6fa$var$V;)if (b = $bcc038267b15f6fa$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, $bcc038267b15f6fa$var$V = a;
    else for(; null !== $bcc038267b15f6fa$var$V;){
        b = $bcc038267b15f6fa$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bcc038267b15f6fa$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bcc038267b15f6fa$var$p(163));
            }
        } catch (F) {
            $bcc038267b15f6fa$var$W(b, b["return"], F);
        }
        a = b.sibling;
        if (null !== a) {
            a["return"] = b["return"];
            $bcc038267b15f6fa$var$V = a;
            break;
        }
        $bcc038267b15f6fa$var$V = b["return"];
    }
    n = $bcc038267b15f6fa$var$Oj;
    $bcc038267b15f6fa$var$Oj = !1;
    return n;
}
function $bcc038267b15f6fa$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bcc038267b15f6fa$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bcc038267b15f6fa$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bcc038267b15f6fa$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bcc038267b15f6fa$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bcc038267b15f6fa$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bcc038267b15f6fa$var$Of], delete b[$bcc038267b15f6fa$var$Pf], delete b[$bcc038267b15f6fa$var$of], delete b[$bcc038267b15f6fa$var$Qf], delete b[$bcc038267b15f6fa$var$Rf]));
    a.stateNode = null;
    a["return"] = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bcc038267b15f6fa$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bcc038267b15f6fa$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a["return"] || $bcc038267b15f6fa$var$Uj(a["return"])) return null;
            a = a["return"];
        }
        a.sibling["return"] = a["return"];
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child["return"] = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bcc038267b15f6fa$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bcc038267b15f6fa$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bcc038267b15f6fa$var$Wj(a, b, c), a = a.sibling; null !== a;)$bcc038267b15f6fa$var$Wj(a, b, c), a = a.sibling;
}
function $bcc038267b15f6fa$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bcc038267b15f6fa$var$Xj(a, b, c), a = a.sibling; null !== a;)$bcc038267b15f6fa$var$Xj(a, b, c), a = a.sibling;
}
var $bcc038267b15f6fa$var$X = null, $bcc038267b15f6fa$var$Yj = !1;
function $bcc038267b15f6fa$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$bcc038267b15f6fa$var$ak(a, b, c), c = c.sibling;
}
function $bcc038267b15f6fa$var$ak(a, b, c) {
    if ($bcc038267b15f6fa$var$lc && "function" === typeof $bcc038267b15f6fa$var$lc.onCommitFiberUnmount) try {
        $bcc038267b15f6fa$var$lc.onCommitFiberUnmount($bcc038267b15f6fa$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bcc038267b15f6fa$var$U || $bcc038267b15f6fa$var$Mj(c, b);
        case 6:
            var d = $bcc038267b15f6fa$var$X, e = $bcc038267b15f6fa$var$Yj;
            $bcc038267b15f6fa$var$X = null;
            $bcc038267b15f6fa$var$Zj(a, b, c);
            $bcc038267b15f6fa$var$X = d;
            $bcc038267b15f6fa$var$Yj = e;
            null !== $bcc038267b15f6fa$var$X && ($bcc038267b15f6fa$var$Yj ? (a = $bcc038267b15f6fa$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bcc038267b15f6fa$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bcc038267b15f6fa$var$X && ($bcc038267b15f6fa$var$Yj ? (a = $bcc038267b15f6fa$var$X, c = c.stateNode, 8 === a.nodeType ? $bcc038267b15f6fa$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bcc038267b15f6fa$var$Kf(a, c), $bcc038267b15f6fa$var$bd(a)) : $bcc038267b15f6fa$var$Kf($bcc038267b15f6fa$var$X, c.stateNode));
            break;
        case 4:
            d = $bcc038267b15f6fa$var$X;
            e = $bcc038267b15f6fa$var$Yj;
            $bcc038267b15f6fa$var$X = c.stateNode.containerInfo;
            $bcc038267b15f6fa$var$Yj = !0;
            $bcc038267b15f6fa$var$Zj(a, b, c);
            $bcc038267b15f6fa$var$X = d;
            $bcc038267b15f6fa$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bcc038267b15f6fa$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bcc038267b15f6fa$var$Nj(c, b, g) : 0 !== (f & 4) && $bcc038267b15f6fa$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bcc038267b15f6fa$var$Zj(a, b, c);
            break;
        case 1:
            if (!$bcc038267b15f6fa$var$U && ($bcc038267b15f6fa$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bcc038267b15f6fa$var$W(c, b, h);
            }
            $bcc038267b15f6fa$var$Zj(a, b, c);
            break;
        case 21:
            $bcc038267b15f6fa$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bcc038267b15f6fa$var$U = (d = $bcc038267b15f6fa$var$U) || null !== c.memoizedState, $bcc038267b15f6fa$var$Zj(a, b, c), $bcc038267b15f6fa$var$U = d) : $bcc038267b15f6fa$var$Zj(a, b, c);
            break;
        default:
            $bcc038267b15f6fa$var$Zj(a, b, c);
    }
}
function $bcc038267b15f6fa$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bcc038267b15f6fa$var$Lj);
        b.forEach(function(b) {
            var d = $bcc038267b15f6fa$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bcc038267b15f6fa$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bcc038267b15f6fa$var$X = h.stateNode;
                        $bcc038267b15f6fa$var$Yj = !1;
                        break a;
                    case 3:
                        $bcc038267b15f6fa$var$X = h.stateNode.containerInfo;
                        $bcc038267b15f6fa$var$Yj = !0;
                        break a;
                    case 4:
                        $bcc038267b15f6fa$var$X = h.stateNode.containerInfo;
                        $bcc038267b15f6fa$var$Yj = !0;
                        break a;
                }
                h = h["return"];
            }
            if (null === $bcc038267b15f6fa$var$X) throw Error($bcc038267b15f6fa$var$p(160));
            $bcc038267b15f6fa$var$ak(f, g, e);
            $bcc038267b15f6fa$var$X = null;
            $bcc038267b15f6fa$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k["return"] = null);
            e["return"] = null;
        } catch (l) {
            $bcc038267b15f6fa$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bcc038267b15f6fa$var$ek(b, a), b = b.sibling;
}
function $bcc038267b15f6fa$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            if (d & 4) {
                try {
                    $bcc038267b15f6fa$var$Qj(3, a, a["return"]), $bcc038267b15f6fa$var$Rj(3, a);
                } catch (t) {
                    $bcc038267b15f6fa$var$W(a, a["return"], t);
                }
                try {
                    $bcc038267b15f6fa$var$Qj(5, a, a["return"]);
                } catch (t) {
                    $bcc038267b15f6fa$var$W(a, a["return"], t);
                }
            }
            break;
        case 1:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            d & 512 && null !== c && $bcc038267b15f6fa$var$Mj(c, c["return"]);
            break;
        case 5:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            d & 512 && null !== c && $bcc038267b15f6fa$var$Mj(c, c["return"]);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bcc038267b15f6fa$var$ob(e, "");
                } catch (t) {
                    $bcc038267b15f6fa$var$W(a, a["return"], t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bcc038267b15f6fa$var$ab(e, f);
                    $bcc038267b15f6fa$var$vb(h, g);
                    var l = $bcc038267b15f6fa$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bcc038267b15f6fa$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bcc038267b15f6fa$var$nb(e, q) : "children" === m ? $bcc038267b15f6fa$var$ob(e, q) : $bcc038267b15f6fa$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bcc038267b15f6fa$var$bb(e, f);
                            break;
                        case "textarea":
                            $bcc038267b15f6fa$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bcc038267b15f6fa$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bcc038267b15f6fa$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bcc038267b15f6fa$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bcc038267b15f6fa$var$Pf] = f;
                } catch (t) {
                    $bcc038267b15f6fa$var$W(a, a["return"], t);
                }
            }
            break;
        case 6:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bcc038267b15f6fa$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bcc038267b15f6fa$var$W(a, a["return"], t);
                }
            }
            break;
        case 3:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bcc038267b15f6fa$var$bd(b.containerInfo);
            } catch (t) {
                $bcc038267b15f6fa$var$W(a, a["return"], t);
            }
            break;
        case 4:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            break;
        case 13:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bcc038267b15f6fa$var$gk = $bcc038267b15f6fa$var$B()));
            d & 4 && $bcc038267b15f6fa$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bcc038267b15f6fa$var$U = (l = $bcc038267b15f6fa$var$U) || m, $bcc038267b15f6fa$var$dk(b, a), $bcc038267b15f6fa$var$U = l) : $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bcc038267b15f6fa$var$V = a, m = a.child; null !== m;){
                    for(q = $bcc038267b15f6fa$var$V = m; null !== $bcc038267b15f6fa$var$V;){
                        r = $bcc038267b15f6fa$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bcc038267b15f6fa$var$Qj(4, r, r["return"]);
                                break;
                            case 1:
                                $bcc038267b15f6fa$var$Mj(r, r["return"]);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r["return"];
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bcc038267b15f6fa$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bcc038267b15f6fa$var$Mj(r, r["return"]);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bcc038267b15f6fa$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y["return"] = r, $bcc038267b15f6fa$var$V = y) : $bcc038267b15f6fa$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bcc038267b15f6fa$var$rb("display", g));
                            } catch (t) {
                                $bcc038267b15f6fa$var$W(a, a["return"], t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bcc038267b15f6fa$var$W(a, a["return"], t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child["return"] = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q["return"] || q["return"] === a) break a;
                        m === q && (m = null);
                        q = q["return"];
                    }
                    m === q && (m = null);
                    q.sibling["return"] = q["return"];
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bcc038267b15f6fa$var$dk(b, a);
            $bcc038267b15f6fa$var$fk(a);
            d & 4 && $bcc038267b15f6fa$var$bk(a);
            break;
        case 21:
            break;
        default:
            $bcc038267b15f6fa$var$dk(b, a), $bcc038267b15f6fa$var$fk(a);
    }
}
function $bcc038267b15f6fa$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a["return"]; null !== c;){
                    if ($bcc038267b15f6fa$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c["return"];
                }
                throw Error($bcc038267b15f6fa$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bcc038267b15f6fa$var$ob(e, ""), d.flags &= -33);
                    var f = $bcc038267b15f6fa$var$Vj(a);
                    $bcc038267b15f6fa$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bcc038267b15f6fa$var$Vj(a);
                    $bcc038267b15f6fa$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($bcc038267b15f6fa$var$p(161));
            }
        } catch (k) {
            $bcc038267b15f6fa$var$W(a, a["return"], k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bcc038267b15f6fa$var$ik(a, b, c) {
    $bcc038267b15f6fa$var$V = a;
    $bcc038267b15f6fa$var$jk(a, b, c);
}
function $bcc038267b15f6fa$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bcc038267b15f6fa$var$V;){
        var e = $bcc038267b15f6fa$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bcc038267b15f6fa$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bcc038267b15f6fa$var$U;
                h = $bcc038267b15f6fa$var$Kj;
                var l = $bcc038267b15f6fa$var$U;
                $bcc038267b15f6fa$var$Kj = g;
                if (($bcc038267b15f6fa$var$U = k) && !l) for($bcc038267b15f6fa$var$V = e; null !== $bcc038267b15f6fa$var$V;)g = $bcc038267b15f6fa$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bcc038267b15f6fa$var$kk(e) : null !== k ? (k["return"] = g, $bcc038267b15f6fa$var$V = k) : $bcc038267b15f6fa$var$kk(e);
                for(; null !== f;)$bcc038267b15f6fa$var$V = f, $bcc038267b15f6fa$var$jk(f, b, c), f = f.sibling;
                $bcc038267b15f6fa$var$V = e;
                $bcc038267b15f6fa$var$Kj = h;
                $bcc038267b15f6fa$var$U = l;
            }
            $bcc038267b15f6fa$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, $bcc038267b15f6fa$var$V = f) : $bcc038267b15f6fa$var$lk(a, b, c);
    }
}
function $bcc038267b15f6fa$var$lk(a) {
    for(; null !== $bcc038267b15f6fa$var$V;){
        var b = $bcc038267b15f6fa$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bcc038267b15f6fa$var$U || $bcc038267b15f6fa$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bcc038267b15f6fa$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bcc038267b15f6fa$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bcc038267b15f6fa$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bcc038267b15f6fa$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bcc038267b15f6fa$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bcc038267b15f6fa$var$p(163));
                }
                $bcc038267b15f6fa$var$U || b.flags & 512 && $bcc038267b15f6fa$var$Sj(b);
            } catch (r) {
                $bcc038267b15f6fa$var$W(b, b["return"], r);
            }
        }
        if (b === a) {
            $bcc038267b15f6fa$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $bcc038267b15f6fa$var$V = c;
            break;
        }
        $bcc038267b15f6fa$var$V = b["return"];
    }
}
function $bcc038267b15f6fa$var$hk(a) {
    for(; null !== $bcc038267b15f6fa$var$V;){
        var b = $bcc038267b15f6fa$var$V;
        if (b === a) {
            $bcc038267b15f6fa$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $bcc038267b15f6fa$var$V = c;
            break;
        }
        $bcc038267b15f6fa$var$V = b["return"];
    }
}
function $bcc038267b15f6fa$var$kk(a) {
    for(; null !== $bcc038267b15f6fa$var$V;){
        var b = $bcc038267b15f6fa$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b["return"];
                    try {
                        $bcc038267b15f6fa$var$Rj(4, b);
                    } catch (k) {
                        $bcc038267b15f6fa$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b["return"];
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bcc038267b15f6fa$var$W(b, e, k);
                        }
                    }
                    var f = b["return"];
                    try {
                        $bcc038267b15f6fa$var$Sj(b);
                    } catch (k) {
                        $bcc038267b15f6fa$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b["return"];
                    try {
                        $bcc038267b15f6fa$var$Sj(b);
                    } catch (k) {
                        $bcc038267b15f6fa$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bcc038267b15f6fa$var$W(b, b["return"], k);
        }
        if (b === a) {
            $bcc038267b15f6fa$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h["return"] = b["return"];
            $bcc038267b15f6fa$var$V = h;
            break;
        }
        $bcc038267b15f6fa$var$V = b["return"];
    }
}
var $bcc038267b15f6fa$var$mk = Math.ceil, $bcc038267b15f6fa$var$nk = $bcc038267b15f6fa$var$ua.ReactCurrentDispatcher, $bcc038267b15f6fa$var$ok = $bcc038267b15f6fa$var$ua.ReactCurrentOwner, $bcc038267b15f6fa$var$pk = $bcc038267b15f6fa$var$ua.ReactCurrentBatchConfig, $bcc038267b15f6fa$var$K = 0, $bcc038267b15f6fa$var$R = null, $bcc038267b15f6fa$var$Y = null, $bcc038267b15f6fa$var$Z = 0, $bcc038267b15f6fa$var$gj = 0, $bcc038267b15f6fa$var$fj = $bcc038267b15f6fa$var$Uf(0), $bcc038267b15f6fa$var$T = 0, $bcc038267b15f6fa$var$qk = null, $bcc038267b15f6fa$var$hh = 0, $bcc038267b15f6fa$var$rk = 0, $bcc038267b15f6fa$var$sk = 0, $bcc038267b15f6fa$var$tk = null, $bcc038267b15f6fa$var$uk = null, $bcc038267b15f6fa$var$gk = 0, $bcc038267b15f6fa$var$Hj = Infinity, $bcc038267b15f6fa$var$vk = null, $bcc038267b15f6fa$var$Pi = !1, $bcc038267b15f6fa$var$Qi = null, $bcc038267b15f6fa$var$Si = null, $bcc038267b15f6fa$var$wk = !1, $bcc038267b15f6fa$var$xk = null, $bcc038267b15f6fa$var$yk = 0, $bcc038267b15f6fa$var$zk = 0, $bcc038267b15f6fa$var$Ak = null, $bcc038267b15f6fa$var$Bk = -1, $bcc038267b15f6fa$var$Ck = 0;
function $bcc038267b15f6fa$var$L() {
    return 0 !== ($bcc038267b15f6fa$var$K & 6) ? $bcc038267b15f6fa$var$B() : -1 !== $bcc038267b15f6fa$var$Bk ? $bcc038267b15f6fa$var$Bk : $bcc038267b15f6fa$var$Bk = $bcc038267b15f6fa$var$B();
}
function $bcc038267b15f6fa$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bcc038267b15f6fa$var$K & 2) && 0 !== $bcc038267b15f6fa$var$Z) return $bcc038267b15f6fa$var$Z & -$bcc038267b15f6fa$var$Z;
    if (null !== $bcc038267b15f6fa$var$Kg.transition) return 0 === $bcc038267b15f6fa$var$Ck && ($bcc038267b15f6fa$var$Ck = $bcc038267b15f6fa$var$yc()), $bcc038267b15f6fa$var$Ck;
    a = $bcc038267b15f6fa$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bcc038267b15f6fa$var$jd(a.type);
    return a;
}
function $bcc038267b15f6fa$var$mh(a, b, c, d) {
    if (50 < $bcc038267b15f6fa$var$zk) throw $bcc038267b15f6fa$var$zk = 0, $bcc038267b15f6fa$var$Ak = null, Error($bcc038267b15f6fa$var$p(185));
    $bcc038267b15f6fa$var$Ac(a, c, d);
    if (0 === ($bcc038267b15f6fa$var$K & 2) || a !== $bcc038267b15f6fa$var$R) a === $bcc038267b15f6fa$var$R && (0 === ($bcc038267b15f6fa$var$K & 2) && ($bcc038267b15f6fa$var$rk |= c), 4 === $bcc038267b15f6fa$var$T && $bcc038267b15f6fa$var$Dk(a, $bcc038267b15f6fa$var$Z)), $bcc038267b15f6fa$var$Ek(a, d), 1 === c && 0 === $bcc038267b15f6fa$var$K && 0 === (b.mode & 1) && ($bcc038267b15f6fa$var$Hj = $bcc038267b15f6fa$var$B() + 500, $bcc038267b15f6fa$var$fg && $bcc038267b15f6fa$var$jg());
}
function $bcc038267b15f6fa$var$Ek(a, b) {
    var c = a.callbackNode;
    $bcc038267b15f6fa$var$wc(a, b);
    var d = $bcc038267b15f6fa$var$uc(a, a === $bcc038267b15f6fa$var$R ? $bcc038267b15f6fa$var$Z : 0);
    if (0 === d) null !== c && $bcc038267b15f6fa$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bcc038267b15f6fa$var$bc(c);
        if (1 === b) 0 === a.tag ? $bcc038267b15f6fa$var$ig($bcc038267b15f6fa$var$Fk.bind(null, a)) : $bcc038267b15f6fa$var$hg($bcc038267b15f6fa$var$Fk.bind(null, a)), $bcc038267b15f6fa$var$Jf(function() {
            0 === ($bcc038267b15f6fa$var$K & 6) && $bcc038267b15f6fa$var$jg();
        }), c = null;
        else {
            switch($bcc038267b15f6fa$var$Dc(d)){
                case 1:
                    c = $bcc038267b15f6fa$var$fc;
                    break;
                case 4:
                    c = $bcc038267b15f6fa$var$gc;
                    break;
                case 16:
                    c = $bcc038267b15f6fa$var$hc;
                    break;
                case 536870912:
                    c = $bcc038267b15f6fa$var$jc;
                    break;
                default:
                    c = $bcc038267b15f6fa$var$hc;
            }
            c = $bcc038267b15f6fa$var$Gk(c, $bcc038267b15f6fa$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bcc038267b15f6fa$var$Hk(a, b) {
    $bcc038267b15f6fa$var$Bk = -1;
    $bcc038267b15f6fa$var$Ck = 0;
    if (0 !== ($bcc038267b15f6fa$var$K & 6)) throw Error($bcc038267b15f6fa$var$p(327));
    var c = a.callbackNode;
    if ($bcc038267b15f6fa$var$Ik() && a.callbackNode !== c) return null;
    var d = $bcc038267b15f6fa$var$uc(a, a === $bcc038267b15f6fa$var$R ? $bcc038267b15f6fa$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bcc038267b15f6fa$var$Jk(a, d);
    else {
        b = d;
        var e = $bcc038267b15f6fa$var$K;
        $bcc038267b15f6fa$var$K |= 2;
        var f = $bcc038267b15f6fa$var$Kk();
        if ($bcc038267b15f6fa$var$R !== a || $bcc038267b15f6fa$var$Z !== b) $bcc038267b15f6fa$var$vk = null, $bcc038267b15f6fa$var$Hj = $bcc038267b15f6fa$var$B() + 500, $bcc038267b15f6fa$var$Lk(a, b);
        for(;;)try {
            $bcc038267b15f6fa$var$Mk();
            break;
        } catch (h) {
            $bcc038267b15f6fa$var$Nk(a, h);
        }
        $bcc038267b15f6fa$var$Qg();
        $bcc038267b15f6fa$var$nk.current = f;
        $bcc038267b15f6fa$var$K = e;
        null !== $bcc038267b15f6fa$var$Y ? b = 0 : ($bcc038267b15f6fa$var$R = null, $bcc038267b15f6fa$var$Z = 0, b = $bcc038267b15f6fa$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bcc038267b15f6fa$var$xc(a), 0 !== e && (d = e, b = $bcc038267b15f6fa$var$Ok(a, e)));
        if (1 === b) throw c = $bcc038267b15f6fa$var$qk, $bcc038267b15f6fa$var$Lk(a, 0), $bcc038267b15f6fa$var$Dk(a, d), $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B()), c;
        if (6 === b) $bcc038267b15f6fa$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bcc038267b15f6fa$var$Pk(e) && (b = $bcc038267b15f6fa$var$Jk(a, d), 2 === b && (f = $bcc038267b15f6fa$var$xc(a), 0 !== f && (d = f, b = $bcc038267b15f6fa$var$Ok(a, f))), 1 === b)) throw c = $bcc038267b15f6fa$var$qk, $bcc038267b15f6fa$var$Lk(a, 0), $bcc038267b15f6fa$var$Dk(a, d), $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bcc038267b15f6fa$var$p(345));
                case 2:
                    $bcc038267b15f6fa$var$Qk(a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk);
                    break;
                case 3:
                    $bcc038267b15f6fa$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $bcc038267b15f6fa$var$gk + 500 - $bcc038267b15f6fa$var$B(), 10 < b)) {
                        if (0 !== $bcc038267b15f6fa$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bcc038267b15f6fa$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bcc038267b15f6fa$var$Ff($bcc038267b15f6fa$var$Qk.bind(null, a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk), b);
                        break;
                    }
                    $bcc038267b15f6fa$var$Qk(a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk);
                    break;
                case 4:
                    $bcc038267b15f6fa$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bcc038267b15f6fa$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bcc038267b15f6fa$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bcc038267b15f6fa$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bcc038267b15f6fa$var$Ff($bcc038267b15f6fa$var$Qk.bind(null, a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk), d);
                        break;
                    }
                    $bcc038267b15f6fa$var$Qk(a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk);
                    break;
                case 5:
                    $bcc038267b15f6fa$var$Qk(a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk);
                    break;
                default:
                    throw Error($bcc038267b15f6fa$var$p(329));
            }
        }
    }
    $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B());
    return a.callbackNode === c ? $bcc038267b15f6fa$var$Hk.bind(null, a) : null;
}
function $bcc038267b15f6fa$var$Ok(a, b) {
    var c = $bcc038267b15f6fa$var$tk;
    a.current.memoizedState.isDehydrated && ($bcc038267b15f6fa$var$Lk(a, b).flags |= 256);
    a = $bcc038267b15f6fa$var$Jk(a, b);
    2 !== a && (b = $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$uk = c, null !== b && $bcc038267b15f6fa$var$Gj(b));
    return a;
}
function $bcc038267b15f6fa$var$Gj(a) {
    null === $bcc038267b15f6fa$var$uk ? $bcc038267b15f6fa$var$uk = a : $bcc038267b15f6fa$var$uk.push.apply($bcc038267b15f6fa$var$uk, a);
}
function $bcc038267b15f6fa$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bcc038267b15f6fa$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b["return"] || b["return"] === a) return !0;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return !0;
}
function $bcc038267b15f6fa$var$Dk(a, b) {
    b &= ~$bcc038267b15f6fa$var$sk;
    b &= ~$bcc038267b15f6fa$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bcc038267b15f6fa$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bcc038267b15f6fa$var$Fk(a) {
    if (0 !== ($bcc038267b15f6fa$var$K & 6)) throw Error($bcc038267b15f6fa$var$p(327));
    $bcc038267b15f6fa$var$Ik();
    var b = $bcc038267b15f6fa$var$uc(a, 0);
    if (0 === (b & 1)) return $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B()), null;
    var c = $bcc038267b15f6fa$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bcc038267b15f6fa$var$xc(a);
        0 !== d && (b = d, c = $bcc038267b15f6fa$var$Ok(a, d));
    }
    if (1 === c) throw c = $bcc038267b15f6fa$var$qk, $bcc038267b15f6fa$var$Lk(a, 0), $bcc038267b15f6fa$var$Dk(a, b), $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B()), c;
    if (6 === c) throw Error($bcc038267b15f6fa$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bcc038267b15f6fa$var$Qk(a, $bcc038267b15f6fa$var$uk, $bcc038267b15f6fa$var$vk);
    $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B());
    return null;
}
function $bcc038267b15f6fa$var$Rk(a, b) {
    var c = $bcc038267b15f6fa$var$K;
    $bcc038267b15f6fa$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bcc038267b15f6fa$var$K = c, 0 === $bcc038267b15f6fa$var$K && ($bcc038267b15f6fa$var$Hj = $bcc038267b15f6fa$var$B() + 500, $bcc038267b15f6fa$var$fg && $bcc038267b15f6fa$var$jg());
    }
}
function $bcc038267b15f6fa$var$Sk(a) {
    null !== $bcc038267b15f6fa$var$xk && 0 === $bcc038267b15f6fa$var$xk.tag && 0 === ($bcc038267b15f6fa$var$K & 6) && $bcc038267b15f6fa$var$Ik();
    var b = $bcc038267b15f6fa$var$K;
    $bcc038267b15f6fa$var$K |= 1;
    var c = $bcc038267b15f6fa$var$pk.transition, d = $bcc038267b15f6fa$var$C;
    try {
        if ($bcc038267b15f6fa$var$pk.transition = null, $bcc038267b15f6fa$var$C = 1, a) return a();
    } finally{
        $bcc038267b15f6fa$var$C = d, $bcc038267b15f6fa$var$pk.transition = c, $bcc038267b15f6fa$var$K = b, 0 === ($bcc038267b15f6fa$var$K & 6) && $bcc038267b15f6fa$var$jg();
    }
}
function $bcc038267b15f6fa$var$Ij() {
    $bcc038267b15f6fa$var$gj = $bcc038267b15f6fa$var$fj.current;
    $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$fj);
}
function $bcc038267b15f6fa$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bcc038267b15f6fa$var$Gf(c));
    if (null !== $bcc038267b15f6fa$var$Y) for(c = $bcc038267b15f6fa$var$Y["return"]; null !== c;){
        var d = c;
        $bcc038267b15f6fa$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bcc038267b15f6fa$var$$f();
                break;
            case 3:
                $bcc038267b15f6fa$var$Jh();
                $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$Wf);
                $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$H);
                $bcc038267b15f6fa$var$Oh();
                break;
            case 5:
                $bcc038267b15f6fa$var$Lh(d);
                break;
            case 4:
                $bcc038267b15f6fa$var$Jh();
                break;
            case 13:
                $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M);
                break;
            case 19:
                $bcc038267b15f6fa$var$E($bcc038267b15f6fa$var$M);
                break;
            case 10:
                $bcc038267b15f6fa$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $bcc038267b15f6fa$var$Ij();
        }
        c = c["return"];
    }
    $bcc038267b15f6fa$var$R = a;
    $bcc038267b15f6fa$var$Y = a = $bcc038267b15f6fa$var$wh(a.current, null);
    $bcc038267b15f6fa$var$Z = $bcc038267b15f6fa$var$gj = b;
    $bcc038267b15f6fa$var$T = 0;
    $bcc038267b15f6fa$var$qk = null;
    $bcc038267b15f6fa$var$sk = $bcc038267b15f6fa$var$rk = $bcc038267b15f6fa$var$hh = 0;
    $bcc038267b15f6fa$var$uk = $bcc038267b15f6fa$var$tk = null;
    if (null !== $bcc038267b15f6fa$var$Wg) {
        for(b = 0; b < $bcc038267b15f6fa$var$Wg.length; b++)if (c = $bcc038267b15f6fa$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bcc038267b15f6fa$var$Wg = null;
    }
    return a;
}
function $bcc038267b15f6fa$var$Nk(a, b) {
    do {
        var c = $bcc038267b15f6fa$var$Y;
        try {
            $bcc038267b15f6fa$var$Qg();
            $bcc038267b15f6fa$var$Ph.current = $bcc038267b15f6fa$var$ai;
            if ($bcc038267b15f6fa$var$Sh) {
                for(var d = $bcc038267b15f6fa$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bcc038267b15f6fa$var$Sh = !1;
            }
            $bcc038267b15f6fa$var$Rh = 0;
            $bcc038267b15f6fa$var$P = $bcc038267b15f6fa$var$O = $bcc038267b15f6fa$var$N = null;
            $bcc038267b15f6fa$var$Th = !1;
            $bcc038267b15f6fa$var$Uh = 0;
            $bcc038267b15f6fa$var$ok.current = null;
            if (null === c || null === c["return"]) {
                $bcc038267b15f6fa$var$T = 1;
                $bcc038267b15f6fa$var$qk = b;
                $bcc038267b15f6fa$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c["return"], h = c, k = b;
                b = $bcc038267b15f6fa$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bcc038267b15f6fa$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bcc038267b15f6fa$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $bcc038267b15f6fa$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bcc038267b15f6fa$var$Ti(f, l, b);
                            $bcc038267b15f6fa$var$uj();
                            break a;
                        }
                        k = Error($bcc038267b15f6fa$var$p(426));
                    }
                } else if ($bcc038267b15f6fa$var$I && h.mode & 1) {
                    var J = $bcc038267b15f6fa$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bcc038267b15f6fa$var$Wi(J, g, h, f, b);
                        $bcc038267b15f6fa$var$Jg($bcc038267b15f6fa$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $bcc038267b15f6fa$var$Ki(k, h);
                4 !== $bcc038267b15f6fa$var$T && ($bcc038267b15f6fa$var$T = 2);
                null === $bcc038267b15f6fa$var$tk ? $bcc038267b15f6fa$var$tk = [
                    f
                ] : $bcc038267b15f6fa$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bcc038267b15f6fa$var$Oi(f, k, b);
                            $bcc038267b15f6fa$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bcc038267b15f6fa$var$Si || !$bcc038267b15f6fa$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bcc038267b15f6fa$var$Ri(f, h, b);
                                $bcc038267b15f6fa$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f["return"];
                }while (null !== f);
            }
            $bcc038267b15f6fa$var$Tk(c);
        } catch (na) {
            b = na;
            $bcc038267b15f6fa$var$Y === c && null !== c && ($bcc038267b15f6fa$var$Y = c = c["return"]);
            continue;
        }
        break;
    }while (1);
}
function $bcc038267b15f6fa$var$Kk() {
    var a = $bcc038267b15f6fa$var$nk.current;
    $bcc038267b15f6fa$var$nk.current = $bcc038267b15f6fa$var$ai;
    return null === a ? $bcc038267b15f6fa$var$ai : a;
}
function $bcc038267b15f6fa$var$uj() {
    if (0 === $bcc038267b15f6fa$var$T || 3 === $bcc038267b15f6fa$var$T || 2 === $bcc038267b15f6fa$var$T) $bcc038267b15f6fa$var$T = 4;
    null === $bcc038267b15f6fa$var$R || 0 === ($bcc038267b15f6fa$var$hh & 268435455) && 0 === ($bcc038267b15f6fa$var$rk & 268435455) || $bcc038267b15f6fa$var$Dk($bcc038267b15f6fa$var$R, $bcc038267b15f6fa$var$Z);
}
function $bcc038267b15f6fa$var$Jk(a, b) {
    var c = $bcc038267b15f6fa$var$K;
    $bcc038267b15f6fa$var$K |= 2;
    var d = $bcc038267b15f6fa$var$Kk();
    if ($bcc038267b15f6fa$var$R !== a || $bcc038267b15f6fa$var$Z !== b) $bcc038267b15f6fa$var$vk = null, $bcc038267b15f6fa$var$Lk(a, b);
    for(;;)try {
        $bcc038267b15f6fa$var$Uk();
        break;
    } catch (e) {
        $bcc038267b15f6fa$var$Nk(a, e);
    }
    $bcc038267b15f6fa$var$Qg();
    $bcc038267b15f6fa$var$K = c;
    $bcc038267b15f6fa$var$nk.current = d;
    if (null !== $bcc038267b15f6fa$var$Y) throw Error($bcc038267b15f6fa$var$p(261));
    $bcc038267b15f6fa$var$R = null;
    $bcc038267b15f6fa$var$Z = 0;
    return $bcc038267b15f6fa$var$T;
}
function $bcc038267b15f6fa$var$Uk() {
    for(; null !== $bcc038267b15f6fa$var$Y;)$bcc038267b15f6fa$var$Vk($bcc038267b15f6fa$var$Y);
}
function $bcc038267b15f6fa$var$Mk() {
    for(; null !== $bcc038267b15f6fa$var$Y && !$bcc038267b15f6fa$var$cc();)$bcc038267b15f6fa$var$Vk($bcc038267b15f6fa$var$Y);
}
function $bcc038267b15f6fa$var$Vk(a) {
    var b = $bcc038267b15f6fa$var$Wk(a.alternate, a, $bcc038267b15f6fa$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bcc038267b15f6fa$var$Tk(a) : $bcc038267b15f6fa$var$Y = b;
    $bcc038267b15f6fa$var$ok.current = null;
}
function $bcc038267b15f6fa$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b["return"];
        if (0 === (b.flags & 32768)) {
            if (c = $bcc038267b15f6fa$var$Fj(c, b, $bcc038267b15f6fa$var$gj), null !== c) {
                $bcc038267b15f6fa$var$Y = c;
                return;
            }
        } else {
            c = $bcc038267b15f6fa$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bcc038267b15f6fa$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bcc038267b15f6fa$var$T = 6;
                $bcc038267b15f6fa$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bcc038267b15f6fa$var$Y = b;
            return;
        }
        $bcc038267b15f6fa$var$Y = b = a;
    }while (null !== b);
    0 === $bcc038267b15f6fa$var$T && ($bcc038267b15f6fa$var$T = 5);
}
function $bcc038267b15f6fa$var$Qk(a, b, c) {
    var d = $bcc038267b15f6fa$var$C, e = $bcc038267b15f6fa$var$pk.transition;
    try {
        $bcc038267b15f6fa$var$pk.transition = null, $bcc038267b15f6fa$var$C = 1, $bcc038267b15f6fa$var$Xk(a, b, c, d);
    } finally{
        $bcc038267b15f6fa$var$pk.transition = e, $bcc038267b15f6fa$var$C = d;
    }
    return null;
}
function $bcc038267b15f6fa$var$Xk(a, b, c, d) {
    do $bcc038267b15f6fa$var$Ik();
    while (null !== $bcc038267b15f6fa$var$xk);
    if (0 !== ($bcc038267b15f6fa$var$K & 6)) throw Error($bcc038267b15f6fa$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bcc038267b15f6fa$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bcc038267b15f6fa$var$Bc(a, f);
    a === $bcc038267b15f6fa$var$R && ($bcc038267b15f6fa$var$Y = $bcc038267b15f6fa$var$R = null, $bcc038267b15f6fa$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bcc038267b15f6fa$var$wk || ($bcc038267b15f6fa$var$wk = !0, $bcc038267b15f6fa$var$Gk($bcc038267b15f6fa$var$hc, function() {
        $bcc038267b15f6fa$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bcc038267b15f6fa$var$pk.transition;
        $bcc038267b15f6fa$var$pk.transition = null;
        var g = $bcc038267b15f6fa$var$C;
        $bcc038267b15f6fa$var$C = 1;
        var h = $bcc038267b15f6fa$var$K;
        $bcc038267b15f6fa$var$K |= 4;
        $bcc038267b15f6fa$var$ok.current = null;
        $bcc038267b15f6fa$var$Pj(a, c);
        $bcc038267b15f6fa$var$ek(c, a);
        $bcc038267b15f6fa$var$Oe($bcc038267b15f6fa$var$Df);
        $bcc038267b15f6fa$var$dd = !!$bcc038267b15f6fa$var$Cf;
        $bcc038267b15f6fa$var$Df = $bcc038267b15f6fa$var$Cf = null;
        a.current = c;
        $bcc038267b15f6fa$var$ik(c, a, e);
        $bcc038267b15f6fa$var$dc();
        $bcc038267b15f6fa$var$K = h;
        $bcc038267b15f6fa$var$C = g;
        $bcc038267b15f6fa$var$pk.transition = f;
    } else a.current = c;
    $bcc038267b15f6fa$var$wk && ($bcc038267b15f6fa$var$wk = !1, $bcc038267b15f6fa$var$xk = a, $bcc038267b15f6fa$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($bcc038267b15f6fa$var$Si = null);
    $bcc038267b15f6fa$var$mc(c.stateNode, d);
    $bcc038267b15f6fa$var$Ek(a, $bcc038267b15f6fa$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bcc038267b15f6fa$var$Pi) throw $bcc038267b15f6fa$var$Pi = !1, a = $bcc038267b15f6fa$var$Qi, $bcc038267b15f6fa$var$Qi = null, a;
    0 !== ($bcc038267b15f6fa$var$yk & 1) && 0 !== a.tag && $bcc038267b15f6fa$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bcc038267b15f6fa$var$Ak ? $bcc038267b15f6fa$var$zk++ : ($bcc038267b15f6fa$var$zk = 0, $bcc038267b15f6fa$var$Ak = a) : $bcc038267b15f6fa$var$zk = 0;
    $bcc038267b15f6fa$var$jg();
    return null;
}
function $bcc038267b15f6fa$var$Ik() {
    if (null !== $bcc038267b15f6fa$var$xk) {
        var a = $bcc038267b15f6fa$var$Dc($bcc038267b15f6fa$var$yk), b = $bcc038267b15f6fa$var$pk.transition, c = $bcc038267b15f6fa$var$C;
        try {
            $bcc038267b15f6fa$var$pk.transition = null;
            $bcc038267b15f6fa$var$C = 16 > a ? 16 : a;
            if (null === $bcc038267b15f6fa$var$xk) var d = !1;
            else {
                a = $bcc038267b15f6fa$var$xk;
                $bcc038267b15f6fa$var$xk = null;
                $bcc038267b15f6fa$var$yk = 0;
                if (0 !== ($bcc038267b15f6fa$var$K & 6)) throw Error($bcc038267b15f6fa$var$p(331));
                var e = $bcc038267b15f6fa$var$K;
                $bcc038267b15f6fa$var$K |= 4;
                for($bcc038267b15f6fa$var$V = a.current; null !== $bcc038267b15f6fa$var$V;){
                    var f = $bcc038267b15f6fa$var$V, g = f.child;
                    if (0 !== ($bcc038267b15f6fa$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bcc038267b15f6fa$var$V = l; null !== $bcc038267b15f6fa$var$V;){
                                    var m = $bcc038267b15f6fa$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bcc038267b15f6fa$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q["return"] = m, $bcc038267b15f6fa$var$V = q;
                                    else for(; null !== $bcc038267b15f6fa$var$V;){
                                        m = $bcc038267b15f6fa$var$V;
                                        var r = m.sibling, y = m["return"];
                                        $bcc038267b15f6fa$var$Tj(m);
                                        if (m === l) {
                                            $bcc038267b15f6fa$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r["return"] = y;
                                            $bcc038267b15f6fa$var$V = r;
                                            break;
                                        }
                                        $bcc038267b15f6fa$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bcc038267b15f6fa$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, $bcc038267b15f6fa$var$V = g;
                    else b: for(; null !== $bcc038267b15f6fa$var$V;){
                        f = $bcc038267b15f6fa$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bcc038267b15f6fa$var$Qj(9, f, f["return"]);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x["return"] = f["return"];
                            $bcc038267b15f6fa$var$V = x;
                            break b;
                        }
                        $bcc038267b15f6fa$var$V = f["return"];
                    }
                }
                var w = a.current;
                for($bcc038267b15f6fa$var$V = w; null !== $bcc038267b15f6fa$var$V;){
                    g = $bcc038267b15f6fa$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u["return"] = g, $bcc038267b15f6fa$var$V = u;
                    else b: for(g = w; null !== $bcc038267b15f6fa$var$V;){
                        h = $bcc038267b15f6fa$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bcc038267b15f6fa$var$Rj(9, h);
                            }
                        } catch (na) {
                            $bcc038267b15f6fa$var$W(h, h["return"], na);
                        }
                        if (h === g) {
                            $bcc038267b15f6fa$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F["return"] = h["return"];
                            $bcc038267b15f6fa$var$V = F;
                            break b;
                        }
                        $bcc038267b15f6fa$var$V = h["return"];
                    }
                }
                $bcc038267b15f6fa$var$K = e;
                $bcc038267b15f6fa$var$jg();
                if ($bcc038267b15f6fa$var$lc && "function" === typeof $bcc038267b15f6fa$var$lc.onPostCommitFiberRoot) try {
                    $bcc038267b15f6fa$var$lc.onPostCommitFiberRoot($bcc038267b15f6fa$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bcc038267b15f6fa$var$C = c, $bcc038267b15f6fa$var$pk.transition = b;
        }
    }
    return !1;
}
function $bcc038267b15f6fa$var$Yk(a, b, c) {
    b = $bcc038267b15f6fa$var$Ki(c, b);
    b = $bcc038267b15f6fa$var$Oi(a, b, 1);
    a = $bcc038267b15f6fa$var$dh(a, b, 1);
    b = $bcc038267b15f6fa$var$L();
    null !== a && ($bcc038267b15f6fa$var$Ac(a, 1, b), $bcc038267b15f6fa$var$Ek(a, b));
}
function $bcc038267b15f6fa$var$W(a, b, c) {
    if (3 === a.tag) $bcc038267b15f6fa$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bcc038267b15f6fa$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bcc038267b15f6fa$var$Si || !$bcc038267b15f6fa$var$Si.has(d))) {
                a = $bcc038267b15f6fa$var$Ki(c, a);
                a = $bcc038267b15f6fa$var$Ri(b, a, 1);
                b = $bcc038267b15f6fa$var$dh(b, a, 1);
                a = $bcc038267b15f6fa$var$L();
                null !== b && ($bcc038267b15f6fa$var$Ac(b, 1, a), $bcc038267b15f6fa$var$Ek(b, a));
                break;
            }
        }
        b = b["return"];
    }
}
function $bcc038267b15f6fa$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    b = $bcc038267b15f6fa$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $bcc038267b15f6fa$var$R === a && ($bcc038267b15f6fa$var$Z & c) === c && (4 === $bcc038267b15f6fa$var$T || 3 === $bcc038267b15f6fa$var$T && ($bcc038267b15f6fa$var$Z & 130023424) === $bcc038267b15f6fa$var$Z && 500 > $bcc038267b15f6fa$var$B() - $bcc038267b15f6fa$var$gk ? $bcc038267b15f6fa$var$Lk(a, 0) : $bcc038267b15f6fa$var$sk |= c);
    $bcc038267b15f6fa$var$Ek(a, b);
}
function $bcc038267b15f6fa$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bcc038267b15f6fa$var$sc, $bcc038267b15f6fa$var$sc <<= 1, 0 === ($bcc038267b15f6fa$var$sc & 130023424) && ($bcc038267b15f6fa$var$sc = 4194304)));
    var c = $bcc038267b15f6fa$var$L();
    a = $bcc038267b15f6fa$var$Zg(a, b);
    null !== a && ($bcc038267b15f6fa$var$Ac(a, b, c), $bcc038267b15f6fa$var$Ek(a, c));
}
function $bcc038267b15f6fa$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bcc038267b15f6fa$var$Zk(a, c);
}
function $bcc038267b15f6fa$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bcc038267b15f6fa$var$p(314));
    }
    null !== d && d["delete"](b);
    $bcc038267b15f6fa$var$Zk(a, c);
}
var $bcc038267b15f6fa$var$Wk;
$bcc038267b15f6fa$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bcc038267b15f6fa$var$Wf.current) $bcc038267b15f6fa$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bcc038267b15f6fa$var$Ug = !1, $bcc038267b15f6fa$var$zj(a, b, c);
            $bcc038267b15f6fa$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bcc038267b15f6fa$var$Ug = !1, $bcc038267b15f6fa$var$I && 0 !== (b.flags & 1048576) && $bcc038267b15f6fa$var$ug(b, $bcc038267b15f6fa$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bcc038267b15f6fa$var$jj(a, b);
            a = b.pendingProps;
            var e = $bcc038267b15f6fa$var$Yf(b, $bcc038267b15f6fa$var$H.current);
            $bcc038267b15f6fa$var$Tg(b, c);
            e = $bcc038267b15f6fa$var$Xh(null, b, d, a, e, c);
            var f = $bcc038267b15f6fa$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bcc038267b15f6fa$var$Zf(d) ? (f = !0, $bcc038267b15f6fa$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bcc038267b15f6fa$var$ah(b), e.updater = $bcc038267b15f6fa$var$nh, b.stateNode = e, e._reactInternals = b, $bcc038267b15f6fa$var$rh(b, d, a, c), b = $bcc038267b15f6fa$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $bcc038267b15f6fa$var$I && f && $bcc038267b15f6fa$var$vg(b), $bcc038267b15f6fa$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bcc038267b15f6fa$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bcc038267b15f6fa$var$$k(d);
                a = $bcc038267b15f6fa$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $bcc038267b15f6fa$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bcc038267b15f6fa$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bcc038267b15f6fa$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bcc038267b15f6fa$var$aj(null, b, d, $bcc038267b15f6fa$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($bcc038267b15f6fa$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bcc038267b15f6fa$var$Lg(d, e), $bcc038267b15f6fa$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bcc038267b15f6fa$var$Lg(d, e), $bcc038267b15f6fa$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $bcc038267b15f6fa$var$lj(b);
                if (null === a) throw Error($bcc038267b15f6fa$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bcc038267b15f6fa$var$bh(a, b);
                $bcc038267b15f6fa$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bcc038267b15f6fa$var$Ki(Error($bcc038267b15f6fa$var$p(423)), b);
                        b = $bcc038267b15f6fa$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bcc038267b15f6fa$var$Ki(Error($bcc038267b15f6fa$var$p(424)), b);
                        b = $bcc038267b15f6fa$var$mj(a, b, d, c, e);
                        break a;
                    } else for($bcc038267b15f6fa$var$yg = $bcc038267b15f6fa$var$Lf(b.stateNode.containerInfo.firstChild), $bcc038267b15f6fa$var$xg = b, $bcc038267b15f6fa$var$I = !0, $bcc038267b15f6fa$var$zg = null, c = $bcc038267b15f6fa$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bcc038267b15f6fa$var$Ig();
                    if (d === e) {
                        b = $bcc038267b15f6fa$var$$i(a, b, c);
                        break a;
                    }
                    $bcc038267b15f6fa$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bcc038267b15f6fa$var$Kh(b), null === a && $bcc038267b15f6fa$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bcc038267b15f6fa$var$Ef(d, e) ? g = null : null !== f && $bcc038267b15f6fa$var$Ef(d, f) && (b.flags |= 32), $bcc038267b15f6fa$var$hj(a, b), $bcc038267b15f6fa$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $bcc038267b15f6fa$var$Eg(b), null;
        case 13:
            return $bcc038267b15f6fa$var$pj(a, b, c);
        case 4:
            return $bcc038267b15f6fa$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bcc038267b15f6fa$var$Bh(b, null, d, c) : $bcc038267b15f6fa$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bcc038267b15f6fa$var$Lg(d, e), $bcc038267b15f6fa$var$Zi(a, b, d, e, c);
        case 7:
            return $bcc038267b15f6fa$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bcc038267b15f6fa$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bcc038267b15f6fa$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bcc038267b15f6fa$var$G($bcc038267b15f6fa$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bcc038267b15f6fa$var$He(f.value, g)) {
                        if (f.children === e.children && !$bcc038267b15f6fa$var$Wf.current) {
                            b = $bcc038267b15f6fa$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f["return"] = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bcc038267b15f6fa$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bcc038267b15f6fa$var$Sg(f["return"], c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f["return"];
                            if (null === g) throw Error($bcc038267b15f6fa$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bcc038267b15f6fa$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g["return"] = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f["return"] = g["return"];
                                g = f;
                                break;
                            }
                            g = g["return"];
                        }
                        f = g;
                    }
                }
                $bcc038267b15f6fa$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bcc038267b15f6fa$var$Tg(b, c), e = $bcc038267b15f6fa$var$Vg(e), d = d(e), b.flags |= 1, $bcc038267b15f6fa$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bcc038267b15f6fa$var$Lg(d, b.pendingProps), e = $bcc038267b15f6fa$var$Lg(d.type, e), $bcc038267b15f6fa$var$aj(a, b, d, e, c);
        case 15:
            return $bcc038267b15f6fa$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bcc038267b15f6fa$var$Lg(d, e), $bcc038267b15f6fa$var$jj(a, b), b.tag = 1, $bcc038267b15f6fa$var$Zf(d) ? (a = !0, $bcc038267b15f6fa$var$cg(b)) : a = !1, $bcc038267b15f6fa$var$Tg(b, c), $bcc038267b15f6fa$var$ph(b, d, e), $bcc038267b15f6fa$var$rh(b, d, e, c), $bcc038267b15f6fa$var$kj(null, b, d, !0, a, c);
        case 19:
            return $bcc038267b15f6fa$var$yj(a, b, c);
        case 22:
            return $bcc038267b15f6fa$var$ej(a, b, c);
    }
    throw Error($bcc038267b15f6fa$var$p(156, b.tag));
};
function $bcc038267b15f6fa$var$Gk(a, b) {
    return $bcc038267b15f6fa$var$ac(a, b);
}
function $bcc038267b15f6fa$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bcc038267b15f6fa$var$Bg(a, b, c, d) {
    return new $bcc038267b15f6fa$var$al(a, b, c, d);
}
function $bcc038267b15f6fa$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bcc038267b15f6fa$var$$k(a) {
    if ("function" === typeof a) return $bcc038267b15f6fa$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bcc038267b15f6fa$var$Da) return 11;
        if (a === $bcc038267b15f6fa$var$Ga) return 14;
    }
    return 2;
}
function $bcc038267b15f6fa$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $bcc038267b15f6fa$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bcc038267b15f6fa$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bcc038267b15f6fa$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bcc038267b15f6fa$var$ya:
            return $bcc038267b15f6fa$var$Ah(c.children, e, f, b);
        case $bcc038267b15f6fa$var$za:
            g = 8;
            e |= 8;
            break;
        case $bcc038267b15f6fa$var$Aa:
            return a = $bcc038267b15f6fa$var$Bg(12, c, b, e | 2), a.elementType = $bcc038267b15f6fa$var$Aa, a.lanes = f, a;
        case $bcc038267b15f6fa$var$Ea:
            return a = $bcc038267b15f6fa$var$Bg(13, c, b, e), a.elementType = $bcc038267b15f6fa$var$Ea, a.lanes = f, a;
        case $bcc038267b15f6fa$var$Fa:
            return a = $bcc038267b15f6fa$var$Bg(19, c, b, e), a.elementType = $bcc038267b15f6fa$var$Fa, a.lanes = f, a;
        case $bcc038267b15f6fa$var$Ia:
            return $bcc038267b15f6fa$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $bcc038267b15f6fa$var$Ba:
                    g = 10;
                    break a;
                case $bcc038267b15f6fa$var$Ca:
                    g = 9;
                    break a;
                case $bcc038267b15f6fa$var$Da:
                    g = 11;
                    break a;
                case $bcc038267b15f6fa$var$Ga:
                    g = 14;
                    break a;
                case $bcc038267b15f6fa$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bcc038267b15f6fa$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $7FyBz._)(a), ""));
    }
    b = $bcc038267b15f6fa$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bcc038267b15f6fa$var$Ah(a, b, c, d) {
    a = $bcc038267b15f6fa$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bcc038267b15f6fa$var$qj(a, b, c, d) {
    a = $bcc038267b15f6fa$var$Bg(22, a, d, b);
    a.elementType = $bcc038267b15f6fa$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bcc038267b15f6fa$var$xh(a, b, c) {
    a = $bcc038267b15f6fa$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bcc038267b15f6fa$var$zh(a, b, c) {
    b = $bcc038267b15f6fa$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bcc038267b15f6fa$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bcc038267b15f6fa$var$zc(0);
    this.expirationTimes = $bcc038267b15f6fa$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bcc038267b15f6fa$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bcc038267b15f6fa$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $bcc038267b15f6fa$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bcc038267b15f6fa$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bcc038267b15f6fa$var$ah(f);
    return a;
}
function $bcc038267b15f6fa$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bcc038267b15f6fa$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bcc038267b15f6fa$var$el(a) {
    if (!a) return $bcc038267b15f6fa$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bcc038267b15f6fa$var$Vb(a) !== a || 1 !== a.tag) throw Error($bcc038267b15f6fa$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bcc038267b15f6fa$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b["return"];
        }while (null !== b);
        throw Error($bcc038267b15f6fa$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bcc038267b15f6fa$var$Zf(c)) return $bcc038267b15f6fa$var$bg(a, c, b);
    }
    return b;
}
function $bcc038267b15f6fa$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $bcc038267b15f6fa$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $bcc038267b15f6fa$var$el(null);
    c = a.current;
    d = $bcc038267b15f6fa$var$L();
    e = $bcc038267b15f6fa$var$lh(c);
    f = $bcc038267b15f6fa$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bcc038267b15f6fa$var$dh(c, f, e);
    a.current.lanes = e;
    $bcc038267b15f6fa$var$Ac(a, e, d);
    $bcc038267b15f6fa$var$Ek(a, d);
    return a;
}
function $bcc038267b15f6fa$var$gl(a, b, c, d) {
    var e = b.current, f = $bcc038267b15f6fa$var$L(), g = $bcc038267b15f6fa$var$lh(e);
    c = $bcc038267b15f6fa$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bcc038267b15f6fa$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bcc038267b15f6fa$var$dh(e, b, g);
    null !== a && ($bcc038267b15f6fa$var$mh(a, e, g, f), $bcc038267b15f6fa$var$eh(a, e, g));
    return g;
}
function $bcc038267b15f6fa$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bcc038267b15f6fa$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bcc038267b15f6fa$var$jl(a, b) {
    $bcc038267b15f6fa$var$il(a, b);
    (a = a.alternate) && $bcc038267b15f6fa$var$il(a, b);
}
function $bcc038267b15f6fa$var$kl() {
    return null;
}
var $bcc038267b15f6fa$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $bcc038267b15f6fa$var$ml(a) {
    this._internalRoot = a;
}
$bcc038267b15f6fa$var$nl.prototype.render = $bcc038267b15f6fa$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bcc038267b15f6fa$var$p(409));
    $bcc038267b15f6fa$var$gl(a, b, null, null);
};
$bcc038267b15f6fa$var$nl.prototype.unmount = $bcc038267b15f6fa$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bcc038267b15f6fa$var$Sk(function() {
            $bcc038267b15f6fa$var$gl(null, a, null, null);
        });
        b[$bcc038267b15f6fa$var$uf] = null;
    }
};
function $bcc038267b15f6fa$var$nl(a) {
    this._internalRoot = a;
}
$bcc038267b15f6fa$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bcc038267b15f6fa$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bcc038267b15f6fa$var$Qc.length && 0 !== b && b < $bcc038267b15f6fa$var$Qc[c].priority; c++);
        $bcc038267b15f6fa$var$Qc.splice(c, 0, a);
        0 === c && $bcc038267b15f6fa$var$Vc(a);
    }
};
function $bcc038267b15f6fa$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bcc038267b15f6fa$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bcc038267b15f6fa$var$ql() {}
function $bcc038267b15f6fa$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $bcc038267b15f6fa$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $bcc038267b15f6fa$var$fl(b, d, a, 0, null, !1, !1, "", $bcc038267b15f6fa$var$ql);
        a._reactRootContainer = g;
        a[$bcc038267b15f6fa$var$uf] = g.current;
        $bcc038267b15f6fa$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bcc038267b15f6fa$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $bcc038267b15f6fa$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $bcc038267b15f6fa$var$cl(a, 0, !1, null, null, !1, !1, "", $bcc038267b15f6fa$var$ql);
    a._reactRootContainer = k;
    a[$bcc038267b15f6fa$var$uf] = k.current;
    $bcc038267b15f6fa$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bcc038267b15f6fa$var$Sk(function() {
        $bcc038267b15f6fa$var$gl(b, k, c, d);
    });
    return k;
}
function $bcc038267b15f6fa$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $bcc038267b15f6fa$var$hl(g);
                h.call(_$a);
            };
        }
        $bcc038267b15f6fa$var$gl(b, g, a, e);
    } else g = $bcc038267b15f6fa$var$rl(c, b, a, e, d);
    return $bcc038267b15f6fa$var$hl(g);
}
$bcc038267b15f6fa$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bcc038267b15f6fa$var$tc(b.pendingLanes);
                0 !== c && ($bcc038267b15f6fa$var$Cc(b, c | 1), $bcc038267b15f6fa$var$Ek(b, $bcc038267b15f6fa$var$B()), 0 === ($bcc038267b15f6fa$var$K & 6) && ($bcc038267b15f6fa$var$Hj = $bcc038267b15f6fa$var$B() + 500, $bcc038267b15f6fa$var$jg()));
            }
            break;
        case 13:
            $bcc038267b15f6fa$var$Sk(function() {
                var b = $bcc038267b15f6fa$var$Zg(a, 1);
                if (null !== b) {
                    var c = $bcc038267b15f6fa$var$L();
                    $bcc038267b15f6fa$var$mh(b, a, 1, c);
                }
            }), $bcc038267b15f6fa$var$jl(a, 1);
    }
};
$bcc038267b15f6fa$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $bcc038267b15f6fa$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $bcc038267b15f6fa$var$L();
            $bcc038267b15f6fa$var$mh(b, a, 134217728, c);
        }
        $bcc038267b15f6fa$var$jl(a, 134217728);
    }
};
$bcc038267b15f6fa$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $bcc038267b15f6fa$var$lh(a), c = $bcc038267b15f6fa$var$Zg(a, b);
        if (null !== c) {
            var d = $bcc038267b15f6fa$var$L();
            $bcc038267b15f6fa$var$mh(c, a, b, d);
        }
        $bcc038267b15f6fa$var$jl(a, b);
    }
};
$bcc038267b15f6fa$var$Hc = function Hc() {
    return $bcc038267b15f6fa$var$C;
};
$bcc038267b15f6fa$var$Ic = function Ic(a, b) {
    var c = $bcc038267b15f6fa$var$C;
    try {
        return $bcc038267b15f6fa$var$C = a, b();
    } finally{
        $bcc038267b15f6fa$var$C = c;
    }
};
$bcc038267b15f6fa$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $bcc038267b15f6fa$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bcc038267b15f6fa$var$Db(d);
                        if (!e) throw Error($bcc038267b15f6fa$var$p(90));
                        $bcc038267b15f6fa$var$Wa(d);
                        $bcc038267b15f6fa$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bcc038267b15f6fa$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bcc038267b15f6fa$var$fb(a, !!c.multiple, b, !1);
    }
};
$bcc038267b15f6fa$var$Gb = $bcc038267b15f6fa$var$Rk;
$bcc038267b15f6fa$var$Hb = $bcc038267b15f6fa$var$Sk;
var $bcc038267b15f6fa$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $bcc038267b15f6fa$var$Cb,
        $bcc038267b15f6fa$var$ue,
        $bcc038267b15f6fa$var$Db,
        $bcc038267b15f6fa$var$Eb,
        $bcc038267b15f6fa$var$Fb,
        $bcc038267b15f6fa$var$Rk
    ]
}, $bcc038267b15f6fa$var$ul = {
    findFiberByHostInstance: $bcc038267b15f6fa$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $bcc038267b15f6fa$var$vl = {
    bundleType: $bcc038267b15f6fa$var$ul.bundleType,
    version: $bcc038267b15f6fa$var$ul.version,
    rendererPackageName: $bcc038267b15f6fa$var$ul.rendererPackageName,
    rendererConfig: $bcc038267b15f6fa$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bcc038267b15f6fa$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $bcc038267b15f6fa$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bcc038267b15f6fa$var$ul.findFiberByHostInstance || $bcc038267b15f6fa$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bcc038267b15f6fa$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bcc038267b15f6fa$var$wl.isDisabled && $bcc038267b15f6fa$var$wl.supportsFiber) try {
        $bcc038267b15f6fa$var$kc = $bcc038267b15f6fa$var$wl.inject($bcc038267b15f6fa$var$vl), $bcc038267b15f6fa$var$lc = $bcc038267b15f6fa$var$wl;
    } catch (a) {}
}
$bcc038267b15f6fa$export$ae55be85d98224ed = $bcc038267b15f6fa$var$tl;
$bcc038267b15f6fa$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bcc038267b15f6fa$var$ol(b)) throw Error($bcc038267b15f6fa$var$p(200));
    return $bcc038267b15f6fa$var$dl(a, b, null, c);
};
$bcc038267b15f6fa$export$882461b6382ed46c = function(a, b) {
    if (!$bcc038267b15f6fa$var$ol(a)) throw Error($bcc038267b15f6fa$var$p(299));
    var c = !1, d = "", e = $bcc038267b15f6fa$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bcc038267b15f6fa$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$bcc038267b15f6fa$var$uf] = b.current;
    $bcc038267b15f6fa$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bcc038267b15f6fa$var$ml(b);
};
$bcc038267b15f6fa$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bcc038267b15f6fa$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bcc038267b15f6fa$var$p(268, a));
    }
    a = $bcc038267b15f6fa$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bcc038267b15f6fa$export$cd75ccfd720a3cd4 = function(a) {
    return $bcc038267b15f6fa$var$Sk(a);
};
$bcc038267b15f6fa$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bcc038267b15f6fa$var$pl(b)) throw Error($bcc038267b15f6fa$var$p(200));
    return $bcc038267b15f6fa$var$sl(null, a, b, !0, c);
};
$bcc038267b15f6fa$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bcc038267b15f6fa$var$ol(a)) throw Error($bcc038267b15f6fa$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bcc038267b15f6fa$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bcc038267b15f6fa$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bcc038267b15f6fa$var$uf] = b.current;
    $bcc038267b15f6fa$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bcc038267b15f6fa$var$nl(b);
};
$bcc038267b15f6fa$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bcc038267b15f6fa$var$pl(b)) throw Error($bcc038267b15f6fa$var$p(200));
    return $bcc038267b15f6fa$var$sl(null, a, b, !1, c);
};
$bcc038267b15f6fa$export$502457920280e6be = function(a) {
    if (!$bcc038267b15f6fa$var$pl(a)) throw Error($bcc038267b15f6fa$var$p(40));
    return a._reactRootContainer ? ($bcc038267b15f6fa$var$Sk(function() {
        $bcc038267b15f6fa$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bcc038267b15f6fa$var$uf] = null;
        });
    }), !0) : !1;
};
$bcc038267b15f6fa$export$c78a37762a8d58e1 = $bcc038267b15f6fa$var$Rk;
$bcc038267b15f6fa$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bcc038267b15f6fa$var$pl(c)) throw Error($bcc038267b15f6fa$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bcc038267b15f6fa$var$p(38));
    return $bcc038267b15f6fa$var$sl(a, b, c, !1, d);
};
$bcc038267b15f6fa$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("2cSXK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lGsPG"));

});
parcelRegister("lGsPG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $fc93e2bf2b682af5$export$c4744153514ff05d; }, function (v) { return $fc93e2bf2b682af5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $fc93e2bf2b682af5$export$3e506c1ccc9cc1a7; }, function (v) { return $fc93e2bf2b682af5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $fc93e2bf2b682af5$export$e26fe2ed2fa76875; }, function (v) { return $fc93e2bf2b682af5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $fc93e2bf2b682af5$export$502329bbf4b505b1; }, function (v) { return $fc93e2bf2b682af5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $fc93e2bf2b682af5$export$6e3807111c4874c4; }, function (v) { return $fc93e2bf2b682af5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $fc93e2bf2b682af5$export$c27134553091fb3a; }, function (v) { return $fc93e2bf2b682af5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $fc93e2bf2b682af5$export$33ee1acdc04fd2a2; }, function (v) { return $fc93e2bf2b682af5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $fc93e2bf2b682af5$export$b00a404bbd5edef2; }, function (v) { return $fc93e2bf2b682af5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $fc93e2bf2b682af5$export$8352ce38b91d0c62; }, function (v) { return $fc93e2bf2b682af5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $fc93e2bf2b682af5$export$d66a1c1c77bd778b; }, function (v) { return $fc93e2bf2b682af5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $fc93e2bf2b682af5$export$d3dfb8e4810cb555; }, function (v) { return $fc93e2bf2b682af5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $fc93e2bf2b682af5$export$839f9183b0465a69; }, function (v) { return $fc93e2bf2b682af5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $fc93e2bf2b682af5$export$72fdf0e06517287b; }, function (v) { return $fc93e2bf2b682af5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $fc93e2bf2b682af5$export$4b844e58a3e414b4; }, function (v) { return $fc93e2bf2b682af5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $fc93e2bf2b682af5$export$816d2913ae6b83b1; }, function (v) { return $fc93e2bf2b682af5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $fc93e2bf2b682af5$export$61bcfe829111a1d0; }, function (v) { return $fc93e2bf2b682af5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $fc93e2bf2b682af5$export$7ee8c9beb337bc3f; }, function (v) { return $fc93e2bf2b682af5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $fc93e2bf2b682af5$export$b5836b71941fa3ed; }, function (v) { return $fc93e2bf2b682af5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $fc93e2bf2b682af5$export$cf845f2c119da08a; }, function (v) { return $fc93e2bf2b682af5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc93e2bf2b682af5$export$c4744153514ff05d;
var $fc93e2bf2b682af5$export$3e506c1ccc9cc1a7;
var $fc93e2bf2b682af5$export$e26fe2ed2fa76875;
var $fc93e2bf2b682af5$export$502329bbf4b505b1;
var $fc93e2bf2b682af5$export$6e3807111c4874c4;
var $fc93e2bf2b682af5$export$c27134553091fb3a;
var $fc93e2bf2b682af5$export$33ee1acdc04fd2a2;
var $fc93e2bf2b682af5$export$b00a404bbd5edef2;
var $fc93e2bf2b682af5$export$8352ce38b91d0c62;
var $fc93e2bf2b682af5$export$d66a1c1c77bd778b;
var $fc93e2bf2b682af5$export$d3dfb8e4810cb555;
var $fc93e2bf2b682af5$export$839f9183b0465a69;
var $fc93e2bf2b682af5$export$72fdf0e06517287b;
var $fc93e2bf2b682af5$export$4b844e58a3e414b4;
var $fc93e2bf2b682af5$export$816d2913ae6b83b1;
var $fc93e2bf2b682af5$export$61bcfe829111a1d0;
var $fc93e2bf2b682af5$export$7ee8c9beb337bc3f;
var $fc93e2bf2b682af5$export$b5836b71941fa3ed;
var $fc93e2bf2b682af5$export$cf845f2c119da08a;
"use strict";
function $fc93e2bf2b682af5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fc93e2bf2b682af5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fc93e2bf2b682af5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fc93e2bf2b682af5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fc93e2bf2b682af5$var$g(C, c)) n < e && 0 > $fc93e2bf2b682af5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fc93e2bf2b682af5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fc93e2bf2b682af5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fc93e2bf2b682af5$var$l = performance;
    $fc93e2bf2b682af5$export$c4744153514ff05d = function() {
        return $fc93e2bf2b682af5$var$l.now();
    };
} else {
    var $fc93e2bf2b682af5$var$p = Date, $fc93e2bf2b682af5$var$q = $fc93e2bf2b682af5$var$p.now();
    $fc93e2bf2b682af5$export$c4744153514ff05d = function() {
        return $fc93e2bf2b682af5$var$p.now() - $fc93e2bf2b682af5$var$q;
    };
}
var $fc93e2bf2b682af5$var$r = [], $fc93e2bf2b682af5$var$t = [], $fc93e2bf2b682af5$var$u = 1, $fc93e2bf2b682af5$var$v = null, $fc93e2bf2b682af5$var$y = 3, $fc93e2bf2b682af5$var$z = !1, $fc93e2bf2b682af5$var$A = !1, $fc93e2bf2b682af5$var$B = !1, $fc93e2bf2b682af5$var$D = "function" === typeof setTimeout ? setTimeout : null, $fc93e2bf2b682af5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fc93e2bf2b682af5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fc93e2bf2b682af5$var$G(a) {
    for(var b = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$t); null !== b;){
        if (null === b.callback) $fc93e2bf2b682af5$var$k($fc93e2bf2b682af5$var$t);
        else if (b.startTime <= a) $fc93e2bf2b682af5$var$k($fc93e2bf2b682af5$var$t), b.sortIndex = b.expirationTime, $fc93e2bf2b682af5$var$f($fc93e2bf2b682af5$var$r, b);
        else break;
        b = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$t);
    }
}
function $fc93e2bf2b682af5$var$H(a) {
    $fc93e2bf2b682af5$var$B = !1;
    $fc93e2bf2b682af5$var$G(a);
    if (!$fc93e2bf2b682af5$var$A) {
        if (null !== $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r)) $fc93e2bf2b682af5$var$A = !0, $fc93e2bf2b682af5$var$I($fc93e2bf2b682af5$var$J);
        else {
            var b = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$t);
            null !== b && $fc93e2bf2b682af5$var$K($fc93e2bf2b682af5$var$H, b.startTime - a);
        }
    }
}
function $fc93e2bf2b682af5$var$J(a, b) {
    $fc93e2bf2b682af5$var$A = !1;
    $fc93e2bf2b682af5$var$B && ($fc93e2bf2b682af5$var$B = !1, $fc93e2bf2b682af5$var$E($fc93e2bf2b682af5$var$L), $fc93e2bf2b682af5$var$L = -1);
    $fc93e2bf2b682af5$var$z = !0;
    var c = $fc93e2bf2b682af5$var$y;
    try {
        $fc93e2bf2b682af5$var$G(b);
        for($fc93e2bf2b682af5$var$v = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r); null !== $fc93e2bf2b682af5$var$v && (!($fc93e2bf2b682af5$var$v.expirationTime > b) || a && !$fc93e2bf2b682af5$var$M());){
            var d = $fc93e2bf2b682af5$var$v.callback;
            if ("function" === typeof d) {
                $fc93e2bf2b682af5$var$v.callback = null;
                $fc93e2bf2b682af5$var$y = $fc93e2bf2b682af5$var$v.priorityLevel;
                var e = d($fc93e2bf2b682af5$var$v.expirationTime <= b);
                b = $fc93e2bf2b682af5$export$c4744153514ff05d();
                "function" === typeof e ? $fc93e2bf2b682af5$var$v.callback = e : $fc93e2bf2b682af5$var$v === $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r) && $fc93e2bf2b682af5$var$k($fc93e2bf2b682af5$var$r);
                $fc93e2bf2b682af5$var$G(b);
            } else $fc93e2bf2b682af5$var$k($fc93e2bf2b682af5$var$r);
            $fc93e2bf2b682af5$var$v = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r);
        }
        if (null !== $fc93e2bf2b682af5$var$v) var w = !0;
        else {
            var m = $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$t);
            null !== m && $fc93e2bf2b682af5$var$K($fc93e2bf2b682af5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fc93e2bf2b682af5$var$v = null, $fc93e2bf2b682af5$var$y = c, $fc93e2bf2b682af5$var$z = !1;
    }
}
var $fc93e2bf2b682af5$var$N = !1, $fc93e2bf2b682af5$var$O = null, $fc93e2bf2b682af5$var$L = -1, $fc93e2bf2b682af5$var$P = 5, $fc93e2bf2b682af5$var$Q = -1;
function $fc93e2bf2b682af5$var$M() {
    return $fc93e2bf2b682af5$export$c4744153514ff05d() - $fc93e2bf2b682af5$var$Q < $fc93e2bf2b682af5$var$P ? !1 : !0;
}
function $fc93e2bf2b682af5$var$R() {
    if (null !== $fc93e2bf2b682af5$var$O) {
        var a = $fc93e2bf2b682af5$export$c4744153514ff05d();
        $fc93e2bf2b682af5$var$Q = a;
        var b = !0;
        try {
            b = $fc93e2bf2b682af5$var$O(!0, a);
        } finally{
            b ? $fc93e2bf2b682af5$var$S() : ($fc93e2bf2b682af5$var$N = !1, $fc93e2bf2b682af5$var$O = null);
        }
    } else $fc93e2bf2b682af5$var$N = !1;
}
var $fc93e2bf2b682af5$var$S;
if ("function" === typeof $fc93e2bf2b682af5$var$F) $fc93e2bf2b682af5$var$S = function S() {
    $fc93e2bf2b682af5$var$F($fc93e2bf2b682af5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fc93e2bf2b682af5$var$T = new MessageChannel, $fc93e2bf2b682af5$var$U = $fc93e2bf2b682af5$var$T.port2;
    $fc93e2bf2b682af5$var$T.port1.onmessage = $fc93e2bf2b682af5$var$R;
    $fc93e2bf2b682af5$var$S = function S() {
        $fc93e2bf2b682af5$var$U.postMessage(null);
    };
} else $fc93e2bf2b682af5$var$S = function S() {
    $fc93e2bf2b682af5$var$D($fc93e2bf2b682af5$var$R, 0);
};
function $fc93e2bf2b682af5$var$I(a) {
    $fc93e2bf2b682af5$var$O = a;
    $fc93e2bf2b682af5$var$N || ($fc93e2bf2b682af5$var$N = !0, $fc93e2bf2b682af5$var$S());
}
function $fc93e2bf2b682af5$var$K(a, b) {
    $fc93e2bf2b682af5$var$L = $fc93e2bf2b682af5$var$D(function() {
        a($fc93e2bf2b682af5$export$c4744153514ff05d());
    }, b);
}
$fc93e2bf2b682af5$export$3e506c1ccc9cc1a7 = 5;
$fc93e2bf2b682af5$export$e26fe2ed2fa76875 = 1;
$fc93e2bf2b682af5$export$502329bbf4b505b1 = 4;
$fc93e2bf2b682af5$export$6e3807111c4874c4 = 3;
$fc93e2bf2b682af5$export$c27134553091fb3a = null;
$fc93e2bf2b682af5$export$33ee1acdc04fd2a2 = 2;
$fc93e2bf2b682af5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fc93e2bf2b682af5$export$8352ce38b91d0c62 = function() {
    $fc93e2bf2b682af5$var$A || $fc93e2bf2b682af5$var$z || ($fc93e2bf2b682af5$var$A = !0, $fc93e2bf2b682af5$var$I($fc93e2bf2b682af5$var$J));
};
$fc93e2bf2b682af5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fc93e2bf2b682af5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fc93e2bf2b682af5$export$d3dfb8e4810cb555 = function() {
    return $fc93e2bf2b682af5$var$y;
};
$fc93e2bf2b682af5$export$839f9183b0465a69 = function() {
    return $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r);
};
$fc93e2bf2b682af5$export$72fdf0e06517287b = function(a) {
    switch($fc93e2bf2b682af5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fc93e2bf2b682af5$var$y;
    }
    var c = $fc93e2bf2b682af5$var$y;
    $fc93e2bf2b682af5$var$y = b;
    try {
        return a();
    } finally{
        $fc93e2bf2b682af5$var$y = c;
    }
};
$fc93e2bf2b682af5$export$4b844e58a3e414b4 = function() {};
$fc93e2bf2b682af5$export$816d2913ae6b83b1 = function() {};
$fc93e2bf2b682af5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fc93e2bf2b682af5$var$y;
    $fc93e2bf2b682af5$var$y = a;
    try {
        return b();
    } finally{
        $fc93e2bf2b682af5$var$y = c;
    }
};
$fc93e2bf2b682af5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fc93e2bf2b682af5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fc93e2bf2b682af5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fc93e2bf2b682af5$var$f($fc93e2bf2b682af5$var$t, a), null === $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$r) && a === $fc93e2bf2b682af5$var$h($fc93e2bf2b682af5$var$t) && ($fc93e2bf2b682af5$var$B ? ($fc93e2bf2b682af5$var$E($fc93e2bf2b682af5$var$L), $fc93e2bf2b682af5$var$L = -1) : $fc93e2bf2b682af5$var$B = !0, $fc93e2bf2b682af5$var$K($fc93e2bf2b682af5$var$H, c - d))) : (a.sortIndex = e, $fc93e2bf2b682af5$var$f($fc93e2bf2b682af5$var$r, a), $fc93e2bf2b682af5$var$A || $fc93e2bf2b682af5$var$z || ($fc93e2bf2b682af5$var$A = !0, $fc93e2bf2b682af5$var$I($fc93e2bf2b682af5$var$J)));
    return a;
};
$fc93e2bf2b682af5$export$b5836b71941fa3ed = $fc93e2bf2b682af5$var$M;
$fc93e2bf2b682af5$export$cf845f2c119da08a = function(a) {
    var b = $fc93e2bf2b682af5$var$y;
    return function() {
        var c = $fc93e2bf2b682af5$var$y;
        $fc93e2bf2b682af5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fc93e2bf2b682af5$var$y = c;
        }
    };
};

});



parcelRegister("7rv2B", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $56b3221ce7e4c084$export$a7c73072b1a182ae; }, function (v) { return $56b3221ce7e4c084$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $56b3221ce7e4c084$export$9f27bc3417b4524d; }, function (v) { return $56b3221ce7e4c084$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $56b3221ce7e4c084$export$db77ccec0bb4ccac; }, function (v) { return $56b3221ce7e4c084$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $56b3221ce7e4c084$export$8392c0c9d3dcbd35; }, function (v) { return $56b3221ce7e4c084$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $56b3221ce7e4c084$export$ffb0004e005737fa; }, function (v) { return $56b3221ce7e4c084$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $56b3221ce7e4c084$export$b624eff549462981; }, function (v) { return $56b3221ce7e4c084$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $56b3221ce7e4c084$export$7897aa7841a5380c; }, function (v) { return $56b3221ce7e4c084$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $56b3221ce7e4c084$export$602eac185826482c; }, function (v) { return $56b3221ce7e4c084$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $56b3221ce7e4c084$export$e2c29f18771995cb; }, function (v) { return $56b3221ce7e4c084$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $56b3221ce7e4c084$export$5f8d39834fd61797; }, function (v) { return $56b3221ce7e4c084$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $56b3221ce7e4c084$export$74bf444e3cd11ea5; }, function (v) { return $56b3221ce7e4c084$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $56b3221ce7e4c084$export$998bcd577473dd93; }, function (v) { return $56b3221ce7e4c084$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $56b3221ce7e4c084$export$92387174baf9b227; }, function (v) { return $56b3221ce7e4c084$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $56b3221ce7e4c084$export$ec112efeb987d9c6; }, function (v) { return $56b3221ce7e4c084$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $56b3221ce7e4c084$export$b706b080d889d2c9; }, function (v) { return $56b3221ce7e4c084$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $56b3221ce7e4c084$export$5be5a87408f70ddc; }, function (v) { return $56b3221ce7e4c084$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $56b3221ce7e4c084$export$45a5e7f76e0caa8d; }, function (v) { return $56b3221ce7e4c084$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $56b3221ce7e4c084$export$455c2e768291efa6; }, function (v) { return $56b3221ce7e4c084$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $56b3221ce7e4c084$export$9522e17588c12572; }, function (v) { return $56b3221ce7e4c084$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $56b3221ce7e4c084$export$2110ac352bb060b9; }, function (v) { return $56b3221ce7e4c084$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $56b3221ce7e4c084$export$56885ab8b9c456ab; }, function (v) { return $56b3221ce7e4c084$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $56b3221ce7e4c084$export$d927fcb6adf8f9de; }, function (v) { return $56b3221ce7e4c084$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $56b3221ce7e4c084$export$b82d16f27459e05a; }, function (v) { return $56b3221ce7e4c084$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $56b3221ce7e4c084$export$522c17b4f5e123e8; }, function (v) { return $56b3221ce7e4c084$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $56b3221ce7e4c084$export$1aabd8a0274ecfd6; }, function (v) { return $56b3221ce7e4c084$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $56b3221ce7e4c084$export$3d6c20d97e46b957; }, function (v) { return $56b3221ce7e4c084$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $56b3221ce7e4c084$export$9b621391a187a31a; }, function (v) { return $56b3221ce7e4c084$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $56b3221ce7e4c084$export$f5bbd400c2f4426f; }, function (v) { return $56b3221ce7e4c084$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56b3221ce7e4c084$export$a7c73072b1a182ae;
var $56b3221ce7e4c084$export$9f27bc3417b4524d;
var $56b3221ce7e4c084$export$db77ccec0bb4ccac;
var $56b3221ce7e4c084$export$8392c0c9d3dcbd35;
var $56b3221ce7e4c084$export$ffb0004e005737fa;
var $56b3221ce7e4c084$export$b624eff549462981;
var $56b3221ce7e4c084$export$7897aa7841a5380c;
var $56b3221ce7e4c084$export$602eac185826482c;
var $56b3221ce7e4c084$export$e2c29f18771995cb;
var $56b3221ce7e4c084$export$5f8d39834fd61797;
var $56b3221ce7e4c084$export$74bf444e3cd11ea5;
var $56b3221ce7e4c084$export$998bcd577473dd93;
var $56b3221ce7e4c084$export$92387174baf9b227;
var $56b3221ce7e4c084$export$ec112efeb987d9c6;
var $56b3221ce7e4c084$export$b706b080d889d2c9;
var $56b3221ce7e4c084$export$5be5a87408f70ddc;
var $56b3221ce7e4c084$export$45a5e7f76e0caa8d;
var $56b3221ce7e4c084$export$455c2e768291efa6;
var $56b3221ce7e4c084$export$9522e17588c12572;
var $56b3221ce7e4c084$export$2110ac352bb060b9;
var $56b3221ce7e4c084$export$56885ab8b9c456ab;
var $56b3221ce7e4c084$export$d927fcb6adf8f9de;
var $56b3221ce7e4c084$export$b82d16f27459e05a;
var $56b3221ce7e4c084$export$522c17b4f5e123e8;
var $56b3221ce7e4c084$export$1aabd8a0274ecfd6;
var $56b3221ce7e4c084$export$3d6c20d97e46b957;
var $56b3221ce7e4c084$export$9b621391a187a31a;
var $56b3221ce7e4c084$export$f5bbd400c2f4426f;
"use strict";
var $56b3221ce7e4c084$var$b = Symbol["for"]("react.element"), $56b3221ce7e4c084$var$c = Symbol["for"]("react.portal"), $56b3221ce7e4c084$var$d = Symbol["for"]("react.fragment"), $56b3221ce7e4c084$var$e = Symbol["for"]("react.strict_mode"), $56b3221ce7e4c084$var$f = Symbol["for"]("react.profiler"), $56b3221ce7e4c084$var$g = Symbol["for"]("react.provider"), $56b3221ce7e4c084$var$h = Symbol["for"]("react.context"), $56b3221ce7e4c084$var$k = Symbol["for"]("react.server_context"), $56b3221ce7e4c084$var$l = Symbol["for"]("react.forward_ref"), $56b3221ce7e4c084$var$m = Symbol["for"]("react.suspense"), $56b3221ce7e4c084$var$n = Symbol["for"]("react.suspense_list"), $56b3221ce7e4c084$var$p = Symbol["for"]("react.memo"), $56b3221ce7e4c084$var$q = Symbol["for"]("react.lazy"), $56b3221ce7e4c084$var$t = Symbol["for"]("react.offscreen"), $56b3221ce7e4c084$var$u;
$56b3221ce7e4c084$var$u = Symbol["for"]("react.module.reference");
function $56b3221ce7e4c084$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $56b3221ce7e4c084$var$b:
                switch(a = a.type, a){
                    case $56b3221ce7e4c084$var$d:
                    case $56b3221ce7e4c084$var$f:
                    case $56b3221ce7e4c084$var$e:
                    case $56b3221ce7e4c084$var$m:
                    case $56b3221ce7e4c084$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $56b3221ce7e4c084$var$k:
                            case $56b3221ce7e4c084$var$h:
                            case $56b3221ce7e4c084$var$l:
                            case $56b3221ce7e4c084$var$q:
                            case $56b3221ce7e4c084$var$p:
                            case $56b3221ce7e4c084$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $56b3221ce7e4c084$var$c:
                return r;
        }
    }
}
$56b3221ce7e4c084$export$a7c73072b1a182ae = $56b3221ce7e4c084$var$h;
$56b3221ce7e4c084$export$9f27bc3417b4524d = $56b3221ce7e4c084$var$g;
$56b3221ce7e4c084$export$db77ccec0bb4ccac = $56b3221ce7e4c084$var$b;
$56b3221ce7e4c084$export$8392c0c9d3dcbd35 = $56b3221ce7e4c084$var$l;
$56b3221ce7e4c084$export$ffb0004e005737fa = $56b3221ce7e4c084$var$d;
$56b3221ce7e4c084$export$b624eff549462981 = $56b3221ce7e4c084$var$q;
$56b3221ce7e4c084$export$7897aa7841a5380c = $56b3221ce7e4c084$var$p;
$56b3221ce7e4c084$export$602eac185826482c = $56b3221ce7e4c084$var$c;
$56b3221ce7e4c084$export$e2c29f18771995cb = $56b3221ce7e4c084$var$f;
$56b3221ce7e4c084$export$5f8d39834fd61797 = $56b3221ce7e4c084$var$e;
$56b3221ce7e4c084$export$74bf444e3cd11ea5 = $56b3221ce7e4c084$var$m;
$56b3221ce7e4c084$export$998bcd577473dd93 = $56b3221ce7e4c084$var$n;
$56b3221ce7e4c084$export$92387174baf9b227 = function() {
    return !1;
};
$56b3221ce7e4c084$export$ec112efeb987d9c6 = function() {
    return !1;
};
$56b3221ce7e4c084$export$b706b080d889d2c9 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$h;
};
$56b3221ce7e4c084$export$5be5a87408f70ddc = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$g;
};
$56b3221ce7e4c084$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $56b3221ce7e4c084$var$b;
};
$56b3221ce7e4c084$export$455c2e768291efa6 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$l;
};
$56b3221ce7e4c084$export$9522e17588c12572 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$d;
};
$56b3221ce7e4c084$export$2110ac352bb060b9 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$q;
};
$56b3221ce7e4c084$export$56885ab8b9c456ab = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$p;
};
$56b3221ce7e4c084$export$d927fcb6adf8f9de = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$c;
};
$56b3221ce7e4c084$export$b82d16f27459e05a = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$f;
};
$56b3221ce7e4c084$export$522c17b4f5e123e8 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$e;
};
$56b3221ce7e4c084$export$1aabd8a0274ecfd6 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$m;
};
$56b3221ce7e4c084$export$3d6c20d97e46b957 = function(a) {
    return $56b3221ce7e4c084$var$v(a) === $56b3221ce7e4c084$var$n;
};
$56b3221ce7e4c084$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $56b3221ce7e4c084$var$d || a === $56b3221ce7e4c084$var$f || a === $56b3221ce7e4c084$var$e || a === $56b3221ce7e4c084$var$m || a === $56b3221ce7e4c084$var$n || a === $56b3221ce7e4c084$var$t || "object" === typeof a && null !== a && (a.$$typeof === $56b3221ce7e4c084$var$q || a.$$typeof === $56b3221ce7e4c084$var$p || a.$$typeof === $56b3221ce7e4c084$var$g || a.$$typeof === $56b3221ce7e4c084$var$h || a.$$typeof === $56b3221ce7e4c084$var$l || a.$$typeof === $56b3221ce7e4c084$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$56b3221ce7e4c084$export$f5bbd400c2f4426f = $56b3221ce7e4c084$var$v;

});

parcelRegister("hYzT4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Dexie", function () { return $7399f652bbd3211b$export$4ece27d405df7279; });
$parcel$export(module.exports, "RangeSet", function () { return $7399f652bbd3211b$export$34cb5241245008dd; });
$parcel$export(module.exports, "mergeRanges", function () { return $7399f652bbd3211b$export$4876cc3130d3f820; });
$parcel$export(module.exports, "rangesOverlap", function () { return $7399f652bbd3211b$export$8f43b23b5d8de905; });
$parcel$export(module.exports, "liveQuery", function () { return $7399f652bbd3211b$export$6a9705d8f6f38796; });
$parcel$export(module.exports, "default", function () { return $7399f652bbd3211b$export$4ece27d405df7279; });
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.4, Tue May 30 2023
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ 
var $7FyBz = parcelRequire("7FyBz");
var $7399f652bbd3211b$var$__assign = function __assign1() {
    $7399f652bbd3211b$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7399f652bbd3211b$var$__assign.apply(this, arguments);
};
function $7399f652bbd3211b$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $7399f652bbd3211b$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $7399f652bbd3211b$var$keys = Object.keys;
var $7399f652bbd3211b$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$7399f652bbd3211b$var$_global.Promise) $7399f652bbd3211b$var$_global.Promise = Promise;
function $7399f652bbd3211b$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $7399f652bbd3211b$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $7399f652bbd3211b$var$getProto = Object.getPrototypeOf;
var $7399f652bbd3211b$var$_hasOwn = {}.hasOwnProperty;
function $7399f652bbd3211b$var$hasOwn(obj, prop) {
    return $7399f652bbd3211b$var$_hasOwn.call(obj, prop);
}
function $7399f652bbd3211b$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($7399f652bbd3211b$var$getProto(proto));
    (typeof Reflect === "undefined" ? $7399f652bbd3211b$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $7399f652bbd3211b$var$setProp(proto, key, extension[key]);
    });
}
var $7399f652bbd3211b$var$defineProperty = Object.defineProperty;
function $7399f652bbd3211b$var$setProp(obj, prop, functionOrGetSet, options) {
    $7399f652bbd3211b$var$defineProperty(obj, prop, $7399f652bbd3211b$var$extend(functionOrGetSet && $7399f652bbd3211b$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $7399f652bbd3211b$var$derive(Child) {
    return {
        from: function from(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $7399f652bbd3211b$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $7399f652bbd3211b$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $7399f652bbd3211b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $7399f652bbd3211b$var$getPropertyDescriptor(obj, prop) {
    var pd = $7399f652bbd3211b$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $7399f652bbd3211b$var$getProto(obj)) && $7399f652bbd3211b$var$getPropertyDescriptor(proto, prop);
}
var $7399f652bbd3211b$var$_slice = [].slice;
function $7399f652bbd3211b$var$slice(args, start, end) {
    return $7399f652bbd3211b$var$_slice.call(args, start, end);
}
function $7399f652bbd3211b$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $7399f652bbd3211b$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $7399f652bbd3211b$var$asap$1(fn) {
    if ($7399f652bbd3211b$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $7399f652bbd3211b$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $7399f652bbd3211b$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $7399f652bbd3211b$var$getByKeyPath(obj, keyPath) {
    if ($7399f652bbd3211b$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $7399f652bbd3211b$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj === undefined ? undefined : $7399f652bbd3211b$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $7399f652bbd3211b$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $7399f652bbd3211b$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$7399f652bbd3211b$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($7399f652bbd3211b$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$7399f652bbd3211b$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $7399f652bbd3211b$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($7399f652bbd3211b$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $7399f652bbd3211b$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $7399f652bbd3211b$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $7399f652bbd3211b$var$setByKeyPath(obj, kp, undefined);
    });
}
function $7399f652bbd3211b$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($7399f652bbd3211b$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $7399f652bbd3211b$var$concat = [].concat;
function $7399f652bbd3211b$var$flatten(a) {
    return $7399f652bbd3211b$var$concat.apply([], a);
}
var $7399f652bbd3211b$var$intrinsicTypeNames = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($7399f652bbd3211b$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $7399f652bbd3211b$var$_global[t];
});
var $7399f652bbd3211b$var$intrinsicTypes = $7399f652bbd3211b$var$intrinsicTypeNames.map(function(t) {
    return $7399f652bbd3211b$var$_global[t];
});
$7399f652bbd3211b$var$arrayToObject($7399f652bbd3211b$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $7399f652bbd3211b$var$circularRefs = null;
function $7399f652bbd3211b$var$deepClone(any) {
    $7399f652bbd3211b$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $7399f652bbd3211b$var$innerDeepClone(any);
    $7399f652bbd3211b$var$circularRefs = null;
    return rv;
}
function $7399f652bbd3211b$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $7399f652bbd3211b$var$circularRefs && $7399f652bbd3211b$var$circularRefs.get(any);
    if (rv) return rv;
    if ($7399f652bbd3211b$var$isArray(any)) {
        rv = [];
        $7399f652bbd3211b$var$circularRefs && $7399f652bbd3211b$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($7399f652bbd3211b$var$innerDeepClone(any[i]));
    } else if ($7399f652bbd3211b$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $7399f652bbd3211b$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $7399f652bbd3211b$var$circularRefs && $7399f652bbd3211b$var$circularRefs.set(any, rv);
        for(var prop in any)if ($7399f652bbd3211b$var$hasOwn(any, prop)) rv[prop] = $7399f652bbd3211b$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $7399f652bbd3211b$var$toString = {}.toString;
function $7399f652bbd3211b$var$toStringTag(o) {
    return $7399f652bbd3211b$var$toString.call(o).slice(8, -1);
}
var $7399f652bbd3211b$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $7399f652bbd3211b$var$getIteratorOf = (typeof $7399f652bbd3211b$var$iteratorSymbol === "undefined" ? "undefined" : (0, $7FyBz._)($7399f652bbd3211b$var$iteratorSymbol)) === "symbol" ? function getIteratorOf(x) {
    var i;
    return x != null && (i = x[$7399f652bbd3211b$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $7399f652bbd3211b$var$NO_CHAR_ARRAY = {};
function $7399f652bbd3211b$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($7399f652bbd3211b$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $7399f652bbd3211b$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $7399f652bbd3211b$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $7399f652bbd3211b$var$isAsyncFunction = typeof Symbol !== "undefined" ? function isAsyncFunction(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $7399f652bbd3211b$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $7399f652bbd3211b$var$setDebug(value, filter) {
    $7399f652bbd3211b$var$debug = value;
    $7399f652bbd3211b$var$libraryFilter = filter;
}
var $7399f652bbd3211b$var$libraryFilter = function libraryFilter() {
    return true;
};
var $7399f652bbd3211b$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $7399f652bbd3211b$var$getErrorWithStack() {
    if ($7399f652bbd3211b$var$NEEDS_THROW_FOR_STACK) try {
        $7399f652bbd3211b$var$getErrorWithStack["arguments"];
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $7399f652bbd3211b$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($7399f652bbd3211b$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $7399f652bbd3211b$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $7399f652bbd3211b$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $7399f652bbd3211b$var$errorList = $7399f652bbd3211b$var$dexieErrorNames.concat($7399f652bbd3211b$var$idbDomErrorNames);
var $7399f652bbd3211b$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $7399f652bbd3211b$var$DexieError(name, msg) {
    this._e = $7399f652bbd3211b$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$7399f652bbd3211b$var$derive($7399f652bbd3211b$var$DexieError).from(Error).extend({
    stack: {
        get: function get() {
            return this._stack || (this._stack = this.name + ": " + this.message + $7399f652bbd3211b$var$prettyStack(this._e, 2));
        }
    },
    toString: function toString() {
        return this.name + ": " + this.message;
    }
});
function $7399f652bbd3211b$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $7399f652bbd3211b$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $7399f652bbd3211b$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $7399f652bbd3211b$var$getMultiErrorMessage(msg, failures);
}
$7399f652bbd3211b$var$derive($7399f652bbd3211b$var$ModifyError).from($7399f652bbd3211b$var$DexieError);
function $7399f652bbd3211b$var$BulkError(msg, failures) {
    this._e = $7399f652bbd3211b$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $7399f652bbd3211b$var$getMultiErrorMessage(msg, failures);
}
$7399f652bbd3211b$var$derive($7399f652bbd3211b$var$BulkError).from($7399f652bbd3211b$var$DexieError);
var $7399f652bbd3211b$var$errnames = $7399f652bbd3211b$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $7399f652bbd3211b$var$BaseException = $7399f652bbd3211b$var$DexieError;
var $7399f652bbd3211b$var$exceptions = $7399f652bbd3211b$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $7399f652bbd3211b$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $7399f652bbd3211b$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $7399f652bbd3211b$var$derive(DexieError).from($7399f652bbd3211b$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$7399f652bbd3211b$var$exceptions.Syntax = SyntaxError;
$7399f652bbd3211b$var$exceptions.Type = TypeError;
$7399f652bbd3211b$var$exceptions.Range = RangeError;
var $7399f652bbd3211b$var$exceptionMap = $7399f652bbd3211b$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $7399f652bbd3211b$var$exceptions[name];
    return obj;
}, {});
function $7399f652bbd3211b$var$mapError(domError, message) {
    if (!domError || domError instanceof $7399f652bbd3211b$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$7399f652bbd3211b$var$exceptionMap[domError.name]) return domError;
    var rv = new $7399f652bbd3211b$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $7399f652bbd3211b$var$setProp(rv, "stack", {
        get: function get() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $7399f652bbd3211b$var$fullNameExceptions = $7399f652bbd3211b$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $7399f652bbd3211b$var$exceptions[name];
    return obj;
}, {});
$7399f652bbd3211b$var$fullNameExceptions.ModifyError = $7399f652bbd3211b$var$ModifyError;
$7399f652bbd3211b$var$fullNameExceptions.DexieError = $7399f652bbd3211b$var$DexieError;
$7399f652bbd3211b$var$fullNameExceptions.BulkError = $7399f652bbd3211b$var$BulkError;
function $7399f652bbd3211b$var$nop() {}
function $7399f652bbd3211b$var$mirror(val) {
    return val;
}
function $7399f652bbd3211b$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $7399f652bbd3211b$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $7399f652bbd3211b$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $7399f652bbd3211b$var$hookCreatingChain(f1, f2) {
    if (f1 === $7399f652bbd3211b$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $7399f652bbd3211b$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $7399f652bbd3211b$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $7399f652bbd3211b$var$hookDeletingChain(f1, f2) {
    if (f1 === $7399f652bbd3211b$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $7399f652bbd3211b$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $7399f652bbd3211b$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $7399f652bbd3211b$var$hookUpdatingChain(f1, f2) {
    if (f1 === $7399f652bbd3211b$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $7399f652bbd3211b$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $7399f652bbd3211b$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $7399f652bbd3211b$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $7399f652bbd3211b$var$extend(res, res2);
    };
}
function $7399f652bbd3211b$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $7399f652bbd3211b$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $7399f652bbd3211b$var$promisableChain(f1, f2) {
    if (f1 === $7399f652bbd3211b$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $7399f652bbd3211b$var$INTERNAL = {};
var $7399f652bbd3211b$var$LONG_STACKS_CLIP_LIMIT = 100, $7399f652bbd3211b$var$MAX_LONG_STACKS = 20, $7399f652bbd3211b$var$ZONE_ECHO_LIMIT = 100, $7399f652bbd3211b$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $7399f652bbd3211b$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $7399f652bbd3211b$var$getProto(nativeP),
        globalP
    ];
}(), $7399f652bbd3211b$var$resolvedNativePromise = $7399f652bbd3211b$var$_a$1[0], $7399f652bbd3211b$var$nativePromiseProto = $7399f652bbd3211b$var$_a$1[1], $7399f652bbd3211b$var$resolvedGlobalPromise = $7399f652bbd3211b$var$_a$1[2], $7399f652bbd3211b$var$nativePromiseThen = $7399f652bbd3211b$var$nativePromiseProto && $7399f652bbd3211b$var$nativePromiseProto.then;
var $7399f652bbd3211b$var$NativePromise = $7399f652bbd3211b$var$resolvedNativePromise && $7399f652bbd3211b$var$resolvedNativePromise.constructor;
var $7399f652bbd3211b$var$patchGlobalPromise = !!$7399f652bbd3211b$var$resolvedGlobalPromise;
var $7399f652bbd3211b$var$stack_being_generated = false;
var $7399f652bbd3211b$var$schedulePhysicalTick = $7399f652bbd3211b$var$resolvedGlobalPromise ? function schedulePhysicalTick() {
    $7399f652bbd3211b$var$resolvedGlobalPromise.then($7399f652bbd3211b$var$physicalTick);
} : $7399f652bbd3211b$var$_global.setImmediate ? setImmediate.bind(null, $7399f652bbd3211b$var$physicalTick) : $7399f652bbd3211b$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $7399f652bbd3211b$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($7399f652bbd3211b$var$physicalTick, 0);
};
var $7399f652bbd3211b$var$asap = function asap(callback, args) {
    $7399f652bbd3211b$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($7399f652bbd3211b$var$needsNewPhysicalTick) {
        $7399f652bbd3211b$var$schedulePhysicalTick();
        $7399f652bbd3211b$var$needsNewPhysicalTick = false;
    }
};
var $7399f652bbd3211b$var$isOutsideMicroTick = true, $7399f652bbd3211b$var$needsNewPhysicalTick = true, $7399f652bbd3211b$var$unhandledErrors = [], $7399f652bbd3211b$var$rejectingErrors = [], $7399f652bbd3211b$var$currentFulfiller = null, $7399f652bbd3211b$var$rejectionMapper = $7399f652bbd3211b$var$mirror;
var $7399f652bbd3211b$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $7399f652bbd3211b$var$globalError,
    pgp: false,
    env: {},
    finalize: function finalize() {
        this.unhandleds.forEach(function(uh) {
            try {
                $7399f652bbd3211b$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $7399f652bbd3211b$var$PSD = $7399f652bbd3211b$var$globalPSD;
var $7399f652bbd3211b$var$microtickQueue = [];
var $7399f652bbd3211b$var$numScheduledCalls = 0;
var $7399f652bbd3211b$var$tickFinalizers = [];
function $7399f652bbd3211b$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $7399f652bbd3211b$var$nop;
    this._lib = false;
    var psd = this._PSD = $7399f652bbd3211b$var$PSD;
    if ($7399f652bbd3211b$var$debug) {
        this._stackHolder = $7399f652bbd3211b$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $7399f652bbd3211b$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $7399f652bbd3211b$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $7399f652bbd3211b$var$executePromiseTask(this, fn);
}
var $7399f652bbd3211b$var$thenProp = {
    get: function get() {
        var psd = $7399f652bbd3211b$var$PSD, microTaskId = $7399f652bbd3211b$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $7399f652bbd3211b$var$PSD || microTaskId !== $7399f652bbd3211b$var$totalEchoes);
            var cleanup = possibleAwait && !$7399f652bbd3211b$var$decrementExpectedAwaits();
            var rv = new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
                $7399f652bbd3211b$var$propagateToListener(_this, new $7399f652bbd3211b$var$Listener($7399f652bbd3211b$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $7399f652bbd3211b$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $7399f652bbd3211b$var$debug && $7399f652bbd3211b$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $7399f652bbd3211b$var$INTERNAL;
        return then;
    },
    set: function set(value) {
        $7399f652bbd3211b$var$setProp(this, "then", value && value.prototype === $7399f652bbd3211b$var$INTERNAL ? $7399f652bbd3211b$var$thenProp : {
            get: function get() {
                return value;
            },
            set: $7399f652bbd3211b$var$thenProp.set
        });
    }
};
$7399f652bbd3211b$var$props($7399f652bbd3211b$var$DexiePromise.prototype, {
    then: $7399f652bbd3211b$var$thenProp,
    _then: function _then(onFulfilled, onRejected) {
        $7399f652bbd3211b$var$propagateToListener(this, new $7399f652bbd3211b$var$Listener(null, null, onFulfilled, onRejected, $7399f652bbd3211b$var$PSD));
    },
    "catch": function _catch(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $7399f652bbd3211b$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $7399f652bbd3211b$var$PromiseReject(err);
        });
    },
    "finally": function _finally(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $7399f652bbd3211b$var$PromiseReject(err);
        });
    },
    stack: {
        get: function get() {
            if (this._stack) return this._stack;
            try {
                $7399f652bbd3211b$var$stack_being_generated = true;
                var stacks = $7399f652bbd3211b$var$getStack(this, [], $7399f652bbd3211b$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $7399f652bbd3211b$var$stack_being_generated = false;
            }
        }
    },
    timeout: function timeout(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $7399f652bbd3211b$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject)["finally"](clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $7399f652bbd3211b$var$setProp($7399f652bbd3211b$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$7399f652bbd3211b$var$globalPSD.env = $7399f652bbd3211b$var$snapShot();
function $7399f652bbd3211b$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$7399f652bbd3211b$var$props($7399f652bbd3211b$var$DexiePromise, {
    all: function all() {
        var values = $7399f652bbd3211b$var$getArrayOf.apply(null, arguments).map($7399f652bbd3211b$var$onPossibleParallellAsync);
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $7399f652bbd3211b$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function resolve(value) {
        if (value instanceof $7399f652bbd3211b$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $7399f652bbd3211b$var$DexiePromise($7399f652bbd3211b$var$INTERNAL, true, value);
        $7399f652bbd3211b$var$linkToPreviousPromise(rv, $7399f652bbd3211b$var$currentFulfiller);
        return rv;
    },
    reject: $7399f652bbd3211b$var$PromiseReject,
    race: function race() {
        var values = $7399f652bbd3211b$var$getArrayOf.apply(null, arguments).map($7399f652bbd3211b$var$onPossibleParallellAsync);
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $7399f652bbd3211b$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function get() {
            return $7399f652bbd3211b$var$PSD;
        },
        set: function set(value) {
            return $7399f652bbd3211b$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function get() {
            return $7399f652bbd3211b$var$totalEchoes;
        }
    },
    newPSD: $7399f652bbd3211b$var$newScope,
    usePSD: $7399f652bbd3211b$var$usePSD,
    scheduler: {
        get: function get() {
            return $7399f652bbd3211b$var$asap;
        },
        set: function set(value) {
            $7399f652bbd3211b$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function get() {
            return $7399f652bbd3211b$var$rejectionMapper;
        },
        set: function set(value) {
            $7399f652bbd3211b$var$rejectionMapper = value;
        }
    },
    follow: function follow(fn, zoneProps) {
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            return $7399f652bbd3211b$var$newScope(function(resolve, reject) {
                var psd = $7399f652bbd3211b$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $7399f652bbd3211b$var$callBoth(function() {
                    var _this = this;
                    $7399f652bbd3211b$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($7399f652bbd3211b$var$NativePromise) {
    if ($7399f652bbd3211b$var$NativePromise.allSettled) $7399f652bbd3211b$var$setProp($7399f652bbd3211b$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $7399f652bbd3211b$var$getArrayOf.apply(null, arguments).map($7399f652bbd3211b$var$onPossibleParallellAsync);
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $7399f652bbd3211b$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($7399f652bbd3211b$var$NativePromise.any && typeof AggregateError !== "undefined") $7399f652bbd3211b$var$setProp($7399f652bbd3211b$var$DexiePromise, "any", function() {
        var possiblePromises = $7399f652bbd3211b$var$getArrayOf.apply(null, arguments).map($7399f652bbd3211b$var$onPossibleParallellAsync);
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $7399f652bbd3211b$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $7399f652bbd3211b$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $7399f652bbd3211b$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $7399f652bbd3211b$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $7399f652bbd3211b$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $7399f652bbd3211b$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $7399f652bbd3211b$var$endMicroTickScope();
        }, $7399f652bbd3211b$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $7399f652bbd3211b$var$handleRejection(promise, ex);
    }
}
function $7399f652bbd3211b$var$handleRejection(promise, reason) {
    $7399f652bbd3211b$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $7399f652bbd3211b$var$beginMicroTickScope();
    reason = $7399f652bbd3211b$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $7399f652bbd3211b$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $7399f652bbd3211b$var$tryCatch(function() {
        var origProp = $7399f652bbd3211b$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $7399f652bbd3211b$var$setProp(reason, "stack", {
            get: function get() {
                return $7399f652bbd3211b$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $7399f652bbd3211b$var$addPossiblyUnhandledError(promise);
    $7399f652bbd3211b$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $7399f652bbd3211b$var$endMicroTickScope();
}
function $7399f652bbd3211b$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$7399f652bbd3211b$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($7399f652bbd3211b$var$numScheduledCalls === 0) {
        ++$7399f652bbd3211b$var$numScheduledCalls;
        $7399f652bbd3211b$var$asap(function() {
            if (--$7399f652bbd3211b$var$numScheduledCalls === 0) $7399f652bbd3211b$var$finalizePhysicalTick();
        }, []);
    }
}
function $7399f652bbd3211b$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$7399f652bbd3211b$var$numScheduledCalls;
    $7399f652bbd3211b$var$asap($7399f652bbd3211b$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $7399f652bbd3211b$var$callListener(cb, promise, listener) {
    try {
        $7399f652bbd3211b$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($7399f652bbd3211b$var$rejectingErrors.length) $7399f652bbd3211b$var$rejectingErrors = [];
            ret = cb(value);
            if ($7399f652bbd3211b$var$rejectingErrors.indexOf(value) === -1) $7399f652bbd3211b$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $7399f652bbd3211b$var$currentFulfiller = null;
        if (--$7399f652bbd3211b$var$numScheduledCalls === 0) $7399f652bbd3211b$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $7399f652bbd3211b$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $7399f652bbd3211b$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($7399f652bbd3211b$var$debug) {
        stack = $7399f652bbd3211b$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $7399f652bbd3211b$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $7399f652bbd3211b$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $7399f652bbd3211b$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $7399f652bbd3211b$var$physicalTick() {
    $7399f652bbd3211b$var$beginMicroTickScope() && $7399f652bbd3211b$var$endMicroTickScope();
}
function $7399f652bbd3211b$var$beginMicroTickScope() {
    var wasRootExec = $7399f652bbd3211b$var$isOutsideMicroTick;
    $7399f652bbd3211b$var$isOutsideMicroTick = false;
    $7399f652bbd3211b$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $7399f652bbd3211b$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($7399f652bbd3211b$var$microtickQueue.length > 0){
        callbacks = $7399f652bbd3211b$var$microtickQueue;
        $7399f652bbd3211b$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($7399f652bbd3211b$var$microtickQueue.length > 0);
    $7399f652bbd3211b$var$isOutsideMicroTick = true;
    $7399f652bbd3211b$var$needsNewPhysicalTick = true;
}
function $7399f652bbd3211b$var$finalizePhysicalTick() {
    var unhandledErrs = $7399f652bbd3211b$var$unhandledErrors;
    $7399f652bbd3211b$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $7399f652bbd3211b$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $7399f652bbd3211b$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $7399f652bbd3211b$var$tickFinalizers.splice($7399f652bbd3211b$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $7399f652bbd3211b$var$tickFinalizers.push(finalizer);
    ++$7399f652bbd3211b$var$numScheduledCalls;
    $7399f652bbd3211b$var$asap(function() {
        if (--$7399f652bbd3211b$var$numScheduledCalls === 0) $7399f652bbd3211b$var$finalizePhysicalTick();
    }, []);
}
function $7399f652bbd3211b$var$addPossiblyUnhandledError(promise) {
    if (!$7399f652bbd3211b$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $7399f652bbd3211b$var$unhandledErrors.push(promise);
}
function $7399f652bbd3211b$var$markErrorAsHandled(promise) {
    var i = $7399f652bbd3211b$var$unhandledErrors.length;
    while(i)if ($7399f652bbd3211b$var$unhandledErrors[--i]._value === promise._value) {
        $7399f652bbd3211b$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $7399f652bbd3211b$var$PromiseReject(reason) {
    return new $7399f652bbd3211b$var$DexiePromise($7399f652bbd3211b$var$INTERNAL, false, reason);
}
function $7399f652bbd3211b$var$wrap(fn, errorCatcher) {
    var psd = $7399f652bbd3211b$var$PSD;
    return function() {
        var wasRootExec = $7399f652bbd3211b$var$beginMicroTickScope(), outerScope = $7399f652bbd3211b$var$PSD;
        try {
            $7399f652bbd3211b$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $7399f652bbd3211b$var$switchToZone(outerScope, false);
            if (wasRootExec) $7399f652bbd3211b$var$endMicroTickScope();
        }
    };
}
var $7399f652bbd3211b$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $7399f652bbd3211b$var$taskCounter = 0;
var $7399f652bbd3211b$var$zoneStack = [];
var $7399f652bbd3211b$var$zoneEchoes = 0;
var $7399f652bbd3211b$var$totalEchoes = 0;
var $7399f652bbd3211b$var$zone_id_counter = 0;
function $7399f652bbd3211b$var$newScope(fn, props, a1, a2) {
    var parent = $7399f652bbd3211b$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$7399f652bbd3211b$var$zone_id_counter;
    var globalEnv = $7399f652bbd3211b$var$globalPSD.env;
    psd.env = $7399f652bbd3211b$var$patchGlobalPromise ? {
        Promise: $7399f652bbd3211b$var$DexiePromise,
        PromiseProp: {
            value: $7399f652bbd3211b$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $7399f652bbd3211b$var$DexiePromise.all,
        race: $7399f652bbd3211b$var$DexiePromise.race,
        allSettled: $7399f652bbd3211b$var$DexiePromise.allSettled,
        any: $7399f652bbd3211b$var$DexiePromise.any,
        resolve: $7399f652bbd3211b$var$DexiePromise.resolve,
        reject: $7399f652bbd3211b$var$DexiePromise.reject,
        nthen: $7399f652bbd3211b$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $7399f652bbd3211b$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $7399f652bbd3211b$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $7399f652bbd3211b$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $7399f652bbd3211b$var$incrementExpectedAwaits() {
    if (!$7399f652bbd3211b$var$task.id) $7399f652bbd3211b$var$task.id = ++$7399f652bbd3211b$var$taskCounter;
    ++$7399f652bbd3211b$var$task.awaits;
    $7399f652bbd3211b$var$task.echoes += $7399f652bbd3211b$var$ZONE_ECHO_LIMIT;
    return $7399f652bbd3211b$var$task.id;
}
function $7399f652bbd3211b$var$decrementExpectedAwaits() {
    if (!$7399f652bbd3211b$var$task.awaits) return false;
    if (--$7399f652bbd3211b$var$task.awaits === 0) $7399f652bbd3211b$var$task.id = 0;
    $7399f652bbd3211b$var$task.echoes = $7399f652bbd3211b$var$task.awaits * $7399f652bbd3211b$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $7399f652bbd3211b$var$nativePromiseThen).indexOf("[native code]") === -1) $7399f652bbd3211b$var$incrementExpectedAwaits = $7399f652bbd3211b$var$decrementExpectedAwaits = $7399f652bbd3211b$var$nop;
function $7399f652bbd3211b$var$onPossibleParallellAsync(possiblePromise) {
    if ($7399f652bbd3211b$var$task.echoes && possiblePromise && possiblePromise.constructor === $7399f652bbd3211b$var$NativePromise) {
        $7399f652bbd3211b$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $7399f652bbd3211b$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $7399f652bbd3211b$var$decrementExpectedAwaits();
            return $7399f652bbd3211b$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $7399f652bbd3211b$var$zoneEnterEcho(targetZone) {
    ++$7399f652bbd3211b$var$totalEchoes;
    if (!$7399f652bbd3211b$var$task.echoes || --$7399f652bbd3211b$var$task.echoes === 0) $7399f652bbd3211b$var$task.echoes = $7399f652bbd3211b$var$task.id = 0;
    $7399f652bbd3211b$var$zoneStack.push($7399f652bbd3211b$var$PSD);
    $7399f652bbd3211b$var$switchToZone(targetZone, true);
}
function $7399f652bbd3211b$var$zoneLeaveEcho() {
    var zone = $7399f652bbd3211b$var$zoneStack[$7399f652bbd3211b$var$zoneStack.length - 1];
    $7399f652bbd3211b$var$zoneStack.pop();
    $7399f652bbd3211b$var$switchToZone(zone, false);
}
function $7399f652bbd3211b$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $7399f652bbd3211b$var$PSD;
    if (bEnteringZone ? $7399f652bbd3211b$var$task.echoes && (!$7399f652bbd3211b$var$zoneEchoes++ || targetZone !== $7399f652bbd3211b$var$PSD) : $7399f652bbd3211b$var$zoneEchoes && (!--$7399f652bbd3211b$var$zoneEchoes || targetZone !== $7399f652bbd3211b$var$PSD)) $7399f652bbd3211b$var$enqueueNativeMicroTask(bEnteringZone ? $7399f652bbd3211b$var$zoneEnterEcho.bind(null, targetZone) : $7399f652bbd3211b$var$zoneLeaveEcho);
    if (targetZone === $7399f652bbd3211b$var$PSD) return;
    $7399f652bbd3211b$var$PSD = targetZone;
    if (currentZone === $7399f652bbd3211b$var$globalPSD) $7399f652bbd3211b$var$globalPSD.env = $7399f652bbd3211b$var$snapShot();
    if ($7399f652bbd3211b$var$patchGlobalPromise) {
        var GlobalPromise_1 = $7399f652bbd3211b$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $7399f652bbd3211b$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($7399f652bbd3211b$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $7399f652bbd3211b$var$snapShot() {
    var GlobalPromise = $7399f652bbd3211b$var$_global.Promise;
    return $7399f652bbd3211b$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($7399f652bbd3211b$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $7399f652bbd3211b$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $7399f652bbd3211b$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $7399f652bbd3211b$var$PSD;
    try {
        $7399f652bbd3211b$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $7399f652bbd3211b$var$switchToZone(outerScope, false);
    }
}
function $7399f652bbd3211b$var$enqueueNativeMicroTask(job) {
    $7399f652bbd3211b$var$nativePromiseThen.call($7399f652bbd3211b$var$resolvedNativePromise, job);
}
function $7399f652bbd3211b$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $7399f652bbd3211b$var$PSD;
        if (possibleAwait) $7399f652bbd3211b$var$incrementExpectedAwaits();
        $7399f652bbd3211b$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $7399f652bbd3211b$var$switchToZone(outerZone, false);
            if (cleanup) $7399f652bbd3211b$var$enqueueNativeMicroTask($7399f652bbd3211b$var$decrementExpectedAwaits);
        }
    };
}
function $7399f652bbd3211b$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $7399f652bbd3211b$var$nativeAwaitCompatibleWrap(onResolved, zone), $7399f652bbd3211b$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $7399f652bbd3211b$var$UNHANDLEDREJECTION = "unhandledrejection";
function $7399f652bbd3211b$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($7399f652bbd3211b$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($7399f652bbd3211b$var$UNHANDLEDREJECTION, true, true);
            $7399f652bbd3211b$var$extend(event, eventData);
        } else if ($7399f652bbd3211b$var$_global.CustomEvent) {
            event = new CustomEvent($7399f652bbd3211b$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $7399f652bbd3211b$var$extend(event, eventData);
        }
        if (event && $7399f652bbd3211b$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$7399f652bbd3211b$var$_global.PromiseRejectionEvent && $7399f652bbd3211b$var$_global.onunhandledrejection) try {
                $7399f652bbd3211b$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($7399f652bbd3211b$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $7399f652bbd3211b$var$rejection = $7399f652bbd3211b$var$DexiePromise.reject;
function $7399f652bbd3211b$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$7399f652bbd3211b$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.DatabaseClosed());
            db.open()["catch"]($7399f652bbd3211b$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $7399f652bbd3211b$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $7399f652bbd3211b$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $7399f652bbd3211b$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $7399f652bbd3211b$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $7399f652bbd3211b$var$newScope(function() {
                $7399f652bbd3211b$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $7399f652bbd3211b$var$DEXIE_VERSION = "3.2.4";
var $7399f652bbd3211b$var$maxString = String.fromCharCode(65535);
var $7399f652bbd3211b$var$minKey = -Infinity;
var $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $7399f652bbd3211b$var$STRING_EXPECTED = "String expected.";
var $7399f652bbd3211b$var$connections = [];
var $7399f652bbd3211b$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $7399f652bbd3211b$var$hasIEDeleteObjectStoreBug = $7399f652bbd3211b$var$isIEOrEdge;
var $7399f652bbd3211b$var$hangsOnDeleteLargeKeyRange = $7399f652bbd3211b$var$isIEOrEdge;
var $7399f652bbd3211b$var$dexieStackFrameFilter = function dexieStackFrameFilter(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $7399f652bbd3211b$var$DBNAMES_DB = "__dbnames";
var $7399f652bbd3211b$var$READONLY = "readonly";
var $7399f652bbd3211b$var$READWRITE = "readwrite";
function $7399f652bbd3211b$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $7399f652bbd3211b$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $7399f652bbd3211b$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $7399f652bbd3211b$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $7399f652bbd3211b$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $7399f652bbd3211b$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $7399f652bbd3211b$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $7399f652bbd3211b$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $7399f652bbd3211b$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $7399f652bbd3211b$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $7399f652bbd3211b$var$PSD.transless || $7399f652bbd3211b$var$PSD
            }) : $7399f652bbd3211b$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $7399f652bbd3211b$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($7399f652bbd3211b$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $7399f652bbd3211b$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            return ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            }) && ix.keyPath.every(function(keyPath) {
                return keyPaths.indexOf(keyPath) >= 0;
            });
        })[0];
        if (compoundIndex && this.db._maxKey !== $7399f652bbd3211b$var$maxString) return this.where(compoundIndex.name).equals(compoundIndex.keyPath.map(function(kp) {
            return indexOrCrit[kp];
        }));
        if (!compoundIndex && $7399f652bbd3211b$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $7399f652bbd3211b$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $7399f652bbd3211b$var$getByKeyPath(x, keyPath);
                    return $7399f652bbd3211b$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $7399f652bbd3211b$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $7399f652bbd3211b$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function readHook(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($7399f652bbd3211b$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $7399f652bbd3211b$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $7399f652bbd3211b$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $7399f652bbd3211b$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $7399f652bbd3211b$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$7399f652bbd3211b$var$isArray(keyOrObject)) {
            var key = $7399f652bbd3211b$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $7399f652bbd3211b$var$keys(modifications).forEach(function(keyPath) {
                    $7399f652bbd3211b$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $7399f652bbd3211b$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $7399f652bbd3211b$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $7399f652bbd3211b$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype["delete"] = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $7399f652bbd3211b$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $7399f652bbd3211b$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $7399f652bbd3211b$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($7399f652bbd3211b$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $7399f652bbd3211b$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($7399f652bbd3211b$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $7399f652bbd3211b$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $7399f652bbd3211b$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $7399f652bbd3211b$var$Events(ctx) {
    var evs = {};
    var rv = function rv(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $7399f652bbd3211b$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $7399f652bbd3211b$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function subscribe(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function unsubscribe(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $7399f652bbd3211b$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($7399f652bbd3211b$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $7399f652bbd3211b$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $7399f652bbd3211b$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $7399f652bbd3211b$var$makeClassConstructor(prototype, constructor) {
    $7399f652bbd3211b$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $7399f652bbd3211b$var$createTableConstructor(db) {
    return $7399f652bbd3211b$var$makeClassConstructor($7399f652bbd3211b$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $7399f652bbd3211b$var$Events(null, {
            creating: [
                $7399f652bbd3211b$var$hookCreatingChain,
                $7399f652bbd3211b$var$nop
            ],
            reading: [
                $7399f652bbd3211b$var$pureFunctionChain,
                $7399f652bbd3211b$var$mirror
            ],
            updating: [
                $7399f652bbd3211b$var$hookUpdatingChain,
                $7399f652bbd3211b$var$nop
            ],
            deleting: [
                $7399f652bbd3211b$var$hookDeletingChain,
                $7399f652bbd3211b$var$nop
            ]
        });
    });
}
function $7399f652bbd3211b$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $7399f652bbd3211b$var$addFilter(ctx, fn) {
    ctx.filter = $7399f652bbd3211b$var$combine(ctx.filter, fn);
}
function $7399f652bbd3211b$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $7399f652bbd3211b$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $7399f652bbd3211b$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $7399f652bbd3211b$var$combine(ctx.isMatch, fn);
}
function $7399f652bbd3211b$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $7399f652bbd3211b$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $7399f652bbd3211b$var$openCursor(ctx, coreTable, trans) {
    var index = $7399f652bbd3211b$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $7399f652bbd3211b$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $7399f652bbd3211b$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $7399f652bbd3211b$var$iterate($7399f652bbd3211b$var$openCursor(ctx, coreTable, coreTrans), $7399f652bbd3211b$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function union(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$7399f652bbd3211b$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $7399f652bbd3211b$var$iterate($7399f652bbd3211b$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $7399f652bbd3211b$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function mappedFn(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $7399f652bbd3211b$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function c() {
                return cursor["continue"]();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $7399f652bbd3211b$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $7399f652bbd3211b$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $7399f652bbd3211b$var$cmp(a, b) {
    try {
        var ta = $7399f652bbd3211b$var$type(a);
        var tb = $7399f652bbd3211b$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $7399f652bbd3211b$var$compareUint8Arrays($7399f652bbd3211b$var$getUint8Array(a), $7399f652bbd3211b$var$getUint8Array(b));
            case "Array":
                return $7399f652bbd3211b$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $7399f652bbd3211b$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $7399f652bbd3211b$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $7399f652bbd3211b$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $7399f652bbd3211b$var$type(x) {
    var t = typeof x === "undefined" ? "undefined" : (0, $7FyBz._)(x);
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $7399f652bbd3211b$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $7399f652bbd3211b$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $7399f652bbd3211b$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $7399f652bbd3211b$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $7399f652bbd3211b$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $7399f652bbd3211b$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $7399f652bbd3211b$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $7399f652bbd3211b$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $7399f652bbd3211b$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($7399f652bbd3211b$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $7399f652bbd3211b$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $7399f652bbd3211b$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $7399f652bbd3211b$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $7399f652bbd3211b$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $7399f652bbd3211b$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($7399f652bbd3211b$var$isPlainKeyRange(ctx)) $7399f652bbd3211b$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $7399f652bbd3211b$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $7399f652bbd3211b$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $7399f652bbd3211b$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $7399f652bbd3211b$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $7399f652bbd3211b$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $7399f652bbd3211b$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $7399f652bbd3211b$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $7399f652bbd3211b$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $7399f652bbd3211b$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $7399f652bbd3211b$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function modifyer(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($7399f652bbd3211b$var$getByKeyPath(item, keyPath) !== val) {
                            $7399f652bbd3211b$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function applyMutateResult(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $7399f652bbd3211b$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function nextChunk1(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $7399f652bbd3211b$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $7399f652bbd3211b$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $7399f652bbd3211b$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $7399f652bbd3211b$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $7399f652bbd3211b$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $7399f652bbd3211b$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype["delete"] = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($7399f652bbd3211b$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$7399f652bbd3211b$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $7399f652bbd3211b$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($7399f652bbd3211b$var$deleteCallback);
    };
    return Collection;
}();
var $7399f652bbd3211b$var$deleteCallback = function deleteCallback(value, ctx) {
    return ctx.value = null;
};
function $7399f652bbd3211b$var$createCollectionConstructor(db) {
    return $7399f652bbd3211b$var$makeClassConstructor($7399f652bbd3211b$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $7399f652bbd3211b$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $7399f652bbd3211b$var$mirror ? readingHook : null
        };
    });
}
function $7399f652bbd3211b$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $7399f652bbd3211b$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $7399f652bbd3211b$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $7399f652bbd3211b$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $7399f652bbd3211b$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $7399f652bbd3211b$var$rangeEqual("");
    }).limit(0);
}
function $7399f652bbd3211b$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $7399f652bbd3211b$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $7399f652bbd3211b$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $7399f652bbd3211b$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $7399f652bbd3211b$var$fail(whereClause, $7399f652bbd3211b$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $7399f652bbd3211b$var$upperFactory(dir);
        lower = $7399f652bbd3211b$var$lowerFactory(dir);
        compare = dir === "next" ? $7399f652bbd3211b$var$simpleCompare : $7399f652bbd3211b$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $7399f652bbd3211b$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $7399f652bbd3211b$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor["continue"](lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $7399f652bbd3211b$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $7399f652bbd3211b$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $7399f652bbd3211b$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function get() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $7399f652bbd3211b$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $7399f652bbd3211b$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $7399f652bbd3211b$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$STRING_EXPECTED);
        return this.between(str, str + $7399f652bbd3211b$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $7399f652bbd3211b$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $7399f652bbd3211b$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $7399f652bbd3211b$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $7399f652bbd3211b$var$getArrayOf.apply($7399f652bbd3211b$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $7399f652bbd3211b$var$emptyCollection(this);
        return $7399f652bbd3211b$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $7399f652bbd3211b$var$getArrayOf.apply($7399f652bbd3211b$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $7399f652bbd3211b$var$emptyCollection(this);
        return $7399f652bbd3211b$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $7399f652bbd3211b$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $7399f652bbd3211b$var$getArrayOf.apply($7399f652bbd3211b$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $7399f652bbd3211b$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor["continue"](set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $7399f652bbd3211b$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $7399f652bbd3211b$var$getArrayOf.apply($7399f652bbd3211b$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $7399f652bbd3211b$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var _$cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $7399f652bbd3211b$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $7399f652bbd3211b$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $7399f652bbd3211b$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (_$cmp(newRange[0], range[1]) < 0 && _$cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $7399f652bbd3211b$var$fail(this, $7399f652bbd3211b$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function keyIsBeyondCurrentEntry(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function keyIsBeforeCurrentEntry(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $7399f652bbd3211b$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor["continue"](set[rangePos][0]);
                    else cursor["continue"](set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $7399f652bbd3211b$var$getArrayOf.apply($7399f652bbd3211b$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $7399f652bbd3211b$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $7399f652bbd3211b$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $7399f652bbd3211b$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $7399f652bbd3211b$var$createWhereClauseConstructor(db) {
    return $7399f652bbd3211b$var$makeClassConstructor($7399f652bbd3211b$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $7399f652bbd3211b$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $7399f652bbd3211b$var$eventRejectHandler(reject) {
    return $7399f652bbd3211b$var$wrap(function(event) {
        $7399f652bbd3211b$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $7399f652bbd3211b$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $7399f652bbd3211b$var$globalEvents = $7399f652bbd3211b$var$Events(null, $7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $7399f652bbd3211b$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $7399f652bbd3211b$var$assert(!$7399f652bbd3211b$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$7399f652bbd3211b$var$PSD.global) $7399f652bbd3211b$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $7399f652bbd3211b$var$assert(!$7399f652bbd3211b$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$7399f652bbd3211b$var$PSD.global) $7399f652bbd3211b$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $7399f652bbd3211b$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $7399f652bbd3211b$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $7399f652bbd3211b$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $7399f652bbd3211b$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $7399f652bbd3211b$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $7399f652bbd3211b$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $7399f652bbd3211b$var$exceptions.TransactionInactive();
        $7399f652bbd3211b$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $7399f652bbd3211b$var$wrap(function(ev) {
            $7399f652bbd3211b$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $7399f652bbd3211b$var$wrap(function(ev) {
            $7399f652bbd3211b$var$preventDefault(ev);
            _this.active && _this._reject(new $7399f652bbd3211b$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $7399f652bbd3211b$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $7399f652bbd3211b$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.TransactionInactive());
        if (this._locked()) return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $7399f652bbd3211b$var$PSD
            ]);
        });
        else if (bWriteLock) return $7399f652bbd3211b$var$newScope(function() {
            var p = new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p["finally"](function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $7399f652bbd3211b$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($7399f652bbd3211b$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($7399f652bbd3211b$var$wrap(reject.bind(null, err)));
            })["finally"](function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $7399f652bbd3211b$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($7399f652bbd3211b$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $7399f652bbd3211b$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $7399f652bbd3211b$var$createTransactionConstructor(db) {
    return $7399f652bbd3211b$var$makeClassConstructor($7399f652bbd3211b$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $7399f652bbd3211b$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $7399f652bbd3211b$var$rejection(e);
        });
    });
}
function $7399f652bbd3211b$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $7399f652bbd3211b$var$nameFromKeyPath(keyPath)
    };
}
function $7399f652bbd3211b$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $7399f652bbd3211b$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $7399f652bbd3211b$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $7399f652bbd3211b$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $7399f652bbd3211b$var$getMaxKey = function getMaxKey1(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $7399f652bbd3211b$var$getMaxKey = function getMaxKey() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $7399f652bbd3211b$var$getMaxKey = function getMaxKey() {
            return $7399f652bbd3211b$var$maxString;
        };
        return $7399f652bbd3211b$var$maxString;
    }
};
function $7399f652bbd3211b$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $7399f652bbd3211b$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $7399f652bbd3211b$var$getByKeyPath(obj, keyPath);
    };
}
function $7399f652bbd3211b$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $7399f652bbd3211b$var$getByKeyPath(obj, keyPath);
    };
}
function $7399f652bbd3211b$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $7399f652bbd3211b$var$_id_counter = 0;
function $7399f652bbd3211b$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $7399f652bbd3211b$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $7399f652bbd3211b$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $7399f652bbd3211b$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $7399f652bbd3211b$var$getKeyExtractor(keyPath)
                        },
                        indexes: $7399f652bbd3211b$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $7399f652bbd3211b$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $7399f652bbd3211b$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$7399f652bbd3211b$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function getIndexByKeyPath(keyPath) {
                            return indexByKeyPath[$7399f652bbd3211b$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$7399f652bbd3211b$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $7399f652bbd3211b$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function errorHandler(event) {
                    ++numFailures;
                    $7399f652bbd3211b$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store["delete"](makeIDBKeyRange(range)));
                } else {
                    var _$_a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _$_a[0], args2 = _$_a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function done(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, _$query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $7399f652bbd3211b$var$wrap(resolve);
                var index = _$query.index, range = _$query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                req.onsuccess = $7399f652bbd3211b$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$7399f652bbd3211b$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor["continue"].bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function doThrowCursorIsNotStarted() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function doThrowCursorIsStopped() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor["continue"] = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $7399f652bbd3211b$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this["continue"]() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $7399f652bbd3211b$var$wrap(resolveIteration);
                            req.onerror = $7399f652bbd3211b$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor["continue"] = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function guardedCallback() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $7399f652bbd3211b$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor["continue"] = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $7399f652bbd3211b$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, _$query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = _$query.index, range = _$query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor["continue"]();
                        };
                        req_1.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function getMany(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $7399f652bbd3211b$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function successHandler(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $7399f652bbd3211b$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function get(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $7399f652bbd3211b$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function count(_a) {
                var _$query = _a.query, trans = _a.trans;
                var index = _$query.index, range = _$query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $7399f652bbd3211b$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function table(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $7399f652bbd3211b$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $7399f652bbd3211b$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $7399f652bbd3211b$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $7399f652bbd3211b$var$createMiddlewareStack($7399f652bbd3211b$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $7399f652bbd3211b$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $7399f652bbd3211b$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $7399f652bbd3211b$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $7399f652bbd3211b$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $7399f652bbd3211b$var$setProp(obj, tableName, {
                    get: function get() {
                        return this.table(tableName);
                    },
                    set: function set(value) {
                        $7399f652bbd3211b$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $7399f652bbd3211b$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $7399f652bbd3211b$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $7399f652bbd3211b$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion["catch"](reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $7399f652bbd3211b$var$PSD.transless || $7399f652bbd3211b$var$PSD;
    $7399f652bbd3211b$var$newScope(function() {
        $7399f652bbd3211b$var$PSD.trans = trans;
        $7399f652bbd3211b$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $7399f652bbd3211b$var$keys(globalSchema).forEach(function(tableName) {
                $7399f652bbd3211b$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $7399f652bbd3211b$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $7399f652bbd3211b$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            })["catch"](rejectTransaction);
        } else $7399f652bbd3211b$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans)["catch"](rejectTransaction);
    });
}
function $7399f652bbd3211b$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $7399f652bbd3211b$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $7399f652bbd3211b$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $7399f652bbd3211b$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $7399f652bbd3211b$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $7399f652bbd3211b$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $7399f652bbd3211b$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $7399f652bbd3211b$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $7399f652bbd3211b$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $7399f652bbd3211b$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $7399f652bbd3211b$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $7399f652bbd3211b$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $7399f652bbd3211b$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $7399f652bbd3211b$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $7399f652bbd3211b$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $7399f652bbd3211b$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $7399f652bbd3211b$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $7399f652bbd3211b$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $7399f652bbd3211b$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$7399f652bbd3211b$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $7399f652bbd3211b$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $7399f652bbd3211b$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $7399f652bbd3211b$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $7399f652bbd3211b$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $7399f652bbd3211b$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $7399f652bbd3211b$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $7399f652bbd3211b$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$7399f652bbd3211b$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $7399f652bbd3211b$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $7399f652bbd3211b$var$addIndex(store, idx);
    });
    return store;
}
function $7399f652bbd3211b$var$createMissingTables(newSchema, idbtrans) {
    $7399f652bbd3211b$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $7399f652bbd3211b$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $7399f652bbd3211b$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $7399f652bbd3211b$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $7399f652bbd3211b$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $7399f652bbd3211b$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $7399f652bbd3211b$var$createIndexSpec($7399f652bbd3211b$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $7399f652bbd3211b$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $7399f652bbd3211b$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $7399f652bbd3211b$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $7399f652bbd3211b$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $7399f652bbd3211b$var$slice(idbdb.objectStoreNames, 0);
    $7399f652bbd3211b$var$setApiOnPlace(db, [
        db._allTables
    ], $7399f652bbd3211b$var$keys(globalSchema), globalSchema);
}
function $7399f652bbd3211b$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $7399f652bbd3211b$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $7399f652bbd3211b$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $7399f652bbd3211b$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $7399f652bbd3211b$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $7399f652bbd3211b$var$_global.WorkerGlobalScope && $7399f652bbd3211b$var$_global instanceof $7399f652bbd3211b$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $7399f652bbd3211b$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $7399f652bbd3211b$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $7399f652bbd3211b$var$isArray(keyPath), indexNum === 0);
    });
}
var $7399f652bbd3211b$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $7399f652bbd3211b$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $7399f652bbd3211b$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $7399f652bbd3211b$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $7399f652bbd3211b$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $7399f652bbd3211b$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $7399f652bbd3211b$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $7399f652bbd3211b$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $7399f652bbd3211b$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $7399f652bbd3211b$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $7399f652bbd3211b$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $7399f652bbd3211b$var$keys(dbschema), dbschema);
        db._storeNames = $7399f652bbd3211b$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $7399f652bbd3211b$var$promisableChain(this._cfg.contentUpgrade || $7399f652bbd3211b$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $7399f652bbd3211b$var$createVersionConstructor(db) {
    return $7399f652bbd3211b$var$makeClassConstructor($7399f652bbd3211b$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $7399f652bbd3211b$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $7399f652bbd3211b$export$4ece27d405df7279($7399f652bbd3211b$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $7399f652bbd3211b$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $7399f652bbd3211b$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $7399f652bbd3211b$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $7399f652bbd3211b$var$DBNAMES_DB;
        });
    }) : $7399f652bbd3211b$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $7399f652bbd3211b$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$7399f652bbd3211b$var$hasDatabasesNative(indexedDB1) && name !== $7399f652bbd3211b$var$DBNAMES_DB && $7399f652bbd3211b$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    })["catch"]($7399f652bbd3211b$var$nop);
}
function $7399f652bbd3211b$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$7399f652bbd3211b$var$hasDatabasesNative(indexedDB1) && name !== $7399f652bbd3211b$var$DBNAMES_DB && $7399f652bbd3211b$var$getDbNamesTable(indexedDB1, IDBKeyRange)["delete"](name)["catch"]($7399f652bbd3211b$var$nop);
}
function $7399f652bbd3211b$var$vip(fn) {
    return $7399f652bbd3211b$var$newScope(function() {
        $7399f652bbd3211b$var$PSD.letThrough = true;
        return fn();
    });
}
function $7399f652bbd3211b$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function tryIdb() {
            return indexedDB.databases()["finally"](resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    })["finally"](function() {
        return clearInterval(intervalId);
    });
}
function $7399f652bbd3211b$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $7399f652bbd3211b$var$rejection(state.dbOpenError) : db;
    });
    $7399f652bbd3211b$var$debug && (state.openCanceller._stackHolder = $7399f652bbd3211b$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $7399f652bbd3211b$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    return $7399f652bbd3211b$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $7399f652bbd3211b$var$DexiePromise.resolve() : $7399f652bbd3211b$var$idbReady()).then(function() {
            return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
                throwIfCancelled();
                if (!indexedDB1) throw new $7399f652bbd3211b$var$exceptions.MissingAPI();
                var dbName = db.name;
                var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
                if (!req) throw new $7399f652bbd3211b$var$exceptions.MissingAPI();
                req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                req.onblocked = $7399f652bbd3211b$var$wrap(db._fireOnBlocked);
                req.onupgradeneeded = $7399f652bbd3211b$var$wrap(function(e) {
                    upgradeTransaction = req.transaction;
                    if (state.autoSchema && !db._options.allowEmptyDB) {
                        req.onerror = $7399f652bbd3211b$var$preventDefault;
                        upgradeTransaction.abort();
                        req.result.close();
                        var delreq = indexedDB1.deleteDatabase(dbName);
                        delreq.onsuccess = delreq.onerror = $7399f652bbd3211b$var$wrap(function() {
                            reject(new $7399f652bbd3211b$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                        });
                    } else {
                        upgradeTransaction.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                        var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                        wasCreated = oldVer < 1;
                        db._novip.idbdb = req.result;
                        $7399f652bbd3211b$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                    }
                }, reject);
                req.onsuccess = $7399f652bbd3211b$var$wrap(function() {
                    upgradeTransaction = null;
                    var idbdb = db._novip.idbdb = req.result;
                    var objectStoreNames = $7399f652bbd3211b$var$slice(idbdb.objectStoreNames);
                    if (objectStoreNames.length > 0) try {
                        var tmpTrans = idbdb.transaction($7399f652bbd3211b$var$safariMultiStoreFix(objectStoreNames), "readonly");
                        if (state.autoSchema) $7399f652bbd3211b$var$readGlobalSchema(db, idbdb, tmpTrans);
                        else {
                            $7399f652bbd3211b$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                            if (!$7399f652bbd3211b$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                        }
                        $7399f652bbd3211b$var$generateMiddlewareStacks(db, tmpTrans);
                    } catch (e) {}
                    $7399f652bbd3211b$var$connections.push(db);
                    idbdb.onversionchange = $7399f652bbd3211b$var$wrap(function(ev) {
                        state.vcFired = true;
                        db.on("versionchange").fire(ev);
                    });
                    idbdb.onclose = $7399f652bbd3211b$var$wrap(function(ev) {
                        db.on("close").fire(ev);
                    });
                    if (wasCreated) $7399f652bbd3211b$var$_onDatabaseCreated(db._deps, dbName);
                    resolve();
                }, reject);
            });
        })
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $7399f652bbd3211b$var$DexiePromise.resolve($7399f652bbd3211b$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($7399f652bbd3211b$var$promisableChain, $7399f652bbd3211b$var$nop);
                state.onReadyBeingFired = [];
                return $7399f652bbd3211b$var$DexiePromise.resolve($7399f652bbd3211b$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    })["finally"](function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    })["catch"](function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $7399f652bbd3211b$var$rejection(err);
    })["finally"](function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $7399f652bbd3211b$var$awaitIterator(iterator) {
    var callNext = function callNext(result) {
        return iterator.next(result);
    }, doThrow = function doThrow(error) {
        return iterator["throw"](error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $7399f652bbd3211b$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $7399f652bbd3211b$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $7399f652bbd3211b$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $7399f652bbd3211b$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $7399f652bbd3211b$var$DexiePromise.resolve().then(function() {
        var transless = $7399f652bbd3211b$var$PSD.transless || $7399f652bbd3211b$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $7399f652bbd3211b$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $7399f652bbd3211b$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $7399f652bbd3211b$var$rejection(ex);
        }
        var scopeFuncIsAsync = $7399f652bbd3211b$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $7399f652bbd3211b$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $7399f652bbd3211b$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $7399f652bbd3211b$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue["throw"] === "function") returnValue = $7399f652bbd3211b$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $7399f652bbd3211b$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        })["catch"](function(e) {
            trans._reject(e);
            return $7399f652bbd3211b$var$rejection(e);
        });
    });
}
function $7399f652bbd3211b$var$pad(a, value, count) {
    var result = $7399f652bbd3211b$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $7399f652bbd3211b$var$createVirtualIndexMiddleware(down) {
    return $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, down), {
        table: function table(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $7399f652bbd3211b$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $7399f652bbd3211b$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$7399f652bbd3211b$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $7399f652bbd3211b$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $7399f652bbd3211b$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, table), {
                schema: $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function count(req) {
                    return table.count(translateRequest(req));
                },
                query: function query(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function openCursor(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor["continue"]($7399f652bbd3211b$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor["continue"](cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor["continue"]();
                        }
                        var virtualCursor = Object.create(cursor, {
                            "continue": {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function value(key, primaryKey) {
                                    cursor.continuePrimaryKey($7399f652bbd3211b$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function get() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function get() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function get() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $7399f652bbd3211b$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $7399f652bbd3211b$var$createVirtualIndexMiddleware
};
function $7399f652bbd3211b$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $7399f652bbd3211b$var$keys(a).forEach(function(prop) {
        if (!$7399f652bbd3211b$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $7399f652bbd3211b$var$toStringTag(ap);
                var bpTypeName = $7399f652bbd3211b$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $7399f652bbd3211b$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $7399f652bbd3211b$var$keys(b).forEach(function(prop) {
        if (!$7399f652bbd3211b$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $7399f652bbd3211b$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $7399f652bbd3211b$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function create(downCore) {
        return $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, downCore), {
            table: function table(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, downTable), {
                    mutate: function mutate(req) {
                        var dxTrans = $7399f652bbd3211b$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $7399f652bbd3211b$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $7399f652bbd3211b$var$nop && updating.fire === $7399f652bbd3211b$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $7399f652bbd3211b$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $7399f652bbd3211b$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $7399f652bbd3211b$var$PSD.trans;
                            var keys = req.keys || $7399f652bbd3211b$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, req), {
                                keys: keys
                            }) : $7399f652bbd3211b$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $7399f652bbd3211b$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $7399f652bbd3211b$var$__spreadArray([], req.keys, true);
                            return $7399f652bbd3211b$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $7399f652bbd3211b$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $7399f652bbd3211b$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($7399f652bbd3211b$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $7399f652bbd3211b$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                })["catch"](function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $7399f652bbd3211b$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $7399f652bbd3211b$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($7399f652bbd3211b$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $7399f652bbd3211b$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $7399f652bbd3211b$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function create(core) {
        return {
            table: function table(tableName) {
                var table = core.table(tableName);
                return $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, table), {
                    getMany: function getMany(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $7399f652bbd3211b$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $7399f652bbd3211b$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $7399f652bbd3211b$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function mutate(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $7399f652bbd3211b$var$_a;
function $7399f652bbd3211b$var$isEmptyRange(node) {
    return !("from" in node);
}
var $7399f652bbd3211b$export$34cb5241245008dd = function RangeSet1(fromOrTree, to) {
    if (this) $7399f652bbd3211b$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $7399f652bbd3211b$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $7399f652bbd3211b$var$extend(rv, fromOrTree);
        return rv;
    }
};
$7399f652bbd3211b$var$props($7399f652bbd3211b$export$34cb5241245008dd.prototype, ($7399f652bbd3211b$var$_a = {
    add: function add(rangeSet) {
        $7399f652bbd3211b$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function addKey(key) {
        $7399f652bbd3211b$var$addRange(this, key, key);
        return this;
    },
    addKeys: function addKeys(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $7399f652bbd3211b$var$addRange(_this, key, key);
        });
        return this;
    }
}, $7399f652bbd3211b$var$_a[$7399f652bbd3211b$var$iteratorSymbol] = function() {
    return $7399f652bbd3211b$var$getRangeSetIterator(this);
}, $7399f652bbd3211b$var$_a));
function $7399f652bbd3211b$var$addRange(target, from, to) {
    var diff = $7399f652bbd3211b$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($7399f652bbd3211b$var$isEmptyRange(target)) return $7399f652bbd3211b$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($7399f652bbd3211b$var$cmp(to, target.from) < 0) {
        left ? $7399f652bbd3211b$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $7399f652bbd3211b$var$rebalance(target);
    }
    if ($7399f652bbd3211b$var$cmp(from, target.to) > 0) {
        right ? $7399f652bbd3211b$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $7399f652bbd3211b$var$rebalance(target);
    }
    if ($7399f652bbd3211b$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($7399f652bbd3211b$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $7399f652bbd3211b$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $7399f652bbd3211b$export$4876cc3130d3f820(target, right);
}
function $7399f652bbd3211b$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $7399f652bbd3211b$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$7399f652bbd3211b$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $7399f652bbd3211b$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $7399f652bbd3211b$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $7399f652bbd3211b$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($7399f652bbd3211b$var$cmp(b.from, a.to) <= 0 && $7399f652bbd3211b$var$cmp(b.to, a.from) >= 0) return true;
        $7399f652bbd3211b$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $7399f652bbd3211b$var$getRangeSetIterator(node) {
    var state = $7399f652bbd3211b$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function next(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $7399f652bbd3211b$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $7399f652bbd3211b$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $7399f652bbd3211b$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $7399f652bbd3211b$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $7399f652bbd3211b$var$computeDepth(rootClone);
    }
    target.d = $7399f652bbd3211b$var$computeDepth(target);
}
function $7399f652bbd3211b$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $7399f652bbd3211b$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function create(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $7399f652bbd3211b$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, core), {
            table: function table(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, table), {
                    mutate: function mutate(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function getRangeSet(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $7399f652bbd3211b$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($7399f652bbd3211b$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $7399f652bbd3211b$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $7399f652bbd3211b$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function getRange(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $7399f652bbd3211b$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function get(req) {
                        return [
                            primaryKey,
                            new $7399f652bbd3211b$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function getMany(req) {
                        return [
                            primaryKey,
                            new $7399f652bbd3211b$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $7399f652bbd3211b$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $7399f652bbd3211b$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function getRangeSet(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $7399f652bbd3211b$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function get() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function get() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function get() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $7399f652bbd3211b$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function addKeyOrKeys(key) {
            return ix.multiEntry && $7399f652bbd3211b$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($7399f652bbd3211b$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $7399f652bbd3211b$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $7399f652bbd3211b$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $7399f652bbd3211b$var$nop,
            dbReadyPromise: null,
            cancelOpen: $7399f652bbd3211b$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $7399f652bbd3211b$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $7399f652bbd3211b$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $7399f652bbd3211b$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $7399f652bbd3211b$var$promisableChain,
                $7399f652bbd3211b$var$nop
            ]
        });
        this.on.ready.subscribe = $7399f652bbd3211b$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $7399f652bbd3211b$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $7399f652bbd3211b$var$createCollectionConstructor(this);
        this.Table = $7399f652bbd3211b$var$createTableConstructor(this);
        this.Transaction = $7399f652bbd3211b$var$createTransactionConstructor(this);
        this.Version = $7399f652bbd3211b$var$createVersionConstructor(this);
        this.WhereClause = $7399f652bbd3211b$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $7399f652bbd3211b$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $7399f652bbd3211b$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($7399f652bbd3211b$var$virtualIndexMiddleware);
        this.use($7399f652bbd3211b$var$hooksMiddleware);
        this.use($7399f652bbd3211b$var$observabilityMiddleware);
        this.use($7399f652bbd3211b$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $7399f652bbd3211b$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $7399f652bbd3211b$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($7399f652bbd3211b$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $7399f652bbd3211b$var$PSD.letThrough || this._vip) ? fn() : new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $7399f652bbd3211b$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $7399f652bbd3211b$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open()["catch"]($7399f652bbd3211b$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $7399f652bbd3211b$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $7399f652bbd3211b$var$connections.indexOf(this);
        if (idx >= 0) $7399f652bbd3211b$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $7399f652bbd3211b$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $7399f652bbd3211b$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $7399f652bbd3211b$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype["delete"] = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $7399f652bbd3211b$var$DexiePromise(function(resolve, reject) {
            var doDelete = function doDelete() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $7399f652bbd3211b$var$wrap(function() {
                    $7399f652bbd3211b$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $7399f652bbd3211b$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function get() {
            var _this = this;
            return $7399f652bbd3211b$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $7399f652bbd3211b$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $7399f652bbd3211b$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $7399f652bbd3211b$var$READONLY) idbMode = $7399f652bbd3211b$var$READONLY;
            else if (mode == "rw" || mode == $7399f652bbd3211b$var$READWRITE) idbMode = $7399f652bbd3211b$var$READWRITE;
            else throw new $7399f652bbd3211b$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $7399f652bbd3211b$var$READONLY && idbMode === $7399f652bbd3211b$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $7399f652bbd3211b$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $7399f652bbd3211b$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $7399f652bbd3211b$var$rejection(e);
        }
        var enterTransaction = $7399f652bbd3211b$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $7399f652bbd3211b$var$PSD.trans ? $7399f652bbd3211b$var$usePSD($7399f652bbd3211b$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$7399f652bbd3211b$var$hasOwn(this._allTables, tableName)) throw new $7399f652bbd3211b$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $7399f652bbd3211b$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $7399f652bbd3211b$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$7399f652bbd3211b$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $7399f652bbd3211b$var$extendObservabilitySet(target, newSet) {
    $7399f652bbd3211b$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $7399f652bbd3211b$export$34cb5241245008dd());
        $7399f652bbd3211b$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $7399f652bbd3211b$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $7399f652bbd3211b$var$Observable(function(observer) {
        var scopeFuncIsAsync = $7399f652bbd3211b$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $7399f652bbd3211b$var$incrementExpectedAwaits();
            var exec = function exec() {
                return $7399f652bbd3211b$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $7399f652bbd3211b$var$PSD.trans ? $7399f652bbd3211b$var$usePSD($7399f652bbd3211b$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($7399f652bbd3211b$var$decrementExpectedAwaits, $7399f652bbd3211b$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function unsubscribe() {
                closed = true;
                $7399f652bbd3211b$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $7399f652bbd3211b$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $7399f652bbd3211b$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function mutationListener(parts) {
            $7399f652bbd3211b$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function doQuery1() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $7399f652bbd3211b$var$globalEvents($7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $7399f652bbd3211b$var$domDeps;
try {
    $7399f652bbd3211b$var$domDeps = {
        indexedDB: $7399f652bbd3211b$var$_global.indexedDB || $7399f652bbd3211b$var$_global.mozIndexedDB || $7399f652bbd3211b$var$_global.webkitIndexedDB || $7399f652bbd3211b$var$_global.msIndexedDB,
        IDBKeyRange: $7399f652bbd3211b$var$_global.IDBKeyRange || $7399f652bbd3211b$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $7399f652bbd3211b$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $7399f652bbd3211b$var$Dexie = $7399f652bbd3211b$export$4ece27d405df7279;
$7399f652bbd3211b$var$props($7399f652bbd3211b$var$Dexie, $7399f652bbd3211b$var$__assign($7399f652bbd3211b$var$__assign({}, $7399f652bbd3211b$var$fullNameExceptions), {
    "delete": function _delete(databaseName) {
        var db = new $7399f652bbd3211b$var$Dexie(databaseName, {
            addons: []
        });
        return db["delete"]();
    },
    exists: function exists(name) {
        return new $7399f652bbd3211b$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        })["catch"]("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function getDatabaseNames1(cb) {
        try {
            return $7399f652bbd3211b$var$getDatabaseNames($7399f652bbd3211b$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $7399f652bbd3211b$var$rejection(new $7399f652bbd3211b$var$exceptions.MissingAPI());
        }
    },
    defineClass: function defineClass() {
        function Class(content) {
            $7399f652bbd3211b$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function ignoreTransaction(scopeFunc) {
        return $7399f652bbd3211b$var$PSD.trans ? $7399f652bbd3211b$var$usePSD($7399f652bbd3211b$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $7399f652bbd3211b$var$vip,
    async: function async(generatorFn) {
        return function() {
            try {
                var rv = $7399f652bbd3211b$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $7399f652bbd3211b$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $7399f652bbd3211b$var$rejection(e);
            }
        };
    },
    spawn: function spawn(generatorFn, args, thiz) {
        try {
            var rv = $7399f652bbd3211b$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $7399f652bbd3211b$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $7399f652bbd3211b$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function get() {
            return $7399f652bbd3211b$var$PSD.trans || null;
        }
    },
    waitFor: function waitFor(promiseOrFunction, optionalTimeout) {
        var promise = $7399f652bbd3211b$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $7399f652bbd3211b$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $7399f652bbd3211b$var$PSD.trans ? $7399f652bbd3211b$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $7399f652bbd3211b$var$DexiePromise,
    debug: {
        get: function get() {
            return $7399f652bbd3211b$var$debug;
        },
        set: function set(value) {
            $7399f652bbd3211b$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $7399f652bbd3211b$var$dexieStackFrameFilter);
        }
    },
    derive: $7399f652bbd3211b$var$derive,
    extend: $7399f652bbd3211b$var$extend,
    props: $7399f652bbd3211b$var$props,
    override: $7399f652bbd3211b$var$override,
    Events: $7399f652bbd3211b$var$Events,
    on: $7399f652bbd3211b$var$globalEvents,
    liveQuery: $7399f652bbd3211b$export$6a9705d8f6f38796,
    extendObservabilitySet: $7399f652bbd3211b$var$extendObservabilitySet,
    getByKeyPath: $7399f652bbd3211b$var$getByKeyPath,
    setByKeyPath: $7399f652bbd3211b$var$setByKeyPath,
    delByKeyPath: $7399f652bbd3211b$var$delByKeyPath,
    shallowClone: $7399f652bbd3211b$var$shallowClone,
    deepClone: $7399f652bbd3211b$var$deepClone,
    getObjectDiff: $7399f652bbd3211b$var$getObjectDiff,
    cmp: $7399f652bbd3211b$var$cmp,
    asap: $7399f652bbd3211b$var$asap$1,
    minKey: $7399f652bbd3211b$var$minKey,
    addons: [],
    connections: $7399f652bbd3211b$var$connections,
    errnames: $7399f652bbd3211b$var$errnames,
    dependencies: $7399f652bbd3211b$var$domDeps,
    semVer: $7399f652bbd3211b$var$DEXIE_VERSION,
    version: $7399f652bbd3211b$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$7399f652bbd3211b$var$Dexie.maxKey = $7399f652bbd3211b$var$getMaxKey($7399f652bbd3211b$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $7399f652bbd3211b$var$globalEvents($7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$7399f652bbd3211b$var$propagatingLocally) {
            var event_1;
            if ($7399f652bbd3211b$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $7399f652bbd3211b$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $7399f652bbd3211b$var$propagatingLocally = false;
        }
    });
    addEventListener($7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$7399f652bbd3211b$var$propagatingLocally) $7399f652bbd3211b$var$propagateLocally(detail);
    });
}
function $7399f652bbd3211b$var$propagateLocally(updateParts) {
    var wasMe = $7399f652bbd3211b$var$propagatingLocally;
    try {
        $7399f652bbd3211b$var$propagatingLocally = true;
        $7399f652bbd3211b$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $7399f652bbd3211b$var$propagatingLocally = wasMe;
    }
}
var $7399f652bbd3211b$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $7399f652bbd3211b$var$bc_1 = new BroadcastChannel($7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $7399f652bbd3211b$var$bc_1.unref === "function") $7399f652bbd3211b$var$bc_1.unref();
    $7399f652bbd3211b$var$globalEvents($7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$7399f652bbd3211b$var$propagatingLocally) $7399f652bbd3211b$var$bc_1.postMessage(changedParts);
    });
    $7399f652bbd3211b$var$bc_1.onmessage = function(ev) {
        if (ev.data) $7399f652bbd3211b$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $7399f652bbd3211b$var$globalEvents($7399f652bbd3211b$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$7399f652bbd3211b$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $7399f652bbd3211b$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $7399f652bbd3211b$var$propagateLocally(data.changedParts);
        }
    });
    var $7399f652bbd3211b$var$swContainer = self.document && navigator.serviceWorker;
    if ($7399f652bbd3211b$var$swContainer) $7399f652bbd3211b$var$swContainer.addEventListener("message", $7399f652bbd3211b$var$propagateMessageLocally);
}
function $7399f652bbd3211b$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $7399f652bbd3211b$var$STORAGE_MUTATED_DOM_EVENT_NAME) $7399f652bbd3211b$var$propagateLocally(data.changedParts);
}
$7399f652bbd3211b$var$DexiePromise.rejectionMapper = $7399f652bbd3211b$var$mapError;
$7399f652bbd3211b$var$setDebug($7399f652bbd3211b$var$debug, $7399f652bbd3211b$var$dexieStackFrameFilter);

});

var $79ec79cf06303d09$exports = {};
"use strict";

$79ec79cf06303d09$exports = (parcelRequire("2GWz0"));



var $8SyCD = parcelRequire("8SyCD");
var $09dc9bbe6193c50d$export$882461b6382ed46c;
var $09dc9bbe6193c50d$export$757ceba2d55c277e;
"use strict";
var $b4e4ce7bd3c993b9$exports = {};
"use strict";
function $b4e4ce7bd3c993b9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4e4ce7bd3c993b9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4e4ce7bd3c993b9$var$checkDCE();

$b4e4ce7bd3c993b9$exports = (parcelRequire("gcIpL"));


var $09dc9bbe6193c50d$var$i;
$09dc9bbe6193c50d$export$882461b6382ed46c = $b4e4ce7bd3c993b9$exports.createRoot;
$09dc9bbe6193c50d$export$757ceba2d55c277e = $b4e4ce7bd3c993b9$exports.hydrateRoot;



parcelRequire("8SyCD");
/**
 * React Router DOM v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $14480b1fff30b85c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14480b1fff30b85c$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14480b1fff30b85c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14480b1fff30b85c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $1196a0d52e0d4b84$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $e27df26376ee47c8$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $066d6dac5b762181$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $91ba7fda5158b7f7$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d96d9f5229f262d2$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $dbe29b95089823d0$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $d96d9f5229f262d2$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $d96d9f5229f262d2$export$79e617b1955a2616)(o, minLen);
}


function $d7028e800eea0566$export$fdf2a89c76341bbf(arr, i) {
    return (0, $e27df26376ee47c8$export$e6256bf45c68d561)(arr) || (0, $066d6dac5b762181$export$2fd15edff6687200)(arr, i) || (0, $dbe29b95089823d0$export$a5be06335b3a083c)(arr, i) || (0, $91ba7fda5158b7f7$export$60dbc22abd7da546)();
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $7FyBz = parcelRequire("7FyBz");
var $1e21d28140546eff$var$extendStatics = function extendStatics1(d, b) {
    $1e21d28140546eff$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e21d28140546eff$var$extendStatics(d, b);
};
function $1e21d28140546eff$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e21d28140546eff$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e21d28140546eff$export$18ce0697a983be9b = function __assign1() {
    $1e21d28140546eff$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e21d28140546eff$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e21d28140546eff$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e21d28140546eff$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e21d28140546eff$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e21d28140546eff$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e21d28140546eff$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e21d28140546eff$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7FyBz._)(x)) === "symbol" ? x : "".concat(x);
}
function $1e21d28140546eff$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7FyBz._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e21d28140546eff$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e21d28140546eff$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e21d28140546eff$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e21d28140546eff$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e21d28140546eff$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e21d28140546eff$export$45d3717a4c69092e(o, m, p);
}
function $1e21d28140546eff$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e21d28140546eff$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e21d28140546eff$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e21d28140546eff$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e21d28140546eff$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e21d28140546eff$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e21d28140546eff$export$10c90e4f7922046c(v) {
    return this instanceof $1e21d28140546eff$export$10c90e4f7922046c ? (this.v = v, this) : new $1e21d28140546eff$export$10c90e4f7922046c(v);
}
function $1e21d28140546eff$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e21d28140546eff$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e21d28140546eff$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e21d28140546eff$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e21d28140546eff$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e21d28140546eff$export$19a8beecd37a4c45 === "function" ? $1e21d28140546eff$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e21d28140546eff$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e21d28140546eff$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1e21d28140546eff$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1e21d28140546eff$export$45d3717a4c69092e(result, mod, k);
    }
    $1e21d28140546eff$var$__setModuleDefault(result, mod);
    return result;
}
function $1e21d28140546eff$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $1e21d28140546eff$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e21d28140546eff$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e21d28140546eff$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e21d28140546eff$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e21d28140546eff$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e21d28140546eff$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e21d28140546eff$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1e21d28140546eff$export$2e2bcd8739ae039 = {
    __extends: $1e21d28140546eff$export$a8ba968b8961cb8a,
    __assign: $1e21d28140546eff$export$18ce0697a983be9b,
    __rest: $1e21d28140546eff$export$3c9a16f847548506,
    __decorate: $1e21d28140546eff$export$29e00dfd3077644b,
    __param: $1e21d28140546eff$export$d5ad3fd78186038f,
    __metadata: $1e21d28140546eff$export$f1db080c865becb9,
    __awaiter: $1e21d28140546eff$export$1050f835b63b671e,
    __generator: $1e21d28140546eff$export$67ebef60e6f28a6,
    __createBinding: $1e21d28140546eff$export$45d3717a4c69092e,
    __exportStar: $1e21d28140546eff$export$f33643c0debef087,
    __values: $1e21d28140546eff$export$19a8beecd37a4c45,
    __read: $1e21d28140546eff$export$8d051b38c9118094,
    __spread: $1e21d28140546eff$export$afc72e2116322959,
    __spreadArrays: $1e21d28140546eff$export$6388937ca91ccae8,
    __spreadArray: $1e21d28140546eff$export$1216008129fb82ed,
    __await: $1e21d28140546eff$export$10c90e4f7922046c,
    __asyncGenerator: $1e21d28140546eff$export$e427f37a30a4de9b,
    __asyncDelegator: $1e21d28140546eff$export$bbd80228419bb833,
    __asyncValues: $1e21d28140546eff$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e21d28140546eff$export$4fb47efe1390b86f,
    __importStar: $1e21d28140546eff$export$c21735bcef00d192,
    __importDefault: $1e21d28140546eff$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e21d28140546eff$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e21d28140546eff$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e21d28140546eff$export$81fdc39f203e4e04,
    __addDisposableResource: $1e21d28140546eff$export$88ac25d8e944e405,
    __disposeResources: $1e21d28140546eff$export$8f076105dc360e92
};



var $8SyCD = parcelRequire("8SyCD");

/**
 * @remix-run/router v1.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

function $03c1c3c5357980fb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $03c1c3c5357980fb$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $03c1c3c5357980fb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $03c1c3c5357980fb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $60e59d78a798167e$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $704692afbed935f9$export$c2c98ac76e997b63(o, p) {
    $704692afbed935f9$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $704692afbed935f9$export$c2c98ac76e997b63(o, p);
}


function $45ac59093a09d67c$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $704692afbed935f9$export$c2c98ac76e997b63)(subClass, superClass);
}




function $374abfc95d2ca867$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}




function $c829f592a2a25626$export$e62c166da838fa3(arr) {
    return (0, $e27df26376ee47c8$export$e6256bf45c68d561)(arr) || (0, $374abfc95d2ca867$export$1eb58a6e75231000)(arr) || (0, $dbe29b95089823d0$export$a5be06335b3a083c)(arr) || (0, $91ba7fda5158b7f7$export$60dbc22abd7da546)();
}



function $c1eaaf6e7eac4d19$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $d96d9f5229f262d2$export$79e617b1955a2616)(arr);
}



function $3652b4c8a2db3c11$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $24d5e0e98ab2c79e$export$1b5e630bc3aea29f(arr) {
    return (0, $c1eaaf6e7eac4d19$export$7e0947b5ad3404e2)(arr) || (0, $374abfc95d2ca867$export$1eb58a6e75231000)(arr) || (0, $dbe29b95089823d0$export$a5be06335b3a083c)(arr) || (0, $3652b4c8a2db3c11$export$e6f3c4780d19eb2b)();
}


function $00b18b8cd7c209dd$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $974c98494df55f11$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $00b18b8cd7c209dd$export$685354647fba1516)()) $974c98494df55f11$export$2d841144c5f8c4ab = Reflect.construct;
    else $974c98494df55f11$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $704692afbed935f9$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $974c98494df55f11$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $310e41a7fbb8854b$export$f09211a7d3c496a1(o) {
    $310e41a7fbb8854b$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $310e41a7fbb8854b$export$f09211a7d3c496a1(o);
}


function $bf5809746802cc40$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $90a77dd41ef751d3$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $90a77dd41ef751d3$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $bf5809746802cc40$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $974c98494df55f11$export$2d841144c5f8c4ab)(Class, arguments, (0, $310e41a7fbb8854b$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $704692afbed935f9$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $90a77dd41ef751d3$export$2466d533fda16e33(Class);
}




function $85f9018b4c192026$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $7FyBz = parcelRequire("7FyBz");
function $0a704e302535ff3b$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $7FyBz._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $85f9018b4c192026$export$f3b8ed2e4a5d10b8)(self);
}


function $c73dafd5d42ceae5$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $00b18b8cd7c209dd$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $310e41a7fbb8854b$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $310e41a7fbb8854b$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $0a704e302535ff3b$export$ef97c660ca164e52)(this, result);
    };
}




function $407acd0611c09ae6$var$_extends() {
    $407acd0611c09ae6$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $407acd0611c09ae6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $407acd0611c09ae6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($407acd0611c09ae6$export$e19cd5f9376f8cee || ($407acd0611c09ae6$export$e19cd5f9376f8cee = {}));
var $407acd0611c09ae6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $407acd0611c09ae6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $407acd0611c09ae6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $407acd0611c09ae6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $407acd0611c09ae6$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $407acd0611c09ae6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $407acd0611c09ae6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $407acd0611c09ae6$export$fe53371bee54353d(to);
    }
    return $407acd0611c09ae6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $407acd0611c09ae6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $407acd0611c09ae6$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $407acd0611c09ae6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $407acd0611c09ae6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $407acd0611c09ae6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $407acd0611c09ae6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $407acd0611c09ae6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $407acd0611c09ae6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $407acd0611c09ae6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $407acd0611c09ae6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $407acd0611c09ae6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $407acd0611c09ae6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $407acd0611c09ae6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $407acd0611c09ae6$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $407acd0611c09ae6$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $407acd0611c09ae6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($407acd0611c09ae6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Push;
        var location = $407acd0611c09ae6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $407acd0611c09ae6$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace;
        var location = $407acd0611c09ae6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $407acd0611c09ae6$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $407acd0611c09ae6$export$fe53371bee54353d(to);
        $407acd0611c09ae6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($407acd0611c09ae6$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($407acd0611c09ae6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $407acd0611c09ae6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($407acd0611c09ae6$var$ResultType || ($407acd0611c09ae6$var$ResultType = {}));
var $407acd0611c09ae6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $407acd0611c09ae6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $407acd0611c09ae6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $407acd0611c09ae6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $407acd0611c09ae6$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($407acd0611c09ae6$var$isIndexRoute(route)) {
            var indexRoute = $407acd0611c09ae6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $407acd0611c09ae6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $407acd0611c09ae6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $407acd0611c09ae6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $407acd0611c09ae6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $407acd0611c09ae6$var$flattenRoutes(routes);
    $407acd0611c09ae6$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $407acd0611c09ae6$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $407acd0611c09ae6$var$safelyDecodeURI(pathname));
    return matches;
}
function $407acd0611c09ae6$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $407acd0611c09ae6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $407acd0611c09ae6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $407acd0611c09ae6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $407acd0611c09ae6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $407acd0611c09ae6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $407acd0611c09ae6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $407acd0611c09ae6$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $407acd0611c09ae6$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $c829f592a2a25626$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $407acd0611c09ae6$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $407acd0611c09ae6$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $407acd0611c09ae6$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $407acd0611c09ae6$var$paramRe = /^:\w+$/;
var $407acd0611c09ae6$var$dynamicSegmentValue = 3;
var $407acd0611c09ae6$var$indexRouteValue = 2;
var $407acd0611c09ae6$var$emptySegmentValue = 1;
var $407acd0611c09ae6$var$staticSegmentValue = 10;
var $407acd0611c09ae6$var$splatPenalty = -2;
var $407acd0611c09ae6$var$isSplat = function(s) {
    return s === "*";
};
function $407acd0611c09ae6$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($407acd0611c09ae6$var$isSplat)) initialScore += $407acd0611c09ae6$var$splatPenalty;
    if (index) initialScore += $407acd0611c09ae6$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$407acd0611c09ae6$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($407acd0611c09ae6$var$paramRe.test(segment) ? $407acd0611c09ae6$var$dynamicSegmentValue : segment === "" ? $407acd0611c09ae6$var$emptySegmentValue : $407acd0611c09ae6$var$staticSegmentValue);
    }, initialScore);
}
function $407acd0611c09ae6$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $407acd0611c09ae6$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $407acd0611c09ae6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $407acd0611c09ae6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $407acd0611c09ae6$export$a5c6d149b50c1d86($407acd0611c09ae6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $407acd0611c09ae6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $407acd0611c09ae6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $407acd0611c09ae6$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $407acd0611c09ae6$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $407acd0611c09ae6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($407acd0611c09ae6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $407acd0611c09ae6$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $407acd0611c09ae6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $407acd0611c09ae6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $407acd0611c09ae6$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $407acd0611c09ae6$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $407acd0611c09ae6$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $407acd0611c09ae6$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $407acd0611c09ae6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $407acd0611c09ae6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $407acd0611c09ae6$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $407acd0611c09ae6$var$normalizeSearch(search),
        hash: $407acd0611c09ae6$var$normalizeHash(hash)
    };
}
function $407acd0611c09ae6$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $407acd0611c09ae6$var$getInvalidPathError(_char, field, dest, path) {
    return "Cannot include a '" + _char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $407acd0611c09ae6$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $407acd0611c09ae6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $407acd0611c09ae6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $407acd0611c09ae6$var$_extends({}, toArg);
        $407acd0611c09ae6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $407acd0611c09ae6$var$getInvalidPathError("?", "pathname", "search", to));
        $407acd0611c09ae6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $407acd0611c09ae6$var$getInvalidPathError("#", "pathname", "hash", to));
        $407acd0611c09ae6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $407acd0611c09ae6$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        var fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments1 = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments1[0] === ".."){
                toSegments1.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments1.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $407acd0611c09ae6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $407acd0611c09ae6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $407acd0611c09ae6$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $407acd0611c09ae6$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $407acd0611c09ae6$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $407acd0611c09ae6$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $407acd0611c09ae6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $407acd0611c09ae6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $407acd0611c09ae6$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(AbortedDeferredError, Error1);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $90a77dd41ef751d3$export$2466d533fda16e33)(Error));
var $407acd0611c09ae6$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $407acd0611c09ae6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $407acd0611c09ae6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise["catch"](function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $407acd0611c09ae6$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet["delete"](key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers["delete"](fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet["delete"](k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $14480b1fff30b85c$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $407acd0611c09ae6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, key, $407acd0611c09ae6$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $407acd0611c09ae6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $407acd0611c09ae6$var$unwrapTrackedPromise(value) {
    if (!$407acd0611c09ae6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $407acd0611c09ae6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $407acd0611c09ae6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $407acd0611c09ae6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $407acd0611c09ae6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $407acd0611c09ae6$export$a6cd19cd1951a23c = function(url, init) {
    var response = $407acd0611c09ae6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $407acd0611c09ae6$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $407acd0611c09ae6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $407acd0611c09ae6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $407acd0611c09ae6$var$validMutationMethods = new Set($407acd0611c09ae6$var$validMutationMethodsArr);
var $407acd0611c09ae6$var$validRequestMethodsArr = [
    "get"
].concat((0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)($407acd0611c09ae6$var$validMutationMethodsArr));
var $407acd0611c09ae6$var$validRequestMethods = new Set($407acd0611c09ae6$var$validRequestMethodsArr);
var $407acd0611c09ae6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $407acd0611c09ae6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $407acd0611c09ae6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $407acd0611c09ae6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $407acd0611c09ae6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $407acd0611c09ae6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $407acd0611c09ae6$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $407acd0611c09ae6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $407acd0611c09ae6$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $407acd0611c09ae6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $407acd0611c09ae6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $407acd0611c09ae6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $407acd0611c09ae6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $407acd0611c09ae6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $407acd0611c09ae6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $407acd0611c09ae6$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $407acd0611c09ae6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $407acd0611c09ae6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $407acd0611c09ae6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $407acd0611c09ae6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $407acd0611c09ae6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($407acd0611c09ae6$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers["delete"](fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $407acd0611c09ae6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers["delete"](key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $407acd0611c09ae6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $407acd0611c09ae6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $407acd0611c09ae6$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $407acd0611c09ae6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $407acd0611c09ae6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($407acd0611c09ae6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $407acd0611c09ae6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $407acd0611c09ae6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $407acd0611c09ae6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $407acd0611c09ae6$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $407acd0611c09ae6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $407acd0611c09ae6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $407acd0611c09ae6$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $407acd0611c09ae6$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $407acd0611c09ae6$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $407acd0611c09ae6$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $407acd0611c09ae6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $407acd0611c09ae6$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $407acd0611c09ae6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, $407acd0611c09ae6$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $407acd0611c09ae6$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $407acd0611c09ae6$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $407acd0611c09ae6$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $407acd0611c09ae6$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $407acd0611c09ae6$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $407acd0611c09ae6$var$ResultType.error,
                            error: $407acd0611c09ae6$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $407acd0611c09ae6$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$407acd0611c09ae6$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($407acd0611c09ae6$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $407acd0611c09ae6$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $407acd0611c09ae6$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($407acd0611c09ae6$var$isDeferredResult(result)) throw $407acd0611c09ae6$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $407acd0611c09ae6$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $407acd0611c09ae6$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($407acd0611c09ae6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $407acd0611c09ae6$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $407acd0611c09ae6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($407acd0611c09ae6$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers["delete"](rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $407acd0611c09ae6$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $407acd0611c09ae6$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds["delete"](routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $407acd0611c09ae6$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $407acd0611c09ae6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $407acd0611c09ae6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $407acd0611c09ae6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $407acd0611c09ae6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $407acd0611c09ae6$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $407acd0611c09ae6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches["delete"](key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $407acd0611c09ae6$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $407acd0611c09ae6$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $407acd0611c09ae6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $407acd0611c09ae6$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                            return [
                                2
                            ];
                        }
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $407acd0611c09ae6$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if ($407acd0611c09ae6$var$isRedirectResult(actionResult)) {
                            fetchControllers["delete"](key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                // A new navigation was kicked off after our action started, so that
                                // should take precedence over this redirect navigation.  We already
                                // set isRevalidationRequired so all loaders for the new route should
                                // fire unless opted out via shouldRevalidate
                                updateFetcherState(key, $407acd0611c09ae6$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                updateFetcherState(key, $407acd0611c09ae6$var$getLoadingFetcher(submission));
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        fetcherSubmission: submission
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($407acd0611c09ae6$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($407acd0611c09ae6$var$isDeferredResult(actionResult)) throw $407acd0611c09ae6$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $407acd0611c09ae6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $407acd0611c09ae6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $407acd0611c09ae6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $407acd0611c09ae6$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($407acd0611c09ae6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $407acd0611c09ae6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds["delete"](key);
                        fetchControllers["delete"](key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers["delete"](r.key);
                        });
                        redirect = $407acd0611c09ae6$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $407acd0611c09ae6$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $407acd0611c09ae6$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $407acd0611c09ae6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $407acd0611c09ae6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, result;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $407acd0611c09ae6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $407acd0611c09ae6$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $407acd0611c09ae6$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$407acd0611c09ae6$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $407acd0611c09ae6$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $407acd0611c09ae6$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$407acd0611c09ae6$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $407acd0611c09ae6$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($407acd0611c09ae6$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $407acd0611c09ae6$export$3e9cee6b33872309(!$407acd0611c09ae6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $407acd0611c09ae6$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(state, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $407acd0611c09ae6$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $407acd0611c09ae6$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($407acd0611c09ae6$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $407acd0611c09ae6$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $407acd0611c09ae6$export$e19cd5f9376f8cee.Replace : $407acd0611c09ae6$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $407acd0611c09ae6$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($407acd0611c09ae6$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $407acd0611c09ae6$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $407acd0611c09ae6$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $407acd0611c09ae6$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $407acd0611c09ae6$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $407acd0611c09ae6$var$callLoaderOrAction("loader", $407acd0611c09ae6$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $407acd0611c09ae6$var$ResultType.error,
                                        error: $407acd0611c09ae6$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $407acd0611c09ae6$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $407acd0611c09ae6$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $407acd0611c09ae6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers["delete"](key);
        }
        return state.fetchers.get(key) || $407acd0611c09ae6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches["delete"](key);
        fetchReloadIds["delete"](key);
        fetchRedirectIds["delete"](key);
        deletedFetchers["delete"](key);
        state.fetchers["delete"](key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers["delete"](key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $407acd0611c09ae6$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers["delete"](key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $407acd0611c09ae6$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $407acd0611c09ae6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds["delete"](key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $407acd0611c09ae6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds["delete"](key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $407acd0611c09ae6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers["delete"](key);
        blockerFunctions["delete"](key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $407acd0611c09ae6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $407acd0611c09ae6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $407acd0611c09ae6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds["delete"](routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $407acd0611c09ae6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $407acd0611c09ae6$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $407acd0611c09ae6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $407acd0611c09ae6$export$4d0306f8f6a4585b = Symbol("deferred");
function $407acd0611c09ae6$export$3336b097a6fbc59a(routes, opts) {
    $407acd0611c09ae6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $407acd0611c09ae6$var$defaultMapRouteProperties;
    var dataRoutes = $407acd0611c09ae6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, _temp3) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp3 === void 0 ? {} : _temp3).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $407acd0611c09ae6$var$createLocation("", $407acd0611c09ae6$export$fe53371bee54353d(url), null, "default");
                        matches = $407acd0611c09ae6$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$407acd0611c09ae6$var$isValidMethod(method) && method !== "HEAD") {
                            error = $407acd0611c09ae6$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $407acd0611c09ae6$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $407acd0611c09ae6$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $407acd0611c09ae6$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($407acd0611c09ae6$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $407acd0611c09ae6$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $407acd0611c09ae6$var$createLocation("", $407acd0611c09ae6$export$fe53371bee54353d(url), null, "default");
                        matches = $407acd0611c09ae6$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$407acd0611c09ae6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $407acd0611c09ae6$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $407acd0611c09ae6$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $407acd0611c09ae6$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $407acd0611c09ae6$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $407acd0611c09ae6$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($407acd0611c09ae6$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$407acd0611c09ae6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $407acd0611c09ae6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$407acd0611c09ae6$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $407acd0611c09ae6$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $407acd0611c09ae6$var$isResponse(result1) ? result1 : $407acd0611c09ae6$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($407acd0611c09ae6$var$isQueryRouteResponse(e)) {
                            if (e.type === $407acd0611c09ae6$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($407acd0611c09ae6$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $407acd0611c09ae6$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $407acd0611c09ae6$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $407acd0611c09ae6$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        _state.label = 3;
                    case 3:
                        if ($407acd0611c09ae6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($407acd0611c09ae6$var$isDeferredResult(result)) {
                            error1 = $407acd0611c09ae6$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $407acd0611c09ae6$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($407acd0611c09ae6$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$407acd0611c09ae6$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $407acd0611c09ae6$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $407acd0611c09ae6$var$_extends({}, context, {
                                statusCode: $407acd0611c09ae6$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $407acd0611c09ae6$var$_extends({}, result.headers ? (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $407acd0611c09ae6$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                actionHeaders: $407acd0611c09ae6$var$_extends({}, result.headers ? (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $407acd0611c09ae6$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $407acd0611c09ae6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(matchesToLoad.map(function(match) {
                                return $407acd0611c09ae6$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $407acd0611c09ae6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $407acd0611c09ae6$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $407acd0611c09ae6$export$fec11da027c70692(routes, context, error) {
    var newContext = $407acd0611c09ae6$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $407acd0611c09ae6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $407acd0611c09ae6$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $407acd0611c09ae6$export$cae722b0cc860f13(to ? to : ".", $407acd0611c09ae6$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $407acd0611c09ae6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$407acd0611c09ae6$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $407acd0611c09ae6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $407acd0611c09ae6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $407acd0611c09ae6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$407acd0611c09ae6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$407acd0611c09ae6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $407acd0611c09ae6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $407acd0611c09ae6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $407acd0611c09ae6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$407acd0611c09ae6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$407acd0611c09ae6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $407acd0611c09ae6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $407acd0611c09ae6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $407acd0611c09ae6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $407acd0611c09ae6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $407acd0611c09ae6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($407acd0611c09ae6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $407acd0611c09ae6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $407acd0611c09ae6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $407acd0611c09ae6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $407acd0611c09ae6$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $407acd0611c09ae6$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $407acd0611c09ae6$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($407acd0611c09ae6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $407acd0611c09ae6$var$shouldRevalidateLoader(match, $407acd0611c09ae6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $407acd0611c09ae6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $407acd0611c09ae6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $407acd0611c09ae6$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $407acd0611c09ae6$var$shouldRevalidateLoader(fetcherMatch, $407acd0611c09ae6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $407acd0611c09ae6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $407acd0611c09ae6$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $407acd0611c09ae6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $407acd0611c09ae6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $407acd0611c09ae6$var$_loadLazyRouteModule.apply(this, arguments);
}
function $407acd0611c09ae6$var$_loadLazyRouteModule() {
    $407acd0611c09ae6$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $407acd0611c09ae6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $407acd0611c09ae6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$407acd0611c09ae6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $407acd0611c09ae6$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $407acd0611c09ae6$var$_loadLazyRouteModule.apply(this, arguments);
}
function $407acd0611c09ae6$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $407acd0611c09ae6$var$_callLoaderOrAction.apply(this, arguments);
}
function $407acd0611c09ae6$var$_callLoaderOrAction() {
    $407acd0611c09ae6$var$_callLoaderOrAction = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, _result$init, _result$init2;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler)["catch"](function(e) {
                                handlerError = e;
                            }),
                            $407acd0611c09ae6$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $407acd0611c09ae6$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $407acd0611c09ae6$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $407acd0611c09ae6$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $407acd0611c09ae6$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $407acd0611c09ae6$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $407acd0611c09ae6$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$407acd0611c09ae6$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($407acd0611c09ae6$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $407acd0611c09ae6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$407acd0611c09ae6$var$ABSOLUTE_URL_REGEX.test(location)) location = $407acd0611c09ae6$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $407acd0611c09ae6$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $407acd0611c09ae6$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $407acd0611c09ae6$var$ResultType.error ? $407acd0611c09ae6$var$ResultType.error : $407acd0611c09ae6$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $407acd0611c09ae6$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $407acd0611c09ae6$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $407acd0611c09ae6$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $407acd0611c09ae6$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($407acd0611c09ae6$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $407acd0611c09ae6$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $407acd0611c09ae6$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $407acd0611c09ae6$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $407acd0611c09ae6$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($407acd0611c09ae6$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $407acd0611c09ae6$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $407acd0611c09ae6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $407acd0611c09ae6$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $407acd0611c09ae6$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $407acd0611c09ae6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $407acd0611c09ae6$export$3e9cee6b33872309(!$407acd0611c09ae6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($407acd0611c09ae6$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $407acd0611c09ae6$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $407acd0611c09ae6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($407acd0611c09ae6$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $407acd0611c09ae6$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $407acd0611c09ae6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $407acd0611c09ae6$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($407acd0611c09ae6$var$isErrorResult(result)) {
            var boundaryMatch = $407acd0611c09ae6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $407acd0611c09ae6$var$_extends({}, errors, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error));
            state.fetchers["delete"](key);
        } else if ($407acd0611c09ae6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $407acd0611c09ae6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($407acd0611c09ae6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $407acd0611c09ae6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $407acd0611c09ae6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $407acd0611c09ae6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $407acd0611c09ae6$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $407acd0611c09ae6$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $407acd0611c09ae6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $407acd0611c09ae6$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $407acd0611c09ae6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $407acd0611c09ae6$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($407acd0611c09ae6$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $407acd0611c09ae6$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(path) : path;
    return $407acd0611c09ae6$export$fe53371bee54353d($407acd0611c09ae6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $407acd0611c09ae6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $407acd0611c09ae6$var$isDeferredResult(result) {
    return result.type === $407acd0611c09ae6$var$ResultType.deferred;
}
function $407acd0611c09ae6$var$isErrorResult(result) {
    return result.type === $407acd0611c09ae6$var$ResultType.error;
}
function $407acd0611c09ae6$var$isRedirectResult(result) {
    return (result && result.type) === $407acd0611c09ae6$var$ResultType.redirect;
}
function $407acd0611c09ae6$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $407acd0611c09ae6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $407acd0611c09ae6$var$isRedirectResponse(result) {
    if (!$407acd0611c09ae6$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $407acd0611c09ae6$var$isQueryRouteResponse(obj) {
    return obj && $407acd0611c09ae6$var$isResponse(obj.response) && (obj.type === $407acd0611c09ae6$var$ResultType.data || obj.type === $407acd0611c09ae6$var$ResultType.error);
}
function $407acd0611c09ae6$var$isValidMethod(method) {
    return $407acd0611c09ae6$var$validRequestMethods.has(method.toLowerCase());
}
function $407acd0611c09ae6$var$isMutationMethod(method) {
    return $407acd0611c09ae6$var$validMutationMethods.has(method.toLowerCase());
}
function $407acd0611c09ae6$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $407acd0611c09ae6$var$_resolveDeferredResults.apply(this, arguments);
}
function $407acd0611c09ae6$var$_resolveDeferredResults() {
    $407acd0611c09ae6$var$_resolveDeferredResults = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$407acd0611c09ae6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($407acd0611c09ae6$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $407acd0611c09ae6$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $407acd0611c09ae6$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $1e21d28140546eff$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $407acd0611c09ae6$var$_resolveDeferredResults.apply(this, arguments);
}
function $407acd0611c09ae6$var$resolveDeferredData(result, signal, unwrap) {
    return $407acd0611c09ae6$var$_resolveDeferredData.apply(this, arguments);
}
function $407acd0611c09ae6$var$_resolveDeferredData() {
    $407acd0611c09ae6$var$_resolveDeferredData = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $407acd0611c09ae6$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $407acd0611c09ae6$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $407acd0611c09ae6$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $407acd0611c09ae6$var$_resolveDeferredData.apply(this, arguments);
}
function $407acd0611c09ae6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $407acd0611c09ae6$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $407acd0611c09ae6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $407acd0611c09ae6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $407acd0611c09ae6$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $407acd0611c09ae6$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $407acd0611c09ae6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $407acd0611c09ae6$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $407acd0611c09ae6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $407acd0611c09ae6$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $407acd0611c09ae6$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $407acd0611c09ae6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($407acd0611c09ae6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $407acd0611c09ae6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($407acd0611c09ae6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $407acd0611c09ae6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






var $8SyCD = parcelRequire("8SyCD");

function $b6e23d349026de17$var$_extends() {
    $b6e23d349026de17$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b6e23d349026de17$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $b6e23d349026de17$export$3add0d5dce533e2e = /*#__PURE__*/ $8SyCD.createContext(null);
var $b6e23d349026de17$export$145dfa71566a64dc = /*#__PURE__*/ $8SyCD.createContext(null);
var $b6e23d349026de17$var$AwaitContext = /*#__PURE__*/ $8SyCD.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $b6e23d349026de17$export$26749e8557646306 = /*#__PURE__*/ $8SyCD.createContext(null);
var $b6e23d349026de17$export$c7914228fb69b0f5 = /*#__PURE__*/ $8SyCD.createContext(null);
var $b6e23d349026de17$export$9072aa6dd1f93057 = /*#__PURE__*/ $8SyCD.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $b6e23d349026de17$var$RouteErrorContext = /*#__PURE__*/ $8SyCD.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b6e23d349026de17$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var _React_useContext = $8SyCD.useContext($b6e23d349026de17$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $b6e23d349026de17$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $407acd0611c09ae6$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b6e23d349026de17$export$9c954a9d03d32f4a() {
    return $8SyCD.useContext($b6e23d349026de17$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b6e23d349026de17$export$45d76561a5302f2b() {
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return $8SyCD.useContext($b6e23d349026de17$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b6e23d349026de17$export$1b3f31771c5d07c() {
    return $8SyCD.useContext($b6e23d349026de17$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b6e23d349026de17$export$6c330e8992e8a295(pattern) {
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var pathname = $b6e23d349026de17$export$45d76561a5302f2b().pathname;
    return $8SyCD.useMemo(function() {
        return (0, $407acd0611c09ae6$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $b6e23d349026de17$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b6e23d349026de17$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $8SyCD.useContext($b6e23d349026de17$export$26749e8557646306)["static"];
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8SyCD.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b6e23d349026de17$export$9770f232ac06a008() {
    var isDataRoute = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b6e23d349026de17$var$useNavigateStable() : $b6e23d349026de17$var$useNavigateUnstable();
}
function $b6e23d349026de17$var$useNavigateUnstable() {
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var dataRouterContext = $8SyCD.useContext($b6e23d349026de17$export$3add0d5dce533e2e);
    var _React_useContext = $8SyCD.useContext($b6e23d349026de17$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).matches;
    var _useLocation = $b6e23d349026de17$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $407acd0611c09ae6$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $8SyCD.useRef(false);
    $b6e23d349026de17$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $8SyCD.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $407acd0611c09ae6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $407acd0611c09ae6$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $b6e23d349026de17$var$OutletContext = /*#__PURE__*/ $8SyCD.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b6e23d349026de17$export$4138103a3ae699cc() {
    return $8SyCD.useContext($b6e23d349026de17$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b6e23d349026de17$export$a3be3530d8e40d0b(context) {
    var outlet = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b6e23d349026de17$export$99eaa27ddbbb95ef() {
    var matches = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b6e23d349026de17$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).matches;
    var _useLocation = $b6e23d349026de17$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $407acd0611c09ae6$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $8SyCD.useMemo(function() {
        return (0, $407acd0611c09ae6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b6e23d349026de17$export$5d3fca4a98652595(routes, locationArg) {
    return $b6e23d349026de17$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b6e23d349026de17$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var navigator = $8SyCD.useContext($b6e23d349026de17$export$26749e8557646306).navigator;
    var _React_useContext = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $b6e23d349026de17$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $407acd0611c09ae6$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $407acd0611c09ae6$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $b6e23d349026de17$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $407acd0611c09ae6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $407acd0611c09ae6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b6e23d349026de17$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $407acd0611c09ae6$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b6e23d349026de17$var$DefaultErrorComponent() {
    var error = $b6e23d349026de17$export$ed527bf60f6e05f2();
    var message = (0, $407acd0611c09ae6$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8SyCD.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8SyCD.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $b6e23d349026de17$var$defaultErrorElement = /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$DefaultErrorComponent, null);
var $b6e23d349026de17$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(RenderErrorBoundary, _React_Component);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($8SyCD.Component);
function $b6e23d349026de17$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $8SyCD.useContext($b6e23d349026de17$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext["static"] && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b6e23d349026de17$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $b6e23d349026de17$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8SyCD.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b6e23d349026de17$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b6e23d349026de17$var$DataRouterHook || {});
var $b6e23d349026de17$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b6e23d349026de17$var$DataRouterStateHook || {});
function $b6e23d349026de17$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b6e23d349026de17$var$useDataRouterContext(hookName) {
    var ctx = $8SyCD.useContext($b6e23d349026de17$export$3add0d5dce533e2e);
    !ctx && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b6e23d349026de17$var$useDataRouterState(hookName) {
    var state = $8SyCD.useContext($b6e23d349026de17$export$145dfa71566a64dc);
    !state && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return state;
}
function $b6e23d349026de17$var$useRouteContext(hookName) {
    var route = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057);
    !route && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b6e23d349026de17$var$useCurrentRouteId(hookName) {
    var route = $b6e23d349026de17$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b6e23d349026de17$export$5fc8298006ad9e58() {
    return $b6e23d349026de17$var$useCurrentRouteId($b6e23d349026de17$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b6e23d349026de17$export$d0fd4b7106de2769() {
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b6e23d349026de17$export$600dc272ed516c15() {
    var dataRouterContext = $b6e23d349026de17$var$useDataRouterContext($b6e23d349026de17$var$DataRouterHook.UseRevalidator);
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseRevalidator);
    return $8SyCD.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b6e23d349026de17$export$2378eb7f5ff86053() {
    var _useDataRouterState = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $8SyCD.useMemo(function() {
        return matches.map(function(m) {
            return (0, $407acd0611c09ae6$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b6e23d349026de17$export$1448a5050d252c4d() {
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseLoaderData);
    var routeId = $b6e23d349026de17$var$useCurrentRouteId($b6e23d349026de17$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b6e23d349026de17$export$fd5d37484eab868d(routeId) {
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b6e23d349026de17$export$fdc00f3f26066d5e() {
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseActionData);
    var routeId = $b6e23d349026de17$var$useCurrentRouteId($b6e23d349026de17$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b6e23d349026de17$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $8SyCD.useContext($b6e23d349026de17$var$RouteErrorContext);
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseRouteError);
    var routeId = $b6e23d349026de17$var$useCurrentRouteId($b6e23d349026de17$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b6e23d349026de17$export$78a72ddb39bdd145() {
    var value = $8SyCD.useContext($b6e23d349026de17$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b6e23d349026de17$export$17f53340677d5831() {
    var value = $8SyCD.useContext($b6e23d349026de17$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $b6e23d349026de17$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b6e23d349026de17$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $b6e23d349026de17$var$useDataRouterContext($b6e23d349026de17$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $b6e23d349026de17$var$useDataRouterState($b6e23d349026de17$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $8SyCD.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $b6e23d349026de17$var$_extends({}, currentLocation, {
                pathname: (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b6e23d349026de17$var$_extends({}, nextLocation, {
                pathname: (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8SyCD.useEffect(function() {
        var key = String(++$b6e23d349026de17$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8SyCD.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $407acd0611c09ae6$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b6e23d349026de17$var$useNavigateStable() {
    var router = $b6e23d349026de17$var$useDataRouterContext($b6e23d349026de17$var$DataRouterHook.UseNavigateStable).router;
    var id = $b6e23d349026de17$var$useCurrentRouteId($b6e23d349026de17$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $8SyCD.useRef(false);
    $b6e23d349026de17$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $8SyCD.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b6e23d349026de17$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $b6e23d349026de17$var$alreadyWarned = {};
function $b6e23d349026de17$var$warningOnce(key, cond, message) {
    if (!cond && !$b6e23d349026de17$var$alreadyWarned[key]) $b6e23d349026de17$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $b6e23d349026de17$var$START_TRANSITION = "startTransition";
var $b6e23d349026de17$var$startTransitionImpl = $8SyCD[$b6e23d349026de17$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b6e23d349026de17$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $8SyCD.useCallback(function(newState) {
        if (v7_startTransition && $b6e23d349026de17$var$startTransitionImpl) $b6e23d349026de17$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8SyCD.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $8SyCD.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $8SyCD.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $b6e23d349026de17$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $b6e23d349026de17$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b6e23d349026de17$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $8SyCD.useRef();
    if (historyRef.current == null) historyRef.current = (0, $407acd0611c09ae6$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $8SyCD.useCallback(function(newState) {
        v7_startTransition && $b6e23d349026de17$var$startTransitionImpl ? $b6e23d349026de17$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8SyCD.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b6e23d349026de17$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var matches = $8SyCD.useContext($b6e23d349026de17$export$9072aa6dd1f93057).matches;
    var _useLocation = $b6e23d349026de17$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $b6e23d349026de17$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $407acd0611c09ae6$export$cae722b0cc860f13)(to, (0, $407acd0611c09ae6$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $8SyCD.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b6e23d349026de17$export$910ae8079b2c2852(props) {
    return $b6e23d349026de17$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b6e23d349026de17$export$e7b0ac011bb776c6(_props) {
    (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b6e23d349026de17$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $407acd0611c09ae6$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5["static"], staticProp = tmp1 === void 0 ? false : tmp1;
    !!$b6e23d349026de17$export$9c954a9d03d32f4a() && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $8SyCD.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $407acd0611c09ae6$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $8SyCD.useMemo(function() {
        var trailingPathname = (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b6e23d349026de17$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $b6e23d349026de17$export$5d3fca4a98652595($b6e23d349026de17$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b6e23d349026de17$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$ResolveAwait, null, children));
}
var $b6e23d349026de17$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b6e23d349026de17$var$AwaitRenderStatus || {});
var $b6e23d349026de17$var$neverSettledPromise = new Promise(function() {});
var $b6e23d349026de17$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $b6e23d349026de17$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $b6e23d349026de17$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $b6e23d349026de17$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject()["catch"](function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $b6e23d349026de17$var$AwaitRenderStatus.error : promise._data !== undefined ? $b6e23d349026de17$var$AwaitRenderStatus.success : $b6e23d349026de17$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $b6e23d349026de17$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $b6e23d349026de17$var$AwaitRenderStatus.error && promise._error instanceof (0, $407acd0611c09ae6$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $b6e23d349026de17$var$neverSettledPromise;
                if (status === $b6e23d349026de17$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $b6e23d349026de17$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $b6e23d349026de17$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $8SyCD.createElement($b6e23d349026de17$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($8SyCD.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b6e23d349026de17$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $b6e23d349026de17$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b6e23d349026de17$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $8SyCD.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $8SyCD.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(parentPath).concat([
            index
        ]);
        if (element.type === $8SyCD.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b6e23d349026de17$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b6e23d349026de17$export$e7b0ac011bb776c6) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b6e23d349026de17$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b6e23d349026de17$export$daf73786167a7f72(matches) {
    return $b6e23d349026de17$var$_renderMatches(matches);
}
function $b6e23d349026de17$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8SyCD.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8SyCD.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b6e23d349026de17$export$f30f7e456d254e83(routes, opts) {
    return (0, $407acd0611c09ae6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b6e23d349026de17$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $407acd0611c09ae6$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b6e23d349026de17$export$52b333d321859367
    }).initialize();
}



function $76b4f75f035f6acf$var$_extends() {
    $76b4f75f035f6acf$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76b4f75f035f6acf$var$_extends.apply(this, arguments);
}
function $76b4f75f035f6acf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $76b4f75f035f6acf$var$defaultMethod = "get";
var $76b4f75f035f6acf$var$defaultEncType = "application/x-www-form-urlencoded";
function $76b4f75f035f6acf$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $76b4f75f035f6acf$var$isButtonElement(object) {
    return $76b4f75f035f6acf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $76b4f75f035f6acf$var$isFormElement(object) {
    return $76b4f75f035f6acf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $76b4f75f035f6acf$var$isInputElement(object) {
    return $76b4f75f035f6acf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $76b4f75f035f6acf$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $76b4f75f035f6acf$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$76b4f75f035f6acf$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $76b4f75f035f6acf$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $76b4f75f035f6acf$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $76b4f75f035f6acf$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $76b4f75f035f6acf$var$_formDataSupportsSubmitter = null;
function $76b4f75f035f6acf$var$isFormDataSubmitterSupported() {
    if ($76b4f75f035f6acf$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $76b4f75f035f6acf$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $76b4f75f035f6acf$var$_formDataSupportsSubmitter = true;
    }
    return $76b4f75f035f6acf$var$_formDataSupportsSubmitter;
}
var $76b4f75f035f6acf$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $76b4f75f035f6acf$var$getFormEncType(encType) {
    if (encType != null && !$76b4f75f035f6acf$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $76b4f75f035f6acf$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($76b4f75f035f6acf$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $76b4f75f035f6acf$var$defaultMethod;
        encType = $76b4f75f035f6acf$var$getFormEncType(target.getAttribute("enctype")) || $76b4f75f035f6acf$var$defaultEncType;
        formData = new FormData(target);
    } else if ($76b4f75f035f6acf$var$isButtonElement(target) || $76b4f75f035f6acf$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $76b4f75f035f6acf$var$defaultMethod;
        encType = $76b4f75f035f6acf$var$getFormEncType(target.getAttribute("formenctype")) || $76b4f75f035f6acf$var$getFormEncType(form.getAttribute("enctype")) || $76b4f75f035f6acf$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$76b4f75f035f6acf$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($76b4f75f035f6acf$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $76b4f75f035f6acf$var$defaultMethod;
        action = null;
        encType = $76b4f75f035f6acf$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $76b4f75f035f6acf$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $76b4f75f035f6acf$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $76b4f75f035f6acf$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $76b4f75f035f6acf$export$1f3f55432a00e06d(routes, opts) {
    return (0, $407acd0611c09ae6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76b4f75f035f6acf$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $407acd0611c09ae6$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76b4f75f035f6acf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b6e23d349026de17$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76b4f75f035f6acf$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $407acd0611c09ae6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76b4f75f035f6acf$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $407acd0611c09ae6$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76b4f75f035f6acf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b6e23d349026de17$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76b4f75f035f6acf$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $76b4f75f035f6acf$var$_extends({}, state, {
        errors: $76b4f75f035f6acf$var$deserializeErrors(state.errors)
    });
    return state;
}
function $76b4f75f035f6acf$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $407acd0611c09ae6$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $76b4f75f035f6acf$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8SyCD.createContext({
    isTransitioning: false
});
var $76b4f75f035f6acf$export$148fd98d095596d4 = /*#__PURE__*/ $8SyCD.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $76b4f75f035f6acf$var$START_TRANSITION = "startTransition";
var $76b4f75f035f6acf$var$startTransitionImpl = $8SyCD[$76b4f75f035f6acf$var$START_TRANSITION];
var $76b4f75f035f6acf$var$FLUSH_SYNC = "flushSync";
var $76b4f75f035f6acf$var$flushSyncImpl = $b4e4ce7bd3c993b9$exports[$76b4f75f035f6acf$var$FLUSH_SYNC];
function $76b4f75f035f6acf$var$startTransitionSafe(cb) {
    if ($76b4f75f035f6acf$var$startTransitionImpl) $76b4f75f035f6acf$var$startTransitionImpl(cb);
    else cb();
}
function $76b4f75f035f6acf$var$flushSyncSafe(cb) {
    if ($76b4f75f035f6acf$var$flushSyncImpl) $76b4f75f035f6acf$var$flushSyncImpl(cb);
    else cb();
}
var $76b4f75f035f6acf$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $76b4f75f035f6acf$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $8SyCD.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $8SyCD.useCallback(function(cb) {
        if (v7_startTransition) $76b4f75f035f6acf$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $8SyCD.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current["delete"](key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $76b4f75f035f6acf$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $76b4f75f035f6acf$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $76b4f75f035f6acf$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished["finally"](function() {
                $76b4f75f035f6acf$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $76b4f75f035f6acf$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8SyCD.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8SyCD.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $76b4f75f035f6acf$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8SyCD.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function() {
                return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished["finally"](function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8SyCD.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8SyCD.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $8SyCD.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $8SyCD.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8SyCD.createElement($76b4f75f035f6acf$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8SyCD.createElement($76b4f75f035f6acf$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $8SyCD.createElement($76b4f75f035f6acf$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $76b4f75f035f6acf$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, state = _ref3.state;
    return (0, $b6e23d349026de17$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $76b4f75f035f6acf$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $8SyCD.useRef();
    if (historyRef.current == null) historyRef.current = (0, $407acd0611c09ae6$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $8SyCD.useCallback(function(newState) {
        v7_startTransition && $76b4f75f035f6acf$var$startTransitionImpl ? $76b4f75f035f6acf$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8SyCD.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $76b4f75f035f6acf$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $8SyCD.useRef();
    if (historyRef.current == null) historyRef.current = (0, $407acd0611c09ae6$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $8SyCD.useCallback(function(newState) {
        v7_startTransition && $76b4f75f035f6acf$var$startTransitionImpl ? $76b4f75f035f6acf$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8SyCD.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $76b4f75f035f6acf$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $8SyCD.useCallback(function(newState) {
        v7_startTransition && $76b4f75f035f6acf$var$startTransitionImpl ? $76b4f75f035f6acf$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8SyCD.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $b6e23d349026de17$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $76b4f75f035f6acf$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $76b4f75f035f6acf$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $76b4f75f035f6acf$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8SyCD.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $76b4f75f035f6acf$var$_objectWithoutPropertiesLoose(_ref7, $76b4f75f035f6acf$var$_excluded);
    var basename = $8SyCD.useContext((0, $b6e23d349026de17$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $76b4f75f035f6acf$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($76b4f75f035f6acf$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $b6e23d349026de17$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $76b4f75f035f6acf$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8SyCD.createElement("a", $76b4f75f035f6acf$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $76b4f75f035f6acf$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8SyCD.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $76b4f75f035f6acf$var$_objectWithoutPropertiesLoose(_ref8, $76b4f75f035f6acf$var$_excluded2);
    var path = (0, $b6e23d349026de17$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $b6e23d349026de17$export$45d76561a5302f2b)();
    var routerState = $8SyCD.useContext((0, $b6e23d349026de17$export$145dfa71566a64dc));
    var navigator = $8SyCD.useContext((0, $b6e23d349026de17$export$26749e8557646306)).navigator;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $76b4f75f035f6acf$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8SyCD.createElement($76b4f75f035f6acf$export$a6c7ac8248d6e38a, $76b4f75f035f6acf$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $76b4f75f035f6acf$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8SyCD.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $76b4f75f035f6acf$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $76b4f75f035f6acf$var$_objectWithoutPropertiesLoose(_ref9, $76b4f75f035f6acf$var$_excluded3);
    var submit = $76b4f75f035f6acf$export$47c85c6e3a081d3();
    var formAction = $76b4f75f035f6acf$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8SyCD.createElement("form", $76b4f75f035f6acf$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $76b4f75f035f6acf$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $76b4f75f035f6acf$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $76b4f75f035f6acf$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($76b4f75f035f6acf$var$DataRouterHook || ($76b4f75f035f6acf$var$DataRouterHook = {}));
var $76b4f75f035f6acf$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($76b4f75f035f6acf$var$DataRouterStateHook || ($76b4f75f035f6acf$var$DataRouterStateHook = {}));
// Internal hooks
function $76b4f75f035f6acf$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $76b4f75f035f6acf$var$useDataRouterContext(hookName) {
    var ctx = $8SyCD.useContext((0, $b6e23d349026de17$export$3add0d5dce533e2e));
    !ctx && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $76b4f75f035f6acf$var$useDataRouterState(hookName) {
    var state = $8SyCD.useContext((0, $b6e23d349026de17$export$145dfa71566a64dc));
    !state && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $76b4f75f035f6acf$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $b6e23d349026de17$export$9770f232ac06a008)();
    var location = (0, $b6e23d349026de17$export$45d76561a5302f2b)();
    var path = (0, $b6e23d349026de17$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8SyCD.useCallback(function(event) {
        if ($76b4f75f035f6acf$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $407acd0611c09ae6$export$fe53371bee54353d)(location) === (0, $407acd0611c09ae6$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $76b4f75f035f6acf$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $8SyCD.useRef($76b4f75f035f6acf$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $8SyCD.useRef(false);
    var location = (0, $b6e23d349026de17$export$45d76561a5302f2b)();
    var searchParams = $8SyCD.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $76b4f75f035f6acf$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $b6e23d349026de17$export$9770f232ac06a008)();
    var setSearchParams = $8SyCD.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $76b4f75f035f6acf$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $76b4f75f035f6acf$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $76b4f75f035f6acf$var$fetcherId = 0;
var $76b4f75f035f6acf$var$getUniqueFetcherId = function() {
    return "__" + String(++$76b4f75f035f6acf$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $76b4f75f035f6acf$export$47c85c6e3a081d3() {
    var router = $76b4f75f035f6acf$var$useDataRouterContext($76b4f75f035f6acf$var$DataRouterHook.UseSubmit).router;
    var basename = $8SyCD.useContext((0, $b6e23d349026de17$export$26749e8557646306)).basename;
    var currentRouteId = (0, $b6e23d349026de17$export$5fc8298006ad9e58)();
    return $8SyCD.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $76b4f75f035f6acf$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $76b4f75f035f6acf$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $76b4f75f035f6acf$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $76b4f75f035f6acf$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $8SyCD.useContext((0, $b6e23d349026de17$export$26749e8557646306)).basename;
    var routeContext = $8SyCD.useContext((0, $b6e23d349026de17$export$9072aa6dd1f93057));
    !routeContext && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $76b4f75f035f6acf$var$_extends({}, (0, $b6e23d349026de17$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $b6e23d349026de17$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params["delete"]("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $407acd0611c09ae6$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $407acd0611c09ae6$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $76b4f75f035f6acf$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $76b4f75f035f6acf$var$useDataRouterContext($76b4f75f035f6acf$var$DataRouterHook.UseFetcher).router;
    var state = $76b4f75f035f6acf$var$useDataRouterState($76b4f75f035f6acf$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $8SyCD.useContext($76b4f75f035f6acf$export$148fd98d095596d4);
    var route = $8SyCD.useContext((0, $b6e23d349026de17$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    !route && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(key || ""), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($76b4f75f035f6acf$var$getUniqueFetcherId());
    // Registration/cleanup
    $8SyCD.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $8SyCD.useCallback(function(href, opts) {
        !routeId && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $76b4f75f035f6acf$export$47c85c6e3a081d3();
    var submit = $8SyCD.useCallback(function(target, opts) {
        submitImpl(target, $76b4f75f035f6acf$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $8SyCD.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $8SyCD.createElement($76b4f75f035f6acf$export$a7fed597f4b8afd8, $76b4f75f035f6acf$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $407acd0611c09ae6$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $8SyCD.useMemo(function() {
        return $76b4f75f035f6acf$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $76b4f75f035f6acf$export$fa996778a3a31087() {
    var state = $76b4f75f035f6acf$var$useDataRouterState($76b4f75f035f6acf$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $76b4f75f035f6acf$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $76b4f75f035f6acf$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $76b4f75f035f6acf$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $76b4f75f035f6acf$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $76b4f75f035f6acf$var$useDataRouterContext($76b4f75f035f6acf$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $76b4f75f035f6acf$var$useDataRouterState($76b4f75f035f6acf$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $8SyCD.useContext((0, $b6e23d349026de17$export$26749e8557646306)).basename;
    var location = (0, $b6e23d349026de17$export$45d76561a5302f2b)();
    var matches = (0, $b6e23d349026de17$export$2378eb7f5ff86053)();
    var navigation = (0, $b6e23d349026de17$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8SyCD.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $76b4f75f035f6acf$var$usePageHide($8SyCD.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $76b4f75f035f6acf$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $76b4f75f035f6acf$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($76b4f75f035f6acf$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8SyCD.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $76b4f75f035f6acf$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $76b4f75f035f6acf$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8SyCD.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($76b4f75f035f6acf$var$_extends({}, location, {
                    pathname: (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($76b4f75f035f6acf$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8SyCD.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76b4f75f035f6acf$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $8SyCD.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76b4f75f035f6acf$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $8SyCD.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $76b4f75f035f6acf$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $b6e23d349026de17$export$b273b3273281a049)(when);
    $8SyCD.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8SyCD.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $76b4f75f035f6acf$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $8SyCD.useContext($76b4f75f035f6acf$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $407acd0611c09ae6$export$3e9cee6b33872309)(false);
    var basename = $76b4f75f035f6acf$var$useDataRouterContext($76b4f75f035f6acf$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $b6e23d349026de17$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $407acd0611c09ae6$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $407acd0611c09ae6$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $407acd0611c09ae6$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");
var $72d4b339b8bd94c3$exports = {};

var $7FyBz = parcelRequire("7FyBz");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, $7FyBz._)(arg);
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $72d4b339b8bd94c3$exports) {
        classNames["default"] = classNames;
        $72d4b339b8bd94c3$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $a205fb7a2d11f9f1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a205fb7a2d11f9f1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a205fb7a2d11f9f1$export$2e2bcd8739ae039(o);
}



function $34082abc482249a6$export$2e2bcd8739ae039(input, hint) {
    if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $500545cd6a1f64e2$export$2e2bcd8739ae039(arg) {
    var key = (0, $34082abc482249a6$export$2e2bcd8739ae039)(arg, "string");
    return (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $54033efc60d3b6a4$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $500545cd6a1f64e2$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $d92fa87bc98e5ec0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d92fa87bc98e5ec0$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d92fa87bc98e5ec0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d92fa87bc98e5ec0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $eac4a3709f8f6581$export$2e2bcd8739ae039(obj, fields) {
    var clone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}




var $8SyCD = parcelRequire("8SyCD");
var $9098d7397e765aa5$exports = {};
"use strict";

$9098d7397e765aa5$exports = (parcelRequire("7rv2B"));



var $8SyCD = parcelRequire("8SyCD");
function $f718e8ae83c37f1e$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $8SyCD.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $5a9f4dc5cf4fdd27$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $5a9f4dc5cf4fdd27$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5a9f4dc5cf4fdd27$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $5a9f4dc5cf4fdd27$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        return $5a9f4dc5cf4fdd27$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
}
function $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $9098d7397e765aa5$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
}
function $5a9f4dc5cf4fdd27$export$b51ae67c7882a242(node) {
    if (!/*#__PURE__*/ (0, $8SyCD.isValidElement)(node)) return false;
    if ((0, $9098d7397e765aa5$exports.isFragment)(node)) return false;
    return $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7(node);
} /* eslint-enable */ 






var $1f0413060b1cb2c2$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};



var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
function $d48bf3967eb7347a$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $acdffdb8fad00eb9$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $d68c973a35db94b3$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $5e35c2f511a546c9$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $d68c973a35db94b3$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $d68c973a35db94b3$export$2e2bcd8739ae039)(o, minLen);
}


function $6673e9e9f1a6e057$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ba942fe2765b61c7$export$2e2bcd8739ae039(arr, i) {
    return (0, $d48bf3967eb7347a$export$2e2bcd8739ae039)(arr) || (0, $acdffdb8fad00eb9$export$2e2bcd8739ae039)(arr, i) || (0, $5e35c2f511a546c9$export$2e2bcd8739ae039)(arr, i) || (0, $6673e9e9f1a6e057$export$2e2bcd8739ae039)();
}





function $11ad4ac28895cd96$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $d68c973a35db94b3$export$2e2bcd8739ae039)(arr);
}


function $cb221cbac1b37255$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $e3a8b530b9409ff9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e17b38c8264d6486$export$2e2bcd8739ae039(arr) {
    return (0, $11ad4ac28895cd96$export$2e2bcd8739ae039)(arr) || (0, $cb221cbac1b37255$export$2e2bcd8739ae039)(arr) || (0, $5e35c2f511a546c9$export$2e2bcd8739ae039)(arr) || (0, $e3a8b530b9409ff9$export$2e2bcd8739ae039)();
}



/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1090c7b9e53914a6$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $1090c7b9e53914a6$export$2e2bcd8739ae039 = $1090c7b9e53914a6$var$murmur2;


function $014625af273be671$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


function $2cd98a4abf51dc5f$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $0c499bcbbdb3e2de$var$APPEND_ORDER = "data-rc-order";
var $0c499bcbbdb3e2de$var$APPEND_PRIORITY = "data-rc-priority";
var $0c499bcbbdb3e2de$var$MARK_KEY = "rc-util-key";
var $0c499bcbbdb3e2de$var$containerCache = new Map();
function $0c499bcbbdb3e2de$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $0c499bcbbdb3e2de$var$MARK_KEY;
}
function $0c499bcbbdb3e2de$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $0c499bcbbdb3e2de$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $0c499bcbbdb3e2de$var$findStyles(container) {
    return Array.from(($0c499bcbbdb3e2de$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $0c499bcbbdb3e2de$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $014625af273be671$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $0c499bcbbdb3e2de$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute($0c499bcbbdb3e2de$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($0c499bcbbdb3e2de$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $0c499bcbbdb3e2de$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = $0c499bcbbdb3e2de$var$findStyles(container).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($0c499bcbbdb3e2de$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($0c499bcbbdb3e2de$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $0c499bcbbdb3e2de$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $0c499bcbbdb3e2de$var$getContainer(option);
    return $0c499bcbbdb3e2de$var$findStyles(container).find(function(node) {
        return node.getAttribute($0c499bcbbdb3e2de$var$getMark(option)) === key;
    });
}
function $0c499bcbbdb3e2de$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $0c499bcbbdb3e2de$var$findExistNode(key, option);
    if (existNode) {
        var container = $0c499bcbbdb3e2de$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $0c499bcbbdb3e2de$var$syncRealContainer(container, option) {
    var cachedRealContainer = $0c499bcbbdb3e2de$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $2cd98a4abf51dc5f$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $0c499bcbbdb3e2de$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $0c499bcbbdb3e2de$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $0c499bcbbdb3e2de$export$f80df667f2f5a272() {
    $0c499bcbbdb3e2de$var$containerCache.clear();
}
function $0c499bcbbdb3e2de$export$4d99a2890bb989f0(css, key) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $0c499bcbbdb3e2de$var$getContainer(option);
    // Sync real parent
    $0c499bcbbdb3e2de$var$syncRealContainer(container, option);
    var existNode = $0c499bcbbdb3e2de$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $0c499bcbbdb3e2de$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($0c499bcbbdb3e2de$var$getMark(option), key);
    return newNode;
}



var $8SyCD = parcelRequire("8SyCD");

function $77a6042d7679eeb3$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $2c43ba8d26f61a30$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $77a6042d7679eeb3$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




/* eslint-disable no-console */ var $ed6f30969113606c$var$warned = {};
var $ed6f30969113606c$var$preWarningFns = [];
var $ed6f30969113606c$export$61616f168f0e5a05 = function preMessage(fn) {
    $ed6f30969113606c$var$preWarningFns.push(fn);
};
function $ed6f30969113606c$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $ed6f30969113606c$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $ed6f30969113606c$export$60eef1277fe463e4() {
    $ed6f30969113606c$var$warned = {};
}
function $ed6f30969113606c$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$ed6f30969113606c$var$warned[message]) {
        method(false, message);
        $ed6f30969113606c$var$warned[message] = true;
    }
}
function $ed6f30969113606c$export$82934adf09101657(valid, message) {
    $ed6f30969113606c$export$848feb93d8f32b9b($ed6f30969113606c$export$491112666e282270, valid, message);
}
function $ed6f30969113606c$export$89ff31684837bbbf(valid, message) {
    $ed6f30969113606c$export$848feb93d8f32b9b($ed6f30969113606c$export$a92e4c44d367d0af, valid, message);
}
$ed6f30969113606c$export$82934adf09101657.preMessage = $ed6f30969113606c$export$61616f168f0e5a05;
$ed6f30969113606c$export$82934adf09101657.resetWarned = $ed6f30969113606c$export$60eef1277fe463e4;
$ed6f30969113606c$export$82934adf09101657.noteOnce = $ed6f30969113606c$export$89ff31684837bbbf;
var $ed6f30969113606c$export$2e2bcd8739ae039 /* eslint-enable */  = $ed6f30969113606c$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $81937b17d7a39a0b$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(a) === "object" && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $81937b17d7a39a0b$export$2e2bcd8739ae039 = $81937b17d7a39a0b$var$isEqual;



var $8SyCD = parcelRequire("8SyCD");
function $8c9b1388f71090cb$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $de94c4fdc35681ad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $500545cd6a1f64e2$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $de94c4fdc35681ad$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $de94c4fdc35681ad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $de94c4fdc35681ad$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



// [times, realValue]
var $9bc073427a8c0410$var$SPLIT = "%";
var $9bc073427a8c0410$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, Entity);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.cache.get(keys.join($9bc073427a8c0410$var$SPLIT)) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                var path = keys.join($9bc073427a8c0410$var$SPLIT);
                var prevValue = this.cache.get(path);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache["delete"](path);
                else this.cache.set(path, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $9bc073427a8c0410$export$2e2bcd8739ae039 = $9bc073427a8c0410$var$Entity;


var $812e58228ca1c244$var$_excluded = [
    "children"
];
var $812e58228ca1c244$export$5d99297dcd5476ac = "data-token-hash";
var $812e58228ca1c244$export$89ce1123b3c0bd9e = "data-css-hash";
var $812e58228ca1c244$export$36f8a6c9fa24262a = "data-cache-path";
var $812e58228ca1c244$export$4c16a0c02134a7dc = "__cssinjs_instance__";
function $812e58228ca1c244$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== "undefined" && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($812e58228ca1c244$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$812e58228ca1c244$export$4c16a0c02134a7dc] = style[$812e58228ca1c244$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$812e58228ca1c244$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($812e58228ca1c244$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($812e58228ca1c244$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$812e58228ca1c244$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $9bc073427a8c0410$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
var $812e58228ca1c244$var$StyleContext = /*#__PURE__*/ $8SyCD.createContext({
    hashPriority: "low",
    cache: $812e58228ca1c244$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $812e58228ca1c244$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $812e58228ca1c244$var$_excluded);
    var parentContext = $8SyCD.useContext($812e58228ca1c244$var$StyleContext);
    var context = (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        var mergedContext = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $812e58228ca1c244$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $8SyCD.createElement($812e58228ca1c244$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $812e58228ca1c244$export$2e2bcd8739ae039 = $812e58228ca1c244$var$StyleContext;













function $e96756256245ec2a$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $e96756256245ec2a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, ThemeCache);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "cache", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "keys", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this["delete"](targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache["delete"](derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache["delete"](derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$e96756256245ec2a$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($e96756256245ec2a$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($e96756256245ec2a$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);






var $36cd636123c5603a$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $36cd636123c5603a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, Theme);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "derivatives", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $36cd636123c5603a$var$uuid;
        if (derivatives.length === 0) (0, $ed6f30969113606c$export$491112666e282270)(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
        $36cd636123c5603a$var$uuid += 1;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();


var $594b86af963ae683$var$cacheThemes = new (0, $e96756256245ec2a$export$2e2bcd8739ae039)();
function $594b86af963ae683$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$594b86af963ae683$var$cacheThemes.has(derivativeArr)) $594b86af963ae683$var$cacheThemes.set(derivativeArr, new (0, $36cd636123c5603a$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $594b86af963ae683$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
var $d345e6062a3ed2bd$var$resultCache = new WeakMap();
var $d345e6062a3ed2bd$var$RESULT_VALUE = {};
function $d345e6062a3ed2bd$export$6aabcc1951563d93(callback, deps) {
    var current = $d345e6062a3ed2bd$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($d345e6062a3ed2bd$var$RESULT_VALUE)) current.set($d345e6062a3ed2bd$var$RESULT_VALUE, callback());
    return current.get($d345e6062a3ed2bd$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $d345e6062a3ed2bd$var$flattenTokenCache = new WeakMap();
function $d345e6062a3ed2bd$export$597374558a261efc(token) {
    var str = $d345e6062a3ed2bd$var$flattenTokenCache.get(token) || "";
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $36cd636123c5603a$export$2e2bcd8739ae039)) str += value.id;
            else if (value && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(value) === "object") str += $d345e6062a3ed2bd$export$597374558a261efc(value);
            else str += value;
        });
        // Put in cache
        $d345e6062a3ed2bd$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $d345e6062a3ed2bd$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $1090c7b9e53914a6$export$2e2bcd8739ae039)("".concat(salt, "_").concat($d345e6062a3ed2bd$export$597374558a261efc(token)));
}
var $d345e6062a3ed2bd$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
// Magic `content` for detect selector support
var $d345e6062a3ed2bd$var$checkContent = "_bAmBoO_";
function $d345e6062a3ed2bd$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $014625af273be671$export$2e2bcd8739ae039)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(styleStr, $d345e6062a3ed2bd$var$randomSelectorKey);
        var _ele = document.createElement("div");
        _ele.style.position = "fixed";
        _ele.style.left = "0";
        _ele.style.top = "0";
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($d345e6062a3ed2bd$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $0c499bcbbdb3e2de$export$2232e336aecaa80a)($d345e6062a3ed2bd$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $d345e6062a3ed2bd$var$canLayer = undefined;
function $d345e6062a3ed2bd$export$ac8d3fd9840e20dd() {
    if ($d345e6062a3ed2bd$var$canLayer === undefined) $d345e6062a3ed2bd$var$canLayer = $d345e6062a3ed2bd$var$supportSelector("@layer ".concat($d345e6062a3ed2bd$var$randomSelectorKey, " { .").concat($d345e6062a3ed2bd$var$randomSelectorKey, ' { content: "').concat($d345e6062a3ed2bd$var$checkContent, '"!important; } }'), function(ele) {
        ele.className = $d345e6062a3ed2bd$var$randomSelectorKey;
    });
    return $d345e6062a3ed2bd$var$canLayer;
}
var $d345e6062a3ed2bd$var$canWhere = undefined;
function $d345e6062a3ed2bd$export$f51d3b8ac4ac9ed1() {
    if ($d345e6062a3ed2bd$var$canWhere === undefined) $d345e6062a3ed2bd$var$canWhere = $d345e6062a3ed2bd$var$supportSelector(":where(.".concat($d345e6062a3ed2bd$var$randomSelectorKey, ') { content: "').concat($d345e6062a3ed2bd$var$checkContent, '"!important; }'), function(ele) {
        ele.className = $d345e6062a3ed2bd$var$randomSelectorKey;
    });
    return $d345e6062a3ed2bd$var$canWhere;
}
var $d345e6062a3ed2bd$var$canLogic = undefined;
function $d345e6062a3ed2bd$export$64a912f57d5de48e() {
    if ($d345e6062a3ed2bd$var$canLogic === undefined) $d345e6062a3ed2bd$var$canLogic = $d345e6062a3ed2bd$var$supportSelector(".".concat($d345e6062a3ed2bd$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $d345e6062a3ed2bd$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === "93px";
    });
    return $d345e6062a3ed2bd$var$canLogic;
}
var $d345e6062a3ed2bd$export$9542afab8c2a5f48 = (0, $014625af273be671$export$2e2bcd8739ae039)();
function $d345e6062a3ed2bd$export$523c0b569236b342(num) {
    if (typeof num === "number") return "".concat(num, "px");
    return num;
}
function $d345e6062a3ed2bd$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var _objectSpread2;
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, customizeAttrs), {}, (_objectSpread2 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, (0, $812e58228ca1c244$export$5d99297dcd5476ac), tokenKey), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, (0, $812e58228ca1c244$export$89ce1123b3c0bd9e), styleId), _objectSpread2));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, '="').concat(val, '"') : null;
    }).filter(function(v) {
        return v;
    }).join(" ");
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}



var $225107b77a38e2c5$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return "--".concat(prefix ? "".concat(prefix, "-") : "").concat(token).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var $225107b77a38e2c5$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return "";
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(""), "}");
};
var $225107b77a38e2c5$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === "string" || typeof value === "number") && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $225107b77a38e2c5$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === "number" && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $225107b77a38e2c5$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $6a684e1af621c10a$var$useInternalLayoutEffect = (0, $014625af273be671$export$2e2bcd8739ae039)() ? $8SyCD.useLayoutEffect : $8SyCD.useEffect;
var $6a684e1af621c10a$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $8SyCD.useRef(true);
    $6a684e1af621c10a$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $6a684e1af621c10a$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $6a684e1af621c10a$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $6a684e1af621c10a$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $6a684e1af621c10a$export$2e2bcd8739ae039 = $6a684e1af621c10a$var$useLayoutEffect;



var $8SyCD = parcelRequire("8SyCD");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $5633a9a0a0a5ad43$var$fullClone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, $8SyCD);
var $5633a9a0a0a5ad43$var$useInsertionEffect = $5633a9a0a0a5ad43$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $5633a9a0a0a5ad43$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $8SyCD.useMemo(renderEffect, deps);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $5633a9a0a0a5ad43$var$useCompatibleInsertionEffect = $5633a9a0a0a5ad43$var$useInsertionEffect ? function useCompatibleInsertionEffect(renderEffect, effect, deps) {
    return $5633a9a0a0a5ad43$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $5633a9a0a0a5ad43$var$useInsertionEffectPolyfill;
var $5633a9a0a0a5ad43$export$2e2bcd8739ae039 = $5633a9a0a0a5ad43$var$useCompatibleInsertionEffect;





var $8SyCD = parcelRequire("8SyCD");
var $82950b3a809ed4d0$var$fullClone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, $8SyCD);
var $82950b3a809ed4d0$var$useInsertionEffect = $82950b3a809ed4d0$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $82950b3a809ed4d0$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $8SyCD.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $82950b3a809ed4d0$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $82950b3a809ed4d0$var$useEffectCleanupRegister = typeof $82950b3a809ed4d0$var$useInsertionEffect !== "undefined" ? $82950b3a809ed4d0$var$useCleanupRegister : $82950b3a809ed4d0$var$useRun;
var $82950b3a809ed4d0$export$2e2bcd8739ae039 = $82950b3a809ed4d0$var$useEffectCleanupRegister;


function $1f6ac953b9cae3be$var$useProdHMR() {
    return false;
}
var $1f6ac953b9cae3be$var$webpackHMR = false;
function $1f6ac953b9cae3be$var$useDevHMR() {
    return $1f6ac953b9cae3be$var$webpackHMR;
}
var $1f6ac953b9cae3be$export$2e2bcd8739ae039 = $1f6ac953b9cae3be$var$useProdHMR;
var $1f6ac953b9cae3be$var$win, $1f6ac953b9cae3be$var$originWebpackHotUpdate;


function $7da64a9610f301db$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $8SyCD.useContext((0, $812e58228ca1c244$export$2e2bcd8739ae039)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keyPath));
    var deps = fullPath.join("_");
    var register = (0, $82950b3a809ed4d0$export$2e2bcd8739ae039)([
        deps
    ]);
    var HMRUpdate = (0, $1f6ac953b9cae3be$export$2e2bcd8739ae039)();
    var buildCache = function buildCache(updater) {
        globalCache.update(fullPath, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $8SyCD.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        deps
    ]);
    var cacheEntity = globalCache.get(fullPath);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $5633a9a0a0a5ad43$export$2e2bcd8739ae039)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.update(fullPath, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.get(fullPath)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        deps
    ]);
    return cacheContent;
}


var $1027e04a58b2ac6d$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $1027e04a58b2ac6d$var$hashPrefix = "css";
var $1027e04a58b2ac6d$var$tokenKeys = new Map();
function $1027e04a58b2ac6d$var$recordCleanToken(tokenKey) {
    $1027e04a58b2ac6d$var$tokenKeys.set(tokenKey, ($1027e04a58b2ac6d$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $1027e04a58b2ac6d$var$removeStyleTags(key, instanceId) {
    if (typeof document !== "undefined") {
        var styles = document.querySelectorAll("style[".concat((0, $812e58228ca1c244$export$5d99297dcd5476ac), '="').concat(key, '"]'));
        styles.forEach(function(style) {
            if (style[0, $812e58228ca1c244$export$4c16a0c02134a7dc] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $1027e04a58b2ac6d$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $1027e04a58b2ac6d$var$cleanTokenStyle(tokenKey, instanceId) {
    $1027e04a58b2ac6d$var$tokenKeys.set(tokenKey, ($1027e04a58b2ac6d$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($1027e04a58b2ac6d$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $1027e04a58b2ac6d$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $1027e04a58b2ac6d$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $1027e04a58b2ac6d$var$removeStyleTags(key, instanceId);
        $1027e04a58b2ac6d$var$tokenKeys["delete"](key);
    });
}
var $1027e04a58b2ac6d$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $1027e04a58b2ac6d$export$270fba097347f4fa = "token";
function $1027e04a58b2ac6d$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $8SyCD.useContext)((0, $812e58228ca1c244$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $1027e04a58b2ac6d$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $d345e6062a3ed2bd$export$6aabcc1951563d93)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(tokens)));
    }, tokens);
    var tokenStr = (0, $d345e6062a3ed2bd$export$597374558a261efc)(mergedToken);
    var overrideTokenStr = (0, $d345e6062a3ed2bd$export$597374558a261efc)(override);
    var cssVarStr = cssVar ? (0, $d345e6062a3ed2bd$export$597374558a261efc)(cssVar) : "";
    var cachedToken = (0, $7da64a9610f301db$export$2e2bcd8739ae039)($1027e04a58b2ac6d$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $1027e04a58b2ac6d$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedDerivativeToken);
        var cssVarsStr = "";
        if (!!cssVar) {
            var _transformToken = (0, $225107b77a38e2c5$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $d345e6062a3ed2bd$export$6c82d0ebe8f2ea2c)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $d345e6062a3ed2bd$export$6c82d0ebe8f2ea2c)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $1027e04a58b2ac6d$var$recordCleanToken(themeKey);
        var hashId = "".concat($1027e04a58b2ac6d$var$hashPrefix, "-").concat((0, $1090c7b9e53914a6$export$2e2bcd8739ae039)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $1027e04a58b2ac6d$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(cssVarsStr, (0, $1090c7b9e53914a6$export$2e2bcd8739ae039)("css-variables-".concat(token._themeKey)), {
                mark: (0, $812e58228ca1c244$export$89ce1123b3c0bd9e),
                prepend: "queue",
                attachTo: container,
                priority: -999
            });
            style[0, $812e58228ca1c244$export$4c16a0c02134a7dc] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $812e58228ca1c244$export$5d99297dcd5476ac), token._themeKey);
        }
    });
    return cachedToken;
}
var $1027e04a58b2ac6d$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $d345e6062a3ed2bd$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};






var $8SyCD = parcelRequire("8SyCD");




function $b0ab868e4ce1c6e6$export$2e2bcd8739ae039() {
    $b0ab868e4ce1c6e6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0ab868e4ce1c6e6$export$2e2bcd8739ae039.apply(this, arguments);
}










var $8SyCD = parcelRequire("8SyCD");
var $2338d47b63de7f0d$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2338d47b63de7f0d$export$2e2bcd8739ae039 = $2338d47b63de7f0d$var$unitlessKeys;


var $23e17261a89a56a7$export$71ad59f2e432cfe8 = "-ms-";
var $23e17261a89a56a7$export$2c0f367103c8d01c = "-moz-";
var $23e17261a89a56a7$export$39dfd62a25e0fe93 = "-webkit-";
var $23e17261a89a56a7$export$a29989082612d0d9 = "comm";
var $23e17261a89a56a7$export$aa3a2e812ca8570d = "rule";
var $23e17261a89a56a7$export$527d108ccf083c2b = "decl";
var $23e17261a89a56a7$export$d3d35020fa5b54f0 = "@page";
var $23e17261a89a56a7$export$500415a86c544f73 = "@media";
var $23e17261a89a56a7$export$a763edbf796b780a = "@import";
var $23e17261a89a56a7$export$2790aeb8b4e5c826 = "@charset";
var $23e17261a89a56a7$export$1cc683e23b84b133 = "@viewport";
var $23e17261a89a56a7$export$9447a5efea57e862 = "@supports";
var $23e17261a89a56a7$export$ef011b4e114b1fba = "@document";
var $23e17261a89a56a7$export$6aad947bda0f3f46 = "@namespace";
var $23e17261a89a56a7$export$b44a8529a35fcb60 = "@keyframes";
var $23e17261a89a56a7$export$2c16de31893252e6 = "@font-face";
var $23e17261a89a56a7$export$3d846dd52e150c6f = "@counter-style";
var $23e17261a89a56a7$export$22314bfbb57653fe = "@font-feature-values";
var $23e17261a89a56a7$export$d773506282b3cfe6 = "@layer";
var $23e17261a89a56a7$export$2335f513bbd82c6d = Math.abs;
var $23e17261a89a56a7$export$6788812c4e6611e6 = String.fromCharCode;
var $23e17261a89a56a7$export$e6e34fd1f2686227 = Object.assign;
function $23e17261a89a56a7$export$d6af199866bfb566(e, r) {
    return $23e17261a89a56a7$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $23e17261a89a56a7$export$a9db5e087081082d(e, 0)) << 2 ^ $23e17261a89a56a7$export$a9db5e087081082d(e, 1)) << 2 ^ $23e17261a89a56a7$export$a9db5e087081082d(e, 2)) << 2 ^ $23e17261a89a56a7$export$a9db5e087081082d(e, 3) : 0;
}
function $23e17261a89a56a7$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $23e17261a89a56a7$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $23e17261a89a56a7$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $23e17261a89a56a7$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $23e17261a89a56a7$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $23e17261a89a56a7$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $23e17261a89a56a7$export$36776f635604f274(e) {
    return e.length;
}
function $23e17261a89a56a7$export$f9084667e487ed46(e) {
    return e.length;
}
function $23e17261a89a56a7$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $23e17261a89a56a7$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $23e17261a89a56a7$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$23e17261a89a56a7$export$4659b591c19bdf3d(e, r);
    });
}
var $23e17261a89a56a7$export$53f1d5ea8de3d7c = 1;
var $23e17261a89a56a7$export$4e0c71f277ca26b3 = 1;
var $23e17261a89a56a7$export$f24224f1c91d8156 = 0;
var $23e17261a89a56a7$export$5880b8b5730aff45 = 0;
var $23e17261a89a56a7$export$c0306caf338ac095 = 0;
var $23e17261a89a56a7$export$30a86d91af8ff6e6 = "";
function $23e17261a89a56a7$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $23e17261a89a56a7$export$53f1d5ea8de3d7c,
        column: $23e17261a89a56a7$export$4e0c71f277ca26b3,
        length: t,
        "return": "",
        siblings: u
    };
}
function $23e17261a89a56a7$export$784d13d8ee351f07(e, r) {
    return $23e17261a89a56a7$export$e6e34fd1f2686227($23e17261a89a56a7$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $23e17261a89a56a7$export$590e8b2c435046d9(e) {
    while(e.root)e = $23e17261a89a56a7$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $23e17261a89a56a7$export$10d8903dec122b9d(e, e.siblings);
}
function $23e17261a89a56a7$export$eba6f6f03b0a92e7() {
    return $23e17261a89a56a7$export$c0306caf338ac095;
}
function $23e17261a89a56a7$export$232faf9add678146() {
    $23e17261a89a56a7$export$c0306caf338ac095 = $23e17261a89a56a7$export$5880b8b5730aff45 > 0 ? $23e17261a89a56a7$export$a9db5e087081082d($23e17261a89a56a7$export$30a86d91af8ff6e6, --$23e17261a89a56a7$export$5880b8b5730aff45) : 0;
    if ($23e17261a89a56a7$export$4e0c71f277ca26b3--, $23e17261a89a56a7$export$c0306caf338ac095 === 10) $23e17261a89a56a7$export$4e0c71f277ca26b3 = 1, $23e17261a89a56a7$export$53f1d5ea8de3d7c--;
    return $23e17261a89a56a7$export$c0306caf338ac095;
}
function $23e17261a89a56a7$export$48cfd1e771a65c4f() {
    $23e17261a89a56a7$export$c0306caf338ac095 = $23e17261a89a56a7$export$5880b8b5730aff45 < $23e17261a89a56a7$export$f24224f1c91d8156 ? $23e17261a89a56a7$export$a9db5e087081082d($23e17261a89a56a7$export$30a86d91af8ff6e6, $23e17261a89a56a7$export$5880b8b5730aff45++) : 0;
    if ($23e17261a89a56a7$export$4e0c71f277ca26b3++, $23e17261a89a56a7$export$c0306caf338ac095 === 10) $23e17261a89a56a7$export$4e0c71f277ca26b3 = 1, $23e17261a89a56a7$export$53f1d5ea8de3d7c++;
    return $23e17261a89a56a7$export$c0306caf338ac095;
}
function $23e17261a89a56a7$export$4d3fb11e950abb9e() {
    return $23e17261a89a56a7$export$a9db5e087081082d($23e17261a89a56a7$export$30a86d91af8ff6e6, $23e17261a89a56a7$export$5880b8b5730aff45);
}
function $23e17261a89a56a7$export$e88cb2efb12ae807() {
    return $23e17261a89a56a7$export$5880b8b5730aff45;
}
function $23e17261a89a56a7$export$58adb3bec8346d0f(e, r) {
    return $23e17261a89a56a7$export$2f35ab04d2335697($23e17261a89a56a7$export$30a86d91af8ff6e6, e, r);
}
function $23e17261a89a56a7$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $23e17261a89a56a7$export$2de70f21292aac9e(e) {
    return $23e17261a89a56a7$export$53f1d5ea8de3d7c = $23e17261a89a56a7$export$4e0c71f277ca26b3 = 1, $23e17261a89a56a7$export$f24224f1c91d8156 = $23e17261a89a56a7$export$36776f635604f274($23e17261a89a56a7$export$30a86d91af8ff6e6 = e), $23e17261a89a56a7$export$5880b8b5730aff45 = 0, [];
}
function $23e17261a89a56a7$export$45918ac1574455b1(e) {
    return $23e17261a89a56a7$export$30a86d91af8ff6e6 = "", e;
}
function $23e17261a89a56a7$export$410ac95b9ec204b8(e) {
    return $23e17261a89a56a7$export$87c2784dc9fc4ab($23e17261a89a56a7$export$58adb3bec8346d0f($23e17261a89a56a7$export$5880b8b5730aff45 - 1, $23e17261a89a56a7$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $23e17261a89a56a7$export$660b2ee2d4fb4eff(e) {
    return $23e17261a89a56a7$export$45918ac1574455b1($23e17261a89a56a7$export$5f8c09e3ae6f64e1($23e17261a89a56a7$export$2de70f21292aac9e(e)));
}
function $23e17261a89a56a7$export$7af1228ff777d175(e) {
    while($23e17261a89a56a7$export$c0306caf338ac095 = $23e17261a89a56a7$export$4d3fb11e950abb9e())if ($23e17261a89a56a7$export$c0306caf338ac095 < 33) $23e17261a89a56a7$export$48cfd1e771a65c4f();
    else break;
    return $23e17261a89a56a7$export$9e1725a4cfeada27(e) > 2 || $23e17261a89a56a7$export$9e1725a4cfeada27($23e17261a89a56a7$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $23e17261a89a56a7$export$5f8c09e3ae6f64e1(e) {
    while($23e17261a89a56a7$export$48cfd1e771a65c4f())switch($23e17261a89a56a7$export$9e1725a4cfeada27($23e17261a89a56a7$export$c0306caf338ac095)){
        case 0:
            $23e17261a89a56a7$export$10d8903dec122b9d($23e17261a89a56a7$export$c2ab62c7bf24634($23e17261a89a56a7$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $23e17261a89a56a7$export$10d8903dec122b9d($23e17261a89a56a7$export$410ac95b9ec204b8($23e17261a89a56a7$export$c0306caf338ac095), e);
            break;
        default:
            $23e17261a89a56a7$export$10d8903dec122b9d($23e17261a89a56a7$export$6788812c4e6611e6($23e17261a89a56a7$export$c0306caf338ac095), e);
    }
    return e;
}
function $23e17261a89a56a7$export$955ba06d119e085e(e, r) {
    while(--r && $23e17261a89a56a7$export$48cfd1e771a65c4f())if ($23e17261a89a56a7$export$c0306caf338ac095 < 48 || $23e17261a89a56a7$export$c0306caf338ac095 > 102 || $23e17261a89a56a7$export$c0306caf338ac095 > 57 && $23e17261a89a56a7$export$c0306caf338ac095 < 65 || $23e17261a89a56a7$export$c0306caf338ac095 > 70 && $23e17261a89a56a7$export$c0306caf338ac095 < 97) break;
    return $23e17261a89a56a7$export$58adb3bec8346d0f(e, $23e17261a89a56a7$export$e88cb2efb12ae807() + (r < 6 && $23e17261a89a56a7$export$4d3fb11e950abb9e() == 32 && $23e17261a89a56a7$export$48cfd1e771a65c4f() == 32));
}
function $23e17261a89a56a7$export$c889f2fcc19dbf12(e) {
    while($23e17261a89a56a7$export$48cfd1e771a65c4f())switch($23e17261a89a56a7$export$c0306caf338ac095){
        case e:
            return $23e17261a89a56a7$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $23e17261a89a56a7$export$c889f2fcc19dbf12($23e17261a89a56a7$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $23e17261a89a56a7$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $23e17261a89a56a7$export$48cfd1e771a65c4f();
            break;
    }
    return $23e17261a89a56a7$export$5880b8b5730aff45;
}
function $23e17261a89a56a7$export$4254d4e2b3745c4c(e, r) {
    while($23e17261a89a56a7$export$48cfd1e771a65c4f())if (e + $23e17261a89a56a7$export$c0306caf338ac095 === 57) break;
    else if (e + $23e17261a89a56a7$export$c0306caf338ac095 === 84 && $23e17261a89a56a7$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $23e17261a89a56a7$export$58adb3bec8346d0f(r, $23e17261a89a56a7$export$5880b8b5730aff45 - 1) + "*" + $23e17261a89a56a7$export$6788812c4e6611e6(e === 47 ? e : $23e17261a89a56a7$export$48cfd1e771a65c4f());
}
function $23e17261a89a56a7$export$c2ab62c7bf24634(e) {
    while(!$23e17261a89a56a7$export$9e1725a4cfeada27($23e17261a89a56a7$export$4d3fb11e950abb9e()))$23e17261a89a56a7$export$48cfd1e771a65c4f();
    return $23e17261a89a56a7$export$58adb3bec8346d0f(e, $23e17261a89a56a7$export$5880b8b5730aff45);
}
function $23e17261a89a56a7$export$ef7acd7185315e22(e) {
    return $23e17261a89a56a7$export$45918ac1574455b1($23e17261a89a56a7$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $23e17261a89a56a7$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $23e17261a89a56a7$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $23e17261a89a56a7$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $23e17261a89a56a7$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($23e17261a89a56a7$export$f8e21b1e77979a08(j += $23e17261a89a56a7$export$77ad94ebf1c2b9ed($23e17261a89a56a7$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $23e17261a89a56a7$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $23e17261a89a56a7$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $23e17261a89a56a7$export$955ba06d119e085e($23e17261a89a56a7$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($23e17261a89a56a7$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $23e17261a89a56a7$export$10d8903dec122b9d($23e17261a89a56a7$export$4a34f930e789283c($23e17261a89a56a7$export$4254d4e2b3745c4c($23e17261a89a56a7$export$48cfd1e771a65c4f(), $23e17261a89a56a7$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $23e17261a89a56a7$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $23e17261a89a56a7$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $23e17261a89a56a7$export$36776f635604f274(j) - l) $23e17261a89a56a7$export$10d8903dec122b9d(p > 32 ? $23e17261a89a56a7$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $23e17261a89a56a7$export$f8483753829ec8f3($23e17261a89a56a7$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $23e17261a89a56a7$export$10d8903dec122b9d(y = $23e17261a89a56a7$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $23e17261a89a56a7$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $23e17261a89a56a7$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $23e17261a89a56a7$export$98e6a39c04603d36(e, y, y, n && $23e17261a89a56a7$export$10d8903dec122b9d($23e17261a89a56a7$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $23e17261a89a56a7$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $23e17261a89a56a7$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $23e17261a89a56a7$export$232faf9add678146() == 125) continue;
            }
            switch(j += $23e17261a89a56a7$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($23e17261a89a56a7$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($23e17261a89a56a7$export$4d3fb11e950abb9e() === 45) j += $23e17261a89a56a7$export$410ac95b9ec204b8($23e17261a89a56a7$export$48cfd1e771a65c4f());
                    v = $23e17261a89a56a7$export$4d3fb11e950abb9e(), o = l = $23e17261a89a56a7$export$36776f635604f274(k = j += $23e17261a89a56a7$export$c2ab62c7bf24634($23e17261a89a56a7$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $23e17261a89a56a7$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $23e17261a89a56a7$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $23e17261a89a56a7$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $23e17261a89a56a7$export$2f35ab04d2335697(e, p + 1, p = $23e17261a89a56a7$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $23e17261a89a56a7$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $23e17261a89a56a7$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $23e17261a89a56a7$export$35059013cd4a06db(e, r, a, s === 0 ? $23e17261a89a56a7$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $23e17261a89a56a7$export$4a34f930e789283c(e, r, a, c) {
    return $23e17261a89a56a7$export$35059013cd4a06db(e, r, a, $23e17261a89a56a7$export$a29989082612d0d9, $23e17261a89a56a7$export$6788812c4e6611e6($23e17261a89a56a7$export$eba6f6f03b0a92e7()), $23e17261a89a56a7$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $23e17261a89a56a7$export$f8483753829ec8f3(e, r, a, n, c) {
    return $23e17261a89a56a7$export$35059013cd4a06db(e, r, a, $23e17261a89a56a7$export$527d108ccf083c2b, $23e17261a89a56a7$export$2f35ab04d2335697(e, 0, n), $23e17261a89a56a7$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $23e17261a89a56a7$export$82e9f45cca5ba907(n, c, s) {
    switch($23e17261a89a56a7$export$d6af199866bfb566(n, c)){
        case 5103:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $23e17261a89a56a7$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$2c0f367103c8d01c + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($23e17261a89a56a7$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "box-$1$2" + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "flex-item-" + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$23e17261a89a56a7$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $23e17261a89a56a7$export$71ad59f2e432cfe8 + "grid-row-" + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "flex-line-pack" + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + "box-" + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "-grow", "") + $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $23e17261a89a56a7$export$39dfd62a25e0fe93 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed($23e17261a89a56a7$export$77ad94ebf1c2b9ed($23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed($23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "box-pack:$3" + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $23e17261a89a56a7$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$23e17261a89a56a7$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $23e17261a89a56a7$export$71ad59f2e432cfe8 + "grid-column-align" + $23e17261a89a56a7$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $23e17261a89a56a7$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$23e17261a89a56a7$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$23e17261a89a56a7$export$f8e21b1e77979a08(s, "span") ? $23e17261a89a56a7$export$4659b591c19bdf3d(s, /\d+/) : +$23e17261a89a56a7$export$4659b591c19bdf3d(s, /\d+/) - +$23e17261a89a56a7$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $23e17261a89a56a7$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $23e17261a89a56a7$export$71ad59f2e432cfe8 + $23e17261a89a56a7$export$77ad94ebf1c2b9ed($23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($23e17261a89a56a7$export$36776f635604f274(n) - 1 - c > 6) switch($23e17261a89a56a7$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($23e17261a89a56a7$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $23e17261a89a56a7$export$2c0f367103c8d01c + ($23e17261a89a56a7$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$23e17261a89a56a7$export$f8e21b1e77979a08(n, "stretch") ? $23e17261a89a56a7$export$82e9f45cca5ba907($23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $23e17261a89a56a7$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $23e17261a89a56a7$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($23e17261a89a56a7$export$a9db5e087081082d(n, c + 6) === 121) return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, ":", ":" + $23e17261a89a56a7$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($23e17261a89a56a7$export$a9db5e087081082d(n, $23e17261a89a56a7$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $23e17261a89a56a7$export$39dfd62a25e0fe93 + ($23e17261a89a56a7$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $23e17261a89a56a7$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $23e17261a89a56a7$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, ":", ":" + $23e17261a89a56a7$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $23e17261a89a56a7$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $23e17261a89a56a7$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $23e17261a89a56a7$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $23e17261a89a56a7$export$a763edbf796b780a:
        case $23e17261a89a56a7$export$527d108ccf083c2b:
            return e["return"] = e["return"] || e.value;
        case $23e17261a89a56a7$export$a29989082612d0d9:
            return "";
        case $23e17261a89a56a7$export$b44a8529a35fcb60:
            return e["return"] = e.value + "{" + $23e17261a89a56a7$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $23e17261a89a56a7$export$aa3a2e812ca8570d:
            if (!$23e17261a89a56a7$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $23e17261a89a56a7$export$36776f635604f274(a = $23e17261a89a56a7$export$dfdc1655ccc5b9cb(e.children, t)) ? e["return"] = e.value + "{" + a + "}" : "";
}
function $23e17261a89a56a7$export$5a7767152ae0305f(e) {
    var r = $23e17261a89a56a7$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $23e17261a89a56a7$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r["return"]) e(r);
        }
    };
}
function $23e17261a89a56a7$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n["return"]) switch(n.type){
            case $23e17261a89a56a7$export$527d108ccf083c2b:
                n["return"] = $23e17261a89a56a7$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $23e17261a89a56a7$export$b44a8529a35fcb60:
                return $23e17261a89a56a7$export$dfdc1655ccc5b9cb([
                    $23e17261a89a56a7$export$784d13d8ee351f07(n, {
                        value: $23e17261a89a56a7$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $23e17261a89a56a7$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $23e17261a89a56a7$export$aa3a2e812ca8570d:
                if (n.length) return $23e17261a89a56a7$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($23e17261a89a56a7$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    $23e17261a89a56a7$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $23e17261a89a56a7$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $23e17261a89a56a7$export$e6e34fd1f2686227(n, {
                                props: $23e17261a89a56a7$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    $23e17261a89a56a7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $23e17261a89a56a7$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    $23e17261a89a56a7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $23e17261a89a56a7$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    $23e17261a89a56a7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $23e17261a89a56a7$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $23e17261a89a56a7$export$590e8b2c435046d9($23e17261a89a56a7$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $23e17261a89a56a7$export$e6e34fd1f2686227(n, {
                                props: $23e17261a89a56a7$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $23e17261a89a56a7$export$76a88f7de6507443(e) {
    switch(e.type){
        case $23e17261a89a56a7$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $23e17261a89a56a7$export$1be1fc439b849fdf($23e17261a89a56a7$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($23e17261a89a56a7$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $23e17261a89a56a7$export$2f35ab04d2335697(r, 1, $23e17261a89a56a7$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $23e17261a89a56a7$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $23e17261a89a56a7$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $23e17261a89a56a7$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



function $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : "").concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}


var $ee800512f23a21f8$var$linter = function linter(key, value, info) {
    if (key === "content") {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            "normal",
            "none",
            "initial",
            "inherit",
            "unset"
        ];
        if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $ee800512f23a21f8$export$2e2bcd8739ae039 = $ee800512f23a21f8$var$linter;



var $9095ce0d7f0d050f$var$linter = function linter(key, value, info) {
    if (key === "animation") {
        if (info.hashId && value !== "none") (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $9095ce0d7f0d050f$export$2e2bcd8739ae039 = $9095ce0d7f0d050f$var$linter;



function $ddb2673872794fda$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || "";
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $ddb2673872794fda$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes("&") ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, "");
}
var $ddb2673872794fda$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $ddb2673872794fda$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($ddb2673872794fda$var$isConcatSelector)) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("Concat ':not' selector not support in legacy browsers.", info);
};
var $ddb2673872794fda$export$2e2bcd8739ae039 = $ddb2673872794fda$var$linter;



var $5257edf9a0451136$var$linter = function linter(key, value, info) {
    switch(key){
        case "marginLeft":
        case "marginRight":
        case "paddingLeft":
        case "paddingRight":
        case "left":
        case "right":
        case "borderLeft":
        case "borderLeftWidth":
        case "borderLeftStyle":
        case "borderLeftColor":
        case "borderRight":
        case "borderRightWidth":
        case "borderRightStyle":
        case "borderRightColor":
        case "borderTopLeftRadius":
        case "borderTopRightRadius":
        case "borderBottomLeftRadius":
        case "borderBottomRightRadius":
            (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "margin":
        case "padding":
        case "borderWidth":
        case "borderStyle":
            // case 'borderColor':
            if (typeof value === "string") {
                var valueArr = value.split(" ").map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case "clear":
        case "textAlign":
            if (value === "left" || value === "right") (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "borderRadius":
            if (typeof value === "string") {
                var radiusGroups = value.split("/").map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(" ").map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $5257edf9a0451136$export$2e2bcd8739ae039 = $5257edf9a0451136$var$linter;



var $1586c9dbc93ee7ed$var$linter = function linter(key, value, info) {
    if (typeof value === "string" && /NaN/g.test(value) || Number.isNaN(value)) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $1586c9dbc93ee7ed$export$2e2bcd8739ae039 = $1586c9dbc93ee7ed$var$linter;



var $8ccdb63b34651693$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(",");
        return selectors.some(function(item) {
            return item.split("&").length > 2;
        });
    })) (0, $e65b1f7b8ab54f1d$export$e7b7955c4f1f8c03)("Should not use more than one `&` in a selector.", info);
};
var $8ccdb63b34651693$export$2e2bcd8739ae039 = $8ccdb63b34651693$var$linter;









var $1ebaa75500ff28a9$export$1c054aa01963e47e = "data-ant-cssinjs-cache-path";
var $1ebaa75500ff28a9$export$e0a2f8ff7fc63361 = "_FILE_STYLE__";
function $1ebaa75500ff28a9$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(";");
}
var $1ebaa75500ff28a9$var$cachePathMap;
var $1ebaa75500ff28a9$var$fromCSSFile = true;
function $1ebaa75500ff28a9$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $1ebaa75500ff28a9$var$cachePathMap = mockCache;
    $1ebaa75500ff28a9$var$fromCSSFile = fromFile;
}
function $1ebaa75500ff28a9$export$18298bb220d85216() {
    if (!$1ebaa75500ff28a9$var$cachePathMap) {
        $1ebaa75500ff28a9$var$cachePathMap = {};
        if ((0, $014625af273be671$export$2e2bcd8739ae039)()) {
            var div = document.createElement("div");
            div.className = $1ebaa75500ff28a9$export$1c054aa01963e47e;
            div.style.position = "fixed";
            div.style.visibility = "hidden";
            div.style.top = "-9999px";
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || "";
            content = content.replace(/^"/, "").replace(/"$/, "");
            // Fill data
            content.split(";").forEach(function(item) {
                var _item$split = item.split(":"), _item$split2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $1ebaa75500ff28a9$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($1ebaa75500ff28a9$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $1ebaa75500ff28a9$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $1ebaa75500ff28a9$export$5aa0d776d676ab98(path) {
    $1ebaa75500ff28a9$export$18298bb220d85216();
    return !!$1ebaa75500ff28a9$var$cachePathMap[path];
}
function $1ebaa75500ff28a9$export$d3851dfd3659b2ce(path) {
    var hash = $1ebaa75500ff28a9$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $014625af273be671$export$2e2bcd8739ae039)()) {
        if ($1ebaa75500ff28a9$var$fromCSSFile) styleStr = $1ebaa75500ff28a9$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $812e58228ca1c244$export$89ce1123b3c0bd9e), '="').concat($1ebaa75500ff28a9$var$cachePathMap[path], '"]'));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $1ebaa75500ff28a9$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



var $d21f66fac4f2a7ee$var$SKIP_CHECK = "_skip_check_";
var $d21f66fac4f2a7ee$var$MULTI_VALUE = "_multi_value_";
function $d21f66fac4f2a7ee$export$8756898546458274(styleStr) {
    var serialized = (0, $23e17261a89a56a7$export$dfdc1655ccc5b9cb)((0, $23e17261a89a56a7$export$ef7acd7185315e22)(styleStr), (0, $23e17261a89a56a7$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function $d21f66fac4f2a7ee$var$isCompoundCSSProperty(value) {
    return (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(value) === "object" && value && ($d21f66fac4f2a7ee$var$SKIP_CHECK in value || $d21f66fac4f2a7ee$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $d21f66fac4f2a7ee$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(",").map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || "";
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(fullPath.slice(1))).join(" ");
    });
    return keys.join(",");
}
var $d21f66fac4f2a7ee$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = "";
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === "string" && !root ? {} : originStyle;
        if (typeof style === "string") styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(value) === "object" && value && (key !== "animationName" || !value._keyframe) && !$d21f66fac4f2a7ee$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith("@")) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else // 注入 hashId
                        mergedKey = $d21f66fac4f2a7ee$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = "";
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var appendStyle = function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $2338d47b63de7f0d$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === "number" && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    };
                    var _value;
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(value) === "object" && value !== null && value !== void 0 && value[$d21f66fac4f2a7ee$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer && (0, $d345e6062a3ed2bd$export$ac8d3fd9840e20dd)()) {
        var layerCells = layer.split(",");
        var layerName = layerCells[layerCells.length - 1].trim();
        styleStr = "@layer ".concat(layerName, " {").concat(styleStr, "}");
        // Order of layer if needed
        if (layerCells.length > 1) // zombieJ: stylis do not support layer order, so we need to handle it manually.
        styleStr = "@layer ".concat(layer, "{%%%:%}").concat(styleStr);
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $d21f66fac4f2a7ee$export$412618713057f6ca(path, styleStr) {
    return (0, $1090c7b9e53914a6$export$2e2bcd8739ae039)("".concat(path.join("%")).concat(styleStr));
}
function $d21f66fac4f2a7ee$var$Empty() {
    return null;
}
var $d21f66fac4f2a7ee$export$1e6d9f0d06c7ec14 = "style";
function $d21f66fac4f2a7ee$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $8SyCD.useContext((0, $812e58228ca1c244$export$2e2bcd8739ae039)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $d345e6062a3ed2bd$export$9542afab8c2a5f48);
    var _useGlobalCache = (0, $7da64a9610f301db$export$2e2bcd8739ae039)($d21f66fac4f2a7ee$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join("|");
        // Get style from SSR inline style directly
        if ((0, $1ebaa75500ff28a9$export$5aa0d776d676ab98)(cachePath)) {
            var _getStyleAndHash = (0, $1ebaa75500ff28a9$export$d3851dfd3659b2ce)(cachePath), _getStyleAndHash2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $d21f66fac4f2a7ee$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: layer,
            path: path.join("-"),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $d21f66fac4f2a7ee$export$8756898546458274(parsedStyle);
        var styleId = $d21f66fac4f2a7ee$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $d345e6062a3ed2bd$export$9542afab8c2a5f48)) (0, $0c499bcbbdb3e2de$export$2232e336aecaa80a)(styleId, {
            mark: (0, $812e58228ca1c244$export$89ce1123b3c0bd9e)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $1ebaa75500ff28a9$export$e0a2f8ff7fc63361)) {
            var mergedCSSConfig = {
                mark: (0, $812e58228ca1c244$export$89ce1123b3c0bd9e),
                prepend: "queue",
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === "function" ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            var style = (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $812e58228ca1c244$export$4c16a0c02134a7dc] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $812e58228ca1c244$export$5d99297dcd5476ac), tokenKey);
            // Inject client side effect style
            Object.keys(effectStyle).forEach(function(effectKey) {
                (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)($d21f66fac4f2a7ee$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $8SyCD.createElement($d21f66fac4f2a7ee$var$Empty, null);
        else {
            var _ref6;
            styleNode = /*#__PURE__*/ $8SyCD.createElement("style", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, (_ref6 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref6, (0, $812e58228ca1c244$export$5d99297dcd5476ac), cachedTokenKey), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref6, (0, $812e58228ca1c244$export$89ce1123b3c0bd9e), cachedStyleId), _ref6), {
                dangerouslySetInnerHTML: {
                    __html: cachedStyleStr
                }
            }));
        }
        return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, styleNode, node);
    };
}
var $d21f66fac4f2a7ee$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    keyStyleText = (0, $d345e6062a3ed2bd$export$71c98ec84f0481d3)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $d21f66fac4f2a7ee$export$8756898546458274(effectStyle[effectKey]);
            keyStyleText += (0, $d345e6062a3ed2bd$export$71c98ec84f0481d3)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


var $a4a27af22c478547$export$d96c342855c5e1fc = "cssVar";
var $a4a27af22c478547$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? "" : _config$scope;
    var _useContext = (0, $8SyCD.useContext)((0, $812e58228ca1c244$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $7da64a9610f301db$export$2e2bcd8739ae039)($a4a27af22c478547$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $225107b77a38e2c5$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $d21f66fac4f2a7ee$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 3), styleId = _ref2[2];
        if (0, $d345e6062a3ed2bd$export$9542afab8c2a5f48) (0, $0c499bcbbdb3e2de$export$2232e336aecaa80a)(styleId, {
            mark: (0, $812e58228ca1c244$export$89ce1123b3c0bd9e)
        });
    }, function(_ref3) {
        var _ref4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $812e58228ca1c244$export$89ce1123b3c0bd9e),
            prepend: "queue",
            attachTo: container,
            priority: -999
        });
        style[0, $812e58228ca1c244$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $812e58228ca1c244$export$5d99297dcd5476ac), key);
    });
    return cache;
};
var $a4a27af22c478547$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $d345e6062a3ed2bd$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $a4a27af22c478547$export$2e2bcd8739ae039 = $a4a27af22c478547$var$useCSSVarRegister;





var $2db90891d4921517$var$_ExtractStyleFns;
var $2db90891d4921517$var$ExtractStyleFns = ($2db90891d4921517$var$_ExtractStyleFns = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($2db90891d4921517$var$_ExtractStyleFns, (0, $d21f66fac4f2a7ee$export$1e6d9f0d06c7ec14), (0, $d21f66fac4f2a7ee$export$f9380c9a627682d3)), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($2db90891d4921517$var$_ExtractStyleFns, (0, $1027e04a58b2ac6d$export$270fba097347f4fa), (0, $1027e04a58b2ac6d$export$f9380c9a627682d3)), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($2db90891d4921517$var$_ExtractStyleFns, (0, $a4a27af22c478547$export$d96c342855c5e1fc), (0, $a4a27af22c478547$export$f9380c9a627682d3)), $2db90891d4921517$var$_ExtractStyleFns);
function $2db90891d4921517$var$isNotNull(value) {
    return value !== null;
}
function $2db90891d4921517$export$2e2bcd8739ae039(cache) {
    var plain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var matchPrefixRegexp = new RegExp("^(".concat(Object.keys($2db90891d4921517$var$ExtractStyleFns).join("|"), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = "";
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, "").replace(/%/g, "|");
        var _key$split = key.split("%"), _key$split2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $2db90891d4921517$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith("style")) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($2db90891d4921517$var$isNotNull).sort(function(_ref, _ref2) {
        var _ref3 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 1), o1 = _ref3[0];
        var _ref4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref2, 1), o2 = _ref4[0];
        return o1 - o2;
    }).forEach(function(_ref5) {
        var _ref6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref5, 2), style = _ref6[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $d345e6062a3ed2bd$export$71c98ec84f0481d3)(".".concat((0, $1ebaa75500ff28a9$export$1c054aa01963e47e), '{content:"').concat((0, $1ebaa75500ff28a9$export$dfdc1655ccc5b9cb)(cachePathMap), '";}'), undefined, undefined, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, (0, $1ebaa75500ff28a9$export$1c054aa01963e47e), (0, $1ebaa75500ff28a9$export$1c054aa01963e47e)), plain);
    return styleText;
}








var $e58e9423190bd08e$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, Keyframe);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "name", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "style", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $e58e9423190bd08e$export$2e2bcd8739ae039 = $e58e9423190bd08e$var$Keyframe;






function $15001a1fc1b91065$var$splitValues(value) {
    if (typeof value === "number") return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = "";
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes("(")) {
                temp += item;
                brackets += item.split("(").length - 1;
            } else if (item.includes(")")) {
                temp += item;
                brackets -= item.split(")").length - 1;
                if (brackets === 0) {
                    list.push(temp);
                    temp = "";
                }
            } else if (brackets > 0) temp += item;
            else list.push(item);
            return list;
        }, []),
        !!importantCells
    ];
}
function $15001a1fc1b91065$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $15001a1fc1b91065$var$keyMap = {
    // Inset
    inset: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    insetBlock: [
        "top",
        "bottom"
    ],
    insetBlockStart: [
        "top"
    ],
    insetBlockEnd: [
        "bottom"
    ],
    insetInline: [
        "left",
        "right"
    ],
    insetInlineStart: [
        "left"
    ],
    insetInlineEnd: [
        "right"
    ],
    // Margin
    marginBlock: [
        "marginTop",
        "marginBottom"
    ],
    marginBlockStart: [
        "marginTop"
    ],
    marginBlockEnd: [
        "marginBottom"
    ],
    marginInline: [
        "marginLeft",
        "marginRight"
    ],
    marginInlineStart: [
        "marginLeft"
    ],
    marginInlineEnd: [
        "marginRight"
    ],
    // Padding
    paddingBlock: [
        "paddingTop",
        "paddingBottom"
    ],
    paddingBlockStart: [
        "paddingTop"
    ],
    paddingBlockEnd: [
        "paddingBottom"
    ],
    paddingInline: [
        "paddingLeft",
        "paddingRight"
    ],
    paddingInlineStart: [
        "paddingLeft"
    ],
    paddingInlineEnd: [
        "paddingRight"
    ],
    // Border
    borderBlock: $15001a1fc1b91065$var$noSplit([
        "borderTop",
        "borderBottom"
    ]),
    borderBlockStart: $15001a1fc1b91065$var$noSplit([
        "borderTop"
    ]),
    borderBlockEnd: $15001a1fc1b91065$var$noSplit([
        "borderBottom"
    ]),
    borderInline: $15001a1fc1b91065$var$noSplit([
        "borderLeft",
        "borderRight"
    ]),
    borderInlineStart: $15001a1fc1b91065$var$noSplit([
        "borderLeft"
    ]),
    borderInlineEnd: $15001a1fc1b91065$var$noSplit([
        "borderRight"
    ]),
    // Border width
    borderBlockWidth: [
        "borderTopWidth",
        "borderBottomWidth"
    ],
    borderBlockStartWidth: [
        "borderTopWidth"
    ],
    borderBlockEndWidth: [
        "borderBottomWidth"
    ],
    borderInlineWidth: [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    borderInlineStartWidth: [
        "borderLeftWidth"
    ],
    borderInlineEndWidth: [
        "borderRightWidth"
    ],
    // Border style
    borderBlockStyle: [
        "borderTopStyle",
        "borderBottomStyle"
    ],
    borderBlockStartStyle: [
        "borderTopStyle"
    ],
    borderBlockEndStyle: [
        "borderBottomStyle"
    ],
    borderInlineStyle: [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    borderInlineStartStyle: [
        "borderLeftStyle"
    ],
    borderInlineEndStyle: [
        "borderRightStyle"
    ],
    // Border color
    borderBlockColor: [
        "borderTopColor",
        "borderBottomColor"
    ],
    borderBlockStartColor: [
        "borderTopColor"
    ],
    borderBlockEndColor: [
        "borderBottomColor"
    ],
    borderInlineColor: [
        "borderLeftColor",
        "borderRightColor"
    ],
    borderInlineStartColor: [
        "borderLeftColor"
    ],
    borderInlineEndColor: [
        "borderRightColor"
    ],
    // Border radius
    borderStartStartRadius: [
        "borderTopLeftRadius"
    ],
    borderStartEndRadius: [
        "borderTopRightRadius"
    ],
    borderEndStartRadius: [
        "borderBottomLeftRadius"
    ],
    borderEndEndRadius: [
        "borderBottomRightRadius"
    ]
};
function $15001a1fc1b91065$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $15001a1fc1b91065$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $15001a1fc1b91065$var$keyMap[key];
            if (matchValue && (typeof value === "number" || typeof value === "string")) {
                var _splitValues = $15001a1fc1b91065$var$splitValues(value), _splitValues2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $15001a1fc1b91065$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $15001a1fc1b91065$var$wrapImportantAndSkipCheck(value, _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $15001a1fc1b91065$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $15001a1fc1b91065$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $15001a1fc1b91065$export$2e2bcd8739ae039 = $15001a1fc1b91065$var$transform;





var $9c13818e82137130$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $9c13818e82137130$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $9c13818e82137130$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $9c13818e82137130$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === "string" && value.includes("px")) {
                var newValue = value.replace($9c13818e82137130$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $2338d47b63de7f0d$export$2e2bcd8739ae039)[key] && typeof value === "number" && value !== 0) clone[key] = "".concat(value, "px").replace($9c13818e82137130$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith("@") && mergedKey.includes("px") && mediaQuery) {
                var newKey = key.replace($9c13818e82137130$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $9c13818e82137130$export$2e2bcd8739ae039 = $9c13818e82137130$var$transform;




var $c974dd1cf61f4fb8$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $d345e6062a3ed2bd$export$f51d3b8ac4ac9ed1)() && (0, $d345e6062a3ed2bd$export$64a912f57d5de48e)();
    }
};



var $8SyCD = parcelRequire("8SyCD");
var $c42b58850f71819f$var$IconContext = /*#__PURE__*/ (0, $8SyCD.createContext)({});
var $c42b58850f71819f$export$2e2bcd8739ae039 = $c42b58850f71819f$var$IconContext;










function $a34941462ba6474a$export$2e2bcd8739ae039(arr) {
    return (0, $d48bf3967eb7347a$export$2e2bcd8739ae039)(arr) || (0, $cb221cbac1b37255$export$2e2bcd8739ae039)(arr) || (0, $5e35c2f511a546c9$export$2e2bcd8739ae039)(arr) || (0, $6673e9e9f1a6e057$export$2e2bcd8739ae039)();
}


function $16b08fc4c83b8dcc$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}


function $d5357cacfbc573f6$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $a34941462ba6474a$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(entity);
    else clone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $d5357cacfbc573f6$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $d5357cacfbc573f6$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $d5357cacfbc573f6$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $d5357cacfbc573f6$var$isObject(obj) {
    return (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $d5357cacfbc573f6$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $d5357cacfbc573f6$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $d5357cacfbc573f6$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $d5357cacfbc573f6$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $d5357cacfbc573f6$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $d5357cacfbc573f6$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(originValue) !== "object") // Init container if not exist
                    clone = $d5357cacfbc573f6$export$2e2bcd8739ae039(clone, path, $d5357cacfbc573f6$var$createEmpty(value));
                    $d5357cacfbc573f6$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $d5357cacfbc573f6$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



var $8SyCD = parcelRequire("8SyCD");

function $a45ff4e670d5554a$export$8793edee2d425525() {}
var $a45ff4e670d5554a$var$deprecatedWarnList = null;
function $a45ff4e670d5554a$export$60eef1277fe463e4() {
    $a45ff4e670d5554a$var$deprecatedWarnList = null;
    (0, $ed6f30969113606c$export$60eef1277fe463e4)();
}
// eslint-disable-next-line import/no-mutable-exports
var $a45ff4e670d5554a$var$warning = $a45ff4e670d5554a$export$8793edee2d425525;
var $a45ff4e670d5554a$var$valid, $a45ff4e670d5554a$var$component, $a45ff4e670d5554a$var$message;
var $a45ff4e670d5554a$export$11b88c75b33aa1fd = /*#__PURE__*/ $8SyCD.createContext({});
var $a45ff4e670d5554a$export$cf977aa92c751e61 = function() {
    var noopWarning = function() {};
    noopWarning.deprecated = $a45ff4e670d5554a$export$8793edee2d425525;
    return noopWarning;
};
var $a45ff4e670d5554a$export$2e2bcd8739ae039 = $a45ff4e670d5554a$var$warning;



var $8SyCD = parcelRequire("8SyCD");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$6babfaa939aeeb39$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8SyCD.createContext)(undefined);



var $8SyCD = parcelRequire("8SyCD");

/* eslint-disable no-template-curly-in-string */ var $cc78bc78ccbd9379$var$locale = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};
var $cc78bc78ccbd9379$export$2e2bcd8739ae039 = $cc78bc78ccbd9379$var$locale;


var $87045a7d0eda9d8e$var$locale = {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $87045a7d0eda9d8e$export$2e2bcd8739ae039 = $87045a7d0eda9d8e$var$locale;


var $1e928e30d46a4a01$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $1e928e30d46a4a01$export$2e2bcd8739ae039 = $1e928e30d46a4a01$var$locale;


// Merge into a locale object
var $8fceb48b49e824dd$var$locale = {
    lang: Object.assign({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ]
    }, (0, $87045a7d0eda9d8e$export$2e2bcd8739ae039)),
    timePickerLocale: Object.assign({}, (0, $1e928e30d46a4a01$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$8fceb48b49e824dd$export$2e2bcd8739ae039 = $8fceb48b49e824dd$var$locale;


var $651632db00dbbfa1$export$2e2bcd8739ae039 = (0, $8fceb48b49e824dd$export$2e2bcd8739ae039);




var $32f46d71751d4424$var$typeTemplate = "${label} is not a valid ${type}";
var $32f46d71751d4424$var$localeValues = {
    locale: "en",
    Pagination: (0, $cc78bc78ccbd9379$export$2e2bcd8739ae039),
    DatePicker: (0, $8fceb48b49e824dd$export$2e2bcd8739ae039),
    TimePicker: (0, $1e928e30d46a4a01$export$2e2bcd8739ae039),
    Calendar: (0, $651632db00dbbfa1$export$2e2bcd8739ae039),
    global: {
        placeholder: "Please select"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckall: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Tour: {
        Next: "Next",
        Previous: "Previous",
        Finish: "Finish"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand"
    },
    PageHeader: {
        back: "Back"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            "default": "Field validation error for ${label}",
            required: "Please enter ${label}",
            "enum": "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $32f46d71751d4424$var$typeTemplate,
                method: $32f46d71751d4424$var$typeTemplate,
                array: $32f46d71751d4424$var$typeTemplate,
                object: $32f46d71751d4424$var$typeTemplate,
                number: $32f46d71751d4424$var$typeTemplate,
                date: $32f46d71751d4424$var$typeTemplate,
                boolean: $32f46d71751d4424$var$typeTemplate,
                integer: $32f46d71751d4424$var$typeTemplate,
                float: $32f46d71751d4424$var$typeTemplate,
                regexp: $32f46d71751d4424$var$typeTemplate,
                email: $32f46d71751d4424$var$typeTemplate,
                url: $32f46d71751d4424$var$typeTemplate,
                hex: $32f46d71751d4424$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    Image: {
        preview: "Preview"
    },
    QRCode: {
        expired: "QR code expired",
        refresh: "Refresh"
    },
    ColorPicker: {
        presetEmpty: "Empty"
    }
};
var $32f46d71751d4424$export$2e2bcd8739ae039 = $32f46d71751d4424$var$localeValues;


"use client";
var $0e0c8f184d62e3a6$var$runtimeLocale = Object.assign({}, (0, $32f46d71751d4424$export$2e2bcd8739ae039).Modal);
var $0e0c8f184d62e3a6$var$localeList = [];
var $0e0c8f184d62e3a6$var$generateLocale = function() {
    return $0e0c8f184d62e3a6$var$localeList.reduce(function(merged, locale) {
        return Object.assign(Object.assign({}, merged), locale);
    }, (0, $32f46d71751d4424$export$2e2bcd8739ae039).Modal);
};
function $0e0c8f184d62e3a6$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        var cloneLocale = Object.assign({}, newLocale);
        $0e0c8f184d62e3a6$var$localeList.push(cloneLocale);
        $0e0c8f184d62e3a6$var$runtimeLocale = $0e0c8f184d62e3a6$var$generateLocale();
        return function() {
            $0e0c8f184d62e3a6$var$localeList = $0e0c8f184d62e3a6$var$localeList.filter(function(locale) {
                return locale !== cloneLocale;
            });
            $0e0c8f184d62e3a6$var$runtimeLocale = $0e0c8f184d62e3a6$var$generateLocale();
        };
    }
    $0e0c8f184d62e3a6$var$runtimeLocale = Object.assign({}, (0, $32f46d71751d4424$export$2e2bcd8739ae039).Modal);
}
function $0e0c8f184d62e3a6$export$1b6004afda18cd51() {
    return $0e0c8f184d62e3a6$var$runtimeLocale;
}



var $8SyCD = parcelRequire("8SyCD");
var $e191ee49d7dd1877$var$LocaleContext = /*#__PURE__*/ (0, $8SyCD.createContext)(undefined);
var $e191ee49d7dd1877$export$2e2bcd8739ae039 = $e191ee49d7dd1877$var$LocaleContext;



var $8SyCD = parcelRequire("8SyCD");


var $57e602fd4d8f074b$var$useLocale = function(componentName, defaultLocale) {
    var fullLocale = $8SyCD.useContext((0, $e191ee49d7dd1877$export$2e2bcd8739ae039));
    var getLocale = $8SyCD.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $32f46d71751d4424$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    var getLocaleCode = $8SyCD.useMemo(function() {
        var localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $32f46d71751d4424$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $57e602fd4d8f074b$export$2e2bcd8739ae039 = $57e602fd4d8f074b$var$useLocale;


"use client";
var $ffdafc34f27b75e9$export$b2f162cd5c15ea3e = "internalMark";
var $ffdafc34f27b75e9$var$LocaleProvider = function(props) {
    var _props_locale = props.locale, locale = _props_locale === void 0 ? {} : _props_locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    $8SyCD.useEffect(function() {
        var clearLocale = (0, $0e0c8f184d62e3a6$export$9485ecb9d81a550c)(locale && locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    var getMemoizedContextValue = $8SyCD.useMemo(function() {
        return Object.assign(Object.assign({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $e191ee49d7dd1877$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $ffdafc34f27b75e9$export$2e2bcd8739ae039 = $ffdafc34f27b75e9$var$LocaleProvider;





var $8SyCD = parcelRequire("8SyCD");

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ /**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $ccaafa3c9f83636a$export$b0e60b43d1d059f0(n, max) {
    if ($ccaafa3c9f83636a$export$7bf7d6849640691b(n)) n = "100%";
    var isPercent = $ccaafa3c9f83636a$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $ccaafa3c9f83636a$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $ccaafa3c9f83636a$export$7bf7d6849640691b(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function $ccaafa3c9f83636a$export$d86432a85610ea90(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
}
function $ccaafa3c9f83636a$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $ccaafa3c9f83636a$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $ccaafa3c9f83636a$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? "0" + c : String(c);
}


function $235be27093016177$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $235be27093016177$export$c85ca4f4753af384(r, g, b) {
    r = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $235be27093016177$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $235be27093016177$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $235be27093016177$var$hue2rgb(p, q, h + 1 / 3);
        g = $235be27093016177$var$hue2rgb(p, q, h);
        b = $235be27093016177$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $235be27093016177$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $235be27093016177$export$210753cfeec758a5(h, s, v) {
    h = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $235be27093016177$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
function $235be27093016177$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)($235be27093016177$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
function $235be27093016177$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)($235be27093016177$export$51dcdea396f3aff6(a)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ccaafa3c9f83636a$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join("");
}
function $235be27093016177$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $235be27093016177$export$616da979ad1c2414(h) {
    return $235be27093016177$export$262b3ba788b4d07c(h) / 255;
}
function $235be27093016177$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $235be27093016177$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $351fed76e763600d$export$e4b2ac9215619f8d = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};



function $7b3605043e423ec8$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") color = $7b3605043e423ec8$export$56237d872eed15a0(color);
    if (typeof color === "object") {
        if ($7b3605043e423ec8$export$80d4d71a83d4526d(color.r) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.g) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $235be27093016177$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($7b3605043e423ec8$export$80d4d71a83d4526d(color.h) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.s) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.v)) {
            s = (0, $ccaafa3c9f83636a$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $ccaafa3c9f83636a$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $235be27093016177$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($7b3605043e423ec8$export$80d4d71a83d4526d(color.h) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.s) && $7b3605043e423ec8$export$80d4d71a83d4526d(color.l)) {
            s = (0, $ccaafa3c9f83636a$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $ccaafa3c9f83636a$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $235be27093016177$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) a = color.a;
    }
    a = (0, $ccaafa3c9f83636a$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $7b3605043e423ec8$var$CSS_INTEGER = "[-\\+]?\\d+%?";
// <http://www.w3.org/TR/css3-values/#number-value>
var $7b3605043e423ec8$var$CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $7b3605043e423ec8$var$CSS_UNIT = "(?:".concat($7b3605043e423ec8$var$CSS_NUMBER, ")|(?:").concat($7b3605043e423ec8$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $7b3605043e423ec8$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($7b3605043e423ec8$var$CSS_UNIT, ")[,|\\s]+(").concat($7b3605043e423ec8$var$CSS_UNIT, ")[,|\\s]+(").concat($7b3605043e423ec8$var$CSS_UNIT, ")\\s*\\)?");
var $7b3605043e423ec8$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($7b3605043e423ec8$var$CSS_UNIT, ")[,|\\s]+(").concat($7b3605043e423ec8$var$CSS_UNIT, ")[,|\\s]+(").concat($7b3605043e423ec8$var$CSS_UNIT, ")[,|\\s]+(").concat($7b3605043e423ec8$var$CSS_UNIT, ")\\s*\\)?");
var $7b3605043e423ec8$var$matchers = {
    CSS_UNIT: new RegExp($7b3605043e423ec8$var$CSS_UNIT),
    rgb: new RegExp("rgb" + $7b3605043e423ec8$var$PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + $7b3605043e423ec8$var$PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + $7b3605043e423ec8$var$PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + $7b3605043e423ec8$var$PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + $7b3605043e423ec8$var$PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + $7b3605043e423ec8$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $7b3605043e423ec8$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $351fed76e763600d$export$e4b2ac9215619f8d)[color]) {
        color = (0, $351fed76e763600d$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $7b3605043e423ec8$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $7b3605043e423ec8$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $7b3605043e423ec8$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $7b3605043e423ec8$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $7b3605043e423ec8$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $7b3605043e423ec8$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $7b3605043e423ec8$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $235be27093016177$export$262b3ba788b4d07c)(match[1]),
        g: (0, $235be27093016177$export$262b3ba788b4d07c)(match[2]),
        b: (0, $235be27093016177$export$262b3ba788b4d07c)(match[3]),
        a: (0, $235be27093016177$export$616da979ad1c2414)(match[4]),
        format: named ? "name" : "hex8"
    };
    match = $7b3605043e423ec8$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $235be27093016177$export$262b3ba788b4d07c)(match[1]),
        g: (0, $235be27093016177$export$262b3ba788b4d07c)(match[2]),
        b: (0, $235be27093016177$export$262b3ba788b4d07c)(match[3]),
        format: named ? "name" : "hex"
    };
    match = $7b3605043e423ec8$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $235be27093016177$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $235be27093016177$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $235be27093016177$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $235be27093016177$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? "name" : "hex8"
    };
    match = $7b3605043e423ec8$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $235be27093016177$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $235be27093016177$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $235be27093016177$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $7b3605043e423ec8$export$80d4d71a83d4526d(color) {
    return Boolean($7b3605043e423ec8$var$matchers.CSS_UNIT.exec(String(color)));
}


var $9a4cf0984844f770$var$hueStep = 2; // 色相阶梯
var $9a4cf0984844f770$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $9a4cf0984844f770$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $9a4cf0984844f770$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $9a4cf0984844f770$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $9a4cf0984844f770$var$lightColorCount = 5; // 浅色数量，主色上
var $9a4cf0984844f770$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $9a4cf0984844f770$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
];
// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $9a4cf0984844f770$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $235be27093016177$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $9a4cf0984844f770$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $235be27093016177$export$34d09c4a771c46ef)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $9a4cf0984844f770$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $9a4cf0984844f770$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $9a4cf0984844f770$var$hueStep * i : Math.round(hsv.h) + $9a4cf0984844f770$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $9a4cf0984844f770$var$hueStep * i : Math.round(hsv.h) - $9a4cf0984844f770$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $9a4cf0984844f770$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $9a4cf0984844f770$var$saturationStep * i;
    else if (i === $9a4cf0984844f770$var$darkColorCount) saturation = hsv.s + $9a4cf0984844f770$var$saturationStep;
    else saturation = hsv.s + $9a4cf0984844f770$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $9a4cf0984844f770$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $9a4cf0984844f770$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $9a4cf0984844f770$var$brightnessStep1 * i;
    else value = hsv.v - $9a4cf0984844f770$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $9a4cf0984844f770$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $7b3605043e423ec8$export$87de337d8199f22c)(color);
    for(var i = $9a4cf0984844f770$var$lightColorCount; i > 0; i -= 1){
        var hsv = $9a4cf0984844f770$var$toHsv(pColor);
        var colorString = $9a4cf0984844f770$var$toHex((0, $7b3605043e423ec8$export$87de337d8199f22c)({
            h: $9a4cf0984844f770$var$getHue(hsv, i, true),
            s: $9a4cf0984844f770$var$getSaturation(hsv, i, true),
            v: $9a4cf0984844f770$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($9a4cf0984844f770$var$toHex(pColor));
    for(var _i = 1; _i <= $9a4cf0984844f770$var$darkColorCount; _i += 1){
        var _hsv = $9a4cf0984844f770$var$toHsv(pColor);
        var _colorString = $9a4cf0984844f770$var$toHex((0, $7b3605043e423ec8$export$87de337d8199f22c)({
            h: $9a4cf0984844f770$var$getHue(_hsv, _i),
            s: $9a4cf0984844f770$var$getSaturation(_hsv, _i),
            v: $9a4cf0984844f770$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === "dark") return $9a4cf0984844f770$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $9a4cf0984844f770$var$toHex($9a4cf0984844f770$var$mix((0, $7b3605043e423ec8$export$87de337d8199f22c)(opts.backgroundColor || "#141414"), (0, $7b3605043e423ec8$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}


var $cf51007abaccff76$export$3968a3afc810b5f5 = {
    red: "#F5222D",
    volcano: "#FA541C",
    orange: "#FA8C16",
    gold: "#FAAD14",
    yellow: "#FADB14",
    lime: "#A0D911",
    green: "#52C41A",
    cyan: "#13C2C2",
    blue: "#1677FF",
    geekblue: "#2F54EB",
    purple: "#722ED1",
    magenta: "#EB2F96",
    grey: "#666666"
};
var $cf51007abaccff76$export$36ad6df0f83f284d = {};
var $cf51007abaccff76$export$24617255e4daf647 = {};
Object.keys($cf51007abaccff76$export$3968a3afc810b5f5).forEach(function(key) {
    $cf51007abaccff76$export$36ad6df0f83f284d[key] = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)($cf51007abaccff76$export$3968a3afc810b5f5[key]);
    $cf51007abaccff76$export$36ad6df0f83f284d[key].primary = $cf51007abaccff76$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $cf51007abaccff76$export$24617255e4daf647[key] = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)($cf51007abaccff76$export$3968a3afc810b5f5[key], {
        theme: "dark",
        backgroundColor: "#141414"
    });
    $cf51007abaccff76$export$24617255e4daf647[key].primary = $cf51007abaccff76$export$24617255e4daf647[key][5];
});
var $cf51007abaccff76$export$a90204d1394caf30 = $cf51007abaccff76$export$36ad6df0f83f284d.red;
var $cf51007abaccff76$export$e63a1643b2f79b16 = $cf51007abaccff76$export$36ad6df0f83f284d.volcano;
var $cf51007abaccff76$export$c24201f7fe3571d8 = $cf51007abaccff76$export$36ad6df0f83f284d.gold;
var $cf51007abaccff76$export$ad766f34ace1cafd = $cf51007abaccff76$export$36ad6df0f83f284d.orange;
var $cf51007abaccff76$export$594c5a8758200c32 = $cf51007abaccff76$export$36ad6df0f83f284d.yellow;
var $cf51007abaccff76$export$221d31baf2636aad = $cf51007abaccff76$export$36ad6df0f83f284d.lime;
var $cf51007abaccff76$export$955a2ebd2fb142ae = $cf51007abaccff76$export$36ad6df0f83f284d.green;
var $cf51007abaccff76$export$7474046f446842ee = $cf51007abaccff76$export$36ad6df0f83f284d.cyan;
var $cf51007abaccff76$export$2aa0182783e7e9de = $cf51007abaccff76$export$36ad6df0f83f284d.blue;
var $cf51007abaccff76$export$4138d3aeddcbf415 = $cf51007abaccff76$export$36ad6df0f83f284d.geekblue;
var $cf51007abaccff76$export$e13cce2a2d16a9d4 = $cf51007abaccff76$export$36ad6df0f83f284d.purple;
var $cf51007abaccff76$export$2a9ca2e383622e18 = $cf51007abaccff76$export$36ad6df0f83f284d.magenta;
var $cf51007abaccff76$export$e4c89085febbc618 = $cf51007abaccff76$export$36ad6df0f83f284d.grey;
var $cf51007abaccff76$export$3e2c219d3ab79d01 = $cf51007abaccff76$export$36ad6df0f83f284d.grey;


var $04ab0e088bd8fd11$var$genControlHeight = function(token) {
    var controlHeight = token.controlHeight;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $04ab0e088bd8fd11$export$2e2bcd8739ae039 = $04ab0e088bd8fd11$var$genControlHeight;


function $6a85d6b294d24bbd$export$2e2bcd8739ae039(token) {
    var sizeUnit = token.sizeUnit, sizeStep = token.sizeStep;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}


var $ea6c8029512de812$export$37e27b43af4d16eb = {
    blue: "#1677ff",
    purple: "#722ED1",
    cyan: "#13C2C2",
    green: "#52C41A",
    magenta: "#EB2F96",
    pink: "#eb2f96",
    red: "#F5222D",
    orange: "#FA8C16",
    yellow: "#FADB14",
    volcano: "#FA541C",
    geekblue: "#2F54EB",
    gold: "#FAAD14",
    lime: "#A0D911"
};
var $ea6c8029512de812$var$seedToken = Object.assign(Object.assign({}, $ea6c8029512de812$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: "#1677ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",
    colorLink: "",
    colorTextBase: "",
    colorBgBase: "",
    // Font
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
    fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: "solid",
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
    motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
    motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
    motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $ea6c8029512de812$export$2e2bcd8739ae039 = $ea6c8029512de812$var$seedToken;






var $cc3db88804fc55ed$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = "";
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === "number") color = (0, $235be27093016177$export$4076ec82b665900d)(color);
        this.originalInput = color;
        var rgb = (0, $7b3605043e423ec8$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $ccaafa3c9f83636a$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $235be27093016177$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $235be27093016177$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $235be27093016177$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $235be27093016177$export$c85ca4f4753af384)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $235be27093016177$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return "#" + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $235be27093016177$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return "#" + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function fmt(x) {
            return "".concat(Math.round((0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function rnd(x) {
            return Math.round((0, $ccaafa3c9f83636a$export$b0e60b43d1d059f0)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return false;
        var hex = "#" + (0, $235be27093016177$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $351fed76e763600d$export$e4b2ac9215619f8d)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $ccaafa3c9f83636a$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $ccaafa3c9f83636a$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("white", amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("black", amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $ccaafa3c9f83636a$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $ccaafa3c9f83636a$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $cc3db88804fc55ed$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = "";
    if (opts === void 0) opts = {};
    return new $cc3db88804fc55ed$export$d850312fc213f33e(color, opts);
}


function $800215846a65d2bd$export$2e2bcd8739ae039(seed, _ref) {
    var generateColorPalettes = _ref.generateColorPalettes, generateNeutralColorPalettes = _ref.generateNeutralColorPalettes;
    var colorSuccessBase = seed.colorSuccess, colorWarningBase = seed.colorWarning, colorErrorBase = seed.colorError, colorInfoBase = seed.colorInfo, colorPrimaryBase = seed.colorPrimary, colorBgBase = seed.colorBgBase, colorTextBase = seed.colorTextBase;
    var primaryColors = generateColorPalettes(colorPrimaryBase);
    var successColors = generateColorPalettes(colorSuccessBase);
    var warningColors = generateColorPalettes(colorWarningBase);
    var errorColors = generateColorPalettes(colorErrorBase);
    var infoColors = generateColorPalettes(colorInfoBase);
    var neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    var colorLink = seed.colorLink || seed.colorInfo;
    var linkColors = generateColorPalettes(colorLink);
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)("#000").setAlpha(0.45).toRgbString(),
        colorWhite: "#fff"
    });
}


var $2b80a0b2a83fcc24$var$genRadius = function(radiusBase) {
    var radiusLG = radiusBase;
    var radiusSM = radiusBase;
    var radiusXS = radiusBase;
    var radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $2b80a0b2a83fcc24$export$2e2bcd8739ae039 = $2b80a0b2a83fcc24$var$genRadius;


function $3ccc6adfad0ec3bc$export$2e2bcd8739ae039(token) {
    var motionUnit = token.motionUnit, motionBase = token.motionBase, borderRadius = token.borderRadius, lineWidth = token.lineWidth;
    return Object.assign({
        // motion
        motionDurationFast: "".concat((motionBase + motionUnit).toFixed(1), "s"),
        motionDurationMid: "".concat((motionBase + motionUnit * 2).toFixed(1), "s"),
        motionDurationSlow: "".concat((motionBase + motionUnit * 3).toFixed(1), "s"),
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $2b80a0b2a83fcc24$export$2e2bcd8739ae039)(borderRadius));
}




var $9e91e5c8d63730b4$export$31f6399ba7ce6bea = function(baseColor, alpha) {
    return new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(baseColor).setAlpha(alpha).toRgbString();
};
var $9e91e5c8d63730b4$export$7003a8a990e79359 = function(baseColor, brightness) {
    var instance = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(baseColor);
    return instance.darken(brightness).toHexString();
};


var $7ae1b40ac6a9526f$export$da275153033f4ec1 = function(baseColor) {
    var colors = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
var $7ae1b40ac6a9526f$export$3e0cb0c1d9c1b691 = function(bgBaseColor, textBaseColor) {
    var colorBgBase = bgBaseColor || "#fff";
    var colorTextBase = textBaseColor || "#000";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgLayout: (0, $9e91e5c8d63730b4$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $9e91e5c8d63730b4$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $9e91e5c8d63730b4$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $9e91e5c8d63730b4$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: "transparent",
        colorBorder: (0, $9e91e5c8d63730b4$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $9e91e5c8d63730b4$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


// https://zhuanlan.zhihu.com/p/32746810
function $66e4c934f279890c$export$2e2bcd8739ae039(base) {
    var fontSizes = new Array(10).fill(null).map(function(_, index) {
        var i = index - 1;
        var baseSize = base * Math.pow(2.71828, i / 5);
        var intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map(function(size) {
        var height = size + 8;
        return {
            size: size,
            lineHeight: height / size
        };
    });
}


var $839d2e4305ad8fce$var$genFontMapToken = function(fontSize) {
    var fontSizePairs = (0, $66e4c934f279890c$export$2e2bcd8739ae039)(fontSize);
    var fontSizes = fontSizePairs.map(function(pair) {
        return pair.size;
    });
    var lineHeights = fontSizePairs.map(function(pair) {
        return pair.lineHeight;
    });
    var fontSizeMD = fontSizes[1];
    var fontSizeSM = fontSizes[0];
    var fontSizeLG = fontSizes[2];
    var lineHeight = lineHeights[1];
    var lineHeightSM = lineHeights[0];
    var lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $839d2e4305ad8fce$export$2e2bcd8739ae039 = $839d2e4305ad8fce$var$genFontMapToken;


function $d2f5e65d878552ad$export$2e2bcd8739ae039(token) {
    var colorPalettes = Object.keys((0, $ea6c8029512de812$export$37e27b43af4d16eb)).map(function(colorKey) {
        var colors = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)(token[colorKey]);
        return new Array(10).fill(1).reduce(function(prev, _, i) {
            prev["".concat(colorKey, "-").concat(i + 1)] = colors[i];
            prev["".concat(colorKey).concat(i + 1)] = colors[i];
            return prev;
        }, {});
    }).reduce(function(prev, cur) {
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $800215846a65d2bd$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: (0, $7ae1b40ac6a9526f$export$da275153033f4ec1),
        generateNeutralColorPalettes: (0, $7ae1b40ac6a9526f$export$3e0cb0c1d9c1b691)
    })), (0, $839d2e4305ad8fce$export$2e2bcd8739ae039)(token.fontSize)), (0, $6a85d6b294d24bbd$export$2e2bcd8739ae039)(token)), (0, $04ab0e088bd8fd11$export$2e2bcd8739ae039)(token)), (0, $3ccc6adfad0ec3bc$export$2e2bcd8739ae039)(token));
}



var $7da138eb2c256f6d$export$164de7ab8df77ef0 = (0, $594b86af963ae683$export$2e2bcd8739ae039)((0, $d2f5e65d878552ad$export$2e2bcd8739ae039));
var $7da138eb2c256f6d$export$f84bd70098573c5c = {
    token: (0, $ea6c8029512de812$export$2e2bcd8739ae039),
    override: {
        override: (0, $ea6c8029512de812$export$2e2bcd8739ae039)
    },
    hashed: true
};
var $7da138eb2c256f6d$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext($7da138eb2c256f6d$export$f84bd70098573c5c);




var $8SyCD = parcelRequire("8SyCD");
var $d263e45406476254$export$eaca8ee5ed21b4e9 = "anticon";
var $d263e45406476254$var$defaultGetPrefixCls = function(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : "ant";
};
var $d263e45406476254$export$a92f85ab3e9ad68b = /*#__PURE__*/ $8SyCD.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $d263e45406476254$var$defaultGetPrefixCls,
    iconPrefixCls: $d263e45406476254$export$eaca8ee5ed21b4e9
});
var $d263e45406476254$export$cd5442f2b8da7663 = $d263e45406476254$export$a92f85ab3e9ad68b.Consumer;


/* eslint-disable import/prefer-default-export, prefer-destructuring */ 




var $33bccc17ef7bd33f$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $33bccc17ef7bd33f$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function(colorVal, type) {
        var baseColor = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorVal);
        var colorPalettes = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, "primary");
        var primaryColor = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(theme.primaryColor);
        var primaryColors = (0, $9a4cf0984844f770$export$2e2bcd8739ae039)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(primaryColors[0]);
        variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, "success");
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, "warning");
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, "error");
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, "info");
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join("\n"), "\n  }\n  ").trim();
}
function $33bccc17ef7bd33f$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    var style = $33bccc17ef7bd33f$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $014625af273be671$export$2e2bcd8739ae039)()) (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(style, "".concat($33bccc17ef7bd33f$var$dynamicStyleMark, "-dynamic-theme"));
}



var $8SyCD = parcelRequire("8SyCD");
"use client";
var $e0eab3dc6b8ab52c$var$DisabledContext = /*#__PURE__*/ $8SyCD.createContext(false);
var $e0eab3dc6b8ab52c$export$6adb5f3b918b11bb = function(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $8SyCD.useContext($e0eab3dc6b8ab52c$var$DisabledContext);
    return /*#__PURE__*/ $8SyCD.createElement($e0eab3dc6b8ab52c$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $e0eab3dc6b8ab52c$export$2e2bcd8739ae039 = $e0eab3dc6b8ab52c$var$DisabledContext;



var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
"use client";
var $5ef11331ce5e57bf$var$SizeContext = /*#__PURE__*/ $8SyCD.createContext(undefined);
var $5ef11331ce5e57bf$export$dbc92d89fabc8ebe = function(_ref) {
    var children = _ref.children, size = _ref.size;
    var originSize = $8SyCD.useContext($5ef11331ce5e57bf$var$SizeContext);
    return /*#__PURE__*/ $8SyCD.createElement($5ef11331ce5e57bf$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $5ef11331ce5e57bf$export$2e2bcd8739ae039 = $5ef11331ce5e57bf$var$SizeContext;


function $1429257a26085410$var$useConfig() {
    var componentDisabled = (0, $8SyCD.useContext)((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var componentSize = (0, $8SyCD.useContext)((0, $5ef11331ce5e57bf$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $1429257a26085410$export$2e2bcd8739ae039 = $1429257a26085410$var$useConfig;






var $8SyCD = parcelRequire("8SyCD");
var $174ce41c0d9e321a$var$useEmptyId = function() {
    return "";
};
var $174ce41c0d9e321a$var$useThemeKey = typeof (0, $8SyCD.useId) === "undefined" ? $174ce41c0d9e321a$var$useEmptyId : (0, $8SyCD.useId);
var $174ce41c0d9e321a$export$2e2bcd8739ae039 = $174ce41c0d9e321a$var$useThemeKey;



function $21564fea3b3853c3$export$2e2bcd8739ae039(theme, parentTheme) {
    var _a;
    var warning = (0, $a45ff4e670d5554a$export$cf977aa92c751e61)("ConfigProvider");
    var themeConfig = theme || {};
    var parentThemeConfig = themeConfig.inherit === false || !parentTheme ? (0, $7da138eb2c256f6d$export$f84bd70098573c5c) : parentTheme;
    var themeKey = (0, $174ce41c0d9e321a$export$2e2bcd8739ae039)();
    return (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        var mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach(function(componentName) {
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        var cssVarKey = "css-var-".concat(themeKey.replace(/:/g, ""));
        var mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: "ant"
        }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], function(prev, next) {
        return prev.some(function(prevTheme, index) {
            var nextTheme = next[index];
            return !(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        });
    });
}









var $8SyCD = parcelRequire("8SyCD");

function $a4b291de522e10cb$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $a4b291de522e10cb$export$2e2bcd8739ae039(node) {
    if ($a4b291de522e10cb$export$41e30d8dd0ba7a50(node)) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($b4e4ce7bd3c993b9$exports))).findDOMNode(node);
    return null;
}




var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
var $65059b5aa47e3b5f$var$_excluded = [
    "children"
];
var $65059b5aa47e3b5f$export$841858b892ce1f4c = /*#__PURE__*/ $8SyCD.createContext({});
function $65059b5aa47e3b5f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $65059b5aa47e3b5f$var$_excluded);
    return /*#__PURE__*/ $8SyCD.createElement($65059b5aa47e3b5f$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}




function $3c581732adae8c1a$export$2e2bcd8739ae039(o, p) {
    $3c581732adae8c1a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c581732adae8c1a$export$2e2bcd8739ae039(o, p);
}


function $9cb2c16f15be24ce$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $3c581732adae8c1a$export$2e2bcd8739ae039)(subClass, superClass);
}


function $984f41b0d22fca01$export$2e2bcd8739ae039(o) {
    $984f41b0d22fca01$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $984f41b0d22fca01$export$2e2bcd8739ae039(o);
}


function $0b861333cf830d1b$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $17c050cdb820e309$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6bca2144bb911d23$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $17c050cdb820e309$export$2e2bcd8739ae039)(self);
}


function $721e716a80b17452$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $0b861333cf830d1b$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $984f41b0d22fca01$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $984f41b0d22fca01$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6bca2144bb911d23$export$2e2bcd8739ae039)(this, result);
    };
}



var $8SyCD = parcelRequire("8SyCD");
var $b006a8e7053d1cd1$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($8SyCD.Component);
var $b006a8e7053d1cd1$export$2e2bcd8739ae039 = $b006a8e7053d1cd1$var$DomWrapper;







var $8SyCD = parcelRequire("8SyCD");
function $2fb61ecc178138e6$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $8SyCD.useRef(false);
    var _React$useState = $8SyCD.useState(defaultValue), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $8SyCD.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}



var $8SyCD = parcelRequire("8SyCD");
var $9cdeebdbc75174de$export$de71442bbf2143da = "none";
var $9cdeebdbc75174de$export$4fc3521687bcacd2 = "appear";
var $9cdeebdbc75174de$export$5d6af549241fe2e8 = "enter";
var $9cdeebdbc75174de$export$59b1c493d29f68e4 = "leave";
var $9cdeebdbc75174de$export$40b34dd77d5522bf = "none";
var $9cdeebdbc75174de$export$1b792916a5fac4fc = "prepare";
var $9cdeebdbc75174de$export$9563153dd25a3ce8 = "start";
var $9cdeebdbc75174de$export$e205886172277ec6 = "active";
var $9cdeebdbc75174de$export$3a846c3d2fac10b8 = "end";
var $9cdeebdbc75174de$export$98351fa4e6b4f204 = "prepared";



var $8SyCD = parcelRequire("8SyCD");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $4c0b810d6371922c$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $4c0b810d6371922c$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $4c0b810d6371922c$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $4c0b810d6371922c$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $4c0b810d6371922c$var$vendorPrefixes = $4c0b810d6371922c$export$6e8b350b1a8958a0((0, $014625af273be671$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $4c0b810d6371922c$var$style = {};
if ((0, $014625af273be671$export$2e2bcd8739ae039)()) {
    var $4c0b810d6371922c$var$_document$createEleme = document.createElement("div");
    $4c0b810d6371922c$var$style = $4c0b810d6371922c$var$_document$createEleme.style;
}
var $4c0b810d6371922c$var$prefixedEventNames = {};
function $4c0b810d6371922c$export$a032e4f39350c1d8(eventName) {
    if ($4c0b810d6371922c$var$prefixedEventNames[eventName]) return $4c0b810d6371922c$var$prefixedEventNames[eventName];
    var prefixMap = $4c0b810d6371922c$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $4c0b810d6371922c$var$style) {
                $4c0b810d6371922c$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $4c0b810d6371922c$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $4c0b810d6371922c$var$internalAnimationEndName = $4c0b810d6371922c$export$a032e4f39350c1d8("animationend");
var $4c0b810d6371922c$var$internalTransitionEndName = $4c0b810d6371922c$export$a032e4f39350c1d8("transitionend");
var $4c0b810d6371922c$export$d28133ed3ad06c8b = !!($4c0b810d6371922c$var$internalAnimationEndName && $4c0b810d6371922c$var$internalTransitionEndName);
var $4c0b810d6371922c$export$760cc9769c51b738 = $4c0b810d6371922c$var$internalAnimationEndName || "animationend";
var $4c0b810d6371922c$export$44baea64b8602e3c = $4c0b810d6371922c$var$internalTransitionEndName || "transitionend";
function $4c0b810d6371922c$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $719c51ef7cf6da0d$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $8SyCD.useRef)();
    // Cache callback
    var callbackRef = (0, $8SyCD.useRef)(callback);
    callbackRef.current = callback;
    // Internal motion event handler
    var onInternalMotionEnd = $8SyCD.useCallback(function(event) {
        callbackRef.current(event);
    }, []);
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $4c0b810d6371922c$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $4c0b810d6371922c$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $4c0b810d6371922c$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $4c0b810d6371922c$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $8SyCD.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $8SyCD = parcelRequire("8SyCD");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $6ec6ad03e7a8fb1b$var$useIsomorphicLayoutEffect = (0, $014625af273be671$export$2e2bcd8739ae039)() ? (0, $8SyCD.useLayoutEffect) : (0, $8SyCD.useEffect);
var $6ec6ad03e7a8fb1b$export$2e2bcd8739ae039 = $6ec6ad03e7a8fb1b$var$useIsomorphicLayoutEffect;





var $8SyCD = parcelRequire("8SyCD");


var $8927aaea5eb757b1$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $8927aaea5eb757b1$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $8927aaea5eb757b1$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $8927aaea5eb757b1$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $8927aaea5eb757b1$var$rafUUID = 0;
var $8927aaea5eb757b1$var$rafIds = new Map();
function $8927aaea5eb757b1$var$cleanup(id) {
    $8927aaea5eb757b1$var$rafIds["delete"](id);
}
var $8927aaea5eb757b1$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $8927aaea5eb757b1$var$rafUUID += 1;
    var id = $8927aaea5eb757b1$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $8927aaea5eb757b1$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $8927aaea5eb757b1$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $8927aaea5eb757b1$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$8927aaea5eb757b1$var$wrapperRaf.cancel = function(id) {
    var realId = $8927aaea5eb757b1$var$rafIds.get(id);
    $8927aaea5eb757b1$var$cleanup(id);
    return $8927aaea5eb757b1$var$caf(realId);
};
var $8927aaea5eb757b1$export$2e2bcd8739ae039 = $8927aaea5eb757b1$var$wrapperRaf;



var $8SyCD = parcelRequire("8SyCD");
var $b67cb33af6a5e945$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $8SyCD.useRef(null);
    function cancelNextFrame() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $8SyCD.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $5b7b988f9c2e387f$var$FULL_STEP_QUEUE = [
    (0, $9cdeebdbc75174de$export$1b792916a5fac4fc),
    (0, $9cdeebdbc75174de$export$9563153dd25a3ce8),
    (0, $9cdeebdbc75174de$export$e205886172277ec6),
    (0, $9cdeebdbc75174de$export$3a846c3d2fac10b8)
];
var $5b7b988f9c2e387f$var$SIMPLE_STEP_QUEUE = [
    (0, $9cdeebdbc75174de$export$1b792916a5fac4fc),
    (0, $9cdeebdbc75174de$export$98351fa4e6b4f204)
];
var $5b7b988f9c2e387f$export$c2029bf6cfdbc28a = false;
var $5b7b988f9c2e387f$export$dbee1e282e8c4830 = true;
function $5b7b988f9c2e387f$export$39e04e72f972b885(step) {
    return step === (0, $9cdeebdbc75174de$export$e205886172277ec6) || step === (0, $9cdeebdbc75174de$export$3a846c3d2fac10b8);
}
var $5b7b988f9c2e387f$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)((0, $9cdeebdbc75174de$export$40b34dd77d5522bf)), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $b67cb33af6a5e945$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $9cdeebdbc75174de$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $5b7b988f9c2e387f$var$SIMPLE_STEP_QUEUE : $5b7b988f9c2e387f$var$FULL_STEP_QUEUE;
    (0, $6ec6ad03e7a8fb1b$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $9cdeebdbc75174de$export$40b34dd77d5522bf) && step !== (0, $9cdeebdbc75174de$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $5b7b988f9c2e387f$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $8SyCD.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $aa43ceded5a3e0cd$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)(), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)((0, $9cdeebdbc75174de$export$de71442bbf2143da)), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)(null), _useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $8SyCD.useRef)(false);
    var deadlineRef = (0, $8SyCD.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $8SyCD.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $9cdeebdbc75174de$export$de71442bbf2143da), true);
        setStyle(null, true);
    }
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $9cdeebdbc75174de$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $9cdeebdbc75174de$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $9cdeebdbc75174de$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (status !== (0, $9cdeebdbc75174de$export$de71442bbf2143da) && currentActive && canEnd !== false) updateMotionEndStatus();
    }
    var _useDomMotionEvents = (0, $719c51ef7cf6da0d$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        var _ref2, _ref3, _ref4;
        switch(targetStatus){
            case 0, $9cdeebdbc75174de$export$4fc3521687bcacd2:
                return _ref2 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref2, (0, $9cdeebdbc75174de$export$1b792916a5fac4fc), onAppearPrepare), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref2, (0, $9cdeebdbc75174de$export$9563153dd25a3ce8), onAppearStart), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref2, (0, $9cdeebdbc75174de$export$e205886172277ec6), onAppearActive), _ref2;
            case 0, $9cdeebdbc75174de$export$5d6af549241fe2e8:
                return _ref3 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref3, (0, $9cdeebdbc75174de$export$1b792916a5fac4fc), onEnterPrepare), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref3, (0, $9cdeebdbc75174de$export$9563153dd25a3ce8), onEnterStart), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref3, (0, $9cdeebdbc75174de$export$e205886172277ec6), onEnterActive), _ref3;
            case 0, $9cdeebdbc75174de$export$59b1c493d29f68e4:
                return _ref4 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref4, (0, $9cdeebdbc75174de$export$1b792916a5fac4fc), onLeavePrepare), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref4, (0, $9cdeebdbc75174de$export$9563153dd25a3ce8), onLeaveStart), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref4, (0, $9cdeebdbc75174de$export$e205886172277ec6), onLeaveActive), _ref4;
            default:
                return {};
        }
    };
    var eventHandlers = $8SyCD.useMemo(function() {
        return getEventHandlers(status);
    }, [
        status
    ]);
    var _useStepQueue = (0, $5b7b988f9c2e387f$export$2e2bcd8739ae039)(status, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $9cdeebdbc75174de$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $9cdeebdbc75174de$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $5b7b988f9c2e387f$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $9cdeebdbc75174de$export$e205886172277ec6)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $9cdeebdbc75174de$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $5b7b988f9c2e387f$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $5b7b988f9c2e387f$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $6ec6ad03e7a8fb1b$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $9cdeebdbc75174de$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $9cdeebdbc75174de$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $9cdeebdbc75174de$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $9cdeebdbc75174de$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $9cdeebdbc75174de$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $8SyCD.useEffect)(function() {
        if (// Cancel appear
        status === (0, $9cdeebdbc75174de$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        status === (0, $9cdeebdbc75174de$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        status === (0, $9cdeebdbc75174de$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $9cdeebdbc75174de$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $8SyCD.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $8SyCD.useRef(false);
    (0, $8SyCD.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $9cdeebdbc75174de$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $9cdeebdbc75174de$export$1b792916a5fac4fc] && step === (0, $9cdeebdbc75174de$export$9563153dd25a3ce8)) mergedStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $74ed531808a1565a$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $8SyCD.useContext((0, $65059b5aa47e3b5f$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $8SyCD.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $8SyCD.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $a4b291de522e10cb$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $aa43ceded5a3e0cd$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $8SyCD.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $8SyCD.useCallback(function(node) {
            nodeRef.current = node;
            (0, $5a9f4dc5cf4fdd27$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $9cdeebdbc75174de$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $9cdeebdbc75174de$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $5b7b988f9c2e387f$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $9cdeebdbc75174de$export$9563153dd25a3ce8)) statusSuffix = "start";
            var motionCls = (0, $4c0b810d6371922c$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $4c0b810d6371922c$export$27c72201b1d09951)(motionName, status), (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, motionCls, motionCls && statusSuffix), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $8SyCD.isValidElement(motionChildren) && (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $8SyCD.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $8SyCD.createElement((0, $b006a8e7053d1cd1$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $74ed531808a1565a$export$2e2bcd8739ae039 = $74ed531808a1565a$export$e265d52a86a9f199((0, $4c0b810d6371922c$export$d28133ed3ad06c8b));












var $8SyCD = parcelRequire("8SyCD");



var $bbbb9ab84f2d5517$export$3904baa009bc026e = "add";
var $bbbb9ab84f2d5517$export$851162f0adad2cbc = "keep";
var $bbbb9ab84f2d5517$export$c8b3fb08b68cfc85 = "remove";
var $bbbb9ab84f2d5517$export$2ac1bd1808d2e43a = "removed";
function $bbbb9ab84f2d5517$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $bbbb9ab84f2d5517$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($bbbb9ab84f2d5517$export$c47fd798e598c85c);
}
function $bbbb9ab84f2d5517$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $bbbb9ab84f2d5517$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $bbbb9ab84f2d5517$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $bbbb9ab84f2d5517$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $bbbb9ab84f2d5517$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $bbbb9ab84f2d5517$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $bbbb9ab84f2d5517$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $bbbb9ab84f2d5517$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $bbbb9ab84f2d5517$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $8c4f85df23eb5b18$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $8c4f85df23eb5b18$var$_excluded2 = [
    "status"
];
var $8c4f85df23eb5b18$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $8c4f85df23eb5b18$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $74ed531808a1565a$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $bbbb9ab84f2d5517$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $bbbb9ab84f2d5517$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_this$props, $8c4f85df23eb5b18$var$_excluded);
                    var Component = component || $8SyCD.Fragment;
                    var motionProps = {};
                    $8c4f85df23eb5b18$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $8SyCD.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref2, $8c4f85df23eb5b18$var$_excluded2);
                        var visible = status === (0, $bbbb9ab84f2d5517$export$3904baa009bc026e) || status === (0, $bbbb9ab84f2d5517$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $8SyCD.createElement(CSSMotion, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $bbbb9ab84f2d5517$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $bbbb9ab84f2d5517$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $bbbb9ab84f2d5517$export$2ac1bd1808d2e43a) && entity.status === (0, $bbbb9ab84f2d5517$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($8SyCD.Component);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $8c4f85df23eb5b18$export$2e2bcd8739ae039 = $8c4f85df23eb5b18$export$fcfc62c1d33d5e2e((0, $4c0b810d6371922c$export$d28133ed3ad06c8b));



var $981eb2f292da8c80$export$2e2bcd8739ae039 = (0, $74ed531808a1565a$export$2e2bcd8739ae039);



var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");

var $b6d604d81b12fa1a$export$2e2bcd8739ae039 = "5.12.1";


"use client";
var $bd3e129f37a47fb3$export$2e2bcd8739ae039 = (0, $b6d604d81b12fa1a$export$2e2bcd8739ae039);







function $b6d62d4e20338c02$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $b6d62d4e20338c02$var$getAlphaColor(frontColor, backgroundColor) {
    var _toRgb = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(frontColor).toRgb(), fR = _toRgb.r, fG = _toRgb.g, fB = _toRgb.b, originAlpha = _toRgb.a;
    if (originAlpha < 1) return frontColor;
    var _toRgb1 = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(backgroundColor).toRgb(), bR = _toRgb1.r, bG = _toRgb1.g, bB = _toRgb1.b;
    for(var fA = 0.01; fA <= 1; fA += 0.01){
        var r = Math.round((fR - bR * (1 - fA)) / fA);
        var g = Math.round((fG - bG * (1 - fA)) / fA);
        var b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($b6d62d4e20338c02$var$isStableColor(r) && $b6d62d4e20338c02$var$isStableColor(g) && $b6d62d4e20338c02$var$isStableColor(b)) return new (0, $cc3db88804fc55ed$export$d850312fc213f33e)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $cc3db88804fc55ed$export$d850312fc213f33e)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $b6d62d4e20338c02$export$2e2bcd8739ae039 = $b6d62d4e20338c02$var$getAlphaColor;


var $22afc1a4724095e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $22afc1a4724095e0$export$2e2bcd8739ae039(derivativeToken) {
    var override = derivativeToken.override, restToken = $22afc1a4724095e0$var$__rest(derivativeToken, [
        "override"
    ]);
    var overrideTokens = Object.assign({}, override);
    Object.keys((0, $ea6c8029512de812$export$2e2bcd8739ae039)).forEach(function(token) {
        delete overrideTokens[token];
    });
    var mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    var screenXS = 480;
    var screenSM = 576;
    var screenMD = 768;
    var screenLG = 992;
    var screenXL = 1200;
    var screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        var fastDuration = "0s";
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    var aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $b6d62d4e20338c02$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $b6d62d4e20338c02$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $b6d62d4e20338c02$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 4,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $b6d62d4e20338c02$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: "none",
        linkHoverDecoration: "none",
        linkFocusDecoration: "none",
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: "\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowSecondary: "\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowTertiary: "\n      0 1px 2px 0 rgba(0, 0, 0, 0.03),\n      0 1px 6px -1px rgba(0, 0, 0, 0.02),\n      0 2px 4px 0 rgba(0, 0, 0, 0.02)\n    ",
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
        boxShadowCard: "\n      0 1px 2px -2px ".concat(new (0, $cc3db88804fc55ed$export$d850312fc213f33e)("rgba(0, 0, 0, 0.16)").toRgbString(), ",\n      0 3px 6px 0 ").concat(new (0, $cc3db88804fc55ed$export$d850312fc213f33e)("rgba(0, 0, 0, 0.12)").toRgbString(), ",\n      0 5px 12px 4px ").concat(new (0, $cc3db88804fc55ed$export$d850312fc213f33e)("rgba(0, 0, 0, 0.09)").toRgbString(), "\n    "),
        boxShadowDrawerRight: "\n      -6px 0 16px 0 rgba(0, 0, 0, 0.08),\n      -3px 0 6px -4px rgba(0, 0, 0, 0.12),\n      -9px 0 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowDrawerLeft: "\n      6px 0 16px 0 rgba(0, 0, 0, 0.08),\n      3px 0 6px -4px rgba(0, 0, 0, 0.12),\n      9px 0 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowDrawerUp: "\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowDrawerDown: "\n      0 -6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 -3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 -9px 28px 8px rgba(0, 0, 0, 0.05)\n    ",
        boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
    }), overrideTokens);
    return aliasToken;
}


var $4686879ac4f429c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4686879ac4f429c9$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true
};
var $4686879ac4f429c9$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
var $4686879ac4f429c9$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
var $4686879ac4f429c9$export$18602cb46ae80b62 = function(originToken, overrideToken, theme) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    var override = overrideToken.override, components = $4686879ac4f429c9$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    var mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $22afc1a4724095e0$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(function(_ref) {
        var _$_ref = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
        var componentTheme = value.theme, componentTokens = $4686879ac4f429c9$var$__rest(value, [
            "theme"
        ]);
        var mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $4686879ac4f429c9$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $4686879ac4f429c9$export$2e2bcd8739ae039() {
    var _React_useContext = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $7da138eb2c256f6d$export$69b0ebb9efcddb30)), rootDesignToken = _React_useContext.token, hashed = _React_useContext.hashed, theme = _React_useContext.theme, override = _React_useContext.override, cssVar = _React_useContext.cssVar;
    var salt = "".concat((0, $bd3e129f37a47fb3$export$2e2bcd8739ae039), "-").concat(hashed || "");
    var mergedTheme = theme || (0, $7da138eb2c256f6d$export$164de7ab8df77ef0);
    var _useCacheToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $1027e04a58b2ac6d$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $ea6c8029512de812$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $4686879ac4f429c9$export$18602cb46ae80b62,
        // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        formatToken: (0, $22afc1a4724095e0$export$2e2bcd8739ae039),
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $4686879ac4f429c9$export$c6b9faa6b723d31a,
            ignore: $4686879ac4f429c9$export$738b109e247a462c,
            preserve: $4686879ac4f429c9$var$preserve
        }
    }), 3), token = _useCacheToken[0], hashId = _useCacheToken[1], realToken = _useCacheToken[2];
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : "",
        token,
        cssVar
    ];
}


"use client";
function $1d8e78aa4d66ed0b$export$2e2bcd8739ae039(props) {
    var children = props.children;
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var motion = token.motion;
    var needWrapMotionProviderRef = $8SyCD.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $8SyCD.createElement((0, $65059b5aa47e3b5f$export$2e2bcd8739ae039), {
        motion: motion
    }, children);
    return children;
}



var $8SyCD = parcelRequire("8SyCD");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ var $9189e6af494f48be$var$PropWarning = /*#__PURE__*/ $8SyCD.memo(function(_ref) {
    var dropdownMatchSelectWidth = _ref.dropdownMatchSelectWidth;
    var warning = (0, $a45ff4e670d5554a$export$cf977aa92c751e61)("ConfigProvider");
    warning.deprecated(dropdownMatchSelectWidth === undefined, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    return null;
});
var $9189e6af494f48be$export$2e2bcd8739ae039 = function() {
    return null;
};








// eslint-disable-next-line import/prefer-default-export
var $37504622da5ae229$export$9a16e7694a707ab4 = function(token) {
    return {
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: "none",
        outline: "none",
        cursor: "pointer",
        transition: "color ".concat(token.motionDurationSlow),
        "&:focus, &:hover": {
            color: token.colorLinkHover
        },
        "&:active": {
            color: token.colorLinkActive
        }
    };
};


"use client";
var $7cbb7e49dbe61000$export$b2b65df0d0824629 = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
var $7cbb7e49dbe61000$export$23997c3e44cc1c59 = function resetComponent(token) {
    var needInheritFontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: "none",
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? "inherit" : token.fontFamily
    };
};
var $7cbb7e49dbe61000$export$171ccda7bc085e59 = function() {
    return {
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        fontStyle: "normal",
        lineHeight: 0,
        textAlign: "center",
        textTransform: "none",
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: "-0.125em",
        textRendering: "optimizeLegibility",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "> *": {
            lineHeight: 1
        },
        svg: {
            display: "inline-block"
        }
    };
};
var $7cbb7e49dbe61000$export$8c467e8859fdef13 = function() {
    return {
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        "&::before": {
            display: "table",
            content: '""'
        },
        "&::after": {
            // https://github.com/ant-design/ant-design/issues/21864
            display: "table",
            clear: "both",
            content: '""'
        }
    };
};
var $7cbb7e49dbe61000$export$905d771977096614 = function(token) {
    var _obj;
    return {
        a: (_obj = {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: "transparent",
            // remove the gray background on active links in IE 10.
            outline: "none",
            cursor: "pointer",
            transition: "color ".concat(token.motionDurationSlow),
            "-webkit-text-decoration-skip": "objects",
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            "&:hover": {
                color: token.colorLinkHover
            },
            "&:active": {
                color: token.colorLinkActive
            }
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:active,\n  &:hover", {
            textDecoration: token.linkHoverDecoration,
            outline: 0
        }), // https://github.com/ant-design/ant-design/issues/22503
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:focus", {
            textDecoration: token.linkFocusDecoration,
            outline: 0
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&[disabled]", {
            color: token.colorTextDisabled,
            cursor: "not-allowed"
        }), _obj)
    };
};
var $7cbb7e49dbe61000$export$689382c111559cd9 = function(token, componentPrefixCls) {
    var fontFamily = token.fontFamily, fontSize = token.fontSize;
    var rootPrefixSelector = '[class^="'.concat(componentPrefixCls, '"], [class*=" ').concat(componentPrefixCls, '"]');
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, rootPrefixSelector, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        fontFamily: fontFamily,
        fontSize: fontSize,
        boxSizing: "border-box",
        "&::before, &::after": {
            boxSizing: "border-box"
        }
    }, rootPrefixSelector, {
        boxSizing: "border-box",
        "&::before, &::after": {
            boxSizing: "border-box"
        }
    }));
};
var $7cbb7e49dbe61000$export$6539948f0a737e39 = function(token) {
    return {
        outline: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidthFocus), " solid ").concat(token.colorPrimaryBorder),
        outlineOffset: 1,
        transition: "outline-offset 0s, outline 0s"
    };
};
var $7cbb7e49dbe61000$export$a44db842bcb28231 = function(token) {
    return {
        "&:focus-visible": Object.assign({}, $7cbb7e49dbe61000$export$6539948f0a737e39(token))
    };
};



var $3fc15afd9b37ec4f$var$useResetIconStyle = function(iconPrefixCls, csp) {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), theme = _useToken[0], token = _useToken[1];
    // Generate style for icons
    return (0, $d21f66fac4f2a7ee$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: "",
        path: [
            "ant-design-icons",
            iconPrefixCls
        ],
        nonce: function() {
            return csp === null || csp === void 0 ? void 0 : csp.nonce;
        }
    }, function() {
        return [
            (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, ".".concat(iconPrefixCls), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$171ccda7bc085e59)()), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, ".".concat(iconPrefixCls, " .").concat(iconPrefixCls, "-icon"), {
                display: "block"
            })))
        ];
    });
};
var $3fc15afd9b37ec4f$export$2e2bcd8739ae039 = $3fc15afd9b37ec4f$var$useResetIconStyle;


"use client";
"use client";
var $f2caf184cab96719$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ var $f2caf184cab96719$var$existThemeConfig = false;
var $f2caf184cab96719$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
var $f2caf184cab96719$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale",
    "pageHeader"
];
// These props is used by `useContext` directly in sub component
var $f2caf184cab96719$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "pageHeader",
    "input",
    "pagination",
    "form",
    "select",
    "button"
];
var $f2caf184cab96719$export$e4ec87ea71f29b41 = "ant";
var $f2caf184cab96719$var$globalPrefixCls;
var $f2caf184cab96719$var$globalIconPrefixCls;
var $f2caf184cab96719$var$globalTheme;
function $f2caf184cab96719$var$getGlobalPrefixCls() {
    return $f2caf184cab96719$var$globalPrefixCls || $f2caf184cab96719$export$e4ec87ea71f29b41;
}
function $f2caf184cab96719$var$getGlobalIconPrefixCls() {
    return $f2caf184cab96719$var$globalIconPrefixCls || (0, $d263e45406476254$export$eaca8ee5ed21b4e9);
}
function $f2caf184cab96719$var$isLegacyTheme(theme) {
    return Object.keys(theme).some(function(key) {
        return key.endsWith("Color");
    });
}
var $f2caf184cab96719$var$setGlobalConfig = function(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $f2caf184cab96719$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $f2caf184cab96719$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) {
        if ($f2caf184cab96719$var$isLegacyTheme(theme)) (0, $33bccc17ef7bd33f$export$f9c59eed5de5ff80)($f2caf184cab96719$var$getGlobalPrefixCls(), theme);
        else $f2caf184cab96719$var$globalTheme = theme;
    }
};
var $f2caf184cab96719$export$f9cd1e43211d8a4a = function() {
    return {
        getPrefixCls: function(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($f2caf184cab96719$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $f2caf184cab96719$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $f2caf184cab96719$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function() {
            // If Global prefixCls provided, use this
            if ($f2caf184cab96719$var$globalPrefixCls) return $f2caf184cab96719$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $f2caf184cab96719$var$getGlobalPrefixCls();
        },
        getTheme: function() {
            return $f2caf184cab96719$var$globalTheme;
        }
    };
};
var $f2caf184cab96719$var$ProviderChildren = function(props) {
    var children = props.children, customCsp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, alert = props.alert, anchor = props.anchor, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, popupMatchSelectWidth = props.popupMatchSelectWidth, popupOverflow = props.popupOverflow, legacyLocale = props.legacyLocale, parentContext = props.parentContext, customIconPrefixCls = props.iconPrefixCls, theme = props.theme, componentDisabled = props.componentDisabled, segmented = props.segmented, statistic = props.statistic, spin = props.spin, calendar = props.calendar, carousel = props.carousel, cascader = props.cascader, collapse = props.collapse, typography = props.typography, checkbox = props.checkbox, descriptions = props.descriptions, divider = props.divider, drawer = props.drawer, skeleton = props.skeleton, steps = props.steps, image = props.image, layout = props.layout, list = props.list, mentions = props.mentions, modal = props.modal, progress = props.progress, result = props.result, slider = props.slider, breadcrumb = props.breadcrumb, menu = props.menu, pagination = props.pagination, input = props.input, empty = props.empty, badge = props.badge, radio = props.radio, rate = props.rate, SWITCH = props["switch"], transfer = props.transfer, avatar = props.avatar, message = props.message, tag = props.tag, table = props.table, card = props.card, tabs = props.tabs, timeline = props.timeline, timePicker = props.timePicker, upload = props.upload, notification = props.notification, tree = props.tree, colorPicker = props.colorPicker, datePicker = props.datePicker, rangePicker = props.rangePicker, flex = props.flex, wave = props.wave, dropdown = props.dropdown, warningConfig = props.warning;
    // =================================== Context ===================================
    var getPrefixCls = $8SyCD.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $d263e45406476254$export$eaca8ee5ed21b4e9);
    var csp = customCsp || parentContext.csp;
    (0, $3fc15afd9b37ec4f$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    var mergedTheme = (0, $21564fea3b3853c3$export$2e2bcd8739ae039)(theme, parentContext.theme);
    var baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        "switch": SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig
    };
    var config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach(function(key) {
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $f2caf184cab96719$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $8SyCD.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement((0, $9189e6af494f48be$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    var validateMessages = $8SyCD.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $d5357cacfbc573f6$export$4950aa0f605343fb)(((_a = (0, $32f46d71751d4424$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $6babfaa939aeeb39$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $ffdafc34f27b75e9$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $ffdafc34f27b75e9$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $c42b58850f71819f$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $5ef11331ce5e57bf$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $8SyCD.createElement((0, $1d8e78aa4d66ed0b$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    var memoTheme = $8SyCD.useMemo(function() {
        var _a = mergedTheme || {}, algorithm = _a.algorithm, token = _a.token, components = _a.components, cssVar = _a.cssVar, rest = $f2caf184cab96719$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        var themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $594b86af963ae683$export$2e2bcd8739ae039)(algorithm) : (0, $7da138eb2c256f6d$export$164de7ab8df77ef0);
        var parsedComponents = {};
        Object.entries(components || {}).forEach(function(_ref2) {
            var _$_ref2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref2, 2), componentName = _$_ref2[0], componentToken = _$_ref2[1];
            var parsedToken = Object.assign({}, componentToken);
            if ("algorithm" in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") parsedToken.theme = (0, $594b86af963ae683$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        var mergedToken = Object.assign(Object.assign({}, (0, $ea6c8029512de812$export$2e2bcd8739ae039)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $7da138eb2c256f6d$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $a45ff4e670d5554a$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $8SyCD.createElement((0, $e0eab3dc6b8ab52c$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $8SyCD.createElement((0, $d263e45406476254$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
var $f2caf184cab96719$var$ConfigProvider = function(props) {
    var context = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b));
    var antLocale = $8SyCD.useContext((0, $e191ee49d7dd1877$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $8SyCD.createElement($f2caf184cab96719$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$f2caf184cab96719$var$ConfigProvider.ConfigContext = (0, $d263e45406476254$export$a92f85ab3e9ad68b);
$f2caf184cab96719$var$ConfigProvider.SizeContext = (0, $5ef11331ce5e57bf$export$2e2bcd8739ae039);
$f2caf184cab96719$var$ConfigProvider.config = $f2caf184cab96719$var$setGlobalConfig;
$f2caf184cab96719$var$ConfigProvider.useConfig = (0, $1429257a26085410$export$2e2bcd8739ae039);
Object.defineProperty($f2caf184cab96719$var$ConfigProvider, "SizeContext", {
    get: function() {
        return 0, $5ef11331ce5e57bf$export$2e2bcd8739ae039;
    }
});
var $f2caf184cab96719$export$2e2bcd8739ae039 = $f2caf184cab96719$var$ConfigProvider;



var $8SyCD = parcelRequire("8SyCD");
var $70bdd1d9fe5ae128$export$a8257692ac88316c = $8SyCD.isValidElement;
function $70bdd1d9fe5ae128$export$9522e17588c12572(child) {
    return child && $70bdd1d9fe5ae128$export$a8257692ac88316c(child) && child.type === $8SyCD.Fragment;
}
function $70bdd1d9fe5ae128$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$70bdd1d9fe5ae128$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $8SyCD.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function $70bdd1d9fe5ae128$export$e530037191fcd5d7(element, props) {
    return $70bdd1d9fe5ae128$export$2dfe578f95754f6a(element, element, props);
}






var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
function $fa203615ea0be7e2$export$2e2bcd8739ae039(callback) {
    var fnRef = $8SyCD.useRef();
    fnRef.current = callback;
    var memoFn = $8SyCD.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}






/** We only think `undefined` is empty */ function $a27c32063ec0d006$var$hasValue(value) {
    return value !== undefined;
}
function $a27c32063ec0d006$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)(function() {
        if ($a27c32063ec0d006$var$hasValue(value)) return value;
        else if ($a27c32063ec0d006$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $2fb61ecc178138e6$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        if (!$a27c32063ec0d006$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

















var $105f0394848f0183$var$AbstractCalculator = /*#__PURE__*/ (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $105f0394848f0183$export$2e2bcd8739ae039 = $105f0394848f0183$var$AbstractCalculator;


var $20a8431d71f20fa8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        _this.result = 0;
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === "number") _this.result = num;
        return _this;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === "number") this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === "number") this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === "number") this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === "number") this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $105f0394848f0183$export$2e2bcd8739ae039));







var $29b79cbfbbceb661$var$CALC_UNIT = "CALC_UNIT";
function $29b79cbfbbceb661$var$unit(value) {
    if (typeof value === "number") return "".concat(value).concat($29b79cbfbbceb661$var$CALC_UNIT);
    return value;
}
var $29b79cbfbbceb661$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num) {
        var _this;
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        _this.result = "";
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (typeof num === "number") _this.result = $29b79cbfbbceb661$var$unit(num);
        else if (typeof num === "string") _this.result = num;
        return _this;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " + ").concat($29b79cbfbbceb661$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " - ").concat($29b79cbfbbceb661$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _ref = options || {}, tmp = _ref.unit, cssUnit = tmp === void 0 ? true : tmp;
                var regexp = new RegExp("".concat($29b79cbfbbceb661$var$CALC_UNIT), "g");
                this.result = this.result.replace(regexp, cssUnit ? "px" : "");
                if (typeof this.lowPriority !== "undefined") return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $105f0394848f0183$export$2e2bcd8739ae039));


var $caf4a5c6adbee1a1$var$genCalc = function(type) {
    var Calculator = type === "css" ? (0, $29b79cbfbbceb661$export$2e2bcd8739ae039) : (0, $20a8431d71f20fa8$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num);
    };
};
var $caf4a5c6adbee1a1$export$2e2bcd8739ae039 = $caf4a5c6adbee1a1$var$genCalc;



function $398abe234338aec2$export$2e2bcd8739ae039(type) {
    if (type === "js") return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $d345e6062a3ed2bd$export$523c0b569236b342)(value);
            }).join(","), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $d345e6062a3ed2bd$export$523c0b569236b342)(value);
            }).join(","), ")");
        }
    };
}


var $abce1a6f0eeaf31d$var$enableStatistic = typeof CSSINJS_STATISTIC !== "undefined";
var $abce1a6f0eeaf31d$var$recording = true;
function $abce1a6f0eeaf31d$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$abce1a6f0eeaf31d$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $abce1a6f0eeaf31d$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function() {
                    return obj[key];
                }
            });
        });
    });
    $abce1a6f0eeaf31d$var$recording = true;
    return ret;
}
var $abce1a6f0eeaf31d$export$754a5e2d36c5fa7a = {};
var $abce1a6f0eeaf31d$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $abce1a6f0eeaf31d$var$noop() {}
function $abce1a6f0eeaf31d$export$2e2bcd8739ae039(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $abce1a6f0eeaf31d$var$noop;
    if ($abce1a6f0eeaf31d$var$enableStatistic && typeof Proxy !== "undefined") {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function(obj, prop) {
                if ($abce1a6f0eeaf31d$var$recording) tokenKeys.add(prop);
                return obj[prop];
            }
        });
        flush = function(componentName, componentToken) {
            var _a;
            $abce1a6f0eeaf31d$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: Object.assign(Object.assign({}, (_a = $abce1a6f0eeaf31d$export$754a5e2d36c5fa7a[componentName]) === null || _a === void 0 ? void 0 : _a.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
}



"use client";
var $bc22d80d69885d2a$var$getDefaultComponentToken = function(component, token, getDefaultToken) {
    var _a;
    if (typeof getDefaultToken === "function") return getDefaultToken((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, (_a = token[component]) !== null && _a !== void 0 ? _a : {}));
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
};
var $bc22d80d69885d2a$var$getComponentToken = function(component, token, defaultToken, options) {
    var customToken = Object.assign({}, token[component]);
    if (options === null || options === void 0 ? void 0 : options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _$_ref = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_ref, 2), oldTokenKey = _$_ref[0], newTokenKey = _$_ref[1];
            var _a;
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if ((customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey]) || (customToken === null || customToken === void 0 ? void 0 : customToken[newTokenKey])) (_a = customToken[newTokenKey]) !== null && _a !== void 0 ? _a : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
        });
    }
    var mergedToken = Object.assign(Object.assign({}, defaultToken), customToken);
    if (options === null || options === void 0 ? void 0 : options.format) mergedToken = options.format(mergedToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
};
var $bc22d80d69885d2a$var$getCompVarPrefix = function(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")
    ].filter(Boolean).join("-"));
};
function $bc22d80d69885d2a$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cells = Array.isArray(componentName) ? componentName : [
        componentName,
        componentName
    ];
    var _cells = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(cells, 1), component = _cells[0];
    var concatComponent = cells.join("-");
    return function(prefixCls) {
        var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 5), theme = _useToken[0], realToken = _useToken[1], hashId = _useToken[2], token = _useToken[3], cssVar = _useToken[4];
        var _useContext = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, iconPrefixCls = _useContext.iconPrefixCls, csp = _useContext.csp;
        var rootPrefixCls = getPrefixCls();
        var type = cssVar ? "css" : "js";
        var calc = (0, $caf4a5c6adbee1a1$export$2e2bcd8739ae039)(type);
        var _genMaxMin = (0, $398abe234338aec2$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
        // Shared config
        var sharedConfig = {
            theme: theme,
            token: token,
            hashId: hashId,
            nonce: function() {
                return csp === null || csp === void 0 ? void 0 : csp.nonce;
            },
            clientOnly: options.clientOnly,
            // antd is always at top of styles
            order: options.order || -999
        };
        // Generate style for all a tags in antd component.
        (0, $d21f66fac4f2a7ee$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, sharedConfig), {
            clientOnly: false,
            path: [
                "Shared",
                rootPrefixCls
            ]
        }), function() {
            return [
                {
                    // Link
                    "&": (0, $7cbb7e49dbe61000$export$905d771977096614)(token)
                }
            ];
        });
        // Generate style for icons
        (0, $3fc15afd9b37ec4f$export$2e2bcd8739ae039)(iconPrefixCls, csp);
        var wrapSSR = (0, $d21f66fac4f2a7ee$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, sharedConfig), {
            path: [
                concatComponent,
                prefixCls,
                iconPrefixCls
            ]
        }), function() {
            if (options.injectStyle === false) return [];
            var _statisticToken = (0, $abce1a6f0eeaf31d$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
            var defaultComponentToken = $bc22d80d69885d2a$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            var componentCls = ".".concat(prefixCls);
            var componentToken = $bc22d80d69885d2a$var$getComponentToken(component, realToken, defaultComponentToken, {
                deprecatedTokens: options.deprecatedTokens,
                format: options.format
            });
            if (cssVar) Object.keys(defaultComponentToken).forEach(function(key) {
                defaultComponentToken[key] = "var(".concat((0, $225107b77a38e2c5$export$309b3b095f0c7662)(key, $bc22d80d69885d2a$var$getCompVarPrefix(component, cssVar.prefix)), ")");
            });
            var mergedToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(proxyToken, {
                componentCls: componentCls,
                prefixCls: prefixCls,
                iconCls: ".".concat(iconPrefixCls),
                antCls: ".".concat(rootPrefixCls),
                calc: calc,
                max: max,
                min: min
            }, cssVar ? defaultComponentToken : componentToken);
            var styleInterpolation = styleFn(mergedToken, {
                hashId: hashId,
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls
            });
            flush(component, componentToken);
            return [
                options.resetStyle === false ? null : (0, $7cbb7e49dbe61000$export$689382c111559cd9)(mergedToken, prefixCls),
                styleInterpolation
            ];
        });
        return [
            wrapSSR,
            (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key)
        ];
    };
}
var $bc22d80d69885d2a$export$1537386bc155ea56 = function(componentName, styleFn, getDefaultToken, options) {
    var useStyle = $bc22d80d69885d2a$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken, Object.assign({
        resetStyle: false,
        // Sub Style should default after root one
        order: -998
    }, options));
    var StyledComponent = function(_ref2) {
        var prefixCls = _ref2.prefixCls;
        useStyle(prefixCls);
        return null;
    };
    return StyledComponent;
};
var $bc22d80d69885d2a$var$genCSSVarRegister = function(component, getDefaultToken, options) {
    var prefixToken = function prefixToken(key) {
        return "".concat(component).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
    };
    var _ref = options !== null && options !== void 0 ? options : {}, tmp = _ref.unitless, originUnitless = tmp === void 0 ? {} : tmp, _ref_injectStyle = _ref.injectStyle, injectStyle = _ref_injectStyle === void 0 ? true : _ref_injectStyle;
    var compUnitless = (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, prefixToken("zIndexPopup"), true);
    Object.keys(originUnitless).forEach(function(key) {
        compUnitless[prefixToken(key)] = originUnitless[key];
    });
    var CSSVarRegister = function(_ref3) {
        var rootCls = _ref3.rootCls, cssVar = _ref3.cssVar;
        var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), realToken = _useToken[1];
        (0, $a4a27af22c478547$export$2e2bcd8739ae039)({
            path: [
                component
            ],
            prefix: cssVar.prefix,
            key: cssVar === null || cssVar === void 0 ? void 0 : cssVar.key,
            unitless: Object.assign(Object.assign({}, (0, $4686879ac4f429c9$export$c6b9faa6b723d31a)), compUnitless),
            ignore: (0, $4686879ac4f429c9$export$738b109e247a462c),
            token: realToken,
            scope: rootCls
        }, function() {
            var defaultToken = $bc22d80d69885d2a$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            var componentToken = $bc22d80d69885d2a$var$getComponentToken(component, realToken, defaultToken, {
                format: options === null || options === void 0 ? void 0 : options.format,
                deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
            });
            Object.keys(defaultToken).forEach(function(key) {
                componentToken[prefixToken(key)] = componentToken[key];
                delete componentToken[key];
            });
            return componentToken;
        });
        return null;
    };
    var useCSSVar = function(rootCls) {
        var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 5), cssVar = _useToken[4];
        return function(node) {
            return injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(CSSVarRegister, {
                rootCls: rootCls,
                cssVar: cssVar,
                component: component
            }), node) : node;
        };
    };
    return useCSSVar;
};
var $bc22d80d69885d2a$export$51ec95de45185b42 = function(component, styleFn, getDefaultToken, options) {
    var useStyle = $bc22d80d69885d2a$export$2e2bcd8739ae039(component, styleFn, getDefaultToken, options);
    var useCSSVar = $bc22d80d69885d2a$var$genCSSVarRegister(component, getDefaultToken, options);
    return function genStyleHooks(prefixCls) {
        var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
        var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(useStyle(prefixCls), 2), hashId = _useStyle[1];
        var wrapCSSVar = useCSSVar(rootCls);
        return [
            wrapCSSVar,
            hashId
        ];
    };
};


var $14b1524ad0be910f$var$genWaveStyle = function(token) {
    var componentCls = token.componentCls, colorPrimary = token.colorPrimary;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none",
        boxSizing: "border-box",
        color: "var(--wave-color, ".concat(colorPrimary, ")"),
        boxShadow: "0 0 0 0 currentcolor",
        opacity: 0.2,
        // =================== Motion ===================
        "&.wave-motion-appear": {
            transition: [
                "box-shadow 0.4s ".concat(token.motionEaseOutCirc),
                "opacity 2s ".concat(token.motionEaseOutCirc)
            ].join(","),
            "&-active": {
                boxShadow: "0 0 0 6px currentcolor",
                opacity: 0
            },
            "&.wave-quick": {
                transition: [
                    "box-shadow 0.3s ".concat(token.motionEaseInOut),
                    "opacity 0.35s ".concat(token.motionEaseInOut)
                ].join(",")
            }
        }
    });
};
var $14b1524ad0be910f$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$2e2bcd8739ae039)("Wave", function(token) {
    return [
        $14b1524ad0be910f$var$genWaveStyle(token)
    ];
});




var $8SyCD = parcelRequire("8SyCD");






function $ebf36ae10d47ff06$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $ebf36ae10d47ff06$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var _$t = r.pop();
                if (_$t in e) return next.value = _$t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $9cf742ccf514c151$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9cf742ccf514c151$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9cf742ccf514c151$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9cf742ccf514c151$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





// Let compiler not to search module usage
var $68cc2bdb5293678e$var$fullClone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, $b4e4ce7bd3c993b9$exports);
var $68cc2bdb5293678e$var$version = $68cc2bdb5293678e$var$fullClone.version, $68cc2bdb5293678e$var$reactRender = $68cc2bdb5293678e$var$fullClone.render, $68cc2bdb5293678e$var$unmountComponentAtNode = $68cc2bdb5293678e$var$fullClone.unmountComponentAtNode;
var $68cc2bdb5293678e$var$createRoot;
try {
    var $68cc2bdb5293678e$var$mainVersion = Number(($68cc2bdb5293678e$var$version || "").split(".")[0]);
    if ($68cc2bdb5293678e$var$mainVersion >= 18) $68cc2bdb5293678e$var$createRoot = $68cc2bdb5293678e$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $68cc2bdb5293678e$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $68cc2bdb5293678e$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $68cc2bdb5293678e$var$MARK = "__rc_react_root__";
// ========================== Render ==========================
function $68cc2bdb5293678e$var$modernRender(node, container) {
    $68cc2bdb5293678e$var$toggleWarning(true);
    var root = container[$68cc2bdb5293678e$var$MARK] || $68cc2bdb5293678e$var$createRoot(container);
    $68cc2bdb5293678e$var$toggleWarning(false);
    root.render(node);
    container[$68cc2bdb5293678e$var$MARK] = root;
}
function $68cc2bdb5293678e$var$legacyRender(node, container) {
    $68cc2bdb5293678e$var$reactRender(node, container);
}
function $68cc2bdb5293678e$export$892c6608f54d7438(node, container) {}
function $68cc2bdb5293678e$export$b3890eb0ae9dca99(node, container) {
    if ($68cc2bdb5293678e$var$createRoot) {
        $68cc2bdb5293678e$var$modernRender(node, container);
        return;
    }
    $68cc2bdb5293678e$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $68cc2bdb5293678e$var$modernUnmount(_x) {
    return $68cc2bdb5293678e$var$_modernUnmount.apply(this, arguments);
}
function $68cc2bdb5293678e$var$_modernUnmount() {
    $68cc2bdb5293678e$var$_modernUnmount = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee(container) {
        return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$68cc2bdb5293678e$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$68cc2bdb5293678e$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $68cc2bdb5293678e$var$_modernUnmount.apply(this, arguments);
}
function $68cc2bdb5293678e$var$legacyUnmount(container) {
    $68cc2bdb5293678e$var$unmountComponentAtNode(container);
}
function $68cc2bdb5293678e$export$fd39fe14445b207a(container) {}
function $68cc2bdb5293678e$export$121e2d597d222bad(_x2) {
    return $68cc2bdb5293678e$var$_unmount.apply(this, arguments);
}
function $68cc2bdb5293678e$var$_unmount() {
    $68cc2bdb5293678e$var$_unmount = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee2(container) {
        return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($68cc2bdb5293678e$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $68cc2bdb5293678e$var$modernUnmount(container));
                case 2:
                    $68cc2bdb5293678e$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $68cc2bdb5293678e$var$_unmount.apply(this, arguments);
}




var $8SyCD = parcelRequire("8SyCD");
function $cdbd563a25c62248$export$1394a8dd73acd4cc(color) {
    // eslint-disable-next-line no-useless-escape
    var match = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
function $cdbd563a25c62248$export$9d61ea039e87eb91(color) {
    return color && color !== "#fff" && color !== "#ffffff" && color !== "rgb(255, 255, 255)" && color !== "rgba(255, 255, 255, 1)" && $cdbd563a25c62248$export$1394a8dd73acd4cc(color) && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== "transparent";
}
function $cdbd563a25c62248$export$651d8e9c80304fc8(node) {
    var _getComputedStyle = getComputedStyle(node), borderTopColor = _getComputedStyle.borderTopColor, borderColor = _getComputedStyle.borderColor, backgroundColor = _getComputedStyle.backgroundColor;
    if ($cdbd563a25c62248$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($cdbd563a25c62248$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($cdbd563a25c62248$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}


var $8fcc0c1cf0e69ec1$export$23466a5792b7a5d3 = "ant-wave-target";


"use client";
function $e46b8cef01ed7158$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
var $e46b8cef01ed7158$var$WaveEffect = function(props) {
    var syncPos = function syncPos() {
        var nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $cdbd563a25c62248$export$651d8e9c80304fc8)(target));
        var isStatic = nodeStyle.position === "static";
        // Rect
        var borderLeftWidth = nodeStyle.borderLeftWidth, borderTopWidth = nodeStyle.borderTopWidth;
        setLeft(isStatic ? target.offsetLeft : $e46b8cef01ed7158$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $e46b8cef01ed7158$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        var borderTopLeftRadius = nodeStyle.borderTopLeftRadius, borderTopRightRadius = nodeStyle.borderTopRightRadius, borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius, borderBottomRightRadius = nodeStyle.borderBottomRightRadius;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map(function(radius) {
            return $e46b8cef01ed7158$var$validateNum(parseFloat(radius));
        }));
    };
    var className = props.className, target = props.target, component = props.component;
    var divRef = $8SyCD.useRef(null);
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(null), 2), color = _React_useState[0], setWaveColor = _React_useState[1];
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState([]), 2), borderRadius = _React_useState1[0], setBorderRadius = _React_useState1[1];
    var _React_useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), left = _React_useState2[0], setLeft = _React_useState2[1];
    var _React_useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), top = _React_useState3[0], setTop = _React_useState3[1];
    var _React_useState4 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), width = _React_useState4[0], setWidth = _React_useState4[1];
    var _React_useState5 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), height = _React_useState5[0], setHeight = _React_useState5[1];
    var _React_useState6 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), enabled = _React_useState6[0], setEnabled = _React_useState6[1];
    var waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map(function(radius) {
            return "".concat(radius, "px");
        }).join(" ")
    };
    if (color) waveStyle["--wave-color"] = color;
    $8SyCD.useEffect(function() {
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            var id = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            var resizeObserver;
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return function() {
                (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    var isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $8fcc0c1cf0e69ec1$export$23466a5792b7a5d3)));
    return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: function(_, event) {
            var _a;
            if (event.deadline || event.propertyName === "opacity") {
                var holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (0, $68cc2bdb5293678e$export$121e2d597d222bad)(holder).then(function() {
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, function(_ref) {
        var motionClassName = _ref.className;
        return /*#__PURE__*/ $8SyCD.createElement("div", {
            ref: divRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, {
                "wave-quick": isSmallComponent
            }, motionClassName),
            style: waveStyle
        });
    });
};
var $e46b8cef01ed7158$var$showWaveEffect = function(target, info) {
    var _a;
    var component = info.component;
    // Skip for unchecked checkbox
    if (component === "Checkbox" && !((_a = target.querySelector("input")) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    var holder = document.createElement("div");
    holder.style.position = "absolute";
    holder.style.left = "0px";
    holder.style.top = "0px";
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    (0, $68cc2bdb5293678e$export$b3890eb0ae9dca99)(/*#__PURE__*/ $8SyCD.createElement($e46b8cef01ed7158$var$WaveEffect, Object.assign({}, info, {
        target: target
    })), holder);
};
var $e46b8cef01ed7158$export$2e2bcd8739ae039 = $e46b8cef01ed7158$var$showWaveEffect;





function $5bbe58a5a7fcce40$export$2e2bcd8739ae039(nodeRef, className, component) {
    var wave = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).wave;
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 3), token = _useToken[1], hashId = _useToken[2];
    var showWave = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(event) {
        var node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        var targetNode = node.querySelector(".".concat((0, $8fcc0c1cf0e69ec1$export$23466a5792b7a5d3))) || node;
        var showEffect = (wave || {}).showEffect;
        // Customize wave effect
        (showEffect || (0, $e46b8cef01ed7158$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    var rafId = $8SyCD.useRef();
    // Merge trigger event into one for each frame
    var showDebounceWave = function(event) {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            showWave(event);
        });
    };
    return showDebounceWave;
}


var $1f7e26aa70b888fb$var$Wave = function(props) {
    var children = props.children, disabled = props.disabled, component = props.component;
    var getPrefixCls = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var containerRef = (0, $8SyCD.useRef)(null);
    // ============================== Style ===============================
    var prefixCls = getPrefixCls("wave");
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $14b1524ad0be910f$export$2e2bcd8739ae039)(prefixCls), 2), hashId = _useStyle[1];
    // =============================== Wave ===============================
    var showWave = (0, $5bbe58a5a7fcce40$export$2e2bcd8739ae039)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useEffect(function() {
        var node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        var onClick = function(e) {
            // Fix radio button click twice
            if (!(0, $1f0413060b1cb2c2$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute("disabled") || node.disabled || node.className.includes("disabled") || node.className.includes("-leave")) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener("click", onClick, true);
        return function() {
            node.removeEventListener("click", onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    var ref = (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(children) ? (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(children.ref, containerRef) : containerRef;
    return (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $1f7e26aa70b888fb$export$2e2bcd8739ae039 = $1f7e26aa70b888fb$var$Wave;





var $8SyCD = parcelRequire("8SyCD");

var $57fee9dea752ba29$var$useSize = function(customSize) {
    var size = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $5ef11331ce5e57bf$export$2e2bcd8739ae039));
    var mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useMemo(function() {
        if (!customSize) return size;
        if (typeof customSize === "string") return customSize !== null && customSize !== void 0 ? customSize : size;
        if (customSize instanceof Function) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $57fee9dea752ba29$export$2e2bcd8739ae039 = $57fee9dea752ba29$var$useSize;






var $8SyCD = parcelRequire("8SyCD");

function $0181a7b922e4e9e8$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($0181a7b922e4e9e8$export$2e2bcd8739ae039(child));
        else if ((0, $9098d7397e765aa5$exports.isFragment)(child) && child.props) ret = ret.concat($0181a7b922e4e9e8$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}



var $8SyCD = parcelRequire("8SyCD");





var $6d35bb3f34fd8cc3$var$genSpaceCompactStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        "&-block": {
            display: "flex",
            width: "100%"
        },
        "&-vertical": {
            flexDirection: "column"
        }
    });
};
var // ============================== Export ==============================
$6d35bb3f34fd8cc3$export$2e2bcd8739ae039 = $6d35bb3f34fd8cc3$var$genSpaceCompactStyle;


var $a876ddbfa81c095a$var$genSpaceStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        display: "inline-flex",
        "&-rtl": {
            direction: "rtl"
        },
        "&-vertical": {
            flexDirection: "column"
        },
        "&-align": {
            flexDirection: "column",
            "&-center": {
                alignItems: "center"
            },
            "&-start": {
                alignItems: "flex-start"
            },
            "&-end": {
                alignItems: "flex-end"
            },
            "&-baseline": {
                alignItems: "baseline"
            }
        }
    }, "".concat(componentCls, "-item:empty"), {
        display: "none"
    }));
};
var $a876ddbfa81c095a$var$genSpaceGapStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        "&-gap-row-small": {
            rowGap: token.spaceGapSmallSize
        },
        "&-gap-row-middle": {
            rowGap: token.spaceGapMiddleSize
        },
        "&-gap-row-large": {
            rowGap: token.spaceGapLargeSize
        },
        "&-gap-col-small": {
            columnGap: token.spaceGapSmallSize
        },
        "&-gap-col-middle": {
            columnGap: token.spaceGapMiddleSize
        },
        "&-gap-col-large": {
            columnGap: token.spaceGapLargeSize
        }
    });
};
var $a876ddbfa81c095a$export$9ca1be8807fe0675 = function() {
    return {};
};
var $a876ddbfa81c095a$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Space", function(token) {
    var spaceToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $a876ddbfa81c095a$var$genSpaceStyle(spaceToken),
        $a876ddbfa81c095a$var$genSpaceGapStyle(spaceToken),
        (0, $6d35bb3f34fd8cc3$export$2e2bcd8739ae039)(spaceToken)
    ];
}, function() {
    return {};
}, {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
var $e2e782fcf54617f6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e2e782fcf54617f6$export$8d1c486ac0db0a7d = /*#__PURE__*/ $8SyCD.createContext(null);
var $e2e782fcf54617f6$export$cd8cf9d7bab8dd4 = function(prefixCls, direction) {
    var compactItemContext = $8SyCD.useContext($e2e782fcf54617f6$export$8d1c486ac0db0a7d);
    var compactItemClassnames = $8SyCD.useMemo(function() {
        if (!compactItemContext) return "";
        var compactDirection = compactItemContext.compactDirection, isFirstItem = compactItemContext.isFirstItem, isLastItem = compactItemContext.isLastItem;
        var separator = compactDirection === "vertical" ? "-vertical-" : "-";
        var _obj;
        return (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-compact").concat(separator, "item"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-compact").concat(separator, "first-item"), isFirstItem), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-compact").concat(separator, "last-item"), isLastItem), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-compact").concat(separator, "item-rtl"), direction === "rtl"), _obj));
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
var $e2e782fcf54617f6$export$5f56e610a4afb685 = function(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $8SyCD.createElement($e2e782fcf54617f6$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
var $e2e782fcf54617f6$var$CompactItem = function(_a) {
    var children = _a.children, otherProps = $e2e782fcf54617f6$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $8SyCD.createElement($e2e782fcf54617f6$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
var $e2e782fcf54617f6$var$Compact = function(props) {
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, directionConfig = _React_useContext.direction;
    var size = props.size, direction = props.direction, block = props.block, customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, children = props.children, restProps = $e2e782fcf54617f6$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctx) {
        return size !== null && size !== void 0 ? size : ctx;
    });
    var prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a876ddbfa81c095a$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj;
    var clx = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, hashId, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), directionConfig === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-block"), block), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-vertical"), direction === "vertical"), _obj), className, rootClassName);
    var compactItemContext = $8SyCD.useContext($e2e782fcf54617f6$export$8d1c486ac0db0a7d);
    var childNodes = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children);
    var nodes = $8SyCD.useMemo(function() {
        return childNodes.map(function(child, i) {
            var key = child && child.key || "".concat(prefixCls, "-item-").concat(i);
            return /*#__PURE__*/ $8SyCD.createElement($e2e782fcf54617f6$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        });
    }, [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $e2e782fcf54617f6$export$2e2bcd8739ae039 = $e2e782fcf54617f6$var$Compact;





var $8SyCD = parcelRequire("8SyCD");




"use client";
var $fb4522e65fe1e51a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fb4522e65fe1e51a$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $8SyCD.createContext(undefined);
var $fb4522e65fe1e51a$var$ButtonGroup = function(props) {
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = $fb4522e65fe1e51a$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    var prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 3), hashId = _useToken[2];
    var sizeCls = "";
    switch(size){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        case "middle":
        default:
    }
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), className, hashId);
    return /*#__PURE__*/ $8SyCD.createElement($fb4522e65fe1e51a$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $fb4522e65fe1e51a$export$2e2bcd8739ae039 = $fb4522e65fe1e51a$var$ButtonGroup;



var $7FyBz = parcelRequire("7FyBz");

var $8SyCD = parcelRequire("8SyCD");

"use client";
var $32812387acf2752d$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var $32812387acf2752d$export$c5dca2bf412dea0d = $32812387acf2752d$var$rxTwoCNChar.test.bind($32812387acf2752d$var$rxTwoCNChar);
function $32812387acf2752d$export$19bc9a290855952(type) {
    if (type === "danger") return {
        danger: true
    };
    return {
        type: type
    };
}
function $32812387acf2752d$export$844ec244b1367d54(str) {
    return typeof str === "string";
}
function $32812387acf2752d$export$1085c0511270cee(type) {
    return type === "text" || type === "link";
}
function $32812387acf2752d$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    var SPACE = needInserted ? " " : "";
    if (typeof child !== "string" && typeof child !== "number" && $32812387acf2752d$export$844ec244b1367d54(child.type) && $32812387acf2752d$export$c5dca2bf412dea0d(child.props.children)) return (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(child, {
        children: child.props.children.split("").join(SPACE)
    });
    if ($32812387acf2752d$export$844ec244b1367d54(child)) return $32812387acf2752d$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", null, child.split("").join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", null, child);
    if ((0, $70bdd1d9fe5ae128$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", null, child);
    return child;
}
function $32812387acf2752d$export$b6ee00a7e7908bc(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Children.forEach(children, function(child) {
        var type = typeof child === "undefined" ? "undefined" : (0, $7FyBz._)(child);
        var isCurrentChildPure = type === "string" || type === "number";
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Children.map(childList, function(child) {
        return $32812387acf2752d$var$splitCNCharsBySpace(child, needInserted);
    });
}
var $32812387acf2752d$var$ButtonTypes = [
    "default",
    "primary",
    "dashed",
    "link",
    "text"
];
var $32812387acf2752d$var$ButtonShapes = [
    "default",
    "circle",
    "round"
];
var $32812387acf2752d$var$ButtonHTMLTypes = [
    "submit",
    "button",
    "reset"
];



var $8SyCD = parcelRequire("8SyCD");

"use client";
var $965c0690e2c89c6a$var$IconWrapper = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var className = props.className, style = props.style, children = props.children, prefixCls = props.prefixCls;
    var iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-icon"), className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $965c0690e2c89c6a$export$2e2bcd8739ae039 = $965c0690e2c89c6a$var$IconWrapper;




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $0cfb2a974b1b5606$var$LoadingOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "0 0 1024 1024",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    name: "loading",
    theme: "outlined"
};
var $0cfb2a974b1b5606$export$2e2bcd8739ae039 = $0cfb2a974b1b5606$var$LoadingOutlined;







var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");




function $ba1d9436078efdd1$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $ba1d9436078efdd1$export$cca82218ea4431a(ele) {
    return $ba1d9436078efdd1$var$getRoot(ele) instanceof ShadowRoot;
}
function $ba1d9436078efdd1$export$70e8259662bb498b(ele) {
    return $ba1d9436078efdd1$export$cca82218ea4431a(ele) ? $ba1d9436078efdd1$var$getRoot(ele) : null;
}




var $8SyCD = parcelRequire("8SyCD");

function $1b30616e478e7e61$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $1b30616e478e7e61$export$491112666e282270(valid, message) {
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $1b30616e478e7e61$export$ab652842c37578f4(target) {
    return (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(target.icon) === "object" || typeof target.icon === "function");
}
function $1b30616e478e7e61$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc["class"];
                break;
            default:
                delete acc[key];
                acc[$1b30616e478e7e61$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1b30616e478e7e61$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(node.tag, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        key: key
    }, $1b30616e478e7e61$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1b30616e478e7e61$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(node.tag, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        key: key
    }, $1b30616e478e7e61$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1b30616e478e7e61$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1b30616e478e7e61$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $9a4cf0984844f770$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1b30616e478e7e61$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1b30616e478e7e61$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
var $1b30616e478e7e61$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1b30616e478e7e61$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $8SyCD.useContext)((0, $c42b58850f71819f$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls;
    var mergedStyleStr = $1b30616e478e7e61$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    (0, $8SyCD.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $ba1d9436078efdd1$export$70e8259662bb498b)(ele);
        (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)(mergedStyleStr, "@ant-design-icons", {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $b2d2b3345f37d0a8$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $b2d2b3345f37d0a8$var$twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
};
function $b2d2b3345f37d0a8$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $b2d2b3345f37d0a8$var$twoToneColorPalette.primaryColor = primaryColor;
    $b2d2b3345f37d0a8$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1b30616e478e7e61$export$b71c93f469694483)(primaryColor);
    $b2d2b3345f37d0a8$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $b2d2b3345f37d0a8$var$getTwoToneColors() {
    return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, $b2d2b3345f37d0a8$var$twoToneColorPalette);
}
var $b2d2b3345f37d0a8$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $b2d2b3345f37d0a8$var$_excluded);
    var svgRef = $8SyCD.useRef();
    var colors = $b2d2b3345f37d0a8$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1b30616e478e7e61$export$b71c93f469694483)(primaryColor)
    };
    (0, $1b30616e478e7e61$export$938b1f86b61613d0)(svgRef);
    (0, $1b30616e478e7e61$export$491112666e282270)((0, $1b30616e478e7e61$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $1b30616e478e7e61$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === "function") target = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $1b30616e478e7e61$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
    }, restProps), {}, {
        ref: svgRef
    }));
};
$b2d2b3345f37d0a8$var$IconBase.displayName = "IconReact";
$b2d2b3345f37d0a8$var$IconBase.getTwoToneColors = $b2d2b3345f37d0a8$var$getTwoToneColors;
$b2d2b3345f37d0a8$var$IconBase.setTwoToneColors = $b2d2b3345f37d0a8$var$setTwoToneColors;
var $b2d2b3345f37d0a8$export$2e2bcd8739ae039 = $b2d2b3345f37d0a8$var$IconBase;





function $c6889c13fdee7f19$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $1b30616e478e7e61$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $b2d2b3345f37d0a8$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $c6889c13fdee7f19$export$abc7c554784cb4a7() {
    var colors = (0, $b2d2b3345f37d0a8$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



"use client";
var $fb00e6bc3d52cbac$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $c6889c13fdee7f19$export$8a145f34580ff02b)((0, $cf51007abaccff76$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $fb00e6bc3d52cbac$var$Icon = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _classNames;
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $fb00e6bc3d52cbac$var$_excluded);
    var _React$useContext = $8SyCD.useContext((0, $c42b58850f71819f$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(rootClassName, prefixCls, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), _classNames), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $1b30616e478e7e61$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $8SyCD.createElement("span", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $8SyCD.createElement((0, $b2d2b3345f37d0a8$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$fb00e6bc3d52cbac$var$Icon.displayName = "AntdIcon";
$fb00e6bc3d52cbac$var$Icon.getTwoToneColor = (0, $c6889c13fdee7f19$export$abc7c554784cb4a7);
$fb00e6bc3d52cbac$var$Icon.setTwoToneColor = (0, $c6889c13fdee7f19$export$8a145f34580ff02b);
var $fb00e6bc3d52cbac$export$2e2bcd8739ae039 = $fb00e6bc3d52cbac$var$Icon;


var $d921af23c702a53c$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0cfb2a974b1b5606$export$2e2bcd8739ae039)
    }));
};
var $d921af23c702a53c$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d921af23c702a53c$var$LoadingOutlined);





var $8SyCD = parcelRequire("8SyCD");

"use client";
var $be3948f6786ba666$var$InnerLoadingIcon = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(_ref, ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, iconClassName = _ref.iconClassName;
    var mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-loading-icon"), className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $965c0690e2c89c6a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $d921af23c702a53c$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
var $be3948f6786ba666$var$getCollapsedWidth = function() {
    return {
        width: 0,
        opacity: 0,
        transform: "scale(0)"
    };
};
var $be3948f6786ba666$var$getRealWidth = function(node) {
    return {
        width: node.scrollWidth,
        opacity: 1,
        transform: "scale(1)"
    };
};
var $be3948f6786ba666$var$LoadingIcon = function(props) {
    var prefixCls = props.prefixCls, loading = props.loading, existIcon = props.existIcon, className = props.className, style = props.style;
    var visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement($be3948f6786ba666$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), {
        visible: visible,
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"),
        motionLeave: visible,
        removeOnLeave: true,
        onAppearStart: $be3948f6786ba666$var$getCollapsedWidth,
        onAppearActive: $be3948f6786ba666$var$getRealWidth,
        onEnterStart: $be3948f6786ba666$var$getCollapsedWidth,
        onEnterActive: $be3948f6786ba666$var$getRealWidth,
        onLeaveStart: $be3948f6786ba666$var$getRealWidth,
        onLeaveActive: $be3948f6786ba666$var$getCollapsedWidth
    }, function(_ref2, ref) {
        var motionCls = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement($be3948f6786ba666$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: className,
            style: Object.assign(Object.assign({}, style), motionStyle),
            ref: ref,
            iconClassName: motionCls
        });
    });
};
var $be3948f6786ba666$export$2e2bcd8739ae039 = $be3948f6786ba666$var$LoadingIcon;







var $499437974110df5e$var$genButtonBorderStyle = function(buttonTypeCls, borderColor) {
    return(// Border
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> span, > ".concat(buttonTypeCls), {
        "&:not(:last-child)": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, & > ".concat(buttonTypeCls), {
            "&:not(:disabled)": {
                borderInlineEndColor: borderColor
            }
        }),
        "&:not(:first-child)": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, & > ".concat(buttonTypeCls), {
            "&:not(:disabled)": {
                borderInlineStartColor: borderColor
            }
        })
    }));
};
var $499437974110df5e$var$genGroupStyle = function(token) {
    var componentCls = token.componentCls, fontSize = token.fontSize, lineWidth = token.lineWidth, groupBorderColor = token.groupBorderColor, colorErrorHover = token.colorErrorHover;
    var _obj, _obj1;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group"), [
        (_obj1 = {
            position: "relative",
            display: "inline-flex"
        }, // Border
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> span, > ".concat(componentCls), {
            "&:not(:last-child)": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, & > ".concat(componentCls), {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }),
            "&:not(:first-child)": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                marginInlineStart: token.calc(lineWidth).mul(-1).equal()
            }, "&, & > ".concat(componentCls), {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            })
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, componentCls, (_obj = {
            position: "relative",
            zIndex: 1
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:hover,\n          &:focus,\n          &:active", {
            zIndex: 2
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&[disabled]", {
            zIndex: 0
        }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-icon-only"), {
            fontSize: fontSize
        }), _obj1),
        // Border Color
        $499437974110df5e$var$genButtonBorderStyle("".concat(componentCls, "-primary"), groupBorderColor),
        $499437974110df5e$var$genButtonBorderStyle("".concat(componentCls, "-danger"), colorErrorHover)
    ]);
};
var $499437974110df5e$export$2e2bcd8739ae039 = $499437974110df5e$var$genGroupStyle;


// ============================== Shared ==============================
var $9299243921c534ad$var$genSharedButtonStyle = function(token) {
    var componentCls = token.componentCls, iconCls = token.iconCls, fontWeight = token.fontWeight;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj = {
        outline: "none",
        position: "relative",
        display: "inline-block",
        fontWeight: fontWeight,
        whiteSpace: "nowrap",
        textAlign: "center",
        backgroundImage: "none",
        background: "transparent",
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " transparent"),
        cursor: "pointer",
        transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
        userSelect: "none",
        touchAction: "manipulation",
        lineHeight: token.lineHeight,
        color: token.colorText,
        "&:disabled > *": {
            pointerEvents: "none"
        },
        "> span": {
            display: "inline-block"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-icon"), {
        lineHeight: 0
    }), // Leave a space between icon and text.
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(iconCls, " + span, > span + ").concat(iconCls), {
        marginInlineStart: token.marginXS
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-icon-only) > ").concat(componentCls, "-icon"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-loading-icon, &:not(:last-child)"), {
        marginInlineEnd: token.marginXS
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> a", {
        color: "currentColor"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(:disabled)", Object.assign({}, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-two-chinese-chars::first-letter"), {
        letterSpacing: "0.34em"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-two-chinese-chars > *:not(").concat(iconCls, ")"), {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
    }), // make `btn-icon-only` not too narrow
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-icon-only".concat(componentCls, "-compact-item"), {
        flex: "none"
    }), _obj));
};
var $9299243921c534ad$var$genHoverActiveButtonStyle = function(btnCls, hoverStyle, activeStyle) {
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not(:disabled):not(".concat(btnCls, "-disabled)"), {
        "&:hover": hoverStyle,
        "&:active": activeStyle
    });
};
// ============================== Shape ===============================
var $9299243921c534ad$var$genCircleButtonStyle = function(token) {
    return {
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: "50%"
    };
};
var $9299243921c534ad$var$genRoundButtonStyle = function(token) {
    return {
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    };
};
// =============================== Type ===============================
var $9299243921c534ad$var$genDisabledStyle = function(token) {
    return {
        cursor: "not-allowed",
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: "none"
    };
};
var $9299243921c534ad$var$genGhostButtonStyle = function(btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) {
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(btnCls, "-background-ghost"), Object.assign(Object.assign({
        color: textColor || undefined,
        background: background,
        borderColor: borderColor || undefined,
        boxShadow: "none"
    }, $9299243921c534ad$var$genHoverActiveButtonStyle(btnCls, Object.assign({
        background: background
    }, hoverStyle), Object.assign({
        background: background
    }, activeStyle))), {
        "&:disabled": {
            cursor: "not-allowed",
            color: textColorDisabled || undefined,
            borderColor: borderColorDisabled || undefined
        }
    }));
};
var $9299243921c534ad$var$genSolidDisabledButtonStyle = function(token) {
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:disabled, &".concat(token.componentCls, "-disabled"), Object.assign({}, $9299243921c534ad$var$genDisabledStyle(token)));
};
var $9299243921c534ad$var$genSolidButtonStyle = function(token) {
    return Object.assign({}, $9299243921c534ad$var$genSolidDisabledButtonStyle(token));
};
var $9299243921c534ad$var$genPureDisabledButtonStyle = function(token) {
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:disabled, &".concat(token.componentCls, "-disabled"), {
        cursor: "not-allowed",
        color: token.colorTextDisabled
    });
};
// Type: Default
var $9299243921c534ad$var$genDefaultButtonStyle = function(token) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $9299243921c534ad$var$genSolidButtonStyle(token)), {
        background: token.defaultBg,
        borderColor: token.defaultBorderColor,
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }), $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    })), $9299243921c534ad$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(token.componentCls, "-dangerous"), Object.assign(Object.assign(Object.assign({
        color: token.colorError,
        borderColor: token.colorError
    }, $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorBorderHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $9299243921c534ad$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder)), $9299243921c534ad$var$genSolidDisabledButtonStyle(token))));
};
// Type: Primary
var $9299243921c534ad$var$genPrimaryButtonStyle = function(token) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $9299243921c534ad$var$genSolidButtonStyle(token)), {
        color: token.primaryColor,
        background: token.colorPrimary,
        boxShadow: token.primaryShadow
    }), $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryHover
    }, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryActive
    })), $9299243921c534ad$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(token.componentCls, "-dangerous"), Object.assign(Object.assign(Object.assign({
        background: token.colorError,
        boxShadow: token.dangerShadow,
        color: token.dangerColor
    }, $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        background: token.colorErrorHover
    }, {
        background: token.colorErrorActive
    })), $9299243921c534ad$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $9299243921c534ad$var$genSolidDisabledButtonStyle(token))));
};
// Type: Dashed
var $9299243921c534ad$var$genDashedButtonStyle = function(token) {
    return Object.assign(Object.assign({}, $9299243921c534ad$var$genDefaultButtonStyle(token)), {
        borderStyle: "dashed"
    });
};
// Type: Link
var $9299243921c534ad$var$genLinkButtonStyle = function(token) {
    return Object.assign(Object.assign(Object.assign({
        color: token.colorLink
    }, $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    })), $9299243921c534ad$var$genPureDisabledButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(token.componentCls, "-dangerous"), Object.assign(Object.assign({
        color: token.colorError
    }, $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorErrorHover
    }, {
        color: token.colorErrorActive
    })), $9299243921c534ad$var$genPureDisabledButtonStyle(token))));
};
// Type: Text
var $9299243921c534ad$var$genTextButtonStyle = function(token) {
    return Object.assign(Object.assign(Object.assign({}, $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorText,
        background: token.textHoverBg
    }, {
        color: token.colorText,
        background: token.colorBgTextActive
    })), $9299243921c534ad$var$genPureDisabledButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(token.componentCls, "-dangerous"), Object.assign(Object.assign({
        color: token.colorError
    }, $9299243921c534ad$var$genPureDisabledButtonStyle(token)), $9299243921c534ad$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }, {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }))));
};
var $9299243921c534ad$var$genTypeButtonStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-default"), $9299243921c534ad$var$genDefaultButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-primary"), $9299243921c534ad$var$genPrimaryButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-dashed"), $9299243921c534ad$var$genDashedButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-link"), $9299243921c534ad$var$genLinkButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-text"), $9299243921c534ad$var$genTextButtonStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-ghost"), $9299243921c534ad$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorBgContainer, token.colorBgContainer, token.colorTextDisabled, token.colorBorder)), _obj;
};
// =============================== Size ===============================
var $9299243921c534ad$var$genSizeButtonStyle = function genSizeButtonStyle(token) {
    var sizePrefixCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var componentCls = token.componentCls, controlHeight = token.controlHeight, fontSize = token.fontSize, borderRadius = token.borderRadius, buttonPaddingHorizontal = token.buttonPaddingHorizontal, iconCls = token.iconCls, buttonPaddingVertical = token.buttonPaddingVertical;
    var iconOnlyCls = "".concat(componentCls, "-icon-only");
    var _obj, _obj1;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls).concat(sizePrefixCls), (_obj1 = {
            fontSize: fontSize,
            height: controlHeight,
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(buttonPaddingVertical), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(buttonPaddingHorizontal)),
            borderRadius: borderRadius
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(iconOnlyCls), (_obj = {
            width: controlHeight,
            paddingInlineStart: 0,
            paddingInlineEnd: 0
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-round"), {
            width: "auto"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, iconCls, {
            fontSize: token.buttonIconOnlyFontSize
        }), _obj)), // Loading
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-loading"), {
            opacity: token.opacityLoading,
            cursor: "default"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-loading-icon"), {
            transition: "width ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ", opacity ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut)
        }), _obj1)),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls).concat(componentCls, "-circle").concat(sizePrefixCls), $9299243921c534ad$var$genCircleButtonStyle(token)),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls).concat(componentCls, "-round").concat(sizePrefixCls), $9299243921c534ad$var$genRoundButtonStyle(token))
    ];
};
var $9299243921c534ad$var$genSizeBaseButtonStyle = function(token) {
    return $9299243921c534ad$var$genSizeButtonStyle((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    }));
};
var $9299243921c534ad$var$genSizeSmallButtonStyle = function(token) {
    var smallToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: token.paddingBlockSM,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $9299243921c534ad$var$genSizeButtonStyle(smallToken, "".concat(token.componentCls, "-sm"));
};
var $9299243921c534ad$var$genSizeLargeButtonStyle = function(token) {
    var largeToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: token.paddingBlockLG,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $9299243921c534ad$var$genSizeButtonStyle(largeToken, "".concat(token.componentCls, "-lg"));
};
var $9299243921c534ad$var$genBlockButtonStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-block"), {
        width: "100%"
    }));
};
var $9299243921c534ad$export$362fb92a8f81bbf9 = function(token) {
    var paddingInline = token.paddingInline, onlyIconSize = token.onlyIconSize, paddingBlock = token.paddingBlock;
    var buttonToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: paddingBlock,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
var $9299243921c534ad$export$9ca1be8807fe0675 = function(token) {
    var contentFontSize = token.fontSize;
    var contentFontSizeSM = token.fontSize;
    var contentFontSizeLG = token.fontSizeLG;
    return {
        fontWeight: 400,
        defaultShadow: "0 ".concat(token.controlOutlineWidth, "px 0 ").concat(token.controlTmpOutline),
        primaryShadow: "0 ".concat(token.controlOutlineWidth, "px 0 ").concat(token.controlOutline),
        dangerShadow: "0 ".concat(token.controlOutlineWidth, "px 0 ").concat(token.colorErrorOutline),
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: "transparent",
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * token.lineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * token.lineHeight) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * token.lineHeight) / 2 - token.lineWidth, 0),
        onlyIconSize: token.fontSizeLG,
        onlyIconSizeSM: token.fontSizeLG - 2,
        onlyIconSizeLG: token.fontSizeLG + 2,
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: "transparent",
        textHoverBg: token.colorBgTextHover,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG
    };
};
var $9299243921c534ad$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Button", function(token) {
    var buttonToken = $9299243921c534ad$export$362fb92a8f81bbf9(token);
    return [
        // Shared
        $9299243921c534ad$var$genSharedButtonStyle(buttonToken),
        // Size
        $9299243921c534ad$var$genSizeSmallButtonStyle(buttonToken),
        $9299243921c534ad$var$genSizeBaseButtonStyle(buttonToken),
        $9299243921c534ad$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $9299243921c534ad$var$genBlockButtonStyle(buttonToken),
        // Group (type, ghost, danger, loading)
        $9299243921c534ad$var$genTypeButtonStyle(buttonToken),
        // Button Group
        (0, $499437974110df5e$export$2e2bcd8739ae039)(buttonToken)
    ];
}, $9299243921c534ad$export$9ca1be8807fe0675, {
    unitless: {
        fontWeight: true
    }
});




// handle border collapse

function $8123ced5d1d65f52$var$compactItemBorder(token, parentCls, options) {
    var focusElCls = options.focusElCls, focus = options.focus, borderElCls = options.borderElCls;
    var childCombinator = borderElCls ? "> *" : "";
    var hoverEffects = [
        "hover",
        focus ? "focus" : null,
        "active"
    ].filter(Boolean).map(function(n) {
        return "&:".concat(n, " ").concat(childCombinator);
    }).join(",");
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-last-item)"), {
        marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item", Object.assign(Object.assign((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, hoverEffects, {
        zIndex: 2
    }), focusElCls ? (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(focusElCls), {
        zIndex: 2
    }) : {}), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&[disabled] ".concat(childCombinator), {
        zIndex: 0
    }))), _obj;
}
// handle border-radius
function $8123ced5d1d65f52$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    var borderElCls = options.borderElCls;
    var childCombinator = borderElCls ? "> ".concat(borderElCls) : "";
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item) ").concat(childCombinator), {
        borderRadius: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-last-item)").concat(parentCls, "-first-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "& ".concat(childCombinator, ", &").concat(prefixCls, "-sm ").concat(childCombinator, ", &").concat(prefixCls, "-lg ").concat(childCombinator), {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-first-item)").concat(parentCls, "-last-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "& ".concat(childCombinator, ", &").concat(prefixCls, "-sm ").concat(childCombinator, ", &").concat(prefixCls, "-lg ").concat(childCombinator), {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
    })), _obj;
}
function $8123ced5d1d65f52$export$b1208b23589b4b73(token) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
    };
    var componentCls = token.componentCls;
    var compactCls = "".concat(componentCls, "-compact");
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, compactCls, Object.assign(Object.assign({}, $8123ced5d1d65f52$var$compactItemBorder(token, compactCls, options)), $8123ced5d1d65f52$var$compactItemBorderRadius(componentCls, compactCls, options)));
}



function $d4eab392759c7538$var$compactItemVerticalBorder(token, parentCls) {
    var _obj;
    return _obj = {}, // border collapse
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-last-item)"), {
        marginBottom: token.calc(token.lineWidth).mul(-1).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item", {
        "&:hover,&:focus,&:active": {
            zIndex: 2
        },
        "&[disabled]": {
            zIndex: 0
        }
    }), _obj;
}
function $d4eab392759c7538$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item)"), {
        borderRadius: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item".concat(parentCls, "-first-item:not(").concat(parentCls, "-last-item)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-item".concat(parentCls, "-last-item:not(").concat(parentCls, "-first-item)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
    })), _obj;
}
function $d4eab392759c7538$export$4dc87cb8ebf78ac6(token) {
    var compactCls = "".concat(token.componentCls, "-compact-vertical");
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, compactCls, Object.assign(Object.assign({}, $d4eab392759c7538$var$compactItemVerticalBorder(token, compactCls)), $d4eab392759c7538$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)));
}




var $65c346cb31df6b54$var$genButtonCompactStyle = function(token) {
    var componentCls = token.componentCls, calc = token.calc;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj = {}, // Special styles for Primary Button
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-compact-item".concat(componentCls, "-primary"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not([disabled]) + ".concat(componentCls, "-compact-item").concat(componentCls, "-primary:not([disabled])"), {
        position: "relative",
        "&:before": {
            position: "absolute",
            top: calc(token.lineWidth).mul(-1).equal(),
            insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: token.lineWidth,
            height: "calc(100% + ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " * 2)"),
            backgroundColor: token.colorPrimaryHover,
            content: '""'
        }
    })), // Special styles for Primary Button
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-compact-vertical-item", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-primary"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not([disabled]) + ".concat(componentCls, "-compact-vertical-item").concat(componentCls, "-primary:not([disabled])"), {
        position: "relative",
        "&:before": {
            position: "absolute",
            top: calc(token.lineWidth).mul(-1).equal(),
            insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: "calc(100% + ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " * 2)"),
            height: token.lineWidth,
            backgroundColor: token.colorPrimaryHover,
            content: '""'
        }
    }))), _obj));
};
var // ============================== Export ==============================
$65c346cb31df6b54$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$1537386bc155ea56)([
    "Button",
    "compact"
], function(token) {
    var buttonToken = (0, $9299243921c534ad$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $8123ced5d1d65f52$export$b1208b23589b4b73)(buttonToken),
        (0, $d4eab392759c7538$export$4dc87cb8ebf78ac6)(buttonToken),
        $65c346cb31df6b54$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $9299243921c534ad$export$9ca1be8807fe0675));


"use client";
var $10de6dc93b7a3d74$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $10de6dc93b7a3d74$var$getLoadingConfig(loading) {
    if (typeof loading === "object" && loading) {
        var delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
var $10de6dc93b7a3d74$var$InternalButton = function(props, ref) {
    var _a, _b;
    var _props_loading = props.loading, loading = _props_loading === void 0 ? false : _props_loading, customizePrefixCls = props.prefixCls, _props_type = props.type, type = _props_type === void 0 ? "default" : _props_type, danger = props.danger, _props_shape = props.shape, shape = _props_shape === void 0 ? "default" : _props_shape, customizeSize = props.size, styles = props.styles, customDisabled = props.disabled, className = props.className, rootClassName = props.rootClassName, children = props.children, icon = props.icon, _props_ghost = props.ghost, ghost = _props_ghost === void 0 ? false : _props_ghost, _props_block = props.block, block = _props_block === void 0 ? false : _props_block, _props_htmlType = props.// React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType, htmlType = _props_htmlType === void 0 ? "button" : _props_htmlType, customClassNames = props.classNames, tmp = props.style, customStyle = tmp === void 0 ? {} : tmp, rest = $10de6dc93b7a3d74$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style"
    ]);
    var _useContext = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, autoInsertSpaceInButton = _useContext.autoInsertSpaceInButton, direction = _useContext.direction, button = _useContext.button;
    var prefixCls = getPrefixCls("btn", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $9299243921c534ad$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var disabled = (0, $8SyCD.useContext)((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var groupSize = (0, $8SyCD.useContext)((0, $fb4522e65fe1e51a$export$ed0cc8bd1f617d6d));
    var loadingOrDelay = (0, $8SyCD.useMemo)(function() {
        return $10de6dc93b7a3d74$var$getLoadingConfig(loading);
    }, [
        loading
    ]);
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(loadingOrDelay.loading), 2), innerLoading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(false), 2), hasTwoCNChar = _useState1[0], setHasTwoCNChar = _useState1[1];
    var internalRef = /*#__PURE__*/ (0, $8SyCD.createRef)();
    var buttonRef = (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, internalRef);
    var needInserted = (0, $8SyCD.Children).count(children) === 1 && !icon && !(0, $32812387acf2752d$export$1085c0511270cee)(type);
    (0, $8SyCD.useEffect)(function() {
        var cleanupTimer = function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        };
        var delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(function() {
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        return cleanupTimer;
    }, [
        loadingOrDelay
    ]);
    (0, $8SyCD.useEffect)(function() {
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        var buttonText = buttonRef.current.textContent;
        if (needInserted && (0, $32812387acf2752d$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    }, [
        buttonRef
    ]);
    var handleClick = function(e) {
        var onClick = props.onClick;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    var autoInsertSpace = autoInsertSpaceInButton !== false;
    var _useCompactItemContext = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContext.compactSize, compactItemClassnames = _useCompactItemContext.compactItemClassnames;
    var sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: undefined
    };
    var sizeFullName = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctxSize) {
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    var sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] || "" : "";
    var iconType = innerLoading ? "loading" : icon;
    var linkButtonRestProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(rest, [
        "navigate"
    ]);
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, hashId, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(shape), shape !== "default" && shape), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(type), type), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-background-ghost"), ghost && !(0, $32812387acf2752d$export$1085c0511270cee)(type)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-loading"), innerLoading), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace && !innerLoading), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-block"), block), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-dangerous"), !!danger), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), compactItemClassnames, className, rootClassName, button === null || button === void 0 ? void 0 : button.className);
    var fullStyle = Object.assign(Object.assign({}, button === null || button === void 0 ? void 0 : button.style), customStyle);
    var iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, (_a = button === null || button === void 0 ? void 0 : button.classNames) === null || _a === void 0 ? void 0 : _a.icon);
    var iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), ((_b = button === null || button === void 0 ? void 0 : button.styles) === null || _b === void 0 ? void 0 : _b.icon) || {});
    var iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $965c0690e2c89c6a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $be3948f6786ba666$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    var kids = children || children === 0 ? (0, $32812387acf2752d$export$b6ee00a7e7908bc)(children, needInserted && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(classes, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-disabled"), mergedDisabled)),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: buttonRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    var buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $65c346cb31df6b54$export$2e2bcd8739ae039), {
        key: "compact",
        prefixCls: prefixCls
    }));
    if (!(0, $32812387acf2752d$export$1085c0511270cee)(type)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $1f7e26aa70b888fb$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: !!innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
};
var $10de6dc93b7a3d74$var$Button = /*#__PURE__*/ (0, $8SyCD.forwardRef)($10de6dc93b7a3d74$var$InternalButton);
$10de6dc93b7a3d74$var$Button.Group = (0, $fb4522e65fe1e51a$export$2e2bcd8739ae039);
$10de6dc93b7a3d74$var$Button.__ANT_BUTTON = true;
var $10de6dc93b7a3d74$export$2e2bcd8739ae039 = $10de6dc93b7a3d74$var$Button;



"use client";
var $7095a40e3141dc69$export$2e2bcd8739ae039 = (0, $10de6dc93b7a3d74$export$2e2bcd8739ae039);




var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
















var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
var $705169cc919d014d$export$24829b7c0e49e9f7 = "RC_FORM_INTERNAL_HOOKS";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $705169cc919d014d$var$warningFunc = function warningFunc() {
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var $705169cc919d014d$var$Context = /*#__PURE__*/ $8SyCD.createContext({
    getFieldValue: $705169cc919d014d$var$warningFunc,
    getFieldsValue: $705169cc919d014d$var$warningFunc,
    getFieldError: $705169cc919d014d$var$warningFunc,
    getFieldWarning: $705169cc919d014d$var$warningFunc,
    getFieldsError: $705169cc919d014d$var$warningFunc,
    isFieldsTouched: $705169cc919d014d$var$warningFunc,
    isFieldTouched: $705169cc919d014d$var$warningFunc,
    isFieldValidating: $705169cc919d014d$var$warningFunc,
    isFieldsValidating: $705169cc919d014d$var$warningFunc,
    resetFields: $705169cc919d014d$var$warningFunc,
    setFields: $705169cc919d014d$var$warningFunc,
    setFieldValue: $705169cc919d014d$var$warningFunc,
    setFieldsValue: $705169cc919d014d$var$warningFunc,
    validateFields: $705169cc919d014d$var$warningFunc,
    submit: $705169cc919d014d$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $705169cc919d014d$var$warningFunc();
        return {
            dispatch: $705169cc919d014d$var$warningFunc,
            initEntityValue: $705169cc919d014d$var$warningFunc,
            registerField: $705169cc919d014d$var$warningFunc,
            useSubscribe: $705169cc919d014d$var$warningFunc,
            setInitialValues: $705169cc919d014d$var$warningFunc,
            destroyForm: $705169cc919d014d$var$warningFunc,
            setCallbacks: $705169cc919d014d$var$warningFunc,
            registerWatch: $705169cc919d014d$var$warningFunc,
            getFields: $705169cc919d014d$var$warningFunc,
            setValidateMessages: $705169cc919d014d$var$warningFunc,
            setPreserve: $705169cc919d014d$var$warningFunc,
            getInitialValue: $705169cc919d014d$var$warningFunc
        };
    }
});
var $705169cc919d014d$export$2e2bcd8739ae039 = $705169cc919d014d$var$Context;



var $8SyCD = parcelRequire("8SyCD");
var $f7a1de1e4166210f$var$ListContext = /*#__PURE__*/ $8SyCD.createContext(null);
var $f7a1de1e4166210f$export$2e2bcd8739ae039 = $f7a1de1e4166210f$var$ListContext;


function $49b2bc50f9fe5a92$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $49b2bc50f9fe5a92$export$717b316e73068e8d(form) {
    return form && !!form._init;
}








var $7FyBz = parcelRequire("7FyBz");
var $bdd0ec98081f0d43$exports = {};
// shim for using process in browser
var $bdd0ec98081f0d43$var$process = $bdd0ec98081f0d43$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $bdd0ec98081f0d43$var$cachedSetTimeout;
var $bdd0ec98081f0d43$var$cachedClearTimeout;
function $bdd0ec98081f0d43$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $bdd0ec98081f0d43$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $bdd0ec98081f0d43$var$cachedSetTimeout = setTimeout;
        else $bdd0ec98081f0d43$var$cachedSetTimeout = $bdd0ec98081f0d43$var$defaultSetTimout;
    } catch (e) {
        $bdd0ec98081f0d43$var$cachedSetTimeout = $bdd0ec98081f0d43$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $bdd0ec98081f0d43$var$cachedClearTimeout = clearTimeout;
        else $bdd0ec98081f0d43$var$cachedClearTimeout = $bdd0ec98081f0d43$var$defaultClearTimeout;
    } catch (e) {
        $bdd0ec98081f0d43$var$cachedClearTimeout = $bdd0ec98081f0d43$var$defaultClearTimeout;
    }
})();
function $bdd0ec98081f0d43$var$runTimeout(fun) {
    if ($bdd0ec98081f0d43$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($bdd0ec98081f0d43$var$cachedSetTimeout === $bdd0ec98081f0d43$var$defaultSetTimout || !$bdd0ec98081f0d43$var$cachedSetTimeout) && setTimeout) {
        $bdd0ec98081f0d43$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bdd0ec98081f0d43$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $bdd0ec98081f0d43$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $bdd0ec98081f0d43$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $bdd0ec98081f0d43$var$runClearTimeout(marker) {
    if ($bdd0ec98081f0d43$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($bdd0ec98081f0d43$var$cachedClearTimeout === $bdd0ec98081f0d43$var$defaultClearTimeout || !$bdd0ec98081f0d43$var$cachedClearTimeout) && clearTimeout) {
        $bdd0ec98081f0d43$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bdd0ec98081f0d43$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $bdd0ec98081f0d43$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $bdd0ec98081f0d43$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $bdd0ec98081f0d43$var$queue = [];
var $bdd0ec98081f0d43$var$draining = false;
var $bdd0ec98081f0d43$var$currentQueue;
var $bdd0ec98081f0d43$var$queueIndex = -1;
function $bdd0ec98081f0d43$var$cleanUpNextTick() {
    if (!$bdd0ec98081f0d43$var$draining || !$bdd0ec98081f0d43$var$currentQueue) return;
    $bdd0ec98081f0d43$var$draining = false;
    if ($bdd0ec98081f0d43$var$currentQueue.length) $bdd0ec98081f0d43$var$queue = $bdd0ec98081f0d43$var$currentQueue.concat($bdd0ec98081f0d43$var$queue);
    else $bdd0ec98081f0d43$var$queueIndex = -1;
    if ($bdd0ec98081f0d43$var$queue.length) $bdd0ec98081f0d43$var$drainQueue();
}
function $bdd0ec98081f0d43$var$drainQueue() {
    if ($bdd0ec98081f0d43$var$draining) return;
    var timeout = $bdd0ec98081f0d43$var$runTimeout($bdd0ec98081f0d43$var$cleanUpNextTick);
    $bdd0ec98081f0d43$var$draining = true;
    var len = $bdd0ec98081f0d43$var$queue.length;
    while(len){
        $bdd0ec98081f0d43$var$currentQueue = $bdd0ec98081f0d43$var$queue;
        $bdd0ec98081f0d43$var$queue = [];
        while(++$bdd0ec98081f0d43$var$queueIndex < len)if ($bdd0ec98081f0d43$var$currentQueue) $bdd0ec98081f0d43$var$currentQueue[$bdd0ec98081f0d43$var$queueIndex].run();
        $bdd0ec98081f0d43$var$queueIndex = -1;
        len = $bdd0ec98081f0d43$var$queue.length;
    }
    $bdd0ec98081f0d43$var$currentQueue = null;
    $bdd0ec98081f0d43$var$draining = false;
    $bdd0ec98081f0d43$var$runClearTimeout(timeout);
}
$bdd0ec98081f0d43$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $bdd0ec98081f0d43$var$queue.push(new $bdd0ec98081f0d43$var$Item(fun, args));
    if ($bdd0ec98081f0d43$var$queue.length === 1 && !$bdd0ec98081f0d43$var$draining) $bdd0ec98081f0d43$var$runTimeout($bdd0ec98081f0d43$var$drainQueue);
};
// v8 likes predictible objects
function $bdd0ec98081f0d43$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$bdd0ec98081f0d43$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$bdd0ec98081f0d43$var$process.title = "browser";
$bdd0ec98081f0d43$var$process.browser = true;
$bdd0ec98081f0d43$var$process.env = {};
$bdd0ec98081f0d43$var$process.argv = [];
$bdd0ec98081f0d43$var$process.version = ""; // empty string to avoid regexp issues
$bdd0ec98081f0d43$var$process.versions = {};
function $bdd0ec98081f0d43$var$noop() {}
$bdd0ec98081f0d43$var$process.on = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.addListener = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.once = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.off = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.removeListener = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.removeAllListeners = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.emit = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.prependListener = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.prependOnceListener = $bdd0ec98081f0d43$var$noop;
$bdd0ec98081f0d43$var$process.listeners = function(name) {
    return [];
};
$bdd0ec98081f0d43$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$bdd0ec98081f0d43$var$process.cwd = function() {
    return "/";
};
$bdd0ec98081f0d43$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$bdd0ec98081f0d43$var$process.umask = function() {
    return 0;
};


function $b47397cfb4465189$var$_extends() {
    $b47397cfb4465189$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b47397cfb4465189$var$_extends.apply(this, arguments);
}
function $b47397cfb4465189$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b47397cfb4465189$var$_setPrototypeOf(subClass, superClass);
}
function $b47397cfb4465189$var$_getPrototypeOf(o) {
    $b47397cfb4465189$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b47397cfb4465189$var$_getPrototypeOf(o);
}
function $b47397cfb4465189$var$_setPrototypeOf(o, p) {
    $b47397cfb4465189$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b47397cfb4465189$var$_setPrototypeOf(o, p);
}
function $b47397cfb4465189$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b47397cfb4465189$var$_construct(Parent, args, Class) {
    if ($b47397cfb4465189$var$_isNativeReflectConstruct()) $b47397cfb4465189$var$_construct = Reflect.construct.bind();
    else $b47397cfb4465189$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $b47397cfb4465189$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $b47397cfb4465189$var$_construct.apply(null, arguments);
}
function $b47397cfb4465189$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $b47397cfb4465189$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b47397cfb4465189$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$b47397cfb4465189$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $b47397cfb4465189$var$_construct(Class, arguments, $b47397cfb4465189$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $b47397cfb4465189$var$_setPrototypeOf(Wrapper, Class);
    };
    return $b47397cfb4465189$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $b47397cfb4465189$var$formatRegExp = /%[sdj%]/g;
var $b47397cfb4465189$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
typeof $bdd0ec98081f0d43$exports !== "undefined" && $bdd0ec98081f0d43$exports.env;
function $b47397cfb4465189$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $b47397cfb4465189$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === "function") return template.apply(null, args);
    if (typeof template === "string") {
        var str = template.replace($b47397cfb4465189$var$formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $b47397cfb4465189$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern";
}
function $b47397cfb4465189$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($b47397cfb4465189$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $b47397cfb4465189$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $b47397cfb4465189$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $b47397cfb4465189$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $b47397cfb4465189$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $b47397cfb4465189$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, "Async Validation Error") || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $b47397cfb4465189$var$_wrapNativeSuper(Error));
function $b47397cfb4465189$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $b47397cfb4465189$var$AsyncValidationError(errors, $b47397cfb4465189$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $b47397cfb4465189$var$flattenObjArr(objArr);
            $b47397cfb4465189$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $b47397cfb4465189$var$AsyncValidationError(results, $b47397cfb4465189$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $b47397cfb4465189$var$asyncSerialArray(arr, func, next);
            else $b47397cfb4465189$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $b47397cfb4465189$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $b47397cfb4465189$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $b47397cfb4465189$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $b47397cfb4465189$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($b47397cfb4465189$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $b47397cfb4465189$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === "object" && typeof target[s] === "object") target[s] = $b47397cfb4465189$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $b47397cfb4465189$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $b47397cfb4465189$var$isEmptyValue(value, type || rule.type))) errors.push($b47397cfb4465189$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $b47397cfb4465189$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === "") errors.push($b47397cfb4465189$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $b47397cfb4465189$var$urlReg;
var $b47397cfb4465189$var$getUrlRegex = function getUrlRegex() {
    if ($b47397cfb4465189$var$urlReg) return $b47397cfb4465189$var$urlReg;
    var word = "[a-fA-F\\d:]";
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
    };
    var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    var v6seg = "[a-fA-F\\d]{1,4}";
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = "(?:\\S+(?::\\S*)?@)?";
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = "(?::\\d{2,5})?";
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $b47397cfb4465189$var$urlReg = new RegExp("(?:^" + regex + "$)", "i");
    return $b47397cfb4465189$var$urlReg;
};
/* eslint max-len:0 */ var $b47397cfb4465189$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $b47397cfb4465189$var$types = {
    integer: function integer(value) {
        return $b47397cfb4465189$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function _float(value) {
        return $b47397cfb4465189$var$types.number(value) && !$b47397cfb4465189$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object: function object(value) {
        return typeof value === "object" && !$b47397cfb4465189$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === "function";
    },
    email: function email(value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($b47397cfb4465189$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match($b47397cfb4465189$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === "string" && !!value.match($b47397cfb4465189$var$pattern$2.hex);
    }
};
var $b47397cfb4465189$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $b47397cfb4465189$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "number",
        "date",
        "url",
        "hex"
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$b47397cfb4465189$var$types[ruleType](value)) errors.push($b47397cfb4465189$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && (typeof value === "undefined" ? "undefined" : (0, $7FyBz._)(value)) !== rule.type) errors.push($b47397cfb4465189$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $b47397cfb4465189$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === "number";
    var min = typeof rule.min === "number";
    var max = typeof rule.max === "number"; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === "number";
    var str = typeof value === "string";
    var arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push($b47397cfb4465189$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($b47397cfb4465189$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($b47397cfb4465189$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($b47397cfb4465189$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $b47397cfb4465189$var$ENUM$1 = "enum";
var $b47397cfb4465189$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$b47397cfb4465189$var$ENUM$1] = Array.isArray(rule[$b47397cfb4465189$var$ENUM$1]) ? rule[$b47397cfb4465189$var$ENUM$1] : [];
    if (rule[$b47397cfb4465189$var$ENUM$1].indexOf(value) === -1) errors.push($b47397cfb4465189$var$format(options.messages[$b47397cfb4465189$var$ENUM$1], rule.fullField, rule[$b47397cfb4465189$var$ENUM$1].join(", ")));
};
var $b47397cfb4465189$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($b47397cfb4465189$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($b47397cfb4465189$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $b47397cfb4465189$var$rules = {
    required: $b47397cfb4465189$var$required$1,
    whitespace: $b47397cfb4465189$var$whitespace,
    type: $b47397cfb4465189$var$type$1,
    range: $b47397cfb4465189$var$range,
    "enum": $b47397cfb4465189$var$enumerable$1,
    pattern: $b47397cfb4465189$var$pattern$1
};
var $b47397cfb4465189$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options, "string");
        if (!$b47397cfb4465189$var$isEmptyValue(value, "string")) {
            $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.range(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $b47397cfb4465189$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") value = undefined;
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (!$b47397cfb4465189$var$isEmptyValue(value)) $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
            $b47397cfb4465189$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$ENUM = "enum";
var $b47397cfb4465189$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $b47397cfb4465189$var$rules[$b47397cfb4465189$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (!$b47397cfb4465189$var$isEmptyValue(value, "string")) $b47397cfb4465189$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value, "date") && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
        if (!$b47397cfb4465189$var$isEmptyValue(value, "date")) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $b47397cfb4465189$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $b47397cfb4465189$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $b47397cfb4465189$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? "array" : typeof value === "undefined" ? "undefined" : (0, $7FyBz._)(value);
    $b47397cfb4465189$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $b47397cfb4465189$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$b47397cfb4465189$var$isEmptyValue(value, ruleType)) $b47397cfb4465189$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($b47397cfb4465189$var$isEmptyValue(value) && !rule.required) return callback();
        $b47397cfb4465189$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $b47397cfb4465189$var$validators = {
    string: $b47397cfb4465189$var$string,
    method: $b47397cfb4465189$var$method,
    number: $b47397cfb4465189$var$number,
    boolean: $b47397cfb4465189$var$_boolean,
    regexp: $b47397cfb4465189$var$regexp,
    integer: $b47397cfb4465189$var$integer,
    float: $b47397cfb4465189$var$floatFn,
    array: $b47397cfb4465189$var$array,
    object: $b47397cfb4465189$var$object,
    "enum": $b47397cfb4465189$var$enumerable,
    pattern: $b47397cfb4465189$var$pattern,
    date: $b47397cfb4465189$var$date,
    url: $b47397cfb4465189$var$type,
    hex: $b47397cfb4465189$var$type,
    email: $b47397cfb4465189$var$type,
    required: $b47397cfb4465189$var$required,
    any: $b47397cfb4465189$var$any
};
function $b47397cfb4465189$var$newMessages() {
    return {
        "default": "Validation error on field %s",
        required: "%s is required",
        "enum": "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            boolean: "%s is not a %s",
            integer: "%s is not an %s",
            float: "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $b47397cfb4465189$var$messages = $b47397cfb4465189$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $b47397cfb4465189$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $b47397cfb4465189$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error("Cannot configure a schema with no rules");
        if (typeof rules !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $b47397cfb4465189$var$deepMerge($b47397cfb4465189$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $b47397cfb4465189$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $b47397cfb4465189$var$messages) messages$1 = $b47397cfb4465189$var$newMessages();
            $b47397cfb4465189$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === "function") {
                    if (source === source_) source = $b47397cfb4465189$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === "function") rule = {
                    validator: rule
                };
                else rule = $b47397cfb4465189$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $b47397cfb4465189$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $b47397cfb4465189$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning("async-validator:", errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($b47397cfb4465189$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($b47397cfb4465189$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $b47397cfb4465189$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $b47397cfb4465189$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
        if (typeof rule.validator !== "function" && rule.type && !$b47397cfb4465189$var$validators.hasOwnProperty(rule.type)) throw new Error($b47397cfb4465189$var$format("Unknown rule type %s", rule.type));
        return rule.type || "string";
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === "function") return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf("message");
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === "required") return $b47397cfb4465189$var$validators.required;
        return $b47397cfb4465189$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$b47397cfb4465189$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
    $b47397cfb4465189$var$validators[type] = validator;
};
$b47397cfb4465189$export$2e2bcd8739ae039.warning = $b47397cfb4465189$var$warning;
$b47397cfb4465189$export$2e2bcd8739ae039.messages = $b47397cfb4465189$var$messages;
$b47397cfb4465189$export$2e2bcd8739ae039.validators = $b47397cfb4465189$var$validators;



var $8SyCD = parcelRequire("8SyCD");

var $4bf19d30452e47d1$var$typeTemplate = "'${name}' is not a valid ${type}";
var $4bf19d30452e47d1$export$c86b939816b8fbf8 = {
    "default": "Validation error on field '${name}'",
    required: "'${name}' is required",
    "enum": "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $4bf19d30452e47d1$var$typeTemplate,
        method: $4bf19d30452e47d1$var$typeTemplate,
        array: $4bf19d30452e47d1$var$typeTemplate,
        object: $4bf19d30452e47d1$var$typeTemplate,
        number: $4bf19d30452e47d1$var$typeTemplate,
        date: $4bf19d30452e47d1$var$typeTemplate,
        boolean: $4bf19d30452e47d1$var$typeTemplate,
        integer: $4bf19d30452e47d1$var$typeTemplate,
        float: $4bf19d30452e47d1$var$typeTemplate,
        regexp: $4bf19d30452e47d1$var$typeTemplate,
        email: $4bf19d30452e47d1$var$typeTemplate,
        url: $4bf19d30452e47d1$var$typeTemplate,
        hex: $4bf19d30452e47d1$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
var $7fb80f6a1c18509b$var$AsyncValidator = (0, $b47397cfb4465189$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $7fb80f6a1c18509b$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $7fb80f6a1c18509b$var$CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function $7fb80f6a1c18509b$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $7fb80f6a1c18509b$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $7fb80f6a1c18509b$var$_validateRule() {
    $7fb80f6a1c18509b$var$_validateRule = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $7fb80f6a1c18509b$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($7fb80f6a1c18509b$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $7fb80f6a1c18509b$var$AsyncValidator((0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $d5357cacfbc573f6$export$4950aa0f605343fb)((0, $4bf19d30452e47d1$export$c86b939816b8fbf8), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, name, value), (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $7fb80f6a1c18509b$var$CODE_LOGIC_ERROR ? messages["default"] : message;
                        return /*#__PURE__*/ $8SyCD.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $8SyCD.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $7fb80f6a1c18509b$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(prev), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, rule), {}, {
                        name: name,
                        "enum": (rule["enum"] || []).join(", ")
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === "string") return $7fb80f6a1c18509b$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $7fb80f6a1c18509b$var$_validateRule.apply(this, arguments);
}
function $7fb80f6a1c18509b$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join(".");
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === "function" && typeof promise["catch"] === "function";
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $ed6f30969113606c$export$2e2bcd8739ae039)(hasPromise, "`callback` is deprecated. Please return a promise instead.");
            if (hasPromise) promise.then(function() {
                callback();
            })["catch"](function(err) {
                callback(err || " ");
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $7fb80f6a1c18509b$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $7fb80f6a1c18509b$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $7fb80f6a1c18509b$var$finishOnFirstFailed(rulePromises) : $7fb80f6a1c18509b$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise["catch"](function(e) {
        return e;
    });
    return summaryPromise;
}
function $7fb80f6a1c18509b$var$finishOnAllFailed(_x8) {
    return $7fb80f6a1c18509b$var$_finishOnAllFailed.apply(this, arguments);
}
function $7fb80f6a1c18509b$var$_finishOnAllFailed() {
    $7fb80f6a1c18509b$var$_finishOnAllFailed = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee3(rulePromises) {
        return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $7fb80f6a1c18509b$var$_finishOnAllFailed.apply(this, arguments);
}
function $7fb80f6a1c18509b$var$finishOnFirstFailed(_x9) {
    return $7fb80f6a1c18509b$var$_finishOnFirstFailed.apply(this, arguments);
}
function $7fb80f6a1c18509b$var$_finishOnFirstFailed() {
    $7fb80f6a1c18509b$var$_finishOnFirstFailed = (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $7fb80f6a1c18509b$var$_finishOnFirstFailed.apply(this, arguments);
}







function $a21d112eacc21569$export$f877b3cb4cb4ccf9(path) {
    return (0, $49b2bc50f9fe5a92$export$45b10814cc054894)(path);
}
function $a21d112eacc21569$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $a21d112eacc21569$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $a21d112eacc21569$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $a21d112eacc21569$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $a21d112eacc21569$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(source) !== "object" || (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(target) !== "object") return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === "function" && typeof targetValue === "function") return true;
        return sourceValue === targetValue;
    });
}
function $a21d112eacc21569$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(event.target) === "object" && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $a21d112eacc21569$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(0, toIndex)), [
        item
    ], (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(toIndex, moveIndex)), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(0, moveIndex)), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(array.slice(toIndex + 1, length)));
    return array;
}


var $26264529f88beb74$var$_excluded = [
    "name"
];
var $26264529f88beb74$var$EMPTY_ERRORS = [];
function $26264529f88beb74$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === "function") return shouldUpdate(prev, next, "source" in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $26264529f88beb74$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(Field, _React$Component);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "state", {
            resetCount: 0
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "cancelRegisterFunc", null);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "dirty", false);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "validatePromise", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "prevValidating", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "errors", $26264529f88beb74$var$EMPTY_ERRORS);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "warnings", $26264529f88beb74$var$EMPTY_ERRORS);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(prefixName), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(name)) : [];
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === "function") return rule(fieldContext);
                return rule;
            });
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "metaCache", null);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $a21d112eacc21569$export$646d5504364ae55b)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === "valueUpdate" && info.source === "external" && prevValue !== curValue) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $26264529f88beb74$var$EMPTY_ERRORS;
                _this.warnings = $26264529f88beb74$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case "reset":
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $26264529f88beb74$var$EMPTY_ERRORS;
                        _this.warnings = $26264529f88beb74$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case "remove":
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "setField":
                    var data = info.data;
                    if (namePathMatch) {
                        if ("touched" in data) _this.touched = data.touched;
                        if ("validating" in data && !("originRCField" in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ("errors" in data) _this.errors = data.errors || $26264529f88beb74$var$EMPTY_ERRORS;
                        if ("warnings" in data) _this.warnings = data.warnings || $26264529f88beb74$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ("value" in data && (0, $a21d112eacc21569$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $26264529f88beb74$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "dependenciesUpdate":
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $a21d112eacc21569$export$646d5504364ae55b)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $26264529f88beb74$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $9cf742ccf514c151$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $ebf36ae10d47ff06$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $49b2bc50f9fe5a92$export$45b10814cc054894)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $7fb80f6a1c18509b$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise["catch"](function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $26264529f88beb74$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $26264529f88beb74$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $26264529f88beb74$var$EMPTY_ERRORS;
            _this.warnings = $26264529f88beb74$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === "function") {
                var _meta2 = _this.getMeta();
                return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $8SyCD.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
        });
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, valuePropName, val);
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var originTriggerFunc = childProps[trigger];
            var control = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, childProps), mergedGetValueProps(value));
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $a21d112eacc21569$export$6eeac3c5b406fb30).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: "updateValue",
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $49b2bc50f9fe5a92$export$45b10814cc054894)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: "validateField",
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $17c050cdb820e309$export$2e2bcd8739ae039)(_this));
        }
        return _this;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $8SyCD.isValidElement(child)) returnChildNode = /*#__PURE__*/ $8SyCD.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!child, "`children` of Field is not validate ReactElement.");
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($8SyCD.Component);
(0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($26264529f88beb74$var$Field, "contextType", (0, $705169cc919d014d$export$2e2bcd8739ae039));
(0, $54033efc60d3b6a4$export$2e2bcd8739ae039)($26264529f88beb74$var$Field, "defaultProps", {
    trigger: "onChange",
    valuePropName: "value"
});
function $26264529f88beb74$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref6, $26264529f88beb74$var$_excluded);
    var fieldContext = $8SyCD.useContext((0, $705169cc919d014d$export$2e2bcd8739ae039));
    var listContext = $8SyCD.useContext((0, $f7a1de1e4166210f$export$2e2bcd8739ae039));
    var namePath = name !== undefined ? (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name) : undefined;
    var key = "keep";
    if (!restProps.isListField) key = "_".concat((namePath || []).join("_"));
    return /*#__PURE__*/ $8SyCD.createElement($26264529f88beb74$var$Field, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $26264529f88beb74$export$2e2bcd8739ae039 = $26264529f88beb74$var$WrapperField;





var $8SyCD = parcelRequire("8SyCD");





function $3a89ba705f61fd89$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $8SyCD.useContext((0, $705169cc919d014d$export$2e2bcd8739ae039));
    var wrapperListContext = $8SyCD.useContext((0, $f7a1de1e4166210f$export$2e2bcd8739ae039));
    var keyRef = $8SyCD.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $8SyCD.useMemo(function() {
        var parentPrefixName = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(parentPrefixName), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $8SyCD.useMemo(function() {
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $8SyCD.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== "function") {
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Form.List only accepts function as children.");
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === "internal") return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $f7a1de1e4166210f$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $705169cc919d014d$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $26264529f88beb74$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $a21d112eacc21569$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $a21d112eacc21569$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $3a89ba705f61fd89$export$2e2bcd8739ae039 = $3a89ba705f61fd89$var$List;













var $8SyCD = parcelRequire("8SyCD");

function $0f0f84a503b01e8d$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise["catch"](function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}









var $5db3a487b9c5de7b$var$SPLIT = "__@field_split__";
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $5db3a487b9c5de7b$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(cell), ":").concat(cell);
    })// Magic split
    .join($5db3a487b9c5de7b$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $5db3a487b9c5de7b$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, NameMap);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "kvs", new Map());
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($5db3a487b9c5de7b$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($5db3a487b9c5de7b$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this["delete"](key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs["delete"]($5db3a487b9c5de7b$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($5db3a487b9c5de7b$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === "number" ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join(".")] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $5db3a487b9c5de7b$export$2e2bcd8739ae039 = $5db3a487b9c5de7b$var$NameMap;



var $2fa0ca9275ca94fb$var$_excluded = [
    "name"
];
var $2fa0ca9275ca94fb$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, FormStore);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "formHooked", false);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "forceRootUpdate", void 0);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "subscribable", true);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "store", {});
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "fieldEntities", []);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "initialValues", {});
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "callbacks", {});
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "validateMessages", null);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "preserve", null);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "lastValidatePromise", null);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getInternalHooks", function(key) {
        if (key === (0, $705169cc919d014d$export$24829b7c0e49e9f7)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "`getInternalHooks` is internal usage. Should not call directly.");
        return null;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $d5357cacfbc573f6$export$4950aa0f605343fb)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(nextStore, namePath, (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "destroyForm", function() {
        var prevWithoutPreserves = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
        _this.getFieldEntities(true).forEach(function(entity) {
            if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
        });
        _this.prevWithoutPreserves = prevWithoutPreserves;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $d5357cacfbc573f6$export$4950aa0f605343fb)(initValue) : initValue;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "watchList", []);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "timeoutId", null);
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name)
            };
        });
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(nameList) === "object") {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = "getMeta" in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $a21d112eacc21569$export$f5be6dfb30403c59)(_this.store, filteredNameList.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)));
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
        return (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(_this.store, namePath);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !("INVALIDATE_NAME_PATH" in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $a21d112eacc21569$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_this.store, namePath, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $d5357cacfbc573f6$export$4950aa0f605343fb)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: "reset"
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: "reset"
        });
        _this.notifyWatch(namePathList);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(fieldData, $2fa0ca9275ca94fb$var$_excluded);
            var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ("value" in data) _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: "setField",
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, "originRCField", {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        }
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: "valueUpdate",
                source: "internal"
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $a21d112eacc21569$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: "remove"
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "dispatch", function(action) {
        switch(action.type){
            case "updateValue":
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case "validateField":
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: "dependenciesUpdate",
            relatedFields: [
                namePath
            ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(childrenFields))
        });
        return childrenFields;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "updateValue", function(name, value) {
        var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $d5357cacfbc573f6$export$2e2bcd8739ae039)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: "valueUpdate",
            source: "internal"
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $a21d112eacc21569$export$f5be6dfb30403c59)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $d5357cacfbc573f6$export$4950aa0f605343fb)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: "valueUpdate",
            source: "external"
        });
        _this.notifyWatch();
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $5db3a487b9c5de7b$export$2e2bcd8739ae039)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $a21d112eacc21569$export$646d5504364ae55b)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $a21d112eacc21569$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
                    validateMessages: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, (0, $4bf19d30452e47d1$export$c86b939816b8fbf8)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                })["catch"](function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $0f0f84a503b01e8d$export$6152adfdcc6be2b5)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise["catch"](function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: "validateFinish"
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        })["catch"](function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise["catch"](function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        })["catch"](function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $2fa0ca9275ca94fb$var$useForm(form) {
    var formRef = $8SyCD.useRef();
    var _React$useState = $8SyCD.useState({}), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $2fa0ca9275ca94fb$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $2fa0ca9275ca94fb$export$2e2bcd8739ae039 = $2fa0ca9275ca94fb$var$useForm;







var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");
var $d1a79d4f9b4745c4$var$FormContext = /*#__PURE__*/ $8SyCD.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $d1a79d4f9b4745c4$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $8SyCD.useContext($d1a79d4f9b4745c4$var$FormContext);
    var formsRef = $8SyCD.useRef({});
    return /*#__PURE__*/ $8SyCD.createElement($d1a79d4f9b4745c4$var$FormContext.Provider, {
        value: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formContext), {}, {
            validateMessages: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formsRef.current), {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $d1a79d4f9b4745c4$export$2e2bcd8739ae039 = $d1a79d4f9b4745c4$var$FormContext;




var $bd4c43f3129272bc$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed"
];
var $bd4c43f3129272bc$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $bd4c43f3129272bc$var$_excluded);
    var formContext = $8SyCD.useContext((0, $d1a79d4f9b4745c4$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $2fa0ca9275ca94fb$export$2e2bcd8739ae039)(form), _useForm2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $8SyCD.useImperativeHandle(ref, function() {
        return formInstance;
    });
    // Register form into Context
    $8SyCD.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $8SyCD.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $8SyCD.useEffect(function() {
        return destroyForm;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === "function";
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $8SyCD.useRef();
    $8SyCD.useEffect(function() {
        if (!(0, $a21d112eacc21569$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $8SyCD.useMemo(function() {
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $8SyCD.createElement((0, $f7a1de1e4166210f$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $8SyCD.createElement((0, $705169cc919d014d$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $8SyCD.createElement(Component, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restProps, {
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $bd4c43f3129272bc$export$2e2bcd8739ae039 = $bd4c43f3129272bc$var$Form;








var $8SyCD = parcelRequire("8SyCD");



function $6032cc5d863e8012$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $6032cc5d863e8012$var$useWatchWarning = function useWatchWarning() {};
// ------- selector type -------
// ------- selector type end -------
function $6032cc5d863e8012$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $49b2bc50f9fe5a92$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $8SyCD.useState)(), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $8SyCD.useMemo)(function() {
        return $6032cc5d863e8012$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $8SyCD.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $8SyCD.useContext)((0, $705169cc919d014d$export$2e2bcd8739ae039));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $a21d112eacc21569$export$f877b3cb4cb4ccf9)(dependencies);
    var namePathRef = (0, $8SyCD.useRef)(namePath);
    namePathRef.current = namePath;
    $6032cc5d863e8012$var$useWatchWarning(namePath);
    (0, $8SyCD.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $705169cc919d014d$export$24829b7c0e49e9f7)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === "function" ? dependencies(watchValue) : (0, $16b08fc4c83b8dcc$export$2e2bcd8739ae039)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $6032cc5d863e8012$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $6032cc5d863e8012$export$2e2bcd8739ae039 = $6032cc5d863e8012$var$useWatch;


var $823622d41bc3310c$var$InternalForm = /*#__PURE__*/ $8SyCD.forwardRef((0, $bd4c43f3129272bc$export$2e2bcd8739ae039));
var $823622d41bc3310c$var$RefForm = $823622d41bc3310c$var$InternalForm;
$823622d41bc3310c$var$RefForm.FormProvider = (0, $d1a79d4f9b4745c4$export$8ce1ff4f94d08846);
$823622d41bc3310c$var$RefForm.Field = (0, $26264529f88beb74$export$2e2bcd8739ae039);
$823622d41bc3310c$var$RefForm.List = (0, $3a89ba705f61fd89$export$2e2bcd8739ae039);
$823622d41bc3310c$var$RefForm.useForm = (0, $2fa0ca9275ca94fb$export$2e2bcd8739ae039);
$823622d41bc3310c$var$RefForm.useWatch = (0, $6032cc5d863e8012$export$2e2bcd8739ae039);
var $823622d41bc3310c$export$2e2bcd8739ae039 = $823622d41bc3310c$var$RefForm;



"use client";
var $1618288003dd675a$export$c24727297075ec6a = /*#__PURE__*/ $8SyCD.createContext({
    labelAlign: "right",
    vertical: false,
    itemRef: function() {}
});
var $1618288003dd675a$export$d718247e9f9b0b9e = /*#__PURE__*/ $8SyCD.createContext(null);
var $1618288003dd675a$export$8ce1ff4f94d08846 = function(props) {
    var providerProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $d1a79d4f9b4745c4$export$8ce1ff4f94d08846), Object.assign({}, providerProps));
};
var $1618288003dd675a$export$fb6582d3042cc879 = /*#__PURE__*/ $8SyCD.createContext({
    prefixCls: ""
});
var $1618288003dd675a$export$bbb5553c6c7a14ed = /*#__PURE__*/ $8SyCD.createContext({});
var $1618288003dd675a$export$80e4c53cb85dcab1 = function(_ref) {
    var children = _ref.children, status = _ref.status, override = _ref.override;
    var formItemInputContext = (0, $8SyCD.useContext)($1618288003dd675a$export$bbb5553c6c7a14ed);
    var newFormItemInputContext = (0, $8SyCD.useMemo)(function() {
        var newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $8SyCD.createElement($1618288003dd675a$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};







var $36bcd88a5dc6cb3d$export$92095d0f4c77bd56 = function(color) {
    return {
        // Firefox
        "&::-moz-placeholder": {
            opacity: 1
        },
        "&::placeholder": {
            color: color,
            userSelect: "none" // https://github.com/ant-design/ant-design/pull/32639
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        }
    };
};
var $36bcd88a5dc6cb3d$export$bf820fba296f2fd8 = function(token) {
    return {
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    };
};
var $36bcd88a5dc6cb3d$export$3fe86db3643510f9 = function(token) {
    return {
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    };
};
var $36bcd88a5dc6cb3d$export$12789f962d420a93 = function(token) {
    return {
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: "none",
        cursor: "not-allowed",
        opacity: 1,
        "&:hover:not([disabled])": Object.assign({}, $36bcd88a5dc6cb3d$export$bf820fba296f2fd8((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    };
};
var $36bcd88a5dc6cb3d$var$genInputLargeStyle = function(token) {
    var paddingBlockLG = token.paddingBlockLG, fontSizeLG = token.fontSizeLG, lineHeightLG = token.lineHeightLG, borderRadiusLG = token.borderRadiusLG, paddingInlineLG = token.paddingInlineLG;
    return {
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingBlockLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingInlineLG)),
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
var $36bcd88a5dc6cb3d$export$bb047f62c5a56f90 = function(token) {
    return {
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingBlockSM), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingInlineSM)),
        borderRadius: token.borderRadiusSM
    };
};
var $36bcd88a5dc6cb3d$export$cf983a15949ad61e = function(token, parentCls) {
    var componentCls = token.componentCls, colorError = token.colorError, colorWarning = token.colorWarning, errorActiveShadow = token.errorActiveShadow, warningActiveShadow = token.warningActiveShadow, colorErrorBorderHover = token.colorErrorBorderHover, colorWarningBorderHover = token.colorWarningBorderHover;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-status-error:not(".concat(parentCls, "-disabled):not(").concat(parentCls, "-borderless)").concat(parentCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderColor: colorError,
        "&:hover": {
            borderColor: colorErrorBorderHover
        },
        "&:focus, &:focus-within": Object.assign({}, $36bcd88a5dc6cb3d$export$3fe86db3643510f9((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            activeBorderColor: colorError,
            activeShadow: errorActiveShadow
        })))
    }, "".concat(componentCls, "-prefix, ").concat(componentCls, "-suffix"), {
        color: colorError
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-status-warning:not(".concat(parentCls, "-disabled):not(").concat(parentCls, "-borderless)").concat(parentCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderColor: colorWarning,
        "&:hover": {
            borderColor: colorWarningBorderHover
        },
        "&:focus, &:focus-within": Object.assign({}, $36bcd88a5dc6cb3d$export$3fe86db3643510f9((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            activeBorderColor: colorWarning,
            activeShadow: warningActiveShadow
        })))
    }, "".concat(componentCls, "-prefix, ").concat(componentCls, "-suffix"), {
        color: colorWarning
    })), _obj;
};
var $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd = function(token) {
    return Object.assign(Object.assign({
        position: "relative",
        display: "inline-block",
        width: "100%",
        minWidth: 0,
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingBlock), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingInline)),
        color: token.colorText,
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        backgroundColor: token.colorBgContainer,
        backgroundImage: "none",
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: token.colorBorder,
        borderRadius: token.borderRadius,
        transition: "all ".concat(token.motionDurationMid)
    }, $36bcd88a5dc6cb3d$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        "&:hover": Object.assign({}, $36bcd88a5dc6cb3d$export$bf820fba296f2fd8(token)),
        "&:focus, &:focus-within": Object.assign({}, $36bcd88a5dc6cb3d$export$3fe86db3643510f9(token)),
        "&-disabled, &[disabled]": Object.assign({}, $36bcd88a5dc6cb3d$export$12789f962d420a93(token)),
        "&-borderless": {
            "&, &:hover, &:focus, &-focused, &-disabled, &[disabled]": {
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none"
            }
        },
        // Reset height for `textarea`s
        "textarea&": {
            maxWidth: "100%",
            // prevent textarea resize from coming out of its container
            height: "auto",
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: "bottom",
            transition: "all ".concat(token.motionDurationSlow, ", height 0s"),
            resize: "vertical"
        },
        // Size
        "&-lg": Object.assign({}, $36bcd88a5dc6cb3d$var$genInputLargeStyle(token)),
        "&-sm": Object.assign({}, $36bcd88a5dc6cb3d$export$bb047f62c5a56f90(token)),
        // RTL
        "&-rtl": {
            direction: "rtl"
        },
        "&-textarea-rtl": {
            direction: "rtl"
        }
    });
};
var $36bcd88a5dc6cb3d$export$ffe8b2a9bd2e5cfe = function(token) {
    var componentCls = token.componentCls, antCls = token.antCls;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return _obj6 = {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0
    }, // Undo padding and float of grid classes
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&[class*='col-']", {
        paddingInlineEnd: token.paddingXS,
        "&:last-child": {
            paddingInlineEnd: 0
        }
    }), // Sizing options
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&-lg ".concat(componentCls, ", &-lg > ").concat(componentCls, "-group-addon"), Object.assign({}, $36bcd88a5dc6cb3d$var$genInputLargeStyle(token))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&-sm ".concat(componentCls, ", &-sm > ").concat(componentCls, "-group-addon"), Object.assign({}, $36bcd88a5dc6cb3d$export$bb047f62c5a56f90(token))), // Fix https://github.com/ant-design/ant-design/issues/5754
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&-lg ".concat(antCls, "-select-single ").concat(antCls, "-select-selector"), {
        height: token.controlHeightLG
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&-sm ".concat(antCls, "-select-single ").concat(antCls, "-select-selector"), {
        height: token.controlHeightSM
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls), {
        display: "table-cell",
        "&:not(:first-child):not(:last-child)": {
            borderRadius: 0
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "".concat(componentCls, "-group"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-addon, &-wrap", {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
            borderRadius: 0
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-wrap > *", {
        display: "block !important"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-addon", (_obj1 = {
        position: "relative",
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingInline)),
        color: token.colorText,
        fontWeight: "normal",
        fontSize: token.fontSize,
        textAlign: "center",
        backgroundColor: token.addonBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
        borderRadius: token.borderRadius,
        transition: "all ".concat(token.motionDurationSlow),
        lineHeight: 1
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(antCls, "-select"), (_obj = {
        margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal()), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal()))
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(antCls, "-select-single:not(").concat(antCls, "-select-customize-input):not(").concat(antCls, "-pagination-size-changer)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(antCls, "-select-selector"), {
        backgroundColor: "inherit",
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " transparent"),
        boxShadow: "none"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-open, &-focused", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(antCls, "-select-selector"), {
        color: token.colorPrimary
    })), _obj)), // https://github.com/ant-design/ant-design/issues/31333
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(antCls, "-cascader-picker"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        margin: "-9px ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())),
        backgroundColor: "transparent"
    }, "".concat(antCls, "-cascader-input"), {
        textAlign: "start",
        border: 0,
        boxShadow: "none"
    })), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-addon:first-child", {
        borderInlineEnd: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-addon:last-child", {
        borderInlineStart: 0
    }), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "".concat(componentCls), {
        width: "100%",
        marginBottom: 0,
        textAlign: "inherit",
        "&:focus": {
            zIndex: 1,
            // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
            borderInlineEndWidth: 1
        },
        "&:hover": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            zIndex: 1,
            borderInlineEndWidth: 1
        }, "".concat(componentCls, "-search-with-button &"), {
            zIndex: 0
        })
    }), // Reset rounded corners
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, ":first-child, ").concat(componentCls, "-group-addon:first-child"), // Reset Select's style in addon
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
    }, "".concat(antCls, "-select ").concat(antCls, "-select-selector"), {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, "-affix-wrapper"), (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:not(:first-child) ".concat(componentCls), {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:not(:last-child) ".concat(componentCls), {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
    }), _obj3)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, ":last-child, ").concat(componentCls, "-group-addon:last-child"), // Reset Select's style in addon
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
    }, "".concat(antCls, "-select ").concat(antCls, "-select-selector"), {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "".concat(componentCls, "-affix-wrapper"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "&:not(:last-child)": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
        }, "".concat(componentCls, "-search &"), {
            borderStartStartRadius: token.borderRadius,
            borderEndStartRadius: token.borderRadius
        })
    }, "&:not(:first-child), ".concat(componentCls, "-search &:not(:first-child)"), {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&".concat(componentCls, "-group-compact"), Object.assign(Object.assign({
        display: "block"
    }, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), (_obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-group-addon, ").concat(componentCls, "-group-wrap, > ").concat(componentCls), {
        "&:not(:first-child):not(:last-child)": {
            borderInlineEndWidth: token.lineWidth,
            "&:hover": {
                zIndex: 1
            },
            "&:focus": {
                zIndex: 1
            }
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > *", {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "\n        & > ".concat(componentCls, "-affix-wrapper,\n        & > ").concat(componentCls, "-number-affix-wrapper,\n        & > ").concat(antCls, "-picker-range\n      "), {
        display: "inline-flex"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > *:not(:last-child)", {
        marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: token.lineWidth
    }), // Undo float for .ant-input-group .ant-input
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls), {
        float: "none"
    }), // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > ".concat(antCls, "-select > ").concat(antCls, "-select-selector,\n      & > ").concat(antCls, "-select-auto-complete ").concat(componentCls, ",\n      & > ").concat(antCls, "-cascader-picker ").concat(componentCls, ",\n      & > ").concat(componentCls, "-group-wrapper ").concat(componentCls), {
        borderInlineEndWidth: token.lineWidth,
        borderRadius: 0,
        "&:hover": {
            zIndex: 1
        },
        "&:focus": {
            zIndex: 1
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > ".concat(antCls, "-select-focused"), {
        zIndex: 1
    }), // update z-index for arrow icon
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > ".concat(antCls, "-select > ").concat(antCls, "-select-arrow"), {
        zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > *:first-child,\n      & > ".concat(antCls, "-select:first-child > ").concat(antCls, "-select-selector,\n      & > ").concat(antCls, "-select-auto-complete:first-child ").concat(componentCls, ",\n      & > ").concat(antCls, "-cascader-picker:first-child ").concat(componentCls), {
        borderStartStartRadius: token.borderRadius,
        borderEndStartRadius: token.borderRadius
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > *:last-child,\n      & > ".concat(antCls, "-select:last-child > ").concat(antCls, "-select-selector,\n      & > ").concat(antCls, "-cascader-picker:last-child ").concat(componentCls, ",\n      & > ").concat(antCls, "-cascader-picker-focused:last-child ").concat(componentCls), {
        borderInlineEndWidth: token.lineWidth,
        borderStartEndRadius: token.borderRadius,
        borderEndEndRadius: token.borderRadius
    }), // https://github.com/ant-design/ant-design/issues/12493
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& > ".concat(antCls, "-select-auto-complete ").concat(componentCls), {
        verticalAlign: "top"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-group-wrapper + ").concat(componentCls, "-group-wrapper"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginInlineStart: token.calc(token.lineWidth).mul(-1).equal()
    }, "".concat(componentCls, "-affix-wrapper"), {
        borderRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-group-wrapper:not(:last-child)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-search > ").concat(componentCls, "-group"), (_obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "& > ".concat(componentCls, "-group-addon > ").concat(componentCls, "-search-button"), {
        borderRadius: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "& > ".concat(componentCls), {
        borderStartStartRadius: token.borderRadius,
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        borderEndStartRadius: token.borderRadius
    }), _obj4))), _obj5))), _obj6;
};
var $36bcd88a5dc6cb3d$var$genInputStyle = function(token) {
    var componentCls = token.componentCls, controlHeightSM = token.controlHeightSM, lineWidth = token.lineWidth, calc = token.calc;
    var FIXED_CHROME_COLOR_HEIGHT = 16;
    var colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd(token)), $36bcd88a5dc6cb3d$export$cf983a15949ad61e(token, componentCls)), {
        '&[type="color"]': (_obj = {
            height: token.controlHeight
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-lg"), {
            height: token.controlHeightLG
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-sm"), {
            height: controlHeightSM,
            paddingTop: colorSmallPadding,
            paddingBottom: colorSmallPadding
        }), _obj),
        '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
            "-webkit-appearance": "none"
        }
    }));
};
var $36bcd88a5dc6cb3d$var$genAllowClearStyle = function(token) {
    var componentCls = token.componentCls;
    return(// ========================= Input =========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-clear-icon"), {
        margin: 0,
        color: token.colorTextQuaternary,
        fontSize: token.fontSizeIcon,
        verticalAlign: -1,
        // https://github.com/ant-design/ant-design/pull/18151
        // https://codesandbox.io/s/wizardly-sun-u10br
        cursor: "pointer",
        transition: "color ".concat(token.motionDurationSlow),
        "&:hover": {
            color: token.colorTextTertiary
        },
        "&:active": {
            color: token.colorText
        },
        "&-hidden": {
            visibility: "hidden"
        },
        "&-has-suffix": {
            margin: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.inputAffixPadding))
        }
    }));
};
var $36bcd88a5dc6cb3d$var$genAffixStyle = function(token) {
    var componentCls = token.componentCls, inputAffixPadding = token.inputAffixPadding, colorTextDescription = token.colorTextDescription, motionDurationSlow = token.motionDurationSlow, colorIcon = token.colorIcon, colorIconHover = token.colorIconHover, iconCls = token.iconCls;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-affix-wrapper"), Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd(token)), (_obj = {
        display: "inline-flex"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-affix-wrapper-disabled):hover"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        zIndex: 1
    }, "".concat(componentCls, "-search-with-button &"), {
        zIndex: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-focused, &:focus", {
        zIndex: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-disabled", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "[disabled]"), {
        background: "transparent"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> input".concat(componentCls), {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        "&::-ms-reveal": {
            display: "none"
        },
        "&:focus": {
            boxShadow: "none !important"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&::before", {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls), {
        "&-prefix, &-suffix": {
            display: "flex",
            flex: "none",
            alignItems: "center",
            "> *:not(:last-child)": {
                marginInlineEnd: token.paddingXS
            }
        },
        "&-show-count-suffix": {
            color: colorTextDescription
        },
        "&-show-count-has-suffix": {
            marginInlineEnd: token.paddingXXS
        },
        "&-prefix": {
            marginInlineEnd: inputAffixPadding
        },
        "&-suffix": {
            marginInlineStart: inputAffixPadding
        }
    }), _obj)), $36bcd88a5dc6cb3d$var$genAllowClearStyle(token)), // password
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(iconCls).concat(componentCls, "-password-icon"), {
        color: colorIcon,
        cursor: "pointer",
        transition: "all ".concat(motionDurationSlow),
        "&:hover": {
            color: colorIconHover
        }
    })), $36bcd88a5dc6cb3d$export$cf983a15949ad61e(token, "".concat(componentCls, "-affix-wrapper"))));
};
var $36bcd88a5dc6cb3d$var$genGroupStyle = function(token) {
    var componentCls = token.componentCls, colorError = token.colorError, colorWarning = token.colorWarning, borderRadiusLG = token.borderRadiusLG, borderRadiusSM = token.borderRadiusSM;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group"), Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), $36bcd88a5dc6cb3d$export$ffe8b2a9bd2e5cfe(token)), {
        "&-rtl": {
            direction: "rtl"
        },
        "&-wrapper": (_obj = {
            display: "inline-block",
            width: "100%",
            textAlign: "start",
            verticalAlign: "top",
            // https://github.com/ant-design/ant-design/issues/6403
            "&-rtl": {
                direction: "rtl"
            },
            // Size
            "&-lg": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                borderRadius: borderRadiusLG,
                fontSize: token.fontSizeLG
            }),
            "&-sm": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                borderRadius: borderRadiusSM
            }),
            // Status
            "&-status-error": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                color: colorError,
                borderColor: colorError
            }),
            "&-status-warning": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                color: colorWarning,
                borderColor: colorWarning
            }),
            "&-disabled": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), Object.assign({}, $36bcd88a5dc6cb3d$export$12789f962d420a93(token)))
        }, // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-first-item):not(").concat(componentCls, "-compact-last-item)").concat(componentCls, "-compact-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
            borderRadius: 0
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-last-item)").concat(componentCls, "-compact-first-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-first-item)").concat(componentCls, "-compact-last-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
        })), _obj)
    }));
};
var $36bcd88a5dc6cb3d$var$genSearchInputStyle = function(token) {
    var componentCls = token.componentCls, antCls = token.antCls;
    var searchPrefixCls = "".concat(componentCls, "-search");
    var _obj, _obj1, _obj2;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, searchPrefixCls, (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls), {
        "&:hover, &:focus": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            borderColor: token.colorPrimaryHover
        }, "+ ".concat(componentCls, "-group-addon ").concat(searchPrefixCls, "-button:not(").concat(antCls, "-btn-primary)"), {
            borderInlineStartColor: token.colorPrimaryHover
        })
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-affix-wrapper"), {
        borderRadius: 0
    }), // fix slight height diff in Firefox:
    // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-lg"), {
        lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal({
            unit: false
        })
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> ".concat(componentCls, "-group"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-group-addon:last-child"), (_obj = {
        insetInlineStart: -1,
        padding: 0,
        border: 0
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(searchPrefixCls, "-button"), {
        paddingTop: 0,
        paddingBottom: 0,
        borderStartStartRadius: 0,
        borderStartEndRadius: token.borderRadius,
        borderEndEndRadius: token.borderRadius,
        borderEndStartRadius: 0,
        boxShadow: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(searchPrefixCls, "-button:not(").concat(antCls, "-btn-primary)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        color: token.colorTextDescription,
        "&:hover": {
            color: token.colorPrimaryHover
        },
        "&:active": {
            color: token.colorPrimaryActive
        }
    }, "&".concat(antCls, "-btn-loading::before"), {
        insetInlineStart: 0,
        insetInlineEnd: 0,
        insetBlockStart: 0,
        insetBlockEnd: 0
    })), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(searchPrefixCls, "-button"), {
        height: token.controlHeight,
        "&:hover, &:focus": {
            zIndex: 1
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-large ".concat(searchPrefixCls, "-button"), {
        height: token.controlHeightLG
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-small ".concat(searchPrefixCls, "-button"), {
        height: token.controlHeightSM
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-rtl", {
        direction: "rtl"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-compact-item"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:not(".concat(componentCls, "-compact-last-item)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-search-button"), {
        marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
        borderRadius: 0
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:not(".concat(componentCls, "-compact-first-item)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ",").concat(componentCls, "-affix-wrapper"), {
        borderRadius: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-group-addon ").concat(componentCls, "-search-button,\n        > ").concat(componentCls, ",\n        ").concat(componentCls, "-affix-wrapper"), {
        "&:hover,&:focus,&:active": {
            zIndex: 2
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-affix-wrapper-focused"), {
        zIndex: 2
    }), _obj1)), _obj2));
};
var $36bcd88a5dc6cb3d$var$genTextAreaStyle = function(token) {
    var componentCls = token.componentCls, paddingLG = token.paddingLG;
    var textareaPrefixCls = "".concat(componentCls, "-textarea");
    var _obj, _obj1, _obj2, _obj3;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, textareaPrefixCls, (_obj3 = {
        position: "relative",
        "&-show-count": (_obj = {}, // https://github.com/ant-design/ant-design/issues/33049
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls), {
            height: "100%"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-data-count"), {
            position: "absolute",
            bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
            insetInlineEnd: 0,
            color: token.colorTextDescription,
            whiteSpace: "nowrap",
            pointerEvents: "none"
        }), _obj),
        "&-allow-clear": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls), {
            paddingInlineEnd: paddingLG
        })
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-affix-wrapper".concat(textareaPrefixCls, "-has-feedback"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls), {
        paddingInlineEnd: paddingLG
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-affix-wrapper".concat(componentCls, "-affix-wrapper"), (_obj2 = {
        padding: 0
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> textarea".concat(componentCls), {
        fontSize: "inherit",
        border: "none",
        outline: "none",
        "&:focus": {
            boxShadow: "none !important"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-suffix"), (_obj1 = {
        margin: 0,
        "> *:not(:last-child)": {
            marginInline: 0
        }
    }, // Clear Icon
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-clear-icon"), {
        position: "absolute",
        insetInlineEnd: token.paddingXS,
        insetBlockStart: token.paddingXS
    }), // Feedback Icon
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(textareaPrefixCls, "-suffix"), {
        position: "absolute",
        top: 0,
        insetInlineEnd: token.paddingInline,
        bottom: 0,
        zIndex: 1,
        display: "inline-flex",
        alignItems: "center",
        margin: "auto",
        pointerEvents: "none"
    }), _obj1)), _obj2)), _obj3));
};
// ============================== Range ===============================
var $36bcd88a5dc6cb3d$var$genRangeStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-out-of-range"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, & input, & textarea, ".concat(componentCls, "-show-count-suffix, ").concat(componentCls, "-data-count"), {
        color: token.colorError
    }));
};
function $36bcd88a5dc6cb3d$export$a157d95850191a12(token) {
    return (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
var $36bcd88a5dc6cb3d$export$bd8b682992bc9781 = function(token) {
    var controlHeight = token.controlHeight, fontSize = token.fontSize, lineHeight = token.lineHeight, lineWidth = token.lineWidth, controlHeightSM = token.controlHeightSM, controlHeightLG = token.controlHeightLG, fontSizeLG = token.fontSizeLG, lineHeightLG = token.lineHeightLG, paddingSM = token.paddingSM, controlPaddingHorizontalSM = token.controlPaddingHorizontalSM, controlPaddingHorizontal = token.controlPaddingHorizontal, colorFillAlter = token.colorFillAlter, colorPrimaryHover = token.colorPrimaryHover, colorPrimary = token.colorPrimary, controlOutlineWidth = token.controlOutlineWidth, controlOutline = token.controlOutline, colorErrorOutline = token.colorErrorOutline, colorWarningOutline = token.colorWarningOutline;
    return {
        paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: "0 0 0 ".concat(controlOutlineWidth, "px ").concat(controlOutline),
        errorActiveShadow: "0 0 0 ".concat(controlOutlineWidth, "px ").concat(colorErrorOutline),
        warningActiveShadow: "0 0 0 ".concat(controlOutlineWidth, "px ").concat(colorWarningOutline),
        hoverBg: "",
        activeBg: ""
    };
};
var // ============================== Export ==============================
$36bcd88a5dc6cb3d$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Input", function(token) {
    var inputToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, $36bcd88a5dc6cb3d$export$a157d95850191a12(token));
    return [
        $36bcd88a5dc6cb3d$var$genInputStyle(inputToken),
        $36bcd88a5dc6cb3d$var$genTextAreaStyle(inputToken),
        $36bcd88a5dc6cb3d$var$genAffixStyle(inputToken),
        $36bcd88a5dc6cb3d$var$genGroupStyle(inputToken),
        $36bcd88a5dc6cb3d$var$genSearchInputStyle(inputToken),
        $36bcd88a5dc6cb3d$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $8123ced5d1d65f52$export$b1208b23589b4b73)(inputToken)
    ];
}, $36bcd88a5dc6cb3d$export$bd8b682992bc9781);


"use client";
var $3c520fef85d47038$var$Group = function(props) {
    var _useContext = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction;
    var customizePrefixCls = props.prefixCls, className = props.className;
    var prefixCls = getPrefixCls("input-group", customizePrefixCls);
    var inputPrefixCls = getPrefixCls("input");
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $36bcd88a5dc6cb3d$export$2e2bcd8739ae039)(inputPrefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), props.size === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), props.size === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-compact"), props.compact), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), hashId, className);
    var formItemContext = (0, $8SyCD.useContext)((0, $1618288003dd675a$export$bbb5553c6c7a14ed));
    var groupFormItemContext = (0, $8SyCD.useMemo)(function() {
        return Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        });
    }, [
        formItemContext
    ]);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $8SyCD.createElement((0, $1618288003dd675a$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $3c520fef85d47038$export$2e2bcd8739ae039 = $3c520fef85d47038$var$Group;





var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $5f98a355ab662616$var$CloseCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            "fill-rule": "evenodd",
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    name: "close-circle",
    theme: "filled"
};
var $5f98a355ab662616$export$2e2bcd8739ae039 = $5f98a355ab662616$var$CloseCircleFilled;



var $9742a01b0cacbf6e$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5f98a355ab662616$export$2e2bcd8739ae039)
    }));
};
var $9742a01b0cacbf6e$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($9742a01b0cacbf6e$var$CloseCircleFilled);









var $8SyCD = parcelRequire("8SyCD");
function $ff7c93464b262e56$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $ff7c93464b262e56$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function $ff7c93464b262e56$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = "";
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        // https://github.com/ant-design/ant-design/issues/45737
        if (target.type !== "file") target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $ff7c93464b262e56$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}


var $1008040ffe7a0ab4$var$BaseInput = function BaseInput(props) {
    var _inputElement$props, _inputElement$props2;
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
    var containerRef = (0, $8SyCD.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _clsx;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            onClick: handleReset,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(clearIconCls, (_clsx = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(clearIconCls, "-hidden"), !needClear), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(clearIconCls, "-has-suffix"), !!suffix), _clsx)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, $8SyCD.cloneElement)(inputElement, {
        value: value,
        hidden: hidden,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_inputElement$props = inputElement.props) === null || _inputElement$props === void 0 ? void 0 : _inputElement$props.className, !(0, $ff7c93464b262e56$export$a19010aeeaa0c7a)(props) && !(0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props) && className) || null,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, (_inputElement$props2 = inputElement.props) === null || _inputElement$props2 === void 0 ? void 0 : _inputElement$props2.style), !(0, $ff7c93464b262e56$export$a19010aeeaa0c7a)(props) && !(0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props) ? style : {})
    });
    // ================== Prefix & Suffix ================== //
    if ((0, $ff7c93464b262e56$export$a19010aeeaa0c7a)(props)) {
        var _clsx2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(affixWrapperPrefixCls, (_clsx2 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _clsx2), !(0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props) && className, classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(AffixWrapperComponent, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            className: affixWrapperCls,
            style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, !(0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props) ? style : undefined), styles === null || styles === void 0 ? void 0 : styles.affixWrapper),
            hidden: !(0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props) && hidden,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), /*#__PURE__*/ (0, $8SyCD.cloneElement)(inputElement, {
            value: value,
            hidden: null
        }), suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $ff7c93464b262e56$export$ae6255aa850a31d1)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-group-wrapper"), className, classes === null || classes === void 0 ? void 0 : classes.group);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, $8SyCD.cloneElement)(element, {
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
var $1008040ffe7a0ab4$export$2e2bcd8739ae039 = $1008040ffe7a0ab4$var$BaseInput;












var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");
var $944aa13c6d788e53$var$_excluded = [
    "show"
];
function $944aa13c6d788e53$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $944aa13c6d788e53$export$2e2bcd8739ae039(count, showCount) {
    return $8SyCD.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $944aa13c6d788e53$var$_excluded);
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === "function" ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}



var $035facd9c4d0c613$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $035facd9c4d0c613$var$Input = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $035facd9c4d0c613$var$_excluded);
    var _useState = (0, $8SyCD.useState)(false), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(false);
    var inputRef = (0, $8SyCD.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $ff7c93464b262e56$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    // =================== Select Range ===================
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(null), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), selection = _React$useState2[0], setSelection = _React$useState2[1];
    // ====================== Count =======================
    var countConfig = (0, $944aa13c6d788e53$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $8SyCD.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, $8SyCD.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        }
        setValue(cutValue);
        if (inputRef.current) (0, $ff7c93464b262e56$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useEffect(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === "Enter") onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        if (inputRef.current) (0, $ff7c93464b262e56$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
            "prefixCls",
            "onPressEnter",
            "addonBefore",
            "addonAfter",
            "prefix",
            "suffix",
            "allowClear",
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            "defaultValue",
            "showCount",
            "count",
            "classes",
            "htmlSize",
            "styles",
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("input", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-show-count-suffix"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $1008040ffe7a0ab4$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, outOfRangeCls),
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles
    }));
});
var $035facd9c4d0c613$export$2e2bcd8739ae039 = $035facd9c4d0c613$var$Input;


var $fd7740826e3c952e$export$2e2bcd8739ae039 = (0, $035facd9c4d0c613$export$2e2bcd8739ae039);





var $69f886f8119a0cf0$var$InputStatuses = [
    "warning",
    "error",
    ""
];
function $69f886f8119a0cf0$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    var _obj;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-status-success"), status === "success"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-status-warning"), status === "warning"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-status-error"), status === "error"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-status-validating"), status === "validating"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-has-feedback"), hasFeedback), _obj));
}
var $69f886f8119a0cf0$export$314e193082d7ba49 = function(contextStatus, customStatus) {
    return customStatus || contextStatus;
};









var $8SyCD = parcelRequire("8SyCD");
function $b784f6d741fc3c99$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    var removePasswordTimeoutRef = (0, $8SyCD.useRef)([]);
    var removePasswordTimeout = function() {
        removePasswordTimeoutRef.current.push(setTimeout(function() {
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute("value");
        }));
    };
    (0, $8SyCD.useEffect)(function() {
        if (triggerOnMount) removePasswordTimeout();
        return function() {
            return removePasswordTimeoutRef.current.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
        };
    }, []);
    return removePasswordTimeout;
}



// eslint-disable-next-line import/prefer-default-export
function $43021d01d739ec7f$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}




var $b2ac4197b57fad70$var$useCSSVarCls = function(prefixCls) {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 5), cssVar = _useToken[4];
    return cssVar ? "".concat(prefixCls, "-css-var") : "";
};
var $b2ac4197b57fad70$export$2e2bcd8739ae039 = $b2ac4197b57fad70$var$useCSSVarCls;


"use client";
var $1c4d6cd69b24c8eb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $1c4d6cd69b24c8eb$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var cursor = (option || {}).cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
var $1c4d6cd69b24c8eb$var$Input = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var _a;
    var customizePrefixCls = props.prefixCls, _props_bordered = props.bordered, bordered = _props_bordered === void 0 ? true : _props_bordered, customStatus = props.status, customSize = props.size, customDisabled = props.disabled, onBlur = props.onBlur, onFocus = props.onFocus, suffix = props.suffix, allowClear = props.allowClear, addonAfter = props.addonAfter, addonBefore = props.addonBefore, className = props.className, style = props.style, styles = props.styles, rootClassName = props.rootClassName, onChange = props.onChange, classes = props.classNames, rest = $1c4d6cd69b24c8eb$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames"
    ]);
    var _React_useContext = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, input = _React_useContext.input;
    var prefixCls = getPrefixCls("input", customizePrefixCls);
    var inputRef = (0, $8SyCD.useRef)(null);
    // Style
    var cssVarCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $36bcd88a5dc6cb3d$export$2e2bcd8739ae039)(prefixCls, cssVarCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    // ===================== Compact Item =====================
    var _useCompactItemContext = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContext.compactSize, compactItemClassnames = _useCompactItemContext.compactItemClassnames;
    // ===================== Size =====================
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctx) {
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    var disabled = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _useContext = (0, $8SyCD.useContext)((0, $1618288003dd675a$export$bbb5553c6c7a14ed)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $69f886f8119a0cf0$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    var inputHasPrefixSuffix = (0, $43021d01d739ec7f$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    var prevHasPrefixSuffix = (0, $8SyCD.useRef)(inputHasPrefixSuffix);
    var _a1;
    /* eslint-enable */ // ===================== Remove Password value =====================
    var removePasswordTimeout = (0, $b784f6d741fc3c99$export$2e2bcd8739ae039)(inputRef, true);
    var handleBlur = function(e) {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function(e) {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleChange = function(e) {
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    var suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    var mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $9742a01b0cacbf6e$export$2e2bcd8739ae039), null)
    };
    var _obj, _obj1, _obj2;
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $fd7740826e3c952e$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.style), style),
        styles: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.styles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, rootClassName, cssVarCls, hashId, compactItemClassnames, input === null || input === void 0 ? void 0 : input.className),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $1618288003dd675a$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $1618288003dd675a$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonBefore)),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), input === null || input === void 0 ? void 0 : input.classNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-borderless"), !bordered), _obj), !inputHasPrefixSuffix && (0, $69f886f8119a0cf0$export$b08e7b47149942a2)(prefixCls, mergedStatus), classes === null || classes === void 0 ? void 0 : classes.input, (_a = input === null || input === void 0 ? void 0 : input.classNames) === null || _a === void 0 ? void 0 : _a.input, hashId)
        }),
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), _obj1), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback), hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-group-rtl"), direction === "rtl"), hashId),
            group: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(prefixCls, "-group-wrapper-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(prefixCls, "-group-wrapper-disabled"), mergedDisabled), _obj2), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback), hashId)
        }
    })));
});
var $1c4d6cd69b24c8eb$export$2e2bcd8739ae039 = $1c4d6cd69b24c8eb$var$Input;






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $f3a516bb745649c0$var$EyeInvisibleOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    name: "eye-invisible",
    theme: "outlined"
};
var $f3a516bb745649c0$export$2e2bcd8739ae039 = $f3a516bb745649c0$var$EyeInvisibleOutlined;



var $c8af03ed18fcc3b9$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f3a516bb745649c0$export$2e2bcd8739ae039)
    }));
};
var $c8af03ed18fcc3b9$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($c8af03ed18fcc3b9$var$EyeInvisibleOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $cc8f8b89e998d230$var$EyeOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    name: "eye",
    theme: "outlined"
};
var $cc8f8b89e998d230$export$2e2bcd8739ae039 = $cc8f8b89e998d230$var$EyeOutlined;



var $54a010748524f0fa$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $cc8f8b89e998d230$export$2e2bcd8739ae039)
    }));
};
var $54a010748524f0fa$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($54a010748524f0fa$var$EyeOutlined);






var $8SyCD = parcelRequire("8SyCD");



"use client";
var $7efbf544cf0ec0fc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7efbf544cf0ec0fc$var$defaultIconRender = function(visible) {
    return visible ? /*#__PURE__*/ $8SyCD.createElement((0, $54a010748524f0fa$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $8SyCD.createElement((0, $c8af03ed18fcc3b9$export$2e2bcd8739ae039), null);
};
var $7efbf544cf0ec0fc$var$ActionMap = {
    click: "onClick",
    hover: "onMouseOver"
};
var $7efbf544cf0ec0fc$var$Password = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _props_visibilityToggle = props.visibilityToggle, visibilityToggle = _props_visibilityToggle === void 0 ? true : _props_visibilityToggle;
    var visibilityControlled = typeof visibilityToggle === "object" && visibilityToggle.visible !== undefined;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(function() {
        return visibilityControlled ? visibilityToggle.visible : false;
    }), 2), visible = _useState[0], setVisible = _useState[1];
    var inputRef = (0, $8SyCD.useRef)(null);
    $8SyCD.useEffect(function() {
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    var removePasswordTimeout = (0, $b784f6d741fc3c99$export$2e2bcd8739ae039)(inputRef);
    var onVisibleChange = function() {
        var disabled = props.disabled;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible(function(prevState) {
            var _a;
            var newState = !prevState;
            if (typeof visibilityToggle === "object") (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    var getIcon = function(prefixCls) {
        var _props_action = props.action, action = _props_action === void 0 ? "click" : _props_action, _props_iconRender = props.iconRender, iconRender = _props_iconRender === void 0 ? $7efbf544cf0ec0fc$var$defaultIconRender : _props_iconRender;
        var iconTrigger = $7efbf544cf0ec0fc$var$ActionMap[action] || "";
        var icon = iconRender(visible);
        var _obj;
        var iconProps = (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, iconTrigger, onVisibleChange), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "className", "".concat(prefixCls, "-icon")), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "key", "passwordIcon"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "onMouseDown", function(e) {
            // Prevent focused state lost
            // https://github.com/ant-design/ant-design/issues/15173
            e.preventDefault();
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "onMouseUp", function(e) {
            // Prevent caret position change
            // https://github.com/ant-design/ant-design/issues/23524
            e.preventDefault();
        }), _obj);
        return /*#__PURE__*/ $8SyCD.cloneElement(/*#__PURE__*/ $8SyCD.isValidElement(icon) ? icon : /*#__PURE__*/ $8SyCD.createElement("span", null, icon), iconProps);
    };
    var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, restProps = $7efbf544cf0ec0fc$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    var prefixCls = getPrefixCls("input-password", customizePrefixCls);
    var suffixIcon = visibilityToggle && getIcon(prefixCls);
    var inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-").concat(size), !!size));
    var omittedProps = Object.assign(Object.assign({}, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(restProps, [
        "suffix",
        "iconRender",
        "visibilityToggle"
    ])), {
        type: visible ? "text" : "password",
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $8SyCD.createElement((0, $1c4d6cd69b24c8eb$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, inputRef)
    }, omittedProps));
});
var $7efbf544cf0ec0fc$export$2e2bcd8739ae039 = $7efbf544cf0ec0fc$var$Password;





var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $9f5a5918e1bb6903$var$SearchOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    name: "search",
    theme: "outlined"
};
var $9f5a5918e1bb6903$export$2e2bcd8739ae039 = $9f5a5918e1bb6903$var$SearchOutlined;



var $b8019eb417509ae4$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $9f5a5918e1bb6903$export$2e2bcd8739ae039)
    }));
};
var $b8019eb417509ae4$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($b8019eb417509ae4$var$SearchOutlined);





var $8SyCD = parcelRequire("8SyCD");






"use client";
var $455b1e4051c93d2f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $455b1e4051c93d2f$var$Search = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props_enterButton = props.enterButton, enterButton = _props_enterButton === void 0 ? false : _props_enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, restProps = $455b1e4051c93d2f$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var composedRef = $8SyCD.useRef(false);
    var prefixCls = getPrefixCls("input-search", customizePrefixCls);
    var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    var compactSize = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction).compactSize;
    var size = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctx) {
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    var inputRef = $8SyCD.useRef(null);
    var onChange = function(e) {
        if (e && e.target && e.type === "click" && customOnSearch) customOnSearch(e.target.value, e, {
            source: "clear"
        });
        if (customOnChange) customOnChange(e);
    };
    var onMouseDown = function(e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    var onSearch = function(e) {
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: "input"
        });
    };
    var onPressEnter = function(e) {
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    var searchIcon = typeof enterButton === "boolean" ? /*#__PURE__*/ $8SyCD.createElement((0, $b8019eb417509ae4$export$2e2bcd8739ae039), null) : null;
    var btnClassName = "".concat(prefixCls, "-button");
    var button;
    var enterButtonAsElement = enterButton || {};
    var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") button = (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: function(e) {
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: "enterButton"
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $8SyCD.createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
        className: btnClassName,
        type: enterButton ? "primary" : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(addonAfter, {
            key: "addonAfter"
        })
    ];
    var _obj;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size), !!size), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-with-button"), !!enterButton), _obj), className);
    var handleOnCompositionStart = function(e) {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var handleOnCompositionEnd = function(e) {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $1c4d6cd69b24c8eb$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $455b1e4051c93d2f$export$2e2bcd8739ae039 = $455b1e4051c93d2f$var$Search;





var $8SyCD = parcelRequire("8SyCD");














var $8SyCD = parcelRequire("8SyCD");









var $8SyCD = parcelRequire("8SyCD");







var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
var $305812c034f1d91d$export$db36075d98ba73d3 = /*#__PURE__*/ $8SyCD.createContext(null);
function $305812c034f1d91d$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $8SyCD.useRef(0);
    var resizeInfosRef = $8SyCD.useRef([]);
    var onCollectionResize = $8SyCD.useContext($305812c034f1d91d$export$db36075d98ba73d3);
    var onResize = $8SyCD.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $8SyCD.createElement($305812c034f1d91d$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $90278272e77a80e6$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function get() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype["delete"] = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $90278272e77a80e6$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $90278272e77a80e6$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $90278272e77a80e6$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($90278272e77a80e6$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $90278272e77a80e6$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $90278272e77a80e6$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $90278272e77a80e6$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $90278272e77a80e6$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $90278272e77a80e6$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $90278272e77a80e6$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $90278272e77a80e6$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $90278272e77a80e6$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $90278272e77a80e6$var$throttle(this.refresh.bind(this), $90278272e77a80e6$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$90278272e77a80e6$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($90278272e77a80e6$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$90278272e77a80e6$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $90278272e77a80e6$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $90278272e77a80e6$var$defineConfigurable = function defineConfigurable(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $90278272e77a80e6$var$getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $90278272e77a80e6$var$global$1;
};
// Placeholder of an empty content rectangle.
var $90278272e77a80e6$var$emptyRect = $90278272e77a80e6$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $90278272e77a80e6$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $90278272e77a80e6$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $90278272e77a80e6$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $90278272e77a80e6$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $90278272e77a80e6$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $90278272e77a80e6$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $90278272e77a80e6$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $90278272e77a80e6$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $90278272e77a80e6$var$emptyRect;
    var styles = $90278272e77a80e6$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $90278272e77a80e6$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $90278272e77a80e6$var$toFloat(styles.width), height = $90278272e77a80e6$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $90278272e77a80e6$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $90278272e77a80e6$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$90278272e77a80e6$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $90278272e77a80e6$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $90278272e77a80e6$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $90278272e77a80e6$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $90278272e77a80e6$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $90278272e77a80e6$var$isDocumentElement(target) {
    return target === $90278272e77a80e6$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $90278272e77a80e6$var$getContentRect(target) {
    if (!$90278272e77a80e6$var$isBrowser) return $90278272e77a80e6$var$emptyRect;
    if ($90278272e77a80e6$var$isSVGGraphicsElement(target)) return $90278272e77a80e6$var$getSVGContentRect(target);
    return $90278272e77a80e6$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $90278272e77a80e6$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $90278272e77a80e6$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $90278272e77a80e6$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $90278272e77a80e6$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $90278272e77a80e6$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $90278272e77a80e6$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $90278272e77a80e6$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $90278272e77a80e6$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $90278272e77a80e6$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $90278272e77a80e6$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $90278272e77a80e6$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $90278272e77a80e6$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $90278272e77a80e6$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $90278272e77a80e6$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations["delete"](target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $90278272e77a80e6$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $90278272e77a80e6$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $90278272e77a80e6$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $90278272e77a80e6$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $90278272e77a80e6$var$ResizeObserverController.getInstance();
        var observer = new $90278272e77a80e6$var$ResizeObserverSPI(callback, controller, this);
        $90278272e77a80e6$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $90278272e77a80e6$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $90278272e77a80e6$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $90278272e77a80e6$var$index = function() {
    // Export existing implementation if available.
    if (typeof $90278272e77a80e6$var$global$1.ResizeObserver !== "undefined") return $90278272e77a80e6$var$global$1.ResizeObserver;
    return $90278272e77a80e6$var$ResizeObserver;
}();
var $90278272e77a80e6$export$2e2bcd8739ae039 = $90278272e77a80e6$var$index;


// =============================== Const ===============================
var $634367ce8e7df4cc$var$elementListeners = new Map();
function $634367ce8e7df4cc$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $634367ce8e7df4cc$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $634367ce8e7df4cc$var$resizeObserver = new (0, $90278272e77a80e6$export$2e2bcd8739ae039)($634367ce8e7df4cc$var$onResize);
var $634367ce8e7df4cc$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $634367ce8e7df4cc$export$524f0fd3b47831a = null; // eslint-disable-line
function $634367ce8e7df4cc$export$d1203567a167490e(element, callback) {
    if (!$634367ce8e7df4cc$var$elementListeners.has(element)) {
        $634367ce8e7df4cc$var$elementListeners.set(element, new Set());
        $634367ce8e7df4cc$var$resizeObserver.observe(element);
    }
    $634367ce8e7df4cc$var$elementListeners.get(element).add(callback);
}
function $634367ce8e7df4cc$export$23a2283368c55ea2(element, callback) {
    if ($634367ce8e7df4cc$var$elementListeners.has(element)) {
        $634367ce8e7df4cc$var$elementListeners.get(element)["delete"](callback);
        if (!$634367ce8e7df4cc$var$elementListeners.get(element).size) {
            $634367ce8e7df4cc$var$resizeObserver.unobserve(element);
            $634367ce8e7df4cc$var$elementListeners["delete"](element);
        }
    }
}







var $8SyCD = parcelRequire("8SyCD");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $d7f4017a6c76cfc0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($8SyCD.Component);


function $4c72d5c2e759017f$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $8SyCD.useRef(null);
    var wrapperRef = $8SyCD.useRef(null);
    var onCollectionResize = $8SyCD.useContext((0, $305812c034f1d91d$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $8SyCD.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $8SyCD.isValidElement(mergedChildren) && (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $a4b291de522e10cb$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(elementRef.current) === "object" ? (0, $a4b291de522e10cb$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $a4b291de522e10cb$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $8SyCD.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $8SyCD.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $8SyCD.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $8SyCD.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $634367ce8e7df4cc$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $634367ce8e7df4cc$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $8SyCD.createElement((0, $d7f4017a6c76cfc0$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $8SyCD.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $4c72d5c2e759017f$var$RefSingleObserver = /*#__PURE__*/ $8SyCD.forwardRef($4c72d5c2e759017f$var$SingleObserver);
var $4c72d5c2e759017f$export$2e2bcd8739ae039 = $4c72d5c2e759017f$var$RefSingleObserver;




var $5ea1841f7a4a2bc6$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $5ea1841f7a4a2bc6$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($5ea1841f7a4a2bc6$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $8SyCD.createElement((0, $4c72d5c2e759017f$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $5ea1841f7a4a2bc6$var$RefResizeObserver = /*#__PURE__*/ $8SyCD.forwardRef($5ea1841f7a4a2bc6$var$ResizeObserver);
$5ea1841f7a4a2bc6$var$RefResizeObserver.Collection = (0, $305812c034f1d91d$export$fb8073518f34e6ec);
var $5ea1841f7a4a2bc6$export$2e2bcd8739ae039 = $5ea1841f7a4a2bc6$var$RefResizeObserver;






var $8SyCD = parcelRequire("8SyCD");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $d3fc983d82fdbcba$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $d3fc983d82fdbcba$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break",
    "white-space"
];
var $d3fc983d82fdbcba$var$computedStyleCache = {};
var $d3fc983d82fdbcba$var$hiddenTextarea;
function $d3fc983d82fdbcba$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $d3fc983d82fdbcba$var$computedStyleCache[nodeRef]) return $d3fc983d82fdbcba$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = $d3fc983d82fdbcba$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(";");
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $d3fc983d82fdbcba$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $d3fc983d82fdbcba$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$d3fc983d82fdbcba$var$hiddenTextarea) {
        $d3fc983d82fdbcba$var$hiddenTextarea = document.createElement("textarea");
        $d3fc983d82fdbcba$var$hiddenTextarea.setAttribute("tab-index", "-1");
        $d3fc983d82fdbcba$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        document.body.appendChild($d3fc983d82fdbcba$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute("wrap")) $d3fc983d82fdbcba$var$hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
    else $d3fc983d82fdbcba$var$hiddenTextarea.removeAttribute("wrap");
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $d3fc983d82fdbcba$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $d3fc983d82fdbcba$var$hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat($d3fc983d82fdbcba$var$HIDDEN_TEXTAREA_STYLE));
    $d3fc983d82fdbcba$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $d3fc983d82fdbcba$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $d3fc983d82fdbcba$var$hiddenTextarea.value = " ";
        var singleRowHeight = $d3fc983d82fdbcba$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? "" : "hidden";
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: "none"
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


var $6dcca6af9015d1d3$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $6dcca6af9015d1d3$var$RESIZE_START = 0;
var $6dcca6af9015d1d3$var$RESIZE_MEASURING = 1;
var $6dcca6af9015d1d3$var$RESIZE_STABLE = 2;
var $6dcca6af9015d1d3$var$ResizableTextArea = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, onPressEnter = _ref.onPressEnter, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $6dcca6af9015d1d3$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : "";
        }
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $8SyCD.useRef();
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $8SyCD.useMemo(function() {
        if (autoSize && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(autoSize) === "object") return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $8SyCD.useState($6dcca6af9015d1d3$var$RESIZE_STABLE), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $8SyCD.useState(), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($6dcca6af9015d1d3$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (resizeState === $6dcca6af9015d1d3$var$RESIZE_START) setResizeState($6dcca6af9015d1d3$var$RESIZE_MEASURING);
        else if (resizeState === $6dcca6af9015d1d3$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $d3fc983d82fdbcba$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($6dcca6af9015d1d3$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $8SyCD.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $6dcca6af9015d1d3$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
                    startResize();
                });
            }
        }
    };
    $8SyCD.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, style), mergedAutoSizeStyle);
    if (resizeState === $6dcca6af9015d1d3$var$RESIZE_START || resizeState === $6dcca6af9015d1d3$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = "hidden";
        mergedStyle.overflowX = "hidden";
    }
    return /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $8SyCD.createElement("textarea", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $6dcca6af9015d1d3$export$2e2bcd8739ae039 = $6dcca6af9015d1d3$var$ResizableTextArea;


var $f1c8b641dd1aa677$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "classes",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize"
];
var $f1c8b641dd1aa677$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).forwardRef(function(_ref, ref) {
    var _countConfig$max, _clsx;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, classes = _ref.classes, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, rest = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $f1c8b641dd1aa677$var$_excluded);
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(null), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var resizableTextAreaRef = (0, $8SyCD.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $8SyCD.useImperativeHandle)(ref, function() {
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            }
        };
    });
    (0, $8SyCD.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(null), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $944aa13c6d788e53$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $ff7c93464b262e56$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        var onPressEnter = rest.onPressEnter, onKeyDown = rest.onKeyDown;
        if (e.key === "Enter" && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        (0, $ff7c93464b262e56$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !rest.autoSize && !showCount && !allowClear;
    var textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $1008040ffe7a0ab4$export$2e2bcd8739ae039), {
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(classes === null || classes === void 0 ? void 0 : classes.affixWrapper, (_clsx = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-show-count"), showCount), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-textarea-allow-clear"), allowClear), _clsx))
        },
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, style), textareaResized && !isPureTextArea ? {
            height: "auto"
        } : {}),
        dataAttrs: {
            affixWrapper: {
                "data-count": typeof dataCount === "string" ? dataCount : undefined
            }
        },
        hidden: hidden,
        inputElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $6dcca6af9015d1d3$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, rest, {
            maxLength: maxLength,
            onKeyDown: handleKeyDown,
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onCompositionStart: onInternalCompositionStart,
            onCompositionEnd: onInternalCompositionEnd,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
            style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
                resize: style === null || style === void 0 ? void 0 : style.resize
            }),
            disabled: disabled,
            prefixCls: prefixCls,
            onResize: handleResize,
            ref: resizableTextAreaRef
        }))
    });
    return textarea;
});
var $f1c8b641dd1aa677$export$2e2bcd8739ae039 = $f1c8b641dd1aa677$var$TextArea;



var $b2102842a9de0ecf$export$2e2bcd8739ae039 = (0, $f1c8b641dd1aa677$export$2e2bcd8739ae039);










"use client";
var $dc712ed726ceb2bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dc712ed726ceb2bf$var$TextArea = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var _a;
    var customizePrefixCls = props.prefixCls, _props_bordered = props.bordered, bordered = _props_bordered === void 0 ? true : _props_bordered, customizeSize = props.size, customDisabled = props.disabled, customStatus = props.status, allowClear = props.allowClear, classes = props.classNames, rootClassName = props.rootClassName, className = props.className, rest = $dc712ed726ceb2bf$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    // ===================== Size =====================
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customizeSize);
    // ===================== Disabled =====================
    var disabled = $8SyCD.useContext((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _React_useContext1 = $8SyCD.useContext((0, $1618288003dd675a$export$bbb5553c6c7a14ed)), contextStatus = _React_useContext1.status, hasFeedback = _React_useContext1.hasFeedback, feedbackIcon = _React_useContext1.feedbackIcon;
    var mergedStatus = (0, $69f886f8119a0cf0$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Ref =====================
    var innerRef = $8SyCD.useRef(null);
    $8SyCD.useImperativeHandle(ref, function() {
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function(option) {
                var _a, _b;
                (0, $1c4d6cd69b24c8eb$export$2b92016deb0b7aad)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function() {
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    var prefixCls = getPrefixCls("input", customizePrefixCls);
    // Allow clear
    var mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ $8SyCD.createElement((0, $9742a01b0cacbf6e$export$2e2bcd8739ae039), null)
    };
    // ===================== Style =====================
    var cssVarCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $36bcd88a5dc6cb3d$export$2e2bcd8739ae039)(prefixCls, cssVarCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj, _obj1;
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $b2102842a9de0ecf$export$2e2bcd8739ae039), Object.assign({}, rest, {
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(cssVarCls, className, rootClassName),
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-textarea-affix-wrapper"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-textarea-show-count"), props.showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)), _obj), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus), hashId)
        },
        classNames: Object.assign(Object.assign({}, classes), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-borderless"), !bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-lg"), mergedSize === "large"), _obj1), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)(prefixCls, mergedStatus), hashId, classes === null || classes === void 0 ? void 0 : classes.textarea)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-textarea-suffix")
        }, feedbackIcon),
        ref: innerRef
    })));
});
var $dc712ed726ceb2bf$export$2e2bcd8739ae039 = $dc712ed726ceb2bf$var$TextArea;


"use client";
var $9631a8a644aaa47e$var$Input = (0, $1c4d6cd69b24c8eb$export$2e2bcd8739ae039);
$9631a8a644aaa47e$var$Input.Group = (0, $3c520fef85d47038$export$2e2bcd8739ae039);
$9631a8a644aaa47e$var$Input.Search = (0, $455b1e4051c93d2f$export$2e2bcd8739ae039);
$9631a8a644aaa47e$var$Input.TextArea = (0, $dc712ed726ceb2bf$export$2e2bcd8739ae039);
$9631a8a644aaa47e$var$Input.Password = (0, $7efbf544cf0ec0fc$export$2e2bcd8739ae039);
var $9631a8a644aaa47e$export$2e2bcd8739ae039 = $9631a8a644aaa47e$var$Input;




var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $4bcbe772a4589c2c$var$CheckCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    name: "check-circle",
    theme: "filled"
};
var $4bcbe772a4589c2c$export$2e2bcd8739ae039 = $4bcbe772a4589c2c$var$CheckCircleFilled;



var $fbda717dcf0caf2c$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4bcbe772a4589c2c$export$2e2bcd8739ae039)
    }));
};
var $fbda717dcf0caf2c$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($fbda717dcf0caf2c$var$CheckCircleFilled);





var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $34ee42d169739201$var$ExclamationCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    name: "exclamation-circle",
    theme: "filled"
};
var $34ee42d169739201$export$2e2bcd8739ae039 = $34ee42d169739201$var$ExclamationCircleFilled;



var $41514c06cac7a0f0$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $34ee42d169739201$export$2e2bcd8739ae039)
    }));
};
var $41514c06cac7a0f0$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($41514c06cac7a0f0$var$ExclamationCircleFilled);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $a4389c080ed9bc10$var$InfoCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    name: "info-circle",
    theme: "filled"
};
var $a4389c080ed9bc10$export$2e2bcd8739ae039 = $a4389c080ed9bc10$var$InfoCircleFilled;



var $dd33a6757a67fbea$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $a4389c080ed9bc10$export$2e2bcd8739ae039)
    }));
};
var $dd33a6757a67fbea$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($dd33a6757a67fbea$var$InfoCircleFilled);





var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
var $7aa43d76a03d0c4e$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext(undefined);
var $7aa43d76a03d0c4e$export$2e2bcd8739ae039 = $7aa43d76a03d0c4e$var$zIndexContext;


"use client";
// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
var $4d9cc5bfe7391b56$var$CONTAINER_OFFSET = 100;
var $4d9cc5bfe7391b56$var$CONTAINER_OFFSET_MAX_COUNT = 10;
var $4d9cc5bfe7391b56$export$33ada7d8845f7e5 = $4d9cc5bfe7391b56$var$CONTAINER_OFFSET * $4d9cc5bfe7391b56$var$CONTAINER_OFFSET_MAX_COUNT;
var $4d9cc5bfe7391b56$export$1658852af8bb2a55 = {
    Modal: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET,
    Drawer: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET,
    Popover: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET,
    Popconfirm: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET,
    Tooltip: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET,
    Tour: $4d9cc5bfe7391b56$var$CONTAINER_OFFSET
};
var $4d9cc5bfe7391b56$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $4d9cc5bfe7391b56$var$isContainerType(type) {
    return type in $4d9cc5bfe7391b56$export$1658852af8bb2a55;
}
function $4d9cc5bfe7391b56$export$3e7906d4075187a4(componentType, customZIndex) {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $7aa43d76a03d0c4e$export$2e2bcd8739ae039));
    var isContainer = $4d9cc5bfe7391b56$var$isContainerType(componentType);
    if (customZIndex !== undefined) return [
        customZIndex,
        customZIndex
    ];
    var zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
    if (isContainer) {
        zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $4d9cc5bfe7391b56$export$1658852af8bb2a55[componentType];
        zIndex = Math.min(zIndex, token.zIndexPopupBase + $4d9cc5bfe7391b56$export$33ada7d8845f7e5);
    } else zIndex += $4d9cc5bfe7391b56$export$3f7a364c708f940b[componentType];
    return [
        parentZIndex === undefined ? customZIndex : zIndex,
        zIndex
    ];
}


// ================== Collapse Motion ==================
var $800f705b9f73a72d$var$getCollapsedHeight = function() {
    return {
        height: 0,
        opacity: 0
    };
};
var $800f705b9f73a72d$var$getRealHeight = function(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $800f705b9f73a72d$var$getCurrentHeight = function(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $800f705b9f73a72d$var$skipOpacityTransition = function(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
};
var $800f705b9f73a72d$var$initCollapseMotion = function initCollapseMotion() {
    var rootCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ant";
    return {
        motionName: "".concat(rootCls, "-motion-collapse"),
        onAppearStart: $800f705b9f73a72d$var$getCollapsedHeight,
        onEnterStart: $800f705b9f73a72d$var$getCollapsedHeight,
        onAppearActive: $800f705b9f73a72d$var$getRealHeight,
        onEnterActive: $800f705b9f73a72d$var$getRealHeight,
        onLeaveStart: $800f705b9f73a72d$var$getCurrentHeight,
        onLeaveActive: $800f705b9f73a72d$var$getCollapsedHeight,
        onAppearEnd: $800f705b9f73a72d$var$skipOpacityTransition,
        onEnterEnd: $800f705b9f73a72d$var$skipOpacityTransition,
        onLeaveEnd: $800f705b9f73a72d$var$skipOpacityTransition,
        motionDeadline: 500
    };
};
var $800f705b9f73a72d$var$SelectPlacements = [
    "bottomLeft",
    "bottomRight",
    "topLeft",
    "topRight"
];
var $800f705b9f73a72d$export$27c72201b1d09951 = function(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $800f705b9f73a72d$export$2e2bcd8739ae039 = $800f705b9f73a72d$var$initCollapseMotion;







var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");


"use client";
function $2023049436a0b213$var$isThenable(thing) {
    return !!(thing && thing.then);
}
var $2023049436a0b213$var$ActionButton = function(props) {
    var type = props.type, children = props.children, prefixCls = props.prefixCls, buttonProps = props.buttonProps, close = props.close, autoFocus = props.autoFocus, emitEvent = props.emitEvent, isSilent = props.isSilent, quitOnNullishReturnValue = props.quitOnNullishReturnValue, actionFn = props.actionFn;
    var clickedRef = $8SyCD.useRef(false);
    var buttonRef = $8SyCD.useRef(null);
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $2fb61ecc178138e6$export$2e2bcd8739ae039)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var onInternalClose = function onInternalClose() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $8SyCD.useEffect(function() {
        var timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(function() {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
        });
        return function() {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    var handlePromiseOnOk = function(returnValueOfOnOk) {
        if (!$2023049436a0b213$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, function(e) {
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    var onClick = function(e) {
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        var returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$2023049436a0b213$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), Object.assign({}, (0, $32812387acf2752d$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $2023049436a0b213$export$2e2bcd8739ae039 = $2023049436a0b213$var$ActionButton;



var $8SyCD = parcelRequire("8SyCD");
var $8e8c617946070343$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext({});
var $8e8c617946070343$export$7c9538f5f3c365e9 = $8e8c617946070343$export$ab57792b9b6974a6.Provider;


"use client";
var $c3ee1ecdaca16ad1$var$ConfirmCancelBtn = function() {
    var _useContext = (0, $8SyCD.useContext)((0, $8e8c617946070343$export$ab57792b9b6974a6)), autoFocusButton = _useContext.autoFocusButton, cancelButtonProps = _useContext.cancelButtonProps, cancelTextLocale = _useContext.cancelTextLocale, isSilent = _useContext.isSilent, mergedOkCancel = _useContext.mergedOkCancel, rootPrefixCls = _useContext.rootPrefixCls, close = _useContext.close, onCancel = _useContext.onCancel, onConfirm = _useContext.onConfirm;
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $2023049436a0b213$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: function close1() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === "cancel",
        buttonProps: cancelButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, cancelTextLocale) : null;
};
var $c3ee1ecdaca16ad1$export$2e2bcd8739ae039 = $c3ee1ecdaca16ad1$var$ConfirmCancelBtn;



var $8SyCD = parcelRequire("8SyCD");


"use client";
var $556e7bd312921c72$var$ConfirmOkBtn = function() {
    var _useContext = (0, $8SyCD.useContext)((0, $8e8c617946070343$export$ab57792b9b6974a6)), autoFocusButton = _useContext.autoFocusButton, close = _useContext.close, isSilent = _useContext.isSilent, okButtonProps = _useContext.okButtonProps, rootPrefixCls = _useContext.rootPrefixCls, okTextLocale = _useContext.okTextLocale, okType = _useContext.okType, onConfirm = _useContext.onConfirm, onOk = _useContext.onOk;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $2023049436a0b213$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || "primary",
        actionFn: onOk,
        close: function close1() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === "ok",
        buttonProps: okButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, okTextLocale);
};
var $556e7bd312921c72$export$2e2bcd8739ae039 = $556e7bd312921c72$var$ConfirmOkBtn;






var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $7fdb7d7564da2ae1$var$CloseOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            "fill-rule": "evenodd",
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    name: "close",
    theme: "outlined"
};
var $7fdb7d7564da2ae1$export$2e2bcd8739ae039 = $7fdb7d7564da2ae1$var$CloseOutlined;



var $12df9fef8659bd8e$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $7fdb7d7564da2ae1$export$2e2bcd8739ae039)
    }));
};
var $12df9fef8659bd8e$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($12df9fef8659bd8e$var$CloseOutlined);







var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");
var $a8f3e00749020c05$var$OrderContext = /*#__PURE__*/ $8SyCD.createContext(null);
var $a8f3e00749020c05$export$2e2bcd8739ae039 = $a8f3e00749020c05$var$OrderContext;





var $8SyCD = parcelRequire("8SyCD");



var $c49359cbde3b95f6$var$EMPTY_LIST = [];
function $c49359cbde3b95f6$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $8SyCD.useState(function() {
        if (!(0, $014625af273be671$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement("div");
        return defaultEle;
    }), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $8SyCD.useRef(false);
    var queueCreate = $8SyCD.useContext((0, $a8f3e00749020c05$export$2e2bcd8739ae039));
    var _React$useState3 = $8SyCD.useState($c49359cbde3b95f6$var$EMPTY_LIST), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($c49359cbde3b95f6$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $8SyCD = parcelRequire("8SyCD");


/* eslint-disable no-param-reassign */ var $c596a707f88dd831$var$cached;
function $c596a707f88dd831$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $c596a707f88dd831$var$cached === undefined) {
        var inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.height = "200px";
        var outer = document.createElement("div");
        var outerStyle = outer.style;
        outerStyle.position = "absolute";
        outerStyle.top = "0";
        outerStyle.left = "0";
        outerStyle.pointerEvents = "none";
        outerStyle.visibility = "hidden";
        outerStyle.width = "200px";
        outerStyle.height = "150px";
        outerStyle.overflow = "hidden";
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthContained = inner.offsetWidth;
        outer.style.overflow = "scroll";
        var widthScroll = inner.offsetWidth;
        if (widthContained === widthScroll) widthScroll = outer.clientWidth;
        document.body.removeChild(outer);
        $c596a707f88dd831$var$cached = widthContained - widthScroll;
    }
    return $c596a707f88dd831$var$cached;
}
function $c596a707f88dd831$var$ensureSize(str) {
    var match = str.match(/^(.*)px$/);
    var value = Number(match === null || match === void 0 ? void 0 : match[1]);
    return Number.isNaN(value) ? $c596a707f88dd831$export$2e2bcd8739ae039() : value;
}
function $c596a707f88dd831$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    var _getComputedStyle = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle.width, height = _getComputedStyle.height;
    return {
        width: $c596a707f88dd831$var$ensureSize(width),
        height: $c596a707f88dd831$var$ensureSize(height)
    };
}


/**
 * Test usage export. Do not use in your production
 */ function $53dfb2dc58792972$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $6389577234b5e764$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $6389577234b5e764$var$uuid = 0;
function $6389577234b5e764$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $8SyCD.useState(function() {
        $6389577234b5e764$var$uuid += 1;
        return "".concat($6389577234b5e764$var$UNIQUE_ID, "_").concat($6389577234b5e764$var$uuid);
    }), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $c596a707f88dd831$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $53dfb2dc58792972$export$31b5c8f1131a3a52)();
            (0, $0c499bcbbdb3e2de$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
        } else (0, $0c499bcbbdb3e2de$export$2232e336aecaa80a)(id);
        return function() {
            (0, $0c499bcbbdb3e2de$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $cb9f666fc48c4c1b$export$18c8ad048e32c7d5 = false;
function $cb9f666fc48c4c1b$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $cb9f666fc48c4c1b$export$18c8ad048e32c7d5 = nextInline;
    return $cb9f666fc48c4c1b$export$18c8ad048e32c7d5;
}


var $1d6ed70505755866$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $014625af273be671$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
var $1d6ed70505755866$var$Portal = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $8SyCD.useState(open), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $8SyCD.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $8SyCD.useState(function() {
        return $1d6ed70505755866$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $8SyCD.useEffect(function() {
        var customizeContainer = $1d6ed70505755866$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $c49359cbde3b95f6$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $6389577234b5e764$export$2e2bcd8739ae039)(autoLock && open && (0, $014625af273be671$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $014625af273be671$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $cb9f666fc48c4c1b$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $8SyCD.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $8SyCD.createElement((0, $a8f3e00749020c05$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $b4e4ce7bd3c993b9$exports.createPortal)(reffedChildren, mergedContainer));
});
var $1d6ed70505755866$export$2e2bcd8739ae039 = $1d6ed70505755866$var$Portal;



var $5691ab22d5134673$export$2e2bcd8739ae039 = (0, $1d6ed70505755866$export$2e2bcd8739ae039);



var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
var $e6400b01f57c83f6$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $8SyCD.createContext({});










var $8SyCD = parcelRequire("8SyCD");
function $1641fb35059f12b8$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, $8SyCD);
    return fullClone.useId;
}
var $1641fb35059f12b8$var$uuid = 0;
function $1641fb35059f12b8$export$2f0435a662835942() {}
var $1641fb35059f12b8$var$useOriginId = $1641fb35059f12b8$var$getUseId();
var $1641fb35059f12b8$export$2e2bcd8739ae039 = $1641fb35059f12b8$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $1641fb35059f12b8$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $8SyCD.useState("ssr-id"), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $8SyCD.useEffect(function() {
        var nextId = $1641fb35059f12b8$var$uuid;
        $1641fb35059f12b8$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};


/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $5ebc594569656f88$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $5ebc594569656f88$var$KeyCode.F1 && keyCode <= $5ebc594569656f88$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $5ebc594569656f88$var$KeyCode.ALT:
            case $5ebc594569656f88$var$KeyCode.CAPS_LOCK:
            case $5ebc594569656f88$var$KeyCode.CONTEXT_MENU:
            case $5ebc594569656f88$var$KeyCode.CTRL:
            case $5ebc594569656f88$var$KeyCode.DOWN:
            case $5ebc594569656f88$var$KeyCode.END:
            case $5ebc594569656f88$var$KeyCode.ESC:
            case $5ebc594569656f88$var$KeyCode.HOME:
            case $5ebc594569656f88$var$KeyCode.INSERT:
            case $5ebc594569656f88$var$KeyCode.LEFT:
            case $5ebc594569656f88$var$KeyCode.MAC_FF_META:
            case $5ebc594569656f88$var$KeyCode.META:
            case $5ebc594569656f88$var$KeyCode.NUMLOCK:
            case $5ebc594569656f88$var$KeyCode.NUM_CENTER:
            case $5ebc594569656f88$var$KeyCode.PAGE_DOWN:
            case $5ebc594569656f88$var$KeyCode.PAGE_UP:
            case $5ebc594569656f88$var$KeyCode.PAUSE:
            case $5ebc594569656f88$var$KeyCode.PRINT_SCREEN:
            case $5ebc594569656f88$var$KeyCode.RIGHT:
            case $5ebc594569656f88$var$KeyCode.SHIFT:
            case $5ebc594569656f88$var$KeyCode.UP:
            case $5ebc594569656f88$var$KeyCode.WIN_KEY:
            case $5ebc594569656f88$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $5ebc594569656f88$var$KeyCode.ZERO && keyCode <= $5ebc594569656f88$var$KeyCode.NINE) return true;
        if (keyCode >= $5ebc594569656f88$var$KeyCode.NUM_ZERO && keyCode <= $5ebc594569656f88$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $5ebc594569656f88$var$KeyCode.A && keyCode <= $5ebc594569656f88$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $5ebc594569656f88$var$KeyCode.SPACE:
            case $5ebc594569656f88$var$KeyCode.QUESTION_MARK:
            case $5ebc594569656f88$var$KeyCode.NUM_PLUS:
            case $5ebc594569656f88$var$KeyCode.NUM_MINUS:
            case $5ebc594569656f88$var$KeyCode.NUM_PERIOD:
            case $5ebc594569656f88$var$KeyCode.NUM_DIVISION:
            case $5ebc594569656f88$var$KeyCode.SEMICOLON:
            case $5ebc594569656f88$var$KeyCode.DASH:
            case $5ebc594569656f88$var$KeyCode.EQUALS:
            case $5ebc594569656f88$var$KeyCode.COMMA:
            case $5ebc594569656f88$var$KeyCode.PERIOD:
            case $5ebc594569656f88$var$KeyCode.SLASH:
            case $5ebc594569656f88$var$KeyCode.APOSTROPHE:
            case $5ebc594569656f88$var$KeyCode.SINGLE_QUOTE:
            case $5ebc594569656f88$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $5ebc594569656f88$var$KeyCode.BACKSLASH:
            case $5ebc594569656f88$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $5ebc594569656f88$export$2e2bcd8739ae039 = $5ebc594569656f88$var$KeyCode;



var $71d39879295f84b9$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $71d39879295f84b9$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $71d39879295f84b9$var$propList = "".concat($71d39879295f84b9$var$attributes, " ").concat($71d39879295f84b9$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $71d39879295f84b9$var$ariaPrefix = "aria-";
var $71d39879295f84b9$var$dataPrefix = "data-";
function $71d39879295f84b9$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $71d39879295f84b9$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === "role" || $71d39879295f84b9$var$match(key, $71d39879295f84b9$var$ariaPrefix)) || // Data
        mergedConfig.data && $71d39879295f84b9$var$match(key, $71d39879295f84b9$var$dataPrefix) || // Attr
        mergedConfig.attr && $71d39879295f84b9$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}



var $8SyCD = parcelRequire("8SyCD");
// =============================== Motion ===============================
function $a3c5ec372899acf0$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $a3c5ec372899acf0$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== "number") ret = d.body[method];
    }
    return ret;
}
function $a3c5ec372899acf0$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $a3c5ec372899acf0$var$getScroll(w);
    pos.top += $a3c5ec372899acf0$var$getScroll(w, true);
    return pos;
}






var $8SyCD = parcelRequire("8SyCD");








var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
var $cf19e240d70aa833$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});


var $860f2df304365c79$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: "hidden",
    outline: "none"
};
var $860f2df304365c79$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $e6400b01f57c83f6$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(holderRef, panelRef);
    var sentinelStartRef = (0, $8SyCD.useRef)();
    var sentinelEndRef = (0, $8SyCD.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus();
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus();
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus();
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode;
    if (footer) footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer);
    var headerNode;
    if (title) headerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title));
    var closer;
    if (closable) closer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }));
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closer, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $860f2df304365c79$var$sentinelStyle,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $cf19e240d70aa833$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $860f2df304365c79$var$sentinelStyle,
        "aria-hidden": "true"
    }));
});
var $860f2df304365c79$export$2e2bcd8739ae039 = $860f2df304365c79$var$Panel;


var $4003a3a439fa7cde$var$Content = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $8SyCD.useRef)();
    // ============================= Style ==============================
    var _React$useState = $8SyCD.useState(), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $a3c5ec372899acf0$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $8SyCD.createElement((0, $860f2df304365c79$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, motionClassName)
        }));
    });
});
$4003a3a439fa7cde$var$Content.displayName = "Content";
var $4003a3a439fa7cde$export$2e2bcd8739ae039 = $4003a3a439fa7cde$var$Content;





var $8SyCD = parcelRequire("8SyCD");


function $3b64ace0f534f216$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            ref: ref,
            style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
}



function $74f13b9e94b9ab0c$export$2e2bcd8739ae039(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    var lastOutSideActiveElementRef = (0, $8SyCD.useRef)();
    var wrapperRef = (0, $8SyCD.useRef)();
    var contentRef = (0, $8SyCD.useRef)();
    var _React$useState = $8SyCD.useState(visible), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $1641fb35059f12b8$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $2cd98a4abf51dc5f$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $2cd98a4abf51dc5f$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $8SyCD.useRef)(false);
    var contentTimeoutRef = (0, $8SyCD.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible) {
            if (e.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
        }
    }
    // ========================= Effect =========================
    (0, $8SyCD.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $8SyCD.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    // ========================= Render =========================
    return /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $71d39879295f84b9$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $8SyCD.createElement((0, $3b64ace0f534f216$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $a3c5ec372899acf0$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
            display: !animatedVisible ? "none" : null
        })
    }, wrapProps), /*#__PURE__*/ $8SyCD.createElement((0, $4003a3a439fa7cde$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $a3c5ec372899acf0$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
}


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $afd35dc56bacc3e0$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $8SyCD.useState(visible), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $8SyCD.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $8SyCD.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $8SyCD.createElement((0, $e6400b01f57c83f6$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $5691ab22d5134673$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $8SyCD.createElement((0, $74f13b9e94b9ab0c$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$afd35dc56bacc3e0$var$DialogWrap.displayName = "Dialog";
var $afd35dc56bacc3e0$export$2e2bcd8739ae039 = $afd35dc56bacc3e0$var$DialogWrap;



var $ec5f8ed10e456b66$export$2e2bcd8739ae039 = (0, $afd35dc56bacc3e0$export$2e2bcd8739ae039);




var $8SyCD = parcelRequire("8SyCD");
"use client";
function $67b4ef833bd34470$var$useInnerClosable(closable, closeIcon, defaultClosable) {
    if (typeof closable === "boolean") return closable;
    if (closeIcon === undefined) return !!defaultClosable;
    return closeIcon !== false && closeIcon !== null;
}
function $67b4ef833bd34470$export$2e2bcd8739ae039(closable, closeIcon, customCloseIconRender) {
    var defaultCloseIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), null);
    var defaultClosable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var mergedClosable = $67b4ef833bd34470$var$useInnerClosable(closable, closeIcon, defaultClosable);
    if (!mergedClosable) return [
        false,
        null
    ];
    var mergedCloseIcon = typeof closeIcon === "boolean" || closeIcon === undefined || closeIcon === null ? defaultCloseIcon : closeIcon;
    return [
        true,
        customCloseIconRender ? customCloseIconRender(mergedCloseIcon) : mergedCloseIcon
    ];
}





var $e41b292bbd40113e$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $014625af273be671$export$2e2bcd8739ae039)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $e41b292bbd40113e$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$e41b292bbd40113e$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement("div");
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $e41b292bbd40113e$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $e41b292bbd40113e$var$isStyleValueSupport(styleName, styleValue);
    return $e41b292bbd40113e$var$isStyleNameSupport(styleName);
}


var $031d4d43453b841c$export$7dbdadf5e9653129 = function() {
    return (0, $014625af273be671$export$2e2bcd8739ae039)() && window.document.documentElement;
};









var $8SyCD = parcelRequire("8SyCD");
function $8106f3c71ac77019$var$voidFunc() {}
var $8106f3c71ac77019$var$WatermarkContext = /*#__PURE__*/ $8SyCD.createContext({
    add: $8106f3c71ac77019$var$voidFunc,
    remove: $8106f3c71ac77019$var$voidFunc
});
function $8106f3c71ac77019$export$94ab53417567be34(panelSelector) {
    var watermark = $8SyCD.useContext($8106f3c71ac77019$var$WatermarkContext);
    var panelEleRef = $8SyCD.useRef();
    var panelRef = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(ele) {
        if (ele) {
            var innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            watermark.add(innerContentEle);
            panelEleRef.current = innerContentEle;
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $8106f3c71ac77019$export$2e2bcd8739ae039 = $8106f3c71ac77019$var$WatermarkContext;





var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");


"use client";
var $e965ec98e163fbf9$var$NormalCancelBtn = function() {
    var _useContext = (0, $8SyCD.useContext)((0, $8e8c617946070343$export$ab57792b9b6974a6)), cancelButtonProps = _useContext.cancelButtonProps, cancelTextLocale = _useContext.cancelTextLocale, onCancel = _useContext.onCancel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $e965ec98e163fbf9$export$2e2bcd8739ae039 = $e965ec98e163fbf9$var$NormalCancelBtn;



var $8SyCD = parcelRequire("8SyCD");



"use client";
var $4f3b47e15499449e$var$NormalOkBtn = function() {
    var _useContext = (0, $8SyCD.useContext)((0, $8e8c617946070343$export$ab57792b9b6974a6)), confirmLoading = _useContext.confirmLoading, okButtonProps = _useContext.okButtonProps, okType = _useContext.okType, okTextLocale = _useContext.okTextLocale, onOk = _useContext.onOk;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), Object.assign({}, (0, $32812387acf2752d$export$19bc9a290855952)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $4f3b47e15499449e$export$2e2bcd8739ae039 = $4f3b47e15499449e$var$NormalOkBtn;




"use client";
function $278c6a25861b4be9$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    }));
}
var $278c6a25861b4be9$export$a06f1c675e846f6f = function(props) {
    var okText = props.okText, _props_okType = props.okType, okType = _props_okType === void 0 ? "primary" : _props_okType, cancelText = props.cancelText, confirmLoading = props.confirmLoading, onOk = props.onOk, onCancel = props.onCancel, okButtonProps = props.okButtonProps, cancelButtonProps = props.cancelButtonProps, footer = props.footer;
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Modal", (0, $0e0c8f184d62e3a6$export$1b6004afda18cd51)()), 1), locale = _useLocale[0];
    // ================== Locale Text ==================
    var okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    var cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    // ================= Context Value =================
    var btnCtxValue = {
        confirmLoading: confirmLoading,
        okButtonProps: okButtonProps,
        cancelButtonProps: cancelButtonProps,
        okTextLocale: okTextLocale,
        cancelTextLocale: cancelTextLocale,
        okType: okType,
        onOk: onOk,
        onCancel: onCancel
    };
    var btnCtxValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useMemo(function() {
        return btnCtxValue;
    }, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(Object.values(btnCtxValue)));
    var footerNode;
    if (typeof footer === "function" || typeof footer === "undefined") {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e965ec98e163fbf9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $4f3b47e15499449e$export$2e2bcd8739ae039), null));
        if (typeof footer === "function") footerNode = footer(footerNode, {
            OkBtn: (0, $4f3b47e15499449e$export$2e2bcd8739ae039),
            CancelBtn: (0, $e965ec98e163fbf9$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $8e8c617946070343$export$7c9538f5f3c365e9), {
            value: btnCtxValueMemo
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e0eab3dc6b8ab52c$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};







var $9f4ece306a24a354$var$initMotionCommon = function(duration) {
    return {
        animationDuration: duration,
        animationFillMode: "both"
    };
};
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
var $9f4ece306a24a354$var$initMotionCommonLeave = function(duration) {
    return {
        animationDuration: duration,
        animationFillMode: "both"
    };
};
var $9f4ece306a24a354$export$83e1da9e09ec9112 = function initMotion(motionCls, inKeyframes, outKeyframes, duration) {
    var sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var sameLevelPrefix = sameLevel ? "&" : "";
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n      ".concat(sameLevelPrefix).concat(motionCls, "-enter,\n      ").concat(sameLevelPrefix).concat(motionCls, "-appear\n    "), Object.assign(Object.assign({}, $9f4ece306a24a354$var$initMotionCommon(duration)), {
        animationPlayState: "paused"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(sameLevelPrefix).concat(motionCls, "-leave"), Object.assign(Object.assign({}, $9f4ece306a24a354$var$initMotionCommonLeave(duration)), {
        animationPlayState: "paused"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n      ".concat(sameLevelPrefix).concat(motionCls, "-enter").concat(motionCls, "-enter-active,\n      ").concat(sameLevelPrefix).concat(motionCls, "-appear").concat(motionCls, "-appear-active\n    "), {
        animationName: inKeyframes,
        animationPlayState: "running"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(sameLevelPrefix).concat(motionCls, "-leave").concat(motionCls, "-leave-active"), {
        animationName: outKeyframes,
        animationPlayState: "running",
        pointerEvents: "none"
    }), _obj;
};


var $cd9156ef7860aebf$export$82e6205b15e6c637 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antFadeIn", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
var $cd9156ef7860aebf$export$c091916f1530334c = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antFadeOut", {
    "0%": {
        opacity: 1
    },
    "100%": {
        opacity: 0
    }
});
var $cd9156ef7860aebf$export$2909268c8354a12 = function initFadeMotion(token) {
    var sameLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var antCls = token.antCls;
    var motionCls = "".concat(antCls, "-fade");
    var sameLevelPrefix = sameLevel ? "&" : "";
    var _obj;
    return [
        (0, $9f4ece306a24a354$export$83e1da9e09ec9112)(motionCls, $cd9156ef7860aebf$export$82e6205b15e6c637, $cd9156ef7860aebf$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n        ".concat(sameLevelPrefix).concat(motionCls, "-enter,\n        ").concat(sameLevelPrefix).concat(motionCls, "-appear\n      "), {
            opacity: 0,
            animationTimingFunction: "linear"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(sameLevelPrefix).concat(motionCls, "-leave"), {
            animationTimingFunction: "linear"
        }), _obj)
    ];
};




var $41928187f0cc1a97$export$3b71758b3ed5255f = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomIn", {
    "0%": {
        transform: "scale(0.2)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
var $41928187f0cc1a97$export$9fdb0a49c6b4b521 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.2)",
        opacity: 0
    }
});
var $41928187f0cc1a97$export$be061d573c42e33a = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomBigIn", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
var $41928187f0cc1a97$export$582d93d613303da3 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomBigOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.8)",
        opacity: 0
    }
});
var $41928187f0cc1a97$export$45eddd18c599b827 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomUpIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    }
});
var $41928187f0cc1a97$export$a85c97750adaa37a = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomUpOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    }
});
var $41928187f0cc1a97$export$bd2378f7814f5f1a = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomLeftIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    }
});
var $41928187f0cc1a97$export$e58f88c751c4f04e = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomLeftOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    }
});
var $41928187f0cc1a97$export$fee1456954aef331 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomRightIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    }
});
var $41928187f0cc1a97$export$811ba6d3e2adb730 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomRightOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    }
});
var $41928187f0cc1a97$export$633a68aa72dec21c = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomDownIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    }
});
var $41928187f0cc1a97$export$1cf46a906e8dede4 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antZoomDownOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    }
});
var $41928187f0cc1a97$var$zoomMotion = {
    zoom: {
        inKeyframes: $41928187f0cc1a97$export$3b71758b3ed5255f,
        outKeyframes: $41928187f0cc1a97$export$9fdb0a49c6b4b521
    },
    "zoom-big": {
        inKeyframes: $41928187f0cc1a97$export$be061d573c42e33a,
        outKeyframes: $41928187f0cc1a97$export$582d93d613303da3
    },
    "zoom-big-fast": {
        inKeyframes: $41928187f0cc1a97$export$be061d573c42e33a,
        outKeyframes: $41928187f0cc1a97$export$582d93d613303da3
    },
    "zoom-left": {
        inKeyframes: $41928187f0cc1a97$export$bd2378f7814f5f1a,
        outKeyframes: $41928187f0cc1a97$export$e58f88c751c4f04e
    },
    "zoom-right": {
        inKeyframes: $41928187f0cc1a97$export$fee1456954aef331,
        outKeyframes: $41928187f0cc1a97$export$811ba6d3e2adb730
    },
    "zoom-up": {
        inKeyframes: $41928187f0cc1a97$export$45eddd18c599b827,
        outKeyframes: $41928187f0cc1a97$export$a85c97750adaa37a
    },
    "zoom-down": {
        inKeyframes: $41928187f0cc1a97$export$633a68aa72dec21c,
        outKeyframes: $41928187f0cc1a97$export$1cf46a906e8dede4
    }
};
var $41928187f0cc1a97$export$f5d123412490d9dc = function(token, motionName) {
    var antCls = token.antCls;
    var motionCls = "".concat(antCls, "-").concat(motionName);
    var _zoomMotion_motionName = $41928187f0cc1a97$var$zoomMotion[motionName], inKeyframes = _zoomMotion_motionName.inKeyframes, outKeyframes = _zoomMotion_motionName.outKeyframes;
    var _obj;
    return [
        (0, $9f4ece306a24a354$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token.motionDurationFast : token.motionDurationMid),
        (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n        ".concat(motionCls, "-enter,\n        ").concat(motionCls, "-appear\n      "), {
            transform: "scale(0)",
            opacity: 0,
            animationTimingFunction: token.motionEaseOutCirc,
            "&-prepare": {
                transform: "none"
            }
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(motionCls, "-leave"), {
            animationTimingFunction: token.motionEaseInOutCirc
        }), _obj)
    ];
};




"use client";
function $2f51c20c70597473$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
var $2f51c20c70597473$export$8bb6dada04673ddd = function(token) {
    var componentCls = token.componentCls, antCls = token.antCls;
    var _obj;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-root"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls).concat(antCls, "-zoom-enter, ").concat(componentCls).concat(antCls, "-zoom-appear"), {
            // reset scale avoid mousePosition bug
            transform: "none",
            opacity: 0,
            animationDuration: token.motionDurationSlow,
            // https://github.com/ant-design/ant-design/issues/11777
            userSelect: "none"
        }), // https://github.com/ant-design/ant-design/issues/37329
        // https://github.com/ant-design/ant-design/issues/40272
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls).concat(antCls, "-zoom-leave ").concat(componentCls, "-content"), {
            pointerEvents: "none"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-mask"), Object.assign(Object.assign({}, $2f51c20c70597473$var$box("fixed")), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            zIndex: token.zIndexPopupBase,
            height: "100%",
            backgroundColor: token.colorBgMask,
            pointerEvents: "none"
        }, "".concat(componentCls, "-hidden"), {
            display: "none"
        }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-wrap"), Object.assign(Object.assign({}, $2f51c20c70597473$var$box("fixed")), // Note: Firefox not support `:has` yet
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            zIndex: token.zIndexPopupBase,
            overflow: "auto",
            outline: 0,
            WebkitOverflowScrolling: "touch"
        }, "&:has(".concat(componentCls).concat(antCls, "-zoom-enter), &:has(").concat(componentCls).concat(antCls, "-zoom-appear)"), {
            pointerEvents: "none"
        }))), _obj)),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-root"), (0, $cd9156ef7860aebf$export$2909268c8354a12)(token))
    ];
};
var $2f51c20c70597473$var$genModalStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1, _obj2, _obj3;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-root"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-wrap-rtl"), {
            direction: "rtl"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-centered"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            textAlign: "center",
            "&::before": {
                display: "inline-block",
                width: 0,
                height: "100%",
                verticalAlign: "middle",
                content: '""'
            }
        }, componentCls, {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "@media (max-width: ".concat(token.screenSMMax, "px)"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, componentCls, {
            maxWidth: "calc(100vw - 16px)",
            margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginXS), " auto")
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-centered"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
            flex: 1
        })), _obj)), _obj1)),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj2 = {
            pointerEvents: "none",
            position: "relative",
            top: 100,
            width: "auto",
            maxWidth: "calc(100vw - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal()), ")"),
            margin: "0 auto",
            paddingBottom: token.paddingLG
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-title"), {
            margin: 0,
            color: token.titleColor,
            fontWeight: token.fontWeightStrong,
            fontSize: token.titleFontSize,
            lineHeight: token.titleLineHeight,
            wordWrap: "break-word"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-content"), {
            position: "relative",
            backgroundColor: token.contentBg,
            backgroundClip: "padding-box",
            border: 0,
            borderRadius: token.borderRadiusLG,
            boxShadow: token.boxShadow,
            pointerEvents: "auto",
            padding: token.contentPadding
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-close"), Object.assign({
            position: "absolute",
            top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
            insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
            zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
            padding: 0,
            color: token.modalCloseIconColor,
            fontWeight: token.fontWeightStrong,
            lineHeight: 1,
            textDecoration: "none",
            background: "transparent",
            borderRadius: token.borderRadiusSM,
            width: token.modalCloseBtnSize,
            height: token.modalCloseBtnSize,
            border: 0,
            outline: 0,
            cursor: "pointer",
            transition: "color ".concat(token.motionDurationMid, ", background-color ").concat(token.motionDurationMid),
            "&-x": {
                display: "flex",
                fontSize: token.fontSizeLG,
                fontStyle: "normal",
                lineHeight: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.modalCloseBtnSize)),
                justifyContent: "center",
                textTransform: "none",
                textRendering: "auto"
            },
            "&:hover": {
                color: token.modalIconHoverColor,
                backgroundColor: token.closeBtnHoverBg,
                textDecoration: "none"
            },
            "&:active": {
                backgroundColor: token.closeBtnActiveBg
            }
        }, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-header"), {
            color: token.colorText,
            background: token.headerBg,
            borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0"),
            marginBottom: token.headerMarginBottom,
            padding: token.headerPadding,
            borderBottom: token.headerBorderBottom
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-body"), {
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            wordWrap: "break-word",
            padding: token.bodyPadding
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-footer"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            textAlign: "end",
            background: token.footerBg,
            marginTop: token.footerMarginTop,
            padding: token.footerPadding,
            borderTop: token.footerBorderTop,
            borderRadius: token.footerBorderRadius
        }, "".concat(token.antCls, "-btn + ").concat(token.antCls, "-btn:not(").concat(token.antCls, "-dropdown-trigger)"), {
            marginBottom: 0,
            marginInlineStart: token.marginXS
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-open"), {
            overflow: "hidden"
        }), _obj2))),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-pure-panel"), (_obj3 = {
            top: "auto",
            padding: 0,
            display: "flex",
            flexDirection: "column"
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-content,\n          ").concat(componentCls, "-body,\n          ").concat(componentCls, "-confirm-body-wrapper"), {
            display: "flex",
            flexDirection: "column",
            flex: "auto"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-confirm-body"), {
            marginBottom: "auto"
        }), _obj3))
    ];
};
var $2f51c20c70597473$var$genRTLStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-root"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-wrap-rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        direction: "rtl"
    }, "".concat(componentCls, "-confirm-body"), {
        direction: "rtl"
    })));
};
var $2f51c20c70597473$export$362fb92a8f81bbf9 = function(token) {
    var headerPaddingVertical = token.padding;
    var headerFontSize = token.fontSizeHeading5;
    var headerLineHeight = token.lineHeightHeading5;
    var modalToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalIconHoverColor: token.colorIconHover,
        modalCloseIconColor: token.colorIcon,
        modalCloseBtnSize: token.fontHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
var $2f51c20c70597473$export$9ca1be8807fe0675 = function(token) {
    return {
        footerBg: "transparent",
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        closeBtnHoverBg: token.wireframe ? "transparent" : token.colorFillContent,
        closeBtnActiveBg: token.wireframe ? "transparent" : token.colorFillContentHover,
        contentPadding: token.wireframe ? 0 : "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingMD), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentHorizontalLG)),
        headerPadding: token.wireframe ? "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.padding), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingLG)) : 0,
        headerBorderBottom: token.wireframe ? "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit) : "none",
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingXS), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.padding)) : 0,
        footerBorderTop: token.wireframe ? "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit) : "none",
        footerBorderRadius: token.wireframe ? "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG)) : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.padding * 2), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.padding * 2), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingLG)) : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    };
};
var $2f51c20c70597473$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Modal", function(token) {
    var modalToken = $2f51c20c70597473$export$362fb92a8f81bbf9(token);
    return [
        $2f51c20c70597473$var$genModalStyle(modalToken),
        $2f51c20c70597473$var$genRTLStyle(modalToken),
        $2f51c20c70597473$export$8bb6dada04673ddd(modalToken),
        (0, $41928187f0cc1a97$export$f5d123412490d9dc)(modalToken, "zoom")
    ];
}, $2f51c20c70597473$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});




"use client";
var $ebf1bd882cc0cd41$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ebf1bd882cc0cd41$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
var $ebf1bd882cc0cd41$var$getClickPosition = function(e) {
    $ebf1bd882cc0cd41$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(function() {
        $ebf1bd882cc0cd41$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $031d4d43453b841c$export$7dbdadf5e9653129)()) document.documentElement.addEventListener("click", $ebf1bd882cc0cd41$var$getClickPosition, true);
var $ebf1bd882cc0cd41$var$Modal = function(props) {
    var _a;
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React_useContext.getPopupContainer, getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, modal = _React_useContext.modal;
    var handleCancel = function(e) {
        var onCancel = props.onCancel;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    var handleOk = function(e) {
        var onOk = props.onOk;
        onOk === null || onOk === void 0 || onOk(e);
    };
    var _ref;
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, open = props.open, wrapClassName = props.wrapClassName, centered = props.centered, getContainer = props.getContainer, closeIcon = props.closeIcon, closable = props.closable, _props_focusTriggerAfterClose = props.focusTriggerAfterClose, focusTriggerAfterClose = _props_focusTriggerAfterClose === void 0 ? true : _props_focusTriggerAfterClose, style = props.style, // Deprecated
    visible = props.visible, _props_width = props.width, width = _props_width === void 0 ? 520 : _props_width, footer = props.footer, modalClassNames = props.classNames, modalStyles = props.styles, restProps = $ebf1bd882cc0cd41$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "closeIcon",
        "closable",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles"
    ]);
    var prefixCls = getPrefixCls("modal", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    // Style
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $2f51c20c70597473$export$2e2bcd8739ae039)(prefixCls, rootCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj;
    var wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(wrapClassName, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-centered"), !!centered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-wrap-rtl"), direction === "rtl"), _obj));
    var dialogFooter = footer !== null && /*#__PURE__*/ $8SyCD.createElement((0, $278c6a25861b4be9$export$a06f1c675e846f6f), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    }));
    var _useClosable = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $67b4ef833bd34470$export$2e2bcd8739ae039)(closable, closeIcon, function(icon) {
        return (0, $278c6a25861b4be9$export$97c34646962d356e)(prefixCls, icon);
    }, /*#__PURE__*/ $8SyCD.createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    }), true), 2), mergedClosable = _useClosable[0], mergedCloseIcon = _useClosable[1];
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    var panelRef = (0, $8106f3c71ac77019$export$94ab53417567be34)(".".concat(prefixCls, "-content"));
    // ============================ zIndex ============================
    var _useZIndex = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4d9cc5bfe7391b56$export$3e7906d4075187a4)("Modal", restProps.zIndex), 2), zIndex = _useZIndex[0], contextZIndex = _useZIndex[1];
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, /*#__PURE__*/ $8SyCD.createElement((0, $1618288003dd675a$export$80e4c53cb85dcab1), {
        status: true,
        override: true
    }, /*#__PURE__*/ $8SyCD.createElement((0, $7aa43d76a03d0c4e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $8SyCD.createElement((0, $ec5f8ed10e456b66$export$2e2bcd8739ae039), Object.assign({
        width: width
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, rootClassName, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $ebf1bd882cc0cd41$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls, "zoom", props.transitionName),
        maskTransitionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls, "fade", props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, className, modal === null || modal === void 0 ? void 0 : modal.className),
        style: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.style), style),
        classNames: Object.assign(Object.assign({
            wrapper: wrapClassNameExtended
        }, modal === null || modal === void 0 ? void 0 : modal.classNames), modalClassNames),
        styles: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.styles), modalStyles),
        panelRef: panelRef
    }))))));
};
var $ebf1bd882cc0cd41$export$2e2bcd8739ae039 = $ebf1bd882cc0cd41$var$Modal;







"use client";
// ============================= Confirm ==============================
var $52395666d77c4736$var$genModalConfirmStyle = function(token) {
    var componentCls = token.componentCls, titleFontSize = token.titleFontSize, titleLineHeight = token.titleLineHeight, modalConfirmIconSize = token.modalConfirmIconSize, fontSize = token.fontSize, lineHeight = token.lineHeight, modalTitleHeight = token.modalTitleHeight, fontHeight = token.fontHeight, confirmBodyPadding = token.confirmBodyPadding;
    var confirmComponentCls = "".concat(componentCls, "-confirm");
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, confirmComponentCls, (_obj1 = {
        "&-rtl": {
            direction: "rtl"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(token.antCls, "-modal-header"), {
        display: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-body-wrapper"), Object.assign({}, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)())), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, " ").concat(componentCls, "-body"), {
        padding: confirmBodyPadding
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-body"), (_obj = {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(token.iconCls), {
        flex: "none",
        fontSize: modalConfirmIconSize,
        marginInlineEnd: token.confirmIconMarginInlineEnd,
        marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-has-title > ".concat(token.iconCls), {
        marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-paragraph"), {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: token.marginXS,
        maxWidth: "calc(100% - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal()), ")")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-title"), {
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: titleFontSize,
        lineHeight: titleLineHeight
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-content"), {
        color: token.colorText,
        fontSize: fontSize,
        lineHeight: lineHeight
    }), // ===================== Footer =====================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(confirmComponentCls, "-btns"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        textAlign: "end",
        marginTop: token.confirmBtnsMarginTop
    }, "".concat(token.antCls, "-btn + ").concat(token.antCls, "-btn"), {
        marginBottom: 0,
        marginInlineStart: token.marginXS
    })), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(confirmComponentCls, "-error ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
        color: token.colorError
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(confirmComponentCls, "-warning ").concat(confirmComponentCls, "-body > ").concat(token.iconCls, ",\n        ").concat(confirmComponentCls, "-confirm ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
        color: token.colorWarning
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(confirmComponentCls, "-info ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
        color: token.colorInfo
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(confirmComponentCls, "-success ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
        color: token.colorSuccess
    }), _obj2;
};
var // ============================== Export ==============================
$52395666d77c4736$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$1537386bc155ea56)([
    "Modal",
    "confirm"
], function(token) {
    var modalToken = (0, $2f51c20c70597473$export$362fb92a8f81bbf9)(token);
    return [
        $52395666d77c4736$var$genModalConfirmStyle(modalToken)
    ];
}, (0, $2f51c20c70597473$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
var $ea86152b5d5d8e68$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ea86152b5d5d8e68$export$78cf841dc2c9f0b5(props) {
    var prefixCls = props.prefixCls, icon = props.icon, okText = props.okText, cancelText = props.cancelText, confirmPrefixCls = props.confirmPrefixCls, type = props.type, okCancel = props.okCancel, footer = props.footer, // Legacy for static function usage
    staticLocale = props.locale, resetProps = $ea86152b5d5d8e68$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    // Icon
    var mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case "info":
            mergedIcon = /*#__PURE__*/ $8SyCD.createElement((0, $dd33a6757a67fbea$export$2e2bcd8739ae039), null);
            break;
        case "success":
            mergedIcon = /*#__PURE__*/ $8SyCD.createElement((0, $fbda717dcf0caf2c$export$2e2bcd8739ae039), null);
            break;
        case "error":
            mergedIcon = /*#__PURE__*/ $8SyCD.createElement((0, $9742a01b0cacbf6e$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $8SyCD.createElement((0, $41514c06cac7a0f0$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    var mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === "confirm";
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || "ok";
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Modal"), 1), locale = _useLocale[0];
    var mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    var okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    var cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    // ================= Context Value =================
    var btnCtxValue = Object.assign({
        autoFocusButton: autoFocusButton,
        cancelTextLocale: cancelTextLocale,
        okTextLocale: okTextLocale,
        mergedOkCancel: mergedOkCancel
    }, resetProps);
    var btnCtxValueMemo = $8SyCD.useMemo(function() {
        return btnCtxValue;
    }, (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(Object.values(btnCtxValue)));
    // ====================== Footer Origin Node ======================
    var footerOriginNode = /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement((0, $c3ee1ecdaca16ad1$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8SyCD.createElement((0, $556e7bd312921c72$export$2e2bcd8739ae039), null));
    var hasTitle = props.title !== undefined && props.title !== null;
    var bodyCls = "".concat(confirmPrefixCls, "-body");
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(confirmPrefixCls, "-body-wrapper")
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(bodyCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(bodyCls, "-has-title"), hasTitle))
    }, mergedIcon, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(confirmPrefixCls, "-paragraph")
    }, hasTitle && /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(confirmPrefixCls, "-title")
    }, props.title), /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(confirmPrefixCls, "-content")
    }, props.content))), footer === undefined || typeof footer === "function" ? /*#__PURE__*/ $8SyCD.createElement((0, $8e8c617946070343$export$7c9538f5f3c365e9), {
        value: btnCtxValueMemo
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(confirmPrefixCls, "-btns")
    }, typeof footer === "function" ? footer(footerOriginNode, {
        OkBtn: (0, $556e7bd312921c72$export$2e2bcd8739ae039),
        CancelBtn: (0, $c3ee1ecdaca16ad1$export$2e2bcd8739ae039)
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $8SyCD.createElement((0, $52395666d77c4736$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
}
var $ea86152b5d5d8e68$var$ConfirmDialog = function(props) {
    var close = props.close, zIndex = props.zIndex, afterClose = props.afterClose, open = props.open, keyboard = props.keyboard, centered = props.centered, getContainer = props.getContainer, maskStyle = props.maskStyle, direction = props.direction, prefixCls = props.prefixCls, wrapClassName = props.wrapClassName, rootPrefixCls = props.rootPrefixCls, bodyStyle = props.bodyStyle, _props_closable = props.closable, closable = _props_closable === void 0 ? false : _props_closable, closeIcon = props.closeIcon, modalRender = props.modalRender, focusTriggerAfterClose = props.focusTriggerAfterClose, onConfirm = props.onConfirm, styles = props.styles;
    var _ref;
    var confirmPrefixCls = "".concat(prefixCls, "-confirm");
    var width = props.width || 416;
    var style = props.style || {};
    var mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(confirmPrefixCls, "".concat(confirmPrefixCls, "-").concat(props.type), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(confirmPrefixCls, "-rtl"), direction === "rtl"), props.className);
    // ========================= zIndex =========================
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var mergedZIndex = $8SyCD.useMemo(function() {
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $4d9cc5bfe7391b56$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $8SyCD.createElement((0, $ebf1bd882cc0cd41$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(confirmPrefixCls, "-centered"), !!props.centered), wrapClassName),
        onCancel: function() {
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        open: open,
        title: "",
        footer: null,
        transitionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls || "", "zoom", props.transitionName),
        maskTransitionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls || "", "fade", props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer,
        closable: closable,
        closeIcon: closeIcon,
        modalRender: modalRender,
        focusTriggerAfterClose: focusTriggerAfterClose
    }, /*#__PURE__*/ $8SyCD.createElement($ea86152b5d5d8e68$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
var $ea86152b5d5d8e68$var$ConfirmDialogWrapper = function(props) {
    var rootPrefixCls = props.rootPrefixCls, iconPrefixCls = props.iconPrefixCls, direction = props.direction, theme = props.theme;
    return /*#__PURE__*/ $8SyCD.createElement((0, $f2caf184cab96719$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $8SyCD.createElement($ea86152b5d5d8e68$var$ConfirmDialog, Object.assign({}, props)));
};
var $ea86152b5d5d8e68$export$2e2bcd8739ae039 = $ea86152b5d5d8e68$var$ConfirmDialogWrapper;


var $1ca3e3a34bf268da$var$destroyFns = [];
var $1ca3e3a34bf268da$export$2e2bcd8739ae039 = $1ca3e3a34bf268da$var$destroyFns;



"use client";
var $b8fd9089a7795ad2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b8fd9089a7795ad2$var$defaultRootPrefixCls = "";
function $b8fd9089a7795ad2$var$getRootPrefixCls() {
    return $b8fd9089a7795ad2$var$defaultRootPrefixCls;
}
function $b8fd9089a7795ad2$export$2e2bcd8739ae039(config) {
    var container = document.createDocumentFragment();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    var currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    var timeoutId;
    function destroy() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (config.onCancel && triggerCancel) config.onCancel.apply(config, [
            function() {}
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(args.slice(1))));
        for(var i = 0; i < (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).length; i++){
            var fn = (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039)[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $68cc2bdb5293678e$export$121e2d597d222bad)(container);
    }
    function render(_a) {
        var okText = _a.okText, cancelText = _a.cancelText, customizePrefixCls = _a.prefixCls, getContainer = _a.getContainer, props = $b8fd9089a7795ad2$var$__rest(_a, [
            "okText",
            "cancelText",
            "prefixCls",
            "getContainer"
        ]);
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(function() {
            var runtimeLocale = (0, $0e0c8f184d62e3a6$export$1b6004afda18cd51)();
            var _globalConfig = (0, $f2caf184cab96719$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls, getTheme = _globalConfig.getTheme;
            // because Modal.config  set rootPrefixCls, which is different from other components
            var rootPrefixCls = getPrefixCls(undefined, $b8fd9089a7795ad2$var$getRootPrefixCls());
            var prefixCls = customizePrefixCls || "".concat(rootPrefixCls, "-modal");
            var iconPrefixCls = getIconPrefixCls();
            var theme = getTheme();
            var mergedGetContainer = getContainer;
            if (mergedGetContainer === false) mergedGetContainer = undefined;
            (0, $68cc2bdb5293678e$export$b3890eb0ae9dca99)(/*#__PURE__*/ $8SyCD.createElement((0, $ea86152b5d5d8e68$export$2e2bcd8739ae039), Object.assign({}, props, {
                getContainer: mergedGetContainer,
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                okText: okText,
                locale: runtimeLocale,
                theme: theme,
                cancelText: cancelText || runtimeLocale.cancelText
            })), container);
        });
    }
    function close() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: function() {
                if (typeof config.afterClose === "function") config.afterClose();
                destroy.apply(_this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === "function") currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $b8fd9089a7795ad2$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: "warning"
    });
}
function $b8fd9089a7795ad2$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: "info"
    });
}
function $b8fd9089a7795ad2$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: "success"
    });
}
function $b8fd9089a7795ad2$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: "error"
    });
}
function $b8fd9089a7795ad2$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: "confirm"
    });
}
function $b8fd9089a7795ad2$export$ff0b30c638ae2396(_ref) {
    var rootPrefixCls = _ref.rootPrefixCls;
    $b8fd9089a7795ad2$var$defaultRootPrefixCls = rootPrefixCls;
}






var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");

"use client";
function $d09d87be952d49db$export$29e2a8c3cdb34b03(Component) {
    return function PureRenderThemeComponent(props) {
        return /*#__PURE__*/ $8SyCD.createElement((0, $f2caf184cab96719$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $8SyCD.createElement(Component, Object.assign({}, props)));
    };
}
function $d09d87be952d49db$export$2e2bcd8739ae039(Component, defaultPrefixCls, getDropdownCls, postProps) {
    function PurePanel(props) {
        var customizePrefixCls = props.prefixCls, style = props.style;
        var holderRef = $8SyCD.useRef(null);
        var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), popupHeight = _React_useState[0], setPopupHeight = _React_useState[1];
        var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), popupWidth = _React_useState1[0], setPopupWidth = _React_useState1[1];
        var _useMergedState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
            value: props.open
        }), 2), open = _useMergedState[0], setOpen = _useMergedState[1];
        var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
        var prefixCls = getPrefixCls(defaultPrefixCls || "select", customizePrefixCls);
        $8SyCD.useEffect(function() {
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== "undefined") {
                var resizeObserver = new ResizeObserver(function(entries) {
                    var element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                var interval = setInterval(function() {
                    var _a;
                    var dropdownCls = getDropdownCls ? ".".concat(getDropdownCls(prefixCls)) : ".".concat(prefixCls, "-dropdown");
                    var popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return function() {
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        var mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: function() {
                return holderRef.current;
            }
        });
        if (postProps) mergedProps = postProps(mergedProps);
        return /*#__PURE__*/ $8SyCD.createElement("div", {
            ref: holderRef,
            style: {
                paddingBottom: popupHeight,
                position: "relative",
                minWidth: popupWidth
            }
        }, /*#__PURE__*/ $8SyCD.createElement(Component, Object.assign({}, mergedProps)));
    }
    return $d09d87be952d49db$export$29e2a8c3cdb34b03(PurePanel);
}







"use client";
var $912c8fc6943d049c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $912c8fc6943d049c$var$PurePanel = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, closeIcon = props.closeIcon, closable = props.closable, type = props.type, title = props.title, children = props.children, footer = props.footer, restProps = $912c8fc6943d049c$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var rootPrefixCls = getPrefixCls();
    var prefixCls = customizePrefixCls || getPrefixCls("modal");
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(rootPrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $2f51c20c70597473$export$2e2bcd8739ae039)(prefixCls, rootCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var confirmPrefixCls = "".concat(prefixCls, "-confirm");
    // Choose target props by confirm mark
    var additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: "",
        footer: "",
        children: /*#__PURE__*/ $8SyCD.createElement((0, $ea86152b5d5d8e68$export$78cf841dc2c9f0b5), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $8SyCD.createElement((0, $278c6a25861b4be9$export$a06f1c675e846f6f), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $860f2df304365c79$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, "".concat(prefixCls, "-pure-panel"), type && confirmPrefixCls, type && "".concat(confirmPrefixCls, "-").concat(type), className, rootCls)
    }, restProps, {
        closeIcon: (0, $278c6a25861b4be9$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $912c8fc6943d049c$export$2e2bcd8739ae039 = (0, $d09d87be952d49db$export$29e2a8c3cdb34b03)($912c8fc6943d049c$var$PurePanel);





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
"use client";
function $4b7855f4062cb96d$export$2e2bcd8739ae039() {
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState([]), 2), elements = _React_useState[0], setElements = _React_useState[1];
    var patchElement = $8SyCD.useCallback(function(element) {
        // append a new element to elements (and create a new ref)
        setElements(function(originElements) {
            return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(originElements), [
                element
            ]);
        });
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return function() {
            setElements(function(originElements) {
                return originElements.filter(function(ele) {
                    return ele !== element;
                });
            });
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}







var $8SyCD = parcelRequire("8SyCD");




"use client";
var $0deaee655cea22af$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0deaee655cea22af$var$HookModal = function(_a, ref) {
    var _b;
    var hookAfterClose = _a.afterClose, config = _a.config, restProps = $0deaee655cea22af$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(true), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(config), 2), innerConfig = _React_useState1[0], setInnerConfig = _React_useState1[1];
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), direction = _React_useContext.direction, getPrefixCls = _React_useContext.getPrefixCls;
    var prefixCls = getPrefixCls("modal");
    var rootPrefixCls = getPrefixCls();
    var afterClose = function() {
        var _$_a;
        hookAfterClose();
        (_$_a = innerConfig.afterClose) === null || _$_a === void 0 || _$_a.call(innerConfig);
    };
    var close = function close() {
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (innerConfig.onCancel && triggerCancel) innerConfig.onCancel.apply(innerConfig, [
            function() {}
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(args.slice(1))));
    };
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            destroy: close,
            update: function(newConfig) {
                setInnerConfig(function(originConfig) {
                    return Object.assign(Object.assign({}, originConfig), newConfig);
                });
            }
        };
    });
    var mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === "confirm";
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Modal", (0, $32f46d71751d4424$export$2e2bcd8739ae039).Modal), 1), contextLocale = _useLocale[0];
    return /*#__PURE__*/ $8SyCD.createElement((0, $ea86152b5d5d8e68$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $0deaee655cea22af$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($0deaee655cea22af$var$HookModal);


"use client";
var $2dfc929e771b5daa$var$uuid = 0;
var $2dfc929e771b5daa$var$ElementsHolder = /*#__PURE__*/ $8SyCD.memo(/*#__PURE__*/ $8SyCD.forwardRef(function(_props, ref) {
    var _usePatchElement = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4b7855f4062cb96d$export$2e2bcd8739ae039)(), 2), elements = _usePatchElement[0], patchElement = _usePatchElement[1];
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            patchElement: patchElement
        };
    }, []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, elements);
}));
function $2dfc929e771b5daa$var$useModal() {
    var holderRef = $8SyCD.useRef(null);
    // ========================== Effect ==========================
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState([]), 2), actionQueue = _React_useState[0], setActionQueue = _React_useState[1];
    $8SyCD.useEffect(function() {
        if (actionQueue.length) {
            var cloneQueue = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach(function(action) {
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    var getConfirmFunc = $8SyCD.useCallback(function(withFunc) {
        return function hookConfirm(config) {
            var _a;
            $2dfc929e771b5daa$var$uuid += 1;
            var modalRef = /*#__PURE__*/ $8SyCD.createRef();
            // Proxy to promise with `onClose`
            var resolvePromise;
            var promise = new Promise(function(resolve) {
                resolvePromise = resolve;
            });
            var silent = false;
            var closeFunc;
            var modal = /*#__PURE__*/ $8SyCD.createElement((0, $0deaee655cea22af$export$2e2bcd8739ae039), {
                key: "modal-".concat($2dfc929e771b5daa$var$uuid),
                config: withFunc(config),
                ref: modalRef,
                afterClose: function() {
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: function() {
                    return silent;
                },
                onConfirm: function(confirmed) {
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).push(closeFunc);
            var instance = {
                destroy: function() {
                    var destroyAction = function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    };
                    if (modalRef.current) destroyAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]);
                    });
                },
                update: function(newConfig) {
                    var updateAction = function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    };
                    if (modalRef.current) updateAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]);
                    });
                },
                then: function(resolve) {
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        };
    }, []);
    var fns = $8SyCD.useMemo(function() {
        return {
            info: getConfirmFunc((0, $b8fd9089a7795ad2$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $b8fd9089a7795ad2$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $b8fd9089a7795ad2$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $b8fd9089a7795ad2$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $b8fd9089a7795ad2$export$665b64399d4af99c))
        };
    }, []);
    return [
        fns,
        /*#__PURE__*/ $8SyCD.createElement($2dfc929e771b5daa$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $2dfc929e771b5daa$export$2e2bcd8739ae039 = $2dfc929e771b5daa$var$useModal;


"use client";
function $d7fa675cd1188439$var$modalWarn(props) {
    return (0, $b8fd9089a7795ad2$export$2e2bcd8739ae039)((0, $b8fd9089a7795ad2$export$503fa8fed137d104)(props));
}
var $d7fa675cd1188439$var$Modal = (0, $ebf1bd882cc0cd41$export$2e2bcd8739ae039);
$d7fa675cd1188439$var$Modal.useModal = (0, $2dfc929e771b5daa$export$2e2bcd8739ae039);
$d7fa675cd1188439$var$Modal.info = function infoFn(props) {
    return (0, $b8fd9089a7795ad2$export$2e2bcd8739ae039)((0, $b8fd9089a7795ad2$export$2f728eab0dacbb2e)(props));
};
$d7fa675cd1188439$var$Modal.success = function successFn(props) {
    return (0, $b8fd9089a7795ad2$export$2e2bcd8739ae039)((0, $b8fd9089a7795ad2$export$2b5f8d7f29c805d4)(props));
};
$d7fa675cd1188439$var$Modal.error = function errorFn(props) {
    return (0, $b8fd9089a7795ad2$export$2e2bcd8739ae039)((0, $b8fd9089a7795ad2$export$60e9e0884ce12b55)(props));
};
$d7fa675cd1188439$var$Modal.warning = $d7fa675cd1188439$var$modalWarn;
$d7fa675cd1188439$var$Modal.warn = $d7fa675cd1188439$var$modalWarn;
$d7fa675cd1188439$var$Modal.confirm = function confirmFn(props) {
    return (0, $b8fd9089a7795ad2$export$2e2bcd8739ae039)((0, $b8fd9089a7795ad2$export$665b64399d4af99c)(props));
};
$d7fa675cd1188439$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).length){
        var close = (0, $1ca3e3a34bf268da$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$d7fa675cd1188439$var$Modal.config = (0, $b8fd9089a7795ad2$export$ff0b30c638ae2396);
$d7fa675cd1188439$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $912c8fc6943d049c$export$2e2bcd8739ae039);
var $d7fa675cd1188439$export$2e2bcd8739ae039 = $d7fa675cd1188439$var$Modal;




var $8SyCD = parcelRequire("8SyCD");
var $1367a51faa32faf0$exports = {};


(function(global, factory) {
    factory($1367a51faa32faf0$exports, (parcelRequire("hYzT4")), (parcelRequire("8SyCD")));
})($1367a51faa32faf0$exports, function(exports1, dexie, React) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function useObservable(observableFactory, arg2, arg3) {
        // Resolve vars from overloading variants of this function:
        var deps;
        var defaultResult;
        if (typeof observableFactory === "function") {
            deps = arg2 || [];
            defaultResult = arg3;
        } else {
            deps = [];
            defaultResult = arg2;
        }
        // Create a ref that keeps the state we need
        var monitor = React__default["default"].useRef({
            hasResult: false,
            result: defaultResult,
            error: null
        });
        // We control when component should rerender. Make triggerUpdate
        // as examplified on React's docs at:
        // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
        var _a = React__default["default"].useReducer(function(x) {
            return x + 1;
        }, 0);
        _a[0];
        var triggerUpdate = _a[1];
        // Memoize the observable based on deps
        var observable = React__default["default"].useMemo(function() {
            // Make it remember previous subscription's default value when
            // resubscribing.
            var observable = typeof observableFactory === "function" ? observableFactory() : observableFactory;
            if (!observable || typeof observable.subscribe !== "function") {
                if (observableFactory === observable) throw new TypeError("Given argument to useObservable() was neither a valid observable nor a function.");
                else throw new TypeError("Observable factory given to useObservable() did not return a valid observable.");
            }
            if (!monitor.current.hasResult && typeof window !== "undefined" // Don't do this in SSR
            ) // Optimize for BehaviorSubject and other observables implementing getValue():
            {
                if (typeof observable.hasValue !== "function" || observable.hasValue()) {
                    if (typeof observable.getValue === "function") {
                        monitor.current.result = observable.getValue();
                        monitor.current.hasResult = true;
                    } else {
                        // Find out if the observable has a current value: try get it by subscribing and
                        // unsubscribing synchronously
                        var subscription = observable.subscribe(function(val) {
                            monitor.current.result = val;
                            monitor.current.hasResult = true;
                        });
                        // Unsubscribe directly. We only needed any synchronous value if it was possible.
                        if (typeof subscription === "function") subscription();
                        else subscription.unsubscribe();
                    }
                }
            }
            return observable;
        }, deps);
        // Integrate with react devtools:
        React__default["default"].useDebugValue(monitor.current.result);
        // Subscribe to the observable
        React__default["default"].useEffect(function() {
            var subscription = observable.subscribe(function(val) {
                var current = monitor.current;
                if (current.error !== null || current.result !== val) {
                    current.error = null;
                    current.result = val;
                    current.hasResult = true;
                    triggerUpdate();
                }
            }, function(err) {
                var current = monitor.current;
                if (current.error !== err) {
                    current.error = err;
                    triggerUpdate();
                }
            });
            return typeof subscription === "function" ? subscription // Support observables that return unsubscribe directly
             : subscription.unsubscribe.bind(subscription);
        }, deps);
        // Throw if observable has emitted error so that
        // an ErrorBoundrary can catch it
        if (monitor.current.error) throw monitor.current.error;
        // Return the current result
        return monitor.current.result;
    }
    function useLiveQuery(querier, deps, defaultResult) {
        return useObservable(function() {
            return dexie.liveQuery(querier);
        }, deps || [], defaultResult);
    }
    function usePermissions(firstArg, table, obj) {
        if (!firstArg) throw new TypeError("Invalid arguments to usePermissions(): undefined or null");
        var db;
        if (arguments.length >= 3) {
            if (!("transaction" in firstArg)) // Using ducktyping instead of instanceof in case there are multiple Dexie modules in app.
            // First arg is  ensures first arg is a Dexie instance
            throw new TypeError("Invalid arguments to usePermission(db, table, obj): 1st arg must be a Dexie instance");
            if (typeof table !== "string") throw new TypeError("Invalid arguments to usePermission(db, table, obj): 2nd arg must be string");
            if (!obj || typeof obj !== "object") throw new TypeError("Invalid arguments to usePermission(db, table, obj): 3rd arg must be an object");
            db = firstArg;
        } else {
            if (firstArg instanceof dexie.Dexie) throw new TypeError("Invalid arguments to usePermission(db, table, obj): Missing table and obj arguments.");
            if (typeof firstArg.table === "function" && typeof firstArg.db === "object") {
                db = firstArg.db;
                obj = firstArg;
                table = firstArg.table();
            } else throw new TypeError("Invalid arguments to usePermissions(). Expected usePermissions(entity: DexieCloudEntity) or usePermissions(db: Dexie, table: string, obj: DexieCloudObject)");
        }
        if (!("cloud" in db)) throw new Error("usePermissions() is only for Dexie Cloud but there's no dexie-cloud-addon active in given db.");
        if (!("permissions" in db.cloud)) throw new Error("usePermissions() requires a newer version of dexie-cloud-addon. Please upgrade it.");
        return useObservable(// @ts-ignore
        function() {
            return db.cloud.permissions(obj, table);
        }, [
            obj.realmId,
            obj.owner,
            table
        ]);
    }
    exports1.useLiveQuery = useLiveQuery;
    exports1.useObservable = useObservable;
    exports1.usePermissions = usePermissions;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});








var $8SyCD = parcelRequire("8SyCD");

var $hYzT4 = parcelRequire("hYzT4");
var $c5efbd2e0c4166b1$export$426b5a85803d33b1 = /*#__PURE__*/ function(Dexie) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(MusicPalDexie, Dexie);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(MusicPalDexie);
    function MusicPalDexie() {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, MusicPalDexie);
        var _this;
        _this = _super.call(this, "musicpal");
        _this.version(1).stores({
            rhythms: "++id, name, createdTime, updatedTime, preparatoryBeats, order, tempo, measures"
        });
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(MusicPalDexie, [
        {
            key: "init",
            value: function init() {}
        }
    ]);
    return MusicPalDexie;
}((0, $hYzT4.default));
var $c5efbd2e0c4166b1$export$37c52bbb9ad91dc9 = /*#__PURE__*/ (0, $8SyCD.createContext)({
    dexie: null
});
function $c5efbd2e0c4166b1$export$391446ce2f0d1557(props) {
    var dexie = props.dexie, children = props.children;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)($c5efbd2e0c4166b1$export$37c52bbb9ad91dc9.Provider, {
        value: {
            dexie: dexie
        },
        children: children
    });
}
function $c5efbd2e0c4166b1$export$95809329f49ea9f9() {
    var dexie = (0, $8SyCD.useContext)($c5efbd2e0c4166b1$export$37c52bbb9ad91dc9).dexie;
    if (!dexie) throw new Error("unable to get dexie storage");
    return {
        dexie: dexie
    };
}





var $8SyCD = parcelRequire("8SyCD");








var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");
"use client";
var $dffb0f76141af56f$var$Element = function(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, size = props.size, shape = props.shape;
    var _obj;
    var sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), size === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), size === "small"), _obj));
    var _obj1;
    var shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-circle"), shape === "circle"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-square"), shape === "square"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-round"), shape === "round"), _obj1));
    var sizeStyle = $8SyCD.useMemo(function() {
        return typeof size === "number" ? {
            width: size,
            height: size,
            lineHeight: "".concat(size, "px")
        } : {};
    }, [
        size
    ]);
    return /*#__PURE__*/ $8SyCD.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $dffb0f76141af56f$export$2e2bcd8739ae039 = $dffb0f76141af56f$var$Element;





"use client";
var $90cda500d921d29d$var$skeletonClsLoading = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("ant-skeleton-loading", {
    "0%": {
        backgroundPosition: "100% 50%"
    },
    "100%": {
        backgroundPosition: "0 50%"
    }
});
var $90cda500d921d29d$var$genSkeletonElementCommonSize = function(size) {
    return {
        height: size,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(size)
    };
};
var $90cda500d921d29d$var$genSkeletonElementAvatarSize = function(size) {
    return Object.assign({
        width: size
    }, $90cda500d921d29d$var$genSkeletonElementCommonSize(size));
};
var $90cda500d921d29d$var$genSkeletonColor = function(token) {
    return {
        background: token.skeletonLoadingBackground,
        backgroundSize: "400% 100%",
        animationName: $90cda500d921d29d$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: "ease",
        animationIterationCount: "infinite"
    };
};
var $90cda500d921d29d$var$genSkeletonElementInputSize = function(size, calc) {
    return Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $90cda500d921d29d$var$genSkeletonElementCommonSize(size));
};
var $90cda500d921d29d$var$genSkeletonElementAvatar = function(token) {
    var skeletonAvatarCls = token.skeletonAvatarCls, gradientFromColor = token.gradientFromColor, controlHeight = token.controlHeight, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls), Object.assign({
        display: "inline-block",
        verticalAlign: "top",
        background: gradientFromColor
    }, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeight))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls).concat(skeletonAvatarCls, "-circle"), {
        borderRadius: "50%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls).concat(skeletonAvatarCls, "-lg"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeightLG))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls).concat(skeletonAvatarCls, "-sm"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeightSM))), _obj;
};
var $90cda500d921d29d$var$genSkeletonElementInput = function(token) {
    var controlHeight = token.controlHeight, borderRadiusSM = token.borderRadiusSM, skeletonInputCls = token.skeletonInputCls, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, gradientFromColor = token.gradientFromColor, calc = token.calc;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonInputCls), Object.assign({
        display: "inline-block",
        verticalAlign: "top",
        background: gradientFromColor,
        borderRadius: borderRadiusSM
    }, $90cda500d921d29d$var$genSkeletonElementInputSize(controlHeight, calc))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonInputCls, "-lg"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementInputSize(controlHeightLG, calc))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonInputCls, "-sm"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementInputSize(controlHeightSM, calc))), _obj;
};
var $90cda500d921d29d$var$genSkeletonElementImageSize = function(size) {
    return Object.assign({
        width: size
    }, $90cda500d921d29d$var$genSkeletonElementCommonSize(size));
};
var $90cda500d921d29d$var$genSkeletonElementImage = function(token) {
    var skeletonImageCls = token.skeletonImageCls, imageSizeBase = token.imageSizeBase, gradientFromColor = token.gradientFromColor, borderRadiusSM = token.borderRadiusSM, calc = token.calc;
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(skeletonImageCls), Object.assign(Object.assign({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "top",
        background: gradientFromColor,
        borderRadius: borderRadiusSM
    }, $90cda500d921d29d$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonImageCls, "-path"), {
        fill: "#bfbfbf"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonImageCls, "-svg"), Object.assign(Object.assign({}, $90cda500d921d29d$var$genSkeletonElementImageSize(imageSizeBase)), {
        maxWidth: calc(imageSizeBase).mul(4).equal(),
        maxHeight: calc(imageSizeBase).mul(4).equal()
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonImageCls, "-svg").concat(skeletonImageCls, "-svg-circle"), {
        borderRadius: "50%"
    }), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(skeletonImageCls).concat(skeletonImageCls, "-circle"), {
        borderRadius: "50%"
    }), _obj1;
};
var $90cda500d921d29d$var$genSkeletonElementButtonShape = function(token, size, buttonCls) {
    var skeletonButtonCls = token.skeletonButtonCls;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(buttonCls).concat(skeletonButtonCls, "-circle"), {
        width: size,
        minWidth: size,
        borderRadius: "50%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(buttonCls).concat(skeletonButtonCls, "-round"), {
        borderRadius: size
    }), _obj;
};
var $90cda500d921d29d$var$genSkeletonElementButtonSize = function(size, calc) {
    return Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $90cda500d921d29d$var$genSkeletonElementCommonSize(size));
};
var $90cda500d921d29d$var$genSkeletonElementButton = function(token) {
    var borderRadiusSM = token.borderRadiusSM, skeletonButtonCls = token.skeletonButtonCls, controlHeight = token.controlHeight, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, gradientFromColor = token.gradientFromColor, calc = token.calc;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(skeletonButtonCls), Object.assign({
        display: "inline-block",
        verticalAlign: "top",
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        width: calc(controlHeight).mul(2).equal(),
        minWidth: calc(controlHeight).mul(2).equal()
    }, $90cda500d921d29d$var$genSkeletonElementButtonSize(controlHeight, calc))), $90cda500d921d29d$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(skeletonButtonCls, "-lg"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementButtonSize(controlHeightLG, calc)))), $90cda500d921d29d$var$genSkeletonElementButtonShape(token, controlHeightLG, "".concat(skeletonButtonCls, "-lg"))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(skeletonButtonCls, "-sm"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementButtonSize(controlHeightSM, calc)))), $90cda500d921d29d$var$genSkeletonElementButtonShape(token, controlHeightSM, "".concat(skeletonButtonCls, "-sm")));
};
// =============================== Base ===============================
var $90cda500d921d29d$var$genBaseStyle = function(token) {
    var componentCls = token.componentCls, skeletonAvatarCls = token.skeletonAvatarCls, skeletonTitleCls = token.skeletonTitleCls, skeletonParagraphCls = token.skeletonParagraphCls, skeletonButtonCls = token.skeletonButtonCls, skeletonInputCls = token.skeletonInputCls, skeletonImageCls = token.skeletonImageCls, controlHeight = token.controlHeight, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, gradientFromColor = token.gradientFromColor, padding = token.padding, marginSM = token.marginSM, borderRadius = token.borderRadius, titleHeight = token.titleHeight, blockRadius = token.blockRadius, paragraphLiHeight = token.paragraphLiHeight, controlHeightXS = token.controlHeightXS, paragraphMarginTop = token.paragraphMarginTop;
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return _obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls), (_obj2 = {
        display: "table",
        width: "100%"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-header"), (_obj = {
        display: "table-cell",
        paddingInlineEnd: padding,
        verticalAlign: "top"
    }, // Avatar
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls), Object.assign({
        display: "inline-block",
        verticalAlign: "top",
        background: gradientFromColor
    }, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeight))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls, "-circle"), {
        borderRadius: "50%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls, "-lg"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeightLG))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(skeletonAvatarCls, "-sm"), Object.assign({}, $90cda500d921d29d$var$genSkeletonElementAvatarSize(controlHeightSM))), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-content"), (_obj1 = {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top"
    }, // Title
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(skeletonTitleCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        width: "100%",
        height: titleHeight,
        background: gradientFromColor,
        borderRadius: blockRadius
    }, "+ ".concat(skeletonParagraphCls), {
        marginBlockStart: controlHeightSM
    })), // paragraph
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(skeletonParagraphCls), {
        padding: 0,
        "> li": {
            width: "100%",
            height: paragraphLiHeight,
            listStyle: "none",
            background: gradientFromColor,
            borderRadius: blockRadius,
            "+ li": {
                marginBlockStart: controlHeightXS
            }
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(skeletonParagraphCls, "> li:last-child:not(:first-child):not(:nth-child(2))"), {
        width: "61%"
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-round ".concat(componentCls, "-content"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(skeletonTitleCls, ", ").concat(skeletonParagraphCls, " > li"), {
        borderRadius: borderRadius
    })), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-with-avatar ").concat(componentCls, "-content"), // Title
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(skeletonTitleCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginBlockStart: marginSM
    }, "+ ".concat(skeletonParagraphCls), {
        marginBlockStart: paragraphMarginTop
    }))), // Skeleton element
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls).concat(componentCls, "-element"), Object.assign(Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "auto"
    }, $90cda500d921d29d$var$genSkeletonElementButton(token)), $90cda500d921d29d$var$genSkeletonElementAvatar(token)), $90cda500d921d29d$var$genSkeletonElementInput(token)), $90cda500d921d29d$var$genSkeletonElementImage(token))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls).concat(componentCls, "-block"), (_obj3 = {
        width: "100%"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(skeletonButtonCls), {
        width: "100%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(skeletonInputCls), {
        width: "100%"
    }), _obj3)), // With active animation
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls).concat(componentCls, "-active"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "\n        ".concat(skeletonTitleCls, ",\n        ").concat(skeletonParagraphCls, " > li,\n        ").concat(skeletonAvatarCls, ",\n        ").concat(skeletonButtonCls, ",\n        ").concat(skeletonInputCls, ",\n        ").concat(skeletonImageCls, "\n      "), Object.assign({}, $90cda500d921d29d$var$genSkeletonColor(token)))), _obj4;
};
var $90cda500d921d29d$export$9ca1be8807fe0675 = function(token) {
    var colorFillContent = token.colorFillContent, colorFill = token.colorFill;
    var gradientFromColor = colorFillContent;
    var gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $90cda500d921d29d$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Skeleton", function(token) {
    var componentCls = token.componentCls, calc = token.calc;
    var skeletonToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: "".concat(componentCls, "-avatar"),
        skeletonTitleCls: "".concat(componentCls, "-title"),
        skeletonParagraphCls: "".concat(componentCls, "-paragraph"),
        skeletonButtonCls: "".concat(componentCls, "-button"),
        skeletonInputCls: "".concat(componentCls, "-input"),
        skeletonImageCls: "".concat(componentCls, "-image"),
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: "linear-gradient(90deg, ".concat(token.gradientFromColor, " 25%, ").concat(token.gradientToColor, " 37%, ").concat(token.gradientFromColor, " 63%)"),
        skeletonLoadingMotionDuration: "1.4s"
    });
    return [
        $90cda500d921d29d$var$genBaseStyle(skeletonToken)
    ];
}, $90cda500d921d29d$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "color",
            "gradientFromColor"
        ],
        [
            "colorGradientEnd",
            "gradientToColor"
        ]
    ]
});


"use client";
var $1f29ec5f966d4817$var$SkeletonAvatar = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, active = props.active, _props_shape = props.shape, shape = _props_shape === void 0 ? "circle" : _props_shape, _props_size = props.size, size = _props_size === void 0 ? "default" : _props_size;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var otherProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "prefixCls",
        "className"
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-element"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-active"), active), className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $8SyCD.createElement((0, $dffb0f76141af56f$export$2e2bcd8739ae039), Object.assign({
        prefixCls: "".concat(prefixCls, "-avatar"),
        shape: shape,
        size: size
    }, otherProps))));
};
var $1f29ec5f966d4817$export$2e2bcd8739ae039 = $1f29ec5f966d4817$var$SkeletonAvatar;







var $8SyCD = parcelRequire("8SyCD");



"use client";
var $908d652729b2d19a$var$SkeletonButton = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, active = props.active, _props_block = props.block, block = _props_block === void 0 ? false : _props_block, _props_size = props.size, size = _props_size === void 0 ? "default" : _props_size;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var otherProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    var _obj;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-element"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-active"), active), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-block"), block), _obj), className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $8SyCD.createElement((0, $dffb0f76141af56f$export$2e2bcd8739ae039), Object.assign({
        prefixCls: "".concat(prefixCls, "-button"),
        size: size
    }, otherProps))));
};
var $908d652729b2d19a$export$2e2bcd8739ae039 = $908d652729b2d19a$var$SkeletonButton;







var $8SyCD = parcelRequire("8SyCD");


"use client";
var $392617d80b3fbc09$var$path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z";
var $392617d80b3fbc09$var$SkeletonImage = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, style = props.style, active = props.active;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-element"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-active"), active), className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-image"), className),
        style: style
    }, /*#__PURE__*/ $8SyCD.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: "".concat(prefixCls, "-image-svg")
    }, /*#__PURE__*/ $8SyCD.createElement("path", {
        d: $392617d80b3fbc09$var$path,
        className: "".concat(prefixCls, "-image-path")
    })))));
};
var $392617d80b3fbc09$export$2e2bcd8739ae039 = $392617d80b3fbc09$var$SkeletonImage;







var $8SyCD = parcelRequire("8SyCD");



"use client";
var $50d42d0e7ecb2b25$var$SkeletonInput = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, active = props.active, block = props.block, _props_size = props.size, size = _props_size === void 0 ? "default" : _props_size;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var otherProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    var _obj;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-element"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-active"), active), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-block"), block), _obj), className, rootClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $8SyCD.createElement((0, $dffb0f76141af56f$export$2e2bcd8739ae039), Object.assign({
        prefixCls: "".concat(prefixCls, "-input"),
        size: size
    }, otherProps))));
};
var $50d42d0e7ecb2b25$export$2e2bcd8739ae039 = $50d42d0e7ecb2b25$var$SkeletonInput;






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $f91d17461e48b43d$var$DotChartOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    name: "dot-chart",
    theme: "outlined"
};
var $f91d17461e48b43d$export$2e2bcd8739ae039 = $f91d17461e48b43d$var$DotChartOutlined;



var $ff29e091a67040b2$var$DotChartOutlined = function DotChartOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f91d17461e48b43d$export$2e2bcd8739ae039)
    }));
};
var $ff29e091a67040b2$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($ff29e091a67040b2$var$DotChartOutlined);




var $8SyCD = parcelRequire("8SyCD");


"use client";
var $c80276f989eb7e23$var$SkeletonNode = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, style = props.style, active = props.active, children = props.children;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-element"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-active"), active), hashId, className, rootClassName);
    var content = children !== null && children !== void 0 ? children : /*#__PURE__*/ $8SyCD.createElement((0, $ff29e091a67040b2$export$2e2bcd8739ae039), null);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-image"), className),
        style: style
    }, content)));
};
var $c80276f989eb7e23$export$2e2bcd8739ae039 = $c80276f989eb7e23$var$SkeletonNode;





var $8SyCD = parcelRequire("8SyCD");
"use client";
var $6f5ddf300aa6fe52$var$Paragraph = function(props) {
    var getWidth = function(index) {
        var width = props.width, _props_rows = props.rows, rows = _props_rows === void 0 ? 2 : _props_rows;
        if (Array.isArray(width)) return width[index];
        // last paragraph
        if (rows - 1 === index) return width;
        return undefined;
    };
    var prefixCls = props.prefixCls, className = props.className, style = props.style, rows = props.rows;
    var rowList = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(Array(rows)).map(function(_, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $8SyCD.createElement("li", {
            key: index,
            style: {
                width: getWidth(index)
            }
        }));
    });
    return /*#__PURE__*/ $8SyCD.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className),
        style: style
    }, rowList);
};
var $6f5ddf300aa6fe52$export$2e2bcd8739ae039 = $6f5ddf300aa6fe52$var$Paragraph;




var $8SyCD = parcelRequire("8SyCD");
"use client";
var $65cc2785deb97bda$var$Title = function(_ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, width = _ref.width, style = _ref.style;
    return /*#__PURE__*/ $8SyCD.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    });
};
var $65cc2785deb97bda$export$2e2bcd8739ae039 = $65cc2785deb97bda$var$Title;



"use client";
function $f3142912c0d3e963$var$getComponentProps(prop) {
    if (prop && typeof prop === "object") return prop;
    return {};
}
function $f3142912c0d3e963$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: "large",
        shape: "square"
    };
    return {
        size: "large",
        shape: "circle"
    };
}
function $f3142912c0d3e963$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: "38%"
    };
    if (hasAvatar && hasParagraph) return {
        width: "50%"
    };
    return {};
}
function $f3142912c0d3e963$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    var basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = "61%";
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
var $f3142912c0d3e963$var$Skeleton = function(props) {
    var customizePrefixCls = props.prefixCls, loading = props.loading, className = props.className, rootClassName = props.rootClassName, style = props.style, children = props.children, _props_avatar = props.avatar, avatar = _props_avatar === void 0 ? false : _props_avatar, _props_title = props.title, title = _props_title === void 0 ? true : _props_title, _props_paragraph = props.paragraph, paragraph = _props_paragraph === void 0 ? true : _props_paragraph, active = props.active, round = props.round;
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, skeleton = _React_useContext.skeleton;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $90cda500d921d29d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    if (loading || !("loading" in props)) {
        var hasAvatar = !!avatar;
        var hasTitle = !!title;
        var hasParagraph = !!paragraph;
        // Avatar
        var avatarNode;
        if (hasAvatar) {
            var avatarProps = Object.assign(Object.assign({
                prefixCls: "".concat(prefixCls, "-avatar")
            }, $f3142912c0d3e963$var$getAvatarBasicProps(hasTitle, hasParagraph)), $f3142912c0d3e963$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $8SyCD.createElement("div", {
                className: "".concat(prefixCls, "-header")
            }, /*#__PURE__*/ $8SyCD.createElement((0, $dffb0f76141af56f$export$2e2bcd8739ae039), Object.assign({}, avatarProps)));
        }
        var contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            var $title;
            if (hasTitle) {
                var titleProps = Object.assign(Object.assign({
                    prefixCls: "".concat(prefixCls, "-title")
                }, $f3142912c0d3e963$var$getTitleBasicProps(hasAvatar, hasParagraph)), $f3142912c0d3e963$var$getComponentProps(title));
                $title = /*#__PURE__*/ $8SyCD.createElement((0, $65cc2785deb97bda$export$2e2bcd8739ae039), Object.assign({}, titleProps));
            }
            // Paragraph
            var paragraphNode;
            if (hasParagraph) {
                var paragraphProps = Object.assign(Object.assign({
                    prefixCls: "".concat(prefixCls, "-paragraph")
                }, $f3142912c0d3e963$var$getParagraphBasicProps(hasAvatar, hasTitle)), $f3142912c0d3e963$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $8SyCD.createElement((0, $6f5ddf300aa6fe52$export$2e2bcd8739ae039), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $8SyCD.createElement("div", {
                className: "".concat(prefixCls, "-content")
            }, $title, paragraphNode);
        }
        var _obj;
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-with-avatar"), hasAvatar), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-active"), active), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-round"), round), _obj), skeleton === null || skeleton === void 0 ? void 0 : skeleton.className, className, rootClassName, hashId);
        return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.style), style)
        }, avatarNode, contentNode));
    }
    return typeof children !== "undefined" ? children : null;
};
$f3142912c0d3e963$var$Skeleton.Button = (0, $908d652729b2d19a$export$2e2bcd8739ae039);
$f3142912c0d3e963$var$Skeleton.Avatar = (0, $1f29ec5f966d4817$export$2e2bcd8739ae039);
$f3142912c0d3e963$var$Skeleton.Input = (0, $50d42d0e7ecb2b25$export$2e2bcd8739ae039);
$f3142912c0d3e963$var$Skeleton.Image = (0, $392617d80b3fbc09$export$2e2bcd8739ae039);
$f3142912c0d3e963$var$Skeleton.Node = (0, $c80276f989eb7e23$export$2e2bcd8739ae039);
var $f3142912c0d3e963$export$2e2bcd8739ae039 = $f3142912c0d3e963$var$Skeleton;


"use client";
var $58b95ada40f29e17$export$2e2bcd8739ae039 = (0, $f3142912c0d3e963$export$2e2bcd8739ae039);





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $e65dd7bcc49a2dcf$var$EllipsisOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    name: "ellipsis",
    theme: "outlined"
};
var $e65dd7bcc49a2dcf$export$2e2bcd8739ae039 = $e65dd7bcc49a2dcf$var$EllipsisOutlined;



var $f4c5b4a4a3d18e7e$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e65dd7bcc49a2dcf$export$2e2bcd8739ae039)
    }));
};
var $f4c5b4a4a3d18e7e$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($f4c5b4a4a3d18e7e$var$EllipsisOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $dc7662902af4ae08$var$PlusOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    name: "plus",
    theme: "outlined"
};
var $dc7662902af4ae08$export$2e2bcd8739ae039 = $dc7662902af4ae08$var$PlusOutlined;



var $7ccd05dd213ce145$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $dc7662902af4ae08$export$2e2bcd8739ae039)
    }));
};
var $7ccd05dd213ce145$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($7ccd05dd213ce145$var$PlusOutlined);











var $fc01ea5e514846e5$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $8SyCD = parcelRequire("8SyCD");



function $21ea20a6809f53e5$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        inkBar: true
    }, (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(animated) === "object" ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}



var $8SyCD = parcelRequire("8SyCD");
var $0fbc8c0feb7aa1f8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8SyCD.createContext)(null);






var $8SyCD = parcelRequire("8SyCD");










var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
var $d330b750661f51f3$var$useIndicator = function useIndicator(_ref) {
    var activeTabOffset = _ref.activeTabOffset, horizontal = _ref.horizontal, rtl = _ref.rtl, indicatorSize = _ref.indicatorSize;
    var _useState = (0, $8SyCD.useState)(), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), inkStyle = _useState2[0], setInkStyle = _useState2[1];
    var inkBarRafRef = (0, $8SyCD.useRef)();
    var getLength = function getLength(origin) {
        if (typeof indicatorSize === "function") return indicatorSize(origin);
        if (typeof indicatorSize === "number") return indicatorSize;
        return origin;
    };
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $8SyCD.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                if (rtl) {
                    newInkStyle.right = activeTabOffset.right + activeTabOffset.width / 2;
                    newInkStyle.transform = "translateX(50%)";
                } else {
                    newInkStyle.left = activeTabOffset.left + activeTabOffset.width / 2;
                    newInkStyle.transform = "translateX(-50%)";
                }
                newInkStyle.width = getLength(activeTabOffset.width);
            } else {
                newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                newInkStyle.transform = "translateY(-50%)";
                newInkStyle.height = getLength(activeTabOffset.height);
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        horizontal,
        rtl,
        indicatorSize
    ]);
    return {
        style: inkStyle
    };
};
var $d330b750661f51f3$export$2e2bcd8739ae039 = $d330b750661f51f3$var$useIndicator;




var $8SyCD = parcelRequire("8SyCD");
var $a96afca128b28df7$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $a96afca128b28df7$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $8SyCD.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $a96afca128b28df7$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $a96afca128b28df7$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        tabSizes,
        holderScrollWidth
    ]);
}




var $8SyCD = parcelRequire("8SyCD");
function $788de6539d1721ae$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $8SyCD.useRef(defaultState);
    var _React$useState = $8SyCD.useState({}), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}




var $8SyCD = parcelRequire("8SyCD");
var $ed19131f9b455fd8$var$MIN_SWIPE_DISTANCE = 0.1;
var $ed19131f9b455fd8$var$STOP_SWIPE_DISTANCE = 0.01;
var $ed19131f9b455fd8$var$REFRESH_INTERVAL = 20;
var $ed19131f9b455fd8$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $ed19131f9b455fd8$var$REFRESH_INTERVAL);
function $ed19131f9b455fd8$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $8SyCD.useState)(), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)(0), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $8SyCD.useState)(0), _useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $8SyCD.useState)(), _useState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $8SyCD.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $ed19131f9b455fd8$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $ed19131f9b455fd8$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $ed19131f9b455fd8$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $ed19131f9b455fd8$var$SPEED_OFF_MULTIPLE;
                currentY *= $ed19131f9b455fd8$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $ed19131f9b455fd8$var$REFRESH_INTERVAL, currentY * $ed19131f9b455fd8$var$REFRESH_INTERVAL);
            }, $ed19131f9b455fd8$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $8SyCD.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = "x";
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = "y";
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $8SyCD.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $8SyCD.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener("touchmove", onProxyTouchMove, {
            passive: false
        });
        document.addEventListener("touchend", onProxyTouchEnd, {
            passive: false
        });
        // No need to clean up since element removed
        ref.current.addEventListener("touchstart", onProxyTouchStart, {
            passive: false
        });
        ref.current.addEventListener("wheel", onProxyWheel);
        return function() {
            document.removeEventListener("touchmove", onProxyTouchMove);
            document.removeEventListener("touchend", onProxyTouchEnd);
        };
    }, []);
}





var $8SyCD = parcelRequire("8SyCD");
function $66b6be425b8c8a17$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $8SyCD.useState)(0), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $8SyCD.useRef)(0);
    var callbackRef = (0, $8SyCD.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $66b6be425b8c8a17$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $8SyCD.useRef)([]);
    var _useState3 = (0, $8SyCD.useState)({}), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $8SyCD.useRef)(typeof defaultState === "function" ? defaultState() : defaultState);
    var flushUpdate = $66b6be425b8c8a17$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $8SyCD = parcelRequire("8SyCD");
var $1c9ce0a4c93de234$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $1c9ce0a4c93de234$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        "top",
        "bottom"
    ].includes(tabPosition)) {
        charUnit = "width";
        position = rtl ? "right" : "left";
        transformSize = Math.abs(transform);
    } else {
        charUnit = "height";
        position = "top";
        transformSize = -transform;
    }
    return (0, $8SyCD.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $1c9ce0a4c93de234$var$DEFAULT_SIZE;
            if (offset[position] + offset[charUnit] > transformSize + visibleTabContentValue) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $1c9ce0a4c93de234$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return startIndex >= endIndex ? [
            0,
            0
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        rtl
    ]);
}



/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $60ec8506026e0a49$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $60ec8506026e0a49$var$RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function $60ec8506026e0a49$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $60ec8506026e0a49$var$RC_TABS_DOUBLE_QUOTE);
}
function $60ec8506026e0a49$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $8SyCD = parcelRequire("8SyCD");
var $d9996f739ffe8d68$var$AddButton = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, editable = props.editable, locale = props.locale, style = props.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $8SyCD.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || "Add tab",
        onClick: function onClick(event) {
            editable.onEdit("add", {
                event: event
            });
        }
    }, editable.addIcon || "+");
});
var $d9996f739ffe8d68$export$2e2bcd8739ae039 = $d9996f739ffe8d68$var$AddButton;




var $8SyCD = parcelRequire("8SyCD");
var $f567dbd1921abab9$var$ExtraContent = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var position = props.position, prefixCls = props.prefixCls, extra = props.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(extra) === "object" && !/*#__PURE__*/ $8SyCD.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === "right") content = assertExtra.right;
    if (position === "left") content = assertExtra.left;
    return content ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
var $f567dbd1921abab9$export$2e2bcd8739ae039 = $f567dbd1921abab9$var$ExtraContent;






















var $8SyCD = parcelRequire("8SyCD");









var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
function $bfaa2e0619d5a15c$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $8SyCD.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}






var $8SyCD = parcelRequire("8SyCD");
function $696ef4fd3eff344a$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $8SyCD.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $8SyCD = parcelRequire("8SyCD");
var $748baca42751bc97$var$PopupContent = /*#__PURE__*/ $8SyCD.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $748baca42751bc97$export$2e2bcd8739ae039 = $748baca42751bc97$var$PopupContent;


var $4aa61ffc3ae57c13$var$Popup = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $8SyCD.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = "auto";
    var offsetStyle = {
        left: "-1000vw",
        top: "-1000vh",
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === "r";
        var alignBottom = dynamicInset && points[0][0] === "b";
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $8SyCD.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $8SyCD.createElement((0, $696ef4fd3eff344a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $8SyCD.createElement("div", {
                ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
                    "--arrow-x": "".concat(arrowPos.x || 0, "px"),
                    "--arrow-y": "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: "border-box",
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $8SyCD.createElement((0, $bfaa2e0619d5a15c$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $8SyCD.createElement((0, $748baca42751bc97$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $4aa61ffc3ae57c13$export$2e2bcd8739ae039 = $4aa61ffc3ae57c13$var$Popup;




var $8SyCD = parcelRequire("8SyCD");
var $e84c5fc775a79577$var$TriggerWrapper = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $8SyCD.useCallback(function(node) {
        (0, $5a9f4dc5cf4fdd27$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $8SyCD.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $e84c5fc775a79577$export$2e2bcd8739ae039 = $e84c5fc775a79577$var$TriggerWrapper;



var $8SyCD = parcelRequire("8SyCD");
var $54e4acdcf455b3d8$var$TriggerContext = /*#__PURE__*/ $8SyCD.createContext(null);
var $54e4acdcf455b3d8$export$2e2bcd8739ae039 = $54e4acdcf455b3d8$var$TriggerContext;



var $8SyCD = parcelRequire("8SyCD");
function $bf62ec175f8bda4d$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $bf62ec175f8bda4d$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $8SyCD.useMemo(function() {
        var mergedShowAction = $bf62ec175f8bda4d$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $bf62ec175f8bda4d$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has("hover")) {
                showActionSet["delete"]("hover");
                showActionSet.add("click");
            }
            if (hideActionSet.has("hover")) {
                hideActionSet["delete"]("hover");
                hideActionSet.add("click");
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}









var $8SyCD = parcelRequire("8SyCD");

function $4e8ed5c9b9b5cc45$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $4e8ed5c9b9b5cc45$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($4e8ed5c9b9b5cc45$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}
function $4e8ed5c9b9b5cc45$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $4e8ed5c9b9b5cc45$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        "hidden",
        "scroll",
        "clip",
        "auto"
    ];
    while(current){
        var _getWin$getComputedSt = $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $4e8ed5c9b9b5cc45$var$getPxValue(val) {
    return $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $4e8ed5c9b9b5cc45$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $4e8ed5c9b9b5cc45$var$getPxValue(borderTopWidth);
        var borderBottomNum = $4e8ed5c9b9b5cc45$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $4e8ed5c9b9b5cc45$var$getPxValue(borderLeftWidth);
        var borderRightNum = $4e8ed5c9b9b5cc45$var$getPxValue(borderRightWidth);
        var scaleX = $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === "clip") {
            var clipNum = $4e8ed5c9b9b5cc45$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $352ab3810eedec3c$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $352ab3810eedec3c$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $352ab3810eedec3c$var$getUnitOffset(rect.width, offsetX),
        $352ab3810eedec3c$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $352ab3810eedec3c$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        points[0],
        points[1]
    ];
}
function $352ab3810eedec3c$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $352ab3810eedec3c$var$reversePoints(points, index) {
    var reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || "c";
        return point;
    }).join("");
}
function $352ab3810eedec3c$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $8SyCD.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $8SyCD.useRef(0);
    var scrollerList = $8SyCD.useMemo(function() {
        if (!popupEle) return [];
        return (0, $4e8ed5c9b9b5cc45$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $8SyCD.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var getIntersectionVisibleArea = // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            };
            var syncNextPopupPosition = function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            };
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement("div");
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            popupElement.style.right = "auto";
            popupElement.style.bottom = "auto";
            popupElement.style.overflow = "hidden";
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = "visible";
            var VISIBLE_FIRST = "visibleFirst";
            if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $4e8ed5c9b9b5cc45$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $4e8ed5c9b9b5cc45$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = "auto";
            popupElement.style.top = "auto";
            popupElement.style.right = "0";
            popupElement.style.bottom = "0";
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $4e8ed5c9b9b5cc45$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $a4b291de522e10cb$export$41e30d8dd0ba7a50)(target) && !(0, $1f0413060b1cb2c2$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $352ab3810eedec3c$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $352ab3810eedec3c$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $352ab3810eedec3c$var$splitPoints(targetPoint);
            var popupPoints = $352ab3810eedec3c$var$splitPoints(popupPoint);
            var targetAlignPoint = $352ab3810eedec3c$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $352ab3810eedec3c$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $352ab3810eedec3c$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            var popupAlignPointTL = $352ab3810eedec3c$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            var targetAlignPointBR = $352ab3810eedec3c$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            var popupAlignPointBR = $352ab3810eedec3c$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $352ab3810eedec3c$var$reversePoints(popupPoints, 0),
                        $352ab3810eedec3c$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $352ab3810eedec3c$var$reversePoints(popupPoints, 0),
                        $352ab3810eedec3c$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $352ab3810eedec3c$var$reversePoints(popupPoints, 1),
                        $352ab3810eedec3c$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $352ab3810eedec3c$var$reversePoints(popupPoints, 1),
                        $352ab3810eedec3c$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            setOffsetInfo({
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            });
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}





function $72f6631ae4007023$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var notifyScroll = function notifyScroll() {
                onAlign();
                onScroll();
            };
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $4e8ed5c9b9b5cc45$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $4e8ed5c9b9b5cc45$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(targetScrollList), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(popupScrollList)));
            mergedList.forEach(function(scroller) {
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}







var $8SyCD = parcelRequire("8SyCD");

function $4780053ddcfa5af6$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $8SyCD.useRef(open);
    // Window click to hide should be lock to avoid trigger lock immediately
    var lockRef = $8SyCD.useRef(false);
    if (openRef.current !== open) {
        lockRef.current = true;
        openRef.current = open;
    }
    $8SyCD.useEffect(function() {
        var id = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            lockRef.current = false;
        });
        return function() {
            (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(id);
        };
    }, [
        open
    ]);
    // Click to hide is special action since click popup element should not hide
    $8SyCD.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var genClickEvents = function genClickEvents() {
                var clickInside = false;
                // User may mouseDown inside and drag out of popup and mouse up
                // Record here to prevent close
                var onWindowMouseDown = function onWindowMouseDown(_ref) {
                    var target = _ref.target;
                    clickInside = inPopupOrChild(target);
                };
                var onWindowClick = function onWindowClick(_ref2) {
                    var target = _ref2.target;
                    if (!lockRef.current && openRef.current && !clickInside && !inPopupOrChild(target)) triggerOpen(false);
                };
                return [
                    onWindowMouseDown,
                    onWindowClick
                ];
            };
            // Events
            var _genClickEvents = genClickEvents(), _genClickEvents2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_genClickEvents, 2), onWinMouseDown = _genClickEvents2[0], onWinClick = _genClickEvents2[1];
            var _genClickEvents3 = genClickEvents(), _genClickEvents4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_genClickEvents3, 2), onShadowMouseDown = _genClickEvents4[0], onShadowClick = _genClickEvents4[1];
            var win = (0, $4e8ed5c9b9b5cc45$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener("mousedown", onWinMouseDown, true);
            win.addEventListener("click", onWinClick, true);
            win.addEventListener("contextmenu", onWinClick, true);
            // shadow root
            var targetShadowRoot = (0, $ba1d9436078efdd1$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener("mousedown", onShadowMouseDown, true);
                targetShadowRoot.addEventListener("click", onShadowClick, true);
                targetShadowRoot.addEventListener("contextmenu", onShadowClick, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener("mousedown", onWinMouseDown, true);
                win.removeEventListener("click", onWinClick, true);
                win.removeEventListener("contextmenu", onWinClick, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener("mousedown", onShadowMouseDown, true);
                    targetShadowRoot.removeEventListener("click", onShadowClick, true);
                    targetShadowRoot.removeEventListener("contextmenu", onShadowClick, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}



var $639aa9e1edacf68a$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $639aa9e1edacf68a$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5691ab22d5134673$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $639aa9e1edacf68a$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
            setMobile((0, $fc01ea5e514846e5$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $8SyCD.useRef({});
        var parentContext = $8SyCD.useContext((0, $54e4acdcf455b3d8$export$2e2bcd8739ae039));
        var context = $8SyCD.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $1641fb35059f12b8$export$2e2bcd8739ae039)();
        var _React$useState3 = $8SyCD.useState(null), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        var setPopupRef = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(node) {
            if ((0, $a4b291de522e10cb$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $8SyCD.useState(null), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $8SyCD.useRef(null);
        var setTargetRef = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(node) {
            if ((0, $a4b291de522e10cb$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $8SyCD.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $ba1d9436078efdd1$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $ba1d9436078efdd1$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $4e8ed5c9b9b5cc45$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $4e8ed5c9b9b5cc45$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $8SyCD.useState(defaultPopupVisible || false), _React$useState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $8SyCD.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $8SyCD.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $8SyCD.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $8SyCD.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $8SyCD.useState(false), _React$useState10 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $8SyCD.useState(null), _React$useState12 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $8SyCD.useState([
            0,
            0
        ]), _React$useState14 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $352ab3810eedec3c$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $bf62ec175f8bda4d$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has("click");
        var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        var triggerAlign = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $72f6631ae4007023$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $8SyCD.useMemo(function() {
            var baseClassName = (0, $4e8ed5c9b9b5cc45$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $8SyCD.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $8SyCD.useState(0), _React$useState16 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $8SyCD.useState(0), _React$useState18 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $4780053ddcfa5af6$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has("hover");
        var hoverToHide = hideActions.has("hover");
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter() {
                // Only trigger re-open when popup is visible
                if (mergedOpen || inMotion) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay);
            wrapperAction("onPointerLeave", false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has("contextMenu")) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $8SyCD.cloneElement(child, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $8SyCD.createElement((0, $e84c5fc775a79577$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $8SyCD.createElement((0, $54e4acdcf455b3d8$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $8SyCD.createElement((0, $4aa61ffc3ae57c13$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $639aa9e1edacf68a$export$2e2bcd8739ae039 = $639aa9e1edacf68a$export$55e99723d7f71b47((0, $5691ab22d5134673$export$2e2bcd8739ae039));





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
var $5fd98d6416933aad$var$ESC = (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC, $5fd98d6416933aad$var$TAB = (0, $5ebc594569656f88$export$2e2bcd8739ae039).TAB;
function $5fd98d6416933aad$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $8SyCD.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $5fd98d6416933aad$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $5fd98d6416933aad$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $8SyCD.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}



var $8SyCD = parcelRequire("8SyCD");

var $c0576b6ae5c54775$var$Overlay = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $8SyCD.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === "function") overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, overlayNode === null || overlayNode === void 0 ? void 0 : overlayNode.ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(overlayNode, {
        ref: (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $c0576b6ae5c54775$export$2e2bcd8739ae039 = $c0576b6ae5c54775$var$Overlay;


var $638f04a694bde789$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $638f04a694bde789$var$targetOffset = [
    0,
    0
];
var $638f04a694bde789$var$placements = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $638f04a694bde789$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $638f04a694bde789$var$targetOffset
    }
};
var $638f04a694bde789$export$2e2bcd8739ae039 = $638f04a694bde789$var$placements;


var $f4f116728f208f88$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $f4f116728f208f88$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $638f04a694bde789$export$2e2bcd8739ae039) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $f4f116728f208f88$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = "visible" in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $5fd98d6416933aad$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $c0576b6ae5c54775$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === "function") return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ("minOverlayWidthMatchTrigger" in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $5a9f4dc5cf4fdd27$export$c1cec34af06bcf7)(children) ? (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(childRef, children.ref) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) triggerHideAction = [
        "click"
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $639aa9e1edacf68a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(overlayClassName, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $f4f116728f208f88$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).forwardRef($f4f116728f208f88$var$Dropdown);


var $ffea931b2b562e41$export$2e2bcd8739ae039 = (0, $f4f116728f208f88$export$2e2bcd8739ae039);














var $8SyCD = parcelRequire("8SyCD");







var $8SyCD = parcelRequire("8SyCD");


var $ed5cc04cc744e78a$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $ed5cc04cc744e78a$var$UNDEFINED = undefined;
function $ed5cc04cc744e78a$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $ed5cc04cc744e78a$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $8SyCD.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $ed5cc04cc744e78a$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $ed5cc04cc744e78a$var$UNDEFINED,
        overflowY: mergedHidden ? "hidden" : $ed5cc04cc744e78a$var$UNDEFINED,
        order: responsive ? order : $ed5cc04cc744e78a$var$UNDEFINED,
        pointerEvents: mergedHidden ? "none" : $ed5cc04cc744e78a$var$UNDEFINED,
        position: mergedHidden ? "absolute" : $ed5cc04cc744e78a$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps["aria-hidden"] = true;
    var itemNode = /*#__PURE__*/ $8SyCD.createElement(Component, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(!invalidate && prefixCls, className),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $ed5cc04cc744e78a$var$Item = /*#__PURE__*/ $8SyCD.forwardRef($ed5cc04cc744e78a$var$InternalItem);
$ed5cc04cc744e78a$var$Item.displayName = "Item";
var $ed5cc04cc744e78a$export$2e2bcd8739ae039 = $ed5cc04cc744e78a$var$Item;





var $8SyCD = parcelRequire("8SyCD");


function $2f75ceb0d0e69d39$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === "undefined") (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $da24e35112c932ff$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $8SyCD.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $2f75ceb0d0e69d39$export$2e2bcd8739ae039)(function() {
                (0, $b4e4ce7bd3c993b9$exports.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $da24e35112c932ff$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $8SyCD.useState(defaultValue), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
var $89050fe1d8103fba$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext(null);


var $4472dbc478d6778d$var$_excluded = [
    "component"
], $4472dbc478d6778d$var$_excluded2 = [
    "className"
], $4472dbc478d6778d$var$_excluded3 = [
    "className"
];
var $4472dbc478d6778d$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $8SyCD.useContext((0, $89050fe1d8103fba$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $4472dbc478d6778d$var$_excluded);
        return /*#__PURE__*/ $8SyCD.createElement(Component, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(context, $4472dbc478d6778d$var$_excluded2);
    var className = props.className, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $4472dbc478d6778d$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $8SyCD.createElement((0, $89050fe1d8103fba$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $8SyCD.createElement((0, $ed5cc04cc744e78a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(contextClassName, className)
    }, restContext, restProps)));
};
var $4472dbc478d6778d$var$RawItem = /*#__PURE__*/ $8SyCD.forwardRef($4472dbc478d6778d$var$InternalRawItem);
$4472dbc478d6778d$var$RawItem.displayName = "RawItem";
var $4472dbc478d6778d$export$2e2bcd8739ae039 = $4472dbc478d6778d$var$RawItem;



var $5b394f3516e3547d$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $5b394f3516e3547d$var$RESPONSIVE = "responsive";
var $5b394f3516e3547d$var$INVALIDATE = "invalidate";
function $5b394f3516e3547d$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $5b394f3516e3547d$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $5b394f3516e3547d$var$_excluded);
    var fullySSR = ssr === "full";
    var notifyEffectUpdate = (0, $da24e35112c932ff$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $da24e35112c932ff$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $da24e35112c932ff$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $da24e35112c932ff$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $da24e35112c932ff$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $da24e35112c932ff$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $8SyCD.useState)(null), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)(null), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $8SyCD.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $8SyCD.useState)(false), _useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $5b394f3516e3547d$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $5b394f3516e3547d$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
    var mergedData = (0, $8SyCD.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === "number") items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $8SyCD.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $8SyCD.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === "function") return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $8SyCD.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone["delete"](key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: "absolute",
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function internalRenderItemNode(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $8SyCD.createElement((0, $89050fe1d8103fba$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $8SyCD.createElement((0, $ed5cc04cc744e78a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $5b394f3516e3547d$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $8SyCD.createElement((0, $ed5cc04cc744e78a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $8SyCD.createElement((0, $89050fe1d8103fba$export$79f16dd643143c25).Provider, {
        value: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $8SyCD.createElement(Component, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $8SyCD.createElement((0, $ed5cc04cc744e78a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $5b394f3516e3547d$var$ForwardOverflow = /*#__PURE__*/ $8SyCD.forwardRef($5b394f3516e3547d$var$Overflow);
$5b394f3516e3547d$var$ForwardOverflow.displayName = "Overflow";
$5b394f3516e3547d$var$ForwardOverflow.Item = (0, $4472dbc478d6778d$export$2e2bcd8739ae039);
$5b394f3516e3547d$var$ForwardOverflow.RESPONSIVE = $5b394f3516e3547d$var$RESPONSIVE;
$5b394f3516e3547d$var$ForwardOverflow.INVALIDATE = $5b394f3516e3547d$var$INVALIDATE;
var // Convert to generic type
$5b394f3516e3547d$export$2e2bcd8739ae039 = $5b394f3516e3547d$var$ForwardOverflow;


var $396895c1c3d96329$export$2e2bcd8739ae039 = (0, $5b394f3516e3547d$export$2e2bcd8739ae039);





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
var $1666be64750afaf1$export$26537912ea160acd = /*#__PURE__*/ $8SyCD.createContext(null);
function $1666be64750afaf1$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $1666be64750afaf1$export$a276eb4e9be640f8(eventKey) {
    var id = $8SyCD.useContext($1666be64750afaf1$export$26537912ea160acd);
    return $1666be64750afaf1$export$80c871fe8d6b896(id, eventKey);
}





var $8SyCD = parcelRequire("8SyCD");


var $772b4bb03368be2b$var$_excluded = [
    "children",
    "locked"
];
var $772b4bb03368be2b$export$c7e742effb1c51e2 = /*#__PURE__*/ $8SyCD.createContext(null);
function $772b4bb03368be2b$var$mergeProps(origin, target) {
    var clone = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $772b4bb03368be2b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $772b4bb03368be2b$var$_excluded);
    var context = $8SyCD.useContext($772b4bb03368be2b$export$c7e742effb1c51e2);
    var inheritableContext = (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        return $772b4bb03368be2b$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $8SyCD.createElement($772b4bb03368be2b$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}




var $8SyCD = parcelRequire("8SyCD");
var $2a06b1ba7a6808c6$var$EmptyList = [];
var $2a06b1ba7a6808c6$export$d9ffb5bfd108b003 = /*#__PURE__*/ $8SyCD.createContext(null);
function $2a06b1ba7a6808c6$export$e295b0c537d32d7d() {
    return $8SyCD.useContext($2a06b1ba7a6808c6$export$d9ffb5bfd108b003);
}
var $2a06b1ba7a6808c6$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $8SyCD.createContext($2a06b1ba7a6808c6$var$EmptyList);
function $2a06b1ba7a6808c6$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $8SyCD.useContext($2a06b1ba7a6808c6$export$54d9e16aa4c8a7fa);
    return $8SyCD.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $2a06b1ba7a6808c6$export$f0b9e0db98edfa53 = /*#__PURE__*/ $8SyCD.createContext(null);



var $8SyCD = parcelRequire("8SyCD");
var $37fea06df14b678b$var$PrivateContext = /*#__PURE__*/ $8SyCD.createContext({});
var $37fea06df14b678b$export$2e2bcd8739ae039 = $37fea06df14b678b$var$PrivateContext;




var $8SyCD = parcelRequire("8SyCD");




function $131a721d4e57a8b6$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $1f0413060b1cb2c2$export$2e2bcd8739ae039)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            "input",
            "select",
            "textarea",
            "button"
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === "a" && !!node.getAttribute("href");
        // Get tabIndex
        var tabIndexAttr = node.getAttribute("tabindex");
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $131a721d4e57a8b6$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(node.querySelectorAll("*")).filter(function(child) {
        return $131a721d4e57a8b6$var$focusable(child, includePositive);
    });
    if ($131a721d4e57a8b6$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $131a721d4e57a8b6$var$lastFocusElement = null;
function $131a721d4e57a8b6$export$79fea02f7a83293d() {
    $131a721d4e57a8b6$var$lastFocusElement = document.activeElement;
}
function $131a721d4e57a8b6$export$8785654047fe7352() {
    $131a721d4e57a8b6$var$lastFocusElement = null;
}
function $131a721d4e57a8b6$export$fac0a9974415d98f() {
    if ($131a721d4e57a8b6$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $131a721d4e57a8b6$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $131a721d4e57a8b6$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $131a721d4e57a8b6$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}



// destruct to reduce minify size
var $bc929647f78c5366$var$LEFT = (0, $5ebc594569656f88$export$2e2bcd8739ae039).LEFT, $bc929647f78c5366$var$RIGHT = (0, $5ebc594569656f88$export$2e2bcd8739ae039).RIGHT, $bc929647f78c5366$var$UP = (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP, $bc929647f78c5366$var$DOWN = (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN, $bc929647f78c5366$var$ENTER = (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER, $bc929647f78c5366$var$ESC = (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC, $bc929647f78c5366$var$HOME = (0, $5ebc594569656f88$export$2e2bcd8739ae039).HOME, $bc929647f78c5366$var$END = (0, $5ebc594569656f88$export$2e2bcd8739ae039).END;
var $bc929647f78c5366$var$ArrowKeys = [
    $bc929647f78c5366$var$UP,
    $bc929647f78c5366$var$DOWN,
    $bc929647f78c5366$var$LEFT,
    $bc929647f78c5366$var$RIGHT
];
function $bc929647f78c5366$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _inline, _horizontal, _vertical, _offsets;
    var prev = "prev";
    var next = "next";
    var children = "children";
    var parent = "parent";
    // Inline enter is special that we use unique operation
    if (mode === "inline" && which === $bc929647f78c5366$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (_inline = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_inline, $bc929647f78c5366$var$UP, prev), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_inline, $bc929647f78c5366$var$DOWN, next), _inline);
    var horizontal = (_horizontal = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_horizontal, $bc929647f78c5366$var$LEFT, isRtl ? next : prev), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_horizontal, $bc929647f78c5366$var$RIGHT, isRtl ? prev : next), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_horizontal, $bc929647f78c5366$var$DOWN, children), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_horizontal, $bc929647f78c5366$var$ENTER, children), _horizontal);
    var vertical = (_vertical = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$UP, prev), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$DOWN, next), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$ENTER, children), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$ESC, parent), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$LEFT, isRtl ? children : parent), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_vertical, $bc929647f78c5366$var$RIGHT, isRtl ? parent : children), _vertical);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? "" : "Sub")]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $bc929647f78c5366$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute("data-menu-list")) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $bc929647f78c5366$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
/**
 * Get focusable elements from the element set under provided container
 */ function $bc929647f78c5366$var$getFocusableElements(container, elements) {
    var list = (0, $131a721d4e57a8b6$export$bbc7b5f11aba534b)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $bc929647f78c5366$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $bc929647f78c5366$var$getFocusableElements(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
function $bc929647f78c5366$export$2e2bcd8739ae039(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $8SyCD.useRef();
    var activeRef = $8SyCD.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $8SyCD.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($bc929647f78c5366$var$ArrowKeys, [
            $bc929647f78c5366$var$ENTER,
            $bc929647f78c5366$var$ESC,
            $bc929647f78c5366$var$HOME,
            $bc929647f78c5366$var$END
        ]).includes(which)) {
            // Convert key to elements
            var elements;
            var key2element;
            var element2key;
            // >>> Wrap as function since we use raf for some case
            var refreshElements = function refreshElements() {
                elements = new Set();
                key2element = new Map();
                element2key = new Map();
                var keys = getKeys();
                keys.forEach(function(key) {
                    var element = document.querySelector("[data-menu-id='".concat((0, $1666be64750afaf1$export$80c871fe8d6b896)(id, key), "']"));
                    if (element) {
                        elements.add(element);
                        element2key.set(element, key);
                        key2element.set(key, element);
                    }
                });
                return elements;
            };
            refreshElements();
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $bc929647f78c5366$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $bc929647f78c5366$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $bc929647f78c5366$var$HOME && which !== $bc929647f78c5366$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($bc929647f78c5366$var$ArrowKeys.includes(which) || [
                $bc929647f78c5366$var$HOME,
                $bc929647f78c5366$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector("a");
                    if (link !== null && link !== void 0 && link.getAttribute("href")) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $bc929647f78c5366$var$HOME,
                $bc929647f78c5366$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === "inline") parentQueryContainer = containerRef.current;
                else parentQueryContainer = $bc929647f78c5366$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $bc929647f78c5366$var$getFocusableElements(parentQueryContainer, elements);
                if (which === $bc929647f78c5366$var$HOME) targetElement = focusableElements[0];
                else if (which === $bc929647f78c5366$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $bc929647f78c5366$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
                    // Async should resync elements
                    refreshElements();
                    var controlId = focusMenuElement.getAttribute("aria-controls");
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $bc929647f78c5366$var$getNextFocusElement(subQueryContainer, elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}





var $8SyCD = parcelRequire("8SyCD");

function $1d8868b000a2d4fc$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


var $d676ad41195b46e0$var$PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__";
var $d676ad41195b46e0$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($d676ad41195b46e0$var$PATH_SPLIT);
};
var $d676ad41195b46e0$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($d676ad41195b46e0$var$PATH_SPLIT);
};
var $d676ad41195b46e0$export$20a0132c46ce5b04 = "rc-menu-more";
function $d676ad41195b46e0$export$2e2bcd8739ae039() {
    var _React$useState = $8SyCD.useState({}), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $8SyCD.useRef)(new Map());
    var path2keyRef = (0, $8SyCD.useRef)(new Map());
    var _React$useState3 = $8SyCD.useState([]), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $8SyCD.useRef)(0);
    var destroyRef = (0, $8SyCD.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $8SyCD.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $d676ad41195b46e0$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $1d8868b000a2d4fc$export$7693db51ef834b40)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $8SyCD.useCallback)(function(key, keyPath) {
        var connectedPath = $d676ad41195b46e0$var$getPathStr(keyPath);
        path2keyRef.current["delete"](connectedPath);
        key2pathRef.current["delete"](key);
    }, []);
    var refreshOverflowKeys = (0, $8SyCD.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $8SyCD.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || "";
        var keys = $d676ad41195b46e0$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($d676ad41195b46e0$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $8SyCD.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($d676ad41195b46e0$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $8SyCD.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($d676ad41195b46e0$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $8SyCD.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $8SyCD = parcelRequire("8SyCD");
function $e79f4bfdefe53a4c$export$2e2bcd8739ae039(func) {
    var funRef = $8SyCD.useRef(func);
    funRef.current = func;
    var callback = $8SyCD.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}




var $8SyCD = parcelRequire("8SyCD");

var $082db7aeb48627af$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $082db7aeb48627af$var$internalId = 0;
function $082db7aeb48627af$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(id, {
        value: id
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $8SyCD.useEffect(function() {
        $082db7aeb48627af$var$internalId += 1;
        var newId = "".concat($082db7aeb48627af$var$uniquePrefix, "-").concat($082db7aeb48627af$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}


















var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");

function $c707269e42d61032$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $8SyCD = parcelRequire("8SyCD");

function $981fb0a7847d474b$export$2e2bcd8739ae039(level) {
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== "inline") return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}




var $8SyCD = parcelRequire("8SyCD");
function $e3f726cd850f53d6$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === "function") iconNode = /*#__PURE__*/ $8SyCD.createElement(icon, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props));
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}




var $b18a891d698cdd5e$var$_excluded = [
    "item"
];
function $b18a891d698cdd5e$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $b18a891d698cdd5e$var$_excluded);
    Object.defineProperty(restInfo, "item", {
        get: function get() {
            (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future.");
            return item;
        }
    });
    return restInfo;
}


var $fb94fb127dd1a31f$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $fb94fb127dd1a31f$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $fb94fb127dd1a31f$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $fb94fb127dd1a31f$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $9cb2c16f15be24ce$export$2e2bcd8739ae039)(LegacyMenuItem, _React$Component);
    var _super = (0, $721e716a80b17452$export$2e2bcd8739ae039)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_this$props, $fb94fb127dd1a31f$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(restProps, [
                    "eventKey",
                    "popupClassName",
                    "popupOffset",
                    "onTitleClick"
                ]);
                (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!attribute, "`attribute` of Menu.Item is deprecated. Please pass attribute directly.");
                return /*#__PURE__*/ $8SyCD.createElement((0, $396895c1c3d96329$export$2e2bcd8739ae039).Item, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, attribute, {
                    title: typeof title === "string" ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($8SyCD.Component);
/**
 * Real Menu Item component
 */ var $fb94fb127dd1a31f$var$InternalMenuItem = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $fb94fb127dd1a31f$var$_excluded2);
    var domDataId = (0, $1666be64750afaf1$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $8SyCD.useContext((0, $37fea06df14b678b$export$2e2bcd8739ae039)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $8SyCD.useRef();
    var elementRef = $8SyCD.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(ref, elementRef);
    var connectedKeys = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $c707269e42d61032$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_useActive, $fb94fb127dd1a31f$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $981fb0a7847d474b$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $b18a891d698cdd5e$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $b18a891d698cdd5e$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === "option") optionRoleProps["aria-selected"] = selected;
    var renderNode = /*#__PURE__*/ $8SyCD.createElement($fb94fb127dd1a31f$var$LegacyMenuItem, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? "none" : role || "menuitem",
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, restProps, activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(itemCls, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-active"), active), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-selected"), selected), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-disabled"), mergedDisabled), _classNames), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $8SyCD.createElement((0, $e3f726cd850f53d6$export$2e2bcd8739ae039), {
        props: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $fb94fb127dd1a31f$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $2a06b1ba7a6808c6$export$e295b0c537d32d7d)();
    var connectedKeyPath = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $8SyCD.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $8SyCD.createElement($fb94fb127dd1a31f$var$InternalMenuItem, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    }));
}
var $fb94fb127dd1a31f$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($fb94fb127dd1a31f$var$MenuItem);








var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");


var $0b1e3fc48163c8eb$var$_excluded = [
    "className",
    "children"
];
var $0b1e3fc48163c8eb$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $0b1e3fc48163c8eb$var$_excluded);
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $8SyCD.createElement("ul", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === "inline" ? "inline" : "vertical"), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $0b1e3fc48163c8eb$var$SubMenuList = /*#__PURE__*/ $8SyCD.forwardRef($0b1e3fc48163c8eb$var$InternalSubMenuList);
$0b1e3fc48163c8eb$var$SubMenuList.displayName = "SubMenuList";
var $0b1e3fc48163c8eb$export$2e2bcd8739ae039 = $0b1e3fc48163c8eb$var$SubMenuList;





var $8SyCD = parcelRequire("8SyCD");
function $9475542e6197d568$export$cd230e97e668be9(children, keyPath) {
    return (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children).map(function(child, index) {
        if (/*#__PURE__*/ $8SyCD.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(keyPath), [
                index
            ]).join("-"));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $8SyCD.cloneElement(child, cloneProps);
        }
        return child;
    });
}








var $8SyCD = parcelRequire("8SyCD");




var $467b92e05ee2a358$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $467b92e05ee2a358$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    }
};
var $467b92e05ee2a358$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $467b92e05ee2a358$var$autoAdjustOverflow
    }
};
var $467b92e05ee2a358$export$2e2bcd8739ae039 = $467b92e05ee2a358$export$803cd8101b6c182b;


function $4f37838eb0a9facc$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


var $debedb0a2cf4d73d$var$popupPlacementMap = {
    horizontal: "bottomLeft",
    vertical: "rightTop",
    "vertical-left": "rightTop",
    "vertical-right": "leftTop"
};
function $debedb0a2cf4d73d$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, (0, $467b92e05ee2a358$export$e2b3f69b0a16e1f)), builtinPlacements) : (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, (0, $467b92e05ee2a358$export$803cd8101b6c182b)), builtinPlacements);
    var popupPlacement = $debedb0a2cf4d73d$var$popupPlacementMap[mode];
    var targetMotion = (0, $4f37838eb0a9facc$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    var targetMotionRef = $8SyCD.useRef(targetMotion);
    if (mode !== "inline") /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $8SyCD.useRef();
    $8SyCD.useEffect(function() {
        visibleRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $639aa9e1edacf68a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-popup"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === "horizontal" ? "minWidth" : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}










var $8SyCD = parcelRequire("8SyCD");




function $232006840302a1a1$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = "inline";
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $8SyCD.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $8SyCD.useState(!sameModeRef.current), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $8SyCD.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, (0, $4f37838eb0a9facc$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $8SyCD.createElement((0, $772b4bb03368be2b$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $8SyCD.createElement((0, $0b1e3fc48163c8eb$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





var $0a5cf64597d10a8f$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "popupStyle",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $0a5cf64597d10a8f$var$_excluded2 = [
    "active"
];
var $0a5cf64597d10a8f$var$InternalSubMenu = function InternalSubMenu(props) {
    var _classNames;
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $0a5cf64597d10a8f$var$_excluded);
    var domDataId = (0, $1666be64750afaf1$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $8SyCD.useContext((0, $37fea06df14b678b$export$2e2bcd8739ae039)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $8SyCD.useContext((0, $2a06b1ba7a6808c6$export$f0b9e0db98edfa53)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $8SyCD.useRef();
    var popupRef = $8SyCD.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
    var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $c707269e42d61032$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_useActive, $0a5cf64597d10a8f$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $8SyCD.useMemo(function() {
        if (active) return active;
        if (mode !== "inline") return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $981fb0a7847d474b$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === "inline") onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $e79f4bfdefe53a4c$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $b18a891d698cdd5e$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== "inline") onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === "string" ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $8SyCD.createElement((0, $e3f726cd850f53d6$export$2e2bcd8739ae039), {
        icon: mode !== "horizontal" ? mergedExpandIcon : undefined,
        props: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $8SyCD.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $8SyCD.useRef(mode);
    if (mode !== "inline" && connectedPath.length > 1) triggerModeRef.current = "vertical";
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $8SyCD.createElement((0, $debedb0a2cf4d73d$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== "inline",
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: /*#__PURE__*/ $8SyCD.createElement((0, $772b4bb03368be2b$export$2e2bcd8739ae039), {
                mode: triggerMode === "horizontal" ? "vertical" : triggerMode
            }, /*#__PURE__*/ $8SyCD.createElement((0, $0b1e3fc48163c8eb$export$2e2bcd8739ae039), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $8SyCD.createElement((0, $396895c1c3d96329$export$2e2bcd8739ae039).Item, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-open"), open), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-active"), mergedActive), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-selected"), childrenSelected), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled), _classNames)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $8SyCD.createElement((0, $232006840302a1a1$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $8SyCD.createElement((0, $772b4bb03368be2b$export$2e2bcd8739ae039), {
        onItemClick: onMergedItemClick,
        mode: mode === "horizontal" ? "vertical" : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
};
function $0a5cf64597d10a8f$export$2e2bcd8739ae039(props) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $9475542e6197d568$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $2a06b1ba7a6808c6$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $8SyCD.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $8SyCD.createElement($0a5cf64597d10a8f$var$InternalSubMenu, props, childList);
    return /*#__PURE__*/ $8SyCD.createElement((0, $2a06b1ba7a6808c6$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
}






var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");



var $6f7743c1b4881b15$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
], $6f7743c1b4881b15$var$_excluded2 = [
    "children"
];
var $6f7743c1b4881b15$var$InternalMenuItemGroup = function InternalMenuItemGroup(_ref) {
    var className = _ref.className, title = _ref.title, eventKey = _ref.eventKey, children = _ref.children, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $6f7743c1b4881b15$var$_excluded);
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $8SyCD.createElement("li", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $8SyCD.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === "string" ? title : undefined
    }, title), /*#__PURE__*/ $8SyCD.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
};
function $6f7743c1b4881b15$export$2e2bcd8739ae039(_ref2) {
    var children = _ref2.children, props = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref2, $6f7743c1b4881b15$var$_excluded2);
    var connectedKeyPath = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)(props.eventKey);
    var childList = (0, $9475542e6197d568$export$cd230e97e668be9)(children, connectedKeyPath);
    var measure = (0, $2a06b1ba7a6808c6$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $8SyCD.createElement($6f7743c1b4881b15$var$InternalMenuItemGroup, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "warnKey"
    ]), childList);
}




var $8SyCD = parcelRequire("8SyCD");



function $dfe735131839def8$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $8SyCD.useContext((0, $772b4bb03368be2b$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $2a06b1ba7a6808c6$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $8SyCD.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}




var $04f50551dfc99da7$var$_excluded = [
    "label",
    "children",
    "key",
    "type"
];
function $04f50551dfc99da7$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(opt) === "object") {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $04f50551dfc99da7$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === "group") {
                if (type === "group") // Group
                return /*#__PURE__*/ $8SyCD.createElement((0, $6f7743c1b4881b15$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $04f50551dfc99da7$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $8SyCD.createElement((0, $0a5cf64597d10a8f$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $04f50551dfc99da7$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === "divider") return /*#__PURE__*/ $8SyCD.createElement((0, $dfe735131839def8$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $8SyCD.createElement((0, $fb94fb127dd1a31f$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $04f50551dfc99da7$export$50458dc1a9a0f894(children, items, keyPath) {
    var childNodes = children;
    if (items) childNodes = $04f50551dfc99da7$var$convertItemsToNodes(items);
    return (0, $9475542e6197d568$export$cd230e97e668be9)(childNodes, keyPath);
}



var $07fb1b3658febad8$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $07fb1b3658febad8$var$EMPTY_LIST = [];
var $07fb1b3658febad8$var$Menu = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _childList$, _classNames;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-menu" : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "vertical" : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? "hover" : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? "..." : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $07fb1b3658febad8$var$_excluded);
    var childList = $8SyCD.useMemo(function() {
        return (0, $04f50551dfc99da7$export$50458dc1a9a0f894)(children, items, $07fb1b3658febad8$var$EMPTY_LIST);
    }, [
        children,
        items
    ]);
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $8SyCD.useRef();
    var uuid = (0, $082db7aeb48627af$export$2e2bcd8739ae039)(id);
    var isRtl = direction === "rtl";
    // ========================= Open =========================
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $07fb1b3658febad8$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $b4e4ce7bd3c993b9$exports.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $8SyCD.useState(mergedOpenKeys), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $8SyCD.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo = $8SyCD.useMemo(function() {
        if ((mode === "inline" || mode === "vertical") && inlineCollapsed) return [
            "vertical",
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useMemo, 2), mergedMode = _React$useMemo2[0], mergedInlineCollapsed = _React$useMemo2[1];
    var isInlineMode = mergedMode === "inline";
    var _React$useState5 = $8SyCD.useState(mergedMode), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $8SyCD.useState(mergedInlineCollapsed), _React$useState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $8SyCD.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($07fb1b3658febad8$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $8SyCD.useState(0), _React$useState10 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== "horizontal" || disabledOverflow;
    // Cache
    $8SyCD.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $8SyCD.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $d676ad41195b46e0$export$2e2bcd8739ae039)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $8SyCD.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $8SyCD.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $8SyCD.useEffect(function() {
        refreshOverflowKeys(allVisible ? $07fb1b3658febad8$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $e79f4bfdefe53a4c$export$2e2bcd8739ae039)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $e79f4bfdefe53a4c$export$2e2bcd8739ae039)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $8SyCD.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                if (shouldFocusKey) {
                    var _containerRef$current, _containerRef$current2, _containerRef$current3;
                    (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current2 = _containerRef$current.querySelector("li[data-menu-id='".concat((0, $1666be64750afaf1$export$80c871fe8d6b896)(uuid, shouldFocusKey), "']"))) === null || _containerRef$current2 === void 0 || (_containerRef$current3 = _containerRef$current2.focus) === null || _containerRef$current3 === void 0 || _containerRef$current3.call(_containerRef$current2, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $07fb1b3658febad8$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== "inline") triggerOpenKeys($07fb1b3658febad8$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $e79f4bfdefe53a4c$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $b18a891d698cdd5e$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $e79f4bfdefe53a4c$export$2e2bcd8739ae039)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== "inline") {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $81937b17d7a39a0b$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $bc929647f78c5366$export$2e2bcd8739ae039)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $8SyCD.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $8SyCD.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== "horizontal" || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $8SyCD.createElement((0, $772b4bb03368be2b$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $8SyCD.createElement((0, $396895c1c3d96329$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $fb94fb127dd1a31f$export$2e2bcd8739ae039),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-rtl"), isRtl), _classNames), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $8SyCD.createElement((0, $0a5cf64597d10a8f$export$2e2bcd8739ae039), {
                eventKey: (0, $d676ad41195b46e0$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== "horizontal" || disabledOverflow ? (0, $396895c1c3d96329$export$2e2bcd8739ae039).INVALIDATE : (0, $396895c1c3d96329$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $8SyCD.createElement((0, $37fea06df14b678b$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $1666be64750afaf1$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $8SyCD.createElement((0, $772b4bb03368be2b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $8SyCD.createElement((0, $2a06b1ba7a6808c6$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $8SyCD.createElement("div", {
        style: {
            display: "none"
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $8SyCD.createElement((0, $2a06b1ba7a6808c6$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, childList)))));
});
var $07fb1b3658febad8$export$2e2bcd8739ae039 = $07fb1b3658febad8$var$Menu;







var $8a5b1a1fc083948f$var$ExportMenu = (0, $07fb1b3658febad8$export$2e2bcd8739ae039);
$8a5b1a1fc083948f$var$ExportMenu.Item = (0, $fb94fb127dd1a31f$export$2e2bcd8739ae039);
$8a5b1a1fc083948f$var$ExportMenu.SubMenu = (0, $0a5cf64597d10a8f$export$2e2bcd8739ae039);
$8a5b1a1fc083948f$var$ExportMenu.ItemGroup = (0, $6f7743c1b4881b15$export$2e2bcd8739ae039);
$8a5b1a1fc083948f$var$ExportMenu.Divider = (0, $dfe735131839def8$export$2e2bcd8739ae039);
var $8a5b1a1fc083948f$export$2e2bcd8739ae039 = $8a5b1a1fc083948f$var$ExportMenu;




var $8SyCD = parcelRequire("8SyCD");


var $decd0775e7a69cc9$var$OperationNode = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, id = props.id, tabs = props.tabs, locale = props.locale, mobile = props.mobile, _props$moreIcon = props.moreIcon, moreIcon = _props$moreIcon === void 0 ? "More" : _props$moreIcon, moreTransitionName = props.moreTransitionName, style = props.style, className = props.className, editable = props.editable, tabBarGutter = props.tabBarGutter, rtl = props.rtl, removeAriaLabel = props.removeAriaLabel, onTabClick = props.onTabClick, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $8SyCD.useState)(false), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)(null), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $8SyCD.createElement((0, $8a5b1a1fc083948f$export$2e2bcd8739ae039), {
        onClick: function onClick(_ref) {
            var key = _ref.key, domEvent = _ref.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : "expanded dropdown"
    }, tabs.map(function(tab) {
        var closable = tab.closable, disabled = tab.disabled, closeIcon = tab.closeIcon, key = tab.key, label = tab.label;
        var removable = (0, $60ec8506026e0a49$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $8SyCD.createElement((0, $fb94fb127dd1a31f$export$2e2bcd8739ae039), {
            key: key,
            id: "".concat(popupId, "-").concat(key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(key),
            disabled: disabled
        }, /*#__PURE__*/ $8SyCD.createElement("span", null, label), removable && /*#__PURE__*/ $8SyCD.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || "remove",
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN,
                (0, $5ebc594569656f88$export$2e2bcd8739ae039).SPACE,
                (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).SPACE:
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $8SyCD.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $8SyCD.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, rtl ? "marginRight" : "marginLeft", tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = "hidden";
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $8SyCD.createElement((0, $ffea931b2b562e41$export$2e2bcd8739ae039), {
        prefixCls: dropdownPrefix,
        overlay: menu,
        trigger: [
            "hover"
        ],
        visible: tabs.length ? open : false,
        transitionName: moreTransitionName,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, /*#__PURE__*/ $8SyCD.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $8SyCD.createElement((0, $d9996f739ffe8d68$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $decd0775e7a69cc9$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.memo($decd0775e7a69cc9$var$OperationNode, function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});






var $8SyCD = parcelRequire("8SyCD");

var $5a6bee3eac1a957b$var$TabNode = function TabNode(props) {
    var _classNames;
    var prefixCls = props.prefixCls, id = props.id, active = props.active, _props$tab = props.tab, key = _props$tab.key, label = _props$tab.label, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, icon = _props$tab.icon, closable = props.closable, renderWrapper = props.renderWrapper, removeAriaLabel = props.removeAriaLabel, editable = props.editable, onClick = props.onClick, onFocus = props.onFocus, style = props.style;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = (0, $60ec8506026e0a49$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var labelNode = $8SyCD.useMemo(function() {
        return icon && typeof label === "string" ? /*#__PURE__*/ $8SyCD.createElement("span", null, label) : label;
    }, [
        label,
        icon
    ]);
    var node = /*#__PURE__*/ $8SyCD.createElement("div", {
        key: key,
        "data-node-key": (0, $60ec8506026e0a49$export$c55417729a96230c)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(tabPrefix, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(tabPrefix, "-with-remove"), removable), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(tabPrefix, "-active"), active), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : 0,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            if ([
                (0, $5ebc594569656f88$export$2e2bcd8739ae039).SPACE,
                (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER
            ].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        },
        onFocus: onFocus
    }, icon && /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(tabPrefix, "-icon")
    }, icon), label && labelNode), removable && /*#__PURE__*/ $8SyCD.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || "remove",
        tabIndex: 0,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $5a6bee3eac1a957b$export$2e2bcd8739ae039 = $5a6bee3eac1a957b$var$TabNode;


var $226f71bdd1437b7f$var$getTabSize = function getTabSize(tab, containerRect) {
    // tabListRef
    var offsetWidth = tab.offsetWidth, offsetHeight = tab.offsetHeight, offsetTop = tab.offsetTop, offsetLeft = tab.offsetLeft;
    var _tab$getBoundingClien = tab.getBoundingClientRect(), width = _tab$getBoundingClien.width, height = _tab$getBoundingClien.height, x = _tab$getBoundingClien.x, y = _tab$getBoundingClien.y;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        x - containerRect.x,
        y - containerRect.y
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
var $226f71bdd1437b7f$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        var _refObj$current$getBo = refObj.current.getBoundingClientRect(), width = _refObj$current$getBo.width, height = _refObj$current$getBo.height;
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $226f71bdd1437b7f$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
var $226f71bdd1437b7f$var$TabNavList = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _classNames;
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, indicatorSize = props.indicatorSize;
    var _React$useContext = $8SyCD.useContext((0, $0fbc8c0feb7aa1f8$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var containerRef = (0, $8SyCD.useRef)(null);
    var extraLeftRef = (0, $8SyCD.useRef)(null);
    var extraRightRef = (0, $8SyCD.useRef)(null);
    var tabsWrapperRef = (0, $8SyCD.useRef)(null);
    var tabListRef = (0, $8SyCD.useRef)(null);
    var operationsRef = (0, $8SyCD.useRef)(null);
    var innerAddButtonRef = (0, $8SyCD.useRef)(null);
    var tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
    var _useSyncState = (0, $788de6539d1721ae$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "left" : "right"
        });
    }), _useSyncState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $788de6539d1721ae$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "top" : "bottom"
        });
    }), _useSyncState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $8SyCD.useState)([
        0,
        0
    ]), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)([
        0,
        0
    ]), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $8SyCD.useState)([
        0,
        0
    ]), _useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $8SyCD.useState)([
        0,
        0
    ]), _useState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $66b6be425b8c8a17$export$aefd2a30eb6d999e)(new Map()), _useUpdateState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $a96afca128b28df7$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $226f71bdd1437b7f$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $226f71bdd1437b7f$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $226f71bdd1437b7f$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $226f71bdd1437b7f$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = containerExcludeExtraSizeValue < tabContentSizeValue + addSizeValue;
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $8SyCD.useRef)(null);
    var _useState9 = (0, $8SyCD.useState)(), _useState10 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $ed19131f9b455fd8$export$2e2bcd8739ae039)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $8SyCD.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $1c9ce0a4c93de234$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPosition === "top" || tabPosition === "bottom") tabNodeStyle[rtl ? "marginRight" : "marginLeft"] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $8SyCD.createElement((0, $5a6bee3eac1a957b$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onFocus: function onFocus() {
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var _tabListRef$current;
            var newSizes = new Map();
            var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current2;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector('[data-node-key="'.concat((0, $60ec8506026e0a49$export$c55417729a96230c)(key), '"]'));
                if (btnNode) {
                    var _getTabSize = $226f71bdd1437b7f$var$getTabSize(btnNode, listRect), _getTabSize2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getTabSize, 4), width = _getTabSize2[0], height = _getTabSize2[1], left = _getTabSize2[2], top = _getTabSize2[3];
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    };
    (0, $8SyCD.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_")
    ]);
    var onListHolderResize = (0, $66b6be425b8c8a17$export$2e2bcd8739ae039)(function() {
        // Update wrapper records
        var containerSize = $226f71bdd1437b7f$var$getSize(containerRef);
        var extraLeftSize = $226f71bdd1437b7f$var$getSize(extraLeftRef);
        var extraRightSize = $226f71bdd1437b7f$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $226f71bdd1437b7f$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $226f71bdd1437b7f$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $226f71bdd1437b7f$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(startHiddenTabs), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(endHiddenTabs));
    // =================== Link & Operations ===================
    var activeTabOffset = tabOffsets.get(activeKey);
    var _useIndicator = (0, $d330b750661f51f3$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        rtl: rtl,
        indicatorSize: indicatorSize
    }), indicatorStyle = _useIndicator.style;
    // ========================= Effect ========================
    (0, $8SyCD.useEffect)(function() {
        scrollToTab();
    // eslint-disable-next-line
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $60ec8506026e0a49$export$fac44ee5b035f737)(activeTabOffset),
        (0, $60ec8506026e0a49$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $8SyCD.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $8SyCD.createElement((0, $f567dbd1921abab9$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(wrapPrefix, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? "none" : undefined
        }
    }, tabNodes, /*#__PURE__*/ $8SyCD.createElement((0, $d9996f739ffe8d68$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? "hidden" : null
        })
    }), /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-ink-bar"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: indicatorStyle
    }))))), /*#__PURE__*/ $8SyCD.createElement((0, $decd0775e7a69cc9$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $8SyCD.createElement((0, $f567dbd1921abab9$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $226f71bdd1437b7f$export$2e2bcd8739ae039 = $226f71bdd1437b7f$var$TabNavList;





var $8SyCD = parcelRequire("8SyCD");
var $26df81a878799a55$var$TabPane = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, id = props.id, active = props.active, tabKey = props.tabKey, children = props.children;
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
var $26df81a878799a55$export$2e2bcd8739ae039 = $26df81a878799a55$var$TabPane;


var $403d7981ca3f430b$var$_excluded = [
    "renderTabBar"
], $403d7981ca3f430b$var$_excluded2 = [
    "label",
    "key"
];
// We have to create a TabNavList components.
var $403d7981ca3f430b$var$TabNavListWrapper = function TabNavListWrapper(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $403d7981ca3f430b$var$_excluded);
    var _React$useContext = $8SyCD.useContext((0, $0fbc8c0feb7aa1f8$export$2e2bcd8739ae039)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref2, $403d7981ca3f430b$var$_excluded2);
                return /*#__PURE__*/ $8SyCD.createElement((0, $26df81a878799a55$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $226f71bdd1437b7f$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ $8SyCD.createElement((0, $226f71bdd1437b7f$export$2e2bcd8739ae039), restProps);
};
var $403d7981ca3f430b$export$2e2bcd8739ae039 = $403d7981ca3f430b$var$TabNavListWrapper;









var $8SyCD = parcelRequire("8SyCD");


var $edd68d4a83320301$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className",
    "destroyInactiveTabPane"
];
var $edd68d4a83320301$var$TabPanelList = function TabPanelList(props) {
    var id = props.id, activeKey = props.activeKey, animated = props.animated, tabPosition = props.tabPosition, destroyInactiveTabPane = props.destroyInactiveTabPane;
    var _React$useContext = $8SyCD.useContext((0, $0fbc8c0feb7aa1f8$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(item) {
        var key = item.key, forceRender = item.forceRender, paneStyle = item.style, paneClassName = item.className, itemDestroyInactiveTabPane = item.destroyInactiveTabPane, restTabProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(item, $edd68d4a83320301$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $8SyCD.createElement((0, $981eb2f292da8c80$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref, ref) {
            var motionStyle = _ref.style, motionClassName = _ref.className;
            return /*#__PURE__*/ $8SyCD.createElement((0, $26df81a878799a55$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
};
var $edd68d4a83320301$export$2e2bcd8739ae039 = $edd68d4a83320301$var$TabPanelList;


var $bfb363099721722f$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "moreIcon",
    "moreTransitionName",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName",
    "indicatorSize"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $bfb363099721722f$var$uuid = 0;
var $bfb363099721722f$var$Tabs = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _classNames;
    var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tabs" : _props$prefixCls, className = props.className, items = props.items, direction = props.direction, activeKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, editable = props.editable, animated = props.animated, _props$tabPosition = props.tabPosition, tabPosition = _props$tabPosition === void 0 ? "top" : _props$tabPosition, tabBarGutter = props.tabBarGutter, tabBarStyle = props.tabBarStyle, tabBarExtraContent = props.tabBarExtraContent, locale = props.locale, moreIcon = props.moreIcon, moreTransitionName = props.moreTransitionName, destroyInactiveTabPane = props.destroyInactiveTabPane, renderTabBar = props.renderTabBar, onChange = props.onChange, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName, indicatorSize = props.indicatorSize, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $bfb363099721722f$var$_excluded);
    var tabs = $8SyCD.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(item) === "object" && "key" in item;
        });
    }, [
        items
    ]);
    var rtl = direction === "rtl";
    var mergedAnimated = (0, $21ea20a6809f53e5$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $8SyCD.useState)(false), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $8SyCD.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $fc01ea5e514846e5$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $8SyCD.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $8SyCD.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(null, {
        value: id
    }), _useMergedState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $8SyCD.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat($bfb363099721722f$var$uuid));
            $bfb363099721722f$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBarProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        moreIcon: moreIcon,
        moreTransitionName: moreTransitionName,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName,
        indicatorSize: indicatorSize
    });
    return /*#__PURE__*/ $8SyCD.createElement((0, $0fbc8c0feb7aa1f8$export$2e2bcd8739ae039).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-mobile"), mobile), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-editable"), editable), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-rtl"), rtl), _classNames), className)
    }, restProps), /*#__PURE__*/ $8SyCD.createElement((0, $403d7981ca3f430b$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $8SyCD.createElement((0, $edd68d4a83320301$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
});
var $bfb363099721722f$export$2e2bcd8739ae039 = $bfb363099721722f$var$Tabs;


var $336bf56b8acca016$export$2e2bcd8739ae039 = (0, $bfb363099721722f$export$2e2bcd8739ae039);






var $0fbf9fcbedc9e9e0$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $0fbf9fcbedc9e9e0$export$2e2bcd8739ae039(prefixCls) {
    var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = Object.assign({
        inkBar: true
    }, typeof animated === "object" ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, $0fbf9fcbedc9e9e0$var$motion), {
        motionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(prefixCls, "switch")
    });
    return mergedAnimated;
}



var $8SyCD = parcelRequire("8SyCD");


var $d298b0b106355a60$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d298b0b106355a60$var$filter(items) {
    return items.filter(function(item) {
        return item;
    });
}
function $d298b0b106355a60$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    var childrenItems = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children).map(function(node) {
        if (/*#__PURE__*/ $8SyCD.isValidElement(node)) {
            var key = node.key, props = node.props;
            var _a = props || {}, tab = _a.tab, restProps = $d298b0b106355a60$var$__rest(_a, [
                "tab"
            ]);
            var item = Object.assign(Object.assign({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $d298b0b106355a60$var$filter(childrenItems);
}










var $b219a2444a723b10$export$e801b802b037de6a = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideUpIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
var $b219a2444a723b10$export$f40f41df328ebc38 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideUpOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
var $b219a2444a723b10$export$dd9f089fa5e819fe = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideDownIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    }
});
var $b219a2444a723b10$export$f7243fdb9c27c3b7 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideDownOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    }
});
var $b219a2444a723b10$export$2ad3a07c3513a54 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideLeftIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
var $b219a2444a723b10$export$486fbda27512d5a9 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideLeftOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
var $b219a2444a723b10$export$dd03ad46dbbcd7e0 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideRightIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    }
});
var $b219a2444a723b10$export$db8e3c9b93664f34 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSlideRightOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    }
});
var $b219a2444a723b10$var$slideMotion = {
    "slide-up": {
        inKeyframes: $b219a2444a723b10$export$e801b802b037de6a,
        outKeyframes: $b219a2444a723b10$export$f40f41df328ebc38
    },
    "slide-down": {
        inKeyframes: $b219a2444a723b10$export$dd9f089fa5e819fe,
        outKeyframes: $b219a2444a723b10$export$f7243fdb9c27c3b7
    },
    "slide-left": {
        inKeyframes: $b219a2444a723b10$export$2ad3a07c3513a54,
        outKeyframes: $b219a2444a723b10$export$486fbda27512d5a9
    },
    "slide-right": {
        inKeyframes: $b219a2444a723b10$export$dd03ad46dbbcd7e0,
        outKeyframes: $b219a2444a723b10$export$db8e3c9b93664f34
    }
};
var $b219a2444a723b10$export$9018e60daecf7a6c = function(token, motionName) {
    var antCls = token.antCls;
    var motionCls = "".concat(antCls, "-").concat(motionName);
    var _slideMotion_motionName = $b219a2444a723b10$var$slideMotion[motionName], inKeyframes = _slideMotion_motionName.inKeyframes, outKeyframes = _slideMotion_motionName.outKeyframes;
    var _obj;
    return [
        (0, $9f4ece306a24a354$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n      ".concat(motionCls, "-enter,\n      ").concat(motionCls, "-appear\n    "), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            transform: "scale(0)",
            transformOrigin: "0% 0%",
            opacity: 0,
            animationTimingFunction: token.motionEaseOutQuint
        }, "&-prepare", {
            transform: "scale(1)"
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(motionCls, "-leave"), {
            animationTimingFunction: token.motionEaseInQuint
        }), _obj)
    ];
};


var $312902987c09925b$var$genMotionStyle = function(token) {
    var componentCls = token.componentCls, motionDurationSlow = token.motionDurationSlow;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-switch"), {
            "&-appear, &-enter": {
                transition: "none",
                "&-start": {
                    opacity: 0
                },
                "&-active": {
                    opacity: 1,
                    transition: "opacity ".concat(motionDurationSlow)
                }
            },
            "&-leave": {
                position: "absolute",
                transition: "none",
                inset: 0,
                "&-start": {
                    opacity: 1
                },
                "&-active": {
                    opacity: 0,
                    transition: "opacity ".concat(motionDurationSlow)
                }
            }
        })),
        // Follow code may reuse in other components
        [
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-down")
        ]
    ];
};
var $312902987c09925b$export$2e2bcd8739ae039 = $312902987c09925b$var$genMotionStyle;


var $bd4c1a4e9479d0aa$var$genCardStyle = function(token) {
    var componentCls = token.componentCls, tabsCardPadding = token.tabsCardPadding, cardBg = token.cardBg, cardGutter = token.cardGutter, colorBorderSecondary = token.colorBorderSecondary, itemSelectedColor = token.itemSelectedColor;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-card"), (_obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-tab"), {
        margin: 0,
        padding: tabsCardPadding,
        background: cardBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary),
        transition: "all ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-tab-active"), {
        color: itemSelectedColor,
        background: token.colorBgContainer
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-ink-bar"), {
        visibility: "hidden"
    }), _obj)), // ========================== Top & Bottom ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-top, &").concat(componentCls, "-bottom"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab + ").concat(componentCls, "-tab"), {
        marginLeft: {
            _skip_check_: true,
            value: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardGutter)
        }
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-top"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-tab"), {
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-tab-active"), {
        borderBottomColor: token.colorBgContainer
    }), _obj1))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-bottom"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-tab"), {
        borderRadius: "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG))
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-tab-active"), {
        borderTopColor: token.colorBgContainer
    }), _obj2))), // ========================== Left & Right ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-left, &").concat(componentCls, "-right"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab + ").concat(componentCls, "-tab"), {
        marginTop: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardGutter)
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-left"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-tab"), {
        borderRadius: {
            _skip_check_: true,
            value: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0 ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG))
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-tab-active"), {
        borderRightColor: {
            _skip_check_: true,
            value: token.colorBgContainer
        }
    }), _obj3))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-right"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-tab"), {
        borderRadius: {
            _skip_check_: true,
            value: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0")
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-tab-active"), {
        borderLeftColor: {
            _skip_check_: true,
            value: token.colorBgContainer
        }
    }), _obj4))), _obj5));
};
var $bd4c1a4e9479d0aa$var$genDropdownStyle = function(token) {
    var componentCls = token.componentCls, itemHoverColor = token.itemHoverColor, dropdownEdgeChildVerticalPadding = token.dropdownEdgeChildVerticalPadding;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-dropdown"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        position: "absolute",
        top: -9999,
        left: {
            _skip_check_: true,
            value: -9999
        },
        zIndex: token.zIndexPopup,
        display: "block",
        "&-hidden": {
            display: "none"
        }
    }, "".concat(componentCls, "-dropdown-menu"), {
        maxHeight: token.tabsDropdownHeight,
        margin: 0,
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding), " 0"),
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
            _skip_check_: true,
            value: "left"
        },
        listStyleType: "none",
        backgroundColor: token.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: token.borderRadiusLG,
        outline: "none",
        boxShadow: token.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)), {
            display: "flex",
            alignItems: "center",
            minWidth: token.tabsDropdownWidth,
            margin: 0,
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingXXS), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingSM)),
            color: token.colorText,
            fontWeight: "normal",
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            cursor: "pointer",
            transition: "all ".concat(token.motionDurationSlow),
            "> span": {
                flex: 1,
                whiteSpace: "nowrap"
            },
            "&-remove": {
                flex: "none",
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginSM
                },
                color: token.colorTextDescription,
                fontSize: token.fontSizeSM,
                background: "transparent",
                border: 0,
                cursor: "pointer",
                "&:hover": {
                    color: itemHoverColor
                }
            },
            "&:hover": {
                background: token.controlItemBgHover
            },
            "&-disabled": {
                "&, &:hover": {
                    color: token.colorTextDisabled,
                    background: "transparent",
                    cursor: "not-allowed"
                }
            }
        })
    })));
};
var $bd4c1a4e9479d0aa$var$genPositionStyle = function(token) {
    var componentCls = token.componentCls, margin = token.margin, colorBorderSecondary = token.colorBorderSecondary, horizontalMargin = token.horizontalMargin, verticalItemPadding = token.verticalItemPadding, verticalItemMargin = token.verticalItemMargin, calc = token.calc;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7;
    return _obj7 = {}, // ========================== Top & Bottom ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-top, ").concat(componentCls, "-bottom"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        flexDirection: "column"
    }, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj1 = {
        margin: horizontalMargin,
        "&::before": {
            position: "absolute",
            right: {
                _skip_check_: true,
                value: 0
            },
            left: {
                _skip_check_: true,
                value: 0
            },
            borderBottom: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary),
            content: "''"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-ink-bar"), {
        height: token.lineWidthBold,
        "&-animated": {
            transition: "width ".concat(token.motionDurationSlow, ", left ").concat(token.motionDurationSlow, ",\n            right ").concat(token.motionDurationSlow)
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-nav-wrap"), (_obj = {
        "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: token.controlHeight
        },
        "&::before": {
            left: {
                _skip_check_: true,
                value: 0
            },
            boxShadow: token.boxShadowTabsOverflowLeft
        },
        "&::after": {
            right: {
                _skip_check_: true,
                value: 0
            },
            boxShadow: token.boxShadowTabsOverflowRight
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-nav-wrap-ping-left::before"), {
        opacity: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-nav-wrap-ping-right::after"), {
        opacity: 1
    }), _obj)), _obj1))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-top"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav,\n        > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "&::before": {
            bottom: 0
        }
    }, "".concat(componentCls, "-ink-bar"), {
        bottom: 0
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-bottom"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        order: 1,
        marginTop: margin,
        marginBottom: 0,
        "&::before": {
            top: 0
        }
    }, "".concat(componentCls, "-ink-bar"), {
        top: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> ".concat(componentCls, "-content-holder, > div > ").concat(componentCls, "-content-holder"), {
        order: 0
    }), _obj2)), // ========================== Left & Right ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-left, ").concat(componentCls, "-right"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj4 = {
        flexDirection: "column",
        minWidth: calc(token.controlHeight).mul(1.25).equal()
    }, // >>>>>>>>>>> Tab
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-tab"), {
        padding: verticalItemPadding,
        textAlign: "center"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-tab + ").concat(componentCls, "-tab"), {
        margin: verticalItemMargin
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-nav-wrap"), (_obj3 = {
        flexDirection: "column",
        "&::before, &::after": {
            right: {
                _skip_check_: true,
                value: 0
            },
            left: {
                _skip_check_: true,
                value: 0
            },
            height: token.controlHeight
        },
        "&::before": {
            top: 0,
            boxShadow: token.boxShadowTabsOverflowTop
        },
        "&::after": {
            bottom: 0,
            boxShadow: token.boxShadowTabsOverflowBottom
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-nav-wrap-ping-top::before"), {
        opacity: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-nav-wrap-ping-bottom::after"), {
        opacity: 1
    }), _obj3)), // >>>>>>>>>>> Ink Bar
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-ink-bar"), {
        width: token.lineWidthBold,
        "&-animated": {
            transition: "height ".concat(token.motionDurationSlow, ", top ").concat(token.motionDurationSlow)
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-nav-list, ").concat(componentCls, "-nav-operations"), {
        flex: "1 0 auto",
        // fix safari scroll problem
        flexDirection: "column"
    }), _obj4))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-left"), (_obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-ink-bar"), {
        right: {
            _skip_check_: true,
            value: 0
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "> ".concat(componentCls, "-content-holder, > div > ").concat(componentCls, "-content-holder"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginLeft: {
            _skip_check_: true,
            value: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
        },
        borderLeft: {
            _skip_check_: true,
            value: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder)
        }
    }, "> ".concat(componentCls, "-content > ").concat(componentCls, "-tabpane"), {
        paddingLeft: {
            _skip_check_: true,
            value: token.paddingLG
        }
    })), _obj5)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj7, "".concat(componentCls, "-right"), (_obj6 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        order: 1
    }, "".concat(componentCls, "-ink-bar"), {
        left: {
            _skip_check_: true,
            value: 0
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, "-content-holder, > div > ").concat(componentCls, "-content-holder"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        order: 0,
        marginRight: {
            _skip_check_: true,
            value: calc(token.lineWidth).mul(-1).equal()
        },
        borderRight: {
            _skip_check_: true,
            value: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder)
        }
    }, "> ".concat(componentCls, "-content > ").concat(componentCls, "-tabpane"), {
        paddingRight: {
            _skip_check_: true,
            value: token.paddingLG
        }
    })), _obj6)), _obj7;
};
var $bd4c1a4e9479d0aa$var$genSizeStyle = function(token) {
    var componentCls = token.componentCls, cardPaddingSM = token.cardPaddingSM, cardPaddingLG = token.cardPaddingLG, horizontalItemPaddingSM = token.horizontalItemPaddingSM, horizontalItemPaddingLG = token.horizontalItemPaddingLG;
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, componentCls, {
        "&-small": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab"), {
            padding: horizontalItemPaddingSM,
            fontSize: token.titleFontSizeSM
        })),
        "&-large": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab"), {
            padding: horizontalItemPaddingLG,
            fontSize: token.titleFontSizeLG
        }))
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-card"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-small"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab"), {
        padding: cardPaddingSM
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-bottom"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav ").concat(componentCls, "-tab"), {
        borderRadius: "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius))
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-top"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav ").concat(componentCls, "-tab"), {
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " 0 0")
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-right"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav ").concat(componentCls, "-tab"), {
        borderRadius: {
            _skip_check_: true,
            value: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " 0")
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-left"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav ").concat(componentCls, "-tab"), {
        borderRadius: {
            _skip_check_: true,
            value: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius), " 0 0 ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadius))
        }
    })), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab"), {
        padding: cardPaddingLG
    }))), _obj1)), _obj2;
};
var $bd4c1a4e9479d0aa$var$genTabStyle = function(token) {
    var componentCls = token.componentCls, itemActiveColor = token.itemActiveColor, itemHoverColor = token.itemHoverColor, iconCls = token.iconCls, tabsHorizontalItemMargin = token.tabsHorizontalItemMargin, horizontalItemPadding = token.horizontalItemPadding, itemSelectedColor = token.itemSelectedColor, itemColor = token.itemColor;
    var tabCls = "".concat(componentCls, "-tab");
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, tabCls, (_obj = {
        position: "relative",
        WebkitTouchCallout: "none",
        WebkitTapHighlightColor: "transparent",
        display: "inline-flex",
        alignItems: "center",
        padding: horizontalItemPadding,
        fontSize: token.titleFontSize,
        background: "transparent",
        border: 0,
        outline: "none",
        cursor: "pointer",
        color: itemColor,
        "&-btn, &-remove": Object.assign({
            "&:focus:not(:focus-visible), &:active": {
                color: itemActiveColor
            }
        }, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token)),
        "&-btn": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            outline: "none",
            transition: "all 0.3s"
        }, "".concat(tabCls, "-icon:not(:last-child)"), {
            marginInlineEnd: token.marginSM
        }),
        "&-remove": {
            flex: "none",
            marginRight: {
                _skip_check_: true,
                value: token.calc(token.marginXXS).mul(-1).equal()
            },
            marginLeft: {
                _skip_check_: true,
                value: token.marginXS
            },
            color: token.colorTextDescription,
            fontSize: token.fontSizeSM,
            background: "transparent",
            border: "none",
            outline: "none",
            cursor: "pointer",
            transition: "all ".concat(token.motionDurationSlow),
            "&:hover": {
                color: token.colorTextHeading
            }
        },
        "&:hover": {
            color: itemHoverColor
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(tabCls, "-active ").concat(tabCls, "-btn"), {
        color: itemSelectedColor,
        textShadow: token.tabsActiveTextShadow
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(tabCls, "-disabled"), {
        color: token.colorTextDisabled,
        cursor: "not-allowed"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(tabCls, "-disabled ").concat(tabCls, "-btn, &").concat(tabCls, "-disabled ").concat(componentCls, "-remove"), {
        "&:focus, &:active": {
            color: token.colorTextDisabled
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "& ".concat(tabCls, "-remove ").concat(iconCls), {
        margin: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(iconCls, ":not(:last-child)"), {
        marginRight: {
            _skip_check_: true,
            value: token.marginSM
        }
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(tabCls, " + ").concat(tabCls), {
        margin: {
            _skip_check_: true,
            value: tabsHorizontalItemMargin
        }
    }), _obj1;
};
var $bd4c1a4e9479d0aa$var$genRtlStyle = function(token) {
    var componentCls = token.componentCls, tabsHorizontalItemMarginRTL = token.tabsHorizontalItemMarginRTL, iconCls = token.iconCls, cardGutter = token.cardGutter, calc = token.calc;
    var rtlCls = "".concat(componentCls, "-rtl");
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return _obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, rtlCls, (_obj3 = {
        direction: "rtl"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab"), (_obj = {
        margin: {
            _skip_check_: true,
            value: tabsHorizontalItemMarginRTL
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-tab:last-of-type"), {
        marginLeft: {
            _skip_check_: true,
            value: 0
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, iconCls, {
        marginRight: {
            _skip_check_: true,
            value: 0
        },
        marginLeft: {
            _skip_check_: true,
            value: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginSM)
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-tab-remove"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginRight: {
            _skip_check_: true,
            value: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginXS)
        },
        marginLeft: {
            _skip_check_: true,
            value: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(token.marginXXS).mul(-1).equal())
        }
    }, iconCls, {
        margin: 0
    })), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-left"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-nav"), {
        order: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-content-holder"), {
        order: 0
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-right"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> ".concat(componentCls, "-nav"), {
        order: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "> ".concat(componentCls, "-content-holder"), {
        order: 1
    }), _obj2)), // ====================== Card ======================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-card").concat(componentCls, "-top, &").concat(componentCls, "-card").concat(componentCls, "-bottom"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-tab + ").concat(componentCls, "-tab"), {
        marginRight: {
            _skip_check_: true,
            value: cardGutter
        },
        marginLeft: {
            _skip_check_: true,
            value: 0
        }
    }))), _obj3)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-dropdown-rtl"), {
        direction: "rtl"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-menu-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-dropdown-rtl"), {
        textAlign: {
            _skip_check_: true,
            value: "right"
        }
    })), _obj4;
};
var $bd4c1a4e9479d0aa$var$genTabsStyle = function(token) {
    var componentCls = token.componentCls, tabsCardPadding = token.tabsCardPadding, cardHeight = token.cardHeight, cardGutter = token.cardGutter, itemHoverColor = token.itemHoverColor, itemActiveColor = token.itemActiveColor, colorBorderSecondary = token.colorBorderSecondary;
    var _obj, _obj1, _obj2, _obj3;
    return _obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj1 = {
        display: "flex"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (_obj = {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-wrap"), {
        position: "relative",
        display: "flex",
        flex: "auto",
        alignSelf: "stretch",
        overflow: "hidden",
        whiteSpace: "nowrap",
        transform: "translate(0)",
        // Fix chrome render bug
        // >>>>> Ping shadow
        "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: "opacity ".concat(token.motionDurationSlow),
            content: "''",
            pointerEvents: "none"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-list"), {
        position: "relative",
        display: "flex",
        transition: "opacity ".concat(token.motionDurationSlow)
    }), // >>>>>>>> Operations
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-operations"), {
        display: "flex",
        alignSelf: "stretch"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-operations-hidden"), {
        position: "absolute",
        visibility: "hidden",
        pointerEvents: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-more"), {
        position: "relative",
        padding: tabsCardPadding,
        background: "transparent",
        border: 0,
        color: token.colorText,
        "&::after": {
            position: "absolute",
            right: {
                _skip_check_: true,
                value: 0
            },
            bottom: 0,
            left: {
                _skip_check_: true,
                value: 0
            },
            height: token.calc(token.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-nav-add"), Object.assign({
        minWidth: cardHeight,
        marginLeft: {
            _skip_check_: true,
            value: cardGutter
        },
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingXS)),
        background: "transparent",
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary),
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0"),
        outline: "none",
        cursor: "pointer",
        color: token.colorText,
        transition: "all ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut),
        "&:hover": {
            color: itemHoverColor
        },
        "&:active, &:focus:not(:focus-visible)": {
            color: itemActiveColor
        }
    }, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token))), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-extra-content"), {
        flex: "none"
    }), // ============================ InkBar ============================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-ink-bar"), {
        position: "absolute",
        background: token.inkBarColor,
        pointerEvents: "none"
    }), _obj1)), $bd4c1a4e9479d0aa$var$genTabStyle(token)), (_obj2 = {}, // =========================== TabPanes ===========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-content"), {
        position: "relative",
        width: "100%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-content-holder"), {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-tabpane"), {
        outline: "none",
        "&-hidden": {
            display: "none"
        }
    }), _obj2))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-centered"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-nav, > div > ").concat(componentCls, "-nav"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-nav-wrap"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not([class*='".concat(componentCls, "-nav-wrap-ping'])"), {
        justifyContent: "center"
    })))), _obj3;
};
var $bd4c1a4e9479d0aa$export$9ca1be8807fe0675 = function(token) {
    var cardHeight = token.controlHeightLG;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        cardHeight: cardHeight,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: "".concat((cardHeight - Math.round(token.fontSize * token.lineHeight)) / 2 - token.lineWidth, "px ").concat(token.padding, "px"),
        cardPaddingSM: "".concat(token.paddingXXS * 1.5, "px ").concat(token.padding, "px"),
        cardPaddingLG: "".concat(token.paddingXS, "px ").concat(token.padding, "px ").concat(token.paddingXXS * 1.5, "px"),
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: "0 0 ".concat(token.margin, "px 0"),
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: "",
        horizontalItemMarginRTL: "",
        horizontalItemPadding: "".concat(token.paddingSM, "px 0"),
        horizontalItemPaddingSM: "".concat(token.paddingXS, "px 0"),
        horizontalItemPaddingLG: "".concat(token.padding, "px 0"),
        verticalItemPadding: "".concat(token.paddingXS, "px ").concat(token.paddingLG, "px"),
        verticalItemMargin: "".concat(token.margin, "px 0 0 0"),
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$bd4c1a4e9479d0aa$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Tabs", function(token) {
    var tabsToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsActiveTextShadow: "0 0 0.25px currentcolor",
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: "0 0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.horizontalItemGutter)),
        tabsHorizontalItemMarginRTL: "0 0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.horizontalItemGutter))
    });
    return [
        $bd4c1a4e9479d0aa$var$genSizeStyle(tabsToken),
        $bd4c1a4e9479d0aa$var$genRtlStyle(tabsToken),
        $bd4c1a4e9479d0aa$var$genPositionStyle(tabsToken),
        $bd4c1a4e9479d0aa$var$genDropdownStyle(tabsToken),
        $bd4c1a4e9479d0aa$var$genCardStyle(tabsToken),
        $bd4c1a4e9479d0aa$var$genTabsStyle(tabsToken),
        (0, $312902987c09925b$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $bd4c1a4e9479d0aa$export$9ca1be8807fe0675);



var $ffc6b2e419d41f04$var$TabPane = function() {
    return null;
};
var $ffc6b2e419d41f04$export$2e2bcd8739ae039 = $ffc6b2e419d41f04$var$TabPane;


"use client";
var $a78aafd66bcf74e7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a78aafd66bcf74e7$var$Tabs = function(props) {
    var type = props.type, className = props.className, rootClassName = props.rootClassName, customSize = props.size, onEdit = props.onEdit, hideAdd = props.hideAdd, centered = props.centered, addIcon = props.addIcon, popupClassName = props.popupClassName, children = props.children, items = props.items, animated = props.animated, style = props.style, indicatorSize = props.indicatorSize, otherProps = $a78aafd66bcf74e7$var$__rest(props, [
        "type",
        "className",
        "rootClassName",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "popupClassName",
        "children",
        "items",
        "animated",
        "style",
        "indicatorSize"
    ]);
    var customizePrefixCls = otherProps.prefixCls, _otherProps_moreIcon = otherProps.moreIcon, moreIcon = _otherProps_moreIcon === void 0 ? /*#__PURE__*/ $8SyCD.createElement((0, $f4c5b4a4a3d18e7e$export$2e2bcd8739ae039), null) : _otherProps_moreIcon;
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), direction = _React_useContext.direction, tabs = _React_useContext.tabs, getPrefixCls = _React_useContext.getPrefixCls, getPopupContainer = _React_useContext.getPopupContainer;
    var prefixCls = getPrefixCls("tabs", customizePrefixCls);
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $bd4c1a4e9479d0aa$export$2e2bcd8739ae039)(prefixCls, rootCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var editable;
    if (type === "editable-card") editable = {
        onEdit: function(editType, _ref) {
            var key = _ref.key, event = _ref.event;
            onEdit === null || onEdit === void 0 || onEdit(editType === "add" ? event : key, editType);
        },
        removeIcon: /*#__PURE__*/ $8SyCD.createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), null),
        addIcon: addIcon || /*#__PURE__*/ $8SyCD.createElement((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    var rootPrefixCls = getPrefixCls();
    var mergedItems = (0, $d298b0b106355a60$export$2e2bcd8739ae039)(items, children);
    var mergedAnimated = (0, $0fbf9fcbedc9e9e0$export$2e2bcd8739ae039)(prefixCls, animated);
    var size = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customSize);
    var mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style);
    var _obj;
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $336bf56b8acca016$export$2e2bcd8739ae039), Object.assign({
        direction: direction,
        getPopupContainer: getPopupContainer,
        moreTransitionName: "".concat(rootPrefixCls, "-slide-up")
    }, otherProps, {
        items: mergedItems,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size), size), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-card"), [
            "card",
            "editable-card"
        ].includes(type)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-editable-card"), type === "editable-card"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-centered"), centered), _obj), tabs === null || tabs === void 0 ? void 0 : tabs.className, className, rootClassName, hashId, rootCls),
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(popupClassName, hashId, rootCls),
        style: mergedStyle,
        editable: editable,
        moreIcon: moreIcon,
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicatorSize: indicatorSize !== null && indicatorSize !== void 0 ? indicatorSize : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
    })));
};
$a78aafd66bcf74e7$var$Tabs.TabPane = (0, $ffc6b2e419d41f04$export$2e2bcd8739ae039);
var $a78aafd66bcf74e7$export$2e2bcd8739ae039 = $a78aafd66bcf74e7$var$Tabs;





var $8SyCD = parcelRequire("8SyCD");

"use client";
var $f06de8dba5aec549$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f06de8dba5aec549$var$Grid = function(_a) {
    var prefixCls = _a.prefixCls, className = _a.className, _a_hoverable = _a.hoverable, hoverable = _a_hoverable === void 0 ? true : _a_hoverable, props = $f06de8dba5aec549$var$__rest(_a, [
        "prefixCls",
        "className",
        "hoverable"
    ]);
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefix = getPrefixCls("card", prefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefix, "-grid"), className, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefix, "-grid-hoverable"), hoverable));
    return /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, props, {
        className: classString
    }));
};
var $f06de8dba5aec549$export$2e2bcd8739ae039 = $f06de8dba5aec549$var$Grid;






// ============================== Styles ==============================
// ============================== Head ==============================
var $5fb0448c55ff05a8$var$genCardHeadStyle = function(token) {
    var antCls = token.antCls, componentCls = token.componentCls, headerHeight = token.headerHeight, cardPaddingBase = token.cardPaddingBase, tabsMarginBottom = token.tabsMarginBottom;
    return Object.assign(Object.assign({
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: headerHeight,
        marginBottom: -1,
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardPaddingBase)),
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorderSecondary),
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0")
    }, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "&-wrapper": {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        "&-title": Object.assign(Object.assign({
            display: "inline-block",
            flex: 1
        }, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "\n          > ".concat(componentCls, "-typography,\n          > ").concat(componentCls, "-typography-edit-content\n        "), {
            insetInlineStart: 0,
            marginTop: 0,
            marginBottom: 0
        }))
    }, "".concat(antCls, "-tabs-top"), {
        clear: "both",
        marginBottom: tabsMarginBottom,
        color: token.colorText,
        fontWeight: "normal",
        fontSize: token.fontSize,
        "&-bar": {
            borderBottom: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorderSecondary)
        }
    }));
};
// ============================== Grid ==============================
var $5fb0448c55ff05a8$var$genCardGridStyle = function(token) {
    var cardPaddingBase = token.cardPaddingBase, colorBorderSecondary = token.colorBorderSecondary, cardShadow = token.cardShadow, lineWidth = token.lineWidth;
    return {
        width: "33.33%",
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: "\n      ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " 0 0 0 ").concat(colorBorderSecondary, ",\n      0 ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " 0 0 ").concat(colorBorderSecondary, ",\n      ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " 0 0 ").concat(colorBorderSecondary, ",\n      ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " 0 0 0 ").concat(colorBorderSecondary, " inset,\n      0 ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " 0 0 ").concat(colorBorderSecondary, " inset;\n    "),
        transition: "all ".concat(token.motionDurationMid),
        "&-hoverable:hover": {
            position: "relative",
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
var $5fb0448c55ff05a8$var$genCardActionsStyle = function(token) {
    var componentCls = token.componentCls, iconCls = token.iconCls, actionsLiMargin = token.actionsLiMargin, cardActionsIconSize = token.cardActionsIconSize, colorBorderSecondary = token.colorBorderSecondary, actionsBg = token.actionsBg;
    var _obj;
    return Object.assign(Object.assign({
        margin: 0,
        padding: 0,
        listStyle: "none",
        background: actionsBg,
        borderTop: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary),
        display: "flex",
        borderRadius: "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG))
    }, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), {
        "& > li": {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: "center",
            "> span": (_obj = {
                position: "relative",
                display: "block",
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: "pointer",
                "&:hover": {
                    color: token.colorPrimary,
                    transition: "color ".concat(token.motionDurationMid)
                }
            }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "a:not(".concat(componentCls, "-btn), > ").concat(iconCls), {
                display: "inline-block",
                width: "100%",
                color: token.colorTextDescription,
                lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.fontHeight),
                transition: "color ".concat(token.motionDurationMid),
                "&:hover": {
                    color: token.colorPrimary
                }
            }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(iconCls), {
                fontSize: cardActionsIconSize,
                lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
            }), _obj),
            "&:not(:last-child)": {
                borderInlineEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary)
            }
        }
    });
};
// ============================== Meta ==============================
var $5fb0448c55ff05a8$var$genCardMetaStyle = function(token) {
    return Object.assign(Object.assign({
        margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.marginXXS).mul(-1).equal()), " 0"),
        display: "flex"
    }, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), {
        "&-avatar": {
            paddingInlineEnd: token.padding
        },
        "&-detail": {
            overflow: "hidden",
            flex: 1,
            "> div:not(:last-child)": {
                marginBottom: token.marginXS
            }
        },
        "&-title": Object.assign({
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG
        }, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)),
        "&-description": {
            color: token.colorTextDescription
        }
    });
};
// ============================== Inner ==============================
var $5fb0448c55ff05a8$var$genCardTypeInnerStyle = function(token) {
    var componentCls = token.componentCls, cardPaddingBase = token.cardPaddingBase, colorFillAlter = token.colorFillAlter;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-head"), {
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardPaddingBase)),
        background: colorFillAlter,
        "&-title": {
            fontSize: token.fontSize
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-body"), {
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.padding), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardPaddingBase))
    }), _obj;
};
// ============================== Loading ==============================
var $5fb0448c55ff05a8$var$genCardLoadingStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        overflow: "hidden"
    }, "".concat(componentCls, "-body"), {
        userSelect: "none"
    });
};
// ============================== Basic ==============================
var $5fb0448c55ff05a8$var$genCardStyle = function(token) {
    var antCls = token.antCls, componentCls = token.componentCls, cardShadow = token.cardShadow, cardHeadPadding = token.cardHeadPadding, colorBorderSecondary = token.colorBorderSecondary, boxShadowTertiary = token.boxShadowTertiary, cardPaddingBase = token.cardPaddingBase, extraColor = token.extraColor;
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, componentCls, Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj = {
        position: "relative",
        background: token.colorBgContainer,
        borderRadius: token.borderRadiusLG
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-bordered)"), {
        boxShadow: boxShadowTertiary
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-head"), $5fb0448c55ff05a8$var$genCardHeadStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-extra"), {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: extraColor,
        fontWeight: "normal",
        fontSize: token.fontSize
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-body"), Object.assign({
        padding: cardPaddingBase,
        borderRadius: " 0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG))
    }, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)())), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-grid"), $5fb0448c55ff05a8$var$genCardGridStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-cover"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "> *": {
            display: "block",
            width: "100%"
        }
    }, "img, img + ".concat(antCls, "-image-mask"), {
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0")
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-actions"), $5fb0448c55ff05a8$var$genCardActionsStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-meta"), $5fb0448c55ff05a8$var$genCardMetaStyle(token)), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-bordered"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(colorBorderSecondary)
    }, "".concat(componentCls, "-cover"), {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-hoverable"), {
        cursor: "pointer",
        transition: "box-shadow ".concat(token.motionDurationMid, ", border-color ").concat(token.motionDurationMid),
        "&:hover": {
            borderColor: "transparent",
            boxShadow: cardShadow
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-contain-grid"), (_obj1 = {
        borderRadius: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.borderRadiusLG), " 0 0 ")
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-body"), {
        display: "flex",
        flexWrap: "wrap"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:not(".concat(componentCls, "-loading) ").concat(componentCls, "-body"), {
        marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
        marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
        padding: 0
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-contain-tabs"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-head"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        minHeight: 0
    }, "".concat(componentCls, "-head-title, ").concat(componentCls, "-extra"), {
        paddingTop: cardHeadPadding
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-type-inner"), $5fb0448c55ff05a8$var$genCardTypeInnerStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-loading"), $5fb0448c55ff05a8$var$genCardLoadingStyle(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-rtl"), {
        direction: "rtl"
    }), _obj2;
};
// ============================== Size ==============================
var $5fb0448c55ff05a8$var$genCardSizeStyle = function(token) {
    var componentCls = token.componentCls, cardPaddingSM = token.cardPaddingSM, headerHeightSM = token.headerHeightSM, headerFontSizeSM = token.headerFontSizeSM;
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-small"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls, "-head"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        minHeight: headerHeightSM,
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(cardPaddingSM)),
        fontSize: headerFontSizeSM
    }, "> ".concat(componentCls, "-head-wrapper"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-extra"), {
        fontSize: token.fontSize
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls, "-body"), {
        padding: cardPaddingSM
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-small").concat(componentCls, "-contain-tabs"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-head"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-head-title, ").concat(componentCls, "-extra"), {
        paddingTop: 0,
        display: "flex",
        alignItems: "center"
    }))), _obj1;
};
var $5fb0448c55ff05a8$export$9ca1be8807fe0675 = function(token) {
    return {
        headerBg: "transparent",
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: "".concat(token.paddingSM, "px 0"),
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText
    };
};
var // ============================== Export ==============================
$5fb0448c55ff05a8$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Card", function(token) {
    var cardToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize,
        cardPaddingSM: 12 // Fixed padding.
    });
    return [
        // Style
        $5fb0448c55ff05a8$var$genCardStyle(cardToken),
        // Size
        $5fb0448c55ff05a8$var$genCardSizeStyle(cardToken)
    ];
}, $5fb0448c55ff05a8$export$9ca1be8807fe0675);


"use client";
var $b8acd739291811f6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b8acd739291811f6$var$ActionNode = function(props) {
    var prefixCls = props.prefixCls, _props_actions = props.actions, actions = _props_actions === void 0 ? [] : _props_actions;
    return /*#__PURE__*/ $8SyCD.createElement("ul", {
        className: "".concat(prefixCls, "-actions")
    }, actions.map(function(action, index) {
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        var key = "action-".concat(index);
        return /*#__PURE__*/ $8SyCD.createElement("li", {
            style: {
                width: "".concat(100 / actions.length, "%")
            },
            key: key
        }, /*#__PURE__*/ $8SyCD.createElement("span", null, action));
    }));
};
var $b8acd739291811f6$var$Card = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, rootClassName = props.rootClassName, style = props.style, extra = props.extra, _props_headStyle = props.headStyle, headStyle = _props_headStyle === void 0 ? {} : _props_headStyle, _props_bodyStyle = props.bodyStyle, bodyStyle = _props_bodyStyle === void 0 ? {} : _props_bodyStyle, title = props.title, loading = props.loading, _props_bordered = props.bordered, bordered = _props_bordered === void 0 ? true : _props_bordered, customizeSize = props.size, type = props.type, cover = props.cover, actions = props.actions, tabList = props.tabList, children = props.children, activeTabKey = props.activeTabKey, defaultActiveTabKey = props.defaultActiveTabKey, tabBarExtraContent = props.tabBarExtraContent, hoverable = props.hoverable, _props_tabProps = props.tabProps, tabProps = _props_tabProps === void 0 ? {} : _props_tabProps, others = $b8acd739291811f6$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "extra",
        "headStyle",
        "bodyStyle",
        "title",
        "loading",
        "bordered",
        "size",
        "type",
        "cover",
        "actions",
        "tabList",
        "children",
        "activeTabKey",
        "defaultActiveTabKey",
        "tabBarExtraContent",
        "hoverable",
        "tabProps"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, card = _React_useContext.card;
    var onTabChange = function(key) {
        var _a;
        (_a = props.onTabChange) === null || _a === void 0 || _a.call(props, key);
    };
    var isContainGrid = $8SyCD.useMemo(function() {
        var containGrid = false;
        $8SyCD.Children.forEach(children, function(element) {
            if (element && element.type && element.type === (0, $f06de8dba5aec549$export$2e2bcd8739ae039)) containGrid = true;
        });
        return containGrid;
    }, [
        children
    ]);
    var prefixCls = getPrefixCls("card", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $5fb0448c55ff05a8$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var loadingBlock = /*#__PURE__*/ $8SyCD.createElement((0, $58b95ada40f29e17$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    var hasActiveTabKey = activeTabKey !== undefined;
    var _obj;
    var extraProps = Object.assign(Object.assign({}, tabProps), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, hasActiveTabKey ? "activeKey" : "defaultActiveKey", hasActiveTabKey ? activeTabKey : defaultActiveTabKey), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "tabBarExtraContent", tabBarExtraContent), _obj));
    var head;
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customizeSize);
    var tabSize = !mergedSize || mergedSize === "default" ? "large" : mergedSize;
    var tabs = tabList ? /*#__PURE__*/ $8SyCD.createElement((0, $a78aafd66bcf74e7$export$2e2bcd8739ae039), Object.assign({
        size: tabSize
    }, extraProps, {
        className: "".concat(prefixCls, "-head-tabs"),
        onChange: onTabChange,
        items: tabList.map(function(_a) {
            var tab = _a.tab, item = $b8acd739291811f6$var$__rest(_a, [
                "tab"
            ]);
            return Object.assign({
                label: tab
            }, item);
        })
    })) : null;
    if (title || extra || tabs) head = /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-head"),
        style: headStyle
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-head-wrapper")
    }, title && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-head-title")
    }, title), extra && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), tabs);
    var coverDom = cover ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-cover")
    }, cover) : null;
    var body = /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, loading ? loadingBlock : children);
    var actionDom = actions && actions.length ? /*#__PURE__*/ $8SyCD.createElement($b8acd739291811f6$var$ActionNode, {
        prefixCls: prefixCls,
        actions: actions
    }) : null;
    var divProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(others, [
        "onTabChange"
    ]);
    var _obj1;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, card === null || card === void 0 ? void 0 : card.className, (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-loading"), loading), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-bordered"), bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-hoverable"), hoverable), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-contain-grid"), isContainGrid), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-type-").concat(type), !!type), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj1), className, rootClassName, hashId);
    var mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        ref: ref
    }, divProps, {
        className: classString,
        style: mergedStyle
    }), head, coverDom, body, actionDom));
});
var $b8acd739291811f6$export$2e2bcd8739ae039 = $b8acd739291811f6$var$Card;





var $8SyCD = parcelRequire("8SyCD");

"use client";
var $067ba908e2310b59$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $067ba908e2310b59$var$Meta = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, avatar = props.avatar, title = props.title, description = props.description, others = $067ba908e2310b59$var$__rest(props, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("card", customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-meta"), className);
    var avatarDom = avatar ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-meta-avatar")
    }, avatar) : null;
    var titleDom = title ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-meta-title")
    }, title) : null;
    var descriptionDom = description ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-meta-description")
    }, description) : null;
    var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-meta-detail")
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, others, {
        className: classString
    }), avatarDom, MetaDetail);
};
var $067ba908e2310b59$export$2e2bcd8739ae039 = $067ba908e2310b59$var$Meta;


"use client";
var $6179788acd512012$var$Card = (0, $b8acd739291811f6$export$2e2bcd8739ae039);
$6179788acd512012$var$Card.Grid = (0, $f06de8dba5aec549$export$2e2bcd8739ae039);
$6179788acd512012$var$Card.Meta = (0, $067ba908e2310b59$export$2e2bcd8739ae039);
var $6179788acd512012$export$2e2bcd8739ae039 = $6179788acd512012$var$Card;





var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");

"use client";
var $23639b18935de393$var$Empty = function() {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var bgColor = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(token.colorBgBase);
    // Dark Theme need more dark of this
    var themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $8SyCD.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $8SyCD.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $8SyCD.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $8SyCD.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $8SyCD.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $8SyCD.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $23639b18935de393$export$2e2bcd8739ae039 = $23639b18935de393$var$Empty;





var $8SyCD = parcelRequire("8SyCD");

"use client";
var $4f910325422950ed$var$Simple = function() {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var colorFill = token.colorFill, colorFillTertiary = token.colorFillTertiary, colorFillQuaternary = token.colorFillQuaternary, colorBgContainer = token.colorBgContainer;
    var _useMemo = (0, $8SyCD.useMemo)(function() {
        return {
            borderColor: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorFill).onBackground(colorBgContainer).toHexShortString(),
            shadowColor: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorFillTertiary).onBackground(colorBgContainer).toHexShortString(),
            contentColor: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorFillQuaternary).onBackground(colorBgContainer).toHexShortString()
        };
    }, [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]), borderColor = _useMemo.borderColor, shadowColor = _useMemo.shadowColor, contentColor = _useMemo.contentColor;
    return /*#__PURE__*/ $8SyCD.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $8SyCD.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $8SyCD.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $8SyCD.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $8SyCD.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $4f910325422950ed$export$2e2bcd8739ae039 = $4f910325422950ed$var$Simple;




// ============================== Shared ==============================
var $099489bf0d8fd66d$var$genSharedEmptyStyle = function(token) {
    var componentCls = token.componentCls, margin = token.margin, marginXS = token.marginXS, marginXL = token.marginXL, fontSize = token.fontSize, lineHeight = token.lineHeight;
    var _obj, _obj1;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj1 = {
        marginInline: marginXS,
        fontSize: fontSize,
        lineHeight: lineHeight,
        textAlign: "center"
    }, // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-image"), {
        height: token.emptyImgHeight,
        marginBottom: marginXS,
        opacity: token.opacityImage,
        img: {
            height: "100%"
        },
        svg: {
            maxWidth: "100%",
            height: "100%",
            margin: "auto"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-description"), {
        color: token.colorText
    }), // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-footer"), {
        marginTop: margin
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-normal", (_obj = {
        marginBlock: marginXL,
        color: token.colorTextDisabled
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-description"), {
        color: token.colorTextDisabled
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-image"), {
        height: token.emptyImgHeightMD
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-small", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginBlock: marginXS,
        color: token.colorTextDisabled
    }, "".concat(componentCls, "-image"), {
        height: token.emptyImgHeightSM
    })), _obj1));
};
var // ============================== Export ==============================
$099489bf0d8fd66d$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Empty", function(token) {
    var componentCls = token.componentCls, controlHeightLG = token.controlHeightLG, calc = token.calc;
    var emptyToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        emptyImgCls: "".concat(componentCls, "-img"),
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $099489bf0d8fd66d$var$genSharedEmptyStyle(emptyToken)
    ];
});


"use client";
var $663faa9ebe7f0295$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $663faa9ebe7f0295$var$defaultEmptyImg = /*#__PURE__*/ $8SyCD.createElement((0, $23639b18935de393$export$2e2bcd8739ae039), null);
var $663faa9ebe7f0295$var$simpleEmptyImg = /*#__PURE__*/ $8SyCD.createElement((0, $4f910325422950ed$export$2e2bcd8739ae039), null);
var $663faa9ebe7f0295$var$Empty = function(_a) {
    var className = _a.className, rootClassName = _a.rootClassName, customizePrefixCls = _a.prefixCls, _a_image = _a.image, image = _a_image === void 0 ? $663faa9ebe7f0295$var$defaultEmptyImg : _a_image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, style = _a.style, restProps = $663faa9ebe7f0295$var$__rest(_a, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, empty = _React_useContext.empty;
    var prefixCls = getPrefixCls("empty", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $099489bf0d8fd66d$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Empty"), 1), locale = _useLocale[0];
    var des = typeof description !== "undefined" ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    var alt = typeof des === "string" ? des : "empty";
    var imageNode = null;
    if (typeof image === "string") imageNode = /*#__PURE__*/ $8SyCD.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    var _obj;
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, prefixCls, empty === null || empty === void 0 ? void 0 : empty.className, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-normal"), image === $663faa9ebe7f0295$var$simpleEmptyImg), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), className, rootClassName),
        style: Object.assign(Object.assign({}, empty === null || empty === void 0 ? void 0 : empty.style), style)
    }, restProps), /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-image"),
        style: imageStyle
    }, imageNode), des && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-description")
    }, des), children && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, children)));
};
$663faa9ebe7f0295$var$Empty.PRESENTED_IMAGE_DEFAULT = $663faa9ebe7f0295$var$defaultEmptyImg;
$663faa9ebe7f0295$var$Empty.PRESENTED_IMAGE_SIMPLE = $663faa9ebe7f0295$var$simpleEmptyImg;
var $663faa9ebe7f0295$export$2e2bcd8739ae039 = $663faa9ebe7f0295$var$Empty;






var $8SyCD = parcelRequire("8SyCD");
function $e7a6cdfb5d77a6e3$var$extendsObject() {
    var _arguments = arguments, _loop = function(i) {
        var obj = i < 0 || _arguments.length <= i ? undefined : _arguments[i];
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    };
    var result = Object.assign({}, arguments.length <= 0 ? undefined : arguments[0]);
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return result;
}
var $e7a6cdfb5d77a6e3$export$2e2bcd8739ae039 = $e7a6cdfb5d77a6e3$var$extendsObject;





var $8SyCD = parcelRequire("8SyCD");

var $6d08709ecca144ea$export$74c1bf8296b1541f = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $6d08709ecca144ea$var$getResponsiveMap = function(token) {
    return {
        xs: "(max-width: ".concat(token.screenXSMax, "px)"),
        sm: "(min-width: ".concat(token.screenSM, "px)"),
        md: "(min-width: ".concat(token.screenMD, "px)"),
        lg: "(min-width: ".concat(token.screenLG, "px)"),
        xl: "(min-width: ".concat(token.screenXL, "px)"),
        xxl: "(min-width: ".concat(token.screenXXL, "px)")
    };
};
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ var $6d08709ecca144ea$var$validateBreakpoints = function(token) {
    var indexableToken = token;
    var revBreakpoints = [].concat($6d08709ecca144ea$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach(function(breakpoint, i) {
        var breakpointUpper = breakpoint.toUpperCase();
        var screenMin = "screen".concat(breakpointUpper, "Min");
        var screen = "screen".concat(breakpointUpper);
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error("".concat(screenMin, "<=").concat(screen, " fails : !(").concat(indexableToken[screenMin], "<=").concat(indexableToken[screen], ")"));
        if (i < revBreakpoints.length - 1) {
            var screenMax = "screen".concat(breakpointUpper, "Max");
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error("".concat(screen, "<=").concat(screenMax, " fails : !(").concat(indexableToken[screen], "<=").concat(indexableToken[screenMax], ")"));
            var nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            var nextScreenMin = "screen".concat(nextBreakpointUpperMin, "Min");
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error("".concat(screenMax, "<=").concat(nextScreenMin, " fails : !(").concat(indexableToken[screenMax], "<=").concat(indexableToken[nextScreenMin], ")"));
        }
    });
    return token;
};
function $6d08709ecca144ea$export$2e2bcd8739ae039() {
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var responsiveMap = $6d08709ecca144ea$var$getResponsiveMap($6d08709ecca144ea$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useMemo(function() {
        var subscribers = new Map();
        var subUid = -1;
        var screens = {};
        return {
            matchHandlers: {},
            dispatch: function(pointMap) {
                screens = pointMap;
                subscribers.forEach(function(func) {
                    return func(screens);
                });
                return subscribers.size >= 1;
            },
            subscribe: function(func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe: function(paramToken) {
                subscribers["delete"](paramToken);
                if (!subscribers.size) this.unregister();
            },
            unregister: function() {
                var _this = this;
                Object.keys(responsiveMap).forEach(function(screen) {
                    var matchMediaQuery = responsiveMap[screen];
                    var handler = _this.matchHandlers[matchMediaQuery];
                    handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
                });
                subscribers.clear();
            },
            register: function() {
                var _this = this;
                Object.keys(responsiveMap).forEach(function(screen) {
                    var matchMediaQuery = responsiveMap[screen];
                    var listener = function(_ref) {
                        var matches = _ref.matches;
                        _this.dispatch(Object.assign(Object.assign({}, screens), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, screen, matches)));
                    };
                    var mql = window.matchMedia(matchMediaQuery);
                    mql.addListener(listener);
                    _this.matchHandlers[matchMediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            responsiveMap: responsiveMap
        };
    }, [
        token
    ]);
}
var $6d08709ecca144ea$export$862220c15691d248 = function(screens, screenSizes) {
    if (screenSizes && typeof screenSizes === "object") for(var i = 0; i < $6d08709ecca144ea$export$74c1bf8296b1541f.length; i++){
        var breakpoint = $6d08709ecca144ea$export$74c1bf8296b1541f[i];
        if (screens[breakpoint] && screenSizes[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};




var $8SyCD = parcelRequire("8SyCD");


"use client";
var $554405272ae7ed67$var$DefaultRenderEmpty = function(props) {
    var componentName = props.componentName;
    var getPrefixCls = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefix = getPrefixCls("empty");
    switch(componentName){
        case "Table":
        case "List":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $663faa9ebe7f0295$export$2e2bcd8739ae039), {
                image: (0, $663faa9ebe7f0295$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case "Select":
        case "TreeSelect":
        case "Cascader":
        case "Transfer":
        case "Mentions":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $663faa9ebe7f0295$export$2e2bcd8739ae039), {
                image: (0, $663faa9ebe7f0295$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: "".concat(prefix, "-small")
            });
        /* istanbul ignore next */ default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $663faa9ebe7f0295$export$2e2bcd8739ae039), null);
    }
};
var $554405272ae7ed67$export$2e2bcd8739ae039 = $554405272ae7ed67$var$DefaultRenderEmpty;





var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");
var $7a75170e1d2795b3$var$RowContext = /*#__PURE__*/ (0, $8SyCD.createContext)({});
var $7a75170e1d2795b3$export$2e2bcd8739ae039 = $7a75170e1d2795b3$var$RowContext;





// ============================== Row-Shared ==============================
var $86d3cd512305a3b3$var$genGridRowStyle = function(token) {
    var componentCls = token.componentCls;
    return(// Grid system
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        display: "flex",
        flexFlow: "row wrap",
        minWidth: 0,
        "&::before, &::after": {
            display: "flex"
        },
        "&-no-wrap": {
            flexWrap: "nowrap"
        },
        // The origin of the X-axis
        "&-start": {
            justifyContent: "flex-start"
        },
        // The center of the X-axis
        "&-center": {
            justifyContent: "center"
        },
        // The opposite of the X-axis
        "&-end": {
            justifyContent: "flex-end"
        },
        "&-space-between": {
            justifyContent: "space-between"
        },
        "&-space-around": {
            justifyContent: "space-around"
        },
        "&-space-evenly": {
            justifyContent: "space-evenly"
        },
        // Align at the top
        "&-top": {
            alignItems: "flex-start"
        },
        // Align at the center
        "&-middle": {
            alignItems: "center"
        },
        "&-bottom": {
            alignItems: "flex-end"
        }
    }));
};
// ============================== Col-Shared ==============================
var $86d3cd512305a3b3$var$genGridColStyle = function(token) {
    var componentCls = token.componentCls;
    return(// Grid system
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        position: "relative",
        maxWidth: "100%",
        // Prevent columns from collapsing when empty
        minHeight: 1
    }));
};
var $86d3cd512305a3b3$var$genLoopGridColumnsStyle = function(token, sizeCls) {
    var componentCls = token.componentCls, gridColumns = token.gridColumns;
    var gridColumnsStyle = {};
    for(var i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-").concat(i)] = {
            display: "none"
        };
        gridColumnsStyle["".concat(componentCls, "-push-").concat(i)] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle["".concat(componentCls, "-pull-").concat(i)] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-push-").concat(i)] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-pull-").concat(i)] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-offset-").concat(i)] = {
            marginInlineStart: 0
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-order-").concat(i)] = {
            order: 0
        };
    } else {
        var // https://github.com/ant-design/ant-design/issues/44456
        // Form set `display: flex` on Col which will override `display: block`.
        // Let's get it from css variable to support override.
        _obj;
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-").concat(i)] = [
            (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "--ant-display", "block"), // Fallback to display if variable not support
            (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "display", "block"), _obj),
            {
                display: "var(--ant-display)",
                flex: "0 0 ".concat(i / gridColumns * 100, "%"),
                maxWidth: "".concat(i / gridColumns * 100, "%")
            }
        ];
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-push-").concat(i)] = {
            insetInlineStart: "".concat(i / gridColumns * 100, "%")
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-pull-").concat(i)] = {
            insetInlineEnd: "".concat(i / gridColumns * 100, "%")
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-offset-").concat(i)] = {
            marginInlineStart: "".concat(i / gridColumns * 100, "%")
        };
        gridColumnsStyle["".concat(componentCls).concat(sizeCls, "-order-").concat(i)] = {
            order: i
        };
    }
    return gridColumnsStyle;
};
var $86d3cd512305a3b3$var$genGridStyle = function(token, sizeCls) {
    return $86d3cd512305a3b3$var$genLoopGridColumnsStyle(token, sizeCls);
};
var $86d3cd512305a3b3$var$genGridMediaStyle = function(token, screenSize, sizeCls) {
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "@media (min-width: ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(screenSize), ")"), Object.assign({}, $86d3cd512305a3b3$var$genGridStyle(token, sizeCls)));
};
var $86d3cd512305a3b3$export$519f4f378a4f8e85 = function() {
    return {};
};
var $86d3cd512305a3b3$export$5504d86ab3175593 = function() {
    return {};
};
var $86d3cd512305a3b3$export$b0d9c6b8be4e14cd = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Grid", $86d3cd512305a3b3$var$genGridRowStyle, $86d3cd512305a3b3$export$519f4f378a4f8e85);
var $86d3cd512305a3b3$export$4d3e83959861592f = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Grid", function(token) {
    var gridToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    var gridMediaSizesMap = {
        "-sm": gridToken.screenSMMin,
        "-md": gridToken.screenMDMin,
        "-lg": gridToken.screenLGMin,
        "-xl": gridToken.screenXLMin,
        "-xxl": gridToken.screenXXLMin
    };
    return [
        $86d3cd512305a3b3$var$genGridColStyle(gridToken),
        $86d3cd512305a3b3$var$genGridStyle(gridToken, ""),
        $86d3cd512305a3b3$var$genGridStyle(gridToken, "-xs"),
        Object.keys(gridMediaSizesMap).map(function(key) {
            return $86d3cd512305a3b3$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], key);
        }).reduce(function(pre, cur) {
            return Object.assign(Object.assign({}, pre), cur);
        }, {})
    ];
}, $86d3cd512305a3b3$export$5504d86ab3175593);


"use client";
var $052ff5f829750c55$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $052ff5f829750c55$var$RowAligns = [
    "top",
    "middle",
    "bottom",
    "stretch"
];
var $052ff5f829750c55$var$RowJustify = [
    "start",
    "end",
    "center",
    "space-around",
    "space-between",
    "space-evenly"
];
function $052ff5f829750c55$var$useMergePropByScreen(oriProp, screen) {
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(typeof oriProp === "string" ? oriProp : ""), 2), prop = _React_useState[0], setProp = _React_useState[1];
    var calcMergeAlignOrJustify = function() {
        if (typeof oriProp === "string") setProp(oriProp);
        if (typeof oriProp !== "object") return;
        for(var i = 0; i < (0, $6d08709ecca144ea$export$74c1bf8296b1541f).length; i++){
            var breakpoint = (0, $6d08709ecca144ea$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen[breakpoint]) continue;
            var curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $8SyCD.useEffect(function() {
        calcMergeAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
var $052ff5f829750c55$var$Row = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, justify = props.justify, align = props.align, className = props.className, style = props.style, children = props.children, _props_gutter = props.gutter, gutter = _props_gutter === void 0 ? 0 : _props_gutter, wrap = props.wrap, others = $052ff5f829750c55$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    }), 2), screens = _React_useState[0], setScreens = _React_useState[1];
    // to save screens info when responsiveObserve callback had been call
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState({
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xxl: false
    }), 2), curScreens = _React_useState1[0], setCurScreens = _React_useState1[1];
    // ================================== calc responsive data ==================================
    var mergeAlign = $052ff5f829750c55$var$useMergePropByScreen(align, curScreens);
    var mergeJustify = $052ff5f829750c55$var$useMergePropByScreen(justify, curScreens);
    var gutterRef = $8SyCD.useRef(gutter);
    var responsiveObserver = (0, $6d08709ecca144ea$export$2e2bcd8739ae039)();
    // ================================== Effect ==================================
    $8SyCD.useEffect(function() {
        var token = responsiveObserver.subscribe(function(screen) {
            setCurScreens(screen);
            var currentGutter = gutterRef.current || 0;
            if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) setScreens(screen);
        });
        return function() {
            return responsiveObserver.unsubscribe(token);
        };
    }, []);
    // ================================== Render ==================================
    var getGutter = function() {
        var results = [
            undefined,
            undefined
        ];
        var normalizedGutter = Array.isArray(gutter) ? gutter : [
            gutter,
            undefined
        ];
        normalizedGutter.forEach(function(g, index) {
            if (typeof g === "object") for(var i = 0; i < (0, $6d08709ecca144ea$export$74c1bf8296b1541f).length; i++){
                var breakpoint = (0, $6d08709ecca144ea$export$74c1bf8296b1541f)[i];
                if (screens[breakpoint] && g[breakpoint] !== undefined) {
                    results[index] = g[breakpoint];
                    break;
                }
            }
            else results[index] = g;
        });
        return results;
    };
    var prefixCls = getPrefixCls("row", customizePrefixCls);
    var _useRowStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $86d3cd512305a3b3$export$b0d9c6b8be4e14cd)(prefixCls), 2), wrapCSSVar = _useRowStyle[0], hashId = _useRowStyle[1];
    var gutters = getGutter();
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-no-wrap"), wrap === false), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(mergeJustify), mergeJustify), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(mergeAlign), mergeAlign), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), className, hashId);
    // Add gutter related style
    var rowStyle = {};
    var horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    var _$ref;
    _$ref = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(gutters, 2), rowStyle.rowGap = _$ref[1], _$ref;
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    var _gutters = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(gutters, 2), gutterH = _gutters[0], gutterV = _gutters[1];
    var rowContext = $8SyCD.useMemo(function() {
        return {
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        };
    }, [
        gutterH,
        gutterV,
        wrap
    ]);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $7a75170e1d2795b3$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, others, {
        className: classes,
        style: Object.assign(Object.assign({}, rowStyle), style),
        ref: ref
    }), children)));
});
var $052ff5f829750c55$export$2e2bcd8739ae039 = $052ff5f829750c55$var$Row;



var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
function $56b2aff6b6beff35$export$2e2bcd8739ae039() {
    var _React_useReducer = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useReducer(function(x) {
        return x + 1;
    }, 0), 2), forceUpdate = _React_useReducer[1];
    return forceUpdate;
}



"use client";
function $ad217e1563e0ca7a$var$useBreakpoint() {
    var refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var screensRef = (0, $8SyCD.useRef)({});
    var forceUpdate = (0, $56b2aff6b6beff35$export$2e2bcd8739ae039)();
    var responsiveObserver = (0, $6d08709ecca144ea$export$2e2bcd8739ae039)();
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        var token = responsiveObserver.subscribe(function(supportScreens) {
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return function() {
            return responsiveObserver.unsubscribe(token);
        };
    }, []);
    return screensRef.current;
}
var $ad217e1563e0ca7a$export$2e2bcd8739ae039 = $ad217e1563e0ca7a$var$useBreakpoint;






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $c0a280241545c8c3$var$DoubleLeftOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    name: "double-left",
    theme: "outlined"
};
var $c0a280241545c8c3$export$2e2bcd8739ae039 = $c0a280241545c8c3$var$DoubleLeftOutlined;



var $e1dda8eabd26dbf3$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c0a280241545c8c3$export$2e2bcd8739ae039)
    }));
};
var $e1dda8eabd26dbf3$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($e1dda8eabd26dbf3$var$DoubleLeftOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $51db11dc621da407$var$DoubleRightOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    name: "double-right",
    theme: "outlined"
};
var $51db11dc621da407$export$2e2bcd8739ae039 = $51db11dc621da407$var$DoubleRightOutlined;



var $5d9e2469c70b0b53$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $51db11dc621da407$export$2e2bcd8739ae039)
    }));
};
var $5d9e2469c70b0b53$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($5d9e2469c70b0b53$var$DoubleRightOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $e748cc37df20b73c$var$LeftOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    name: "left",
    theme: "outlined"
};
var $e748cc37df20b73c$export$2e2bcd8739ae039 = $e748cc37df20b73c$var$LeftOutlined;



var $23a81172a0b746de$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e748cc37df20b73c$export$2e2bcd8739ae039)
    }));
};
var $23a81172a0b746de$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($23a81172a0b746de$var$LeftOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $437d750f012da16b$var$RightOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    name: "right",
    theme: "outlined"
};
var $437d750f012da16b$export$2e2bcd8739ae039 = $437d750f012da16b$var$RightOutlined;



var $d282c3c50daf5fec$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $437d750f012da16b$export$2e2bcd8739ae039)
    }));
};
var $d282c3c50daf5fec$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d282c3c50daf5fec$var$RightOutlined);













var $8SyCD = parcelRequire("8SyCD");
var $8da2e27b93e743f5$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $8da2e27b93e743f5$export$2e2bcd8739ae039 = $8da2e27b93e743f5$var$locale;





var $8SyCD = parcelRequire("8SyCD");
var $f882a453eb16bbc5$var$defaultPageSizeOptions = [
    "10",
    "20",
    "50",
    "100"
];
var $f882a453eb16bbc5$var$Options = function Options(props) {
    var _props$pageSizeOption = props.pageSizeOptions, pageSizeOptions = _props$pageSizeOption === void 0 ? $f882a453eb16bbc5$var$defaultPageSizeOptions : _props$pageSizeOption, locale = props.locale, changeSize = props.changeSize, pageSize = props.pageSize, goButton = props.goButton, quickGo = props.quickGo, rootPrefixCls = props.rootPrefixCls, Select = props.selectComponentClass, selectPrefixCls = props.selectPrefixCls, disabled = props.disabled, buildOptionText = props.buildOptionText;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(""), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), goInputText = _React$useState2[0], setGoInputText = _React$useState2[1];
    var getValidValue = function getValidValue() {
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    };
    var mergeBuildOptionText = typeof buildOptionText === "function" ? buildOptionText : function mergeBuildOptionText(value) {
        return "".concat(value, " ").concat(locale.items_per_page);
    };
    var changeSizeHandle = function changeSizeHandle(value) {
        changeSize === null || changeSize === void 0 || changeSize(Number(value));
    };
    var handleChange = function handleChange(e) {
        setGoInputText(e.target.value);
    };
    var handleBlur = function handleBlur(e) {
        if (goButton || goInputText === "") return;
        setGoInputText("");
        if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) return;
        quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    };
    var go = function go(e) {
        if (goInputText === "") return;
        if (e.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER || e.type === "click") {
            setGoInputText("");
            quickGo === null || quickGo === void 0 || quickGo(getValidValue());
        }
    };
    var getPageSizeOptions = function getPageSizeOptions() {
        if (pageSizeOptions.some(function(option) {
            return option.toString() === pageSize.toString();
        })) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize.toString()
        ]).sort(function(a, b) {
            var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    var prefixCls = "".concat(rootPrefixCls, "-options");
    // ============== render ==============
    if (!changeSize && !quickGo) return null;
    var changeSelect = null;
    var goInput = null;
    var gotoButton = null;
    if (changeSize && Select) {
        var options = getPageSizeOptions().map(function(opt, i) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(Select.Option, {
                key: i,
                value: opt.toString()
            }, mergeBuildOptionText(opt));
        });
        changeSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(Select, {
            disabled: disabled,
            prefixCls: selectPrefixCls,
            showSearch: false,
            className: "".concat(prefixCls, "-size-changer"),
            optionLabelProp: "children",
            popupMatchSelectWidth: false,
            value: (pageSize || pageSizeOptions[0]).toString(),
            onChange: changeSizeHandle,
            getPopupContainer: function getPopupContainer(triggerNode) {
                return triggerNode.parentNode;
            },
            "aria-label": locale.page_size,
            defaultOpen: false
        }, options);
    }
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === "boolean" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: "".concat(prefixCls, "-quick-jumper-button")
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
            className: "".concat(prefixCls, "-quick-jumper")
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $f882a453eb16bbc5$export$2e2bcd8739ae039 = $f882a453eb16bbc5$var$Options;





var $8SyCD = parcelRequire("8SyCD");
var $e984788037d5d2cb$var$Pager = function Pager(props) {
    var _classNames;
    var rootPrefixCls = props.rootPrefixCls, page = props.page, active = props.active, className = props.className, showTitle = props.showTitle, onClick = props.onClick, onKeyPress = props.onKeyPress, itemRender = props.itemRender;
    var prefixCls = "".concat(rootPrefixCls, "-item");
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-").concat(page), (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-active"), active), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), !page), _classNames), className);
    var handleClick = function handleClick() {
        onClick(page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        onKeyPress(e, onClick, page);
    };
    var pager = itemRender(page, "page", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $e984788037d5d2cb$export$2e2bcd8739ae039 = $e984788037d5d2cb$var$Pager;


var $98a606cc02262afa$var$defaultItemRender = function defaultItemRender(page, type, element) {
    return element;
};
function $98a606cc02262afa$var$noop() {}
function $98a606cc02262afa$var$isInteger(v) {
    var value = Number(v);
    return typeof value === "number" && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $98a606cc02262afa$var$calculatePage(p, pageSize, total) {
    var _pageSize = typeof p === "undefined" ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
var $98a606cc02262afa$var$Pagination = function Pagination(props) {
    var _classNames5;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-pagination" : _props$prefixCls, _props$selectPrefixCl = props.selectPrefixCls, selectPrefixCls = _props$selectPrefixCl === void 0 ? "rc-select" : _props$selectPrefixCl, className = props.className, selectComponentClass = props.selectComponentClass, currentProp = props.current, _props$defaultCurrent = props.defaultCurrent, defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent, _props$total = props.total, total = _props$total === void 0 ? 0 : _props$total, pageSizeProp = props.pageSize, _props$defaultPageSiz = props.defaultPageSize, defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $98a606cc02262afa$var$noop : _props$onChange, hideOnSinglePage = props.hideOnSinglePage, _props$showPrevNextJu = props.showPrevNextJumpers, showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu, showQuickJumper = props.showQuickJumper, showLessItems = props.showLessItems, _props$showTitle = props.showTitle, showTitle = _props$showTitle === void 0 ? true : _props$showTitle, _props$onShowSizeChan = props.onShowSizeChange, onShowSizeChange = _props$onShowSizeChan === void 0 ? $98a606cc02262afa$var$noop : _props$onShowSizeChan, _props$locale = props.locale, locale = _props$locale === void 0 ? (0, $8da2e27b93e743f5$export$2e2bcd8739ae039) : _props$locale, style = props.style, _props$totalBoundaryS = props.totalBoundaryShowSizeChanger, totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS, disabled = props.disabled, simple = props.simple, showTotal = props.showTotal, showSizeChangerProp = props.showSizeChanger, pageSizeOptions = props.pageSizeOptions, _props$itemRender = props.itemRender, itemRender = _props$itemRender === void 0 ? $98a606cc02262afa$var$defaultItemRender : _props$itemRender, jumpPrevIcon = props.jumpPrevIcon, jumpNextIcon = props.jumpNextIcon, prevIcon = props.prevIcon, nextIcon = props.nextIcon;
    var paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useRef(null);
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(10, {
        value: pageSizeProp,
        defaultValue: defaultPageSize
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), pageSize = _useMergedState2[0], setPageSize = _useMergedState2[1];
    var _useMergedState3 = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(1, {
        value: currentProp,
        defaultValue: defaultCurrent,
        postState: function postState(c) {
            return Math.max(1, Math.min(c, $98a606cc02262afa$var$calculatePage(undefined, pageSize, total)));
        }
    }), _useMergedState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState3, 2), current = _useMergedState4[0], setCurrent = _useMergedState4[1];
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useState(current), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), internalInputVal = _React$useState2[0], setInternalInputVal = _React$useState2[1];
    var hasOnChange = onChange !== $98a606cc02262afa$var$noop;
    var hasCurrent = "current" in props;
    var jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    var jumpNextPage = Math.min($98a606cc02262afa$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        var iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: "".concat(prefixCls, "-item-link")
        });
        if (typeof icon === "function") iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(icon, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props));
        return iconNode;
    }
    function getValidValue(e) {
        var inputValue = e.target.value;
        var allPages = $98a606cc02262afa$var$calculatePage(undefined, pageSize, total);
        var value;
        if (inputValue === "") value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $98a606cc02262afa$var$isInteger(page) && page !== current && $98a606cc02262afa$var$isInteger(total) && total > 0;
    }
    var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP || event.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        var value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        var newCurrent = $98a606cc02262afa$var$calculatePage(size, pageSize, total);
        var nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current, size);
        setCurrent(nextCurrent);
        onChange === null || onChange === void 0 || onChange(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            var currentPage = $98a606cc02262afa$var$calculatePage(undefined, pageSize, total);
            var newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange === null || onChange === void 0 || onChange(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    var hasPrev = current > 1;
    var hasNext = current < $98a606cc02262afa$var$calculatePage(undefined, pageSize, total);
    var showSizeChanger = showSizeChangerProp !== null && showSizeChangerProp !== void 0 ? showSizeChangerProp : total > totalBoundaryShowSizeChanger;
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback) {
        if (event.key === "Enter" || event.charCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) {
            for(var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
            callback.apply(void 0, restParams);
        }
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        var prevButton = itemRender(prevPage, "prev", getItemIcon(prevIcon, "prev page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        var nextButton = itemRender(nextPage, "next", getItemIcon(nextIcon, "next page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === "click" || event.keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    var jumpPrev = null;
    var dataOrAriaAttributeProps = (0, $71d39879295f84b9$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    var totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
        className: "".concat(prefixCls, "-total-text")
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    var jumpNext = null;
    var allPages = $98a606cc02262afa$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    var pagerList = [];
    var pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1
    };
    var prevPage = current - 1 > 0 ? current - 1 : 0;
    var nextPage = current + 1 < allPages ? current + 1 : allPages;
    var goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    var gotoButton = goButton;
    var simplePager = null;
    if (simple) {
        if (typeof goButton === "boolean") gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("button", {
            type: "button",
            onClick: handleGoTO,
            onKeyUp: handleGoTO
        }, locale.jump_to_confirm);
        else /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            onClick: handleGoTO,
            onKeyUp: handleGoTO
        }, goButton);
        gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
            title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
        }, gotoButton);
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
            title: showTitle ? "".concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("input", {
            type: "text",
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("span", {
            className: "".concat(prefixCls, "-slash")
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    var pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e984788037d5d2cb$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: "".concat(prefixCls, "-item-disabled")
        })));
        for(var i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e984788037d5d2cb$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        var jumpPrevContent = itemRender(jumpPrevPage, "jump-prev", getItemIcon(jumpPrevIcon, "prev page"));
        var jumpNextContent = itemRender(jumpNextPage, "jump-next", getItemIcon(jumpNextIcon, "next page"));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-jump-prev"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-jump-next"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
            }, jumpNextContent) : null;
        }
        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(var _i = left; _i <= right; _i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e984788037d5d2cb$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, pagerProps, {
            key: _i,
            page: _i,
            active: current === _i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(pagerList[0], {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).cloneElement(pagerList.at(-1), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item-before-jump-next"), pagerList.at(-1).props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e984788037d5d2cb$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $e984788037d5d2cb$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    var prev = renderPrev(prevPage);
    if (prev) {
        var prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-prev"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
            "aria-disabled": prevDisabled
        }, prev);
    }
    var next = renderNext(nextPage);
    if (next) {
        var nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-next"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
            "aria-disabled": nextDisabled
        }, next);
    }
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className, (_classNames5 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-simple"), simple), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-disabled"), disabled), _classNames5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("ul", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $f882a453eb16bbc5$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectComponentClass: selectComponentClass,
        selectPrefixCls: selectPrefixCls,
        changeSize: showSizeChanger ? changePageSize : null,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton
    }));
};
var $98a606cc02262afa$export$2e2bcd8739ae039 = $98a606cc02262afa$var$Pagination;






var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");











var $8SyCD = parcelRequire("8SyCD");














var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");

var $79adc53013c0ed8f$var$TransBtn = function TransBtn(_ref) {
    var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
    var icon;
    if (typeof customizeIcon === "function") icon = customizeIcon(customizeIconProps);
    else icon = customizeIcon;
    return /*#__PURE__*/ $8SyCD.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            if (_onMouseDown) _onMouseDown(event);
        },
        style: {
            userSelect: "none",
            WebkitUserSelect: "none"
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $8SyCD.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $79adc53013c0ed8f$export$2e2bcd8739ae039 = $79adc53013c0ed8f$var$TransBtn;



var $8SyCD = parcelRequire("8SyCD");
function $80b99fe42673b640$export$9ea6397a890aa3e5(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
    var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
    var mode = arguments.length > 7 ? arguments[7] : undefined;
    var mergedClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useMemo(function() {
        if ((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(allowClear) === "object") return allowClear.clearIcon;
        if (!!clearIcon) return clearIcon;
    }, [
        allowClear,
        clearIcon
    ]);
    var mergedAllowClear = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useMemo(function() {
        if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) return true;
        return false;
    }, [
        allowClear,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
    return {
        allowClear: mergedAllowClear,
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $79adc53013c0ed8f$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-clear"),
            onMouseDown: onClearMouseDown,
            customizeIcon: mergedClearIcon
        }, "\xd7")
    };
}


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $8SyCD = parcelRequire("8SyCD");
var $289a723bfa6ef318$export$8234047c0aea33cf = /*#__PURE__*/ $8SyCD.createContext(null);
function $289a723bfa6ef318$export$2e2bcd8739ae039() {
    return $8SyCD.useContext($289a723bfa6ef318$export$8234047c0aea33cf);
}




var $8SyCD = parcelRequire("8SyCD");
function $9ee11eb2552a8d6b$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $8SyCD.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $8SyCD.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $8SyCD = parcelRequire("8SyCD");
function $3df4c04918577ec5$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $8SyCD.useRef(null);
    var timeoutRef = $8SyCD.useRef(null);
    // Clean up
    $8SyCD.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $8SyCD = parcelRequire("8SyCD");
function $232e23ac1376c70c$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $8SyCD.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $8SyCD.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener("mousedown", onGlobalMouseDown);
        return function() {
            return window.removeEventListener("mousedown", onGlobalMouseDown);
        };
    }, []);
}





var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");



var $c21057684da47c2c$var$Input = function Input(_ref, ref) {
    var _inputNode2;
    var prefixCls = _ref.prefixCls, id = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, activeDescendantId = _ref.activeDescendantId, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $8SyCD.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $ed6f30969113606c$export$491112666e282270)(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $8SyCD.cloneElement(inputNode, (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        type: "search"
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || "off",
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
        role: "combobox",
        "aria-expanded": open || false,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": open ? activeDescendantId : undefined
    }, attrs), {}, {
        value: editable ? value : "",
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? "on" : null,
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $c21057684da47c2c$var$RefInput = /*#__PURE__*/ $8SyCD.forwardRef($c21057684da47c2c$var$Input);
$c21057684da47c2c$var$RefInput.displayName = "Input";
var $c21057684da47c2c$export$2e2bcd8739ae039 = $c21057684da47c2c$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $8SyCD = parcelRequire("8SyCD");

function $28b4485c1ece718a$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $28b4485c1ece718a$export$7383f122bf48ec30 = typeof window !== "undefined" && window.document && window.document.documentElement;
var $28b4485c1ece718a$export$df7146797a248522 = $28b4485c1ece718a$export$7383f122bf48ec30;
function $28b4485c1ece718a$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $28b4485c1ece718a$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $28b4485c1ece718a$var$isTitleType(title) {
    return [
        "string",
        "number"
    ].includes((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(title));
}
function $28b4485c1ece718a$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($28b4485c1ece718a$var$isTitleType(item.title)) title = item.title.toString();
        else if ($28b4485c1ece718a$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $c052dfc07f3505ec$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $28b4485c1ece718a$export$df7146797a248522) /* istanbul ignore next */ $8SyCD.useLayoutEffect(effect, deps);
    else $8SyCD.useEffect(effect, deps);
} /* eslint-enable */ 



function $63963cd309798a95$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $63963cd309798a95$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $63963cd309798a95$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function maxTagPlaceholder(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $8SyCD.useRef(null);
    var _useState = (0, $8SyCD.useState)(0), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)(false), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
    var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $c052dfc07f3505ec$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $8SyCD.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(selectionPrefixCls, "-item"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled)),
            title: (0, $28b4485c1ece718a$export$70d1bf7729efff40)(item)
        }, /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $8SyCD.createElement((0, $79adc53013c0ed8f$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $63963cd309798a95$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xd7"));
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        var onMouseDown = function onMouseDown(e) {
            $63963cd309798a95$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $8SyCD.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose
        }));
    }
    function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === "number") {
            if (typeof label === "string" || typeof label === "number") {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return defaultRenderSelector({
            title: content
        }, content, false);
    }
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $8SyCD.createElement((0, $c21057684da47c2c$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $71d39879295f84b9$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $8SyCD.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xa0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $8SyCD.createElement((0, $396895c1c3d96329$export$2e2bcd8739ae039), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $63963cd309798a95$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $63963cd309798a95$export$2e2bcd8739ae039 = $63963cd309798a95$var$SelectSelector;




var $8SyCD = parcelRequire("8SyCD");



var $9e2c7f3a51f008c7$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, title = props.title;
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === "combobox";
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || "";
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $8SyCD.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== "combobox" && !open && !showSearch ? false : !!inputValue;
    // Get title of selection item
    var selectionTitle = title === undefined ? (0, $28b4485c1ece718a$export$70d1bf7729efff40)(item) : title;
    var renderPlaceholder = function renderPlaceholder() {
        if (item) return null;
        var hiddenStyle = hasTextInput ? {
            visibility: "hidden"
        } : undefined;
        return /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hiddenStyle
        }, placeholder);
    };
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $8SyCD.createElement((0, $c21057684da47c2c$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $71d39879295f84b9$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: selectionTitle,
        style: hasTextInput ? {
            visibility: "hidden"
        } : undefined
    }, item.label) : null, renderPlaceholder());
};
var $9e2c7f3a51f008c7$export$2e2bcd8739ae039 = $9e2c7f3a51f008c7$var$SingleSelector;




function $ac71ed60eb094d2f$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).SHIFT,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).BACKSPACE,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).TAB,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).WIN_KEY,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).ALT,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).META,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).CTRL,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).SEMICOLON,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).EQUALS,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).CONTEXT_MENU,
        // F1-F12
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F1,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F2,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F3,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F4,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F5,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F6,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F7,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F8,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F9,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F10,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F11,
        (0, $5ebc594569656f88$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode);
}


var $888fed3bdb5d8f0a$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $8SyCD.useRef)(null);
    var compositionStatusRef = (0, $8SyCD.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                inputRef.current.focus();
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $3df4c04918577ec5$export$2e2bcd8739ae039)(0), _useLock2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP || which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER && mode === "tags" && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $ac71ed60eb094d2f$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $8SyCD.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== "combobox") triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData.getData("text");
        pastedTextRef.current = value;
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        if (event.target !== inputRef.current && !inputMouseDown && mode !== "combobox") event.preventDefault();
        if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch("", true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === "multiple" || mode === "tags" ? /*#__PURE__*/ $8SyCD.createElement((0, $63963cd309798a95$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, sharedProps)) : /*#__PURE__*/ $8SyCD.createElement((0, $9e2c7f3a51f008c7$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, sharedProps));
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $888fed3bdb5d8f0a$var$ForwardSelector = /*#__PURE__*/ $8SyCD.forwardRef($888fed3bdb5d8f0a$var$Selector);
$888fed3bdb5d8f0a$var$ForwardSelector.displayName = "Selector";
var $888fed3bdb5d8f0a$export$2e2bcd8739ae039 = $888fed3bdb5d8f0a$var$ForwardSelector;









var $8SyCD = parcelRequire("8SyCD");
var $9b438d04e41c4fc0$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "builtinPlacements",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $9b438d04e41c4fc0$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        bottomRight: {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topLeft: {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topRight: {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        }
    };
};
var $9b438d04e41c4fc0$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $9b438d04e41c4fc0$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var mergedBuiltinPlacements = $8SyCD.useMemo(function() {
        return builtinPlacements || $9b438d04e41c4fc0$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        builtinPlacements,
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // =================== Popup Width ===================
    var isNumberPopupWidth = typeof dropdownMatchSelectWidth === "number";
    var stretch = $8SyCD.useMemo(function() {
        if (isNumberPopupWidth) return null;
        return dropdownMatchSelectWidth === false ? "minWidth" : "width";
    }, [
        dropdownMatchSelectWidth,
        isNumberPopupWidth
    ]);
    var popupStyle = dropdownStyle;
    if (isNumberPopupWidth) popupStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, popupStyle), {}, {
        width: dropdownMatchSelectWidth
    });
    // ======================= Ref =======================
    var popupRef = $8SyCD.useRef(null);
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                return popupRef.current;
            }
        };
    });
    return /*#__PURE__*/ $8SyCD.createElement((0, $639aa9e1edacf68a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        hideAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $8SyCD.createElement("div", {
            ref: popupRef,
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        stretch: stretch,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(dropdownClassName, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $9b438d04e41c4fc0$var$RefSelectTrigger = /*#__PURE__*/ $8SyCD.forwardRef($9b438d04e41c4fc0$var$SelectTrigger);
$9b438d04e41c4fc0$var$RefSelectTrigger.displayName = "SelectTrigger";
var $9b438d04e41c4fc0$export$2e2bcd8739ae039 = $9b438d04e41c4fc0$var$RefSelectTrigger;







function $4a680885281ce3fa$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ("value" in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $4a680885281ce3fa$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
    var mergedLabel = label || (childrenAsData ? "children" : "label");
    return {
        label: mergedLabel,
        value: value || "value",
        options: options || "options",
        groupLabel: groupLabel || mergedLabel
    };
}
function $4a680885281ce3fa$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $4a680885281ce3fa$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
    function dig(list, isGroupOption) {
        list.forEach(function(data) {
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $4a680885281ce3fa$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                var grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $4a680885281ce3fa$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $4a680885281ce3fa$export$d0b21b213c8c013c(option) {
    var newOption = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, option);
    if (!("props" in newOption)) Object.defineProperty(newOption, "props", {
        get: function get() {
            (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
            return newOption;
        }
    });
    return newOption;
}
function $4a680885281ce3fa$export$a09ca2a89e052b14(text, tokens) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    function separate(str, _ref3) {
        var _ref4 = (0, $a34941462ba6474a$export$2e2bcd8739ae039)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(prevList), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(separate(unitStr, restTokens)));
        }, []).filter(function(unit) {
            return unit;
        });
    }
    var list = separate(text, tokens);
    return match ? list : null;
}


var $83e88d653e4c2190$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "suffixIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "builtinPlacements",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $83e88d653e4c2190$var$DEFAULT_OMIT_PROPS = [
    "value",
    "onChange",
    "removeIcon",
    "placeholder",
    "autoFocus",
    "maxTagCount",
    "maxTagTextLength",
    "maxTagPlaceholder",
    "choiceTransitionName",
    "onInputKeyDown",
    "onPopupScroll",
    "tabIndex"
];
function $83e88d653e4c2190$export$7f654ad2a77ad2ac(mode) {
    return mode === "tags" || mode === "multiple";
}
var $83e88d653e4c2190$var$BaseSelect = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _customizeRawInputEle, _classNames2;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $83e88d653e4c2190$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $83e88d653e4c2190$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === "combobox";
    var domProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, restProps);
    $83e88d653e4c2190$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $8SyCD.useEffect(function() {
        // Only update on the client side
        setMobile((0, $fc01ea5e514846e5$export$2e2bcd8739ae039)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $8SyCD.useRef(null);
    var selectorDomRef = $8SyCD.useRef(null);
    var triggerRef = $8SyCD.useRef(null);
    var selectorRef = $8SyCD.useRef(null);
    var listRef = $8SyCD.useRef(null);
    var blurRef = $8SyCD.useRef(false);
    /** Used for component focused management */ var _useDelayReset = (0, $9ee11eb2552a8d6b$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $8SyCD.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            }
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $8SyCD.useMemo(function() {
        var _displayValues$;
        if (mode !== "combobox") return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === "string" || typeof val === "number" ? String(val) : "";
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
    var customizeRawInputRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    // SSR not support Portal which means we need delay `open` for the first time render
    var _React$useState3 = $8SyCD.useState(false), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        setRendered(true);
    }, []);
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = rendered ? innerOpen : false;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === "combobox") mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $8SyCD.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $8SyCD.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                "\n",
                "\r\n"
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : (0, $4a680885281ce3fa$export$a09ca2a89e052b14)(searchText, tokenSeparators);
        // Ignore combobox since it's not split-able
        if (mode !== "combobox" && patchLabels) {
            newSearchText = "";
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? "typing" : "effect"
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: "submit"
        });
    };
    // Close will clean up single mode search text
    $8SyCD.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== "combobox") onInternalSearch("", false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $8SyCD.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled && !blurRef.current) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $3df4c04918577ec5$export$2e2bcd8739ae039)(), _useLock2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) {
            // Do not submit form when type in the input
            if (mode !== "combobox") event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: "remove",
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && listRef.current) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen && listRef.current) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: "remove",
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $8SyCD.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes("focus")) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        blurRef.current = true;
        setMockFocused(false, function() {
            focusRef.current = false;
            blurRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === "tags") onSearch(mergedSearchValue, {
                source: "submit"
            });
            else if (mode === "multiple") // `multiple` mode only clean the search value but not trigger event
            onSearch("", {
                source: "blur"
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $8SyCD.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState5 = $8SyCD.useState({}), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $232e23ac1376c70c$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $8SyCD.useMemo(function() {
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var showSuffixIcon = !!suffixIcon || loading;
    var arrowNode;
    if (showSuffixIcon) arrowNode = /*#__PURE__*/ $8SyCD.createElement((0, $79adc53013c0ed8f$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-arrow"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: suffixIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: "clear",
            values: displayValues
        });
        onInternalSearch("", false, false);
    };
    var _useAllowClear = (0, $80b99fe42673b640$export$9ea6397a890aa3e5)(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $8SyCD.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className, (_classNames2 = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-multiple"), multiple), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-single"), !multiple), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-show-arrow"), showSuffixIcon), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-loading"), loading), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $8SyCD.createElement((0, $9b438d04e41c4fc0$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode() {
            return selectorDomRef.current;
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $8SyCD.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $8SyCD.createElement((0, $888fed3bdb5d8f0a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/ $8SyCD.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        },
        "aria-live": "polite"
    }, "".concat(displayValues.map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            "number",
            "string"
        ].includes((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(label)) ? label : value;
    }).join(", "))), selectorNode, arrowNode, mergedAllowClear && clearNode);
    return /*#__PURE__*/ $8SyCD.createElement((0, $289a723bfa6ef318$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $83e88d653e4c2190$export$2e2bcd8739ae039 = $83e88d653e4c2190$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $ec26dd712d996fae$var$OptGroup = function OptGroup() {
    return null;
};
$ec26dd712d996fae$var$OptGroup.isSelectOptGroup = true;
var $ec26dd712d996fae$export$2e2bcd8739ae039 = $ec26dd712d996fae$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $6712e9289b1afa7e$var$Option = function Option() {
    return null;
};
$6712e9289b1afa7e$var$Option.isSelectOption = true;
var $6712e9289b1afa7e$export$2e2bcd8739ae039 = $6712e9289b1afa7e$var$Option;



















var $8SyCD = parcelRequire("8SyCD");







var $8SyCD = parcelRequire("8SyCD");


/**
 * Fill component to provided the scroll content real height.
 */ var $834fca343d6e3079$var$Filler = /*#__PURE__*/ $8SyCD.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: "flex",
        flexDirection: "column"
    };
    if (offsetY !== undefined) {
        var _objectSpread2;
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: "relative",
            overflow: "hidden"
        };
        innerStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, innerStyle), {}, (_objectSpread2 = {
            transform: "translateY(".concat(offsetY, "px)")
        }, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, rtl ? "marginRight" : "marginLeft", -offsetX), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, "left", 0), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, "right", 0), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_objectSpread2, "top", 0), _objectSpread2));
    }
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$834fca343d6e3079$var$Filler.displayName = "Filler";
var $834fca343d6e3079$export$2e2bcd8739ae039 = $834fca343d6e3079$var$Filler;






var $8SyCD = parcelRequire("8SyCD");


function $30b0c78c6c24753f$var$getPageXY(e, horizontal) {
    var obj = "touches" in e ? e.touches[0] : e;
    return obj[horizontal ? "pageX" : "pageY"];
}
var $30b0c78c6c24753f$var$ScrollBar = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _classNames;
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $8SyCD.useState(null), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $8SyCD.useState(null), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $8SyCD.useRef();
    var thumbRef = $8SyCD.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $8SyCD.useState(false), _React$useState8 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $8SyCD.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // `scrollWidth` < `clientWidth` means no need to show scrollbar
    var canScroll = enableScrollRange > 0;
    // ========================= Top ==========================
    var top = $8SyCD.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $8SyCD.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY($30b0c78c6c24753f$var$getPageXY(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $8SyCD.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart);
        thumbEle.addEventListener("touchstart", onThumbMouseDown);
        return function() {
            scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
            thumbEle.removeEventListener("touchstart", onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $8SyCD.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $8SyCD.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $8SyCD.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(moveRafId);
                if (stateDragging) {
                    var offset = $30b0c78c6c24753f$var$getPageXY(e, horizontal) - statePageY;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("touchmove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
            window.addEventListener("touchend", onMouseUp);
            return function() {
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("touchmove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
                window.removeEventListener("touchend", onMouseUp);
                (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $8SyCD.useEffect(function() {
        delayHidden();
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: "absolute",
        visibility: visible && canScroll ? null : "hidden"
    };
    var thumbStyle = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 99,
        cursor: "pointer",
        userSelect: "none"
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = "100%";
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = "100%";
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(scrollbarPrefixCls, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(scrollbarPrefixCls, "-visible"), visible), _classNames)),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $30b0c78c6c24753f$export$2e2bcd8739ae039 = $30b0c78c6c24753f$var$ScrollBar;



var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
function $f3930e2494aaf85b$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $8SyCD.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $8SyCD.cloneElement(children, {
        ref: refFunc
    });
}


function $45519312864d961a$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            }
        });
        var key = getKey(item);
        return /*#__PURE__*/ $8SyCD.createElement((0, $f3930e2494aaf85b$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}




var $8SyCD = parcelRequire("8SyCD");




// Firefox has low performance of map.
var $56586dc892a516a6$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, CacheMap);
        this.maps = void 0;
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        this.id = 0;
        this.maps = Object.create(null);
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $56586dc892a516a6$export$2e2bcd8739ae039 = $56586dc892a516a6$var$CacheMap;


function $4b45a0ab9d2dd849$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $8SyCD.useState(0), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $8SyCD.useRef)(new Map());
    var heightsRef = (0, $8SyCD.useRef)(new (0, $56586dc892a516a6$export$2e2bcd8739ae039)());
    var collectRafRef = (0, $8SyCD.useRef)();
    function cancelRaf() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $a4b291de522e10cb$export$2e2bcd8739ae039)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    if (heightsRef.current.get(key) !== offsetHeight) heightsRef.current.set(key, htmlElement.offsetHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current["delete"](key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $8SyCD.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}






var $8SyCD = parcelRequire("8SyCD");



var $740e25e40ddac95e$var$MAX_TIMES = 10;
function $740e25e40ddac95e$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $8SyCD.useRef();
    var _React$useState = $8SyCD.useState(null), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (syncState && syncState.times < $740e25e40ddac95e$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === "top" ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case "top":
                        targetTop = itemTop - offset;
                        break;
                    case "bottom":
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = "top";
                        else if (itemBottom > scrollBottom) newTargetAlign = "bottom";
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === "number") syncScrollTop(arg);
        else if (arg && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(arg) === "object") {
            var index;
            var align = arg.align;
            if ("index" in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}




var $8SyCD = parcelRequire("8SyCD");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $7e89e49077513a37$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $7e89e49077513a37$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $a5b042033320f357$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $8SyCD.useState(data), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $8SyCD.useState(null), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $8SyCD.useEffect(function() {
        var diff = (0, $7e89e49077513a37$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}



var $8SyCD = parcelRequire("8SyCD");


var $e2357f250d26f6a0$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var $e2357f250d26f6a0$export$2e2bcd8739ae039 = $e2357f250d26f6a0$var$isFF;



var $8SyCD = parcelRequire("8SyCD");
var $a5c532d6066609d2$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $8SyCD.useRef)(false);
    var lockTimeoutRef = (0, $8SyCD.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $8SyCD.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    return function(deltaY) {
        var smoothOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var originScroll = // Pass origin wheel when on the top
        deltaY < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        deltaY > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $7cd1782203499319$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $8SyCD.useRef)(0);
    var nextFrameRef = (0, $8SyCD.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $8SyCD.useRef)(null);
    var isMouseScrollRef = (0, $8SyCD.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $a5c532d6066609d2$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom);
    function onWheelY(event, deltaY) {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(deltaY)) return;
        // Proxy of scroll events
        if (!(0, $e2357f250d26f6a0$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $e2357f250d26f6a0$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $8SyCD.useRef)(null);
    var wheelDirectionCleanRef = (0, $8SyCD.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = "sx";
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
        if (wheelDirectionRef.current === "y") onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $8SyCD = parcelRequire("8SyCD");

var $2877b9fac5c7dc60$var$SMOOTH_PTG = 14 / 15;
function $2877b9fac5c7dc60$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $8SyCD.useRef)(false);
    var touchYRef = (0, $8SyCD.useRef)(0);
    var elementRef = (0, $8SyCD.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $8SyCD.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetY = touchYRef.current - currentY;
            touchYRef.current = currentY;
            if (callback(offsetY)) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(function() {
                offsetY *= $2877b9fac5c7dc60$var$SMOOTH_PTG;
                if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener("touchmove", onTouchMove);
            elementRef.current.addEventListener("touchend", onTouchEnd);
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener("touchmove", onTouchMove);
            elementRef.current.removeEventListener("touchend", onTouchEnd);
        }
    };
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (inVirtual) listRef.current.addEventListener("touchstart", onTouchStart);
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener("touchstart", onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}




var $f22ecd1b6d0ee46d$var$MIN_SIZE = 20;
function $f22ecd1b6d0ee46d$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * 100;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $f22ecd1b6d0ee46d$var$MIN_SIZE);
    baseSize = Math.min(baseSize, containerSize / 2);
    return Math.floor(baseSize);
}





var $8SyCD = parcelRequire("8SyCD");
function $39c4cc8455152e63$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $8SyCD.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}


var $ebd382a3754d105b$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $ebd382a3754d105b$var$EMPTY_DATA = [];
var $ebd382a3754d105b$var$ScrollStyle = {
    overflowY: "auto",
    overflowAnchor: "none"
};
function $ebd382a3754d105b$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $ebd382a3754d105b$var$_excluded);
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var inVirtual = useVirtual && data && (itemHeight * data.length > height || !!scrollWidth);
    var isRTL = direction === "rtl";
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $ebd382a3754d105b$var$EMPTY_DATA;
    var componentRef = (0, $8SyCD.useRef)();
    var fillerInnerRef = (0, $8SyCD.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $8SyCD.useState)(0), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $8SyCD.useState)(0), _useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $8SyCD.useState)(false), _useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    // =============================== Item Key ===============================
    var getKey = $8SyCD.useCallback(function(item) {
        if (typeof itemKey === "function") return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === "function") value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $8SyCD.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $8SyCD.useRef)();
    var _useDiffItem = (0, $a5b042033320f357$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ================================ Height ================================
    var _useHeights = (0, $4b45a0ab9d2dd849$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ========================== Visible Calculation =========================
    var _React$useMemo = $8SyCD.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var item = mergedData[i];
            var key = getKey(item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $8SyCD.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.width || sizeInfo.offsetWidth,
            height: sizeInfo.height || sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $8SyCD.useRef)();
    var horizontalScrollBarRef = (0, $8SyCD.useRef)();
    var horizontalScrollBarSpinSize = $8SyCD.useMemo(function() {
        return (0, $f22ecd1b6d0ee46d$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $8SyCD.useMemo(function() {
        return (0, $f22ecd1b6d0ee46d$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $8SyCD.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var originScroll = (0, $a5c532d6066609d2$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $8SyCD.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function() {
        if (onVirtualScroll) {
            var nextInfo = getVirtualScrollInfo();
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $b4e4ce7bd3c993b9$exports.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = scrollWidth - size.width;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            // Horizontal scroll no need sync virtual position
            (0, $b4e4ce7bd3c993b9$exports.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $7cd1782203499319$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $2877b9fac5c7dc60$export$2e2bcd8739ae039)(useVirtual, componentRef, function(deltaY, smoothOffset) {
        if (originScroll(deltaY, smoothOffset)) return false;
        onRawWheel({
            preventDefault: function preventDefault() {},
            deltaY: deltaY
        });
        return true;
    });
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            if (useVirtual) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener("wheel", onRawWheel);
        componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll);
        componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        return function() {
            componentEle.removeEventListener("wheel", onRawWheel);
            componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
            componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        };
    }, [
        useVirtual
    ]);
    // Sync scroll left
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (scrollWidth) setOffsetLeft(function(left) {
            return keepInHorizontalRange(left);
        });
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $740e25e40ddac95e$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(arg) === "object" && ("left" in arg || "top" in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $39c4cc8455152e63$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $45519312864d961a$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, fullHeight ? "height" : "maxHeight", height), $ebd382a3754d105b$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = "hidden";
            if (scrollWidth) componentStyle.overflowX = "hidden";
            if (scrollMoving) componentStyle.pointerEvents = "none";
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = "rtl";
    return /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        style: (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, style), {}, {
            position: "relative"
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $8SyCD.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $8SyCD.createElement((0, $834fca343d6e3079$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $8SyCD.createElement((0, $30b0c78c6c24753f$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth && /*#__PURE__*/ $8SyCD.createElement((0, $30b0c78c6c24753f$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $ebd382a3754d105b$var$List = /*#__PURE__*/ $8SyCD.forwardRef($ebd382a3754d105b$export$cc3be4e46e8486ed);
$ebd382a3754d105b$var$List.displayName = "List";
var $ebd382a3754d105b$export$2e2bcd8739ae039 = $ebd382a3754d105b$var$List;


var $9130f180cf687367$export$2e2bcd8739ae039 = (0, $ebd382a3754d105b$export$2e2bcd8739ae039);



var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
// Use any here since we do not get the type during compilation
var $c0f2aba139303ec5$var$SelectContext = /*#__PURE__*/ $8SyCD.createContext(null);
var $c0f2aba139303ec5$export$2e2bcd8739ae039 = $c0f2aba139303ec5$var$SelectContext;




/* istanbul ignore file */ function $9aa0f9412540243e$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}


var $a6c36d03cccfaaeb$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $a6c36d03cccfaaeb$var$isTitleType(content) {
    return typeof content === "string" || typeof content === "number";
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $a6c36d03cccfaaeb$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $289a723bfa6ef318$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $8SyCD.useContext((0, $c0f2aba139303ec5$export$2e2bcd8739ae039)), flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $f718e8ae83c37f1e$export$2e2bcd8739ae039)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $8SyCD.useRef(null);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        if (listRef.current) listRef.current.scrollTo(typeof args === "number" ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
            if (!group && !data.disabled) return current;
        }
        return -1;
    };
    var _React$useState = $8SyCD.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? "keyboard" : "mouse"
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $8SyCD.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $8SyCD.useCallback(function(value) {
        return rawValues.has(value) && mode !== "combobox";
    }, [
        mode,
        (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $8SyCD.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref) {
                    var data = _ref.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).N:
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).P:
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP:
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN:
                        var offset = 0;
                        if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).UP) offset = -1;
                        else if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).DOWN) offset = 1;
                        else if ((0, $9aa0f9412540243e$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).N) offset = 1;
                            else if (which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER:
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !item.data.disabled) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $8SyCD.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    function getItemAriaProps(item, index) {
        var group = item.group;
        return {
            role: group ? "presentation" : "option",
            id: "".concat(id, "_list_").concat(index)
        };
    }
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $71d39879295f84b9$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    var a11yProps = {
        role: "listbox",
        id: "".concat(id, "_list")
    };
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, virtual && /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: "hidden"
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $8SyCD.createElement((0, $9130f180cf687367$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps
    }, function(item, itemIndex) {
        var _classNames;
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $a6c36d03cccfaaeb$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $8SyCD.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(data, $a6c36d03cccfaaeb$var$_excluded);
        var passedProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $a6c36d03cccfaaeb$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $8SyCD.createElement("div", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, (0, $71d39879295f84b9$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || disabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!disabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $8SyCD.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, typeof optionRender === "function" ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $8SyCD.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $8SyCD.createElement((0, $79adc53013c0ed8f$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: disabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $a6c36d03cccfaaeb$var$RefOptionList = /*#__PURE__*/ $8SyCD.forwardRef($a6c36d03cccfaaeb$var$OptionList);
$a6c36d03cccfaaeb$var$RefOptionList.displayName = "OptionList";
var $a6c36d03cccfaaeb$export$2e2bcd8739ae039 = $a6c36d03cccfaaeb$var$RefOptionList;





var $8SyCD = parcelRequire("8SyCD");
var /**
 * Cache `value` related LabeledValue & options.
 */ $43b715a190bc09e0$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $8SyCD.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $8SyCD.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $8SyCD.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};





var $8SyCD = parcelRequire("8SyCD");


function $ef8f6a2345ca1020$var$includes(test, search) {
    return (0, $28b4485c1ece718a$export$45b10814cc054894)(test).join("").toUpperCase().includes(search);
}
var $ef8f6a2345ca1020$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $8SyCD.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === "function";
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function filterFunc(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $ef8f6a2345ca1020$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $ef8f6a2345ca1020$var$includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
            return $ef8f6a2345ca1020$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function wrapOption(opt) {
            return (0, $4a680885281ce3fa$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, item), {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};




var $8SyCD = parcelRequire("8SyCD");

var $8e13b7e65f053b96$var$uuid = 0;
var $8e13b7e65f053b96$export$df7146797a248522 = (0, $014625af273be671$export$2e2bcd8739ae039)();
function $8e13b7e65f053b96$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($8e13b7e65f053b96$export$df7146797a248522) {
        retId = $8e13b7e65f053b96$var$uuid;
        $8e13b7e65f053b96$var$uuid += 1;
    } else retId = "TEST_OR_SSR";
    return retId;
}
function $8e13b7e65f053b96$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $8SyCD.useState(), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $8SyCD.useEffect(function() {
        setInnerId("rc_select_".concat($8e13b7e65f053b96$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");

var $ecbd8088adf8ace7$var$_excluded = [
    "children",
    "value"
], $ecbd8088adf8ace7$var$_excluded2 = [
    "children"
];
function $ecbd8088adf8ace7$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref$props, $ecbd8088adf8ace7$var$_excluded);
    return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $ecbd8088adf8ace7$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $8SyCD.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref2$props, $ecbd8088adf8ace7$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $ecbd8088adf8ace7$var$convertNodeToOption(node);
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $ecbd8088adf8ace7$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


function $3b3f0e90b4d39768$export$2e2bcd8739ae039(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $8SyCD.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $ecbd8088adf8ace7$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === "string") labelOptionsMap.set(option[key], option);
        };
        function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        }
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
}



var $8SyCD = parcelRequire("8SyCD");
function $747c9fd72a82fb91$export$2e2bcd8739ae039(callback) {
    var funcRef = $8SyCD.useRef();
    funcRef.current = callback;
    var cacheFn = $8SyCD.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}








var $8SyCD = parcelRequire("8SyCD");



function $5d41ab8facb8054f$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $83e88d653e4c2190$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === "combobox";
    var mergedOptions = options || (0, $ecbd8088adf8ace7$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(mode !== "tags" || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
    // `combobox` & `tags` should option be `string` type
    if (mode === "tags" || mode === "combobox") {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ("value" in opt ? opt.value : opt.key) === "number";
            });
            return typeof ("value" in item ? item.value : item.key) === "number";
        });
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
    }
    // `combobox` should not use `optionLabelProp`
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
    // Only `combobox` support `backfill`
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
    // Only `combobox` support `getInputElement`
    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $ed6f30969113606c$export$89ff31684837bbbf)(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "`onSearch` should work with `showSearch` instead of use alone.");
    (0, $ed6f30969113606c$export$89ff31684837bbbf)(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
    if (value !== undefined && value !== null) {
        var values = (0, $28b4485c1ece718a$export$45b10814cc054894)(value);
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!labelInValue || values.every(function(val) {
            return (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(val) === "object" && ("key" in val || "value" in val);
        }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children).some(function(node) {
            if (!/*#__PURE__*/ $8SyCD.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $8SyCD.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $ed6f30969113606c$export$2e2bcd8739ae039)(inputValue === undefined, "`inputValue` is deprecated, please use `searchValue` instead.");
    }
}
function $5d41ab8facb8054f$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "`value` in Select options should not be `null`.");
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $5d41ab8facb8054f$export$2e2bcd8739ae039 = $5d41ab8facb8054f$var$warningProps;


var $e5dddbf06d3c0106$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "optionRender",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "direction",
    "listHeight",
    "listItemHeight",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange"
];
var $e5dddbf06d3c0106$var$OMIT_DOM_PROPS = [
    "inputValue"
];
function $e5dddbf06d3c0106$var$isRawValue(value) {
    return !value || (0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(value) !== "object";
}
var $e5dddbf06d3c0106$var$Select = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $e5dddbf06d3c0106$var$_excluded);
    var mergedId = (0, $8e13b7e65f053b96$export$2e2bcd8739ae039)(id);
    var multiple = (0, $83e88d653e4c2190$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $8SyCD.useMemo(function() {
        if (filterOption === undefined && mode === "combobox") return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $8SyCD.useMemo(function() {
        return (0, $4a680885281ce3fa$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)("", {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || "";
        }
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $3b3f0e90b4d39768$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $8SyCD.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $28b4485c1ece718a$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($e5dddbf06d3c0106$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $8SyCD.useMemo(function() {
        var _values$;
        var values = convert2LabelValues(internalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === "combobox" && (0, $28b4485c1ece718a$export$9d186c3672bb89c6)((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $43b715a190bc09e0$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $8SyCD.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _item$label;
            return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, item), {}, {
                label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
            });
        });
    }, [
        mode,
        mergedValues
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $8SyCD.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $8SyCD.useEffect(function() {
        if (mode === "combobox") {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $28b4485c1ece718a$export$96bdbc84526f3739)(strValue) ? String(strValue) : "");
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $747c9fd72a82fb91$export$2e2bcd8739ae039)(function(val, label) {
        var _ref;
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return _ref = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref, mergedFieldNames.value, val), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_ref, mergedFieldNames.label, mergedLabel), _ref;
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $8SyCD.useMemo(function() {
        if (mode !== "tags") return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $ef8f6a2345ca1020$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $8SyCD.useMemo(function() {
        if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || "value"] === mergedSearchValue;
        })) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some(function(item) {
            return item[mergedFieldNames.value] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    var orderedFilteredOptions = $8SyCD.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b);
        });
    }, [
        filledSearchOptions,
        filterSort
    ]);
    var displayOptions = $8SyCD.useMemo(function() {
        return (0, $4a680885281ce3fa$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $4a680885281ce3fa$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $8SyCD.useState(null), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $8SyCD.useState(0), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== "combobox";
    var onActiveValue = $8SyCD.useCallback(function(active, index) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? "keyboard" : _ref2$source;
        setAccessibilityIndex(index);
        if (backfill && mode === "combobox" && active !== null && source === "keyboard") setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $4a680885281ce3fa$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== "clear") {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $747c9fd72a82fb91$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === "combobox") // setSearchValue(String(val));
        setActiveValue("");
        else if (!(0, $83e88d653e4c2190$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue("");
            setActiveValue("");
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === "remove" || type === "clear") values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === "submit") {
            var formatted = (searchText || "").trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue("");
            }
            return;
        }
        if (info.source !== "blur") {
            if (mode === "combobox") triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== "tags") patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)(rawValues), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $8SyCD.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)((0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            optionRender: optionRender
        });
    }, [
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $8SyCD.createElement((0, $c0f2aba139303ec5$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $8SyCD.createElement((0, $83e88d653e4c2190$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $e5dddbf06d3c0106$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        direction: direction,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $a6c36d03cccfaaeb$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $e5dddbf06d3c0106$var$TypedSelect = $e5dddbf06d3c0106$var$Select;
$e5dddbf06d3c0106$var$TypedSelect.Option = (0, $6712e9289b1afa7e$export$2e2bcd8739ae039);
$e5dddbf06d3c0106$var$TypedSelect.OptGroup = (0, $ec26dd712d996fae$export$2e2bcd8739ae039);
var $e5dddbf06d3c0106$export$2e2bcd8739ae039 = $e5dddbf06d3c0106$var$TypedSelect;






var $94df4c7f48ab5b7b$export$2e2bcd8739ae039 = (0, $e5dddbf06d3c0106$export$2e2bcd8739ae039);
























var $5a5f31c29f75b421$export$c81b62e088da1305 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveDownIn", {
    "0%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
var $5a5f31c29f75b421$export$6c1eca72ac4f6672 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveDownOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
var $5a5f31c29f75b421$export$8dd54688d033571 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveLeftIn", {
    "0%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
var $5a5f31c29f75b421$export$be161c4e647bea9b = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveLeftOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
var $5a5f31c29f75b421$export$a984c43131c7d145 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveRightIn", {
    "0%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
var $5a5f31c29f75b421$export$e141ac6798b476df = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveRightOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
var $5a5f31c29f75b421$export$ab676201eaaca05 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveUpIn", {
    "0%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
var $5a5f31c29f75b421$export$ec1b91b8ec2f6331 = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antMoveUpOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
var $5a5f31c29f75b421$var$moveMotion = {
    "move-up": {
        inKeyframes: $5a5f31c29f75b421$export$ab676201eaaca05,
        outKeyframes: $5a5f31c29f75b421$export$ec1b91b8ec2f6331
    },
    "move-down": {
        inKeyframes: $5a5f31c29f75b421$export$c81b62e088da1305,
        outKeyframes: $5a5f31c29f75b421$export$6c1eca72ac4f6672
    },
    "move-left": {
        inKeyframes: $5a5f31c29f75b421$export$8dd54688d033571,
        outKeyframes: $5a5f31c29f75b421$export$be161c4e647bea9b
    },
    "move-right": {
        inKeyframes: $5a5f31c29f75b421$export$a984c43131c7d145,
        outKeyframes: $5a5f31c29f75b421$export$e141ac6798b476df
    }
};
var $5a5f31c29f75b421$export$913b1b7e3288c319 = function(token, motionName) {
    var antCls = token.antCls;
    var motionCls = "".concat(antCls, "-").concat(motionName);
    var _moveMotion_motionName = $5a5f31c29f75b421$var$moveMotion[motionName], inKeyframes = _moveMotion_motionName.inKeyframes, outKeyframes = _moveMotion_motionName.outKeyframes;
    var _obj;
    return [
        (0, $9f4ece306a24a354$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n        ".concat(motionCls, "-enter,\n        ").concat(motionCls, "-appear\n      "), {
            opacity: 0,
            animationTimingFunction: token.motionEaseOutCirc
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(motionCls, "-leave"), {
            animationTimingFunction: token.motionEaseInOutCirc
        }), _obj)
    ];
};


"use client";
var $d1b02c6115b55fb1$var$genItemStyle = function(token) {
    var optionHeight = token.optionHeight, optionFontSize = token.optionFontSize, optionLineHeight = token.optionLineHeight, optionPadding = token.optionPadding;
    return {
        position: "relative",
        display: "block",
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: "normal",
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: "border-box"
    };
};
var $d1b02c6115b55fb1$var$genSingleStyle = function(token) {
    var antCls = token.antCls, componentCls = token.componentCls;
    var selectItemCls = "".concat(componentCls, "-item");
    var slideUpEnterActive = "&".concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active");
    var slideUpAppearActive = "&".concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active");
    var slideUpLeaveActive = "&".concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active");
    var dropdownPlacementCls = "".concat(componentCls, "-dropdown-placement-");
    var _obj, _obj1, _obj2;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-dropdown"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj2 = {
            position: "absolute",
            top: -9999,
            zIndex: token.zIndexPopup,
            boxSizing: "border-box",
            padding: token.paddingXXS,
            overflow: "hidden",
            fontSize: token.fontSize,
            // Fix select render lag of long text in chrome
            // https://github.com/ant-design/ant-design/issues/11456
            // https://github.com/ant-design/ant-design/issues/11843
            fontVariant: "initial",
            backgroundColor: token.colorBgElevated,
            borderRadius: token.borderRadiusLG,
            outline: "none",
            boxShadow: token.boxShadowSecondary
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "\n          ".concat(slideUpEnterActive).concat(dropdownPlacementCls, "bottomLeft,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "bottomLeft\n        "), {
            animationName: (0, $b219a2444a723b10$export$e801b802b037de6a)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "\n          ".concat(slideUpEnterActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpEnterActive).concat(dropdownPlacementCls, "topRight,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "topRight\n        "), {
            animationName: (0, $b219a2444a723b10$export$dd9f089fa5e819fe)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(slideUpLeaveActive).concat(dropdownPlacementCls, "bottomLeft"), {
            animationName: (0, $b219a2444a723b10$export$f40f41df328ebc38)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "\n          ".concat(slideUpLeaveActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpLeaveActive).concat(dropdownPlacementCls, "topRight\n        "), {
            animationName: (0, $b219a2444a723b10$export$f7243fdb9c27c3b7)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-hidden", {
            display: "none"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(selectItemCls), Object.assign(Object.assign({}, $d1b02c6115b55fb1$var$genItemStyle(token)), {
            cursor: "pointer",
            transition: "background ".concat(token.motionDurationSlow, " ease"),
            borderRadius: token.borderRadiusSM,
            // =========== Group ============
            "&-group": {
                color: token.colorTextDescription,
                fontSize: token.fontSizeSM,
                cursor: "default"
            },
            // =========== Option ===========
            "&-option": (_obj1 = {
                display: "flex",
                "&-content": Object.assign({
                    flex: "auto"
                }, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)),
                "&-state": {
                    flex: "none",
                    display: "flex",
                    alignItems: "center"
                }
            }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-active:not(".concat(selectItemCls, "-option-disabled)"), {
                backgroundColor: token.optionActiveBg
            }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-selected:not(".concat(selectItemCls, "-option-disabled)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                color: token.optionSelectedColor,
                fontWeight: token.optionSelectedFontWeight,
                backgroundColor: token.optionSelectedBg
            }, "".concat(selectItemCls, "-option-state"), {
                color: token.colorPrimary
            })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-disabled", (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(selectItemCls, "-option-selected"), {
                backgroundColor: token.colorBgContainerDisabled
            }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "color", token.colorTextDisabled), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "cursor", "not-allowed"), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-grouped", {
                paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
            }), _obj1)
        })), // =========================== RTL ===========================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-rtl", {
            direction: "rtl"
        }), _obj2))),
        // Follow code may reuse in other components
        (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-up"),
        (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-down"),
        (0, $5a5f31c29f75b421$export$913b1b7e3288c319)(token, "move-up"),
        (0, $5a5f31c29f75b421$export$913b1b7e3288c319)(token, "move-down")
    ];
};
var $d1b02c6115b55fb1$export$2e2bcd8739ae039 = $d1b02c6115b55fb1$var$genSingleStyle;






"use client";
var $f801490a3cc98e1a$var$FIXED_ITEM_MARGIN = 2;
var $f801490a3cc98e1a$var$getSelectItemStyle = function(token) {
    var multipleSelectItemHeight = token.multipleSelectItemHeight, selectHeight = token.selectHeight, lineWidth = token.lineWidth;
    var selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
    return selectItemDist;
};
function $f801490a3cc98e1a$var$genSizeStyle(token, suffix) {
    var componentCls = token.componentCls, iconCls = token.iconCls;
    var selectOverflowPrefixCls = "".concat(componentCls, "-selection-overflow");
    var selectItemHeight = token.multipleSelectItemHeight;
    var selectItemDist = $f801490a3cc98e1a$var$getSelectItemStyle(token);
    var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : "";
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-multiple").concat(suffixCls), (_obj4 = {
        fontSize: token.fontSize
    }, /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */ // =========================== Overflow ===========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, selectOverflowPrefixCls, {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
            flex: "none",
            alignSelf: "center",
            maxWidth: "100%",
            display: "inline-flex"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-selector"), (_obj = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(selectItemDist).sub($f801490a3cc98e1a$var$FIXED_ITEM_MARGIN).equal()), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc($f801490a3cc98e1a$var$FIXED_ITEM_MARGIN).mul(2).equal())),
        borderRadius: token.borderRadius
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-show-search&"), {
        cursor: "text"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-disabled&"), {
        background: token.multipleSelectorBgDisabled,
        cursor: "not-allowed"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:after", {
        display: "inline-block",
        width: 0,
        margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)($f801490a3cc98e1a$var$FIXED_ITEM_MARGIN), " 0"),
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(selectItemHeight),
        visibility: "hidden",
        content: '"\\a0"'
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n        &".concat(componentCls, "-show-arrow ").concat(componentCls, "-selector,\n        &").concat(componentCls, "-allow-clear ").concat(componentCls, "-selector\n      "), {
        paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-selection-item"), (_obj2 = {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: selectItemHeight,
        marginTop: $f801490a3cc98e1a$var$FIXED_ITEM_MARGIN,
        marginBottom: $f801490a3cc98e1a$var$FIXED_ITEM_MARGIN,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(selectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal()),
        background: token.multipleItemBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.multipleItemBorderColor),
        borderRadius: token.borderRadiusSM,
        cursor: "default",
        transition: "font-size ".concat(token.motionDurationSlow, ", line-height ").concat(token.motionDurationSlow, ", height ").concat(token.motionDurationSlow),
        marginInlineEnd: token.calc($f801490a3cc98e1a$var$FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingInlineStart: token.paddingXS,
        paddingInlineEnd: token.calc(token.paddingXS).div(2).equal()
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-disabled&"), {
        color: token.multipleItemColorDisabled,
        borderColor: token.multipleItemBorderColorDisabled,
        cursor: "not-allowed"
    }), // It's ok not to do this, but 24px makes bottom narrow in view should adjust
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-content", {
        display: "inline-block",
        marginInlineEnd: token.calc(token.paddingXS).div(2).equal(),
        overflow: "hidden",
        whiteSpace: "pre",
        // fix whitespace wrapping. custom tags display all whitespace within.
        textOverflow: "ellipsis"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-remove", Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$171ccda7bc085e59)()), (_obj1 = {
        display: "inline-flex",
        alignItems: "center",
        color: token.colorIcon,
        fontWeight: "bold",
        fontSize: 10,
        lineHeight: "inherit",
        cursor: "pointer"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(iconCls), {
        verticalAlign: "-0.2em"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:hover", {
        color: token.colorIconHover
    }), _obj1))), _obj2)), // ========================== Input ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(selectOverflowPrefixCls, "-item + ").concat(selectOverflowPrefixCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-selection-search"), {
        marginInlineStart: 0
    })), // https://github.com/ant-design/ant-design/issues/44754
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(selectOverflowPrefixCls, "-item-suffix"), {
        height: "100%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-selection-search"), (_obj3 = {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal()
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-input,\n          &-mirror\n        ", {
        height: selectItemHeight,
        fontFamily: token.fontFamily,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(selectItemHeight),
        transition: "all ".concat(token.motionDurationSlow)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-input", {
        width: "100%",
        minWidth: 4.1 // fix search cursor missing
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-mirror", {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        insetInlineEnd: "auto",
        zIndex: 999,
        whiteSpace: "pre",
        // fix whitespace wrapping caused width calculation bug
        visibility: "hidden"
    }), _obj3)), // ======================= Placeholder =======================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-selection-placeholder"), {
        position: "absolute",
        top: "50%",
        insetInlineStart: token.inputPaddingHorizontalBase,
        insetInlineEnd: token.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: "all ".concat(token.motionDurationSlow)
    }), _obj4));
}
var $f801490a3cc98e1a$var$genMultipleStyle = function(token) {
    var componentCls = token.componentCls;
    var smallToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.controlHeightXS,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS
    });
    var largeToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius
    });
    var _obj;
    return [
        $f801490a3cc98e1a$var$genSizeStyle(token),
        // ======================== Small ========================
        $f801490a3cc98e1a$var$genSizeStyle(smallToken, "sm"),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-multiple").concat(componentCls, "-sm"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selection-placeholder"), {
            insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
        }), // https://github.com/ant-design/ant-design/issues/29559
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selection-search"), {
            marginInlineStart: 2 // Magic Number
        }), _obj)),
        // ======================== Large ========================
        $f801490a3cc98e1a$var$genSizeStyle(largeToken, "lg")
    ];
};
var $f801490a3cc98e1a$export$2e2bcd8739ae039 = $f801490a3cc98e1a$var$genMultipleStyle;






"use client";
function $f4d62f110064fe72$var$genSizeStyle(token, suffix) {
    var componentCls = token.componentCls, inputPaddingHorizontalBase = token.inputPaddingHorizontalBase, borderRadius = token.borderRadius;
    var selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
    var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : "";
    var _obj, _obj1, _obj2, _obj3;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-single").concat(suffixCls), (_obj3 = {
        fontSize: token.fontSize,
        height: token.controlHeight
    }, // ========================= Selector =========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-selector"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token, true)), (_obj = {
        display: "flex",
        borderRadius: borderRadius
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selection-search"), {
        position: "absolute",
        top: 0,
        insetInlineStart: inputPaddingHorizontalBase,
        insetInlineEnd: inputPaddingHorizontalBase,
        bottom: 0,
        "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n          ".concat(componentCls, "-selection-item,\n          ").concat(componentCls, "-selection-placeholder\n        "), {
        padding: 0,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(selectHeightWithoutBorder),
        transition: "all ".concat(token.motionDurationSlow, ", visibility 0s"),
        alignSelf: "center"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selection-placeholder"), {
        transition: "none",
        pointerEvents: "none"
    }), // For common baseline align
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, [
        "&:after",
        /* For '' value baseline align */ "".concat(componentCls, "-selection-item:empty:after"),
        /* For undefined value baseline align */ "".concat(componentCls, "-selection-placeholder:empty:after")
    ].join(","), {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
    }), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n        &".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-item,\n        &").concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-placeholder\n      "), {
        paddingInlineEnd: token.showArrowPaddingInlineEnd
    }), // Opacity selection if open
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-open ").concat(componentCls, "-selection-item"), {
        color: token.colorTextPlaceholder
    }), // ========================== Input ==========================
    // We only change the style of non-customize input which is only support by `combobox` mode.
    // Not customize
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:not(".concat(componentCls, "-customize-input)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-selector"), (_obj1 = {
        width: "100%",
        height: "100%",
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(inputPaddingHorizontalBase))
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-selection-search-input"), {
        height: selectHeightWithoutBorder
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:after", {
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(selectHeightWithoutBorder)
    }), _obj1))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-customize-input"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-selector"), (_obj2 = {
        "&:after": {
            display: "none"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-selection-search"), {
        position: "static",
        width: "100%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-selection-placeholder"), {
        position: "absolute",
        insetInlineStart: 0,
        insetInlineEnd: 0,
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(inputPaddingHorizontalBase)),
        "&:after": {
            display: "none"
        }
    }), _obj2))), _obj3));
}
function $f4d62f110064fe72$export$2e2bcd8739ae039(token) {
    var componentCls = token.componentCls;
    var inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
    var _obj;
    return [
        $f4d62f110064fe72$var$genSizeStyle(token),
        // ======================== Small ========================
        // Shared
        $f4d62f110064fe72$var$genSizeStyle((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            controlHeight: token.controlHeightSM,
            borderRadius: token.borderRadiusSM
        }), "sm"),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-single").concat(componentCls, "-sm"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not(".concat(componentCls, "-customize-input)"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selection-search"), {
            insetInlineStart: inputPaddingHorizontalSM,
            insetInlineEnd: inputPaddingHorizontalSM
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-selector"), {
            padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(inputPaddingHorizontalSM))
        }), // With arrow should provides `padding-right` to show the arrow
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-search"), {
            insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n            &".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-item,\n            &").concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-placeholder\n          "), {
            paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
        }), _obj))),
        // ======================== Large ========================
        // Shared
        $f4d62f110064fe72$var$genSizeStyle((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            controlHeight: token.singleItemHeightLG,
            fontSize: token.fontSizeLG,
            borderRadius: token.borderRadiusLG
        }), "lg")
    ];
}


"use client";
// ============================= Selector =============================
var $02201109e50148c3$var$genSelectorStyle = function(token) {
    var componentCls = token.componentCls, selectorBg = token.selectorBg;
    var _obj, _obj1;
    return _obj1 = {
        position: "relative",
        backgroundColor: selectorBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
        transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
        input: {
            cursor: "pointer"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-show-search&"), {
        cursor: "text",
        input: {
            cursor: "auto",
            color: "inherit",
            height: "100%"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-disabled&"), (_obj = {
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        cursor: "not-allowed"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-multiple&"), {
        background: token.multipleSelectorBgDisabled
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "input", {
        cursor: "not-allowed"
    }), _obj)), _obj1;
};
// ============================== Status ==============================
var $02201109e50148c3$var$genStatusStyle = function genStatusStyle(rootSelectCls, token) {
    var overwriteDefaultBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var componentCls = token.componentCls, borderHoverColor = token.borderHoverColor, antCls = token.antCls, borderActiveColor = token.borderActiveColor, outlineColor = token.outlineColor, controlOutlineWidth = token.controlOutlineWidth;
    var overwriteStyle = overwriteDefaultBorder ? (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-selector"), {
        borderColor: borderActiveColor
    }) : {};
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, rootSelectCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not(".concat(componentCls, "-disabled):not(").concat(componentCls, "-customize-input):not(").concat(antCls, "-pagination-size-changer)"), Object.assign(Object.assign({}, overwriteStyle), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:hover ".concat(componentCls, "-selector"), {
        borderColor: borderHoverColor
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-focused& ").concat(componentCls, "-selector"), {
        borderColor: borderActiveColor,
        boxShadow: "0 0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(controlOutlineWidth), " ").concat(outlineColor),
        outline: 0
    }), _obj))));
};
// ============================== Styles ==============================
// /* Reset search input style */
var $02201109e50148c3$var$getSearchInputWithoutBorderStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-selection-search-input"), {
        margin: 0,
        padding: 0,
        background: "transparent",
        border: "none",
        outline: "none",
        appearance: "none",
        fontFamily: "inherit",
        "&::-webkit-search-cancel-button": {
            display: "none",
            "-webkit-appearance": "none"
        }
    });
};
// =============================== Base ===============================
var $02201109e50148c3$var$genBaseStyle = function(token) {
    var antCls = token.antCls, componentCls = token.componentCls, inputPaddingHorizontalBase = token.inputPaddingHorizontalBase, iconCls = token.iconCls;
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, componentCls, Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj1 = {
        position: "relative",
        display: "inline-block",
        cursor: "pointer"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), Object.assign(Object.assign({}, $02201109e50148c3$var$genSelectorStyle(token)), $02201109e50148c3$var$getSearchInputWithoutBorderStyle(token))), // [`&:not(&-disabled):hover ${selectCls}-selector`]: {
    //   ...genHoverStyle(token),
    // },
    // ======================== Selection ========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-selection-item"), Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
    }, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)), // https://github.com/ant-design/ant-design/issues/40421
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(antCls, "-typography"), {
        display: "inline"
    }))), // ======================= Placeholder =======================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-selection-placeholder"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)), {
        flex: 1,
        color: token.colorTextPlaceholder,
        pointerEvents: "none"
    })), // ========================== Arrow ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$171ccda7bc085e59)()), (_obj = {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        height: token.fontSizeIcon,
        marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
        color: token.colorTextQuaternary,
        fontSize: token.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, iconCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        verticalAlign: "top",
        transition: "transform ".concat(token.motionDurationSlow),
        "> svg": {
            verticalAlign: "top"
        }
    }, "&:not(".concat(componentCls, "-suffix)"), {
        pointerEvents: "auto"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-disabled &"), {
        cursor: "not-allowed"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> *:not(:last-child)", {
        marginInlineEnd: 8 // FIXME: magic
    }), _obj))), // ========================== Clear ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-clear"), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        zIndex: 1,
        display: "inline-block",
        width: token.fontSizeIcon,
        height: token.fontSizeIcon,
        marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
        color: token.colorTextQuaternary,
        fontSize: token.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        background: token.clearBg,
        cursor: "pointer",
        opacity: 0,
        transition: "color ".concat(token.motionDurationMid, " ease, opacity ").concat(token.motionDurationSlow, " ease"),
        textRendering: "auto",
        "&:before": {
            display: "block"
        },
        "&:hover": {
            color: token.colorTextTertiary
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:hover", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-clear"), {
        opacity: 1
    })), _obj1))), // ========================= Feedback ==========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-has-feedback"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-clear"), {
        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
    })), _obj2;
};
// ============================== Styles ==============================
var $02201109e50148c3$var$genSelectStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj = {}, // ==================== BorderLess ====================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-borderless ".concat(componentCls, "-selector"), {
            backgroundColor: "transparent !important",
            borderColor: "transparent !important",
            boxShadow: "none !important"
        }), // ==================== In Form ====================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-in-form-item"), {
            width: "100%"
        }), _obj)),
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $02201109e50148c3$var$genBaseStyle(token),
        // Single
        (0, $f4d62f110064fe72$export$2e2bcd8739ae039)(token),
        // Multiple
        (0, $f801490a3cc98e1a$export$2e2bcd8739ae039)(token),
        // Dropdown
        (0, $d1b02c6115b55fb1$export$2e2bcd8739ae039)(token),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-rtl"), {
            direction: "rtl"
        }),
        // =====================================================
        // ==                     Status                      ==
        // =====================================================
        $02201109e50148c3$var$genStatusStyle(componentCls, (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            borderHoverColor: token.colorPrimaryHover,
            borderActiveColor: token.colorPrimary,
            outlineColor: token.controlOutline
        })),
        $02201109e50148c3$var$genStatusStyle("".concat(componentCls, "-status-error"), (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            borderHoverColor: token.colorErrorHover,
            borderActiveColor: token.colorError,
            outlineColor: token.colorErrorOutline
        }), true),
        $02201109e50148c3$var$genStatusStyle("".concat(componentCls, "-status-warning"), (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            borderHoverColor: token.colorWarningHover,
            borderActiveColor: token.colorWarning,
            outlineColor: token.colorWarningOutline
        }), true),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $8123ced5d1d65f52$export$b1208b23589b4b73)(token, {
            borderElCls: "".concat(componentCls, "-selector"),
            focusElCls: "".concat(componentCls, "-focused")
        })
    ];
};
var $02201109e50148c3$export$9ca1be8807fe0675 = function(token) {
    var fontSize = token.fontSize, lineHeight = token.lineHeight, controlHeight = token.controlHeight, controlPaddingHorizontal = token.controlPaddingHorizontal, zIndexPopupBase = token.zIndexPopupBase, colorText = token.colorText, fontWeightStrong = token.fontWeightStrong, controlItemBgActive = token.controlItemBgActive, controlItemBgHover = token.controlItemBgHover, colorBgContainer = token.colorBgContainer, colorFillSecondary = token.colorFillSecondary, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, colorBgContainerDisabled = token.colorBgContainerDisabled, colorTextDisabled = token.colorTextDisabled;
    return {
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: "".concat((controlHeight - fontSize * lineHeight) / 2, "px ").concat(controlPaddingHorizontal, "px"),
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: "transparent",
        multipleItemHeight: controlHeightSM,
        multipleItemHeightLG: controlHeight,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: "transparent",
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25)
    };
};
var $02201109e50148c3$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Select", function(token, _ref) {
    var rootPrefixCls = _ref.rootPrefixCls;
    var selectToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $02201109e50148c3$var$genSelectStyle(selectToken)
    ];
}, $02201109e50148c3$export$9ca1be8807fe0675, {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});


"use client";
var $888513203e238108$var$getBuiltInPlacements = function(popupOverflow) {
    var htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
    var sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ]
        }),
        bottomRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ]
        }),
        topLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ]
        }),
        topRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ]
        })
    };
};
function $888513203e238108$export$2e2bcd8739ae039(buildInPlacements, popupOverflow) {
    return buildInPlacements || $888513203e238108$var$getBuiltInPlacements(popupOverflow);
}



var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $b01b75a95886f538$var$CheckOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    name: "check",
    theme: "outlined"
};
var $b01b75a95886f538$export$2e2bcd8739ae039 = $b01b75a95886f538$var$CheckOutlined;



var $d79b011e1dd73a6b$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b01b75a95886f538$export$2e2bcd8739ae039)
    }));
};
var $d79b011e1dd73a6b$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d79b011e1dd73a6b$var$CheckOutlined);






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $9dd9cd9623565328$var$DownOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    name: "down",
    theme: "outlined"
};
var $9dd9cd9623565328$export$2e2bcd8739ae039 = $9dd9cd9623565328$var$DownOutlined;



var $d4250094f6be33d4$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $9dd9cd9623565328$export$2e2bcd8739ae039)
    }));
};
var $d4250094f6be33d4$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d4250094f6be33d4$var$DownOutlined);





"use client";
function $04b1d1d458943305$export$2e2bcd8739ae039(_ref) {
    var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, hasFeedback = _ref.hasFeedback, prefixCls = _ref.prefixCls, showSuffixIcon = _ref.showSuffixIcon, feedbackIcon = _ref.feedbackIcon, showArrow = _ref.showArrow, componentName = _ref.componentName;
    // Clear Icon
    var mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $8SyCD.createElement((0, $9742a01b0cacbf6e$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    var getSuffixIconNode = function(arrowIcon) {
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $8SyCD.createElement((0, $d921af23c702a53c$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        var iconCls = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function(_ref2) {
            var open = _ref2.open, showSearch = _ref2.showSearch;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $8SyCD.createElement((0, $b8019eb417509ae4$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $8SyCD.createElement((0, $d4250094f6be33d4$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $8SyCD.createElement((0, $d79b011e1dd73a6b$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $8SyCD.createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $ea1fbc1a73d50f78$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}



"use client";
var $5a3a55b7970e77bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5a3a55b7970e77bf$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var $5a3a55b7970e77bf$var$InternalSelect = function(_a, ref) {
    var _b, _c;
    var customizePrefixCls = _a.prefixCls, _a_bordered = _a.bordered, bordered = _a_bordered === void 0 ? true : _a_bordered, className = _a.className, rootClassName = _a.rootClassName, getPopupContainer = _a.getPopupContainer, popupClassName = _a.popupClassName, dropdownClassName = _a.dropdownClassName, _a_listHeight = _a.listHeight, listHeight = _a_listHeight === void 0 ? 256 : _a_listHeight, placement = _a.placement, _a_listItemHeight = _a.listItemHeight, listItemHeight = _a_listItemHeight === void 0 ? 24 : _a_listItemHeight, customizeSize = _a.size, customDisabled = _a.disabled, notFoundContent = _a.notFoundContent, customStatus = _a.status, builtinPlacements = _a.builtinPlacements, dropdownMatchSelectWidth = _a.dropdownMatchSelectWidth, popupMatchSelectWidth = _a.popupMatchSelectWidth, propDirection = _a.direction, style = _a.style, allowClear = _a.allowClear, props = $5a3a55b7970e77bf$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "rootClassName",
        "getPopupContainer",
        "popupClassName",
        "dropdownClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "builtinPlacements",
        "dropdownMatchSelectWidth",
        "popupMatchSelectWidth",
        "direction",
        "style",
        "allowClear"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React_useContext.getPopupContainer, getPrefixCls = _React_useContext.getPrefixCls, renderEmpty = _React_useContext.renderEmpty, contextDirection = _React_useContext.direction, virtual = _React_useContext.virtual, contextPopupMatchSelectWidth = _React_useContext.popupMatchSelectWidth, popupOverflow = _React_useContext.popupOverflow, select = _React_useContext.select;
    var prefixCls = getPrefixCls("select", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
    var _useCompactItemContext = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContext.compactSize, compactItemClassnames = _useCompactItemContext.compactItemClassnames;
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $02201109e50148c3$export$2e2bcd8739ae039)(prefixCls, rootCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var mode = $8SyCD.useMemo(function() {
        var m = props.mode;
        if (m === "combobox") return undefined;
        if (m === $5a3a55b7970e77bf$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return "combobox";
        return m;
    }, [
        props.mode
    ]);
    var isMultiple = mode === "multiple" || mode === "tags";
    var showSuffixIcon = (0, $ea1fbc1a73d50f78$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    var mergedPopupMatchSelectWidth = (_b = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _b !== void 0 ? _b : contextPopupMatchSelectWidth;
    // ===================== Form Status =====================
    var _React_useContext1 = $8SyCD.useContext((0, $1618288003dd675a$export$bbb5553c6c7a14ed)), contextStatus = _React_useContext1.status, hasFeedback = _React_useContext1.hasFeedback, isFormItemInput = _React_useContext1.isFormItemInput, feedbackIcon = _React_useContext1.feedbackIcon;
    var mergedStatus = (0, $69f886f8119a0cf0$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === "combobox") mergedNotFound = null;
    else mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /*#__PURE__*/ $8SyCD.createElement((0, $554405272ae7ed67$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    var _useIcons = (0, $04b1d1d458943305$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        showArrow: props.showArrow,
        componentName: "Select"
    })), suffixIcon = _useIcons.suffixIcon, itemIcon = _useIcons.itemIcon, removeIcon = _useIcons.removeIcon, clearIcon = _useIcons.clearIcon;
    var mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    var selectProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "suffixIcon",
        "itemIcon"
    ]);
    var mergedPopupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(popupClassName || dropdownClassName, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === "rtl"), rootClassName, rootCls, hashId);
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctx) {
        var _$_a;
        return (_$_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _$_a !== void 0 ? _$_a : ctx;
    });
    // ===================== Disabled =====================
    var disabled = $8SyCD.useContext((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _obj;
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-borderless"), !bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-in-form-item"), isFormItemInput), _obj), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, select === null || select === void 0 ? void 0 : select.className, className, rootClassName, rootCls, hashId);
    // ===================== Placement =====================
    var memoPlacement = $8SyCD.useMemo(function() {
        if (placement !== undefined) return placement;
        return direction === "rtl" ? "bottomRight" : "bottomLeft";
    }, [
        placement,
        direction
    ]);
    var mergedBuiltinPlacements = (0, $888513203e238108$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow);
    // ====================== zIndex =========================
    var _useZIndex = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4d9cc5bfe7391b56$export$3e7906d4075187a4)("SelectLike", (_c = props.dropdownStyle) === null || _c === void 0 ? void 0 : _c.zIndex), 1), zIndex = _useZIndex[0];
    // ====================== Render =======================
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $94df4c7f48ab5b7b$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        virtual: virtual,
        showSearch: select === null || select === void 0 ? void 0 : select.showSearch
    }, selectProps, {
        style: Object.assign(Object.assign({}, select === null || select === void 0 ? void 0 : select.style), style),
        dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
        builtinPlacements: mergedBuiltinPlacements,
        transitionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls, "slide-up", props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        dropdownStyle: Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.dropdownStyle), {
            zIndex: zIndex
        })
    })));
};
var $5a3a55b7970e77bf$var$Select = /*#__PURE__*/ $8SyCD.forwardRef($5a3a55b7970e77bf$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ var $5a3a55b7970e77bf$var$PurePanel = (0, $d09d87be952d49db$export$2e2bcd8739ae039)($5a3a55b7970e77bf$var$Select);
$5a3a55b7970e77bf$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $5a3a55b7970e77bf$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$5a3a55b7970e77bf$var$Select.Option = (0, $6712e9289b1afa7e$export$2e2bcd8739ae039);
$5a3a55b7970e77bf$var$Select.OptGroup = (0, $ec26dd712d996fae$export$2e2bcd8739ae039);
$5a3a55b7970e77bf$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $5a3a55b7970e77bf$var$PurePanel;
var $5a3a55b7970e77bf$export$2e2bcd8739ae039 = $5a3a55b7970e77bf$var$Select;


"use client";
var $7bf9b7377505c9dc$export$40e3292f13ea8c60 = function(props) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $5a3a55b7970e77bf$export$2e2bcd8739ae039), Object.assign({}, props, {
        showSearch: true,
        size: "small"
    }));
};
var $7bf9b7377505c9dc$export$c1344b3dabe19d01 = function(props) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $5a3a55b7970e77bf$export$2e2bcd8739ae039), Object.assign({}, props, {
        showSearch: true,
        size: "middle"
    }));
};
$7bf9b7377505c9dc$export$40e3292f13ea8c60.Option = (0, $5a3a55b7970e77bf$export$2e2bcd8739ae039).Option;
$7bf9b7377505c9dc$export$c1344b3dabe19d01.Option = (0, $5a3a55b7970e77bf$export$2e2bcd8739ae039).Option;







var $54ea6fae91f32ab4$var$genPaginationDisabledStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-disabled"), {
        "&, &:hover": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            cursor: "not-allowed"
        }, "".concat(componentCls, "-item-link"), {
            color: token.colorTextDisabled,
            cursor: "not-allowed"
        }),
        "&:focus-visible": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            cursor: "not-allowed"
        }, "".concat(componentCls, "-item-link"), {
            color: token.colorTextDisabled,
            cursor: "not-allowed"
        })
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-disabled"), (_obj1 = {
        cursor: "not-allowed"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item"), {
        cursor: "not-allowed",
        "&:hover, &:active": {
            backgroundColor: "transparent"
        },
        a: {
            color: token.colorTextDisabled,
            backgroundColor: "transparent",
            border: "none",
            cursor: "not-allowed"
        },
        "&-active": {
            borderColor: token.colorBorder,
            backgroundColor: token.itemActiveBgDisabled,
            "&:hover, &:active": {
                backgroundColor: token.itemActiveBgDisabled
            },
            a: {
                color: token.itemActiveColorDisabled
            }
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-link"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        color: token.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
            backgroundColor: "transparent"
        }
    }, "".concat(componentCls, "-simple&"), {
        backgroundColor: "transparent",
        "&:hover, &:active": {
            backgroundColor: "transparent"
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-simple-pager"), {
        color: token.colorTextDisabled
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-link-icon"), {
        opacity: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-ellipsis"), {
        opacity: 1
    }), _obj)), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-simple"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-disabled ").concat(componentCls, "-item-link"), {
        "&:hover, &:active": {
            backgroundColor: "transparent"
        }
    }))), _obj2;
};
var $54ea6fae91f32ab4$var$genPaginationMiniStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1, _obj2;
    return _obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini ").concat(componentCls, "-total-text, &").concat(componentCls, "-mini ").concat(componentCls, "-simple-pager"), {
        height: token.itemSizeSM,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini ").concat(componentCls, "-item"), {
        minWidth: token.itemSizeSM,
        height: token.itemSizeSM,
        margin: 0,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.itemSizeSM).sub(2).equal())
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini:not(").concat(componentCls, "-disabled) ").concat(componentCls, "-item:not(").concat(componentCls, "-item-active)"), {
        backgroundColor: "transparent",
        borderColor: "transparent",
        "&:hover": {
            backgroundColor: token.colorBgTextHover
        },
        "&:active": {
            backgroundColor: token.colorBgTextActive
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini ").concat(componentCls, "-prev, &").concat(componentCls, "-mini ").concat(componentCls, "-next"), {
        minWidth: token.itemSizeSM,
        height: token.itemSizeSM,
        margin: 0,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini:not(").concat(componentCls, "-disabled)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:hover ".concat(componentCls, "-item-link"), {
        backgroundColor: token.colorBgTextHover
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:active ".concat(componentCls, "-item-link"), {
        backgroundColor: token.colorBgTextActive
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-disabled:hover ").concat(componentCls, "-item-link"), {
        backgroundColor: "transparent"
    }), _obj))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "\n    &".concat(componentCls, "-mini ").concat(componentCls, "-prev ").concat(componentCls, "-item-link,\n    &").concat(componentCls, "-mini ").concat(componentCls, "-next ").concat(componentCls, "-item-link\n    "), {
        backgroundColor: "transparent",
        borderColor: "transparent",
        "&::after": {
            height: token.itemSizeSM,
            lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM)
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini ").concat(componentCls, "-jump-prev, &").concat(componentCls, "-mini ").concat(componentCls, "-jump-next"), {
        height: token.itemSizeSM,
        marginInlineEnd: 0,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-mini ").concat(componentCls, "-options"), (_obj1 = {
        marginInlineStart: token.paginationMiniOptionsMarginInlineStart
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-size-changer", {
        top: token.miniOptionsSizeChangerTop
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-quick-jumper", {
        height: token.itemSizeSM,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM),
        input: Object.assign(Object.assign({}, (0, $36bcd88a5dc6cb3d$export$bb047f62c5a56f90)(token)), {
            width: token.paginationMiniQuickJumperInputWidth,
            height: token.controlHeightSM
        })
    }), _obj1)), _obj2;
};
var $54ea6fae91f32ab4$var$genPaginationSimpleStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n    &".concat(componentCls, "-simple ").concat(componentCls, "-prev,\n    &").concat(componentCls, "-simple ").concat(componentCls, "-next\n    "), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        height: token.itemSizeSM,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM),
        verticalAlign: "top"
    }, "".concat(componentCls, "-item-link"), {
        height: token.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
            backgroundColor: token.colorBgTextHover
        },
        "&:active": {
            backgroundColor: token.colorBgTextActive
        },
        "&::after": {
            height: token.itemSizeSM,
            lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSizeSM)
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-simple ").concat(componentCls, "-simple-pager"), {
        display: "inline-block",
        height: token.itemSizeSM,
        marginInlineEnd: token.marginXS,
        input: {
            boxSizing: "border-box",
            height: "100%",
            marginInlineEnd: token.marginXS,
            padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paginationItemPaddingInline)),
            textAlign: "center",
            backgroundColor: token.itemInputBg,
            border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
            borderRadius: token.borderRadius,
            outline: "none",
            transition: "border-color ".concat(token.motionDurationMid),
            color: "inherit",
            "&:hover": {
                borderColor: token.colorPrimary
            },
            "&:focus": {
                borderColor: token.colorPrimaryHover,
                boxShadow: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.inputOutlineOffset), " 0 ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.controlOutlineWidth), " ").concat(token.controlOutline)
            },
            "&[disabled]": {
                color: token.colorTextDisabled,
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                cursor: "not-allowed"
            }
        }
    }), _obj;
};
var $54ea6fae91f32ab4$var$genPaginationJumpStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return _obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), (_obj2 = {
        outline: 0
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-item-container"), (_obj = {
        position: "relative"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-link-icon"), {
        color: token.colorPrimary,
        fontSize: token.fontSizeSM,
        opacity: 0,
        transition: "all ".concat(token.motionDurationMid),
        "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-ellipsis"), {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        display: "block",
        margin: "auto",
        color: token.colorTextDisabled,
        fontFamily: "Arial, Helvetica, sans-serif",
        letterSpacing: token.paginationEllipsisLetterSpacing,
        textAlign: "center",
        textIndent: token.paginationEllipsisTextIndent,
        opacity: 1,
        transition: "all ".concat(token.motionDurationMid)
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&:hover", (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-link-icon"), {
        opacity: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-ellipsis"), {
        opacity: 0
    }), _obj1)), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n    ".concat(componentCls, "-prev,\n    ").concat(componentCls, "-jump-prev,\n    ").concat(componentCls, "-jump-next\n    "), {
        marginInlineEnd: token.marginXS
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n    ".concat(componentCls, "-prev,\n    ").concat(componentCls, "-next,\n    ").concat(componentCls, "-jump-prev,\n    ").concat(componentCls, "-jump-next\n    "), {
        display: "inline-block",
        minWidth: token.itemSize,
        height: token.itemSize,
        color: token.colorText,
        fontFamily: token.fontFamily,
        lineHeight: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.itemSize)),
        textAlign: "center",
        verticalAlign: "middle",
        listStyle: "none",
        borderRadius: token.borderRadius,
        cursor: "pointer",
        transition: "all ".concat(token.motionDurationMid)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_obj3 = {
        fontFamily: "Arial, Helvetica, sans-serif",
        outline: 0,
        button: {
            color: token.colorText,
            cursor: "pointer",
            userSelect: "none"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-item-link"), {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: token.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " transparent"),
        borderRadius: token.borderRadius,
        outline: "none",
        transition: "all ".concat(token.motionDurationMid)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:hover ".concat(componentCls, "-item-link"), {
        backgroundColor: token.colorBgTextHover
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:active ".concat(componentCls, "-item-link"), {
        backgroundColor: token.colorBgTextActive
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-disabled:hover"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-link"), {
        backgroundColor: "transparent"
    })), _obj3)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-slash"), {
        marginInlineEnd: token.paginationSlashMarginInlineEnd,
        marginInlineStart: token.paginationSlashMarginInlineStart
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-options"), {
        display: "inline-block",
        marginInlineStart: token.margin,
        verticalAlign: "middle",
        "&-size-changer.-select": {
            display: "inline-block",
            width: "auto"
        },
        "&-quick-jumper": {
            display: "inline-block",
            height: token.controlHeight,
            marginInlineStart: token.marginXS,
            lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.controlHeight),
            verticalAlign: "top",
            input: Object.assign(Object.assign({}, (0, $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd)(token)), {
                width: token.calc(token.controlHeightLG).mul(1.25).equal(),
                height: token.controlHeight,
                boxSizing: "border-box",
                margin: 0,
                marginInlineStart: token.marginXS,
                marginInlineEnd: token.marginXS
            })
        }
    }), _obj4;
};
var $54ea6fae91f32ab4$var$genPaginationItemStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), (_obj = {
        display: "inline-block",
        minWidth: token.itemSize,
        height: token.itemSize,
        marginInlineEnd: token.marginXS,
        fontFamily: token.fontFamily,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
        textAlign: "center",
        verticalAlign: "middle",
        listStyle: "none",
        backgroundColor: "transparent",
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " transparent"),
        borderRadius: token.borderRadius,
        outline: 0,
        cursor: "pointer",
        userSelect: "none",
        a: {
            display: "block",
            padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paginationItemPaddingInline)),
            color: token.colorText,
            "&:hover": {
                textDecoration: "none"
            }
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-item-active)"), {
        "&:hover": {
            transition: "all ".concat(token.motionDurationMid),
            backgroundColor: token.colorBgTextHover
        },
        "&:active": {
            backgroundColor: token.colorBgTextActive
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-active", {
        fontWeight: token.fontWeightStrong,
        backgroundColor: token.itemActiveBg,
        borderColor: token.colorPrimary,
        a: {
            color: token.colorPrimary
        },
        "&:hover": {
            borderColor: token.colorPrimaryHover
        },
        "&:hover a": {
            color: token.colorPrimaryHover
        }
    }), _obj));
};
var $54ea6fae91f32ab4$var$genPaginationStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "ul, ol": {
            margin: 0,
            padding: 0,
            listStyle: "none"
        },
        "&::after": {
            display: "block",
            clear: "both",
            height: 0,
            overflow: "hidden",
            visibility: "hidden",
            content: '""'
        }
    }, "".concat(componentCls, "-total-text"), {
        display: "inline-block",
        height: token.itemSize,
        marginInlineEnd: token.marginXS,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
        verticalAlign: "middle"
    })), $54ea6fae91f32ab4$var$genPaginationItemStyle(token)), $54ea6fae91f32ab4$var$genPaginationJumpStyle(token)), $54ea6fae91f32ab4$var$genPaginationSimpleStyle(token)), $54ea6fae91f32ab4$var$genPaginationMiniStyle(token)), $54ea6fae91f32ab4$var$genPaginationDisabledStyle(token)), (_obj = {}, // media query style
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "@media only screen and (max-width: ".concat(token.screenLG, "px)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), {
        "&-after-jump-prev, &-before-jump-next": {
            display: "none"
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "@media only screen and (max-width: ".concat(token.screenSM, "px)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-options"), {
        display: "none"
    })), _obj))), // rtl style
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(token.componentCls, "-rtl"), {
        direction: "rtl"
    }), _obj1;
};
var $54ea6fae91f32ab4$var$genPaginationFocusStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ":not(").concat(componentCls, "-disabled)"), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item"), Object.assign({}, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), {
        "&:focus-visible": Object.assign((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-link-icon"), {
            opacity: 1
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-ellipsis"), {
            opacity: 0
        }), _obj), (0, $7cbb7e49dbe61000$export$6539948f0a737e39)(token))
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:focus-visible ".concat(componentCls, "-item-link"), Object.assign({}, (0, $7cbb7e49dbe61000$export$6539948f0a737e39)(token)))), _obj1));
};
var $54ea6fae91f32ab4$export$9ca1be8807fe0675 = function(token) {
    return Object.assign({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemActiveBg: token.colorBgContainer,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0
    }, (0, $36bcd88a5dc6cb3d$export$bd8b682992bc9781)(token));
};
var $54ea6fae91f32ab4$export$362fb92a8f81bbf9 = function(token) {
    return (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginXXS,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: "0.13em" // magic for ui experience
    }, (0, $36bcd88a5dc6cb3d$export$a157d95850191a12)(token));
};
var // ============================== Export ==============================
$54ea6fae91f32ab4$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Pagination", function(token) {
    var paginationToken = $54ea6fae91f32ab4$export$362fb92a8f81bbf9(token);
    return [
        $54ea6fae91f32ab4$var$genPaginationStyle(paginationToken),
        $54ea6fae91f32ab4$var$genPaginationFocusStyle(paginationToken)
    ];
}, $54ea6fae91f32ab4$export$9ca1be8807fe0675);







var $00b0fccce0f8cd7e$var$genBorderedStyle = function(token) {
    var componentCls = token.componentCls;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return _obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls).concat(componentCls, "-bordered").concat(componentCls, "-disabled:not(").concat(componentCls, "-mini)"), (_obj1 = {
        "&, &:hover": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-link"), {
            borderColor: token.colorBorder
        }),
        "&:focus-visible": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-link"), {
            borderColor: token.colorBorder
        })
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item, ").concat(componentCls, "-item-link"), (_obj = {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:hover:not(".concat(componentCls, "-item-active)"), {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        a: {
            color: token.colorTextDisabled
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-item-active"), {
        backgroundColor: token.itemActiveBgDisabled
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        "&:hover button": {
            backgroundColor: token.colorBgContainerDisabled,
            borderColor: token.colorBorder,
            color: token.colorTextDisabled
        }
    }, "".concat(componentCls, "-item-link"), {
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder
    })), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls).concat(componentCls, "-bordered:not(").concat(componentCls, "-mini)"), (_obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_obj2 = {
        "&:hover button": {
            borderColor: token.colorPrimaryHover,
            backgroundColor: token.itemBg
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-item-link"), {
        backgroundColor: token.itemLinkBg,
        borderColor: token.colorBorder
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&:hover ".concat(componentCls, "-item-link"), {
        borderColor: token.colorPrimary,
        backgroundColor: token.itemBg,
        color: token.colorPrimary
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-disabled"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-link"), {
        borderColor: token.colorBorder,
        color: token.colorTextDisabled
    })), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item"), (_obj3 = {
        backgroundColor: token.itemBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder)
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:hover:not(".concat(componentCls, "-item-active)"), {
        borderColor: token.colorPrimary,
        backgroundColor: token.itemBg,
        a: {
            color: token.colorPrimary
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-active", {
        borderColor: token.colorPrimary
    }), _obj3)), _obj4)), _obj5;
};
var $00b0fccce0f8cd7e$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$1537386bc155ea56)([
    "Pagination",
    "bordered"
], function(token) {
    var paginationToken = (0, $54ea6fae91f32ab4$export$362fb92a8f81bbf9)(token);
    return [
        $00b0fccce0f8cd7e$var$genBorderedStyle(paginationToken)
    ];
}, (0, $54ea6fae91f32ab4$export$9ca1be8807fe0675));


"use client";
var $8f2902dad3cf99d4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f2902dad3cf99d4$var$Pagination = function(props) {
    var customizePrefixCls = props.prefixCls, customizeSelectPrefixCls = props.selectPrefixCls, className = props.className, rootClassName = props.rootClassName, style = props.style, customizeSize = props.size, customLocale = props.locale, selectComponentClass = props.selectComponentClass, responsive = props.responsive, showSizeChanger = props.showSizeChanger, restProps = $8f2902dad3cf99d4$var$__rest(props, [
        "prefixCls",
        "selectPrefixCls",
        "className",
        "rootClassName",
        "style",
        "size",
        "locale",
        "selectComponentClass",
        "responsive",
        "showSizeChanger"
    ]);
    var xs = (0, $ad217e1563e0ca7a$export$2e2bcd8739ae039)(responsive).xs;
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, _React_useContext_pagination = _React_useContext.pagination, pagination = _React_useContext_pagination === void 0 ? {} : _React_useContext_pagination;
    var prefixCls = getPrefixCls("pagination", customizePrefixCls);
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $54ea6fae91f32ab4$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
    var iconsProps = $8SyCD.useMemo(function() {
        var ellipsis = /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-item-ellipsis")
        }, "\u2022\u2022\u2022");
        var prevIcon = /*#__PURE__*/ $8SyCD.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $8SyCD.createElement((0, $d282c3c50daf5fec$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $8SyCD.createElement((0, $23a81172a0b746de$export$2e2bcd8739ae039), null));
        var nextIcon = /*#__PURE__*/ $8SyCD.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $8SyCD.createElement((0, $23a81172a0b746de$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $8SyCD.createElement((0, $d282c3c50daf5fec$export$2e2bcd8739ae039), null));
        var jumpPrevIcon = /*#__PURE__*/ $8SyCD.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $8SyCD.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, direction === "rtl" ? /*#__PURE__*/ $8SyCD.createElement((0, $5d9e2469c70b0b53$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }) : /*#__PURE__*/ $8SyCD.createElement((0, $e1dda8eabd26dbf3$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        var jumpNextIcon = /*#__PURE__*/ $8SyCD.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $8SyCD.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, direction === "rtl" ? /*#__PURE__*/ $8SyCD.createElement((0, $e1dda8eabd26dbf3$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }) : /*#__PURE__*/ $8SyCD.createElement((0, $5d9e2469c70b0b53$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Pagination", (0, $cc78bc78ccbd9379$export$2e2bcd8739ae039)), 1), contextLocale = _useLocale[0];
    var locale = Object.assign(Object.assign({}, contextLocale), customLocale);
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customizeSize);
    var isSmall = mergedSize === "small" || !!(xs && !mergedSize && responsive);
    var selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
    var _obj;
    var extendedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-mini"), isSmall), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-bordered"), token.wireframe), _obj), pagination === null || pagination === void 0 ? void 0 : pagination.className, className, rootClassName, hashId);
    var mergedStyle = Object.assign(Object.assign({}, pagination === null || pagination === void 0 ? void 0 : pagination.style), style);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, token.wireframe && /*#__PURE__*/ $8SyCD.createElement((0, $00b0fccce0f8cd7e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $8SyCD.createElement((0, $98a606cc02262afa$export$2e2bcd8739ae039), Object.assign({}, iconsProps, restProps, {
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        selectComponentClass: selectComponentClass || (isSmall ? (0, $7bf9b7377505c9dc$export$40e3292f13ea8c60) : (0, $7bf9b7377505c9dc$export$c1344b3dabe19d01)),
        locale: locale,
        showSizeChanger: mergedShowSizeChanger
    }))));
};
var $8f2902dad3cf99d4$export$2e2bcd8739ae039 = $8f2902dad3cf99d4$var$Pagination;


"use client";
var $b2cc55c05c9b067b$export$2e2bcd8739ae039 = (0, $8f2902dad3cf99d4$export$2e2bcd8739ae039);





var $8SyCD = parcelRequire("8SyCD");


/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $4941ea18f4b61344$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $4941ea18f4b61344$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $4941ea18f4b61344$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}









var $02967d4cdd9960d4$var$antSpinMove = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antSpinMove", {
    to: {
        opacity: 1
    }
});
var $02967d4cdd9960d4$var$antRotate = new (0, $e58e9423190bd08e$export$2e2bcd8739ae039)("antRotate", {
    to: {
        transform: "rotate(405deg)"
    }
});
var $02967d4cdd9960d4$var$genSpinStyle = function(token) {
    var componentCls = token.componentCls, calc = token.calc;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj5 = {
        position: "absolute",
        display: "none",
        color: token.colorPrimary,
        fontSize: 0,
        textAlign: "center",
        verticalAlign: "middle",
        opacity: 0,
        transition: "transform ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOutCirc),
        "&-spinning": {
            position: "static",
            display: "inline-block",
            opacity: 1
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-text"), {
        fontSize: token.fontSize,
        paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-fullscreen", (_obj = {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: token.colorBgMask,
        zIndex: token.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        pointerEvents: "none",
        opacity: 0,
        visibility: "hidden",
        transition: "all ".concat(token.motionDurationMid),
        "&-show": {
            opacity: 1,
            visibility: "visible"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-dot ").concat(componentCls, "-dot-item"), {
        backgroundColor: token.colorWhite
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-text"), {
        color: token.colorTextLightSolid
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-nested-loading", (_obj4 = {
        position: "relative"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "> div > ".concat(componentCls), (_obj3 = {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        zIndex: 4,
        display: "block",
        width: "100%",
        height: "100%",
        maxHeight: token.contentHeight
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-dot"), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "50%",
        margin: calc(token.dotSize).mul(-1).div(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-text"), {
        position: "absolute",
        top: "50%",
        width: "100%",
        textShadow: "0 1px 2px ".concat(token.colorBgContainer) // FIXME: shadow
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-show-text ").concat(componentCls, "-dot"), {
        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-sm", (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-dot"), {
        margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-text"), {
        paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-show-text ").concat(componentCls, "-dot"), {
        marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-lg", (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-dot"), {
        margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-text"), {
        paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-show-text ").concat(componentCls, "-dot"), {
        marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
    }), _obj2)), _obj3)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-container"), {
        position: "relative",
        transition: "opacity ".concat(token.motionDurationSlow),
        "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: token.colorBgContainer,
            opacity: 0,
            transition: "all ".concat(token.motionDurationSlow),
            content: '""',
            pointerEvents: "none"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-blur"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        clear: "both",
        opacity: 0.5,
        userSelect: "none",
        pointerEvents: "none"
    }, "&::after", {
        opacity: 0.4,
        pointerEvents: "auto"
    })), _obj4)), // tip
    // ------------------------------
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-tip", {
        color: token.spinDotDefault
    }), // dots
    // ------------------------------
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-dot"), {
        position: "relative",
        display: "inline-block",
        fontSize: token.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
            position: "absolute",
            display: "block",
            width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
            height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
            backgroundColor: token.colorPrimary,
            borderRadius: "100%",
            transform: "scale(0.75)",
            transformOrigin: "50% 50%",
            opacity: 0.3,
            animationName: $02967d4cdd9960d4$var$antSpinMove,
            animationDuration: "1s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate",
            "&:nth-child(1)": {
                top: 0,
                insetInlineStart: 0,
                animationDelay: "0s"
            },
            "&:nth-child(2)": {
                top: 0,
                insetInlineEnd: 0,
                animationDelay: "0.4s"
            },
            "&:nth-child(3)": {
                insetInlineEnd: 0,
                bottom: 0,
                animationDelay: "0.8s"
            },
            "&:nth-child(4)": {
                bottom: 0,
                insetInlineStart: 0,
                animationDelay: "1.2s"
            }
        },
        "&-spin": {
            transform: "rotate(45deg)",
            animationName: $02967d4cdd9960d4$var$antRotate,
            animationDuration: "1.2s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear"
        }
    }), // small
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-sm ".concat(componentCls, "-dot"), {
        fontSize: token.dotSizeSM,
        i: {
            width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
            height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
        }
    }), // large
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-lg ".concat(componentCls, "-dot"), {
        fontSize: token.dotSizeLG,
        i: {
            width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
            height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-show-text ").concat(componentCls, "-text"), {
        display: "block"
    }), _obj5)));
};
var $02967d4cdd9960d4$export$9ca1be8807fe0675 = function(token) {
    var controlHeightLG = token.controlHeightLG, controlHeight = token.controlHeight;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$02967d4cdd9960d4$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Spin", function(token) {
    var spinToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $02967d4cdd9960d4$var$genSpinStyle(spinToken)
    ];
}, $02967d4cdd9960d4$export$9ca1be8807fe0675);


"use client";
var $4b177413dcaa6282$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4b177413dcaa6282$var$SpinSizes = [
    "small",
    "default",
    "large"
];
// Render indicator
var $4b177413dcaa6282$var$defaultIndicator = null;
function $4b177413dcaa6282$var$renderIndicator(prefixCls, props) {
    var indicator = props.indicator;
    var dotClassName = "".concat(prefixCls, "-dot");
    // should not be render default indicator when indicator value is null
    if (indicator === null) return null;
    if ((0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(indicator)) return (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(indicator.props.className, dotClassName)
    });
    if ((0, $70bdd1d9fe5ae128$export$a8257692ac88316c)($4b177413dcaa6282$var$defaultIndicator)) return (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)($4b177413dcaa6282$var$defaultIndicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))($4b177413dcaa6282$var$defaultIndicator.props.className, dotClassName)
    });
    return /*#__PURE__*/ $8SyCD.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(dotClassName, "".concat(prefixCls, "-dot-spin"))
    }, /*#__PURE__*/ $8SyCD.createElement("i", {
        className: "".concat(prefixCls, "-dot-item"),
        key: 1
    }), /*#__PURE__*/ $8SyCD.createElement("i", {
        className: "".concat(prefixCls, "-dot-item"),
        key: 2
    }), /*#__PURE__*/ $8SyCD.createElement("i", {
        className: "".concat(prefixCls, "-dot-item"),
        key: 3
    }), /*#__PURE__*/ $8SyCD.createElement("i", {
        className: "".concat(prefixCls, "-dot-item"),
        key: 4
    }));
}
function $4b177413dcaa6282$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
var $4b177413dcaa6282$var$Spin = function(props) {
    var prefixCls = props.spinPrefixCls, tmp = props.spinning, customSpinning = tmp === void 0 ? true : tmp, _props_delay = props.delay, delay = _props_delay === void 0 ? 0 : _props_delay, className = props.className, rootClassName = props.rootClassName, _props_size = props.size, size = _props_size === void 0 ? "default" : _props_size, tip = props.tip, wrapperClassName = props.wrapperClassName, style = props.style, children = props.children, hashId = props.hashId, fullscreen = props.fullscreen, restProps = $4b177413dcaa6282$var$__rest(props, [
        "spinPrefixCls",
        "spinning",
        "delay",
        "className",
        "rootClassName",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children",
        "hashId",
        "fullscreen"
    ]);
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(function() {
        return customSpinning && !$4b177413dcaa6282$var$shouldDelay(customSpinning, delay);
    }), 2), spinning = _React_useState[0], setSpinning = _React_useState[1];
    $8SyCD.useEffect(function() {
        if (customSpinning) {
            var showSpinning = (0, $4941ea18f4b61344$export$61fc7d43ac8f84b0)(delay, function() {
                setSpinning(true);
            });
            showSpinning();
            return function() {
                var _a;
                (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 || _a.call(showSpinning);
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    var isNestedPattern = $8SyCD.useMemo(function() {
        return typeof children !== "undefined" && !fullscreen;
    }, [
        children,
        fullscreen
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), direction = _React_useContext.direction, spin = _React_useContext.spin;
    var _obj;
    var spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, spin === null || spin === void 0 ? void 0 : spin.className, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), size === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), size === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-spinning"), spinning), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-show-text"), !!tip), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-fullscreen"), fullscreen), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-fullscreen-show"), fullscreen && spinning), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), className, rootClassName, hashId);
    var containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-container"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-blur"), spinning));
    // fix https://fb.me/react-unknown-prop
    var divProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(restProps, [
        "indicator",
        "prefixCls"
    ]);
    var mergedStyle = Object.assign(Object.assign({}, spin === null || spin === void 0 ? void 0 : spin.style), style);
    var spinElement = /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, divProps, {
        style: mergedStyle,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }), $4b177413dcaa6282$var$renderIndicator(prefixCls, props), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-text")
    }, tip) : null);
    if (isNestedPattern) return /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, divProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-nested-loading"), wrapperClassName, hashId)
    }), spinning && /*#__PURE__*/ $8SyCD.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $8SyCD.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children));
    return spinElement;
};
var $4b177413dcaa6282$var$SpinFC = function(props) {
    var customizePrefixCls = props.prefixCls;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var spinPrefixCls = getPrefixCls("spin", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $02967d4cdd9960d4$export$2e2bcd8739ae039)(spinPrefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var spinClassProps = Object.assign(Object.assign({}, props), {
        spinPrefixCls: spinPrefixCls,
        hashId: hashId
    });
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement($4b177413dcaa6282$var$Spin, Object.assign({}, spinClassProps)));
};
$4b177413dcaa6282$var$SpinFC.setDefaultIndicator = function(indicator) {
    $4b177413dcaa6282$var$defaultIndicator = indicator;
};
var $4b177413dcaa6282$export$2e2bcd8739ae039 = $4b177413dcaa6282$var$SpinFC;





var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");




"use client";
var $3de12888db3e80bd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $3de12888db3e80bd$var$parseFlex(flex) {
    if (typeof flex === "number") return "".concat(flex, " ").concat(flex, " auto");
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return "0 0 ".concat(flex);
    return flex;
}
var $3de12888db3e80bd$var$sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var $3de12888db3e80bd$var$Col = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var _React_useContext1 = $8SyCD.useContext((0, $7a75170e1d2795b3$export$2e2bcd8739ae039)), gutter = _React_useContext1.gutter, wrap = _React_useContext1.wrap;
    var customizePrefixCls = props.prefixCls, span = props.span, order = props.order, offset = props.offset, push = props.push, pull = props.pull, className = props.className, children = props.children, flex = props.flex, style = props.style, others = $3de12888db3e80bd$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    var prefixCls = getPrefixCls("col", customizePrefixCls);
    var _useColStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $86d3cd512305a3b3$export$4d3e83959861592f)(prefixCls), 2), wrapCSSVar = _useColStyle[0], hashId = _useColStyle[1];
    var sizeClassObj = {};
    $3de12888db3e80bd$var$sizes.forEach(function(size) {
        var sizeProps = {};
        var propSize = props[size];
        if (typeof propSize === "number") sizeProps.span = propSize;
        else if (typeof propSize === "object") sizeProps = propSize || {};
        delete others[size];
        var _obj;
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(size, "-flex-").concat(sizeProps.flex), sizeProps.flex || sizeProps.flex === "auto"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj));
    });
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(span), span !== undefined), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-order-").concat(order), order), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-offset-").concat(offset), offset), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-push-").concat(push), push), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-pull-").concat(pull), pull), _obj), className, sizeClassObj, hashId);
    var mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        var horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $3de12888db3e80bd$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", Object.assign({}, others, {
        style: Object.assign(Object.assign({}, mergedStyle), style),
        className: classes,
        ref: ref
    }), children));
});
var $3de12888db3e80bd$export$2e2bcd8739ae039 = $3de12888db3e80bd$var$Col;



var $8SyCD = parcelRequire("8SyCD");
var $d04389629626fa2c$export$52411773e0d6f15d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext({});
var $d04389629626fa2c$export$a3183b990150745c = $d04389629626fa2c$export$52411773e0d6f15d.Consumer;


"use client";
var $a077ba281eb48f92$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a077ba281eb48f92$export$b08a9033b36413fb = function(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, avatar = _a.avatar, title = _a.title, description = _a.description, others = $a077ba281eb48f92$var$__rest(_a, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    var getPrefixCls = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("list", customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item-meta"), className);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-content")
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("h4", {
        className: "".concat(prefixCls, "-item-meta-title")
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-description")
    }, description));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", Object.assign({}, others, {
        className: classString
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-avatar")
    }, avatar), (title || description) && content);
};
var $a077ba281eb48f92$var$InternalItem = function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, children = _a.children, actions = _a.actions, extra = _a.extra, className = _a.className, colStyle = _a.colStyle, others = $a077ba281eb48f92$var$__rest(_a, [
        "prefixCls",
        "children",
        "actions",
        "extra",
        "className",
        "colStyle"
    ]);
    var _useContext = (0, $8SyCD.useContext)((0, $d04389629626fa2c$export$52411773e0d6f15d)), grid = _useContext.grid, itemLayout = _useContext.itemLayout;
    var getPrefixCls = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var isItemContainsTextNodeAndNotSingular = function() {
        var result;
        (0, $8SyCD.Children).forEach(children, function(element) {
            if (typeof element === "string") result = true;
        });
        return result && (0, $8SyCD.Children).count(children) > 1;
    };
    var isFlexMode = function() {
        if (itemLayout === "vertical") return !!extra;
        return !isItemContainsTextNodeAndNotSingular();
    };
    var prefixCls = getPrefixCls("list", customizePrefixCls);
    var actionsContent = actions && actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("ul", {
        className: "".concat(prefixCls, "-item-action"),
        key: "actions"
    }, actions.map(function(action, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("li", {
            key: "".concat(prefixCls, "-item-action-").concat(i)
        }, action, i !== actions.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("em", {
            className: "".concat(prefixCls, "-item-action-split")
        })));
    }));
    var Element = grid ? "div" : "li";
    var itemChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(Element, Object.assign({}, others, !grid ? {
        ref: ref
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-item-no-flex"), !isFlexMode()), className)
    }), itemLayout === "vertical" && extra ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
            className: "".concat(prefixCls, "-item-main"),
            key: "content"
        }, children, actionsContent),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement("div", {
            className: "".concat(prefixCls, "-item-extra"),
            key: "extra"
        }, extra)
    ] : [
        children,
        actionsContent,
        (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(extra, {
            key: "extra"
        })
    ]);
    return grid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, $3de12888db3e80bd$export$2e2bcd8739ae039), {
        ref: ref,
        flex: 1,
        style: colStyle
    }, itemChildren) : itemChildren;
};
var $a077ba281eb48f92$var$Item = /*#__PURE__*/ (0, $8SyCD.forwardRef)($a077ba281eb48f92$var$InternalItem);
$a077ba281eb48f92$var$Item.Meta = $a077ba281eb48f92$export$b08a9033b36413fb;
var $a077ba281eb48f92$export$2e2bcd8739ae039 = $a077ba281eb48f92$var$Item;







var $8d32b9f321c3b640$var$genBorderedStyle = function(token) {
    var listBorderedCls = token.listBorderedCls, componentCls = token.componentCls, paddingLG = token.paddingLG, margin = token.margin, itemPaddingSM = token.itemPaddingSM, itemPaddingLG = token.itemPaddingLG, marginLG = token.marginLG, borderRadiusLG = token.borderRadiusLG;
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(listBorderedCls), (_obj = {
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
        borderRadius: borderRadiusLG
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-header,").concat(componentCls, "-footer,").concat(componentCls, "-item"), {
        paddingInline: paddingLG
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-pagination"), {
        margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(margin), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(marginLG))
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(listBorderedCls).concat(componentCls, "-sm"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item,").concat(componentCls, "-header,").concat(componentCls, "-footer"), {
        padding: itemPaddingSM
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(listBorderedCls).concat(componentCls, "-lg"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item,").concat(componentCls, "-header,").concat(componentCls, "-footer"), {
        padding: itemPaddingLG
    })), _obj1;
};
var $8d32b9f321c3b640$var$genResponsiveStyle = function(token) {
    var componentCls = token.componentCls, screenSM = token.screenSM, screenMD = token.screenMD, marginLG = token.marginLG, marginSM = token.marginSM, margin = token.margin;
    var _obj, _obj1, _obj2, _obj3;
    return _obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "@media screen and (max-width:".concat(screenMD, "px)"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-action"), {
        marginInlineStart: marginLG
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-vertical"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-extra"), {
        marginInlineStart: marginLG
    }))), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "@media screen and (max-width: ".concat(screenSM, "px)"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        flexWrap: "wrap"
    }, "".concat(componentCls, "-action"), {
        marginInlineStart: marginSM
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-vertical"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item"), (_obj1 = {
        flexWrap: "wrap-reverse"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-main"), {
        minWidth: token.contentWidth
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-extra"), {
        margin: "auto auto ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(margin))
    }), _obj1))), _obj2)), _obj3;
};
// =============================== Base ===============================
var $8d32b9f321c3b640$var$genBaseStyle = function(token) {
    var componentCls = token.componentCls, antCls = token.antCls, controlHeight = token.controlHeight, minHeight = token.minHeight, paddingSM = token.paddingSM, marginLG = token.marginLG, padding = token.padding, itemPadding = token.itemPadding, colorPrimary = token.colorPrimary, itemPaddingSM = token.itemPaddingSM, itemPaddingLG = token.itemPaddingLG, paddingXS = token.paddingXS, margin = token.margin, colorText = token.colorText, colorTextDescription = token.colorTextDescription, motionDurationSlow = token.motionDurationSlow, lineWidth = token.lineWidth, headerBg = token.headerBg, footerBg = token.footerBg, emptyTextPadding = token.emptyTextPadding, metaMarginBottom = token.metaMarginBottom, avatarMarginRight = token.avatarMarginRight, titleMarginBottom = token.titleMarginBottom, descriptionFontSize = token.descriptionFontSize;
    var alignCls = {};
    [
        "start",
        "center",
        "end"
    ].forEach(function(item) {
        alignCls["&-align-".concat(item)] = {
            textAlign: item
        };
    });
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return _obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj3 = {
        position: "relative",
        "*": {
            outline: "none"
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-header"), {
        background: headerBg
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-footer"), {
        background: footerBg
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-header, ").concat(componentCls, "-footer"), {
        paddingBlock: paddingSM
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-pagination"), Object.assign(Object.assign({
        marginBlockStart: marginLG
    }, alignCls), // https://github.com/ant-design/ant-design/issues/20037
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(antCls, "-pagination-options"), {
        textAlign: "start"
    }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-spin"), {
        minHeight: minHeight,
        textAlign: "center"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-items"), {
        margin: 0,
        padding: 0,
        listStyle: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-item"), (_obj2 = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: itemPadding,
        color: colorText
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-item-meta"), (_obj = {
        display: "flex",
        flex: 1,
        alignItems: "flex-start",
        maxWidth: "100%"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-meta-avatar"), {
        marginInlineEnd: avatarMarginRight
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-meta-content"), {
        flex: "1 0",
        width: 0,
        color: colorText
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-meta-title"), {
        margin: "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginXXS), " 0"),
        color: colorText,
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        "> a": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            color: colorText,
            transition: "all ".concat(motionDurationSlow)
        }, "&:hover", {
            color: colorPrimary
        })
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-meta-description"), {
        color: colorTextDescription,
        fontSize: descriptionFontSize,
        lineHeight: token.lineHeight
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-item-action"), (_obj1 = {
        flex: "0 0 auto",
        marginInlineStart: token.marginXXL,
        padding: 0,
        fontSize: 0,
        listStyle: "none"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "& > li", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        position: "relative",
        display: "inline-block",
        padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingXS)),
        color: colorTextDescription,
        fontSize: token.fontSize,
        lineHeight: token.lineHeight,
        textAlign: "center"
    }, "&:first-child", {
        paddingInlineStart: 0
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-action-split"), {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineEnd: 0,
        width: lineWidth,
        height: token.calc(token.fontHeight).sub(token.calc(token.marginXXS).mul(2)).equal(),
        transform: "translateY(-50%)",
        backgroundColor: token.colorSplit
    }), _obj1)), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-empty"), {
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(padding), " 0"),
        color: colorTextDescription,
        fontSize: token.fontSizeSM,
        textAlign: "center"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-empty-text"), {
        padding: emptyTextPadding,
        color: token.colorTextDisabled,
        fontSize: token.fontSize,
        textAlign: "center"
    }), // ============================ without flex ============================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-item-no-flex"), {
        display: "block"
    }), _obj3))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-grid ").concat(antCls, "-col > ").concat(componentCls, "-item"), {
        display: "block",
        maxWidth: "100%",
        marginBlockEnd: margin,
        paddingBlock: 0,
        borderBlockEnd: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-vertical ").concat(componentCls, "-item"), (_obj4 = {
        alignItems: "initial"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-main"), {
        display: "block",
        flex: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-extra"), {
        marginInlineStart: marginLG
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-meta"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        marginBlockEnd: metaMarginBottom
    }, "".concat(componentCls, "-item-meta-title"), {
        marginBlockStart: 0,
        marginBlockEnd: titleMarginBottom,
        color: colorText,
        fontSize: token.fontSizeLG,
        lineHeight: token.lineHeightLG
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-action"), {
        marginBlockStart: padding,
        marginInlineStart: "auto",
        "> li": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(padding))
        }, "&:first-child", {
            paddingInlineStart: 0
        })
    }), _obj4)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-split ").concat(componentCls, "-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderBlockEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }, "&:last-child", {
        borderBlockEnd: "none"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-split ").concat(componentCls, "-header"), {
        borderBlockEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-split").concat(componentCls, "-empty ").concat(componentCls, "-footer"), {
        borderTop: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-loading ").concat(componentCls, "-spin-nested-loading"), {
        minHeight: controlHeight
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-split").concat(componentCls, "-something-after-last-item ").concat(antCls, "-spin-container > ").concat(componentCls, "-items > ").concat(componentCls, "-item:last-child"), {
        borderBlockEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-lg ").concat(componentCls, "-item"), {
        padding: itemPaddingLG
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-sm ").concat(componentCls, "-item"), {
        padding: itemPaddingSM
    }), // Horizontal
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, ":not(").concat(componentCls, "-vertical)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-no-flex"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-action"), {
        float: "right"
    }))), _obj5;
};
var $8d32b9f321c3b640$export$9ca1be8807fe0675 = function(token) {
    return {
        contentWidth: 220,
        itemPadding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentVertical), " 0"),
        itemPaddingSM: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentVerticalSM), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentHorizontal)),
        itemPaddingLG: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentVerticalLG), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.paddingContentHorizontalLG)),
        headerBg: "transparent",
        footerBg: "transparent",
        emptyTextPadding: token.padding,
        metaMarginBottom: token.padding,
        avatarMarginRight: token.padding,
        titleMarginBottom: token.paddingSM,
        descriptionFontSize: token.fontSize
    };
};
var // ============================== Export ==============================
$8d32b9f321c3b640$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("List", function(token) {
    var listToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        listBorderedCls: "".concat(token.componentCls, "-bordered"),
        minHeight: token.controlHeightLG
    });
    return [
        $8d32b9f321c3b640$var$genBaseStyle(listToken),
        $8d32b9f321c3b640$var$genBorderedStyle(listToken),
        $8d32b9f321c3b640$var$genResponsiveStyle(listToken)
    ];
}, $8d32b9f321c3b640$export$9ca1be8807fe0675);



"use client";
var $4717634082efcae4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4717634082efcae4$var$List(_a) {
    var _b;
    var _a_pagination = _a.pagination, pagination = _a_pagination === void 0 ? false : _a_pagination, customizePrefixCls = _a.prefixCls, _a_bordered = _a.bordered, bordered = _a_bordered === void 0 ? false : _a_bordered, _a_split = _a.split, split = _a_split === void 0 ? true : _a_split, className = _a.className, rootClassName = _a.rootClassName, style = _a.style, children = _a.children, itemLayout = _a.itemLayout, loadMore = _a.loadMore, grid = _a.grid, _a_dataSource = _a.dataSource, dataSource = _a_dataSource === void 0 ? [] : _a_dataSource, customizeSize = _a.size, header = _a.header, footer = _a.footer, _a_loading = _a.loading, loading = _a_loading === void 0 ? false : _a_loading, rowKey = _a.rowKey, renderItem = _a.renderItem, locale = _a.locale, rest = $4717634082efcae4$var$__rest(_a, [
        "pagination",
        "prefixCls",
        "bordered",
        "split",
        "className",
        "rootClassName",
        "style",
        "children",
        "itemLayout",
        "loadMore",
        "grid",
        "dataSource",
        "size",
        "header",
        "footer",
        "loading",
        "rowKey",
        "renderItem",
        "locale"
    ]);
    var paginationObj = pagination && typeof pagination === "object" ? pagination : {};
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(paginationObj.defaultCurrent || 1), 2), paginationCurrent = _React_useState[0], setPaginationCurrent = _React_useState[1];
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(paginationObj.defaultPageSize || 10), 2), paginationSize = _React_useState1[0], setPaginationSize = _React_useState1[1];
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, renderEmpty = _React_useContext.renderEmpty, direction = _React_useContext.direction, list = _React_useContext.list;
    var defaultPaginationProps = {
        current: 1,
        total: 0
    };
    var triggerPaginationEvent = function(eventName) {
        return function(page, pageSize) {
            var _$_a;
            setPaginationCurrent(page);
            setPaginationSize(pageSize);
            if (pagination && pagination[eventName]) (_$_a = pagination === null || pagination === void 0 ? void 0 : pagination[eventName]) === null || _$_a === void 0 || _$_a.call(pagination, page, pageSize);
        };
    };
    var onPaginationChange = triggerPaginationEvent("onChange");
    var onPaginationShowSizeChange = triggerPaginationEvent("onShowSizeChange");
    var renderInnerItem = function(item, index) {
        if (!renderItem) return null;
        var key;
        if (typeof rowKey === "function") key = rowKey(item);
        else if (rowKey) key = item[rowKey];
        else key = item.key;
        if (!key) key = "list-item-".concat(index);
        return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, {
            key: key
        }, renderItem(item, index));
    };
    var isSomethingAfterLastItem = function() {
        return !!(loadMore || pagination || footer);
    };
    var prefixCls = getPrefixCls("list", customizePrefixCls);
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8d32b9f321c3b640$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var loadingProp = loading;
    if (typeof loadingProp === "boolean") loadingProp = {
        spinning: loadingProp
    };
    var isLoading = loadingProp && loadingProp.spinning;
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customizeSize);
    // large => lg
    // small => sm
    var sizeCls = "";
    switch(mergedSize){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        default:
            break;
    }
    var _obj;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-vertical"), itemLayout === "vertical"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-split"), split), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-bordered"), bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-loading"), isLoading), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-grid"), !!grid), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-something-after-last-item"), isSomethingAfterLastItem()), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), list === null || list === void 0 ? void 0 : list.className, className, rootClassName, hashId);
    var paginationProps = (0, $e7a6cdfb5d77a6e3$export$2e2bcd8739ae039)(defaultPaginationProps, {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
    }, pagination || {});
    var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
    if (paginationProps.current > largestPage) paginationProps.current = largestPage;
    var paginationContent = pagination ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-pagination"), "".concat(prefixCls, "-pagination-align-").concat((_b = paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.align) !== null && _b !== void 0 ? _b : "end"))
    }, /*#__PURE__*/ $8SyCD.createElement((0, $b2cc55c05c9b067b$export$2e2bcd8739ae039), Object.assign({}, paginationProps, {
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationShowSizeChange
    }))) : null;
    var splitDataSource = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(dataSource);
    if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) splitDataSource = (0, $e17b38c8264d6486$export$2e2bcd8739ae039)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
    var needResponsive = Object.keys(grid || {}).some(function(key) {
        return [
            "xs",
            "sm",
            "md",
            "lg",
            "xl",
            "xxl"
        ].includes(key);
    });
    var screens = (0, $ad217e1563e0ca7a$export$2e2bcd8739ae039)(needResponsive);
    var currentBreakpoint = $8SyCD.useMemo(function() {
        for(var i = 0; i < (0, $6d08709ecca144ea$export$74c1bf8296b1541f).length; i += 1){
            var breakpoint = (0, $6d08709ecca144ea$export$74c1bf8296b1541f)[i];
            if (screens[breakpoint]) return breakpoint;
        }
        return undefined;
    }, [
        screens
    ]);
    var colStyle = $8SyCD.useMemo(function() {
        if (!grid) return undefined;
        var columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
        if (columnCount) return {
            width: "".concat(100 / columnCount, "%"),
            maxWidth: "".concat(100 / columnCount, "%")
        };
    }, [
        grid === null || grid === void 0 ? void 0 : grid.column,
        currentBreakpoint
    ]);
    var childrenContent = isLoading && /*#__PURE__*/ $8SyCD.createElement("div", {
        style: {
            minHeight: 53
        }
    });
    if (splitDataSource.length > 0) {
        var items = splitDataSource.map(function(item, index) {
            return renderInnerItem(item, index);
        });
        childrenContent = grid ? /*#__PURE__*/ $8SyCD.createElement((0, $052ff5f829750c55$export$2e2bcd8739ae039), {
            gutter: grid.gutter
        }, $8SyCD.Children.map(items, function(child) {
            return /*#__PURE__*/ $8SyCD.createElement("div", {
                key: child === null || child === void 0 ? void 0 : child.key,
                style: colStyle
            }, child);
        })) : /*#__PURE__*/ $8SyCD.createElement("ul", {
            className: "".concat(prefixCls, "-items")
        }, items);
    } else if (!children && !isLoading) childrenContent = /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-empty-text")
    }, locale && locale.emptyText || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("List")) || /*#__PURE__*/ $8SyCD.createElement((0, $554405272ae7ed67$export$2e2bcd8739ae039), {
        componentName: "List"
    }));
    var paginationPosition = paginationProps.position || "bottom";
    var contextValue = $8SyCD.useMemo(function() {
        return {
            grid: grid,
            itemLayout: itemLayout
        };
    }, [
        JSON.stringify(grid),
        itemLayout
    ]);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $d04389629626fa2c$export$52411773e0d6f15d).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        style: Object.assign(Object.assign({}, list === null || list === void 0 ? void 0 : list.style), style),
        className: classString
    }, rest), (paginationPosition === "top" || paginationPosition === "both") && paginationContent, header && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-header")
    }, header), /*#__PURE__*/ $8SyCD.createElement((0, $4b177413dcaa6282$export$2e2bcd8739ae039), Object.assign({}, loadingProp), childrenContent, children), footer && /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer), loadMore || (paginationPosition === "bottom" || paginationPosition === "both") && paginationContent)));
}
$4717634082efcae4$var$List.Item = (0, $a077ba281eb48f92$export$2e2bcd8739ae039);
var $4717634082efcae4$export$2e2bcd8739ae039 = $4717634082efcae4$var$List;



/**
 * @module fluent-react
 * @overview
 *

 * `fluent-react` provides React bindings for Fluent.  It takes advantage of
 * React's Components system and the virtual DOM.  Translations are exposed to
 * components via the provider pattern.
 *
 * Consult the documentation of the `LocalizationProvider` and the `Localized`
 * components for more information.
 *
 * @example
 * ```jsx
 * <LocalizationProvider l10n={…}>
 *     <Localized id="hello-world">
 *         <p>{'Hello, world!'}</p>
 *     </Localized>
 * </LocalizationProvider>
 * ```
 */ 



/**
 * @module fluent-sequence
 * @overview Manage ordered sequences of FluentBundles.
 */ /**
 * Synchronously map an identifier or an array of identifiers to the best
 * `FluentBundle` instance(s).
 *
 * @param bundles - An iterable of bundles to sift through.
 * @param ids - An id or ids to map.
 */ function $d9ea1be4b5e4f2bb$export$66347a3fed3529a1(bundles, ids) {
    if (!Array.isArray(ids)) return $d9ea1be4b5e4f2bb$var$getBundleForId(bundles, ids);
    return ids.map(function(id) {
        return $d9ea1be4b5e4f2bb$var$getBundleForId(bundles, id);
    });
}
/*
 * Find the best `FluentBundle` with the translation for `id`.
 */ function $d9ea1be4b5e4f2bb$var$getBundleForId(bundles, id) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = bundles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bundle = _step.value;
            if (bundle.hasMessage(id)) return bundle;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}


/**
 * Asynchronously map an identifier or an array of identifiers to the best
 * `FluentBundle` instance(s).
 *
 * @param bundles - An iterable of bundles to sift through.
 * @param ids - An id or ids to map.
 */ function $99f9673035e362ad$export$adaf682ac3edfe45(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $99f9673035e362ad$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $99f9673035e362ad$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $99f9673035e362ad$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $99f9673035e362ad$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $99f9673035e362ad$var$AsyncFromSyncIterator(s);
}





function $4a9a19eba1c9ee24$export$ef4cd27e09be8ab4(bundles, ids) {
    return $4a9a19eba1c9ee24$var$_mapBundleAsync.apply(this, arguments);
}
function $4a9a19eba1c9ee24$var$_mapBundleAsync() {
    $4a9a19eba1c9ee24$var$_mapBundleAsync = (0, $14480b1fff30b85c$export$7c398597f8905a1)(function(bundles, ids) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, bundle, err, foundBundles, remainingCount, _iteratorAbruptCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _value1, bundle1, _iteratorNormalCompletion, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step_value, index, id, err1;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!Array.isArray(ids)) return [
                        3,
                        13
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $99f9673035e362ad$export$adaf682ac3edfe45)(bundles);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    bundle = _value;
                    if (bundle.hasMessage(ids)) return [
                        2,
                        bundle
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        null
                    ];
                case 13:
                    foundBundles = new Array(ids.length).fill(null);
                    remainingCount = ids.length;
                    _iteratorAbruptCompletion1 = false, _didIteratorError1 = false;
                    _state.label = 14;
                case 14:
                    _state.trys.push([
                        14,
                        19,
                        20,
                        25
                    ]);
                    _iterator1 = (0, $99f9673035e362ad$export$adaf682ac3edfe45)(bundles);
                    _state.label = 15;
                case 15:
                    return [
                        4,
                        _iterator1.next()
                    ];
                case 16:
                    if (!(_iteratorAbruptCompletion1 = !(_step1 = _state.sent()).done)) return [
                        3,
                        18
                    ];
                    _value1 = _step1.value;
                    bundle1 = _value1;
                    _iteratorNormalCompletion = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = ids.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion = true){
                            _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step2.value, 2), index = _step_value[0], id = _step_value[1];
                            if (!foundBundles[index] && bundle1.hasMessage(id)) {
                                foundBundles[index] = bundle1;
                                remainingCount--;
                            }
                            // Return early when all ids have been mapped to bundles.
                            if (remainingCount === 0) return [
                                2,
                                foundBundles
                            ];
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator2["return"] != null) {
                                _iterator2["return"]();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    _state.label = 17;
                case 17:
                    _iteratorAbruptCompletion1 = false;
                    return [
                        3,
                        15
                    ];
                case 18:
                    return [
                        3,
                        25
                    ];
                case 19:
                    err1 = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err1;
                    return [
                        3,
                        25
                    ];
                case 20:
                    _state.trys.push([
                        20,
                        ,
                        23,
                        24
                    ]);
                    if (!(_iteratorAbruptCompletion1 && _iterator1["return"] != null)) return [
                        3,
                        22
                    ];
                    return [
                        4,
                        _iterator1["return"]()
                    ];
                case 21:
                    _state.sent();
                    _state.label = 22;
                case 22:
                    return [
                        3,
                        24
                    ];
                case 23:
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                    return [
                        7
                    ];
                case 24:
                    return [
                        7
                    ];
                case 25:
                    return [
                        2,
                        foundBundles
                    ];
            }
        });
    });
    return $4a9a19eba1c9ee24$var$_mapBundleAsync.apply(this, arguments);
}





var $8SyCD = parcelRequire("8SyCD");




/*
 * Base CachedIterable class.
 */ 




var $dfcc22a85d714921$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(CachedIterable, Array1);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(CachedIterable);
    function CachedIterable() {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, CachedIterable);
        return _super.apply(this, arguments);
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(CachedIterable, null, [
        {
            key: "from",
            value: /**
     * Create a `CachedIterable` instance from an iterable or, if another
     * instance of `CachedIterable` is passed, return it without any
     * modifications.
     *
     * @param {Iterable} iterable
     * @returns {CachedIterable}
     */ function from(iterable) {
                if (iterable instanceof this) return iterable;
                return new this(iterable);
            }
        }
    ]);
    return CachedIterable;
}((0, $90a77dd41ef751d3$export$2466d533fda16e33)(Array));


var $d9294caeb057f33c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(CachedIterable) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(CachedSyncIterable, CachedIterable);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(CachedSyncIterable);
    function CachedSyncIterable(iterable) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, CachedSyncIterable);
        var _this;
        _this = _super.call(this);
        if (Symbol.iterator in Object(iterable)) _this.iterator = iterable[Symbol.iterator]();
        else throw new TypeError("Argument must implement the iteration protocol.");
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(CachedSyncIterable, [
        {
            key: Symbol.iterator,
            value: function value() {
                var cached = this;
                var cur = 0;
                return {
                    next: function() {
                        if (cached.length <= cur) cached.push(cached.iterator.next());
                        return cached[cur++];
                    }
                };
            }
        },
        {
            /**
     * This method allows user to consume the next element from the iterator
     * into the cache.
     *
     * @param {number} count - number of elements to consume
     */ key: "touchNext",
            value: function touchNext() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var idx = 0;
                while(idx++ < count){
                    var last = this[this.length - 1];
                    if (last && last.done) break;
                    this.push(this.iterator.next());
                }
                // Return the last cached {value, done} object to allow the calling
                // code to decide if it needs to call touchNext again.
                return this[this.length - 1];
            }
        }
    ]);
    return CachedSyncIterable;
}((0, $dfcc22a85d714921$export$2e2bcd8739ae039));









var $9a98d57b2b0a90aa$export$2e2bcd8739ae039 = /*#__PURE__*/ function(CachedIterable) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(CachedAsyncIterable, CachedIterable);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(CachedAsyncIterable);
    function CachedAsyncIterable(iterable) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, CachedAsyncIterable);
        var _this;
        _this = _super.call(this);
        if (Symbol.asyncIterator in Object(iterable)) _this.iterator = iterable[Symbol.asyncIterator]();
        else if (Symbol.iterator in Object(iterable)) _this.iterator = iterable[Symbol.iterator]();
        else throw new TypeError("Argument must implement the iteration protocol.");
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(CachedAsyncIterable, [
        {
            /**
     * Asynchronous iterator caching the yielded elements.
     *
     * Elements yielded by the original iterable will be cached and available
     * synchronously. Returns an async generator object implementing the
     * iterator protocol over the elements of the original (async or sync)
     * iterable.
     */ key: Symbol.asyncIterator,
            value: function value() {
                var cached = this;
                var cur = 0;
                return {
                    next: function() {
                        return (0, $14480b1fff30b85c$export$7c398597f8905a1)(function() {
                            return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                                if (cached.length <= cur) cached.push(cached.iterator.next());
                                return [
                                    2,
                                    cached[cur++]
                                ];
                            });
                        })();
                    }
                };
            }
        },
        {
            key: "touchNext",
            value: /**
     * This method allows user to consume the next element from the iterator
     * into the cache.
     *
     * @param {number} count - number of elements to consume
     */ function touchNext() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var _this = this;
                return (0, $14480b1fff30b85c$export$7c398597f8905a1)(function() {
                    var idx, last, _tmp;
                    return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                idx = 0;
                                _state.label = 1;
                            case 1:
                                if (!(idx++ < count)) return [
                                    3,
                                    4
                                ];
                                last = _this[_this.length - 1];
                                _tmp = last;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    last
                                ];
                            case 2:
                                _tmp = _state.sent().done;
                                _state.label = 3;
                            case 3:
                                if (_tmp) return [
                                    3,
                                    4
                                ];
                                _this.push(_this.iterator.next());
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                // Return the last cached {value, done} object to allow the calling
                                // code to decide if it needs to call touchNext again.
                                return [
                                    2,
                                    _this[_this.length - 1]
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CachedAsyncIterable;
}((0, $dfcc22a85d714921$export$2e2bcd8739ae039));




var $82aa152fd2135cf6$var$cachedParseMarkup;
function $82aa152fd2135cf6$export$11d2572d418e3213() {
    if (typeof document === "undefined") // We can't use <template> to sanitize translations.
    throw new Error("`document` is undefined. Without it, translations cannot be safely sanitized. Consult the documentation at https://github.com/projectfluent/fluent.js/wiki/React-Overlays.");
    if (!$82aa152fd2135cf6$var$cachedParseMarkup) {
        var template = document.createElement("template");
        $82aa152fd2135cf6$var$cachedParseMarkup = function parseMarkup(str) {
            template.innerHTML = str;
            return Array.from(template.content.childNodes);
        };
    }
    return $82aa152fd2135cf6$var$cachedParseMarkup;
}


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in this directory.
 */ 
function $3e6303611e69f27e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in this directory.
 */ // For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.
var $110467c38e789e8b$var$omittedCloseTags = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};
var $110467c38e789e8b$export$2e2bcd8739ae039 = $110467c38e789e8b$var$omittedCloseTags;


// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.
var $dc05c16cb37f51bd$var$voidElementTags = (0, $3e6303611e69f27e$export$581ff339ea0ba762)({
    menuitem: true
}, (0, $110467c38e789e8b$export$2e2bcd8739ae039));
var $dc05c16cb37f51bd$export$2e2bcd8739ae039 = $dc05c16cb37f51bd$var$voidElementTags;


// Match the opening angle bracket (<) in HTML tags, and HTML entities like
// &amp;, &#0038;, &#x0026;.
var $7ab6a2f379e810f0$var$reMarkup = /<|&#?\w+;/;
var $7ab6a2f379e810f0$var$defaultReportError = function(error) {
    /* global console */ // eslint-disable-next-line no-console
    console.warn("[@fluent/react] ".concat(error.name, ": ").concat(error.message));
};
var $7ab6a2f379e810f0$export$d677167801025e9c = /*#__PURE__*/ function() {
    "use strict";
    function ReactLocalization(bundles) {
        var parseMarkup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $82aa152fd2135cf6$export$11d2572d418e3213)(), reportError = arguments.length > 2 ? arguments[2] : void 0;
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, ReactLocalization);
        this.bundles = (0, $d9294caeb057f33c$export$2e2bcd8739ae039).from(bundles);
        this.parseMarkup = parseMarkup;
        this.reportError = reportError || $7ab6a2f379e810f0$var$defaultReportError;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(ReactLocalization, [
        {
            key: "getBundle",
            value: function getBundle(id) {
                return (0, $d9ea1be4b5e4f2bb$export$66347a3fed3529a1)(this.bundles, id);
            }
        },
        {
            key: "areBundlesEmpty",
            value: function areBundlesEmpty() {
                // Create an iterator and only peek at the first value to see if it contains
                // anything.
                return Boolean(this.bundles[Symbol.iterator]().next().done);
            }
        },
        {
            key: "getString",
            value: function getString(id, vars, fallback) {
                var bundle = this.getBundle(id);
                if (bundle) {
                    var msg = bundle.getMessage(id);
                    if (msg && msg.value) {
                        var errors = [];
                        var value = bundle.formatPattern(msg.value, vars, errors);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var error = _step.value;
                                this.reportError(error);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return value;
                    }
                } else if (this.areBundlesEmpty()) this.reportError(new Error("Attempting to get a string when no localization bundles are present."));
                else this.reportError(new Error('The id "'.concat(id, '" did not match any messages in the localization ') + "bundles."));
                return fallback || id;
            }
        },
        {
            key: "getElement",
            value: function getElement(sourceElement, id) {
                var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var bundle = this.getBundle(id);
                if (bundle === null) {
                    if (!id) this.reportError(new Error("No string id was provided when localizing a component."));
                    else if (this.areBundlesEmpty()) this.reportError(new Error("Attempting to get a localized element when no localization bundles are present."));
                    else this.reportError(new Error('The id "'.concat(id, '" did not match any messages in the localization ') + "bundles."));
                    return (0, $8SyCD.createElement)((0, $8SyCD.Fragment), null, sourceElement);
                }
                // this.getBundle makes the bundle.hasMessage check which ensures that
                // bundle.getMessage returns an existing message.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var msg = bundle.getMessage(id);
                var errors = [];
                var localizedProps;
                // The default is to forbid all message attributes. If the attrs prop exists
                // on the Localized instance, only set message attributes which have been
                // explicitly allowed by the developer.
                if (args.attrs && msg.attributes) {
                    localizedProps = {};
                    errors = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(args.attrs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], allowed = _step_value[1];
                            if (allowed && name in msg.attributes) localizedProps[name] = bundle.formatPattern(msg.attributes[name], args.vars, errors);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = errors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var error = _step1.value;
                            this.reportError(error);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                // If the component to render is a known void element, explicitly dismiss the
                // message value and do not pass it to cloneElement in order to avoid the
                // "void element tags must neither have `children` nor use
                // `dangerouslySetInnerHTML`" error.
                if (typeof sourceElement.type === "string" && sourceElement.type in (0, $dc05c16cb37f51bd$export$2e2bcd8739ae039)) return (0, $8SyCD.cloneElement)(sourceElement, localizedProps);
                // If the message has a null value, we're only interested in its attributes.
                // Do not pass the null value to cloneElement as it would nuke all children
                // of the wrapped component.
                if (msg.value === null) return (0, $8SyCD.cloneElement)(sourceElement, localizedProps);
                errors = [];
                var messageValue = bundle.formatPattern(msg.value, args.vars, errors);
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var error1 = _step2.value;
                        this.reportError(error1);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                // If the message value doesn't contain any markup nor any HTML entities,
                // insert it as the only child of the component to render.
                if (!$7ab6a2f379e810f0$var$reMarkup.test(messageValue) || this.parseMarkup === null) return (0, $8SyCD.cloneElement)(sourceElement, localizedProps, messageValue);
                var elemsLower;
                if (args.elems) {
                    elemsLower = new Map();
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = Object.entries(args.elems)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var _step_value1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step3.value, 2), name1 = _step_value1[0], elem = _step_value1[1];
                            // Ignore elems which are not valid React elements.
                            if (!(0, $8SyCD.isValidElement)(elem)) continue;
                            elemsLower.set(name1.toLowerCase(), elem);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                _iterator3["return"]();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
                // If the message contains markup, parse it and try to match the children
                // found in the translation with the args passed to this function.
                var translationNodes = this.parseMarkup(messageValue);
                var translatedChildren = translationNodes.map(function(param) {
                    var nodeName = param.nodeName, textContent = param.textContent;
                    if (nodeName === "#text") return textContent;
                    var childName = nodeName.toLowerCase();
                    var sourceChild = elemsLower === null || elemsLower === void 0 ? void 0 : elemsLower.get(childName);
                    // If the child is not expected just take its textContent.
                    if (!sourceChild) return textContent;
                    // If the element passed in the elems prop is a known void element,
                    // explicitly dismiss any textContent which might have accidentally been
                    // defined in the translation to prevent the "void element tags must not
                    // have children" error.
                    if (typeof sourceChild.type === "string" && sourceChild.type in (0, $dc05c16cb37f51bd$export$2e2bcd8739ae039)) return sourceChild;
                    // TODO Protect contents of elements wrapped in <Localized>
                    // https://github.com/projectfluent/fluent.js/issues/184
                    // TODO  Control localizable attributes on elements passed as props
                    // https://github.com/projectfluent/fluent.js/issues/185
                    return (0, $8SyCD.cloneElement)(sourceChild, undefined, textContent);
                });
                return (0, $8SyCD.cloneElement).apply(void 0, [
                    sourceElement,
                    localizedProps
                ].concat((0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(translatedChildren)));
            }
        }
    ]);
    return ReactLocalization;
}();



var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");
var $97ca0479da8ed63d$export$2c7c98b7ad3e8317 = (0, $8SyCD.createContext)(null);


function $cbedd744a85eec5e$export$dc45bdc734ce6f1e(props) {
    return (0, $8SyCD.createElement)((0, $97ca0479da8ed63d$export$2c7c98b7ad3e8317).Provider, {
        value: props.l10n
    }, props.children);
}




var $8SyCD = parcelRequire("8SyCD");

function $d90ad0a340d6188f$export$87272ba977ad7085(Inner) {
    function WithLocalization(props) {
        var l10n = (0, $8SyCD.useContext)((0, $97ca0479da8ed63d$export$2c7c98b7ad3e8317));
        if (!l10n) throw new Error("withLocalization was used without wrapping it in a <LocalizationProvider />.");
        // Re-bind getString to trigger a re-render of Inner.
        var getString = l10n.getString.bind(l10n);
        return (0, $8SyCD.createElement)(Inner, (0, $3e6303611e69f27e$export$581ff339ea0ba762)({
            getString: getString
        }, props));
    }
    WithLocalization.displayName = "WithLocalization(".concat($d90ad0a340d6188f$var$displayName(Inner), ")");
    return WithLocalization;
}
function $d90ad0a340d6188f$var$displayName(component) {
    return component.displayName || component.name || "Component";
}



var $8SyCD = parcelRequire("8SyCD");

function $f89bf6c25edcb21d$export$83669d75c31e40c5(props) {
    var id = props.id, attrs = props.attrs, vars = props.vars, elems = props.elems, children = props.children;
    var l10n = (0, $8SyCD.useContext)((0, $97ca0479da8ed63d$export$2c7c98b7ad3e8317));
    if (!l10n) throw new Error("The <Localized /> component was not properly wrapped in a <LocalizationProvider />.");
    var source;
    if (Array.isArray(children)) {
        if (children.length > 1) throw new Error("Expected to receive a single React element to localize.");
        // If it's an array with zero or one element, we can directly get the first one.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        source = children[0];
    } else source = children !== null && children !== void 0 ? children : null;
    // Check if the component to render is a valid element -- if not, then
    // it's either null or a simple fallback string. No need to localize the
    // attributes or replace.
    if (!(0, $8SyCD.isValidElement)(source)) {
        var fallback = typeof source === "string" ? source : undefined;
        var string = l10n.getString(id, vars, fallback);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).Fragment, null, string);
    }
    return l10n.getElement(source, id, {
        attrs: attrs,
        vars: vars,
        elems: elems
    });
}
var $f89bf6c25edcb21d$export$2e2bcd8739ae039 = $f89bf6c25edcb21d$export$83669d75c31e40c5;



var $8SyCD = parcelRequire("8SyCD");

var $160b412984e56eb2$export$45e1d5299cdc6e86 = function() {
    var l10n = (0, $8SyCD.useContext)((0, $97ca0479da8ed63d$export$2c7c98b7ad3e8317));
    if (!l10n) throw new Error("useLocalization was used without wrapping it in a <LocalizationProvider />.");
    return {
        l10n: l10n
    };
};






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $83a8eb5380301ff7$var$ArrowRightOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                }
            }
        ]
    },
    name: "arrow-right",
    theme: "outlined"
};
var $83a8eb5380301ff7$export$2e2bcd8739ae039 = $83a8eb5380301ff7$var$ArrowRightOutlined;



var $44e15bb0c0ae7cd4$var$ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $83a8eb5380301ff7$export$2e2bcd8739ae039)
    }));
};
var $44e15bb0c0ae7cd4$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($44e15bb0c0ae7cd4$var$ArrowRightOutlined);


function $4d84ed2d6d1cd5db$export$e3f55b9c19e951df(props) {
    var onCreateRhythm = props.onCreateRhythm;
    var dexie = (0, $c5efbd2e0c4166b1$export$95809329f49ea9f9)().dexie;
    var rhythms = (0, $1367a51faa32faf0$exports.useLiveQuery)(function() {
        return dexie.rhythms.toArray();
    }, [
        dexie
    ]);
    var renderEmpty = (0, $8SyCD.useCallback)(function() {
        return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $663faa9ebe7f0295$export$2e2bcd8739ae039), {
            description: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "no-rhythms",
                children: "No Rhythms"
            }),
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                type: "primary",
                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), {}),
                onClick: onCreateRhythm,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "create-rhythm",
                    children: "Create Rhythm"
                })
            })
        });
    }, [
        onCreateRhythm
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f2caf184cab96719$export$2e2bcd8739ae039), {
        renderEmpty: renderEmpty,
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6179788acd512012$export$2e2bcd8739ae039), {
            title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "rhythms",
                children: "Rhythms"
            }),
            extra: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                type: "primary",
                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), {}),
                onClick: onCreateRhythm,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "create-rhythm",
                    children: "Create Rhythm"
                })
            }),
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039), {
                dataSource: rhythms,
                renderItem: function(rhythm) {
                    var actions = [
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $76b4f75f035f6acf$export$a6c7ac8248d6e38a), {
                            to: "/metronome/".concat(rhythm.id),
                            children: [
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $44e15bb0c0ae7cd4$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "open",
                                    children: "Open"
                                })
                            ]
                        })
                    ];
                    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item, {
                        actions: actions,
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item.Meta, {
                            title: rhythm.name,
                            description: rhythm.createdTime.toLocaleString()
                        })
                    });
                }
            })
        })
    });
}







var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $830cfd7deffeb938$var$ArrowLeftOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    name: "arrow-left",
    theme: "outlined"
};
var $830cfd7deffeb938$export$2e2bcd8739ae039 = $830cfd7deffeb938$var$ArrowLeftOutlined;



var $d9ef14496d70c2c4$var$ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $830cfd7deffeb938$export$2e2bcd8739ae039)
    }));
};
var $d9ef14496d70c2c4$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d9ef14496d70c2c4$var$ArrowLeftOutlined);





var $8SyCD = parcelRequire("8SyCD");

function $eec4795e5e45e013$export$bbadff23f5cd28e2() {
    var navigate = (0, $b6e23d349026de17$export$9770f232ac06a008)();
    var goBack = (0, $8SyCD.useCallback)(function() {
        navigate(-1);
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d9ef14496d70c2c4$export$2e2bcd8739ae039), {}),
        onClick: goBack,
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
            id: "back",
            children: "Back"
        })
    });
}




function $b7a92f42eb46ae39$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b7a92f42eb46ae39$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $b7a92f42eb46ae39$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $937a19630c6770a0$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $5d5a26e68236d453$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $937a19630c6770a0$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




parcelRequire("8SyCD");

function $666b43abc2af1493$export$c5eaea0d6f8cb6f4(props) {
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
        className: "form__field__group",
        children: props.children
    });
}
function $666b43abc2af1493$export$56e87bf42978147a(props) {
    var label = props.label, name = props.name;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "form__field",
        children: [
            label ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("label", {
                className: "form__field__label",
                htmlFor: name,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: label
                })
            }) : null,
            props.children
        ]
    });
}
function $666b43abc2af1493$export$a7fed597f4b8afd8(props) {
    var children = props.children, rest = (0, $5d5a26e68236d453$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("form", (0, $b7a92f42eb46ae39$export$4fa2f4023c9cbda5)((0, $3e6303611e69f27e$export$581ff339ea0ba762)({
        className: "form"
    }, rest), {
        children: props.children
    }));
}








var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $5ed24dcad99e91a0$var$UpOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    name: "up",
    theme: "outlined"
};
var $5ed24dcad99e91a0$export$2e2bcd8739ae039 = $5ed24dcad99e91a0$var$UpOutlined;



var $c192f59390048967$var$UpOutlined = function UpOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5ed24dcad99e91a0$export$2e2bcd8739ae039)
    }));
};
var $c192f59390048967$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($c192f59390048967$var$UpOutlined);








/* eslint-disable max-classes-per-file */ 


function $d7b77bd03f8b9042$export$d5c7b2f63580e8f5() {
    return typeof BigInt === "function";
}


function $f1fefc504fe6e575$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $f1fefc504fe6e575$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith("-");
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, "$1")// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, "")// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, "");
    if (str.startsWith(".")) str = "0".concat(str);
    var trimStr = str || "0";
    var splitNumber = trimStr.split(".");
    var integerStr = splitNumber[0] || "0";
    var decimalStr = splitNumber[1] || "0";
    if (integerStr === "0" && decimalStr === "0") negative = false;
    var negativeStr = negative ? "-" : "";
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $f1fefc504fe6e575$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes("e");
}
function $f1fefc504fe6e575$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($f1fefc504fe6e575$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes(".") && $f1fefc504fe6e575$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function $f1fefc504fe6e575$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($f1fefc504fe6e575$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $d7b77bd03f8b9042$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $d7b77bd03f8b9042$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($f1fefc504fe6e575$export$2e56483e4ad90ee6(numStr));
    }
    return $f1fefc504fe6e575$export$5be79a0015c5ab12(numStr).fullStr;
}
function $f1fefc504fe6e575$export$b3d198e17b370bec(num) {
    if (typeof num === "number") return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $129bb72b898ed07d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, BigIntDecimal);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "negative", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "integer", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "decimal", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "decimalLen", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "empty", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "nan", void 0);
        if ((0, $f1fefc504fe6e575$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === "-" || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $f1fefc504fe6e575$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === "string" ? mergedValue : (0, $f1fefc504fe6e575$export$fdc98affa95a4322)(mergedValue);
        if ((0, $f1fefc504fe6e575$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split(".");
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || "0";
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? "-" : "";
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, "0");
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, "0"));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();






/**
 * We can remove this when IE not support anymore
 */ var $86a1d3938c4dbdb9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $8c9b1388f71090cb$export$2e2bcd8739ae039)(this, NumberDecimal);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "number", void 0);
        (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(this, "empty", void 0);
        if ((0, $f1fefc504fe6e575$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $de94c4fdc35681ad$export$2e2bcd8739ae039)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(this.number), (0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(this.number), (0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $f1fefc504fe6e575$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $b3c7b47fca9c8820$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $d7b77bd03f8b9042$export$d5c7b2f63580e8f5)()) return new (0, $129bb72b898ed07d$export$2e2bcd8739ae039)(value);
    return new (0, $86a1d3938c4dbdb9$export$2e2bcd8739ae039)(value);
}
function $b3c7b47fca9c8820$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === "") return "";
    var _trimNumber = (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $b3c7b47fca9c8820$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
            return $b3c7b47fca9c8820$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
    }
    if (precisionDecimalStr === ".0") return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $af9628e3e269468f$export$2e2bcd8739ae039 = (0, $b3c7b47fca9c8820$export$2e2bcd8739ae039);







var $8SyCD = parcelRequire("8SyCD");

var $8SyCD = parcelRequire("8SyCD");

function $d8b841fa883e396d$export$2e2bcd8739ae039(input, focused) {
    var selectionRef = (0, $8SyCD.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $ed6f30969113606c$export$2e2bcd8739ae039)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");


/**
 * Hook to detect if the user is on a mobile device
 * Notice that this hook will only detect the device type in effect, so it will always be false in server side
 */ var $9eb0b528a248aba0$var$useMobile = function useMobile() {
    var _useState = (0, $8SyCD.useState)(false), _useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        setMobile((0, $fc01ea5e514846e5$export$2e2bcd8739ae039)());
    }, []);
    return mobile;
};
var $9eb0b528a248aba0$export$2e2bcd8739ae039 = $9eb0b528a248aba0$var$useMobile;



/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $a25a8923741d367d$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $a25a8923741d367d$var$STEP_DELAY = 600;
function $a25a8923741d367d$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = $8SyCD.useRef();
    var frameIds = $8SyCD.useRef([]);
    var onStepRef = $8SyCD.useRef();
    onStepRef.current = onStep;
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStopStep();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, $a25a8923741d367d$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $a25a8923741d367d$var$STEP_DELAY);
    };
    $8SyCD.useEffect(function() {
        return function() {
            onStopStep();
            frameIds.current.forEach(function(id) {
                return (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(id);
            });
        };
    }, []);
    // ======================= Render =======================
    var isMobile = (0, $9eb0b528a248aba0$export$2e2bcd8739ae039)();
    if (isMobile) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(handlerClassName, "".concat(handlerClassName, "-up"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(handlerClassName, "".concat(handlerClassName, "-down"), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession, 
    // there may be a problem that the onmouseup events are executed first, 
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    var safeOnStopStep = function safeOnStopStep() {
        return frameIds.current.push((0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(onStopStep));
    };
    var sharedHandlerProps = {
        unselectable: "on",
        role: "button",
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep
    };
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ $8SyCD.createElement("span", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ $8SyCD.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ $8SyCD.createElement("span", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ $8SyCD.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}



function $5dea5123e11b39a1$export$d2883c6c6307c415(step) {
    var stepStr = typeof step === "number" ? (0, $f1fefc504fe6e575$export$fdc98affa95a4322)(step) : (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)(step).fullStr;
    var hasPoint = stepStr.includes(".");
    if (!hasPoint) return step + "0";
    return (0, $f1fefc504fe6e575$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr;
}




var $8SyCD = parcelRequire("8SyCD");

var /**
 * Always trigger latest once when call multiple time
 */ $773f343626288e73$export$2e2bcd8739ae039 = function() {
    var idRef = (0, $8SyCD.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, $8927aaea5eb757b1$export$2e2bcd8739ae039).cancel(idRef.current);
    };
    (0, $8SyCD.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, $8927aaea5eb757b1$export$2e2bcd8739ae039)(function() {
            callback();
        });
    };
};


var $6389759c7e9eaa3a$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "controls",
    "classNames",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep",
    "changeOnBlur"
], $6389759c7e9eaa3a$var$_excluded2 = [
    "disabled",
    "style",
    "prefixCls",
    "value",
    "prefix",
    "suffix",
    "addonBefore",
    "addonAfter",
    "classes",
    "className",
    "classNames"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var $6389759c7e9eaa3a$var$getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var $6389759c7e9eaa3a$var$getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var $6389759c7e9eaa3a$var$InternalInputNumber = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _clsx;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input-number" : _props$prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, classNames = props.classNames, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, _props$changeOnBlur = props.changeOnBlur, changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur, inputProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $6389759c7e9eaa3a$var$_excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = $8SyCD.useRef(null);
    var _React$useState = $8SyCD.useState(false), _React$useState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = $8SyCD.useRef(false);
    var compositionRef = $8SyCD.useRef(false);
    var shiftKeyRef = $8SyCD.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = $8SyCD.useState(function() {
        return (0, $af9628e3e269468f$export$2e2bcd8739ae039)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = $8SyCD.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(numStr), (0, $f1fefc504fe6e575$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = $8SyCD.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, ".");
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, "");
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = $8SyCD.useRef("");
    var mergedFormatter = $8SyCD.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === "number" ? (0, $f1fefc504fe6e575$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, $f1fefc504fe6e575$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || ".";
                str = (0, $b3c7b47fca9c8820$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = $8SyCD.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            "string",
            "number"
        ].includes((0, $a205fb7a2d11f9f1$export$2e2bcd8739ae039)(initValue))) return Number.isNaN(initValue) ? "" : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = $8SyCD.useMemo(function() {
        return $6389759c7e9eaa3a$var$getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = $8SyCD.useMemo(function() {
        return $6389759c7e9eaa3a$var$getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = $8SyCD.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = $8SyCD.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, $d8b841fa883e396d$export$2e2bcd8739ae039)(inputRef.current, focus), _useCursor2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $af9628e3e269468f$export$2e2bcd8739ae039)((0, $b3c7b47fca9c8820$export$a81f732198733497)(numStr, ".", mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $af9628e3e269468f$export$2e2bcd8739ae039)((0, $b3c7b47fca9c8820$export$a81f732198733497)(numStr, ".", mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : $6389759c7e9eaa3a$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, $773f343626288e73$export$2e2bcd8739ae039)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, ".");
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $5dea5123e11b39a1$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, $af9628e3e269468f$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep($6389759c7e9eaa3a$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $5dea5123e11b39a1$export$d2883c6c6307c415)(step) : step,
            type: up ? "up" : "down"
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(mergedParser(inputValue));
        var formatValue = parsedValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var key = event.key, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === "Enter") {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            "Up",
            "ArrowUp",
            "Down",
            "ArrowDown"
        ].includes(key)) {
            onInternalStep(key === "Up" || key === "ArrowUp");
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        var newValue = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, $af9628e3e269468f$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $6a684e1af621c10a$export$9283e56bae2f7b0f)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, classNames === null || classNames === void 0 ? void 0 : classNames.input, className, (_clsx = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-focused"), focus), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-disabled"), disabled), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-readonly"), readOnly), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue)), _clsx)),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ $8SyCD.createElement((0, $a25a8923741d367d$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ $8SyCD.createElement("input", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
var $6389759c7e9eaa3a$var$InputNumber = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var disabled = props.disabled, style = props.style, prefixCls = props.prefixCls, value = props.value, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, classes = props.classes, className = props.className, classNames = props.classNames, rest = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $6389759c7e9eaa3a$var$_excluded2);
    var inputFocusRef = $8SyCD.useRef(null);
    var focus = function focus(option) {
        if (inputFocusRef.current) (0, $ff7c93464b262e56$export$2b92016deb0b7aad)(inputFocusRef.current, option);
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $1008040ffe7a0ab4$export$2e2bcd8739ae039), {
        inputElement: /*#__PURE__*/ $8SyCD.createElement($6389759c7e9eaa3a$var$InternalInputNumber, (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
            prefixCls: prefixCls,
            disabled: disabled,
            classNames: classNames,
            ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(inputFocusRef, ref)
        }, rest)),
        className: className,
        triggerFocus: focus,
        prefixCls: prefixCls,
        value: value,
        disabled: disabled,
        style: style,
        prefix: prefix,
        suffix: suffix,
        addonAfter: addonAfter,
        addonBefore: addonBefore,
        classes: classes,
        classNames: classNames,
        components: {
            affixWrapper: "div",
            groupWrapper: "div",
            wrapper: "div",
            groupAddon: "div"
        }
    });
});
$6389759c7e9eaa3a$var$InputNumber.displayName = "InputNumber";
var $6389759c7e9eaa3a$export$2e2bcd8739ae039 = $6389759c7e9eaa3a$var$InputNumber;


var $ad12d0d51ead1e85$export$2e2bcd8739ae039 = (0, $6389759c7e9eaa3a$export$2e2bcd8739ae039);



var $8SyCD = parcelRequire("8SyCD");












var $a280b5a6b66c9345$export$b6107fb2af1bfc36 = function(_ref, size) {
    var componentCls = _ref.componentCls, borderRadiusSM = _ref.borderRadiusSM, borderRadiusLG = _ref.borderRadiusLG;
    var borderRadius = size === "lg" ? borderRadiusLG : borderRadiusSM;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&-".concat(size), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-handler-wrap"), {
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-handler-up"), {
        borderStartEndRadius: borderRadius
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-handler-down"), {
        borderEndEndRadius: borderRadius
    }), _obj));
};
var $a280b5a6b66c9345$var$genInputNumberStyles = function(token) {
    var componentCls = token.componentCls, lineWidth = token.lineWidth, lineType = token.lineType, colorBorder = token.colorBorder, borderRadius = token.borderRadius, fontSizeLG = token.fontSizeLG, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, colorError = token.colorError, paddingInlineSM = token.paddingInlineSM, colorTextDescription = token.colorTextDescription, motionDurationMid = token.motionDurationMid, handleHoverColor = token.handleHoverColor, paddingInline = token.paddingInline, paddingBlock = token.paddingBlock, handleBg = token.handleBg, handleActiveBg = token.handleActiveBg, colorTextDisabled = token.colorTextDisabled, borderRadiusSM = token.borderRadiusSM, borderRadiusLG = token.borderRadiusLG, controlWidth = token.controlWidth, handleOpacity = token.handleOpacity, handleBorderColor = token.handleBorderColor, calc = token.calc;
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd)(token)), (0, $36bcd88a5dc6cb3d$export$cf983a15949ad61e)(token, componentCls)), (_obj1 = {
            display: "inline-block",
            width: controlWidth,
            margin: 0,
            padding: 0,
            border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " ").concat(lineType, " ").concat(colorBorder),
            borderRadius: borderRadius,
            "&-rtl": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                direction: "rtl"
            }, "".concat(componentCls, "-input"), {
                direction: "rtl"
            }),
            "&-lg": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                padding: 0,
                fontSize: fontSizeLG,
                borderRadius: borderRadiusLG
            }, "input".concat(componentCls, "-input"), {
                height: calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()
            }),
            "&-sm": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                padding: 0,
                borderRadius: borderRadiusSM
            }, "input".concat(componentCls, "-input"), {
                height: calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal(),
                padding: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingInlineSM))
            }),
            // ===================== Out Of Range =====================
            "&-out-of-range": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-input-wrap"), {
                input: {
                    color: colorError
                }
            }),
            // Style for input-group: input with label, with button or dropdown...
            "&-group": Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $36bcd88a5dc6cb3d$export$ffe8b2a9bd2e5cfe)(token)), {
                "&-wrapper": (_obj = {
                    display: "inline-block",
                    textAlign: "start",
                    verticalAlign: "top"
                }, // https://github.com/ant-design/ant-design/issues/6403
                (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-affix-wrapper"), {
                    width: "100%"
                }), // Size
                (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-lg", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                    borderRadius: borderRadiusLG,
                    fontSize: token.fontSizeLG
                })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-sm", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-group-addon"), {
                    borderRadius: borderRadiusSM
                })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-wrapper-disabled > ").concat(componentCls, "-group-addon"), Object.assign({}, (0, $36bcd88a5dc6cb3d$export$12789f962d420a93)(token))), // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/45764
                (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-first-item):not(").concat(componentCls, "-compact-last-item)").concat(componentCls, "-compact-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
                    borderRadius: 0
                })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-last-item)").concat(componentCls, "-compact-first-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
                    borderStartEndRadius: 0,
                    borderEndEndRadius: 0
                })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-compact-first-item)").concat(componentCls, "-compact-last-item"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-group-addon"), {
                    borderStartStartRadius: 0,
                    borderEndStartRadius: 0
                })), _obj)
            })
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-disabled ".concat(componentCls, "-input"), {
            cursor: "not-allowed"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, componentCls, {
            "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), {
                width: "100%",
                padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingBlock), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingInline)),
                textAlign: "start",
                backgroundColor: "transparent",
                border: 0,
                borderRadius: borderRadius,
                outline: 0,
                transition: "all ".concat(motionDurationMid, " linear"),
                appearance: "textfield",
                fontSize: "inherit"
            }), (0, $36bcd88a5dc6cb3d$export$92095d0f4c77bd56)(token.colorTextPlaceholder)), {
                '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                    margin: 0,
                    /* stylelint-disable-next-line property-no-vendor-prefix */ webkitAppearance: "none",
                    appearance: "none"
                }
            })
        }), _obj1))),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign((_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&:hover ".concat(componentCls, "-handler-wrap, &-focused ").concat(componentCls, "-handler-wrap"), {
            opacity: 1
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-handler-wrap"), // Fix input number inside Menu makes icon too large
        // We arise the selector priority by nest selector here
        // https://github.com/ant-design/ant-design/issues/14367
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            position: "absolute",
            insetBlockStart: 0,
            insetInlineEnd: 0,
            width: token.handleWidth,
            height: "100%",
            background: handleBg,
            borderStartStartRadius: 0,
            borderStartEndRadius: borderRadius,
            borderEndEndRadius: borderRadius,
            borderEndStartRadius: 0,
            opacity: handleOpacity,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            transition: "opacity ".concat(motionDurationMid, " linear ").concat(motionDurationMid)
        }, "".concat(componentCls, "-handler"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%"
        }, "\n              ".concat(componentCls, "-handler-up-inner,\n              ").concat(componentCls, "-handler-down-inner\n            "), {
            marginInlineEnd: 0,
            fontSize: token.handleFontSize
        }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-handler"), {
            height: "50%",
            overflow: "hidden",
            color: colorTextDescription,
            fontWeight: "bold",
            lineHeight: 0,
            textAlign: "center",
            cursor: "pointer",
            borderInlineStart: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " ").concat(lineType, " ").concat(handleBorderColor),
            transition: "all ".concat(motionDurationMid, " linear"),
            "&:active": {
                background: handleActiveBg
            },
            // Hover
            "&:hover": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                height: "60%"
            }, "\n              ".concat(componentCls, "-handler-up-inner,\n              ").concat(componentCls, "-handler-down-inner\n            "), {
                color: handleHoverColor
            }),
            "&-up-inner, &-down-inner": Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$171ccda7bc085e59)()), {
                color: colorTextDescription,
                transition: "all ".concat(motionDurationMid, " linear"),
                userSelect: "none"
            })
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-handler-up"), {
            borderStartEndRadius: borderRadius
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-handler-down"), {
            borderBlockStart: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " ").concat(lineType, " ").concat(handleBorderColor),
            borderEndEndRadius: borderRadius
        }), _obj2), $a280b5a6b66c9345$export$b6107fb2af1bfc36(token, "lg")), $a280b5a6b66c9345$export$b6107fb2af1bfc36(token, "sm")), (_obj4 = {
            // Disabled
            "&-disabled, &-readonly": (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-handler-wrap"), {
                display: "none"
            }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-input"), {
                color: "inherit"
            }), _obj3)
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n          ".concat(componentCls, "-handler-up-disabled,\n          ").concat(componentCls, "-handler-down-disabled\n        "), {
            cursor: "not-allowed"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n          ".concat(componentCls, "-handler-up-disabled:hover &-handler-up-inner,\n          ").concat(componentCls, "-handler-down-disabled:hover &-handler-down-inner\n        "), {
            color: colorTextDisabled
        }), _obj4))),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-borderless"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            borderColor: "transparent",
            boxShadow: "none"
        }, "".concat(componentCls, "-handler-down"), {
            borderBlockStartWidth: 0
        }))
    ];
};
var $a280b5a6b66c9345$var$genAffixWrapperStyles = function(token) {
    var componentCls = token.componentCls, paddingBlock = token.paddingBlock, paddingInline = token.paddingInline, inputAffixPadding = token.inputAffixPadding, controlWidth = token.controlWidth, borderRadiusLG = token.borderRadiusLG, borderRadiusSM = token.borderRadiusSM;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-affix-wrapper"), Object.assign(Object.assign(Object.assign({}, (0, $36bcd88a5dc6cb3d$export$8c9a381315f3ebcd)(token)), (0, $36bcd88a5dc6cb3d$export$cf983a15949ad61e)(token, "".concat(componentCls, "-affix-wrapper"))), (_obj = {
        // or number handler will cover form status
        position: "relative",
        display: "inline-flex",
        width: controlWidth,
        padding: 0,
        paddingInlineStart: paddingInline,
        "&-lg": {
            borderRadius: borderRadiusLG
        },
        "&-sm": {
            borderRadius: borderRadiusSM
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-affix-wrapper-disabled):hover"), {
        zIndex: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-focused, &:focus", {
        zIndex: 1
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-disabled > ".concat(componentCls, "-disabled"), {
        background: "transparent"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> div".concat(componentCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        width: "100%",
        border: "none",
        outline: "none"
    }, "&".concat(componentCls, "-focused"), {
        boxShadow: "none !important"
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "input".concat(componentCls, "-input"), {
        padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingBlock), " 0")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&::before", {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-handler-wrap"), {
        zIndex: 2
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, componentCls, {
        "&-prefix, &-suffix": {
            display: "flex",
            flex: "none",
            alignItems: "center",
            pointerEvents: "none"
        },
        "&-prefix": {
            marginInlineEnd: inputAffixPadding
        },
        "&-suffix": {
            position: "absolute",
            insetBlockStart: 0,
            insetInlineEnd: 0,
            zIndex: 1,
            height: "100%",
            marginInlineEnd: paddingInline,
            marginInlineStart: inputAffixPadding
        }
    }), _obj)));
};
var $a280b5a6b66c9345$export$9ca1be8807fe0675 = function(token) {
    return Object.assign(Object.assign({}, (0, $36bcd88a5dc6cb3d$export$bd8b682992bc9781)(token)), {
        controlWidth: 90,
        handleWidth: token.controlHeightSM - token.lineWidth * 2,
        handleFontSize: token.fontSize / 2,
        handleVisible: "auto",
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: 0
    });
};
var $a280b5a6b66c9345$export$c75c4d82116b857c = function(token) {
    return Object.assign(Object.assign({}, token), {
        handleOpacity: token.handleVisible === true ? 1 : 0
    });
};
var $a280b5a6b66c9345$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("InputNumber", function(token) {
    var inputNumberToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, (0, $36bcd88a5dc6cb3d$export$a157d95850191a12)(token));
    return [
        $a280b5a6b66c9345$var$genInputNumberStyles(inputNumberToken),
        $a280b5a6b66c9345$var$genAffixWrapperStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $8123ced5d1d65f52$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, $a280b5a6b66c9345$export$9ca1be8807fe0675, {
    format: $a280b5a6b66c9345$export$c75c4d82116b857c,
    unitless: {
        handleOpacity: true
    }
});



"use client";
var $52be2c3bc282daba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $52be2c3bc282daba$var$InputNumber = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var inputRef = $8SyCD.useRef(null);
    $8SyCD.useImperativeHandle(ref, function() {
        return inputRef.current;
    });
    var className = props.className, rootClassName = props.rootClassName, customizeSize = props.size, customDisabled = props.disabled, customizePrefixCls = props.prefixCls, addonBefore = props.addonBefore, addonAfter = props.addonAfter, prefix = props.prefix, _props_bordered = props.bordered, bordered = _props_bordered === void 0 ? true : _props_bordered, readOnly = props.readOnly, customStatus = props.status, controls = props.controls, others = $52be2c3bc282daba$var$__rest(props, [
        "className",
        "rootClassName",
        "size",
        "disabled",
        "prefixCls",
        "addonBefore",
        "addonAfter",
        "prefix",
        "bordered",
        "readOnly",
        "status",
        "controls"
    ]);
    var prefixCls = getPrefixCls("input-number", customizePrefixCls);
    // Style
    var cssVarCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a280b5a6b66c9345$export$2e2bcd8739ae039)(prefixCls, cssVarCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _useCompactItemContext = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContext.compactSize, compactItemClassnames = _useCompactItemContext.compactItemClassnames;
    var upIcon = /*#__PURE__*/ $8SyCD.createElement((0, $c192f59390048967$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-handler-up-inner")
    });
    var downIcon = /*#__PURE__*/ $8SyCD.createElement((0, $d4250094f6be33d4$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-handler-down-inner")
    });
    var controlsTemp = typeof controls === "boolean" ? controls : undefined;
    if (typeof controls === "object") {
        upIcon = typeof controls.upIcon === "undefined" ? upIcon : /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-handler-up-inner")
        }, controls.upIcon);
        downIcon = typeof controls.downIcon === "undefined" ? downIcon : /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-handler-down-inner")
        }, controls.downIcon);
    }
    var _React_useContext1 = $8SyCD.useContext((0, $1618288003dd675a$export$bbb5553c6c7a14ed)), hasFeedback = _React_useContext1.hasFeedback, contextStatus = _React_useContext1.status, isFormItemInput = _React_useContext1.isFormItemInput, feedbackIcon = _React_useContext1.feedbackIcon;
    var mergedStatus = (0, $69f886f8119a0cf0$export$314e193082d7ba49)(contextStatus, customStatus);
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(function(ctx) {
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    var disabled = $8SyCD.useContext((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _obj;
    var inputNumberClass = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-borderless"), !bordered), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-in-form-item"), isFormItemInput), _obj), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)(prefixCls, mergedStatus), hashId);
    var wrapperClassName = "".concat(prefixCls, "-group");
    // eslint-disable-next-line react/jsx-no-useless-fragment
    var suffixNode = hasFeedback && /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, feedbackIcon);
    var _obj1, _obj2, _obj3;
    var element = /*#__PURE__*/ $8SyCD.createElement((0, $ad12d0d51ead1e85$export$2e2bcd8739ae039), Object.assign({
        ref: inputRef,
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(cssVarCls, className, rootClassName, compactItemClassnames),
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode,
        addonAfter: addonAfter && /*#__PURE__*/ $8SyCD.createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, /*#__PURE__*/ $8SyCD.createElement((0, $1618288003dd675a$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ $8SyCD.createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, /*#__PURE__*/ $8SyCD.createElement((0, $1618288003dd675a$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonBefore)),
        classNames: {
            input: inputNumberClass
        },
        classes: {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $69f886f8119a0cf0$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), _obj1), hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(wrapperClassName, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(prefixCls, "-wrapper-disabled"), mergedDisabled), _obj2), hashId),
            group: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === "large"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(prefixCls, "-group-wrapper-rtl"), direction === "rtl"), _obj3), (0, $69f886f8119a0cf0$export$b08e7b47149942a2)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback), hashId)
        }
    }, others));
    return wrapCSSVar(element);
});
var $52be2c3bc282daba$var$TypedInputNumber = $52be2c3bc282daba$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ var $52be2c3bc282daba$var$PureInputNumber = function(props) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $f2caf184cab96719$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $8SyCD.createElement($52be2c3bc282daba$var$InputNumber, Object.assign({}, props)));
};
$52be2c3bc282daba$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $52be2c3bc282daba$var$PureInputNumber;
var $52be2c3bc282daba$export$2e2bcd8739ae039 = $52be2c3bc282daba$var$TypedInputNumber;



var $8SyCD = parcelRequire("8SyCD");


function $256a356f4461b6e7$export$e15dc023ebc1e95f(props) {
    var preparatory = props.preparatory, onChangePreparatory = props.onChangePreparatory;
    var id = (0, $8SyCD.useId)();
    var handleChangePreparatory = (0, $8SyCD.useCallback)(function(preparatory) {
        if (preparatory) onChangePreparatory(preparatory);
    }, [
        onChangePreparatory
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$a7fed597f4b8afd8), {
        autoComplete: "off",
        name: "preparatory__settings",
        className: "preparatory__settings",
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
            name: "".concat(id, "-prepratory"),
            label: "prepratory",
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                id: "".concat(id, "-prepratory"),
                min: 1,
                max: 20,
                step: 1,
                value: preparatory,
                onChange: handleChangePreparatory
            })
        })
    });
}






var $8SyCD = parcelRequire("8SyCD");



function $71a71e4b74044f72$export$f81847884871263e(num1, num2) {
    if (num1 % num2 == 0) return num2;
    else return $71a71e4b74044f72$export$f81847884871263e(num2, num1 % num2);
}
function $71a71e4b74044f72$export$f686d97e407ec4ef(num1, num2) {
    if (num1 === 0) return num2;
    if (num2 === 0) return num1;
    return num1 * num2 / $71a71e4b74044f72$export$f81847884871263e(num1, num2);
}


var $c9378659b665be93$export$df409b90d2c1a310;
(function(Dynamics) {
    Dynamics[Dynamics["None"] = 0] = "None";
    Dynamics[Dynamics["Light"] = 1] = "Light";
    Dynamics[Dynamics["Accent"] = 2] = "Accent";
    Dynamics[Dynamics["Invalid"] = 3] = "Invalid";
})($c9378659b665be93$export$df409b90d2c1a310 || ($c9378659b665be93$export$df409b90d2c1a310 = {}));
var $c9378659b665be93$export$2050b8129d8cdad6;
(function(NoteName) {
    NoteName[NoteName["C"] = 0] = "C";
    NoteName[NoteName["CSharp"] = 1] = "CSharp";
    NoteName[NoteName["D"] = 2] = "D";
    NoteName[NoteName["DSharp"] = 3] = "DSharp";
    NoteName[NoteName["E"] = 4] = "E";
    NoteName[NoteName["F"] = 5] = "F";
    NoteName[NoteName["FSharp"] = 6] = "FSharp";
    NoteName[NoteName["G"] = 7] = "G";
    NoteName[NoteName["GSharp"] = 8] = "GSharp";
    NoteName[NoteName["A"] = 9] = "A";
    NoteName[NoteName["ASharp"] = 10] = "ASharp";
    NoteName[NoteName["B"] = 11] = "B";
})($c9378659b665be93$export$2050b8129d8cdad6 || ($c9378659b665be93$export$2050b8129d8cdad6 = {}));



var $92577b47e3b00856$export$ed30250e7522198 = {
    type: "uniform",
    speed: 60
};
var $92577b47e3b00856$export$f045ecc4aca1fdee = {
    type: "varying",
    begin: 60,
    end: 60,
    step: 10
};
var $92577b47e3b00856$export$e98fdd653f95b0e8 = {
    name: (0, $c9378659b665be93$export$2050b8129d8cdad6).A,
    octave: 4,
    dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Accent
};
var $92577b47e3b00856$export$a46cd66499351d28 = {
    name: (0, $c9378659b665be93$export$2050b8129d8cdad6).A,
    octave: 4,
    dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
};
var $92577b47e3b00856$export$7f74fb282b451e4b = [
    {
        repeat: 1,
        beats: [
            {
                notes: [
                    $92577b47e3b00856$export$e98fdd653f95b0e8
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$e98fdd653f95b0e8
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            },
            {
                notes: [
                    $92577b47e3b00856$export$a46cd66499351d28
                ]
            }
        ]
    }
];
var $92577b47e3b00856$export$95e97a0b2b64af93 = {
    name: (0, $c9378659b665be93$export$2050b8129d8cdad6).A,
    octave: 4,
    dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).None
};
var $92577b47e3b00856$export$7dbade755bbd7df5 = 440; // A4
function $92577b47e3b00856$export$9c8164e79773c764(noteName) {
    switch(noteName){
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).C:
            return "C";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).CSharp:
            return "C#";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).D:
            return "D";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).DSharp:
            return "D#";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).E:
            return "E";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).F:
            return "F";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).FSharp:
            return "F#";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).G:
            return "G";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).GSharp:
            return "G#";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).A:
            return "A";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).ASharp:
            return "A#";
        case (0, $c9378659b665be93$export$2050b8129d8cdad6).B:
            return "B";
    }
}
function $92577b47e3b00856$export$e30cdbfc5f0ca703(note) {
    return "".concat($92577b47e3b00856$export$9c8164e79773c764(note.name)).concat(note.octave);
}
function $92577b47e3b00856$export$791af547312e0674(noteA, noteB) {
    return 12 * (noteA.octave - noteB.octave) + (noteA.name - noteB.name);
}
function $92577b47e3b00856$export$a8f9b7b280712859(note) {
    var halfSteps = $92577b47e3b00856$export$791af547312e0674(note, $92577b47e3b00856$export$95e97a0b2b64af93);
    return Math.pow(2, halfSteps / 12) * $92577b47e3b00856$export$7dbade755bbd7df5;
}
function $92577b47e3b00856$export$6f9f24d921645b42(frequency, dynamics) {
    var halfSteps = Math.round(Math.log(frequency / $92577b47e3b00856$export$7dbade755bbd7df5) * 12 / Math.log(2)) - ((0, $c9378659b665be93$export$2050b8129d8cdad6).C - (0, $c9378659b665be93$export$2050b8129d8cdad6).A);
    var octave = Math.floor(halfSteps / 12) + $92577b47e3b00856$export$95e97a0b2b64af93.octave;
    var name = (halfSteps - (octave - $92577b47e3b00856$export$95e97a0b2b64af93.octave) * 12) % ((0, $c9378659b665be93$export$2050b8129d8cdad6).B + 1);
    return {
        name: name,
        octave: octave,
        dynamics: dynamics
    };
}
function $92577b47e3b00856$export$ee00045eeaf37fbc(audioBuffer, sampleRate) {
    var audioSize = audioBuffer.length;
    var rms = 0;
    for(var i = 0; i < audioSize; i++){
        var val = audioBuffer[i];
        rms += val * val;
    }
    rms = Math.sqrt(rms / audioSize);
    if (rms < 0.01) return -1;
    var startIndex = 0;
    var endIndex = audioSize - 1;
    var threshold = 0.2;
    for(var i1 = 0; i1 < audioSize / 2; i1++)if (Math.abs(audioBuffer[i1]) < threshold) {
        startIndex = i1;
        break;
    }
    for(var i2 = 1; i2 < audioSize / 2; i2++)if (Math.abs(audioBuffer[audioSize - i2]) < threshold) {
        endIndex = audioSize - i2;
        break;
    }
    var audioSlice = audioBuffer.slice(startIndex, endIndex);
    var sliceSize = audioSlice.length;
    var c = new Array(sliceSize).fill(0);
    for(var i3 = 0; i3 < sliceSize; i3++)for(var j = 0; j < sliceSize - i3; j++)c[i3] = c[i3] + audioSlice[j] * audioSlice[j + i3];
    var d = 0;
    while(c[d] > c[d + 1])d++;
    var maxval = -1;
    var maxpos = -1;
    for(var i4 = d; i4 < sliceSize; i4++)if (c[i4] > maxval) {
        maxval = c[i4];
        maxpos = i4;
    }
    var T0 = maxpos;
    var x1 = c[T0 - 1];
    var x2 = c[T0];
    var x3 = c[T0 + 1];
    var a = (x1 + x3 - 2 * x2) / 2;
    var b = (x3 - x1) / 2;
    if (a) T0 = T0 - b / (2 * a);
    return sampleRate / T0;
}





var $7FyBz = parcelRequire("7FyBz");
function $60d369029efea793$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, pattern.flags ? pattern.flags : (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : "") + (pattern.dotAll ? "s" : ""));
}


function $65cf2abd720bb043$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}


function $2e0597683b904f01$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $65cf2abd720bb043$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(async () => {}); //=> "AsyncFunction"
 *      R.type(undefined); //=> "Undefined"
 */ var $1c4f1c21523db2ea$var$type = /*#__PURE__*/ (0, $2e0597683b904f01$export$2e2bcd8739ae039)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $1c4f1c21523db2ea$export$2e2bcd8739ae039 = $1c4f1c21523db2ea$var$type;


function $0679c687fdd268b5$export$2e2bcd8739ae039(value, deep, map) {
    map || (map = new $0679c687fdd268b5$var$_ObjectMap()); // this avoids the slower switch with a quick if decision removing some milliseconds in each run.
    if ($0679c687fdd268b5$var$_isPrimitive(value)) return value;
    var copy = function copy(copiedValue) {
        // Check for circular and same references on the object graph and return its corresponding clone.
        var cachedCopy = map.get(value);
        if (cachedCopy) return cachedCopy;
        map.set(value, copiedValue);
        for(var key in value)if (Object.prototype.hasOwnProperty.call(value, key)) copiedValue[key] = deep ? $0679c687fdd268b5$export$2e2bcd8739ae039(value[key], true, map) : value[key];
        return copiedValue;
    };
    switch((0, $1c4f1c21523db2ea$export$2e2bcd8739ae039)(value)){
        case "Object":
            return copy(Object.create(Object.getPrototypeOf(value)));
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $60d369029efea793$export$2e2bcd8739ae039)(value);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
            return value.slice();
        default:
            return value;
    }
}
function $0679c687fdd268b5$var$_isPrimitive(param) {
    var type = typeof param === "undefined" ? "undefined" : (0, $7FyBz._)(param);
    return param == null || type != "object" && type != "function";
}
var $0679c687fdd268b5$var$_ObjectMap = /*#__PURE__*/ function() {
    function _ObjectMap() {
        this.map = {};
        this.length = 0;
    }
    _ObjectMap.prototype.set = function(key, value) {
        var hashedKey = this.hash(key);
        var bucket = this.map[hashedKey];
        if (!bucket) this.map[hashedKey] = bucket = [];
        bucket.push([
            key,
            value
        ]);
        this.length += 1;
    };
    _ObjectMap.prototype.hash = function(key) {
        var hashedKey = [];
        for(var value in key)hashedKey.push(Object.prototype.toString.call(key[value]));
        return hashedKey.join();
    };
    _ObjectMap.prototype.get = function(key) {
        /**
     * depending on the number of objects to be cloned is faster to just iterate over the items in the map just because the hash function is so costly,
     * on my tests this number is 180, anything above that using the hash function is faster.
     */ if (this.length <= 180) {
            for(var p in this.map){
                var bucket = this.map[p];
                for(var i = 0; i < bucket.length; i += 1){
                    var element = bucket[i];
                    if (element[0] === key) return element[1];
                }
            }
            return;
        }
        var hashedKey = this.hash(key);
        var bucket1 = this.map[hashedKey];
        if (!bucket1) return;
        for(var i1 = 0; i1 < bucket1.length; i1 += 1){
            var element1 = bucket1[i1];
            if (element1[0] === key) return element1[1];
        }
    };
    return _ObjectMap;
}();



/**
 * Creates a deep copy of the source that can be used in place of the source
 * object without retaining any references to it.
 * The source object may contain (nested) `Array`s and `Object`s,
 * `Number`s, `String`s, `Boolean`s and `Date`s.
 * `Function`s are assigned by reference rather than copied.
 *
 * Dispatches to a `clone` method if present.
 *
 * Note that if the source object has multiple nodes that share a reference,
 * the returned object will have the same structure, but the references will
 * be pointed to the location within the cloned value.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $6537cf2f093a20b3$var$clone = /*#__PURE__*/ (0, $2e0597683b904f01$export$2e2bcd8739ae039)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $0679c687fdd268b5$export$2e2bcd8739ae039)(value, true);
});
var $6537cf2f093a20b3$export$2e2bcd8739ae039 = $6537cf2f093a20b3$var$clone;


function $e7d0c89ead4e7b91$export$4305c4a638586d94(tempo) {
    return $6537cf2f093a20b3$export$2e2bcd8739ae039(tempo);
}
function $e7d0c89ead4e7b91$export$53eb9750d527b0ce(note) {
    return $6537cf2f093a20b3$export$2e2bcd8739ae039(note);
}
function $e7d0c89ead4e7b91$export$d96ce701b5cbe4ed(beat) {
    return $6537cf2f093a20b3$export$2e2bcd8739ae039(beat);
}
function $e7d0c89ead4e7b91$export$f96da437e9862c2f(measure) {
    return $6537cf2f093a20b3$export$2e2bcd8739ae039(measure);
}
function $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm) {
    return $6537cf2f093a20b3$export$2e2bcd8739ae039(rhythm);
}
function $e7d0c89ead4e7b91$export$626701cf3387d96f(rhythm, preparatory) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    newRhythm.preparatoryBeats = preparatory;
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$14dbe7bbd606b84a(rhythm, tempo) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    newRhythm.tempo = $e7d0c89ead4e7b91$export$4305c4a638586d94(tempo);
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$8abb4dd589a611d(rhythm) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var lastMeasure = newRhythm.measures[rhythm.measures.length - 1];
    if (lastMeasure) newRhythm.measures.push($e7d0c89ead4e7b91$export$f96da437e9862c2f(lastMeasure));
    else newRhythm.measures = (0, $92577b47e3b00856$export$7f74fb282b451e4b);
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$21f3df343fa13a46(rhythm, measureIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    newRhythm.measures.splice(measureIndex, 1);
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$a2bc369da6b0184b(rhythm, measureIndex, repeat) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) measure.repeat = repeat;
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$830fa49c40093bd5(rhythm, measureIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) {
        var beat = measure.beats[measure.beats.length - 1];
        if (beat) measure.beats.push($e7d0c89ead4e7b91$export$d96ce701b5cbe4ed(beat));
    }
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$9387a39c06a193e3(rhythm, measureIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) {
        measure.beats = measure.beats.slice(0, measure.beats.length - 1);
        if (measure.beats.length === 0) newRhythm.measures.splice(measureIndex, 1);
    }
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$79159e21a6bceab7(rhythm, measureIndex, beatIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) {
        var beat = measure.beats[beatIndex];
        if (beat) {
            var lastNote = beat.notes[beat.notes.length - 1];
            beat.notes.push($e7d0c89ead4e7b91$export$53eb9750d527b0ce(lastNote));
        }
    }
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$8847734722b7329e(rhythm, measureIndex, beatIndex, noteIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) {
        var beat = measure.beats[beatIndex];
        if (beat) {
            var note = beat.notes[noteIndex];
            if (note) note.dynamics = (note.dynamics + 1) % (0, $c9378659b665be93$export$df409b90d2c1a310).Invalid;
        }
    }
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$84ca89dac13ca70a(rhythm, measureIndex, beatIndex) {
    var newRhythm = $e7d0c89ead4e7b91$export$85510b841f5c59b9(rhythm);
    var measure = newRhythm.measures[measureIndex];
    if (measure) {
        var beat = measure.beats[beatIndex];
        if (beat) {
            if (beat.notes.length === 1) measure.beats.splice(beatIndex, 1);
            else beat.notes = beat.notes.slice(0, beat.notes.length - 1);
        }
    }
    return newRhythm;
}
function $e7d0c89ead4e7b91$export$1e3c6a5020ae960f(rhythm) {
    var measuresCount = 0;
    var beatsCount = 0;
    var notesCount = 0;
    var ticksCount = 0;
    var ticksPerBeat = 0;
    var tempos = [];
    switch(rhythm.tempo.type){
        case "uniform":
            tempos.push($e7d0c89ead4e7b91$export$4305c4a638586d94(rhythm.tempo));
            break;
        case "varying":
            for(var speed = rhythm.tempo.begin; speed <= rhythm.tempo.end; speed += rhythm.tempo.step)tempos.push({
                type: "uniform",
                speed: speed
            });
            break;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rhythm.measures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var measure = _step.value;
            measuresCount = measuresCount + measure.repeat;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = measure.beats[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var beat = _step1.value;
                    beatsCount = beatsCount + measure.repeat;
                    notesCount = notesCount + beat.notes.length * measure.repeat;
                    ticksPerBeat = (0, $71a71e4b74044f72$export$f686d97e407ec4ef)(ticksPerBeat, beat.notes.length);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ticksCount = beatsCount * ticksPerBeat;
    return {
        tempos: tempos,
        measuresCount: measuresCount,
        beatsCount: beatsCount,
        notesCount: notesCount,
        ticksCount: ticksCount,
        ticksPerBeat: ticksPerBeat
    };
}
function $e7d0c89ead4e7b91$export$5200e0c7549d7bff(rhythm, ticksPerBeat, tickIndex) {
    var measureIndex = 0;
    var measureOffset = 0;
    var beatIndex = 0;
    var beatOffset = 0;
    var noteIndex = 0;
    var noteOffset = 0;
    var ticksCount = 0;
    for(var currMeasureIndex = 0; currMeasureIndex < rhythm.measures.length; currMeasureIndex++){
        var currMeasure = rhythm.measures[currMeasureIndex];
        for(var currMeasureOffset = 0; currMeasureOffset < currMeasure.repeat; currMeasureOffset++)for(var currBeatIndex = 0; currBeatIndex < currMeasure.beats.length; currBeatIndex++){
            var currBeat = currMeasure.beats[currBeatIndex];
            var maxTicksCount = ticksCount + ticksPerBeat;
            if (maxTicksCount - 1 < tickIndex) {
                ticksCount = maxTicksCount;
                beatOffset = beatOffset + 1;
                noteOffset = noteOffset + currBeat.notes.length;
                continue;
            }
            measureIndex = currMeasureIndex;
            measureOffset = currMeasureOffset;
            beatIndex = currBeatIndex;
            noteIndex = Math.floor(tickIndex % ticksPerBeat / (ticksPerBeat / currBeat.notes.length));
            noteOffset = noteOffset + noteIndex;
            return {
                measureOffset: measureOffset,
                measureIndex: measureIndex,
                beatIndex: beatIndex,
                beatOffset: beatOffset,
                noteIndex: noteIndex,
                noteOffset: noteOffset
            };
        }
    }
    return {
        measureOffset: measureOffset,
        measureIndex: measureIndex,
        beatIndex: beatIndex,
        beatOffset: beatOffset,
        noteIndex: noteIndex,
        noteOffset: noteOffset
    };
}
function $e7d0c89ead4e7b91$export$58aa5c5c19a2f2cb(rhythm, measureIndex, measureOffset, beatIndex, beatOffset) {
    var measure = rhythm.measures[measureIndex];
    if (beatIndex >= measure.beats.length - 1) {
        var measureCount = 0;
        for(var i = 0; i < measureIndex; i++)measureCount = measureCount + rhythm.measures[measureIndex].repeat;
        if (measureCount + measure.repeat <= measureOffset + 1) {
            if (measureIndex >= rhythm.measures.length - 1) return;
            else {
                measure = rhythm.measures[measureIndex + 1];
                return {
                    measureIndex: measureIndex + 1,
                    measureOffset: measureOffset + 1,
                    beatIndex: 0,
                    beatOffset: beatOffset + 1
                };
            }
        } else return {
            measureIndex: measureIndex,
            measureOffset: measureOffset,
            beatIndex: beatIndex + 1,
            beatOffset: beatOffset + 1
        };
    } else return {
        measureIndex: measureIndex,
        measureOffset: measureOffset,
        beatIndex: beatIndex + 1,
        beatOffset: beatOffset + 1
    };
}



var $3a38d9f63feceb53$export$158bbc173906b542 = 1000;
var $3a38d9f63feceb53$export$544c576050746347 = 60;
var $3a38d9f63feceb53$export$9245831f62081b68 = $3a38d9f63feceb53$export$544c576050746347 * $3a38d9f63feceb53$export$158bbc173906b542;


function $10b81a11b890c51d$export$4aa85292d1b0882e(props) {
    var tempo = props.tempo, onChangeTempo = props.onChangeTempo;
    var id = (0, $8SyCD.useId)();
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(tempo.type === "uniform" ? tempo.speed : (0, $92577b47e3b00856$export$ed30250e7522198).speed), 2), uniformTempoSpeed = _useState[0], setUniformTempoSpeed = _useState[1];
    var handleChangeUniformTempoSpeed = (0, $8SyCD.useCallback)(function(speed) {
        if (speed) {
            onChangeTempo({
                type: "uniform",
                speed: speed
            });
            setUniformTempoSpeed(speed);
        }
    }, [
        onChangeTempo
    ]);
    var initialVaryingTempo = tempo.type === "uniform" ? (0, $92577b47e3b00856$export$f045ecc4aca1fdee) : tempo;
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(initialVaryingTempo.begin), 2), varyingTempoBegin = _useState1[0], setVaryingTempoBegin = _useState1[1];
    var _useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(initialVaryingTempo.end), 2), varyingTempoEnd = _useState2[0], setVaryingTempoEnd = _useState2[1];
    var _useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(initialVaryingTempo.step), 2), varyingTempoStep = _useState3[0], setVaryingTempoStep = _useState3[1];
    var handleChangeVaryingTempoBegin = (0, $8SyCD.useCallback)(function(begin) {
        if (begin) {
            onChangeTempo({
                type: "varying",
                begin: begin,
                end: varyingTempoEnd,
                step: varyingTempoStep
            });
            setVaryingTempoBegin(begin);
        }
    }, [
        varyingTempoEnd,
        varyingTempoStep,
        setVaryingTempoBegin,
        onChangeTempo
    ]);
    var handleChangeVaryingTempoEnd = (0, $8SyCD.useCallback)(function(end) {
        if (end) {
            onChangeTempo({
                type: "varying",
                begin: varyingTempoBegin,
                end: end,
                step: varyingTempoStep
            });
            setVaryingTempoEnd(end);
        }
    }, [
        varyingTempoBegin,
        varyingTempoStep,
        setVaryingTempoEnd,
        onChangeTempo
    ]);
    var handleChangeVaryingTempoStep = (0, $8SyCD.useCallback)(function(step) {
        if (step) {
            onChangeTempo({
                type: "varying",
                begin: varyingTempoBegin,
                end: varyingTempoEnd,
                step: step
            });
            setVaryingTempoStep(step);
        }
    }, [
        varyingTempoBegin,
        varyingTempoEnd,
        setVaryingTempoStep,
        onChangeTempo
    ]);
    var handleChangeType = (0, $8SyCD.useCallback)(function(value) {
        if (value === "uniform") onChangeTempo({
            type: value,
            speed: uniformTempoSpeed
        });
        else onChangeTempo({
            type: value,
            begin: varyingTempoBegin,
            end: varyingTempoEnd,
            step: varyingTempoStep
        });
    }, [
        uniformTempoSpeed,
        varyingTempoBegin,
        varyingTempoEnd,
        varyingTempoStep,
        onChangeTempo
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $666b43abc2af1493$export$a7fed597f4b8afd8), {
        autoComplete: "off",
        name: "tempo__settings",
        className: "tempo__settings",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                name: "".concat(id, "-type"),
                label: "type",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $5a3a55b7970e77bf$export$2e2bcd8739ae039), {
                    id: "".concat(id, "-type"),
                    value: tempo.type,
                    options: [
                        {
                            value: "uniform",
                            label: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                id: "uniform",
                                children: "Uniform"
                            })
                        },
                        {
                            value: "varying",
                            label: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                id: "varying",
                                children: "Varying"
                            })
                        }
                    ],
                    onChange: handleChangeType
                })
            }),
            tempo.type === "uniform" ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                name: "".concat(id, "-speed"),
                label: "speed",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                    id: "".concat(id, "-speed"),
                    min: 10,
                    max: 240,
                    step: 10,
                    value: uniformTempoSpeed,
                    onChange: handleChangeUniformTempoSpeed
                })
            }) : /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $666b43abc2af1493$export$c5eaea0d6f8cb6f4), {
                children: [
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                        name: "".concat(id, "-begin"),
                        label: "begin",
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                            id: "".concat(id, "-begin"),
                            min: 10,
                            max: 120,
                            step: 10,
                            value: varyingTempoBegin,
                            onChange: handleChangeVaryingTempoBegin
                        })
                    }),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                        name: "".concat(id, "-end"),
                        label: "end",
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                            id: "".concat(id, "-end"),
                            min: 10,
                            max: 240,
                            step: 10,
                            value: varyingTempoEnd,
                            onChange: handleChangeVaryingTempoEnd
                        })
                    }),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                        name: "".concat(id, "-step"),
                        label: "step",
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                            id: "".concat(id, "-step"),
                            min: 10,
                            max: 120,
                            step: 10,
                            value: varyingTempoStep,
                            onChange: handleChangeVaryingTempoStep
                        })
                    })
                ]
            })
        ]
    });
}





var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");
var $8c3a4b2fdf2718a7$export$f4d11df7cce852e7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext({
    editable: true,
    currMeasureIndex: -1,
    currMeasureOffset: -1,
    currBeatIndex: -1,
    currNoteIndex: -1
});
function $8c3a4b2fdf2718a7$export$17213b71fcdfcc99(props) {
    var children = props.children, rest = (0, $5d5a26e68236d453$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)($8c3a4b2fdf2718a7$export$f4d11df7cce852e7.Provider, {
        value: rest,
        children: children
    });
}
function $8c3a4b2fdf2718a7$export$4c4831df60438b35() {
    return (0, $8SyCD.useContext)($8c3a4b2fdf2718a7$export$f4d11df7cce852e7);
}




var $8SyCD = parcelRequire("8SyCD");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 



var $dc596b22b81a4925$export$be5234c0b764b6e0 = Symbol("Comlink.proxy");
var $dc596b22b81a4925$export$39fb953702b7fcd7 = Symbol("Comlink.endpoint");
var $dc596b22b81a4925$export$89981d4b8d9f48aa = Symbol("Comlink.releaseProxy");
var $dc596b22b81a4925$export$ddc31dfe7c269837 = Symbol("Comlink.finalizer");
var $dc596b22b81a4925$var$throwMarker = Symbol("Comlink.thrown");
var $dc596b22b81a4925$var$isObject = function(val) {
    return typeof val === "object" && val !== null || typeof val === "function";
};
/**
 * Internal transfer handle to handle objects marked to proxy.
 */ var $dc596b22b81a4925$var$proxyTransferHandler = {
    canHandle: function(val) {
        return $dc596b22b81a4925$var$isObject(val) && val[$dc596b22b81a4925$export$be5234c0b764b6e0];
    },
    serialize: function(obj) {
        var _ref = new MessageChannel(), port1 = _ref.port1, port2 = _ref.port2;
        $dc596b22b81a4925$export$9b7f6e342a8cbd38(obj, port1);
        return [
            port2,
            [
                port2
            ]
        ];
    },
    deserialize: function(port) {
        port.start();
        return $dc596b22b81a4925$export$4997ffc0176396a6(port);
    }
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */ var $dc596b22b81a4925$var$throwTransferHandler = {
    canHandle: function(value) {
        return $dc596b22b81a4925$var$isObject(value) && $dc596b22b81a4925$var$throwMarker in value;
    },
    serialize: function(param) {
        var value = param.value;
        var serialized;
        if (value instanceof Error) serialized = {
            isError: true,
            value: {
                message: value.message,
                name: value.name,
                stack: value.stack
            }
        };
        else serialized = {
            isError: false,
            value: value
        };
        return [
            serialized,
            []
        ];
    },
    deserialize: function(serialized) {
        if (serialized.isError) throw Object.assign(new Error(serialized.value.message), serialized.value);
        throw serialized.value;
    }
};
/**
 * Allows customizing the serialization of certain values.
 */ var $dc596b22b81a4925$export$ab8f1c00731ee83e = new Map([
    [
        "proxy",
        $dc596b22b81a4925$var$proxyTransferHandler
    ],
    [
        "throw",
        $dc596b22b81a4925$var$throwTransferHandler
    ]
]);
function $dc596b22b81a4925$var$isAllowedOrigin(allowedOrigins, origin) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allowedOrigins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var allowedOrigin = _step.value;
            if (origin === allowedOrigin || allowedOrigin === "*") return true;
            if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $dc596b22b81a4925$export$9b7f6e342a8cbd38(obj) {
    var ep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis, allowedOrigins = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        "*"
    ];
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) return;
        if (!$dc596b22b81a4925$var$isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn("Invalid origin '".concat(ev.origin, "' for comlink proxy"));
            return;
        }
        var _Object_assign = Object.assign({
            path: []
        }, ev.data), id = _Object_assign.id, type = _Object_assign.type, path = _Object_assign.path;
        var argumentList = (ev.data.argumentList || []).map($dc596b22b81a4925$var$fromWireValue);
        var returnValue;
        try {
            var parent = path.slice(0, -1).reduce(function(obj, prop) {
                return obj[prop];
            }, obj);
            var rawValue = path.reduce(function(obj, prop) {
                return obj[prop];
            }, obj);
            switch(type){
                case "GET" /* MessageType.GET */ :
                    returnValue = rawValue;
                    break;
                case "SET" /* MessageType.SET */ :
                    parent[path.slice(-1)[0]] = $dc596b22b81a4925$var$fromWireValue(ev.data.value);
                    returnValue = true;
                    break;
                case "APPLY" /* MessageType.APPLY */ :
                    returnValue = rawValue.apply(parent, argumentList);
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */ :
                    {
                        var _$value = (0, $974c98494df55f11$export$2d841144c5f8c4ab)(rawValue, (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(argumentList));
                        returnValue = $dc596b22b81a4925$export$923f96dd5afa9ce6(_$value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */ :
                    {
                        var _ref = new MessageChannel(), port1 = _ref.port1, port2 = _ref.port2;
                        $dc596b22b81a4925$export$9b7f6e342a8cbd38(obj, port2);
                        returnValue = $dc596b22b81a4925$export$c9b234447cf4ef7c(port1, [
                            port1
                        ]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */ :
                    returnValue = undefined;
                    break;
                default:
                    return;
            }
        } catch (value) {
            returnValue = (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                value: value
            }, $dc596b22b81a4925$var$throwMarker, 0);
        }
        Promise.resolve(returnValue)["catch"](function(value) {
            return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                value: value
            }, $dc596b22b81a4925$var$throwMarker, 0);
        }).then(function(returnValue) {
            var _toWireValue = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($dc596b22b81a4925$var$toWireValue(returnValue), 2), wireValue = _toWireValue[0], transferables = _toWireValue[1];
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */ ) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                $dc596b22b81a4925$var$closeEndPoint(ep);
                if ($dc596b22b81a4925$export$ddc31dfe7c269837 in obj && typeof obj[$dc596b22b81a4925$export$ddc31dfe7c269837] === "function") obj[$dc596b22b81a4925$export$ddc31dfe7c269837]();
            }
        })["catch"](function(error) {
            // Send Serialization Error To Caller
            var _toWireValue = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($dc596b22b81a4925$var$toWireValue((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
                value: new TypeError("Unserializable return value")
            }, $dc596b22b81a4925$var$throwMarker, 0)), 2), wireValue = _toWireValue[0], transferables = _toWireValue[1];
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
        });
    });
    if (ep.start) ep.start();
}
function $dc596b22b81a4925$var$isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function $dc596b22b81a4925$var$closeEndPoint(endpoint) {
    if ($dc596b22b81a4925$var$isMessagePort(endpoint)) endpoint.close();
}
function $dc596b22b81a4925$export$4997ffc0176396a6(ep, target) {
    return $dc596b22b81a4925$var$createProxy(ep, [], target);
}
function $dc596b22b81a4925$var$throwIfProxyReleased(isReleased) {
    if (isReleased) throw new Error("Proxy has been released and is not useable");
}
function $dc596b22b81a4925$var$releaseEndpoint(ep) {
    return $dc596b22b81a4925$var$requestResponseMessage(ep, {
        type: "RELEASE" /* MessageType.RELEASE */ 
    }).then(function() {
        $dc596b22b81a4925$var$closeEndPoint(ep);
    });
}
var $dc596b22b81a4925$var$proxyCounter = new WeakMap();
var $dc596b22b81a4925$var$proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry(function(ep) {
    var newCount = ($dc596b22b81a4925$var$proxyCounter.get(ep) || 0) - 1;
    $dc596b22b81a4925$var$proxyCounter.set(ep, newCount);
    if (newCount === 0) $dc596b22b81a4925$var$releaseEndpoint(ep);
});
function $dc596b22b81a4925$var$registerProxy(proxy, ep) {
    var newCount = ($dc596b22b81a4925$var$proxyCounter.get(ep) || 0) + 1;
    $dc596b22b81a4925$var$proxyCounter.set(ep, newCount);
    if ($dc596b22b81a4925$var$proxyFinalizers) $dc596b22b81a4925$var$proxyFinalizers.register(proxy, ep, proxy);
}
function $dc596b22b81a4925$var$unregisterProxy(proxy) {
    if ($dc596b22b81a4925$var$proxyFinalizers) $dc596b22b81a4925$var$proxyFinalizers.unregister(proxy);
}
function $dc596b22b81a4925$var$createProxy(ep) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    var isProxyReleased = false;
    var proxy = new Proxy(target, {
        get: function(_target, prop) {
            $dc596b22b81a4925$var$throwIfProxyReleased(isProxyReleased);
            if (prop === $dc596b22b81a4925$export$89981d4b8d9f48aa) return function() {
                $dc596b22b81a4925$var$unregisterProxy(proxy);
                $dc596b22b81a4925$var$releaseEndpoint(ep);
                isProxyReleased = true;
            };
            if (prop === "then") {
                if (path.length === 0) return {
                    then: function() {
                        return proxy;
                    }
                };
                var r = $dc596b22b81a4925$var$requestResponseMessage(ep, {
                    type: "GET" /* MessageType.GET */ ,
                    path: path.map(function(p) {
                        return p.toString();
                    })
                }).then($dc596b22b81a4925$var$fromWireValue);
                return r.then.bind(r);
            }
            return $dc596b22b81a4925$var$createProxy(ep, (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(path).concat([
                prop
            ]));
        },
        set: function(_target, prop, rawValue) {
            $dc596b22b81a4925$var$throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            var _toWireValue = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($dc596b22b81a4925$var$toWireValue(rawValue), 2), value = _toWireValue[0], transferables = _toWireValue[1];
            return $dc596b22b81a4925$var$requestResponseMessage(ep, {
                type: "SET" /* MessageType.SET */ ,
                path: (0, $24d5e0e98ab2c79e$export$1b5e630bc3aea29f)(path).concat([
                    prop
                ]).map(function(p) {
                    return p.toString();
                }),
                value: value
            }, transferables).then($dc596b22b81a4925$var$fromWireValue);
        },
        apply: function(_target, _thisArg, rawArgumentList) {
            $dc596b22b81a4925$var$throwIfProxyReleased(isProxyReleased);
            var last = path[path.length - 1];
            if (last === $dc596b22b81a4925$export$39fb953702b7fcd7) return $dc596b22b81a4925$var$requestResponseMessage(ep, {
                type: "ENDPOINT" /* MessageType.ENDPOINT */ 
            }).then($dc596b22b81a4925$var$fromWireValue);
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") return $dc596b22b81a4925$var$createProxy(ep, path.slice(0, -1));
            var _processArguments = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($dc596b22b81a4925$var$processArguments(rawArgumentList), 2), argumentList = _processArguments[0], transferables = _processArguments[1];
            return $dc596b22b81a4925$var$requestResponseMessage(ep, {
                type: "APPLY" /* MessageType.APPLY */ ,
                path: path.map(function(p) {
                    return p.toString();
                }),
                argumentList: argumentList
            }, transferables).then($dc596b22b81a4925$var$fromWireValue);
        },
        construct: function(_target, rawArgumentList) {
            $dc596b22b81a4925$var$throwIfProxyReleased(isProxyReleased);
            var _processArguments = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($dc596b22b81a4925$var$processArguments(rawArgumentList), 2), argumentList = _processArguments[0], transferables = _processArguments[1];
            return $dc596b22b81a4925$var$requestResponseMessage(ep, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */ ,
                path: path.map(function(p) {
                    return p.toString();
                }),
                argumentList: argumentList
            }, transferables).then($dc596b22b81a4925$var$fromWireValue);
        }
    });
    $dc596b22b81a4925$var$registerProxy(proxy, ep);
    return proxy;
}
function $dc596b22b81a4925$var$myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function $dc596b22b81a4925$var$processArguments(argumentList) {
    var processed = argumentList.map($dc596b22b81a4925$var$toWireValue);
    return [
        processed.map(function(v) {
            return v[0];
        }),
        $dc596b22b81a4925$var$myFlat(processed.map(function(v) {
            return v[1];
        }))
    ];
}
var $dc596b22b81a4925$var$transferCache = new WeakMap();
function $dc596b22b81a4925$export$c9b234447cf4ef7c(obj, transfers) {
    $dc596b22b81a4925$var$transferCache.set(obj, transfers);
    return obj;
}
function $dc596b22b81a4925$export$923f96dd5afa9ce6(obj) {
    return Object.assign(obj, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, $dc596b22b81a4925$export$be5234c0b764b6e0, true));
}
function $dc596b22b81a4925$export$f2c03fb5a6c19546(w) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis, targetOrigin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "*";
    return {
        postMessage: function(msg, transferables) {
            return w.postMessage(msg, targetOrigin, transferables);
        },
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context)
    };
}
function $dc596b22b81a4925$var$toWireValue(value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $dc596b22b81a4925$export$ab8f1c00731ee83e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], handler = _step_value[1];
            if (handler.canHandle(value)) {
                var _handler_serialize = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(handler.serialize(value), 2), serializedValue = _handler_serialize[0], transferables = _handler_serialize[1];
                return [
                    {
                        type: "HANDLER" /* WireValueType.HANDLER */ ,
                        name: name,
                        value: serializedValue
                    },
                    transferables
                ];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */ ,
            value: value
        },
        $dc596b22b81a4925$var$transferCache.get(value) || []
    ];
}
function $dc596b22b81a4925$var$fromWireValue(value) {
    switch(value.type){
        case "HANDLER" /* WireValueType.HANDLER */ :
            return $dc596b22b81a4925$export$ab8f1c00731ee83e.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */ :
            return value.value;
    }
}
function $dc596b22b81a4925$var$requestResponseMessage(ep, msg, transfers) {
    return new Promise(function(resolve) {
        var id = $dc596b22b81a4925$var$generateUUID();
        ep.addEventListener("message", function l(ev) {
            if (!ev.data || !ev.data.id || ev.data.id !== id) return;
            ep.removeEventListener("message", l);
            resolve(ev.data);
        });
        if (ep.start) ep.start();
        ep.postMessage(Object.assign({
            id: id
        }, msg), transfers);
    });
}
function $dc596b22b81a4925$var$generateUUID() {
    return new Array(4).fill(0).map(function() {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16);
    }).join("-");
}


var $28347951f6c8bfeb$exports = {};
var $a89b6923030646f9$exports = {};
"use strict";
$a89b6923030646f9$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



var $hKR6R = parcelRequire("hKR6R");
var $28347951f6c8bfeb$var$url = $hKR6R.getBundleURL("kXHk2") + "ticker.7b56a5df.js";
$28347951f6c8bfeb$exports = $a89b6923030646f9$exports($28347951f6c8bfeb$var$url, $hKR6R.getOrigin($28347951f6c8bfeb$var$url), false);


function $2c92663773d045e0$export$3e54be1074f8e0cb() {
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(function() {
        var worker = new Worker($28347951f6c8bfeb$exports);
        return $dc596b22b81a4925$export$4997ffc0176396a6(worker);
    }), 1), worker = _useState[0];
    return worker;
}




var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
var $6cea99cbdd667b82$export$25289944de7a55e4 = /*#__PURE__*/ (0, $8SyCD.createContext)(undefined);



parcelRequire("8SyCD");

function $baf773ef6c515b96$export$c845e54474df320e(props) {
    var children = props.children, audioContext = props.audioContext;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6cea99cbdd667b82$export$25289944de7a55e4).Provider, {
        value: {
            audioContext: audioContext
        },
        children: children
    });
}




var $8SyCD = parcelRequire("8SyCD");
function $2c9a6289909a7048$export$983b9b54330812cb(initial) {
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(initial), 2), flag = _useState[0], setFlag = _useState[1];
    var turnOn = (0, $8SyCD.useCallback)(function() {
        setFlag(true);
    }, [
        setFlag
    ]);
    var turnOff = (0, $8SyCD.useCallback)(function() {
        setFlag(false);
    }, [
        setFlag
    ]);
    var toggle = (0, $8SyCD.useCallback)(function() {
        setFlag(function(flag) {
            return !flag;
        });
    }, [
        setFlag
    ]);
    return {
        flag: flag,
        turnOn: turnOn,
        turnOff: turnOff,
        toggle: toggle
    };
}




var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");

function $44d27c03f7b7c509$export$d4eec936f80d194a() {
    var context = (0, $8SyCD.useContext)((0, $6cea99cbdd667b82$export$25289944de7a55e4));
    if (!context) throw new Error("audio context is not initialized");
    return context;
}


function $090cd79bb8ac5bb9$export$1e3093a342a0b32b(options) {
    var isRunning = options.isRunning;
    var audioContext = (0, $44d27c03f7b7c509$export$d4eec936f80d194a)().audioContext;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(), 2), note = _useState[0], setNote = _useState[1];
    (0, $8SyCD.useEffect)(function() {
        var init = function init() {
            var mediaStream = null;
            var stream = null;
            var analyser = null;
            var animationHandle = null;
            var ignored = false;
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: false
            }).then(function(_mediaStream) {
                if (ignored) return;
                mediaStream = _mediaStream;
                analyser = audioContext.createAnalyser();
                stream = audioContext.createMediaStreamSource(mediaStream);
                stream.connect(analyser);
                analyser.fftSize = 2048;
                var bufferLength = analyser.frequencyBinCount;
                var dataArray = new Float32Array(bufferLength);
                var update = function() {
                    if (ignored) return;
                    if (analyser) {
                        animationHandle = requestAnimationFrame(update);
                        analyser.getFloatTimeDomainData(dataArray);
                        var frequency = (0, $92577b47e3b00856$export$ee00045eeaf37fbc)(dataArray, audioContext.sampleRate);
                        var note = undefined;
                        if (frequency !== -1) note = (0, $92577b47e3b00856$export$6f9f24d921645b42)(frequency, (0, $c9378659b665be93$export$df409b90d2c1a310).Accent);
                        setNote(note);
                    }
                };
                update();
            });
            return function() {
                ignored = true;
                if (animationHandle) {
                    cancelAnimationFrame(animationHandle);
                    animationHandle = null;
                }
                if (stream) {
                    stream.disconnect();
                    stream = null;
                }
                if (analyser) {
                    analyser.disconnect();
                    analyser = null;
                }
                if (mediaStream) {
                    mediaStream.getTracks().forEach(function(track) {
                        track.stop();
                    });
                    mediaStream = null;
                }
            };
        };
        if (isRunning) return init();
    }, [
        isRunning,
        audioContext,
        setNote
    ]);
    return {
        note: note
    };
}



function $7a779d4c9bd79108$export$218c8c3169c024d2() {
    var option = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var prefix = option.prefix;
    var parts = [
        String(Date.now()),
        String(Math.floor(Math.random() * 10000))
    ];
    if (prefix) parts.splice(0, 0, prefix);
    return parts.join(".");
}






var $240623ab8e082e71$var$_obj;
var $240623ab8e082e71$export$83d3b6b868445bfd = ($240623ab8e082e71$var$_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)($240623ab8e082e71$var$_obj, (0, $c9378659b665be93$export$df409b90d2c1a310).Accent, 0.75), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)($240623ab8e082e71$var$_obj, (0, $c9378659b665be93$export$df409b90d2c1a310).Light, 1), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)($240623ab8e082e71$var$_obj, (0, $c9378659b665be93$export$df409b90d2c1a310).None, 0), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)($240623ab8e082e71$var$_obj, (0, $c9378659b665be93$export$df409b90d2c1a310).Invalid, 0), $240623ab8e082e71$var$_obj);
function $240623ab8e082e71$export$53c770026d57c5b8(audioContext, time, note) {
    var osc = audioContext.createOscillator();
    osc.frequency.value = (0, $92577b47e3b00856$export$7dbade755bbd7df5);
    var envelope = audioContext.createGain();
    envelope.gain.value = $240623ab8e082e71$export$83d3b6b868445bfd[note.dynamics];
    envelope.gain.exponentialRampToValueAtTime(1, time);
    envelope.gain.exponentialRampToValueAtTime(0.000001, time + 0.03);
    osc.connect(envelope);
    envelope.connect(audioContext.destination);
    osc.start(time);
    osc.stop(time + 0.03);
}
function $240623ab8e082e71$export$87fabe7426cc95cb(audioContext, rhythm, startTime, beatInterval) {
    return $240623ab8e082e71$export$6e14fdd1b00e53fe(audioContext, rhythm, startTime, 0, 0, 0, beatInterval);
}
function $240623ab8e082e71$export$6e14fdd1b00e53fe(audioContext, rhythm, startTime, measureIndex, beatIndex, beatOffset, beatInterval) {
    var measure = rhythm.measures[measureIndex];
    if (!measure) return;
    var beat = measure.beats[beatIndex];
    if (!beat) return;
    var beatStartTime = startTime + beatInterval * beatOffset;
    var noteInterval = beatInterval / beat.notes.length;
    for(var i = 0; i < beat.notes.length; i++){
        var note = beat.notes[i];
        var time = beatStartTime + noteInterval * i;
        $240623ab8e082e71$export$53c770026d57c5b8(audioContext, time, note);
    }
}


function $1c5dfe08420c4b4e$export$591b115bf5c6fe80(props) {
    var audioContext = props.audioContext, worker = props.worker, isRunning = props.isRunning, rhythm = props.rhythm, beatsCount = props.beatsCount, notesCount = props.notesCount, ticksCount = props.ticksCount, preparatoryTime = props.preparatoryTime, beginTime = props.beginTime, ticksPerBeat = props.ticksPerBeat, tempo = props.tempo, onTempoPrepare = props.onTempoPrepare, onTempoStart = props.onTempoStart, onTempoTick = props.onTempoTick, onTempoEnd = props.onTempoEnd;
    var onTempoPrepareRef = (0, $8SyCD.useRef)(onTempoPrepare);
    onTempoPrepareRef.current = onTempoPrepare;
    var onTempoStartRef = (0, $8SyCD.useRef)(onTempoStart);
    onTempoStartRef.current = onTempoStart;
    var onTempoTickRef = (0, $8SyCD.useRef)(onTempoTick);
    onTempoTickRef.current = onTempoTick;
    var onTempoEndRef = (0, $8SyCD.useRef)(onTempoEnd);
    onTempoEndRef.current = onTempoEnd;
    (0, $8SyCD.useEffect)(function() {
        if (isRunning && rhythm && tempo) {
            var id = "Tick.".concat((0, $7a779d4c9bd79108$export$218c8c3169c024d2)());
            var task = {
                id: id,
                rhythm: rhythm,
                preparatoryTime: preparatoryTime,
                beginTime: beginTime,
                tempo: tempo,
                ticksCount: ticksCount,
                ticksPerBeat: ticksPerBeat
            };
            var beatInterval = (0, $3a38d9f63feceb53$export$9245831f62081b68) / tempo.speed;
            var startTime = audioContext.currentTime + beginTime / 1000;
            var handleTick = $dc596b22b81a4925$export$923f96dd5afa9ce6(function(event, task) {
                switch(event.type){
                    case "preparatory":
                        var _onTempoPrepareRef_current;
                        (0, $240623ab8e082e71$export$87fabe7426cc95cb)(audioContext, rhythm, startTime, beatInterval / 1000);
                        (_onTempoPrepareRef_current = onTempoPrepareRef.current) === null || _onTempoPrepareRef_current === void 0 ? void 0 : _onTempoPrepareRef_current.call(onTempoPrepareRef, tempo);
                        break;
                    case "tick":
                        {
                            var _onTempoStartRef_current, _onTempoTickRef_current;
                            var tick = event.tick;
                            if (tick.measureOffset === 0 && tick.beatIndex === 0 && tick.noteIndex === 0) (_onTempoStartRef_current = onTempoStartRef.current) === null || _onTempoStartRef_current === void 0 ? void 0 : _onTempoStartRef_current.call(onTempoStartRef, tempo);
                            if (tick.noteIndex === 0) {
                                var location = (0, $e7d0c89ead4e7b91$export$58aa5c5c19a2f2cb)(rhythm, tick.measureIndex, tick.measureOffset, tick.beatIndex, tick.beatOffset);
                                if (location) (0, $240623ab8e082e71$export$6e14fdd1b00e53fe)(audioContext, rhythm, startTime, location.measureIndex, location.beatIndex, location.beatOffset, beatInterval / 1000);
                            }
                            (_onTempoTickRef_current = onTempoTickRef.current) === null || _onTempoTickRef_current === void 0 ? void 0 : _onTempoTickRef_current.call(onTempoTickRef, tick, tempo);
                            if (tick.beatOffset === beatsCount - 1 && tick.noteOffset === notesCount - 1) {
                                var _onTempoEndRef_current;
                                (_onTempoEndRef_current = onTempoEndRef.current) === null || _onTempoEndRef_current === void 0 ? void 0 : _onTempoEndRef_current.call(onTempoEndRef, tempo);
                                worker.stopTask(task);
                            }
                        }
                        break;
                }
            });
            worker.startTask(task, handleTick);
            return function() {
                worker.stopTask(task);
            };
        }
    }, [
        audioContext,
        worker,
        isRunning,
        rhythm,
        preparatoryTime,
        beginTime,
        tempo,
        beatsCount,
        notesCount,
        ticksCount,
        ticksPerBeat
    ]);
    return null;
}



function $6cd6357e72a6c21d$export$16de697746054156(props) {
    var rhythm = props.rhythm, isRunning = props.isRunning, onEnd = props.onEnd, children = props.children;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(-1), 2), currMeasureIndex = _useState[0], setCurrMeasureIndex = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(-1), 2), currMeasureOffset = _useState1[0], setCurrMeasureOffset = _useState1[1];
    var _useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(-1), 2), currBeatIndex = _useState2[0], setCurrBeatIndex = _useState2[1];
    var _useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(-1), 2), currNoteIndex = _useState3[0], setCurrNoteIndex = _useState3[1];
    var audioContext = (0, $44d27c03f7b7c509$export$d4eec936f80d194a)().audioContext;
    var worker = (0, $2c92663773d045e0$export$3e54be1074f8e0cb)();
    var _useMemo = (0, $8SyCD.useMemo)(function() {
        return (0, $e7d0c89ead4e7b91$export$1e3c6a5020ae960f)(rhythm);
    }, [
        rhythm
    ]), beatsCount = _useMemo.beatsCount, notesCount = _useMemo.notesCount, ticksCount = _useMemo.ticksCount, ticksPerBeat = _useMemo.ticksPerBeat, tempos = _useMemo.tempos;
    var tickers = (0, $8SyCD.useMemo)(function() {
        if (tempos.length === 0) return [];
        var beginTime = rhythm.preparatoryBeats * ((0, $3a38d9f63feceb53$export$9245831f62081b68) / tempos[0].speed);
        return tempos.map(function(tempo) {
            var preparatoryTime = beginTime - rhythm.preparatoryBeats * ((0, $3a38d9f63feceb53$export$9245831f62081b68) / tempo.speed);
            var ticker = {
                tempo: tempo,
                preparatoryTime: preparatoryTime,
                beginTime: beginTime
            };
            beginTime = beginTime + beatsCount * ((0, $3a38d9f63feceb53$export$9245831f62081b68) / tempo.speed);
            return ticker;
        });
    }, [
        rhythm.preparatoryBeats,
        tempos,
        beatsCount,
        notesCount,
        ticksPerBeat
    ]);
    var handleTempoTempoTick = (0, $8SyCD.useCallback)(function(tick, tempo) {
        setCurrMeasureIndex(tick.measureIndex);
        setCurrMeasureOffset(tick.measureOffset);
        setCurrBeatIndex(tick.beatIndex);
        setCurrNoteIndex(tick.noteIndex);
    }, [
        rhythm,
        ticksPerBeat,
        setCurrMeasureIndex,
        setCurrMeasureOffset,
        setCurrBeatIndex,
        setCurrNoteIndex
    ]);
    var handleTempoEnd = (0, $8SyCD.useCallback)(function(tempo) {
        if (tempos[tempos.length - 1] === tempo) onEnd();
    }, [
        tempos,
        setCurrMeasureIndex,
        setCurrMeasureOffset,
        setCurrBeatIndex,
        setCurrNoteIndex,
        onEnd
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $8c3a4b2fdf2718a7$export$17213b71fcdfcc99), {
        editable: !isRunning,
        currMeasureIndex: currMeasureIndex,
        currMeasureOffset: currMeasureOffset,
        currBeatIndex: currBeatIndex,
        currNoteIndex: currNoteIndex,
        children: [
            tickers.map(function(ticker, index) {
                return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $1c5dfe08420c4b4e$export$591b115bf5c6fe80), {
                    audioContext: audioContext,
                    worker: worker,
                    isRunning: isRunning,
                    rhythm: rhythm,
                    tempo: ticker.tempo,
                    preparatoryTime: ticker.preparatoryTime,
                    beginTime: ticker.beginTime,
                    ticksPerBeat: ticksPerBeat,
                    beatsCount: beatsCount,
                    notesCount: notesCount,
                    ticksCount: ticksCount,
                    onTempoTick: handleTempoTempoTick,
                    onTempoEnd: handleTempoEnd
                }, index);
            }),
            children
        ]
    });
}



parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");


function $64f282d705d00642$export$f5153c3888a6824e(size) {
    return [
        "small",
        "middle",
        "large"
    ].includes(size);
}
function $64f282d705d00642$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === "number" && !Number.isNaN(size);
}






var $69ca49f42a4a37b5$export$6773a72e15c6c21d = [
    "wrap",
    "nowrap",
    "wrap-reverse"
];
var $69ca49f42a4a37b5$export$fc1ed670ad7f670d = [
    "flex-start",
    "flex-end",
    "start",
    "end",
    "center",
    "space-between",
    "space-around",
    "space-evenly",
    "stretch",
    "normal",
    "left",
    "right"
];
var $69ca49f42a4a37b5$export$4a0bd4174fc92cb3 = [
    "center",
    "start",
    "end",
    "flex-start",
    "flex-end",
    "self-start",
    "self-end",
    "baseline",
    "normal",
    "stretch"
];
var $69ca49f42a4a37b5$var$genClsWrap = function(prefixCls, props) {
    var wrapCls = {};
    $69ca49f42a4a37b5$export$6773a72e15c6c21d.forEach(function(cssKey) {
        wrapCls["".concat(prefixCls, "-wrap-").concat(cssKey)] = props.wrap === cssKey;
    });
    return wrapCls;
};
var $69ca49f42a4a37b5$var$genClsAlign = function(prefixCls, props) {
    var alignCls = {};
    $69ca49f42a4a37b5$export$4a0bd4174fc92cb3.forEach(function(cssKey) {
        alignCls["".concat(prefixCls, "-align-").concat(cssKey)] = props.align === cssKey;
    });
    alignCls["".concat(prefixCls, "-align-stretch")] = !props.align && !!props.vertical;
    return alignCls;
};
var $69ca49f42a4a37b5$var$genClsJustify = function(prefixCls, props) {
    var justifyCls = {};
    $69ca49f42a4a37b5$export$fc1ed670ad7f670d.forEach(function(cssKey) {
        justifyCls["".concat(prefixCls, "-justify-").concat(cssKey)] = props.justify === cssKey;
    });
    return justifyCls;
};
function $69ca49f42a4a37b5$var$createFlexClassNames(prefixCls, props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(Object.assign(Object.assign(Object.assign({}, $69ca49f42a4a37b5$var$genClsWrap(prefixCls, props)), $69ca49f42a4a37b5$var$genClsAlign(prefixCls, props)), $69ca49f42a4a37b5$var$genClsJustify(prefixCls, props)));
}
var $69ca49f42a4a37b5$export$2e2bcd8739ae039 = $69ca49f42a4a37b5$var$createFlexClassNames;


var $149d1f684fd9c20c$var$genFlexStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        display: "flex",
        "&-vertical": {
            flexDirection: "column"
        },
        "&-rtl": {
            direction: "rtl"
        },
        "&:empty": {
            display: "none"
        }
    });
};
var $149d1f684fd9c20c$var$genFlexGapStyle = function(token) {
    var componentCls = token.componentCls;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
        "&-gap-small": {
            gap: token.flexGapSM
        },
        "&-gap-middle": {
            gap: token.flexGap
        },
        "&-gap-large": {
            gap: token.flexGapLG
        }
    });
};
var $149d1f684fd9c20c$var$genFlexWrapStyle = function(token) {
    var componentCls = token.componentCls;
    var wrapStyle = {};
    (0, $69ca49f42a4a37b5$export$6773a72e15c6c21d).forEach(function(value) {
        wrapStyle["".concat(componentCls, "-wrap-").concat(value)] = {
            flexWrap: value
        };
    });
    return wrapStyle;
};
var $149d1f684fd9c20c$var$genAlignItemsStyle = function(token) {
    var componentCls = token.componentCls;
    var alignStyle = {};
    (0, $69ca49f42a4a37b5$export$4a0bd4174fc92cb3).forEach(function(value) {
        alignStyle["".concat(componentCls, "-align-").concat(value)] = {
            alignItems: value
        };
    });
    return alignStyle;
};
var $149d1f684fd9c20c$var$genJustifyContentStyle = function(token) {
    var componentCls = token.componentCls;
    var justifyStyle = {};
    (0, $69ca49f42a4a37b5$export$fc1ed670ad7f670d).forEach(function(value) {
        justifyStyle["".concat(componentCls, "-justify-").concat(value)] = {
            justifyContent: value
        };
    });
    return justifyStyle;
};
var $149d1f684fd9c20c$export$9ca1be8807fe0675 = function() {
    return {};
};
var $149d1f684fd9c20c$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Flex", function(token) {
    var paddingXS = token.paddingXS, padding = token.padding, paddingLG = token.paddingLG;
    var flexToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        flexGapSM: paddingXS,
        flexGap: padding,
        flexGapLG: paddingLG
    });
    return [
        $149d1f684fd9c20c$var$genFlexStyle(flexToken),
        $149d1f684fd9c20c$var$genFlexGapStyle(flexToken),
        $149d1f684fd9c20c$var$genFlexWrapStyle(flexToken),
        $149d1f684fd9c20c$var$genAlignItemsStyle(flexToken),
        $149d1f684fd9c20c$var$genJustifyContentStyle(flexToken)
    ];
}, $149d1f684fd9c20c$export$9ca1be8807fe0675);



"use client";
var $58daee52af5fd182$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $58daee52af5fd182$var$Flex = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, rootClassName = props.rootClassName, className = props.className, style = props.style, flex = props.flex, gap = props.gap, children = props.children, _props_vertical = props.vertical, vertical = _props_vertical === void 0 ? false : _props_vertical, tmp = props.component, Component = tmp === void 0 ? "div" : tmp, othersProps = $58daee52af5fd182$var$__rest(props, [
        "prefixCls",
        "rootClassName",
        "className",
        "style",
        "flex",
        "gap",
        "children",
        "vertical",
        "component"
    ]);
    var _React_useContext = (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), ctxFlex = _React_useContext.flex, ctxDirection = _React_useContext.direction, getPrefixCls = _React_useContext.getPrefixCls;
    var prefixCls = getPrefixCls("flex", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $149d1f684fd9c20c$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var mergedVertical = vertical !== null && vertical !== void 0 ? vertical : ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.vertical;
    var _obj;
    var mergedCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(className, rootClassName, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.className, prefixCls, hashId, (0, $69ca49f42a4a37b5$export$2e2bcd8739ae039)(prefixCls, props), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), ctxDirection === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-gap-").concat(gap), (0, $64f282d705d00642$export$f5153c3888a6824e)(gap)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-vertical"), mergedVertical), _obj));
    var mergedStyle = Object.assign(Object.assign({}, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.style), style);
    if (flex) mergedStyle.flex = flex;
    if (gap && !(0, $64f282d705d00642$export$f5153c3888a6824e)(gap)) mergedStyle.gap = gap;
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createElement(Component, Object.assign({
        ref: ref,
        className: mergedCls,
        style: mergedStyle
    }, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(othersProps, [
        "justify",
        "wrap",
        "align"
    ])), children));
});
var $58daee52af5fd182$export$2e2bcd8739ae039 = $58daee52af5fd182$var$Flex;





var $8SyCD = parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $1900276e8b8ee6d7$var$MinusOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    name: "minus",
    theme: "outlined"
};
var $1900276e8b8ee6d7$export$2e2bcd8739ae039 = $1900276e8b8ee6d7$var$MinusOutlined;



var $b1720600650feceb$var$MinusOutlined = function MinusOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1900276e8b8ee6d7$export$2e2bcd8739ae039)
    }));
};
var $b1720600650feceb$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($b1720600650feceb$var$MinusOutlined);






var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $a9623747345a3b75$var$AudioFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            }
        ]
    },
    name: "audio",
    theme: "filled"
};
var $a9623747345a3b75$export$2e2bcd8739ae039 = $a9623747345a3b75$var$AudioFilled;



var $ab9a78851b4012d4$var$AudioFilled = function AudioFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $a9623747345a3b75$export$2e2bcd8739ae039)
    }));
};
var $ab9a78851b4012d4$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($ab9a78851b4012d4$var$AudioFilled);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $7b224e532c10649a$var$AudioMutedOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "defs",
                attrs: {},
                children: [
                    {
                        tag: "style",
                        attrs: {}
                    }
                ]
            },
            {
                tag: "path",
                attrs: {
                    d: "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    },
    name: "audio-muted",
    theme: "outlined"
};
var $7b224e532c10649a$export$2e2bcd8739ae039 = $7b224e532c10649a$var$AudioMutedOutlined;



var $4ebb7508c29ad518$var$AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $7b224e532c10649a$export$2e2bcd8739ae039)
    }));
};
var $4ebb7508c29ad518$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($4ebb7508c29ad518$var$AudioMutedOutlined);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $4cf20eb3f0c01cbd$var$AudioOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"
                }
            }
        ]
    },
    name: "audio",
    theme: "outlined"
};
var $4cf20eb3f0c01cbd$export$2e2bcd8739ae039 = $4cf20eb3f0c01cbd$var$AudioOutlined;



var $a99de091e3782250$var$AudioOutlined = function AudioOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4cf20eb3f0c01cbd$export$2e2bcd8739ae039)
    }));
};
var $a99de091e3782250$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($a99de091e3782250$var$AudioOutlined);





function $4a58786983f7451c$export$70371617cfe16c87(props) {
    var index = props.index, note = props.note, isCurrent = props.isCurrent, onClick = props.onClick;
    var handleOnClick = (0, $8SyCD.useCallback)(function() {
        onClick(index);
    }, [
        index,
        onClick
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("note__icon", {
        "note__icon--current": isCurrent
    });
    switch(note.dynamics){
        case (0, $c9378659b665be93$export$df409b90d2c1a310).None:
            return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4ebb7508c29ad518$export$2e2bcd8739ae039), {
                role: "button",
                className: classes,
                onClick: handleOnClick
            });
        case (0, $c9378659b665be93$export$df409b90d2c1a310).Light:
            return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $a99de091e3782250$export$2e2bcd8739ae039), {
                role: "button",
                className: classes,
                onClick: handleOnClick
            });
        case (0, $c9378659b665be93$export$df409b90d2c1a310).Accent:
            return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $ab9a78851b4012d4$export$2e2bcd8739ae039), {
                role: "button",
                className: classes,
                onClick: handleOnClick
            });
        default:
            return null;
    }
}







function $2e19c29934afdc30$export$1741c600f4af5b12(props) {
    var beat = props.beat, measureIndex = props.measureIndex, beatIndex = props.beatIndex, currBeatIndex = props.currBeatIndex, currMeasureIndex = props.currMeasureIndex, currNoteIndex = props.currNoteIndex, onAddNote = props.onAddNote, onChangeNote = props.onChangeNote, onRemoveNote = props.onRemoveNote;
    var handleAddNote = (0, $8SyCD.useCallback)(function() {
        onAddNote(measureIndex, beatIndex);
    }, [
        onAddNote,
        measureIndex,
        beatIndex
    ]);
    var handleRemoveNote = (0, $8SyCD.useCallback)(function() {
        onRemoveNote(measureIndex, beatIndex);
    }, [
        onRemoveNote,
        measureIndex,
        beatIndex
    ]);
    var handleChangeNote = (0, $8SyCD.useCallback)(function(noteIndex) {
        onChangeNote(measureIndex, beatIndex, noteIndex);
    }, [
        onChangeNote,
        measureIndex,
        beatIndex
    ]);
    var editable = (0, $8c3a4b2fdf2718a7$export$4c4831df60438b35)().editable;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "beat",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "remove-note-btn",
                attrs: {
                    title: true
                },
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                    shape: "circle",
                    disabled: !editable,
                    className: "button--oper",
                    title: "Remove Note",
                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $b1720600650feceb$export$2e2bcd8739ae039), {}),
                    onClick: handleRemoveNote
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "notes",
                children: beat.notes.map(function(note, noteIndex) {
                    var isCurrent = measureIndex === currMeasureIndex && beatIndex === currBeatIndex && noteIndex === currNoteIndex;
                    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                        className: "note",
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4a58786983f7451c$export$70371617cfe16c87), {
                            index: noteIndex,
                            isCurrent: isCurrent,
                            note: note,
                            onClick: handleChangeNote
                        })
                    }, noteIndex);
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "add-note-btn",
                attrs: {
                    title: true
                },
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                    shape: "circle",
                    disabled: !editable,
                    className: "button--oper",
                    title: "Add Note",
                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), {}),
                    onClick: handleAddNote
                })
            })
        ]
    }, beatIndex);
}



function $d2f1450a9803f32f$export$b16767175ec99c16(props) {
    var measure = props.measure, measureIndex = props.measureIndex, currMeasureIndex = props.currMeasureIndex, currMeasureOffset = props.currMeasureOffset, currBeatIndex = props.currBeatIndex, currNoteIndex = props.currNoteIndex, onAddBeat = props.onAddBeat, onRemoveBeat = props.onRemoveBeat, onAddNote = props.onAddNote, onChangeNote = props.onChangeNote, onRemoveNote = props.onRemoveNote;
    var handleAddBeat = (0, $8SyCD.useCallback)(function() {
        onAddBeat(measureIndex);
    }, [
        onAddBeat,
        measureIndex
    ]);
    var handleRemoveBeat = (0, $8SyCD.useCallback)(function() {
        onRemoveBeat(measureIndex);
    }, [
        onRemoveBeat,
        measureIndex
    ]);
    var editable = (0, $8c3a4b2fdf2718a7$export$4c4831df60438b35)().editable;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "measure__beats",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "remove-beat-btn",
                attrs: {
                    title: true
                },
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                    shape: "circle",
                    disabled: !editable,
                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $b1720600650feceb$export$2e2bcd8739ae039), {}),
                    onClick: handleRemoveBeat,
                    title: "Remove Beat"
                }, "remove")
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "beats",
                style: {
                    gridTemplateColumns: "repeat(".concat(measure.beats.length, ", 1fr)")
                },
                children: measure.beats.map(function(beat, beatIndex) {
                    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $2e19c29934afdc30$export$1741c600f4af5b12), {
                        beat: beat,
                        measureIndex: measureIndex,
                        beatIndex: beatIndex,
                        currBeatIndex: currBeatIndex,
                        currMeasureIndex: currMeasureIndex,
                        currMeasureOffset: currMeasureOffset,
                        currNoteIndex: currNoteIndex,
                        onAddNote: onAddNote,
                        onChangeNote: onChangeNote,
                        onRemoveNote: onRemoveNote
                    }, beatIndex);
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "add-beat-btn",
                attrs: {
                    title: true
                },
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                    shape: "circle",
                    disabled: !editable,
                    title: "Add Beat",
                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), {}),
                    onClick: handleAddBeat
                }, "add")
            })
        ]
    });
}





var $8SyCD = parcelRequire("8SyCD");



function $e15820c6eb1628f8$export$49473fd9ea651103(props) {
    var measure = props.measure, onChangeRepeat = props.onChangeRepeat;
    var id = (0, $8SyCD.useId)();
    var submit = (0, $8SyCD.useCallback)(function(evt) {
        evt.preventDefault();
    }, [
        onChangeRepeat
    ]);
    var editable = (0, $8c3a4b2fdf2718a7$export$4c4831df60438b35)().editable;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$a7fed597f4b8afd8), {
        autoComplete: "off",
        name: "settings",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
            name: "".concat(id, "-repeat"),
            label: "repeat",
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $52be2c3bc282daba$export$2e2bcd8739ae039), {
                disabled: !editable,
                id: "".concat(id, "-repeat"),
                value: measure.repeat,
                onChange: onChangeRepeat
            })
        })
    });
}



function $86d933b6cc91e0a8$export$11711709bcaf1de4(props) {
    var index = props.index, currBeatIndex = props.currBeatIndex, currMeasureIndex = props.currMeasureIndex, currMeasureOffset = props.currMeasureOffset, currNoteIndex = props.currNoteIndex, measure = props.measure, onRemove = props.onRemove, onChangeRepeat = props.onChangeRepeat, onAddBeat = props.onAddBeat, onRemoveBeat = props.onRemoveBeat, onAddNote = props.onAddNote, onChangeNote = props.onChangeNote, onRemoveNote = props.onRemoveNote;
    var handleChangeRepeat = (0, $8SyCD.useCallback)(function(repeat) {
        if (repeat) onChangeRepeat(index, repeat);
    }, [
        index,
        onChangeRepeat
    ]);
    var handleRemoveMeasure = (0, $8SyCD.useCallback)(function() {
        onRemove(index);
    }, [
        index,
        onRemove
    ]);
    var items = [
        {
            key: "beats",
            label: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "beats",
                children: "Beats"
            }),
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d2f1450a9803f32f$export$b16767175ec99c16), {
                measure: measure,
                measureIndex: index,
                currMeasureIndex: currMeasureIndex,
                currMeasureOffset: currMeasureOffset,
                currBeatIndex: currBeatIndex,
                currNoteIndex: currNoteIndex,
                onAddBeat: onAddBeat,
                onRemoveBeat: onRemoveBeat,
                onAddNote: onAddNote,
                onChangeNote: onChangeNote,
                onRemoveNote: onRemoveNote
            })
        },
        {
            key: "settings",
            label: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "settings",
                children: "Settings"
            }),
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $e15820c6eb1628f8$export$49473fd9ea651103), {
                measure: measure,
                onChangeRepeat: handleChangeRepeat
            })
        }
    ];
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)("beats"), 2), activeViewKey = _useState[0], setActiveViewKey = _useState[1];
    var editable = (0, $8c3a4b2fdf2718a7$export$4c4831df60438b35)().editable;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6179788acd512012$export$2e2bcd8739ae039), {
        className: "measure__viewer",
        title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
            id: "measure-title",
            vars: {
                index: index + 1
            },
            children: "Measure ".concat(index)
        }),
        extra: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
            disabled: !editable,
            danger: true,
            onClick: handleRemoveMeasure,
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                id: "remove-measure",
                children: "Remove Measure"
            })
        }),
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $a78aafd66bcf74e7$export$2e2bcd8739ae039), {
            activeKey: activeViewKey,
            items: items,
            onChange: setActiveViewKey
        })
    });
}



function $a9168fe7c1f927dc$export$e0269c33dd6199d9(props) {
    var rhythm = props.rhythm, onAddMeasure = props.onAddMeasure, onRemoveMeasure = props.onRemoveMeasure, onChangeRepeat = props.onChangeRepeat, onAddBeat = props.onAddBeat, onRemoveBeat = props.onRemoveBeat, onAddNote = props.onAddNote, onChangeNote = props.onChangeNote, onRemoveNote = props.onRemoveNote;
    var _useRhythmContext = (0, $8c3a4b2fdf2718a7$export$4c4831df60438b35)(), editable = _useRhythmContext.editable, currMeasureIndex = _useRhythmContext.currMeasureIndex, currMeasureOffset = _useRhythmContext.currMeasureOffset, currBeatIndex = _useRhythmContext.currBeatIndex, currNoteIndex = _useRhythmContext.currNoteIndex;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "rhythm__viewer",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039), {
                className: "measure__list",
                dataSource: rhythm.measures,
                renderItem: function(measure, index) {
                    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item, {
                        className: "measure__list__item",
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $86d933b6cc91e0a8$export$11711709bcaf1de4), {
                            index: index,
                            measure: measure,
                            currMeasureIndex: currMeasureIndex,
                            currMeasureOffset: currMeasureOffset,
                            currBeatIndex: currBeatIndex,
                            currNoteIndex: currNoteIndex,
                            onRemove: onRemoveMeasure,
                            onChangeRepeat: onChangeRepeat,
                            onAddBeat: onAddBeat,
                            onRemoveBeat: onRemoveBeat,
                            onAddNote: onAddNote,
                            onChangeNote: onChangeNote,
                            onRemoveNote: onRemoveNote
                        })
                    }, index);
                },
                locale: {
                    emptyText: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                        id: "no-measures",
                        children: "No Measures"
                    })
                }
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $58daee52af5fd182$export$2e2bcd8739ae039), {
                justify: "center",
                className: "rhythm__viewer__toolbar",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                    disabled: !editable,
                    type: "primary",
                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7ccd05dd213ce145$export$2e2bcd8739ae039), {}),
                    onClick: onAddMeasure,
                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                        id: "add-measure",
                        children: "Add Measure"
                    })
                })
            })
        ]
    });
}






var $3ca69fd3903bccf4$var$timerMap = new Map();
var $3ca69fd3903bccf4$export$2cd96fc3b1b618d8;
(function(TickType) {
    TickType[TickType["First"] = 0] = "First";
    TickType[TickType["Middle"] = 1] = "Middle";
    TickType[TickType["Last"] = 2] = "Last";
})($3ca69fd3903bccf4$export$2cd96fc3b1b618d8 || ($3ca69fd3903bccf4$export$2cd96fc3b1b618d8 = {}));
function $3ca69fd3903bccf4$export$1c43efaafc52b831(task, callback) {
    var id = task.id, rhythm = task.rhythm, preparatoryTime = task.preparatoryTime, beginTime = task.beginTime, tempo = task.tempo, ticksCount = task.ticksCount, ticksPerBeat = task.ticksPerBeat;
    var tickIndex = -1;
    var handleTick = function() {
        tickIndex++;
        var _locate = (0, $e7d0c89ead4e7b91$export$5200e0c7549d7bff)(rhythm, ticksPerBeat, tickIndex), measureIndex = _locate.measureIndex, measureOffset = _locate.measureOffset, beatIndex = _locate.beatIndex, beatOffset = _locate.beatOffset, noteIndex = _locate.noteIndex, noteOffset = _locate.noteOffset;
        callback({
            type: "tick",
            tick: {
                measureOffset: measureOffset,
                measureIndex: measureIndex,
                beatIndex: beatIndex,
                beatOffset: beatOffset,
                noteIndex: noteIndex,
                noteOffset: noteOffset,
                tickIndex: tickIndex
            }
        }, task);
        if (tickIndex >= ticksCount - 1) {
            var timer = $3ca69fd3903bccf4$var$timerMap.get(task.id);
            if (timer === null || timer === void 0 ? void 0 : timer.tickIntervalId) {
                self.clearInterval(timer === null || timer === void 0 ? void 0 : timer.tickIntervalId);
                timer.tickIntervalId = null;
            }
        }
    };
    var tickInterval = (0, $3a38d9f63feceb53$export$9245831f62081b68) / (ticksPerBeat * tempo.speed);
    var handleTickerBegin = function() {
        var timer = $3ca69fd3903bccf4$var$timerMap.get(task.id);
        if (timer) timer.tickIntervalId = self.setInterval(handleTick, tickInterval);
    };
    var handleTickerPreparatory = function() {
        callback({
            type: "preparatory"
        }, task);
    };
    var preparatoryTimeoutId = self.setTimeout(handleTickerPreparatory, preparatoryTime);
    var beginTimeoutId = self.setTimeout(handleTickerBegin, beginTime - tickInterval);
    var timer = {
        beginTimeoutId: beginTimeoutId,
        preparatoryTimeoutId: preparatoryTimeoutId,
        tickIntervalId: null
    };
    $3ca69fd3903bccf4$var$timerMap.set(id, timer);
}
function $3ca69fd3903bccf4$export$d9d592371c2a2f98(task) {
    var timer = $3ca69fd3903bccf4$var$timerMap.get(task.id);
    if (timer === null || timer === void 0 ? void 0 : timer.preparatoryTimeoutId) self.clearTimeout(timer.preparatoryTimeoutId);
    if (timer === null || timer === void 0 ? void 0 : timer.beginTimeoutId) self.clearTimeout(timer.beginTimeoutId);
    if (timer === null || timer === void 0 ? void 0 : timer.tickIntervalId) self.clearInterval(timer.tickIntervalId);
}
$dc596b22b81a4925$export$9b7f6e342a8cbd38({
    startTask: $3ca69fd3903bccf4$export$1c43efaafc52b831,
    stopTask: $3ca69fd3903bccf4$export$d9d592371c2a2f98
});






function $bea7d613d13dc0e9$export$e7dc8da1baeb1d74() {
    var _useFlag = (0, $2c9a6289909a7048$export$983b9b54330812cb)(false), isRhythmNameModalOpened = _useFlag.flag, openRhythmNameModal = _useFlag.turnOn, closeRhythmNameModal = _useFlag.turnOff;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(""), 2), rhythmName = _useState[0], setRhythmName = _useState[1];
    var changeRhythmName = (0, $8SyCD.useCallback)(function(evt) {
        setRhythmName(evt.target.value);
    }, [
        setRhythmName
    ]);
    var dexie = (0, $c5efbd2e0c4166b1$export$95809329f49ea9f9)().dexie;
    var navigate = (0, $b6e23d349026de17$export$9770f232ac06a008)();
    var createRhythm = (0, $8SyCD.useCallback)(function(evt) {
        evt.preventDefault();
        var id = (0, $7a779d4c9bd79108$export$218c8c3169c024d2)();
        var rhythm = {
            id: id,
            name: rhythmName,
            order: Date.now(),
            createdTime: new Date(),
            updatedTime: new Date(),
            preparatoryBeats: 4,
            tempo: (0, $92577b47e3b00856$export$ed30250e7522198),
            measures: (0, $92577b47e3b00856$export$7f74fb282b451e4b)
        };
        dexie.rhythms.add(rhythm).then(function() {
            navigate("/metronome/".concat(id));
        }, function() {});
    }, [
        rhythmName,
        dexie,
        navigate
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "page page--metronome",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__header",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $eec4795e5e45e013$export$bbadff23f5cd28e2), {})
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4d84ed2d6d1cd5db$export$e3f55b9c19e951df), {
                    onCreateRhythm: openRhythmNameModal
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d7fa675cd1188439$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "input-name-of-rhythm",
                    children: "Input name of rhythm"
                }),
                open: isRhythmNameModalOpened,
                footer: null,
                onCancel: closeRhythmNameModal,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $666b43abc2af1493$export$a7fed597f4b8afd8), {
                    autoComplete: "off",
                    onSubmit: createRhythm,
                    children: [
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                            name: "name",
                            label: "name",
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                id: "rhythm-name-field",
                                attrs: {
                                    placeholder: true
                                },
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $9631a8a644aaa47e$export$2e2bcd8739ae039), {
                                    name: "name",
                                    value: rhythmName,
                                    onChange: changeRhythmName,
                                    placeholder: "Input name of rhythm"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $666b43abc2af1493$export$56e87bf42978147a), {
                            name: "submit",
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                type: "primary",
                                htmlType: "submit",
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "create",
                                    children: "Create"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");









function $23bff83d966bcedf$export$87e38ee403661ccc(token) {
    var sizePopupArrow = token.sizePopupArrow, borderRadiusXS = token.borderRadiusXS, borderRadiusOuter = token.borderRadiusOuter;
    var unitWidth = sizePopupArrow / 2;
    var ax = 0;
    var ay = unitWidth;
    var bx = borderRadiusOuter * 1 / Math.sqrt(2);
    var by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    var cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    var cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    var dx = 2 * unitWidth - cx;
    var dy = cy;
    var ex = 2 * unitWidth - bx;
    var ey = by;
    var fx = 2 * unitWidth - ax;
    var fy = ay;
    var shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    var polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    var arrowPolygon = "polygon(".concat(polygonOffset, "px 100%, 50% ").concat(polygonOffset, "px, ").concat(2 * unitWidth - polygonOffset, "px 100%, ").concat(polygonOffset, "px 100%)");
    var arrowPath = "path('M ".concat(ax, " ").concat(ay, " A ").concat(borderRadiusOuter, " ").concat(borderRadiusOuter, " 0 0 0 ").concat(bx, " ").concat(by, " L ").concat(cx, " ").concat(cy, " A ").concat(borderRadiusXS, " ").concat(borderRadiusXS, " 0 0 1 ").concat(dx, " ").concat(dy, " L ").concat(ex, " ").concat(ey, " A ").concat(borderRadiusOuter, " ").concat(borderRadiusOuter, " 0 0 0 ").concat(fx, " ").concat(fy, " Z')");
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
var $23bff83d966bcedf$export$601fa0375eb80eec = function(token, bgColor, boxShadow) {
    var sizePopupArrow = token.sizePopupArrow, arrowPolygon = token.arrowPolygon, arrowPath = token.arrowPath, arrowShadowWidth = token.arrowShadowWidth, borderRadiusXS = token.borderRadiusXS, calc = token.calc;
    return {
        pointerEvents: "none",
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: "hidden",
        "&::before": {
            position: "absolute",
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        "&::after": {
            content: '""',
            position: "absolute",
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: "auto",
            borderRadius: {
                _skip_check_: true,
                value: "0 0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(borderRadiusXS), " 0")
            },
            transform: "translateY(50%) rotate(-135deg)",
            boxShadow: boxShadow,
            zIndex: 0,
            background: "transparent"
        }
    };
};


var $cbbf254d657cc278$export$de6e4ffc9ec3c089 = 8;
function $cbbf254d657cc278$export$bddc192327bb9823(options) {
    var contentRadius = options.contentRadius, limitVerticalRadius = options.limitVerticalRadius;
    var arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    var arrowOffsetVertical = limitVerticalRadius ? $cbbf254d657cc278$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $cbbf254d657cc278$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $cbbf254d657cc278$export$2e2bcd8739ae039(token, colorBg, options) {
    var componentCls = token.componentCls, boxShadowPopoverArrow = token.boxShadowPopoverArrow, arrowOffsetVertical = token.arrowOffsetVertical, arrowOffsetHorizontal = token.arrowOffsetHorizontal;
    var _ref = options || {}, _ref_arrowDistance = _ref.arrowDistance, arrowDistance = _ref_arrowDistance === void 0 ? 0 : _ref_arrowDistance, _ref_arrowPlacement = _ref.arrowPlacement, arrowPlacement = _ref_arrowPlacement === void 0 ? {
        left: true,
        right: true,
        top: true,
        bottom: true
    } : _ref_arrowPlacement;
    var _obj, _obj1, _obj2, _obj3;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(// ============================ Basic ============================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-arrow"), [
        Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "block"
        }, (0, $23bff83d966bcedf$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow)), {
            "&:before": {
                background: colorBg
            }
        })
    ]), $cbbf254d657cc278$var$isInject(!!arrowPlacement.top, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, [
        "&-placement-top ".concat(componentCls, "-arrow"),
        "&-placement-topLeft ".concat(componentCls, "-arrow"),
        "&-placement-topRight ".concat(componentCls, "-arrow")
    ].join(","), {
        bottom: arrowDistance,
        transform: "translateY(100%) rotate(180deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-placement-top ".concat(componentCls, "-arrow"), {
        left: {
            _skip_check_: true,
            value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-placement-topLeft ".concat(componentCls, "-arrow"), {
        left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-placement-topRight ".concat(componentCls, "-arrow"), {
        right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
        }
    }), _obj))), $cbbf254d657cc278$var$isInject(!!arrowPlacement.bottom, (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, [
        "&-placement-bottom ".concat(componentCls, "-arrow"),
        "&-placement-bottomLeft ".concat(componentCls, "-arrow"),
        "&-placement-bottomRight ".concat(componentCls, "-arrow")
    ].join(","), {
        top: arrowDistance,
        transform: "translateY(-100%)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-placement-bottom ".concat(componentCls, "-arrow"), {
        left: {
            _skip_check_: true,
            value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-placement-bottomLeft ".concat(componentCls, "-arrow"), {
        left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-placement-bottomRight ".concat(componentCls, "-arrow"), {
        right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
        }
    }), _obj1))), $cbbf254d657cc278$var$isInject(!!arrowPlacement.left, (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, [
        "&-placement-left ".concat(componentCls, "-arrow"),
        "&-placement-leftTop ".concat(componentCls, "-arrow"),
        "&-placement-leftBottom ".concat(componentCls, "-arrow")
    ].join(","), {
        right: {
            _skip_check_: true,
            value: arrowDistance
        },
        transform: "translateX(100%) rotate(90deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-placement-left ".concat(componentCls, "-arrow"), {
        top: {
            _skip_check_: true,
            value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-placement-leftTop ".concat(componentCls, "-arrow"), {
        top: arrowOffsetVertical
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&-placement-leftBottom ".concat(componentCls, "-arrow"), {
        bottom: arrowOffsetVertical
    }), _obj2))), $cbbf254d657cc278$var$isInject(!!arrowPlacement.right, (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, [
        "&-placement-right ".concat(componentCls, "-arrow"),
        "&-placement-rightTop ".concat(componentCls, "-arrow"),
        "&-placement-rightBottom ".concat(componentCls, "-arrow")
    ].join(","), {
        left: {
            _skip_check_: true,
            value: arrowDistance
        },
        transform: "translateX(-100%) rotate(-90deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-placement-right ".concat(componentCls, "-arrow"), {
        top: {
            _skip_check_: true,
            value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-placement-rightTop ".concat(componentCls, "-arrow"), {
        top: arrowOffsetVertical
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-placement-rightBottom ".concat(componentCls, "-arrow"), {
        bottom: arrowOffsetVertical
    }), _obj3))));
}


function $7872110b38a3dec0$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    var overflow = autoAdjustOverflow && typeof autoAdjustOverflow === "object" ? autoAdjustOverflow : {};
    var baseOverflow = {};
    switch(placement){
        case "top":
        case "bottom":
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case "left":
        case "right":
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    var mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
var $7872110b38a3dec0$var$PlacementAlignMap = {
    left: {
        points: [
            "cr",
            "cl"
        ]
    },
    right: {
        points: [
            "cl",
            "cr"
        ]
    },
    top: {
        points: [
            "bc",
            "tc"
        ]
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ]
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tr"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ]
    }
};
var $7872110b38a3dec0$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            "bl",
            "tc"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "cl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tc"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "cr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "bc"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "cr"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bc"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "cl"
        ]
    }
};
var $7872110b38a3dec0$var$DisableAutoArrowList = new Set([
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "leftTop",
    "leftBottom",
    "rightTop",
    "rightBottom"
]);
function $7872110b38a3dec0$export$2e2bcd8739ae039(config) {
    var arrowWidth = config.arrowWidth, autoAdjustOverflow = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter, offset = config.offset, borderRadius = config.borderRadius, visibleFirst = config.visibleFirst;
    var halfArrowWidth = arrowWidth / 2;
    var placementMap = {};
    Object.keys($7872110b38a3dec0$var$PlacementAlignMap).forEach(function(key) {
        var template = arrowPointAtCenter && $7872110b38a3dec0$var$ArrowCenterPlacementAlignMap[key] || $7872110b38a3dec0$var$PlacementAlignMap[key];
        var placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($7872110b38a3dec0$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case "top":
            case "topLeft":
            case "topRight":
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case "bottom":
            case "bottomLeft":
            case "bottomRight":
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case "left":
            case "leftTop":
            case "leftBottom":
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case "right":
            case "rightTop":
            case "rightBottom":
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        // Dynamic offset
        var arrowOffset = (0, $cbbf254d657cc278$export$bddc192327bb9823)({
            contentRadius: borderRadius,
            limitVerticalRadius: true
        });
        if (arrowPointAtCenter) switch(key){
            case "topLeft":
            case "bottomLeft":
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "topRight":
            case "bottomRight":
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case "leftTop":
            case "rightTop":
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "leftBottom":
            case "rightBottom":
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $7872110b38a3dec0$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = "visibleFirst";
    });
    return placementMap;
}









var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $5b99a13eae6b7ba9$var$BarsOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "0 0 1024 1024",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    name: "bars",
    theme: "outlined"
};
var $5b99a13eae6b7ba9$export$2e2bcd8739ae039 = $5b99a13eae6b7ba9$var$BarsOutlined;



var $727a004f671359f7$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5b99a13eae6b7ba9$export$2e2bcd8739ae039)
    }));
};
var $727a004f671359f7$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($727a004f671359f7$var$BarsOutlined);






var $02674965914545cd$var$isNumeric = function(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
var $02674965914545cd$export$2e2bcd8739ae039 = $02674965914545cd$var$isNumeric;




var $8SyCD = parcelRequire("8SyCD");
var $9babb72ffc252783$export$964282a2c3979546 = /*#__PURE__*/ $8SyCD.createContext({
    siderHook: {
        addSider: function() {
            return null;
        },
        removeSider: function() {
            return null;
        }
    }
});


"use client";
var $40d0a8d7e7a928c2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $40d0a8d7e7a928c2$var$dimensionMaxMap = {
    xs: "479.98px",
    sm: "575.98px",
    md: "767.98px",
    lg: "991.98px",
    xl: "1199.98px",
    xxl: "1599.98px"
};
var $40d0a8d7e7a928c2$export$63554aebd2a6d54c = /*#__PURE__*/ $8SyCD.createContext({});
var $40d0a8d7e7a928c2$var$generateId = function() {
    var i = 0;
    return function() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        i += 1;
        return "".concat(prefix).concat(i);
    };
}();
var $40d0a8d7e7a928c2$var$Sider = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, trigger = props.trigger, children = props.children, _props_defaultCollapsed = props.defaultCollapsed, defaultCollapsed = _props_defaultCollapsed === void 0 ? false : _props_defaultCollapsed, _props_theme = props.theme, theme = _props_theme === void 0 ? "dark" : _props_theme, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, _props_collapsible = props.collapsible, collapsible = _props_collapsible === void 0 ? false : _props_collapsible, _props_reverseArrow = props.reverseArrow, reverseArrow = _props_reverseArrow === void 0 ? false : _props_reverseArrow, _props_width = props.width, width = _props_width === void 0 ? 200 : _props_width, _props_collapsedWidth = props.collapsedWidth, collapsedWidth = _props_collapsedWidth === void 0 ? 80 : _props_collapsedWidth, zeroWidthTriggerStyle = props.zeroWidthTriggerStyle, breakpoint = props.breakpoint, onCollapse = props.onCollapse, onBreakpoint = props.onBreakpoint, otherProps = $40d0a8d7e7a928c2$var$__rest(props, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    var siderHook = (0, $8SyCD.useContext)((0, $9babb72ffc252783$export$964282a2c3979546)).siderHook;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)("collapsed" in props ? props.collapsed : defaultCollapsed), 2), collapsed = _useState[0], setCollapsed = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(false), 2), below = _useState1[0], setBelow = _useState1[1];
    (0, $8SyCD.useEffect)(function() {
        if ("collapsed" in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    var handleSetCollapsed = function(value, type) {
        if (!("collapsed" in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // ========================= Responsive =========================
    var responsiveHandlerRef = (0, $8SyCD.useRef)();
    responsiveHandlerRef.current = function(mql) {
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, "responsive");
    };
    (0, $8SyCD.useEffect)(function() {
        var responsiveHandler = function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        };
        var mql;
        if (typeof window !== "undefined") {
            var matchMedia = window.matchMedia;
            if (matchMedia && breakpoint && breakpoint in $40d0a8d7e7a928c2$var$dimensionMaxMap) {
                mql = matchMedia("(max-width: ".concat($40d0a8d7e7a928c2$var$dimensionMaxMap[breakpoint], ")"));
                try {
                    mql.addEventListener("change", responsiveHandler);
                } catch (error) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return function() {
            try {
                mql === null || mql === void 0 || mql.removeEventListener("change", responsiveHandler);
            } catch (error) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $8SyCD.useEffect)(function() {
        var uniqueId = $40d0a8d7e7a928c2$var$generateId("ant-sider-");
        siderHook.addSider(uniqueId);
        return function() {
            return siderHook.removeSider(uniqueId);
        };
    }, []);
    var toggle = function() {
        handleSetCollapsed(!collapsed, "clickTrigger");
    };
    var getPrefixCls = (0, $8SyCD.useContext)((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var renderSider = function() {
        var prefixCls = getPrefixCls("layout-sider", customizePrefixCls);
        var divProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(otherProps, [
            "collapsed"
        ]);
        var rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        var siderWidth = (0, $02674965914545cd$export$2e2bcd8739ae039)(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth);
        // special trigger when collapsedWidth == 0
        var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $8SyCD.createElement("span", {
            onClick: toggle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? "right" : "left")),
            style: zeroWidthTriggerStyle
        }, trigger || /*#__PURE__*/ $8SyCD.createElement((0, $727a004f671359f7$export$2e2bcd8739ae039), null)) : null;
        var iconObj = {
            expanded: reverseArrow ? /*#__PURE__*/ $8SyCD.createElement((0, $d282c3c50daf5fec$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $8SyCD.createElement((0, $23a81172a0b746de$export$2e2bcd8739ae039), null),
            collapsed: reverseArrow ? /*#__PURE__*/ $8SyCD.createElement((0, $23a81172a0b746de$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $8SyCD.createElement((0, $d282c3c50daf5fec$export$2e2bcd8739ae039), null)
        };
        var status = collapsed ? "collapsed" : "expanded";
        var defaultTrigger = iconObj[status];
        var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $8SyCD.createElement("div", {
            className: "".concat(prefixCls, "-trigger"),
            onClick: toggle,
            style: {
                width: siderWidth
            }
        }, trigger || defaultTrigger) : null;
        var divStyle = Object.assign(Object.assign({}, style), {
            flex: "0 0 ".concat(siderWidth),
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth
        });
        var _obj;
        var siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-").concat(theme), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-collapsed"), !!collapsed), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-below"), !!below), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _obj), className);
        return /*#__PURE__*/ $8SyCD.createElement("aside", Object.assign({
            className: siderCls
        }, divProps, {
            style: divStyle,
            ref: ref
        }), /*#__PURE__*/ $8SyCD.createElement("div", {
            className: "".concat(prefixCls, "-children")
        }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
    };
    var contextValue = $8SyCD.useMemo(function() {
        return {
            siderCollapsed: collapsed
        };
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ $8SyCD.createElement($40d0a8d7e7a928c2$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, renderSider());
});
var $40d0a8d7e7a928c2$export$2e2bcd8739ae039 = $40d0a8d7e7a928c2$var$Sider;






var $8SyCD = parcelRequire("8SyCD");

"use client";
var $7d7156ca421c64e2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7d7156ca421c64e2$var$MenuDivider = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, dashed = props.dashed, restProps = $7d7156ca421c64e2$var$__rest(props, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("menu", customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-item-divider-dashed"), !!dashed), className);
    return /*#__PURE__*/ $8SyCD.createElement((0, $dfe735131839def8$export$2e2bcd8739ae039), Object.assign({
        className: classString
    }, restProps));
};
var $7d7156ca421c64e2$export$2e2bcd8739ae039 = $7d7156ca421c64e2$var$MenuDivider;








var $8SyCD = parcelRequire("8SyCD");




var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
function $7bf7ed1fd45b9473$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $8SyCD.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}







var $8SyCD = parcelRequire("8SyCD");
var $3051797e3d7761a3$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $3051797e3d7761a3$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $3051797e3d7761a3$var$targetOffset = [
    0,
    0
];
var $3051797e3d7761a3$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $3051797e3d7761a3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3051797e3d7761a3$var$targetOffset
    }
};
var $3051797e3d7761a3$export$2e2bcd8739ae039 = $3051797e3d7761a3$export$803cd8101b6c182b;



var $f7619dbe8c65ff5c$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $f7619dbe8c65ff5c$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(props, $f7619dbe8c65ff5c$var$_excluded);
    var triggerRef = (0, $8SyCD.useRef)(null);
    (0, $8SyCD.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $d92fa87bc98e5ec0$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $8SyCD.createElement((0, $7bf7ed1fd45b9473$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $639aa9e1edacf68a$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $3051797e3d7761a3$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), children);
};
var $f7619dbe8c65ff5c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8SyCD.forwardRef)($f7619dbe8c65ff5c$var$Tooltip);


var $cff4fed16c062450$export$2e2bcd8739ae039 = (0, $f7619dbe8c65ff5c$export$2e2bcd8739ae039);
















var $8SyCD = parcelRequire("8SyCD");





var $607dcc69cf6ca773$export$6d4fe3a00a1811ad = [
    "blue",
    "purple",
    "cyan",
    "green",
    "magenta",
    "pink",
    "red",
    "orange",
    "yellow",
    "volcano",
    "geekblue",
    "lime",
    "gold"
];


function $a97bc39a850ed8f0$export$2e2bcd8739ae039(token, genCss) {
    return (0, $607dcc69cf6ca773$export$6d4fe3a00a1811ad).reduce(function(prev, colorKey) {
        var lightColor = token["".concat(colorKey, "1")];
        var lightBorderColor = token["".concat(colorKey, "3")];
        var darkColor = token["".concat(colorKey, "6")];
        var textColor = token["".concat(colorKey, "7")];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}




var $2adf8ce2fcb85876$var$genTooltipStyle = function(token) {
    var componentCls = token.componentCls, // ant-tooltip
    tooltipMaxWidth = token.tooltipMaxWidth, tooltipColor = token.tooltipColor, tooltipBg = token.tooltipBg, tooltipBorderRadius = token.tooltipBorderRadius, zIndexPopup = token.zIndexPopup, controlHeight = token.controlHeight, boxShadowSecondary = token.boxShadowSecondary, paddingSM = token.paddingSM, paddingXS = token.paddingXS;
    var _obj;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj = {
            position: "absolute",
            zIndex: zIndexPopup,
            display: "block",
            width: "max-content",
            maxWidth: tooltipMaxWidth,
            visibility: "visible",
            transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
            "&-hidden": {
                display: "none"
            },
            "--antd-arrow-background-color": tooltipBg
        }, // Wrapper for the tooltip content
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-inner"), {
            minWidth: controlHeight,
            minHeight: controlHeight,
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal()), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingXS)),
            color: tooltipColor,
            textAlign: "start",
            textDecoration: "none",
            wordWrap: "break-word",
            backgroundColor: tooltipBg,
            borderRadius: tooltipBorderRadius,
            boxShadow: boxShadowSecondary,
            boxSizing: "border-box"
        }), // Limit left and right placement radius
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, [
            "&-placement-left",
            "&-placement-leftTop",
            "&-placement-leftBottom",
            "&-placement-right",
            "&-placement-rightTop",
            "&-placement-rightBottom"
        ].join(","), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-inner"), {
            borderRadius: token.min(tooltipBorderRadius, (0, $cbbf254d657cc278$export$de6e4ffc9ec3c089))
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-content"), {
            position: "relative"
        }), _obj)), (0, $a97bc39a850ed8f0$export$2e2bcd8739ae039)(token, function(colorKey, _ref) {
            var darkColor = _ref.darkColor;
            var _obj;
            return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-").concat(colorKey), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-inner"), {
                backgroundColor: darkColor
            }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-arrow"), {
                "--antd-arrow-background-color": darkColor
            }), _obj));
        })), {
            // RTL
            "&-rtl": {
                direction: "rtl"
            }
        })),
        // Arrow Style
        (0, $cbbf254d657cc278$export$2e2bcd8739ae039)(token, "var(--antd-arrow-background-color)"),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-pure"), {
            position: "relative",
            maxWidth: "none",
            margin: token.sizePopupArrow
        })
    ];
};
var $2adf8ce2fcb85876$export$9ca1be8807fe0675 = function(token) {
    return Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $cbbf254d657cc278$export$bddc192327bb9823)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $23bff83d966bcedf$export$87e38ee403661ccc)((0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
};
var $2adf8ce2fcb85876$export$2e2bcd8739ae039 = function(prefixCls) {
    var injectStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var useStyle = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Tooltip", function(token) {
        var borderRadius = token.borderRadius, colorTextLightSolid = token.colorTextLightSolid, colorBgSpotlight = token.colorBgSpotlight;
        var TooltipToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $2adf8ce2fcb85876$var$genTooltipStyle(TooltipToken),
            (0, $41928187f0cc1a97$export$f5d123412490d9dc)(token, "zoom-big-fast")
        ];
    }, $2adf8ce2fcb85876$export$9ca1be8807fe0675, {
        resetStyle: false,
        // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle: injectStyle
    });
    return useStyle(prefixCls);
};


/* eslint-disable import/prefer-default-export */ 



var $35809625a0bf139d$var$inverseColors = (0, $607dcc69cf6ca773$export$6d4fe3a00a1811ad).map(function(color) {
    return "".concat(color, "-inverse");
});
var $35809625a0bf139d$export$bb684163c94c55ae = [
    "success",
    "processing",
    "error",
    "default",
    "warning"
];
function $35809625a0bf139d$export$ee62ebd6a58c4884(color) {
    var includeInverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (includeInverse) return [].concat((0, $e17b38c8264d6486$export$2e2bcd8739ae039)($35809625a0bf139d$var$inverseColors), (0, $e17b38c8264d6486$export$2e2bcd8739ae039)((0, $607dcc69cf6ca773$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $607dcc69cf6ca773$export$6d4fe3a00a1811ad).includes(color);
}
function $35809625a0bf139d$export$88a0ba1f7d1ea40e(color) {
    return $35809625a0bf139d$export$bb684163c94c55ae.includes(color);
}


function $729a19bb7cc267c9$export$6e865ea70d7724f(prefixCls, color) {
    var isInternalColor = (0, $35809625a0bf139d$export$ee62ebd6a58c4884)(color);
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-").concat(color), color && isInternalColor));
    var overlayStyle = {};
    var arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle["--antd-arrow-background-color"] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ var $8ad5b45ab9bf0764$var$PurePanel = function(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, _props_placement = props.placement, placement = _props_placement === void 0 ? "top" : _props_placement, title = props.title, color = props.color, overlayInnerStyle = props.overlayInnerStyle;
    var getPrefixCls = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)).getPrefixCls;
    var prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $2adf8ce2fcb85876$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    // Color
    var colorInfo = (0, $729a19bb7cc267c9$export$6e865ea70d7724f)(prefixCls, color);
    var arrowContentStyle = colorInfo.arrowStyle;
    var formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(hashId, prefixCls, "".concat(prefixCls, "-pure"), "".concat(prefixCls, "-placement-").concat(placement), className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ $8SyCD.createElement((0, $7bf7ed1fd45b9473$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $8ad5b45ab9bf0764$export$2e2bcd8739ae039 = $8ad5b45ab9bf0764$var$PurePanel;




"use client";
var $fe25eb7a7ae50d90$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fe25eb7a7ae50d90$var$Tooltip = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _a, _b;
    var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children, afterOpenChange = props.afterOpenChange, afterVisibleChange = props.afterVisibleChange, destroyTooltipOnHide = props.destroyTooltipOnHide, _props_arrow = props.arrow, arrow = _props_arrow === void 0 ? true : _props_arrow, title = props.title, overlay = props.overlay, builtinPlacements = props.builtinPlacements, _props_arrowPointAtCenter = props.arrowPointAtCenter, arrowPointAtCenter = _props_arrowPointAtCenter === void 0 ? false : _props_arrowPointAtCenter, _props_autoAdjustOverflow = props.autoAdjustOverflow, autoAdjustOverflow = _props_autoAdjustOverflow === void 0 ? true : _props_autoAdjustOverflow;
    var mergedShowArrow = !!arrow;
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React_useContext.getPopupContainer, getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    // ============================== Ref ===============================
    var warning = (0, $a45ff4e670d5554a$export$cf977aa92c751e61)("Tooltip");
    var tooltipRef = $8SyCD.useRef(null);
    var forceAlign = function() {
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $8SyCD.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            forcePopupAlign: function() {
                warning.deprecated(false, "forcePopupAlign", "forceAlign");
                forceAlign();
            }
        };
    });
    var _ref;
    // ============================== Open ==============================
    var _useMergedState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    }), 2), open = _useMergedState[0], setOpen = _useMergedState[1];
    var noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    var onOpenChange = function(vis) {
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    var tooltipPlacements = $8SyCD.useMemo(function() {
        var _a, _b;
        var mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === "object") mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $7872110b38a3dec0$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    var memoOverlay = $8SyCD.useMemo(function() {
        if (title === 0) return title;
        return overlay || title || "";
    }, [
        overlay,
        title
    ]);
    var memoOverlayWrapper = /*#__PURE__*/ $8SyCD.createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, typeof memoOverlay === "function" ? memoOverlay() : memoOverlay);
    var getPopupContainer = props.getPopupContainer, _props_placement = props.placement, placement = _props_placement === void 0 ? "top" : _props_placement, _props_mouseEnterDelay = props.mouseEnterDelay, mouseEnterDelay = _props_mouseEnterDelay === void 0 ? 0.1 : _props_mouseEnterDelay, _props_mouseLeaveDelay = props.mouseLeaveDelay, mouseLeaveDelay = _props_mouseLeaveDelay === void 0 ? 0.1 : _props_mouseLeaveDelay, overlayStyle = props.overlayStyle, rootClassName = props.rootClassName, otherProps = $fe25eb7a7ae50d90$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName"
    ]);
    var prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var injectFromPopover = props["data-popover-inject"];
    var tempOpen = open;
    // Hide tooltip when there is no title
    if (!("open" in props) && !("visible" in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    var child = (0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(children) && !(0, $70bdd1d9fe5ae128$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $8SyCD.createElement("span", null, children);
    var childProps = child.props;
    var childCls = !childProps.className || typeof childProps.className === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(childProps.className, openClassName || "".concat(prefixCls, "-open")) : childProps.className;
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $2adf8ce2fcb85876$export$2e2bcd8739ae039)(prefixCls, !injectFromPopover), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    // Color
    var colorInfo = (0, $729a19bb7cc267c9$export$6e865ea70d7724f)(prefixCls, color);
    var arrowContentStyle = colorInfo.arrowStyle;
    var formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    var customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(overlayClassName, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), colorInfo.className, rootClassName, hashId);
    // ============================ zIndex ============================
    var _useZIndex = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4d9cc5bfe7391b56$export$3e7906d4075187a4)("Tooltip", otherProps.zIndex), 2), zIndex = _useZIndex[0], contextZIndex = _useZIndex[1];
    var content = /*#__PURE__*/ $8SyCD.createElement((0, $cff4fed16c062450$export$2e2bcd8739ae039), Object.assign({}, otherProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        overlayStyle: Object.assign(Object.assign({}, arrowContentStyle), overlayStyle),
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-arrow-content")
        }),
        motion: {
            motionName: (0, $800f705b9f73a72d$export$27c72201b1d09951)(rootPrefixCls, "zoom-big-fast", props.transitionName),
            motionDeadline: 1000
        },
        destroyTooltipOnHide: !!destroyTooltipOnHide
    }), tempOpen ? (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $7aa43d76a03d0c4e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content));
});
$fe25eb7a7ae50d90$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $8ad5b45ab9bf0764$export$2e2bcd8739ae039);
var $fe25eb7a7ae50d90$export$2e2bcd8739ae039 = $fe25eb7a7ae50d90$var$Tooltip;




var $8SyCD = parcelRequire("8SyCD");
"use client";
var $65112bb01210c9ec$var$MenuContext = /*#__PURE__*/ (0, $8SyCD.createContext)({
    prefixCls: "",
    firstLevel: true,
    inlineCollapsed: false
});
var $65112bb01210c9ec$export$2e2bcd8739ae039 = $65112bb01210c9ec$var$MenuContext;


"use client";
var $15537eb65696272d$var$MenuItem = function(props) {
    var _a;
    var className = props.className, children = props.children, icon = props.icon, title = props.title, danger = props.danger;
    var _React_useContext = $8SyCD.useContext((0, $65112bb01210c9ec$export$2e2bcd8739ae039)), prefixCls = _React_useContext.prefixCls, firstLevel = _React_useContext.firstLevel, direction = _React_useContext.direction, disableMenuItemTitleTooltip = _React_useContext.disableMenuItemTitleTooltip, isInlineCollapsed = _React_useContext.inlineCollapsed;
    var renderItemChildren = function(inlineCollapsed) {
        var wrapNode = /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-title-content")
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || (0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(children) && children.type === "span") {
            if (children && inlineCollapsed && firstLevel && typeof children === "string") return /*#__PURE__*/ $8SyCD.createElement("div", {
                className: "".concat(prefixCls, "-inline-collapsed-noicon")
            }, children.charAt(0));
        }
        return wrapNode;
    };
    var siderCollapsed = $8SyCD.useContext((0, $40d0a8d7e7a928c2$export$63554aebd2a6d54c)).siderCollapsed;
    var tooltipTitle = title;
    if (typeof title === "undefined") tooltipTitle = firstLevel ? children : "";
    else if (title === false) tooltipTitle = "";
    var tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    var childrenLength = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children).length;
    var _obj;
    var returnNode = /*#__PURE__*/ $8SyCD.createElement((0, $fb94fb127dd1a31f$export$2e2bcd8739ae039), Object.assign({}, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "title",
        "icon",
        "danger"
    ]), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-item-danger"), danger), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _obj), className),
        title: typeof title === "string" ? title : undefined
    }), (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : "", "".concat(prefixCls, "-item-icon"))
    }), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $8SyCD.createElement((0, $fe25eb7a7ae50d90$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
        placement: direction === "rtl" ? "left" : "right",
        overlayClassName: "".concat(prefixCls, "-inline-collapsed-tooltip")
    }), returnNode);
    return returnNode;
};
var $15537eb65696272d$export$2e2bcd8739ae039 = $15537eb65696272d$var$MenuItem;




var $8SyCD = parcelRequire("8SyCD");






"use client";
var $27a438b646042d02$var$SubMenu = function(props) {
    var _a;
    var popupClassName = props.popupClassName, icon = props.icon, title = props.title, customTheme = props.theme;
    var context = $8SyCD.useContext((0, $65112bb01210c9ec$export$2e2bcd8739ae039));
    var prefixCls = context.prefixCls, inlineCollapsed = context.inlineCollapsed, contextTheme = context.theme;
    var parentPath = (0, $2a06b1ba7a6808c6$export$d3d2d0a05677870a)();
    var titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === "string" ? /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-inline-collapsed-noicon")
    }, title.charAt(0)) : /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-title-content")
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        var titleIsSpan = (0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(title) && title.type === "span";
        titleNode = /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : "", "".concat(prefixCls, "-item-icon"))
        }), titleIsSpan ? title : /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-title-content")
        }, title));
    }
    var contextValue = $8SyCD.useMemo(function() {
        return Object.assign(Object.assign({}, context), {
            firstLevel: false
        });
    }, [
        context
    ]);
    // ============================ zIndex ============================
    var _useZIndex = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4d9cc5bfe7391b56$export$3e7906d4075187a4)("Menu"), 1), zIndex = _useZIndex[0];
    return /*#__PURE__*/ $8SyCD.createElement((0, $65112bb01210c9ec$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8SyCD.createElement((0, $0a5cf64597d10a8f$export$2e2bcd8739ae039), Object.assign({}, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "icon"
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, popupClassName, "".concat(prefixCls, "-").concat(customTheme || contextTheme)),
        popupStyle: {
            zIndex: zIndex
        }
    })));
};
var $27a438b646042d02$export$2e2bcd8739ae039 = $27a438b646042d02$var$SubMenu;




var $8SyCD = parcelRequire("8SyCD");











var $8SyCD = parcelRequire("8SyCD");



"use client";
var $aae4b1d2ef8d9ab9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $aae4b1d2ef8d9ab9$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && typeof opt === "object") {
            var _a = opt, label = _a.label, children = _a.children, key = _a.key, type = _a.type, restProps = $aae4b1d2ef8d9ab9$var$__rest(_a, [
                "label",
                "children",
                "key",
                "type"
            ]);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === "group") {
                if (type === "group") // Group
                return /*#__PURE__*/ $8SyCD.createElement((0, $6f7743c1b4881b15$export$2e2bcd8739ae039), Object.assign({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $aae4b1d2ef8d9ab9$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $8SyCD.createElement((0, $27a438b646042d02$export$2e2bcd8739ae039), Object.assign({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $aae4b1d2ef8d9ab9$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === "divider") return /*#__PURE__*/ $8SyCD.createElement((0, $7d7156ca421c64e2$export$2e2bcd8739ae039), Object.assign({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $8SyCD.createElement((0, $15537eb65696272d$export$2e2bcd8739ae039), Object.assign({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $aae4b1d2ef8d9ab9$export$2e2bcd8739ae039(items) {
    return $8SyCD.useMemo(function() {
        if (!items) return items;
        return $aae4b1d2ef8d9ab9$var$convertItemsToNodes(items);
    }, [
        items
    ]);
}




var $8SyCD = parcelRequire("8SyCD");


"use client";
var $f047de512ec73bad$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f047de512ec73bad$var$OverrideContext = /*#__PURE__*/ $8SyCD.createContext(null);
var $f047de512ec73bad$export$9bd434816b0530d0 = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var children = props.children, restProps = $f047de512ec73bad$var$__rest(props, [
        "children"
    ]);
    var override = $8SyCD.useContext($f047de512ec73bad$var$OverrideContext);
    var context = $8SyCD.useMemo(function() {
        return Object.assign(Object.assign({}, override), restProps);
    }, [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    var canRef = (0, $5a9f4dc5cf4fdd27$export$b51ae67c7882a242)(children);
    var mergedRef = (0, $5a9f4dc5cf4fdd27$export$1d1c999670a1285d)(ref, canRef ? children.ref : null);
    return /*#__PURE__*/ $8SyCD.createElement($f047de512ec73bad$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $8SyCD.createElement((0, $e2e782fcf54617f6$export$5f56e610a4afb685), null, canRef ? /*#__PURE__*/ $8SyCD.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $f047de512ec73bad$export$2e2bcd8739ae039 = $f047de512ec73bad$var$OverrideContext;







var $8ef0140f2d9ac191$var$genCollapseMotion = function(token) {
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, token.componentCls, (_obj = {}, // For common/openAnimation
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(token.antCls, "-motion-collapse-legacy"), {
        overflow: "hidden",
        "&-active": {
            transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(token.antCls, "-motion-collapse"), {
        overflow: "hidden",
        transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }), _obj));
};
var $8ef0140f2d9ac191$export$2e2bcd8739ae039 = $8ef0140f2d9ac191$var$genCollapseMotion;





"use client";
var $4926e2745b2fefdc$var$getHorizontalStyle = function(token) {
    var componentCls = token.componentCls, motionDurationSlow = token.motionDurationSlow, horizontalLineHeight = token.horizontalLineHeight, colorSplit = token.colorSplit, lineWidth = token.lineWidth, lineType = token.lineType, itemPaddingInline = token.itemPaddingInline;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-horizontal"), (_obj = {
        lineHeight: horizontalLineHeight,
        border: 0,
        borderBottom: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(lineWidth), " ").concat(lineType, " ").concat(colorSplit),
        boxShadow: "none",
        "&::after": {
            display: "block",
            clear: "both",
            height: 0,
            content: '"\\20"'
        }
    }, // ======================= Item =======================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu"), {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: itemPaddingInline
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls, "-item:hover,\n        > ").concat(componentCls, "-item-active,\n        > ").concat(componentCls, "-submenu ").concat(componentCls, "-submenu-title:hover"), {
        backgroundColor: "transparent"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), {
        transition: [
            "border-color ".concat(motionDurationSlow),
            "background ".concat(motionDurationSlow)
        ].join(",")
    }), // ===================== Sub Menu =====================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu-arrow"), {
        display: "none"
    }), _obj));
};
var $4926e2745b2fefdc$export$2e2bcd8739ae039 = $4926e2745b2fefdc$var$getHorizontalStyle;




"use client";
var $bd02d388527c87e8$var$getRTLStyle = function(_ref) {
    var componentCls = _ref.componentCls, menuArrowOffset = _ref.menuArrowOffset, calc = _ref.calc;
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-rtl"), {
        direction: "rtl"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu-rtl"), {
        transformOrigin: "100% 0"
    }), // Vertical Arrow
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-rtl").concat(componentCls, "-vertical,\n    ").concat(componentCls, "-submenu-rtl ").concat(componentCls, "-vertical"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-submenu-arrow"), {
        "&::before": {
            transform: "rotate(-45deg) translateY(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal()), ")")
        },
        "&::after": {
            transform: "rotate(45deg) translateY(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(menuArrowOffset), ")")
        }
    })), _obj;
};
var $bd02d388527c87e8$export$2e2bcd8739ae039 = $bd02d388527c87e8$var$getRTLStyle;





"use client";
var $b300fe94f0014d97$var$accessibilityFocus = function(token) {
    return Object.assign({}, (0, $7cbb7e49dbe61000$export$6539948f0a737e39)(token));
};
var $b300fe94f0014d97$var$getThemeStyle = function(token, themeSuffix) {
    var componentCls = token.componentCls, itemColor = token.itemColor, itemSelectedColor = token.itemSelectedColor, groupTitleColor = token.groupTitleColor, itemBg = token.itemBg, subMenuItemBg = token.subMenuItemBg, itemSelectedBg = token.itemSelectedBg, activeBarHeight = token.activeBarHeight, activeBarWidth = token.activeBarWidth, activeBarBorderWidth = token.activeBarBorderWidth, motionDurationSlow = token.motionDurationSlow, motionEaseInOut = token.motionEaseInOut, motionEaseOut = token.motionEaseOut, itemPaddingInline = token.itemPaddingInline, motionDurationMid = token.motionDurationMid, itemHoverColor = token.itemHoverColor, lineType = token.lineType, colorSplit = token.colorSplit, // Disabled
    itemDisabledColor = token.itemDisabledColor, // Danger
    dangerItemColor = token.dangerItemColor, dangerItemHoverColor = token.dangerItemHoverColor, dangerItemSelectedColor = token.dangerItemSelectedColor, dangerItemActiveBg = token.dangerItemActiveBg, dangerItemSelectedBg = token.dangerItemSelectedBg, itemHoverBg = token.itemHoverBg, itemActiveBg = token.itemActiveBg, menuSubMenuBg = token.menuSubMenuBg, // Horizontal
    horizontalItemSelectedColor = token.horizontalItemSelectedColor, horizontalItemSelectedBg = token.horizontalItemSelectedBg, horizontalItemBorderRadius = token.horizontalItemBorderRadius, horizontalItemHoverBg = token.horizontalItemHoverBg, popupBg = token.popupBg;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-").concat(themeSuffix, ", ").concat(componentCls, "-").concat(themeSuffix, " > ").concat(componentCls), (_obj5 = {
        color: itemColor,
        background: itemBg
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-root:focus-visible"), Object.assign({}, $b300fe94f0014d97$var$accessibilityFocus(token))), // ======================== Item ========================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item-group-title"), {
        color: groupTitleColor
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-submenu-selected"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-submenu-title"), {
        color: itemSelectedColor
    })), // Disabled
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item-disabled, ").concat(componentCls, "-submenu-disabled"), {
        color: "".concat(itemDisabledColor, " !important")
    }), // Hover
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item:not(").concat(componentCls, "-item-selected):not(").concat(componentCls, "-submenu-selected)"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:hover, > ".concat(componentCls, "-submenu-title:hover"), {
        color: itemHoverColor
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&:not(".concat(componentCls, "-horizontal)"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item:not(").concat(componentCls, "-item-selected)"), {
        "&:hover": {
            backgroundColor: itemHoverBg
        },
        "&:active": {
            backgroundColor: itemActiveBg
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu-title"), {
        "&:hover": {
            backgroundColor: itemHoverBg
        },
        "&:active": {
            backgroundColor: itemActiveBg
        }
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item-danger"), (_obj1 = {
        color: dangerItemColor
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-item:hover"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not(".concat(componentCls, "-item-selected):not(").concat(componentCls, "-submenu-selected)"), {
        color: dangerItemHoverColor
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-item:active"), {
        background: dangerItemActiveBg
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item a"), {
        "&, &:hover": {
            color: "inherit"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item-selected"), (_obj2 = {
        color: itemSelectedColor
    }, // Danger
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-item-danger"), {
        color: dangerItemSelectedColor
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "a, a:hover", {
        color: "inherit"
    }), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "& ".concat(componentCls, "-item-selected"), // Danger
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        backgroundColor: itemSelectedBg
    }, "&".concat(componentCls, "-item-danger"), {
        backgroundColor: dangerItemSelectedBg
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&:not(".concat(componentCls, "-item-disabled):focus-visible"), Object.assign({}, $b300fe94f0014d97$var$accessibilityFocus(token)))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-submenu > ").concat(componentCls), {
        backgroundColor: menuSubMenuBg
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-popup > ").concat(componentCls), {
        backgroundColor: popupBg
    }), // ====================== Horizontal ======================
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-horizontal"), Object.assign(Object.assign({}, themeSuffix === "dark" ? {
        borderBottom: 0
    } : {}), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-item, > ").concat(componentCls, "-submenu"), (_obj3 = {
        top: activeBarBorderWidth,
        marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
        marginBottom: 0,
        borderRadius: horizontalItemBorderRadius,
        "&::after": {
            position: "absolute",
            insetInline: itemPaddingInline,
            bottom: 0,
            borderBottom: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(activeBarHeight), " solid transparent"),
            transition: "border-color ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
            content: '""'
        }
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:hover, &-active, &-open", {
        background: horizontalItemHoverBg,
        "&::after": {
            borderBottomWidth: activeBarHeight,
            borderBottomColor: horizontalItemSelectedColor
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&-selected", {
        color: horizontalItemSelectedColor,
        backgroundColor: horizontalItemSelectedBg,
        "&:hover": {
            backgroundColor: horizontalItemSelectedBg
        },
        "&::after": {
            borderBottomWidth: activeBarHeight,
            borderBottomColor: horizontalItemSelectedColor
        }
    }), _obj3)))), // ================== Inline & Vertical ===================
    //
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-root"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-inline, &").concat(componentCls, "-vertical"), {
        borderInlineEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(activeBarBorderWidth), " ").concat(lineType, " ").concat(colorSplit)
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&".concat(componentCls, "-inline"), (_obj4 = {}, // Sub
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-sub").concat(componentCls, "-inline"), {
        background: subMenuItemBg
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item"), // Danger
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        position: "relative",
        "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(activeBarWidth), " solid ").concat(itemSelectedColor),
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [
                "transform ".concat(motionDurationMid, " ").concat(motionEaseOut),
                "opacity ".concat(motionDurationMid, " ").concat(motionEaseOut)
            ].join(","),
            content: '""'
        }
    }, "&".concat(componentCls, "-item-danger"), {
        "&::after": {
            borderInlineEndColor: dangerItemSelectedColor
        }
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-selected, ").concat(componentCls, "-item-selected"), {
        "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [
                "transform ".concat(motionDurationMid, " ").concat(motionEaseInOut),
                "opacity ".concat(motionDurationMid, " ").concat(motionEaseInOut)
            ].join(",")
        }
    }), _obj4)), _obj5));
};
var $b300fe94f0014d97$export$2e2bcd8739ae039 = $b300fe94f0014d97$var$getThemeStyle;





"use client";
var $8bfa284295d5c28c$var$getVerticalInlineStyle = function(token) {
    var componentCls = token.componentCls, itemHeight = token.itemHeight, itemMarginInline = token.itemMarginInline, padding = token.padding, menuArrowSize = token.menuArrowSize, marginXS = token.marginXS, itemMarginBlock = token.itemMarginBlock, itemWidth = token.itemWidth;
    var paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item"), {
        position: "relative",
        overflow: "hidden"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), {
        height: itemHeight,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(itemHeight),
        paddingInline: padding,
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginInline: itemMarginInline,
        marginBlock: itemMarginBlock,
        width: itemWidth
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "> ".concat(componentCls, "-item,\n            > ").concat(componentCls, "-submenu > ").concat(componentCls, "-submenu-title"), {
        height: itemHeight,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(itemHeight)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-group-list ").concat(componentCls, "-submenu-title,\n            ").concat(componentCls, "-submenu-title"), {
        paddingInlineEnd: paddingWithArrow
    }), _obj;
};
var $8bfa284295d5c28c$var$getVerticalStyle = function(token) {
    var componentCls = token.componentCls, iconCls = token.iconCls, itemHeight = token.itemHeight, colorTextLightSolid = token.colorTextLightSolid, dropdownWidth = token.dropdownWidth, controlHeightLG = token.controlHeightLG, motionDurationMid = token.motionDurationMid, motionEaseOut = token.motionEaseOut, paddingXL = token.paddingXL, itemMarginInline = token.itemMarginInline, fontSizeLG = token.fontSizeLG, motionDurationSlow = token.motionDurationSlow, paddingXS = token.paddingXS, boxShadowSecondary = token.boxShadowSecondary, collapsedWidth = token.collapsedWidth, collapsedIconSize = token.collapsedIconSize;
    var inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(itemHeight),
        listStylePosition: "inside",
        listStyleType: "disc"
    };
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return [
        (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, componentCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&-inline, &-vertical", Object.assign((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-root"), {
            boxShadow: "none"
        }), $8bfa284295d5c28c$var$getVerticalInlineStyle(token)))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu-popup"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-vertical"), Object.assign(Object.assign({}, $8bfa284295d5c28c$var$getVerticalInlineStyle(token)), {
            boxShadow: boxShadowSecondary
        }))), _obj),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-submenu-popup ").concat(componentCls, "-vertical").concat(componentCls, "-sub"), {
            minWidth: dropdownWidth,
            maxHeight: "calc(100vh - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal()), ")"),
            padding: "0",
            overflow: "hidden",
            borderInlineEnd: 0,
            // https://github.com/ant-design/ant-design/issues/22244
            // https://github.com/ant-design/ant-design/issues/26812
            "&:not([class*='-active'])": {
                overflowX: "hidden",
                overflowY: "auto"
            }
        }),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-inline"), (_obj3 = {
            width: "100%"
        }, // Motion enhance for first level
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-root"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), (_obj1 = {
            display: "flex",
            alignItems: "center",
            transition: [
                "border-color ".concat(motionDurationSlow),
                "background ".concat(motionDurationSlow),
                "padding ".concat(motionDurationMid, " ").concat(motionEaseOut)
            ].join(",")
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(componentCls, "-title-content"), {
            flex: "auto",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> *", {
            flex: "none"
        }), _obj1))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-sub").concat(componentCls, "-inline"), (_obj2 = {
            padding: 0,
            border: 0,
            borderRadius: 0,
            boxShadow: "none"
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "& > ".concat(componentCls, "-submenu > ").concat(componentCls, "-submenu-title"), inlineItemStyle), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "& ".concat(componentCls, "-item-group-title"), {
            paddingInlineStart: paddingXL
        }), _obj2)), // >>>>> Item
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, "-item"), inlineItemStyle), _obj3)),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-inline-collapsed"), (_obj6 = {
            width: collapsedWidth
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&".concat(componentCls, "-root"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu ").concat(componentCls, "-submenu-title"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(componentCls, "-inline-collapsed-noicon"), {
            fontSize: fontSizeLG,
            textAlign: "center"
        }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "> ".concat(componentCls, "-item,\n          > ").concat(componentCls, "-item-group > ").concat(componentCls, "-item-group-list > ").concat(componentCls, "-item,\n          > ").concat(componentCls, "-item-group > ").concat(componentCls, "-item-group-list > ").concat(componentCls, "-submenu > ").concat(componentCls, "-submenu-title,\n          > ").concat(componentCls, "-submenu > ").concat(componentCls, "-submenu-title"), (_obj4 = {
            insetInlineStart: 0,
            paddingInline: "calc(50% - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(fontSizeLG).div(2).equal()), " - ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(itemMarginInline), ")"),
            textOverflow: "clip"
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "\n            ".concat(componentCls, "-submenu-arrow,\n            ").concat(componentCls, "-submenu-expand-icon\n          "), {
            opacity: 0
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-icon, ").concat(iconCls), {
            margin: 0,
            fontSize: collapsedIconSize,
            lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(itemHeight),
            "+ span": {
                display: "inline-block",
                opacity: 0
            }
        }), _obj4)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "".concat(componentCls, "-item-icon, ").concat(iconCls), {
            display: "inline-block"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "&-tooltip", (_obj5 = {
            pointerEvents: "none"
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-item-icon, ").concat(iconCls), {
            display: "none"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "a, a:hover", {
            color: colorTextLightSolid
        }), _obj5)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj6, "".concat(componentCls, "-item-group-title"), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$b2b65df0d0824629)), {
            paddingInline: paddingXS
        })), _obj6))
    ];
};
var $8bfa284295d5c28c$export$2e2bcd8739ae039 = $8bfa284295d5c28c$var$getVerticalStyle;


"use client";
var $404e3d94529ee490$var$genMenuItemStyle = function(token) {
    var componentCls = token.componentCls, motionDurationSlow = token.motionDurationSlow, motionDurationMid = token.motionDurationMid, motionEaseInOut = token.motionEaseInOut, motionEaseOut = token.motionEaseOut, iconCls = token.iconCls, iconSize = token.iconSize, iconMarginInlineEnd = token.iconMarginInlineEnd;
    var _obj, _obj1;
    return _obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), (_obj = {
        position: "relative",
        display: "block",
        margin: 0,
        whiteSpace: "nowrap",
        cursor: "pointer",
        transition: [
            "border-color ".concat(motionDurationSlow),
            "background ".concat(motionDurationSlow),
            "padding ".concat(motionDurationSlow, " ").concat(motionEaseInOut)
        ].join(",")
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-icon, ").concat(iconCls), {
        minWidth: iconSize,
        fontSize: iconSize,
        transition: [
            "font-size ".concat(motionDurationMid, " ").concat(motionEaseOut),
            "margin ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
            "color ".concat(motionDurationSlow)
        ].join(","),
        "+ span": {
            marginInlineStart: iconMarginInlineEnd,
            opacity: 1,
            transition: [
                "opacity ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "margin ".concat(motionDurationSlow),
                "color ".concat(motionDurationSlow)
            ].join(",")
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-icon"), Object.assign({}, (0, $7cbb7e49dbe61000$export$171ccda7bc085e59)())), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-item-only-child"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "> ".concat(iconCls, ", > ").concat(componentCls, "-item-icon"), {
        marginInlineEnd: 0
    })), _obj)), // Disabled state sets text to gray and nukes hover/tab effects
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-item-disabled, ").concat(componentCls, "-submenu-disabled"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        background: "none !important",
        cursor: "not-allowed",
        "&::after": {
            borderColor: "transparent !important"
        },
        a: {
            color: "inherit !important"
        }
    }, "> ".concat(componentCls, "-submenu-title"), {
        color: "inherit !important",
        cursor: "not-allowed"
    })), _obj1;
};
var $404e3d94529ee490$var$genSubMenuArrowStyle = function(token) {
    var componentCls = token.componentCls, motionDurationSlow = token.motionDurationSlow, motionEaseInOut = token.motionEaseInOut, borderRadius = token.borderRadius, menuArrowSize = token.menuArrowSize, menuArrowOffset = token.menuArrowOffset;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-submenu"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-expand-icon, &-arrow", {
        position: "absolute",
        top: "50%",
        insetInlineEnd: token.margin,
        width: menuArrowSize,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: "transform ".concat(motionDurationSlow, " ").concat(motionEaseInOut, ", opacity ").concat(motionDurationSlow)
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-arrow", {
        // →
        "&::before, &::after": {
            position: "absolute",
            width: token.calc(menuArrowSize).mul(0.6).equal(),
            height: token.calc(menuArrowSize).mul(0.15).equal(),
            backgroundColor: "currentcolor",
            borderRadius: borderRadius,
            transition: [
                "background ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "transform ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "top ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "color ".concat(motionDurationSlow, " ").concat(motionEaseInOut)
            ].join(","),
            content: '""'
        },
        "&::before": {
            transform: "rotate(45deg) translateY(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal()), ")")
        },
        "&::after": {
            transform: "rotate(-45deg) translateY(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(menuArrowOffset), ")")
        }
    }), _obj));
};
// =============================== Base ===============================
var $404e3d94529ee490$var$getBaseStyle = function(token) {
    var antCls = token.antCls, componentCls = token.componentCls, fontSize = token.fontSize, motionDurationSlow = token.motionDurationSlow, motionDurationMid = token.motionDurationMid, motionEaseInOut = token.motionEaseInOut, paddingXS = token.paddingXS, padding = token.padding, colorSplit = token.colorSplit, lineWidth = token.lineWidth, zIndexPopup = token.zIndexPopup, borderRadiusLG = token.borderRadiusLG, subMenuItemBorderRadius = token.subMenuItemBorderRadius, menuArrowSize = token.menuArrowSize, menuArrowOffset = token.menuArrowOffset, lineType = token.lineType, menuPanelMaskInset = token.menuPanelMaskInset, groupTitleLineHeight = token.groupTitleLineHeight, groupTitleFontSize = token.groupTitleFontSize;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            "": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls), Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), // Hidden
            (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&-hidden", {
                display: "none"
            })))
        }, "".concat(componentCls, "-submenu-hidden"), {
            display: "none"
        }),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $7cbb7e49dbe61000$export$8c467e8859fdef13)()), (_obj = {
            marginBottom: 0,
            paddingInlineStart: 0,
            // Override default ul/ol
            fontSize: fontSize,
            lineHeight: 0,
            listStyle: "none",
            outline: "none",
            // Magic cubic here but smooth transition
            transition: "width ".concat(motionDurationSlow, " cubic-bezier(0.2, 0, 0, 1) 0s")
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "ul, ol", {
            margin: 0,
            padding: 0,
            listStyle: "none"
        }), // Overflow ellipsis
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-overflow", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            display: "flex"
        }, "".concat(componentCls, "-item"), {
            flex: "none"
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu, ").concat(componentCls, "-submenu-title"), {
            borderRadius: token.itemBorderRadius
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-group-title"), {
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingXS), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(padding)),
            fontSize: groupTitleFontSize,
            lineHeight: groupTitleLineHeight,
            transition: "all ".concat(motionDurationSlow)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-horizontal ".concat(componentCls, "-submenu"), {
            transition: [
                "border-color ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "background ".concat(motionDurationSlow, " ").concat(motionEaseInOut)
            ].join(",")
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu, ").concat(componentCls, "-submenu-inline"), {
            transition: [
                "border-color ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "background ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "padding ".concat(motionDurationMid, " ").concat(motionEaseInOut)
            ].join(",")
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-submenu ").concat(componentCls, "-sub"), {
            cursor: "initial",
            transition: [
                "background ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
                "padding ".concat(motionDurationSlow, " ").concat(motionEaseInOut)
            ].join(",")
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-title-content"), // https://github.com/ant-design/ant-design/issues/41143
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            transition: "color ".concat(motionDurationSlow)
        }, "> ".concat(antCls, "-typography-ellipsis-single-line"), {
            display: "inline",
            verticalAlign: "unset"
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item a"), {
            "&::before": {
                position: "absolute",
                inset: 0,
                backgroundColor: "transparent",
                content: '""'
            }
        }), // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-item-divider"), {
            overflow: "hidden",
            lineHeight: 0,
            borderColor: colorSplit,
            borderStyle: lineType,
            borderWidth: 0,
            borderTopWidth: lineWidth,
            marginBlock: lineWidth,
            padding: 0,
            "&-dashed": {
                borderStyle: "dashed"
            }
        }), _obj)), $404e3d94529ee490$var$genMenuItemStyle(token)), (_obj4 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-item-group"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, "-item-group-list"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            margin: 0,
            padding: 0
        }, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), {
            paddingInline: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal()), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(padding))
        }))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, // ======================= Sub Menu =======================
        "&-submenu", (_obj3 = {
            "&-popup": (_obj1 = {
                position: "absolute",
                zIndex: zIndexPopup,
                borderRadius: borderRadiusLG,
                boxShadow: "none",
                transformOrigin: "0 0"
            }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-submenu"), {
                background: "transparent"
            }), // https://github.com/ant-design/ant-design/issues/13955
            (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&::before", {
                position: "absolute",
                inset: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(menuPanelMaskInset), " 0 0"),
                zIndex: -1,
                width: "100%",
                height: "100%",
                opacity: 0,
                content: '""'
            }), _obj1),
            // https://github.com/ant-design/ant-design/issues/13955
            "&-placement-rightTop::before": {
                top: 0,
                insetInlineStart: menuPanelMaskInset
            }
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ", {
            transformOrigin: "100% 0"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ", {
            transformOrigin: "100% 100%"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ", {
            transformOrigin: "0 100%"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ", {
            transformOrigin: "0 0"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ", {
            paddingInlineEnd: token.paddingXS
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ", {
            paddingInlineStart: token.paddingXS
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-topRight,\n          &-placement-topLeft\n          ", {
            paddingBottom: token.paddingXS
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ", {
            paddingTop: token.paddingXS
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "> ".concat(componentCls), Object.assign(Object.assign(Object.assign({
            borderRadius: borderRadiusLG
        }, $404e3d94529ee490$var$genMenuItemStyle(token)), $404e3d94529ee490$var$genSubMenuArrowStyle(token)), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu > ").concat(componentCls, "-submenu-title"), {
            borderRadius: subMenuItemBorderRadius
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-submenu-title::after"), {
            transition: "transform ".concat(motionDurationSlow, " ").concat(motionEaseInOut)
        }), _obj2))), _obj3)), _obj4)), $404e3d94529ee490$var$genSubMenuArrowStyle(token)), (_obj5 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "&-inline-collapsed ".concat(componentCls, "-submenu-arrow,\n        &-inline ").concat(componentCls, "-submenu-arrow"), {
            // ↓
            "&::before": {
                transform: "rotate(-45deg) translateX(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(menuArrowOffset), ")")
            },
            "&::after": {
                transform: "rotate(45deg) translateX(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal()), ")")
            }
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj5, "".concat(componentCls, "-submenu-open").concat(componentCls, "-submenu-inline > ").concat(componentCls, "-submenu-title > ").concat(componentCls, "-submenu-arrow"), {
            // ↑
            transform: "translateY(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal()), ")"),
            "&::after": {
                transform: "rotate(-45deg) translateX(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal()), ")")
            },
            "&::before": {
                transform: "rotate(45deg) translateX(".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(menuArrowOffset), ")")
            }
        }), _obj5))),
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(antCls, "-layout-header"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, {
            lineHeight: "inherit"
        }))
    ];
};
var $404e3d94529ee490$export$9ca1be8807fe0675 = function(token) {
    var colorPrimary = token.colorPrimary, colorError = token.colorError, colorTextDisabled = token.colorTextDisabled, colorErrorBg = token.colorErrorBg, colorText = token.colorText, colorTextDescription = token.colorTextDescription, colorBgContainer = token.colorBgContainer, colorFillAlter = token.colorFillAlter, colorFillContent = token.colorFillContent, lineWidth = token.lineWidth, lineWidthBold = token.lineWidthBold, controlItemBgActive = token.controlItemBgActive, colorBgTextHover = token.colorBgTextHover, controlHeightLG = token.controlHeightLG, lineHeight = token.lineHeight, colorBgElevated = token.colorBgElevated, marginXXS = token.marginXXS, padding = token.padding, fontSize = token.fontSize, controlHeightSM = token.controlHeightSM, fontSizeLG = token.fontSizeLG, colorTextLightSolid = token.colorTextLightSolid, colorErrorHover = token.colorErrorHover;
    var colorTextDark = new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorTextLightSolid).setAlpha(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: "transparent",
        horizontalItemSelectedBg: "transparent",
        colorActiveBarWidth: 0,
        activeBarWidth: 0,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: lineWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: token.marginXXS,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: "transparent",
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: "".concat(controlHeightLG * 1.15, "px"),
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(colorTextLightSolid).setAlpha(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: "#001529",
        darkPopupBg: "#001529",
        darkSubMenuItemBg: "#000c17",
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: "transparent",
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: ""
    };
};
var $404e3d94529ee490$export$c75c4d82116b857c = function(token) {
    return Object.assign(Object.assign({}, token), {
        itemWidth: token.activeBarWidth ? "calc(100% + ".concat(token.activeBarBorderWidth, "px)") : "calc(100% - ".concat(token.itemMarginInline * 2, "px)")
    });
};
var // ============================== Export ==============================
$404e3d94529ee490$export$2e2bcd8739ae039 = function(prefixCls) {
    var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
    var injectStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var useStyle = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Menu", function(token) {
        var colorBgElevated = token.colorBgElevated, colorPrimary = token.colorPrimary, colorTextLightSolid = token.colorTextLightSolid, controlHeightLG = token.controlHeightLG, fontSize = token.fontSize, darkItemColor = token.darkItemColor, darkDangerItemColor = token.darkDangerItemColor, darkItemBg = token.darkItemBg, darkSubMenuItemBg = token.darkSubMenuItemBg, darkItemSelectedColor = token.darkItemSelectedColor, darkItemSelectedBg = token.darkItemSelectedBg, darkDangerItemSelectedBg = token.darkDangerItemSelectedBg, darkItemHoverBg = token.darkItemHoverBg, darkGroupTitleColor = token.darkGroupTitleColor, darkItemHoverColor = token.darkItemHoverColor, darkItemDisabledColor = token.darkItemDisabledColor, darkDangerItemHoverColor = token.darkDangerItemHoverColor, darkDangerItemSelectedColor = token.darkDangerItemSelectedColor, darkDangerItemActiveBg = token.darkDangerItemActiveBg;
        var menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        var menuToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuPanelMaskInset: -7,
            // Still a hardcode here since it's offset by rc-align
            menuSubMenuBg: colorBgElevated,
            calc: token.calc
        });
        var menuDarkToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkItemBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: "transparent",
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: colorTextLightSolid,
            horizontalItemSelectedBg: colorPrimary
        });
        return [
            // Basic
            $404e3d94529ee490$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $4926e2745b2fefdc$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $8bfa284295d5c28c$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $b300fe94f0014d97$export$2e2bcd8739ae039)(menuToken, "light"),
            (0, $b300fe94f0014d97$export$2e2bcd8739ae039)(menuDarkToken, "dark"),
            // RTL
            (0, $bd02d388527c87e8$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $8ef0140f2d9ac191$export$2e2bcd8739ae039)(menuToken),
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(menuToken, "slide-up"),
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(menuToken, "slide-down"),
            (0, $41928187f0cc1a97$export$f5d123412490d9dc)(menuToken, "zoom-big")
        ];
    }, $404e3d94529ee490$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                "colorGroupTitle",
                "groupTitleColor"
            ],
            [
                "radiusItem",
                "itemBorderRadius"
            ],
            [
                "radiusSubMenuItem",
                "subMenuItemBorderRadius"
            ],
            [
                "colorItemText",
                "itemColor"
            ],
            [
                "colorItemTextHover",
                "itemHoverColor"
            ],
            [
                "colorItemTextHoverHorizontal",
                "horizontalItemHoverColor"
            ],
            [
                "colorItemTextSelected",
                "itemSelectedColor"
            ],
            [
                "colorItemTextSelectedHorizontal",
                "horizontalItemSelectedColor"
            ],
            [
                "colorItemTextDisabled",
                "itemDisabledColor"
            ],
            [
                "colorDangerItemText",
                "dangerItemColor"
            ],
            [
                "colorDangerItemTextHover",
                "dangerItemHoverColor"
            ],
            [
                "colorDangerItemTextSelected",
                "dangerItemSelectedColor"
            ],
            [
                "colorDangerItemBgActive",
                "dangerItemActiveBg"
            ],
            [
                "colorDangerItemBgSelected",
                "dangerItemSelectedBg"
            ],
            [
                "colorItemBg",
                "itemBg"
            ],
            [
                "colorItemBgHover",
                "itemHoverBg"
            ],
            [
                "colorSubItemBg",
                "subMenuItemBg"
            ],
            [
                "colorItemBgActive",
                "itemActiveBg"
            ],
            [
                "colorItemBgSelectedHorizontal",
                "horizontalItemSelectedBg"
            ],
            [
                "colorActiveBarWidth",
                "activeBarWidth"
            ],
            [
                "colorActiveBarHeight",
                "activeBarHeight"
            ],
            [
                "colorActiveBarBorderSize",
                "activeBarBorderWidth"
            ],
            [
                "colorItemBgSelected",
                "itemSelectedBg"
            ]
        ],
        format: $404e3d94529ee490$export$c75c4d82116b857c,
        // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle: injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



"use client";
var $d572b90fa27499b5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d572b90fa27499b5$var$InternalMenu = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var _a, _b;
    var override = $8SyCD.useContext((0, $f047de512ec73bad$export$2e2bcd8739ae039));
    var overrideObj = override || {};
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, getPopupContainer = _React_useContext.getPopupContainer, direction = _React_useContext.direction, menu = _React_useContext.menu;
    var rootPrefixCls = getPrefixCls();
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, _props_theme = props.theme, theme = _props_theme === void 0 ? "light" : _props_theme, expandIcon = props.expandIcon, _internalDisableMenuItemTitleTooltip = props._internalDisableMenuItemTitleTooltip, inlineCollapsed = props.inlineCollapsed, siderCollapsed = props.siderCollapsed, items = props.items, children = props.children, rootClassName = props.rootClassName, mode = props.mode, selectable = props.selectable, onClick = props.onClick, overflowedIndicatorPopupClassName = props.overflowedIndicatorPopupClassName, restProps = $d572b90fa27499b5$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "items",
        "children",
        "rootClassName",
        "mode",
        "selectable",
        "onClick",
        "overflowedIndicatorPopupClassName"
    ]);
    var passedProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(restProps, [
        "collapsedWidth"
    ]);
    // ========================= Items ===========================
    var mergedChildren = (0, $aae4b1d2ef8d9ab9$export$2e2bcd8739ae039)(items) || children;
    (_a = overrideObj.validator) === null || _a === void 0 || _a.call(overrideObj, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    var onItemClick = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = overrideObj.onClick) === null || _a === void 0 || _a.call(overrideObj);
    });
    // ========================== Mode ===========================
    var mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    var mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    var mergedInlineCollapsed = $8SyCD.useMemo(function() {
        if (siderCollapsed !== undefined) return siderCollapsed;
        return inlineCollapsed;
    }, [
        inlineCollapsed,
        siderCollapsed
    ]);
    var defaultMotions = {
        horizontal: {
            motionName: "".concat(rootPrefixCls, "-slide-up")
        },
        inline: (0, $800f705b9f73a72d$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: "".concat(rootPrefixCls, "-zoom-big")
        }
    };
    var prefixCls = getPrefixCls("menu", customizePrefixCls || overrideObj.prefixCls);
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $404e3d94529ee490$export$2e2bcd8739ae039)(prefixCls, rootCls, !override), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-").concat(theme), menu === null || menu === void 0 ? void 0 : menu.className, className);
    // ====================== Expand Icon ========================
    var mergedExpandIcon;
    if (typeof expandIcon === "function") mergedExpandIcon = expandIcon;
    else if (expandIcon === null || expandIcon === false) mergedExpandIcon = null;
    else if (overrideObj.expandIcon === null || overrideObj.expandIcon === false) mergedExpandIcon = null;
    else {
        var beClone = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj.expandIcon;
        mergedExpandIcon = (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(beClone, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-submenu-expand-icon"), (0, $70bdd1d9fe5ae128$export$a8257692ac88316c)(beClone) ? (_b = beClone.props) === null || _b === void 0 ? void 0 : _b.className : "")
        });
    }
    // ======================== Context ==========================
    var contextValue = $8SyCD.useMemo(function() {
        return {
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        };
    }, [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme
    ]);
    // ========================= Render ==========================
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $f047de512ec73bad$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $8SyCD.createElement((0, $65112bb01210c9ec$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8SyCD.createElement((0, $8a5b1a1fc083948f$export$2e2bcd8739ae039), Object.assign({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $8SyCD.createElement((0, $f4c5b4a4a3d18e7e$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-").concat(theme), overflowedIndicatorPopupClassName),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style),
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(rootClassName, hashId, overrideObj.rootClassName, rootCls)
    }), mergedChildren))));
});
var $d572b90fa27499b5$export$2e2bcd8739ae039 = $d572b90fa27499b5$var$InternalMenu;


"use client";
var $7207fff4b0bfc7bd$var$Menu = /*#__PURE__*/ (0, $8SyCD.forwardRef)(function(props, ref) {
    var menuRef = (0, $8SyCD.useRef)(null);
    var context = $8SyCD.useContext((0, $40d0a8d7e7a928c2$export$63554aebd2a6d54c));
    (0, $8SyCD.useImperativeHandle)(ref, function() {
        return {
            menu: menuRef.current,
            focus: function(options) {
                var _a;
                (_a = menuRef.current) === null || _a === void 0 || _a.focus(options);
            }
        };
    });
    return /*#__PURE__*/ $8SyCD.createElement((0, $d572b90fa27499b5$export$2e2bcd8739ae039), Object.assign({
        ref: menuRef
    }, props, context));
});
$7207fff4b0bfc7bd$var$Menu.Item = (0, $15537eb65696272d$export$2e2bcd8739ae039);
$7207fff4b0bfc7bd$var$Menu.SubMenu = (0, $27a438b646042d02$export$2e2bcd8739ae039);
$7207fff4b0bfc7bd$var$Menu.Divider = (0, $7d7156ca421c64e2$export$2e2bcd8739ae039);
$7207fff4b0bfc7bd$var$Menu.ItemGroup = (0, $6f7743c1b4881b15$export$2e2bcd8739ae039);
var $7207fff4b0bfc7bd$export$2e2bcd8739ae039 = $7207fff4b0bfc7bd$var$Menu;










var $829b7188f0e1b8fc$var$genStatusStyle = function(token) {
    var componentCls = token.componentCls, menuCls = token.menuCls, colorError = token.colorError, colorTextLightSolid = token.colorTextLightSolid;
    var itemCls = "".concat(menuCls, "-item");
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(menuCls, " ").concat(itemCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(itemCls, "-danger:not(").concat(itemCls, "-disabled)"), {
        color: colorError,
        "&:hover": {
            color: colorTextLightSolid,
            backgroundColor: colorError
        }
    })));
};
var $829b7188f0e1b8fc$export$2e2bcd8739ae039 = $829b7188f0e1b8fc$var$genStatusStyle;




// =============================== Base ===============================
var $6a1528b61b95cb27$var$genBaseStyle = function(token) {
    var componentCls = token.componentCls, menuCls = token.menuCls, zIndexPopup = token.zIndexPopup, dropdownArrowDistance = token.dropdownArrowDistance, sizePopupArrow = token.sizePopupArrow, antCls = token.antCls, iconCls = token.iconCls, motionDurationMid = token.motionDurationMid, paddingBlock = token.paddingBlock, fontSize = token.fontSize, dropdownEdgeChildPadding = token.dropdownEdgeChildPadding, colorTextDisabled = token.colorTextDisabled, fontSizeIcon = token.fontSizeIcon, controlPaddingHorizontal = token.controlPaddingHorizontal, colorBgElevated = token.colorBgElevated;
    var _obj, _obj1, _obj2, _obj3;
    return [
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj1 = {
            position: "absolute",
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: zIndexPopup,
            display: "block",
            // A placeholder out of dropdown visible range to avoid close when user moving
            "&::before": {
                position: "absolute",
                insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                zIndex: -9999,
                opacity: 0.0001,
                content: '""'
            }
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-trigger".concat(antCls, "-btn"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "& > ".concat(iconCls, "-down, & > ").concat(antCls, "-btn-icon > ").concat(iconCls, "-down"), {
            fontSize: fontSizeIcon
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-wrap"), (_obj = {
            position: "relative"
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(antCls, "-btn > ").concat(iconCls, "-down"), {
            fontSize: fontSizeIcon
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(iconCls, "-down::before"), {
            transition: "transform ".concat(motionDurationMid)
        }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-wrap-open"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(iconCls, "-down::before"), {
            transform: "rotate(180deg)"
        })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ", {
            display: "none"
        }), // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottomRight,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottomRight"), {
            animationName: (0, $b219a2444a723b10$export$e801b802b037de6a)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-topRight,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-topRight"), {
            animationName: (0, $b219a2444a723b10$export$dd9f089fa5e819fe)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottomRight"), {
            animationName: (0, $b219a2444a723b10$export$f40f41df328ebc38)
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-topRight"), {
            animationName: (0, $b219a2444a723b10$export$f7243fdb9c27c3b7)
        }), _obj1))),
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $cbbf254d657cc278$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        (_obj3 = {}, // =============================================================
        // ==                          Menu                           ==
        // =============================================================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, " ").concat(menuCls), {
            position: "relative",
            margin: 0
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(menuCls, "-submenu-popup"), {
            position: "absolute",
            zIndex: zIndexPopup,
            background: "transparent",
            boxShadow: "none",
            transformOrigin: "0 0",
            "ul, li": {
                listStyle: "none",
                margin: 0
            }
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, menuCls, Object.assign(Object.assign({
            padding: dropdownEdgeChildPadding,
            listStyleType: "none",
            backgroundColor: colorBgElevated,
            backgroundClip: "padding-box",
            borderRadius: token.borderRadiusLG,
            outline: "none",
            boxShadow: token.boxShadowSecondary
        }, (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token)), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-item-group-title"), {
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingBlock), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(controlPaddingHorizontal)),
            color: token.colorTextDescription,
            transition: "all ".concat(motionDurationMid)
        }), // ======================= Item Content =======================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-item"), {
            position: "relative",
            display: "flex",
            alignItems: "center"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-item-icon"), {
            minWidth: fontSize,
            marginInlineEnd: token.marginXS,
            fontSize: token.fontSizeSM
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-title-content"), {
            flex: "auto",
            "> a": {
                color: "inherit",
                transition: "all ".concat(motionDurationMid),
                "&:hover": {
                    color: "inherit"
                },
                "&::after": {
                    position: "absolute",
                    inset: 0,
                    content: '""'
                }
            }
        }), // =========================== Item ===========================
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-item, ").concat(menuCls, "-submenu-title"), Object.assign(Object.assign((0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            clear: "both",
            margin: 0,
            padding: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(paddingBlock), " ").concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(controlPaddingHorizontal)),
            color: token.colorText,
            fontWeight: "normal",
            fontSize: fontSize,
            lineHeight: token.lineHeight,
            cursor: "pointer",
            transition: "all ".concat(motionDurationMid),
            borderRadius: token.borderRadiusSM
        }, "&:hover, &-active", {
            backgroundColor: token.controlItemBgHover
        }), (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            "&-selected": {
                color: token.colorPrimary,
                backgroundColor: token.controlItemBgActive,
                "&:hover, &-active": {
                    backgroundColor: token.controlItemBgActiveHover
                }
            },
            "&-disabled": {
                color: colorTextDisabled,
                cursor: "not-allowed",
                "&:hover": {
                    color: colorTextDisabled,
                    backgroundColor: colorBgElevated,
                    cursor: "not-allowed"
                },
                a: {
                    pointerEvents: "none"
                }
            },
            "&-divider": {
                height: 1,
                // By design
                margin: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginXXS), " 0"),
                overflow: "hidden",
                lineHeight: 0,
                backgroundColor: token.colorSplit
            }
        }, "".concat(componentCls, "-menu-submenu-expand-icon"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            position: "absolute",
            insetInlineEnd: token.paddingXS
        }, "".concat(componentCls, "-menu-submenu-arrow-icon"), {
            marginInlineEnd: "0 !important",
            color: token.colorTextDescription,
            fontSize: fontSizeIcon,
            fontStyle: "normal"
        })))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-item-group-list"), {
            margin: "0 ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.marginXS)),
            padding: 0,
            listStyle: "none"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-submenu-title"), {
            paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-submenu-vertical"), {
            position: "relative"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-submenu").concat(menuCls, "-submenu-disabled ").concat(componentCls, "-menu-submenu-title"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&, ".concat(componentCls, "-menu-submenu-arrow-icon"), {
            color: colorTextDisabled,
            backgroundColor: colorBgElevated,
            cursor: "not-allowed"
        })), // https://github.com/ant-design/ant-design/issues/19264
        (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(menuCls, "-submenu-selected ").concat(componentCls, "-menu-submenu-title"), {
            color: token.colorPrimary
        }), _obj2)))), _obj3),
        // Follow code may reuse in other components
        [
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $b219a2444a723b10$export$9018e60daecf7a6c)(token, "slide-down"),
            (0, $5a5f31c29f75b421$export$913b1b7e3288c319)(token, "move-up"),
            (0, $5a5f31c29f75b421$export$913b1b7e3288c319)(token, "move-down"),
            (0, $41928187f0cc1a97$export$f5d123412490d9dc)(token, "zoom-big")
        ]
    ];
};
var $6a1528b61b95cb27$export$9ca1be8807fe0675 = function(token) {
    return Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2
    }, (0, $cbbf254d657cc278$export$bddc192327bb9823)({
        contentRadius: token.borderRadiusLG,
        limitVerticalRadius: true
    })), (0, $23bff83d966bcedf$export$87e38ee403661ccc)(token));
};
var $6a1528b61b95cb27$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Dropdown", function(token) {
    var marginXXS = token.marginXXS, sizePopupArrow = token.sizePopupArrow, paddingXXS = token.paddingXXS, componentCls = token.componentCls;
    var dropdownToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        menuCls: "".concat(componentCls, "-menu"),
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $6a1528b61b95cb27$var$genBaseStyle(dropdownToken),
        (0, $829b7188f0e1b8fc$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $6a1528b61b95cb27$export$9ca1be8807fe0675);



"use client";
var $d18dc2df4a7fcd55$var$Placements = [
    "topLeft",
    "topCenter",
    "topRight",
    "bottomLeft",
    "bottomCenter",
    "bottomRight",
    "top",
    "bottom"
];
var $d18dc2df4a7fcd55$var$Dropdown = function(props) {
    var menu = props.menu, arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, dropdownRender = props.dropdownRender, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName, rootClassName = props.rootClassName, overlayStyle = props.overlayStyle, open = props.open, onOpenChange = props.onOpenChange, // Deprecated
    visible = props.visible, onVisibleChange = props.onVisibleChange, _props_mouseEnterDelay = props.mouseEnterDelay, mouseEnterDelay = _props_mouseEnterDelay === void 0 ? 0.15 : _props_mouseEnterDelay, _props_mouseLeaveDelay = props.mouseLeaveDelay, mouseLeaveDelay = _props_mouseLeaveDelay === void 0 ? 0.1 : _props_mouseLeaveDelay, _props_autoAdjustOverflow = props.autoAdjustOverflow, autoAdjustOverflow = _props_autoAdjustOverflow === void 0 ? true : _props_autoAdjustOverflow, _props_placement = props.placement, placement = _props_placement === void 0 ? "" : _props_placement, overlay = props.overlay, transitionName = props.transitionName;
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React_useContext.getPopupContainer, getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, dropdown = _React_useContext.dropdown;
    // Warning for deprecated usage
    var warning = (0, $a45ff4e670d5554a$export$cf977aa92c751e61)("Dropdown");
    var _ref;
    var memoTransitionName = $8SyCD.useMemo(function() {
        var rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes("top")) return "".concat(rootPrefixCls, "-slide-down");
        return "".concat(rootPrefixCls, "-slide-up");
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    var memoPlacement = $8SyCD.useMemo(function() {
        if (!placement) return direction === "rtl" ? "bottomRight" : "bottomLeft";
        if (placement.includes("Center")) return placement.slice(0, placement.indexOf("Center"));
        return placement;
    }, [
        placement,
        direction
    ]);
    var _ref2;
    var prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    var rootCls = (0, $b2ac4197b57fad70$export$2e2bcd8739ae039)(prefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $6a1528b61b95cb27$export$2e2bcd8739ae039)(prefixCls, rootCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _useToken = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4686879ac4f429c9$export$2e2bcd8739ae039)(), 2), token = _useToken[1];
    var child = $8SyCD.Children.only(children);
    var dropdownTrigger = (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-trigger"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), child.props.className),
        disabled: disabled
    });
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;
    if (triggerActions && triggerActions.includes("contextMenu")) alignPoint = true;
    // =========================== Open ============================
    var _useMergedState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        value: open !== null && open !== void 0 ? open : visible
    }), 2), mergedOpen = _useMergedState[0], setOpen = _useMergedState[1];
    var onInnerOpenChange = (0, $fa203615ea0be7e2$export$2e2bcd8739ae039)(function(nextOpen) {
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen, {
            source: "trigger"
        });
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    var overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(overlayClassName, rootClassName, hashId, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"));
    var builtinPlacements = (0, $7872110b38a3dec0$export$2e2bcd8739ae039)({
        arrowPointAtCenter: typeof arrow === "object" && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    var onMenuClick = $8SyCD.useCallback(function() {
        if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) return;
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(false, {
            source: "menu"
        });
        setOpen(false);
    }, [
        menu === null || menu === void 0 ? void 0 : menu.selectable,
        menu === null || menu === void 0 ? void 0 : menu.multiple
    ]);
    var renderOverlay = function() {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        var overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $8SyCD.createElement((0, $7207fff4b0bfc7bd$export$2e2bcd8739ae039), Object.assign({}, menu));
        else if (typeof overlay === "function") overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $8SyCD.Children.only(typeof overlayNode === "string" ? /*#__PURE__*/ $8SyCD.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $8SyCD.createElement((0, $f047de512ec73bad$export$9bd434816b0530d0), {
            prefixCls: "".concat(prefixCls, "-menu"),
            rootClassName: rootCls,
            expandIcon: /*#__PURE__*/ $8SyCD.createElement("span", {
                className: "".concat(prefixCls, "-menu-submenu-arrow")
            }, /*#__PURE__*/ $8SyCD.createElement((0, $d282c3c50daf5fec$export$2e2bcd8739ae039), {
                className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: function(_ref3) {
                var mode = _ref3.mode;
            }
        }, overlayNode);
    };
    // =========================== zIndex ============================
    var _useZIndex = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $4d9cc5bfe7391b56$export$3e7906d4075187a4)("Dropdown", overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex), 2), zIndex = _useZIndex[0], contextZIndex = _useZIndex[1];
    // ============================ Render ============================
    var renderNode = /*#__PURE__*/ $8SyCD.createElement((0, $ffea931b2b562e41$export$2e2bcd8739ae039), Object.assign({
        alignPoint: alignPoint
    }, (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(props, [
        "rootClassName"
    ]), {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
            zIndex: zIndex
        })
    }), dropdownTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $8SyCD.createElement((0, $7aa43d76a03d0c4e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return wrapCSSVar(renderNode);
};
function $d18dc2df4a7fcd55$var$postPureProps(props) {
    return Object.assign(Object.assign({}, props), {
        align: {
            overflow: {
                adjustX: false,
                adjustY: false
            }
        }
    });
}
// We don't care debug panel
var $d18dc2df4a7fcd55$var$PurePanel = (0, $d09d87be952d49db$export$2e2bcd8739ae039)($d18dc2df4a7fcd55$var$Dropdown, "dropdown", function(prefixCls) {
    return prefixCls;
}, $d18dc2df4a7fcd55$var$postPureProps);
/* istanbul ignore next */ var $d18dc2df4a7fcd55$var$WrapPurePanel = function(props) {
    return /*#__PURE__*/ $8SyCD.createElement($d18dc2df4a7fcd55$var$PurePanel, Object.assign({}, props), /*#__PURE__*/ $8SyCD.createElement("span", null));
};
$d18dc2df4a7fcd55$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $d18dc2df4a7fcd55$var$WrapPurePanel;
var $d18dc2df4a7fcd55$export$2e2bcd8739ae039 = $d18dc2df4a7fcd55$var$Dropdown;





var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");
var $e98be207e63604ed$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).createContext({
    latestIndex: 0
});
var $e98be207e63604ed$export$2bbf36e6e96e17f9 = $e98be207e63604ed$export$853f607fd5cc208b.Provider;



var $8SyCD = parcelRequire("8SyCD");

"use client";
var $619c85722346e6cf$var$Item = function(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, split = _ref.split, style = _ref.style;
    var latestIndex = $8SyCD.useContext((0, $e98be207e63604ed$export$853f607fd5cc208b)).latestIndex;
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, /*#__PURE__*/ $8SyCD.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(className, "-split")
    }, split));
};
var $619c85722346e6cf$export$2e2bcd8739ae039 = $619c85722346e6cf$var$Item;



"use client";
var $4f23ba815494acf0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4f23ba815494acf0$var$Space = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _a, _b;
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, space = _React_useContext.space, directionConfig = _React_useContext.direction;
    var _props_size = props.size, size = _props_size === void 0 ? (space === null || space === void 0 ? void 0 : space.size) || "small" : _props_size, align = props.align, className = props.className, rootClassName = props.rootClassName, children = props.children, _props_direction = props.direction, direction = _props_direction === void 0 ? "horizontal" : _props_direction, customizePrefixCls = props.prefixCls, split = props.split, style = props.style, _props_wrap = props.wrap, wrap = _props_wrap === void 0 ? false : _props_wrap, customClassNames = props.classNames, styles = props.styles, otherProps = $4f23ba815494acf0$var$__rest(props, [
        "size",
        "align",
        "className",
        "rootClassName",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap",
        "classNames",
        "styles"
    ]);
    var _ref = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(Array.isArray(size) ? size : [
        size,
        size
    ], 2), horizontalSize = _ref[0], verticalSize = _ref[1];
    var isPresetVerticalSize = (0, $64f282d705d00642$export$f5153c3888a6824e)(verticalSize);
    var isPresetHorizontalSize = (0, $64f282d705d00642$export$f5153c3888a6824e)(horizontalSize);
    var isValidVerticalSize = (0, $64f282d705d00642$export$1b502d0a9135d42b)(verticalSize);
    var isValidHorizontalSize = (0, $64f282d705d00642$export$1b502d0a9135d42b)(horizontalSize);
    var childNodes = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    var mergedAlign = align === undefined && direction === "horizontal" ? "center" : align;
    var prefixCls = getPrefixCls("space", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a876ddbfa81c095a$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, space === null || space === void 0 ? void 0 : space.className, hashId, "".concat(prefixCls, "-").concat(direction), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), directionConfig === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-align-").concat(mergedAlign), mergedAlign), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-gap-row-").concat(verticalSize), isPresetVerticalSize), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-gap-col-").concat(horizontalSize), isPresetHorizontalSize), _obj), className, rootClassName);
    var itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-item"), (_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _a !== void 0 ? _a : (_b = space === null || space === void 0 ? void 0 : space.classNames) === null || _b === void 0 ? void 0 : _b.item);
    // Calculate latest one
    var latestIndex = 0;
    var nodes = childNodes.map(function(child, i) {
        var _a, _b;
        if (child !== null && child !== undefined) latestIndex = i;
        var key = child && child.key || "".concat(itemClassName, "-").concat(i);
        return /*#__PURE__*/ $8SyCD.createElement((0, $619c85722346e6cf$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            index: i,
            split: split,
            style: (_a = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a !== void 0 ? _a : (_b = space === null || space === void 0 ? void 0 : space.styles) === null || _b === void 0 ? void 0 : _b.item
        }, child);
    });
    var spaceContext = $8SyCD.useMemo(function() {
        return {
            latestIndex: latestIndex
        };
    }, [
        latestIndex
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    var gapStyle = {};
    if (wrap) gapStyle.flexWrap = "wrap";
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        ref: ref,
        className: cls,
        style: Object.assign(Object.assign(Object.assign({}, gapStyle), space === null || space === void 0 ? void 0 : space.style), style)
    }, otherProps), /*#__PURE__*/ $8SyCD.createElement((0, $e98be207e63604ed$export$2bbf36e6e96e17f9), {
        value: spaceContext
    }, nodes)));
});
var $4f23ba815494acf0$var$CompoundedSpace = $4f23ba815494acf0$var$Space;
$4f23ba815494acf0$var$CompoundedSpace.Compact = (0, $e2e782fcf54617f6$export$2e2bcd8739ae039);
var $4f23ba815494acf0$export$2e2bcd8739ae039 = $4f23ba815494acf0$var$CompoundedSpace;




"use client";
var $ef88de4a7ca7e351$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ef88de4a7ca7e351$var$DropdownButton = function(props) {
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React_useContext.getPopupContainer, getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var customizePrefixCls = props.prefixCls, _props_type = props.type, type = _props_type === void 0 ? "default" : _props_type, danger = props.danger, disabled = props.disabled, loading = props.loading, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, menu = props.menu, arrow = props.arrow, autoFocus = props.autoFocus, overlay = props.overlay, trigger = props.trigger, align = props.align, open = props.open, onOpenChange = props.onOpenChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _props_icon = props.icon, icon = _props_icon === void 0 ? /*#__PURE__*/ $8SyCD.createElement((0, $f4c5b4a4a3d18e7e$export$2e2bcd8739ae039), null) : _props_icon, title = props.title, _props_buttonsRender = props.buttonsRender, buttonsRender = _props_buttonsRender === void 0 ? function(buttons) {
        return buttons;
    } : _props_buttonsRender, mouseEnterDelay = props.mouseEnterDelay, mouseLeaveDelay = props.mouseLeaveDelay, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, destroyPopupOnHide = props.destroyPopupOnHide, dropdownRender = props.dropdownRender, restProps = $ef88de4a7ca7e351$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "open",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide",
        "dropdownRender"
    ]);
    var prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    var buttonPrefixCls = "".concat(prefixCls, "-button");
    var dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide,
        dropdownRender: dropdownRender
    };
    var _useCompactItemContext = (0, $e2e782fcf54617f6$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContext.compactSize, compactItemClassnames = _useCompactItemContext.compactItemClassnames;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(buttonPrefixCls, compactItemClassnames, className);
    if ("overlay" in props) dropdownProps.overlay = overlay;
    if ("open" in props) dropdownProps.open = open;
    if ("placement" in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === "rtl" ? "bottomLeft" : "bottomRight";
    var leftButton = /*#__PURE__*/ $8SyCD.createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    var rightButton = /*#__PURE__*/ $8SyCD.createElement((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    var _buttonsRender = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(buttonsRender([
        leftButton,
        rightButton
    ]), 2), leftButtonToRender = _buttonsRender[0], rightButtonToRender = _buttonsRender[1];
    return /*#__PURE__*/ $8SyCD.createElement((0, $4f23ba815494acf0$export$2e2bcd8739ae039).Compact, Object.assign({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $8SyCD.createElement((0, $d18dc2df4a7fcd55$export$2e2bcd8739ae039), Object.assign({}, dropdownProps), rightButtonToRender));
};
$ef88de4a7ca7e351$var$DropdownButton.__ANT_BUTTON = true;
var $ef88de4a7ca7e351$export$2e2bcd8739ae039 = $ef88de4a7ca7e351$var$DropdownButton;


"use client";
var $1819c5248ff6edcc$var$Dropdown = (0, $d18dc2df4a7fcd55$export$2e2bcd8739ae039);
$1819c5248ff6edcc$var$Dropdown.Button = (0, $ef88de4a7ca7e351$export$2e2bcd8739ae039);
var $1819c5248ff6edcc$export$2e2bcd8739ae039 = $1819c5248ff6edcc$var$Dropdown;




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $f42acc19a0845dbc$var$TranslationOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "defs",
                attrs: {},
                children: [
                    {
                        tag: "style",
                        attrs: {}
                    }
                ]
            },
            {
                tag: "path",
                attrs: {
                    d: "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z"
                }
            }
        ]
    },
    name: "translation",
    theme: "outlined"
};
var $f42acc19a0845dbc$export$2e2bcd8739ae039 = $f42acc19a0845dbc$var$TranslationOutlined;



var $cca9a1e197770e5b$var$TranslationOutlined = function TranslationOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f42acc19a0845dbc$export$2e2bcd8739ae039)
    }));
};
var $cca9a1e197770e5b$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($cca9a1e197770e5b$var$TranslationOutlined);









var $8SyCD = parcelRequire("8SyCD");

"use strict";


/**
 * @module fluent
 * @overview
 *
 * `fluent` is a JavaScript implementation of Project Fluent, a localization
 * framework designed to unleash the expressive power of the natural language.
 *
 */ 


/* global Intl */ /**
 * @overview
 *
 * The role of the Fluent resolver is to format a `Pattern` to an instance of
 * `FluentValue`. For performance reasons, primitive strings are considered
 * such instances, too.
 *
 * Translations can contain references to other messages or variables,
 * conditional logic in form of select expressions, traits which describe their
 * grammatical features, and can use Fluent builtins which make use of the
 * `Intl` formatters to format numbers and dates into the bundle's languages.
 * See the documentation of the Fluent syntax for more information.
 *
 * In case of errors the resolver will try to salvage as much of the
 * translation as possible. In rare situations where the resolver didn't know
 * how to recover from an error it will return an instance of `FluentNone`.
 *
 * All expressions resolve to an instance of `FluentValue`. The caller should
 * use the `toString` method to convert the instance to a native value.
 *
 * Functions in this file pass around an instance of the `Scope` class, which
 * stores the data required for successful resolution and error recovery.
 */ 
var $7FyBz = parcelRequire("7FyBz");
/**
 * The `FluentType` class is the base of Fluent's type system.
 *
 * Fluent types wrap JavaScript values and store additional configuration for
 * them, which can then be used in the `toString` method together with a proper
 * `Intl` formatter.
 */ 



var $7777e0c078eec48a$export$86bd9bf8a2206303 = /*#__PURE__*/ function() {
    "use strict";
    function FluentType(value) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentType);
        this.value = value;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(FluentType, [
        {
            /**
     * Unwrap the raw value stored by this `FluentType`.
     */ key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        }
    ]);
    return FluentType;
}();
var $7777e0c078eec48a$export$74a88f5da61fec15 = /*#__PURE__*/ function(FluentType) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(FluentNone, FluentType);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(FluentNone);
    function FluentNone() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "???";
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentNone);
        return _super.call(this, value);
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(FluentNone, [
        {
            /**
     * Format this `FluentNone` to the fallback string.
     */ key: "toString",
            value: function toString(scope) {
                return "{".concat(this.value, "}");
            }
        }
    ]);
    return FluentNone;
}($7777e0c078eec48a$export$86bd9bf8a2206303);
var $7777e0c078eec48a$export$bb167d788a5da036 = /*#__PURE__*/ function(FluentType) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(FluentNumber, FluentType);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(FluentNumber);
    function FluentNumber(value) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentNumber);
        var _this;
        _this = _super.call(this, value);
        _this.opts = opts;
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(FluentNumber, [
        {
            /**
     * Format this `FluentNumber` to a string.
     */ key: "toString",
            value: function toString(scope) {
                try {
                    var nf = scope.memoizeIntlObject(Intl.NumberFormat, this.opts);
                    return nf.format(this.value);
                } catch (err) {
                    scope.reportError(err);
                    return this.value.toString(10);
                }
            }
        }
    ]);
    return FluentNumber;
}($7777e0c078eec48a$export$86bd9bf8a2206303);
var $7777e0c078eec48a$export$3756696568ce9bad = /*#__PURE__*/ function(FluentType) {
    "use strict";
    (0, $45ac59093a09d67c$export$7e4530ad35d3bb8)(FluentDateTime, FluentType);
    var _super = (0, $c73dafd5d42ceae5$export$8dd05c13f5255580)(FluentDateTime);
    function FluentDateTime(value) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentDateTime);
        var _this;
        _this = _super.call(this, value);
        _this.opts = opts;
        return _this;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(FluentDateTime, [
        {
            /**
     * Format this `FluentDateTime` to a string.
     */ key: "toString",
            value: function toString(scope) {
                try {
                    var dtf = scope.memoizeIntlObject(Intl.DateTimeFormat, this.opts);
                    return dtf.format(this.value);
                } catch (err) {
                    scope.reportError(err);
                    return new Date(this.value).toISOString();
                }
            }
        }
    ]);
    return FluentDateTime;
}($7777e0c078eec48a$export$86bd9bf8a2206303);


/**
 * The maximum number of placeables which can be expanded in a single call to
 * `formatPattern`. The limit protects against the Billion Laughs and Quadratic
 * Blowup attacks. See https://msdn.microsoft.com/en-us/magazine/ee335713.aspx.
 */ var $9821842c62e4bea4$var$MAX_PLACEABLES = 100;
/** Unicode bidi isolation characters. */ var $9821842c62e4bea4$var$FSI = "\u2068";
var $9821842c62e4bea4$var$PDI = "\u2069";
/** Helper: match a variant key to the given selector. */ function $9821842c62e4bea4$var$match(scope, selector, key) {
    if (key === selector) // Both are strings.
    return true;
    // XXX Consider comparing options too, e.g. minimumFractionDigits.
    if (key instanceof (0, $7777e0c078eec48a$export$bb167d788a5da036) && selector instanceof (0, $7777e0c078eec48a$export$bb167d788a5da036) && key.value === selector.value) return true;
    if (selector instanceof (0, $7777e0c078eec48a$export$bb167d788a5da036) && typeof key === "string") {
        var category = scope.memoizeIntlObject(Intl.PluralRules, selector.opts).select(selector.value);
        if (key === category) return true;
    }
    return false;
}
/** Helper: resolve the default variant from a list of variants. */ function $9821842c62e4bea4$var$getDefault(scope, variants, star) {
    if (variants[star]) return $9821842c62e4bea4$var$resolvePattern(scope, variants[star].value);
    scope.reportError(new RangeError("No default"));
    return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)();
}
/** Helper: resolve arguments to a call expression. */ function $9821842c62e4bea4$var$getArguments(scope, args) {
    var positional = [];
    var named = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var arg = _step.value;
            if (arg.type === "narg") named[arg.name] = $9821842c62e4bea4$var$resolveExpression(scope, arg.value);
            else positional.push($9821842c62e4bea4$var$resolveExpression(scope, arg));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        positional: positional,
        named: named
    };
}
/** Resolve an expression to a Fluent type. */ function $9821842c62e4bea4$var$resolveExpression(scope, expr) {
    switch(expr.type){
        case "str":
            return expr.value;
        case "num":
            return new (0, $7777e0c078eec48a$export$bb167d788a5da036)(expr.value, {
                minimumFractionDigits: expr.precision
            });
        case "var":
            return $9821842c62e4bea4$var$resolveVariableReference(scope, expr);
        case "mesg":
            return $9821842c62e4bea4$var$resolveMessageReference(scope, expr);
        case "term":
            return $9821842c62e4bea4$var$resolveTermReference(scope, expr);
        case "func":
            return $9821842c62e4bea4$var$resolveFunctionReference(scope, expr);
        case "select":
            return $9821842c62e4bea4$var$resolveSelectExpression(scope, expr);
        default:
            return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)();
    }
}
/** Resolve a reference to a variable. */ function $9821842c62e4bea4$var$resolveVariableReference(scope, param) {
    var name = param.name;
    var arg;
    if (scope.params) {
        // We're inside a TermReference. It's OK to reference undefined parameters.
        if (Object.prototype.hasOwnProperty.call(scope.params, name)) arg = scope.params[name];
        else return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("$".concat(name));
    } else if (scope.args && Object.prototype.hasOwnProperty.call(scope.args, name)) // We're in the top-level Pattern or inside a MessageReference. Missing
    // variables references produce ReferenceErrors.
    arg = scope.args[name];
    else {
        scope.reportError(new ReferenceError("Unknown variable: $".concat(name)));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("$".concat(name));
    }
    // Return early if the argument already is an instance of FluentType.
    if (arg instanceof (0, $7777e0c078eec48a$export$86bd9bf8a2206303)) return arg;
    // Convert the argument to a Fluent type.
    switch(typeof arg === "undefined" ? "undefined" : (0, $7FyBz._)(arg)){
        case "string":
            return arg;
        case "number":
            return new (0, $7777e0c078eec48a$export$bb167d788a5da036)(arg);
        case "object":
            if (arg instanceof Date) return new (0, $7777e0c078eec48a$export$3756696568ce9bad)(arg.getTime());
        // eslint-disable-next-line no-fallthrough
        default:
            scope.reportError(new TypeError("Variable type not supported: $".concat(name, ", ").concat(typeof arg === "undefined" ? "undefined" : (0, $7FyBz._)(arg))));
            return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("$".concat(name));
    }
}
/** Resolve a reference to another message. */ function $9821842c62e4bea4$var$resolveMessageReference(scope, param) {
    var name = param.name, attr = param.attr;
    var message = scope.bundle._messages.get(name);
    if (!message) {
        scope.reportError(new ReferenceError("Unknown message: ".concat(name)));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)(name);
    }
    if (attr) {
        var attribute = message.attributes[attr];
        if (attribute) return $9821842c62e4bea4$var$resolvePattern(scope, attribute);
        scope.reportError(new ReferenceError("Unknown attribute: ".concat(attr)));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("".concat(name, ".").concat(attr));
    }
    if (message.value) return $9821842c62e4bea4$var$resolvePattern(scope, message.value);
    scope.reportError(new ReferenceError("No value: ".concat(name)));
    return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)(name);
}
/** Resolve a call to a Term with key-value arguments. */ function $9821842c62e4bea4$var$resolveTermReference(scope, param) {
    var name = param.name, attr = param.attr, args = param.args;
    var id = "-".concat(name);
    var term = scope.bundle._terms.get(id);
    if (!term) {
        scope.reportError(new ReferenceError("Unknown term: ".concat(id)));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)(id);
    }
    if (attr) {
        var attribute = term.attributes[attr];
        if (attribute) {
            // Every TermReference has its own variables.
            scope.params = $9821842c62e4bea4$var$getArguments(scope, args).named;
            var resolved = $9821842c62e4bea4$var$resolvePattern(scope, attribute);
            scope.params = null;
            return resolved;
        }
        scope.reportError(new ReferenceError("Unknown attribute: ".concat(attr)));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("".concat(id, ".").concat(attr));
    }
    scope.params = $9821842c62e4bea4$var$getArguments(scope, args).named;
    var resolved1 = $9821842c62e4bea4$var$resolvePattern(scope, term.value);
    scope.params = null;
    return resolved1;
}
/** Resolve a call to a Function with positional and key-value arguments. */ function $9821842c62e4bea4$var$resolveFunctionReference(scope, param) {
    var name = param.name, args = param.args;
    // Some functions are built-in. Others may be provided by the runtime via
    // the `FluentBundle` constructor.
    var func = scope.bundle._functions[name];
    if (!func) {
        scope.reportError(new ReferenceError("Unknown function: ".concat(name, "()")));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("".concat(name, "()"));
    }
    if (typeof func !== "function") {
        scope.reportError(new TypeError("Function ".concat(name, "() is not callable")));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("".concat(name, "()"));
    }
    try {
        var resolved = $9821842c62e4bea4$var$getArguments(scope, args);
        return func(resolved.positional, resolved.named);
    } catch (err) {
        scope.reportError(err);
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("".concat(name, "()"));
    }
}
/** Resolve a select expression to the member object. */ function $9821842c62e4bea4$var$resolveSelectExpression(scope, param) {
    var selector = param.selector, variants = param.variants, star = param.star;
    var sel = $9821842c62e4bea4$var$resolveExpression(scope, selector);
    if (sel instanceof (0, $7777e0c078eec48a$export$74a88f5da61fec15)) return $9821842c62e4bea4$var$getDefault(scope, variants, star);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Match the selector against keys of each variant, in order.
        for(var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var variant = _step.value;
            var key = $9821842c62e4bea4$var$resolveExpression(scope, variant.key);
            if ($9821842c62e4bea4$var$match(scope, sel, key)) return $9821842c62e4bea4$var$resolvePattern(scope, variant.value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $9821842c62e4bea4$var$getDefault(scope, variants, star);
}
function $9821842c62e4bea4$export$99cfa860dd34571c(scope, ptn) {
    if (scope.dirty.has(ptn)) {
        scope.reportError(new RangeError("Cyclic reference"));
        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)();
    }
    // Tag the pattern as dirty for the purpose of the current resolution.
    scope.dirty.add(ptn);
    var result = [];
    // Wrap interpolations with Directional Isolate Formatting characters
    // only when the pattern has more than one element.
    var useIsolating = scope.bundle._useIsolating && ptn.length > 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ptn[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var elem = _step.value;
            if (typeof elem === "string") {
                result.push(scope.bundle._transform(elem));
                continue;
            }
            scope.placeables++;
            if (scope.placeables > $9821842c62e4bea4$var$MAX_PLACEABLES) {
                scope.dirty["delete"](ptn);
                // This is a fatal error which causes the resolver to instantly bail out
                // on this pattern. The length check protects against excessive memory
                // usage, and throwing protects against eating up the CPU when long
                // placeables are deeply nested.
                throw new RangeError("Too many placeables expanded: ".concat(scope.placeables, ", ") + "max allowed is ".concat($9821842c62e4bea4$var$MAX_PLACEABLES));
            }
            if (useIsolating) result.push($9821842c62e4bea4$var$FSI);
            result.push($9821842c62e4bea4$var$resolveExpression(scope, elem).toString(scope));
            if (useIsolating) result.push($9821842c62e4bea4$var$PDI);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    scope.dirty["delete"](ptn);
    return result.join("");
}
/**
 * Resolve a simple or a complex Pattern to a FluentString
 * (which is really the string primitive).
 */ function $9821842c62e4bea4$var$resolvePattern(scope, value) {
    // Resolve a simple pattern.
    if (typeof value === "string") return scope.bundle._transform(value);
    return $9821842c62e4bea4$export$99cfa860dd34571c(scope, value);
}




var $dbc19e50ac9218e3$export$775b6bb06e53a214 = /*#__PURE__*/ function() {
    "use strict";
    function Scope(bundle, errors, args) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, Scope);
        /**
         * The Set of patterns already encountered during this resolution.
         * Used to detect and prevent cyclic resolutions.
         * @ignore
         */ this.dirty = new WeakSet();
        /** A dict of parameters passed to a TermReference. */ this.params = null;
        /**
         * The running count of placeables resolved so far.
         * Used to detect the Billion Laughs and Quadratic Blowup attacks.
         * @ignore
         */ this.placeables = 0;
        this.bundle = bundle;
        this.errors = errors;
        this.args = args;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(Scope, [
        {
            key: "reportError",
            value: function reportError(error) {
                if (!this.errors || !(error instanceof Error)) throw error;
                this.errors.push(error);
            }
        },
        {
            key: "memoizeIntlObject",
            value: function memoizeIntlObject(ctor, opts) {
                var cache = this.bundle._intls.get(ctor);
                if (!cache) {
                    cache = {};
                    this.bundle._intls.set(ctor, cache);
                }
                var id = JSON.stringify(opts);
                if (!cache[id]) cache[id] = new ctor(this.bundle.locales, opts);
                return cache[id];
            }
        }
    ]);
    return Scope;
}();



/**
 * @overview
 *
 * The FTL resolver ships with a number of functions built-in.
 *
 * Each function take two arguments:
 *   - args - an array of positional args
 *   - opts - an object of key-value args
 *
 * Arguments to functions are guaranteed to already be instances of
 * `FluentValue`.  Functions must return `FluentValues` as well.
 */ 


function $4657046d18376c26$var$values(opts, allowed) {
    var unwrapped = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(opts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], opt = _step_value[1];
            if (allowed.includes(name)) unwrapped[name] = opt.valueOf();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return unwrapped;
}
var $4657046d18376c26$var$NUMBER_ALLOWED = [
    "unitDisplay",
    "currencyDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits"
];
function $4657046d18376c26$export$4e8bcd47a31d751c(args, opts) {
    var arg = args[0];
    if (arg instanceof (0, $7777e0c078eec48a$export$74a88f5da61fec15)) return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("NUMBER(".concat(arg.valueOf(), ")"));
    if (arg instanceof (0, $7777e0c078eec48a$export$bb167d788a5da036)) return new (0, $7777e0c078eec48a$export$bb167d788a5da036)(arg.valueOf(), (0, $3e6303611e69f27e$export$581ff339ea0ba762)({}, arg.opts, $4657046d18376c26$var$values(opts, $4657046d18376c26$var$NUMBER_ALLOWED)));
    if (arg instanceof (0, $7777e0c078eec48a$export$3756696568ce9bad)) return new (0, $7777e0c078eec48a$export$bb167d788a5da036)(arg.valueOf(), (0, $3e6303611e69f27e$export$581ff339ea0ba762)({}, $4657046d18376c26$var$values(opts, $4657046d18376c26$var$NUMBER_ALLOWED)));
    throw new TypeError("Invalid argument to NUMBER");
}
var $4657046d18376c26$var$DATETIME_ALLOWED = [
    "dateStyle",
    "timeStyle",
    "fractionalSecondDigits",
    "dayPeriod",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName"
];
function $4657046d18376c26$export$b72dfaf482d1f75b(args, opts) {
    var arg = args[0];
    if (arg instanceof (0, $7777e0c078eec48a$export$74a88f5da61fec15)) return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)("DATETIME(".concat(arg.valueOf(), ")"));
    if (arg instanceof (0, $7777e0c078eec48a$export$3756696568ce9bad)) return new (0, $7777e0c078eec48a$export$3756696568ce9bad)(arg.valueOf(), (0, $3e6303611e69f27e$export$581ff339ea0ba762)({}, arg.opts, $4657046d18376c26$var$values(opts, $4657046d18376c26$var$DATETIME_ALLOWED)));
    if (arg instanceof (0, $7777e0c078eec48a$export$bb167d788a5da036)) return new (0, $7777e0c078eec48a$export$3756696568ce9bad)(arg.valueOf(), (0, $3e6303611e69f27e$export$581ff339ea0ba762)({}, $4657046d18376c26$var$values(opts, $4657046d18376c26$var$DATETIME_ALLOWED)));
    throw new TypeError("Invalid argument to DATETIME");
}


var $93c9e75e3cb1326c$var$cache = new Map();
function $93c9e75e3cb1326c$export$12a7cb8fe9f8fff9(locales) {
    var stringLocale = Array.isArray(locales) ? locales.join(" ") : locales;
    var memoizer = $93c9e75e3cb1326c$var$cache.get(stringLocale);
    if (memoizer === undefined) {
        memoizer = new Map();
        $93c9e75e3cb1326c$var$cache.set(stringLocale, memoizer);
    }
    return memoizer;
}


var $bf7b7a9819372ede$export$dbb69eb03354692e = /*#__PURE__*/ function() {
    "use strict";
    function FluentBundle(locales) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, functions = _ref.functions, _ref_useIsolating = _ref.useIsolating, useIsolating = _ref_useIsolating === void 0 ? true : _ref_useIsolating, _ref_transform = _ref.transform, transform = _ref_transform === void 0 ? function(v) {
            return v;
        } : _ref_transform;
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentBundle);
        /** @ignore */ this._terms = new Map();
        /** @ignore */ this._messages = new Map();
        this.locales = Array.isArray(locales) ? locales : [
            locales
        ];
        this._functions = (0, $3e6303611e69f27e$export$581ff339ea0ba762)({
            NUMBER: (0, $4657046d18376c26$export$4e8bcd47a31d751c),
            DATETIME: (0, $4657046d18376c26$export$b72dfaf482d1f75b)
        }, functions);
        this._useIsolating = useIsolating;
        this._transform = transform;
        this._intls = (0, $93c9e75e3cb1326c$export$12a7cb8fe9f8fff9)(locales);
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(FluentBundle, [
        {
            /**
     * Check if a message is present in the bundle.
     *
     * @param id - The identifier of the message to check.
     */ key: "hasMessage",
            value: function hasMessage(id) {
                return this._messages.has(id);
            }
        },
        {
            /**
     * Return a raw unformatted message object from the bundle.
     *
     * Raw messages are `{value, attributes}` shapes containing translation units
     * called `Patterns`. `Patterns` are implementation-specific; they should be
     * treated as black boxes and formatted with `FluentBundle.formatPattern`.
     *
     * @param id - The identifier of the message to check.
     */ key: "getMessage",
            value: function getMessage(id) {
                return this._messages.get(id);
            }
        },
        {
            /**
     * Add a translation resource to the bundle.
     *
     * @example
     * ```js
     * let res = new FluentResource("foo = Foo");
     * bundle.addResource(res);
     * bundle.getMessage("foo");
     * // → {value: .., attributes: {..}}
     * ```
     *
     * @param res
     * @param options
     */ key: "addResource",
            value: function addResource(res) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_allowOverrides = _ref.allowOverrides, allowOverrides = _ref_allowOverrides === void 0 ? false : _ref_allowOverrides;
                var errors = [];
                for(var i = 0; i < res.body.length; i++){
                    var entry = res.body[i];
                    if (entry.id.startsWith("-")) {
                        // Identifiers starting with a dash (-) define terms. Terms are private
                        // and cannot be retrieved from FluentBundle.
                        if (allowOverrides === false && this._terms.has(entry.id)) {
                            errors.push(new Error('Attempt to override an existing term: "'.concat(entry.id, '"')));
                            continue;
                        }
                        this._terms.set(entry.id, entry);
                    } else {
                        if (allowOverrides === false && this._messages.has(entry.id)) {
                            errors.push(new Error('Attempt to override an existing message: "'.concat(entry.id, '"')));
                            continue;
                        }
                        this._messages.set(entry.id, entry);
                    }
                }
                return errors;
            }
        },
        {
            /**
     * Format a `Pattern` to a string.
     *
     * Format a raw `Pattern` into a string. `args` will be used to resolve
     * references to variables passed as arguments to the translation.
     *
     * In case of errors `formatPattern` will try to salvage as much of the
     * translation as possible and will still return a string. For performance
     * reasons, the encountered errors are not returned but instead are appended
     * to the `errors` array passed as the third argument.
     *
     * If `errors` is omitted, the first encountered error will be thrown.
     *
     * @example
     * ```js
     * let errors = [];
     * bundle.addResource(
     *     new FluentResource("hello = Hello, {$name}!"));
     *
     * let hello = bundle.getMessage("hello");
     * if (hello.value) {
     *     bundle.formatPattern(hello.value, {name: "Jane"}, errors);
     *     // Returns "Hello, Jane!" and `errors` is empty.
     *
     *     bundle.formatPattern(hello.value, undefined, errors);
     *     // Returns "Hello, {$name}!" and `errors` is now:
     *     // [<ReferenceError: Unknown variable: name>]
     * }
     * ```
     */ key: "formatPattern",
            value: function formatPattern(pattern) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, errors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                // Resolve a simple pattern without creating a scope. No error handling is
                // required; by definition simple patterns don't have placeables.
                if (typeof pattern === "string") return this._transform(pattern);
                // Resolve a complex pattern.
                var scope = new (0, $dbc19e50ac9218e3$export$775b6bb06e53a214)(this, errors, args);
                try {
                    var value = (0, $9821842c62e4bea4$export$99cfa860dd34571c)(scope, pattern);
                    return value.toString(scope);
                } catch (err) {
                    if (scope.errors && err instanceof Error) {
                        scope.errors.push(err);
                        return new (0, $7777e0c078eec48a$export$74a88f5da61fec15)().toString(scope);
                    }
                    throw err;
                }
            }
        }
    ]);
    return FluentBundle;
}();


// This regex is used to iterate through the beginnings of messages and terms.
// With the /m flag, the ^ matches at the beginning of every line.



var $64051be3b00f8c45$var$RE_MESSAGE_START = /^(-?[a-zA-Z][\w-]*) *= */gm;
// Both Attributes and Variants are parsed in while loops. These regexes are
// used to break out of them.
var $64051be3b00f8c45$var$RE_ATTRIBUTE_START = RegExp("\\.([a-zA-Z][\\w-]*) *= *", "y");
var $64051be3b00f8c45$var$RE_VARIANT_START = RegExp("\\*?\\[", "y");
var $64051be3b00f8c45$var$RE_NUMBER_LITERAL = RegExp("(-?[0-9]+(?:\\.([0-9]+))?)", "y");
var $64051be3b00f8c45$var$RE_IDENTIFIER = RegExp("([a-zA-Z][\\w-]*)", "y");
var $64051be3b00f8c45$var$RE_REFERENCE = RegExp("([$-])?([a-zA-Z][\\w-]*)(?:\\.([a-zA-Z][\\w-]*))?", "y");
var $64051be3b00f8c45$var$RE_FUNCTION_NAME = /^[A-Z][A-Z0-9_-]*$/;
// A "run" is a sequence of text or string literal characters which don't
// require any special handling. For TextElements such special characters are: {
// (starts a placeable), and line breaks which require additional logic to check
// if the next line is indented. For StringLiterals they are: \ (starts an
// escape sequence), " (ends the literal), and line breaks which are not allowed
// in StringLiterals. Note that string runs may be empty; text runs may not.
var $64051be3b00f8c45$var$RE_TEXT_RUN = RegExp("([^{}\\n\\r]+)", "y");
var $64051be3b00f8c45$var$RE_STRING_RUN = RegExp('([^\\\\"\\n\\r]*)', "y");
// Escape sequences.
var $64051be3b00f8c45$var$RE_STRING_ESCAPE = RegExp('\\\\([\\\\"])', "y");
var $64051be3b00f8c45$var$RE_UNICODE_ESCAPE = RegExp("\\\\u([a-fA-F0-9]{4})|\\\\U([a-fA-F0-9]{6})", "y");
// Used for trimming TextElements and indents.
var $64051be3b00f8c45$var$RE_LEADING_NEWLINES = /^\n+/;
var $64051be3b00f8c45$var$RE_TRAILING_SPACES = / +$/;
// Used in makeIndent to strip spaces from blank lines and normalize CRLF to LF.
var $64051be3b00f8c45$var$RE_BLANK_LINES = / *\r?\n/g;
// Used in makeIndent to measure the indentation.
var $64051be3b00f8c45$var$RE_INDENT = /( *)$/;
// Common tokens.
var $64051be3b00f8c45$var$TOKEN_BRACE_OPEN = RegExp("{\\s*", "y");
var $64051be3b00f8c45$var$TOKEN_BRACE_CLOSE = RegExp("\\s*}", "y");
var $64051be3b00f8c45$var$TOKEN_BRACKET_OPEN = RegExp("\\[\\s*", "y");
var $64051be3b00f8c45$var$TOKEN_BRACKET_CLOSE = RegExp("\\s*] *", "y");
var $64051be3b00f8c45$var$TOKEN_PAREN_OPEN = RegExp("\\s*\\(\\s*", "y");
var $64051be3b00f8c45$var$TOKEN_ARROW = RegExp("\\s*->\\s*", "y");
var $64051be3b00f8c45$var$TOKEN_COLON = RegExp("\\s*:\\s*", "y");
// Note the optional comma. As a deviation from the Fluent EBNF, the parser
// doesn't enforce commas between call arguments.
var $64051be3b00f8c45$var$TOKEN_COMMA = RegExp("\\s*,?\\s*", "y");
var $64051be3b00f8c45$var$TOKEN_BLANK = RegExp("\\s+", "y");
var $64051be3b00f8c45$export$ce122eb5f5b1d45d = function FluentResource(source) {
    "use strict";
    (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, FluentResource);
    var test = // The parser implementation is inlined below for performance reasons,
    // as well as for convenience of accessing `source` and `cursor`.
    // The parser focuses on minimizing the number of false negatives at the
    // expense of increasing the risk of false positives. In other words, it
    // aims at parsing valid Fluent messages with a success rate of 100%, but it
    // may also parse a few invalid messages which the reference parser would
    // reject. The parser doesn't perform any validation and may produce entries
    // which wouldn't make sense in the real world. For best results users are
    // advised to validate translations with the fluent-syntax parser
    // pre-runtime.
    // The parser makes an extensive use of sticky regexes which can be anchored
    // to any offset of the source string without slicing it. Errors are thrown
    // to bail out of parsing of ill-formed messages.
    function test(re) {
        re.lastIndex = cursor;
        return re.test(source);
    };
    var consumeChar = // Advance the cursor by the char if it matches. May be used as a predicate
    // (was the match found?) or, if errorClass is passed, as an assertion.
    function consumeChar(_char, errorClass) {
        if (source[cursor] === _char) {
            cursor++;
            return true;
        }
        if (errorClass) throw new errorClass("Expected ".concat(_char));
        return false;
    };
    var consumeToken = // Advance the cursor by the token if it matches. May be used as a predicate
    // (was the match found?) or, if errorClass is passed, as an assertion.
    function consumeToken(re, errorClass) {
        if (test(re)) {
            cursor = re.lastIndex;
            return true;
        }
        if (errorClass) throw new errorClass("Expected ".concat(re.toString()));
        return false;
    };
    var match = // Execute a regex, advance the cursor, and return all capture groups.
    function match(re) {
        re.lastIndex = cursor;
        var result = re.exec(source);
        if (result === null) throw new SyntaxError("Expected ".concat(re.toString()));
        cursor = re.lastIndex;
        return result;
    };
    var match1 = // Execute a regex, advance the cursor, and return the capture group.
    function match1(re) {
        return match(re)[1];
    };
    var parseMessage = function parseMessage(id) {
        var value = parsePattern();
        var attributes = parseAttributes();
        if (value === null && Object.keys(attributes).length === 0) throw new SyntaxError("Expected message value or attributes");
        return {
            id: id,
            value: value,
            attributes: attributes
        };
    };
    var parseAttributes = function parseAttributes() {
        var attrs = Object.create(null);
        while(test($64051be3b00f8c45$var$RE_ATTRIBUTE_START)){
            var name = match1($64051be3b00f8c45$var$RE_ATTRIBUTE_START);
            var value = parsePattern();
            if (value === null) throw new SyntaxError("Expected attribute value");
            attrs[name] = value;
        }
        return attrs;
    };
    var parsePattern = function parsePattern() {
        var first;
        // First try to parse any simple text on the same line as the id.
        if (test($64051be3b00f8c45$var$RE_TEXT_RUN)) first = match1($64051be3b00f8c45$var$RE_TEXT_RUN);
        // If there's a placeable on the first line, parse a complex pattern.
        if (source[cursor] === "{" || source[cursor] === "}") // Re-use the text parsed above, if possible.
        return parsePatternElements(first ? [
            first
        ] : [], Infinity);
        // RE_TEXT_VALUE stops at newlines. Only continue parsing the pattern if
        // what comes after the newline is indented.
        var indent = parseIndent();
        if (indent) {
            if (first) // If there's text on the first line, the blank block is part of the
            // translation content in its entirety.
            return parsePatternElements([
                first,
                indent
            ], indent.length);
            // Otherwise, we're dealing with a block pattern, i.e. a pattern which
            // starts on a new line. Discrad the leading newlines but keep the
            // inline indent; it will be used by the dedentation logic.
            indent.value = trim(indent.value, $64051be3b00f8c45$var$RE_LEADING_NEWLINES);
            return parsePatternElements([
                indent
            ], indent.length);
        }
        if (first) // It was just a simple inline text after all.
        return trim(first, $64051be3b00f8c45$var$RE_TRAILING_SPACES);
        return null;
    };
    var parsePatternElements = // Parse a complex pattern as an array of elements.
    function parsePatternElements() {
        var elements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], commonIndent = arguments.length > 1 ? arguments[1] : void 0;
        while(true){
            if (test($64051be3b00f8c45$var$RE_TEXT_RUN)) {
                elements.push(match1($64051be3b00f8c45$var$RE_TEXT_RUN));
                continue;
            }
            if (source[cursor] === "{") {
                elements.push(parsePlaceable());
                continue;
            }
            if (source[cursor] === "}") throw new SyntaxError("Unbalanced closing brace");
            var indent = parseIndent();
            if (indent) {
                elements.push(indent);
                commonIndent = Math.min(commonIndent, indent.length);
                continue;
            }
            break;
        }
        var lastIndex = elements.length - 1;
        var lastElement = elements[lastIndex];
        // Trim the trailing spaces in the last element if it's a TextElement.
        if (typeof lastElement === "string") elements[lastIndex] = trim(lastElement, $64051be3b00f8c45$var$RE_TRAILING_SPACES);
        var baked = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                if (element instanceof $64051be3b00f8c45$var$Indent) // Dedent indented lines by the maximum common indent.
                element = element.value.slice(0, element.value.length - commonIndent);
                if (element) baked.push(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return baked;
    };
    var parsePlaceable = function parsePlaceable() {
        consumeToken($64051be3b00f8c45$var$TOKEN_BRACE_OPEN, SyntaxError);
        var selector = parseInlineExpression();
        if (consumeToken($64051be3b00f8c45$var$TOKEN_BRACE_CLOSE)) return selector;
        if (consumeToken($64051be3b00f8c45$var$TOKEN_ARROW)) {
            var variants = parseVariants();
            consumeToken($64051be3b00f8c45$var$TOKEN_BRACE_CLOSE, SyntaxError);
            return (0, $3e6303611e69f27e$export$581ff339ea0ba762)({
                type: "select",
                selector: selector
            }, variants);
        }
        throw new SyntaxError("Unclosed placeable");
    };
    var parseInlineExpression = function parseInlineExpression() {
        if (source[cursor] === "{") // It's a nested placeable.
        return parsePlaceable();
        if (test($64051be3b00f8c45$var$RE_REFERENCE)) {
            var _match = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(match($64051be3b00f8c45$var$RE_REFERENCE), 4), sigil = _match[1], name = _match[2], tmp = _match[3], attr = tmp === void 0 ? null : tmp;
            if (sigil === "$") return {
                type: "var",
                name: name
            };
            if (consumeToken($64051be3b00f8c45$var$TOKEN_PAREN_OPEN)) {
                var args = parseArguments();
                if (sigil === "-") // A parameterized term: -term(...).
                return {
                    type: "term",
                    name: name,
                    attr: attr,
                    args: args
                };
                if ($64051be3b00f8c45$var$RE_FUNCTION_NAME.test(name)) return {
                    type: "func",
                    name: name,
                    args: args
                };
                throw new SyntaxError("Function names must be all upper-case");
            }
            if (sigil === "-") // A non-parameterized term: -term.
            return {
                type: "term",
                name: name,
                attr: attr,
                args: []
            };
            return {
                type: "mesg",
                name: name,
                attr: attr
            };
        }
        return parseLiteral();
    };
    var parseArguments = function parseArguments() {
        var args = [];
        while(true){
            switch(source[cursor]){
                case ")":
                    cursor++;
                    return args;
                case undefined:
                    throw new SyntaxError("Unclosed argument list");
            }
            args.push(parseArgument());
            // Commas between arguments are treated as whitespace.
            consumeToken($64051be3b00f8c45$var$TOKEN_COMMA);
        }
    };
    var parseArgument = function parseArgument() {
        var expr = parseInlineExpression();
        if (expr.type !== "mesg") return expr;
        if (consumeToken($64051be3b00f8c45$var$TOKEN_COLON)) // The reference is the beginning of a named argument.
        return {
            type: "narg",
            name: expr.name,
            value: parseLiteral()
        };
        // It's a regular message reference.
        return expr;
    };
    var parseVariants = function parseVariants() {
        var variants = [];
        var count = 0;
        var star;
        while(test($64051be3b00f8c45$var$RE_VARIANT_START)){
            if (consumeChar("*")) star = count;
            var key = parseVariantKey();
            var value = parsePattern();
            if (value === null) throw new SyntaxError("Expected variant value");
            variants[count++] = {
                key: key,
                value: value
            };
        }
        if (count === 0) return null;
        if (star === undefined) throw new SyntaxError("Expected default variant");
        return {
            variants: variants,
            star: star
        };
    };
    var parseVariantKey = function parseVariantKey() {
        consumeToken($64051be3b00f8c45$var$TOKEN_BRACKET_OPEN, SyntaxError);
        var key;
        if (test($64051be3b00f8c45$var$RE_NUMBER_LITERAL)) key = parseNumberLiteral();
        else key = {
            type: "str",
            value: match1($64051be3b00f8c45$var$RE_IDENTIFIER)
        };
        consumeToken($64051be3b00f8c45$var$TOKEN_BRACKET_CLOSE, SyntaxError);
        return key;
    };
    var parseLiteral = function parseLiteral() {
        if (test($64051be3b00f8c45$var$RE_NUMBER_LITERAL)) return parseNumberLiteral();
        if (source[cursor] === '"') return parseStringLiteral();
        throw new SyntaxError("Invalid expression");
    };
    var parseNumberLiteral = function parseNumberLiteral() {
        var _match = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(match($64051be3b00f8c45$var$RE_NUMBER_LITERAL), 3), value = _match[1], tmp = _match[2], fraction = tmp === void 0 ? "" : tmp;
        var precision = fraction.length;
        return {
            type: "num",
            value: parseFloat(value),
            precision: precision
        };
    };
    var parseStringLiteral = function parseStringLiteral() {
        consumeChar('"', SyntaxError);
        var value = "";
        while(true){
            value += match1($64051be3b00f8c45$var$RE_STRING_RUN);
            if (source[cursor] === "\\") {
                value += parseEscapeSequence();
                continue;
            }
            if (consumeChar('"')) return {
                type: "str",
                value: value
            };
            // We've reached an EOL of EOF.
            throw new SyntaxError("Unclosed string literal");
        }
    };
    var parseEscapeSequence = // Unescape known escape sequences.
    function parseEscapeSequence() {
        if (test($64051be3b00f8c45$var$RE_STRING_ESCAPE)) return match1($64051be3b00f8c45$var$RE_STRING_ESCAPE);
        if (test($64051be3b00f8c45$var$RE_UNICODE_ESCAPE)) {
            var _match = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(match($64051be3b00f8c45$var$RE_UNICODE_ESCAPE), 3), codepoint4 = _match[1], codepoint6 = _match[2];
            var codepoint = parseInt(codepoint4 || codepoint6, 16);
            return codepoint <= 0xd7ff || 0xe000 <= codepoint ? String.fromCodePoint(codepoint) : // saved using UTF-8. Use U+FFFD REPLACEMENT CHARACTER instead.
            "\uFFFD";
        }
        throw new SyntaxError("Unknown escape sequence");
    };
    var parseIndent = // Parse blank space. Return it if it looks like indent before a pattern
    // line. Skip it othwerwise.
    function parseIndent() {
        var start = cursor;
        consumeToken($64051be3b00f8c45$var$TOKEN_BLANK);
        // Check the first non-blank character after the indent.
        switch(source[cursor]){
            case ".":
            case "[":
            case "*":
            case "}":
            case undefined:
                // A special character. End the Pattern.
                return false;
            case "{":
                // Placeables don't require indentation (in EBNF: block-placeable).
                // Continue the Pattern.
                return makeIndent(source.slice(start, cursor));
        }
        // If the first character on the line is not one of the special characters
        // listed above, it's a regular text character. Check if there's at least
        // one space of indent before it.
        if (source[cursor - 1] === " ") // It's an indented text character (in EBNF: indented-char). Continue
        // the Pattern.
        return makeIndent(source.slice(start, cursor));
        // A not-indented text character is likely the identifier of the next
        // message. End the Pattern.
        return false;
    };
    var trim = // Trim blanks in text according to the given regex.
    function trim(text, re) {
        return text.replace(re, "");
    };
    var makeIndent = // Normalize a blank block and extract the indent details.
    function makeIndent(blank) {
        var value = blank.replace($64051be3b00f8c45$var$RE_BLANK_LINES, "\n");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var length = $64051be3b00f8c45$var$RE_INDENT.exec(blank)[1].length;
        return new $64051be3b00f8c45$var$Indent(value, length);
    };
    this.body = [];
    $64051be3b00f8c45$var$RE_MESSAGE_START.lastIndex = 0;
    var cursor = 0;
    // Iterate over the beginnings of messages and terms to efficiently skip
    // comments and recover from errors.
    while(true){
        var next = $64051be3b00f8c45$var$RE_MESSAGE_START.exec(source);
        if (next === null) break;
        cursor = $64051be3b00f8c45$var$RE_MESSAGE_START.lastIndex;
        try {
            this.body.push(parseMessage(next[1]));
        } catch (err) {
            if (err instanceof SyntaxError) continue;
            throw err;
        }
    }
};
var $64051be3b00f8c45$var$Indent = function Indent(value, length) {
    "use strict";
    (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, Indent);
    this.value = value;
    this.length = length;
};





/*
 * @module fluent-langneg
 * @overview
 *
 * `fluent-langneg` provides language negotiation API that fits into
 * Project Fluent localization composition and fallbacking strategy.
 *
 */ /* eslint no-magic-numbers: 0 */ 
/* eslint no-magic-numbers: 0 */ 


var $f40985cc625cfe01$var$languageCodeRe = "([a-z]{2,3}|\\*)";
var $f40985cc625cfe01$var$scriptCodeRe = "(?:-([a-z]{4}|\\*))";
var $f40985cc625cfe01$var$regionCodeRe = "(?:-([a-z]{2}|\\*))";
var $f40985cc625cfe01$var$variantCodeRe = "(?:-(([0-9][a-z0-9]{3}|[a-z0-9]{5,8})|\\*))";
/**
 * Regular expression splitting locale id into four pieces:
 *
 * Example: `en-Latn-US-macos`
 *
 * language: en
 * script:   Latn
 * region:   US
 * variant:  macos
 *
 * It can also accept a range `*` character on any position.
 */ var $f40985cc625cfe01$var$localeRe = new RegExp("^".concat($f40985cc625cfe01$var$languageCodeRe).concat($f40985cc625cfe01$var$scriptCodeRe, "?").concat($f40985cc625cfe01$var$regionCodeRe, "?").concat($f40985cc625cfe01$var$variantCodeRe, "?$"), "i");
var $f40985cc625cfe01$export$d4f428a61c37ddfa = /*#__PURE__*/ function() {
    "use strict";
    function Locale(locale) {
        (0, $1196a0d52e0d4b84$export$2996f80ef42b8419)(this, Locale);
        var result = $f40985cc625cfe01$var$localeRe.exec(locale.replace(/_/g, "-"));
        if (!result) {
            this.isWellFormed = false;
            return;
        }
        var _result = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(result, 5), language = _result[1], script = _result[2], region = _result[3], variant = _result[4];
        if (language) this.language = language.toLowerCase();
        if (script) this.script = script[0].toUpperCase() + script.slice(1);
        if (region) this.region = region.toUpperCase();
        this.variant = variant;
        this.isWellFormed = true;
    }
    (0, $03c1c3c5357980fb$export$d60067ff2358eee8)(Locale, [
        {
            key: "isEqual",
            value: function isEqual(other) {
                return this.language === other.language && this.script === other.script && this.region === other.region && this.variant === other.variant;
            }
        },
        {
            key: "matches",
            value: function matches(other) {
                var thisRange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, otherRange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return (this.language === other.language || thisRange && this.language === undefined || otherRange && other.language === undefined) && (this.script === other.script || thisRange && this.script === undefined || otherRange && other.script === undefined) && (this.region === other.region || thisRange && this.region === undefined || otherRange && other.region === undefined) && (this.variant === other.variant || thisRange && this.variant === undefined || otherRange && other.variant === undefined);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return [
                    this.language,
                    this.script,
                    this.region,
                    this.variant
                ].filter(function(part) {
                    return part !== undefined;
                }).join("-");
            }
        },
        {
            key: "clearVariants",
            value: function clearVariants() {
                this.variant = undefined;
            }
        },
        {
            key: "clearRegion",
            value: function clearRegion() {
                this.region = undefined;
            }
        },
        {
            key: "addLikelySubtags",
            value: function addLikelySubtags() {
                var newLocale = $f40985cc625cfe01$var$getLikelySubtagsMin(this.toString().toLowerCase());
                if (newLocale) {
                    this.language = newLocale.language;
                    this.script = newLocale.script;
                    this.region = newLocale.region;
                    this.variant = newLocale.variant;
                    return true;
                }
                return false;
            }
        }
    ]);
    return Locale;
}();
/**
 * Below is a manually a list of likely subtags corresponding to Unicode
 * CLDR likelySubtags list.
 * This list is curated by the maintainers of Project Fluent and is
 * intended to be used in place of the full likelySubtags list in use cases
 * where full list cannot be (for example, due to the size).
 *
 * This version of the list is based on CLDR 30.0.3.
 */ var $f40985cc625cfe01$var$likelySubtagsMin = {
    ar: "ar-arab-eg",
    "az-arab": "az-arab-ir",
    "az-ir": "az-arab-ir",
    be: "be-cyrl-by",
    da: "da-latn-dk",
    el: "el-grek-gr",
    en: "en-latn-us",
    fa: "fa-arab-ir",
    ja: "ja-jpan-jp",
    ko: "ko-kore-kr",
    pt: "pt-latn-br",
    sr: "sr-cyrl-rs",
    "sr-ru": "sr-latn-ru",
    sv: "sv-latn-se",
    ta: "ta-taml-in",
    uk: "uk-cyrl-ua",
    zh: "zh-hans-cn",
    "zh-hant": "zh-hant-tw",
    "zh-hk": "zh-hant-hk",
    "zh-mo": "zh-hant-mo",
    "zh-tw": "zh-hant-tw",
    "zh-gb": "zh-hant-gb",
    "zh-us": "zh-hant-us"
};
var $f40985cc625cfe01$var$regionMatchingLangs = [
    "az",
    "bg",
    "cs",
    "de",
    "es",
    "fi",
    "fr",
    "hu",
    "it",
    "lt",
    "lv",
    "nl",
    "pl",
    "ro",
    "ru"
];
function $f40985cc625cfe01$var$getLikelySubtagsMin(loc) {
    if (Object.prototype.hasOwnProperty.call($f40985cc625cfe01$var$likelySubtagsMin, loc)) return new $f40985cc625cfe01$export$d4f428a61c37ddfa($f40985cc625cfe01$var$likelySubtagsMin[loc]);
    var locale = new $f40985cc625cfe01$export$d4f428a61c37ddfa(loc);
    if (locale.language && $f40985cc625cfe01$var$regionMatchingLangs.includes(locale.language)) {
        locale.region = locale.language.toUpperCase();
        return locale;
    }
    return null;
}


function $6f1b146e18a6705c$export$1bf6ae6109033cca(requestedLocales, availableLocales, strategy) {
    var supportedLocales = new Set();
    var availableLocalesMap = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = availableLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var locale = _step.value;
            var newLocale = new (0, $f40985cc625cfe01$export$d4f428a61c37ddfa)(locale);
            if (newLocale.isWellFormed) availableLocalesMap.set(locale, new (0, $f40985cc625cfe01$export$d4f428a61c37ddfa)(locale));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        outer: for(var _iterator1 = requestedLocales[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var reqLocStr = _step1.value;
            var reqLocStrLC = reqLocStr.toLowerCase();
            var requestedLocale = new (0, $f40985cc625cfe01$export$d4f428a61c37ddfa)(reqLocStrLC);
            if (requestedLocale.language === undefined) continue;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                // 1) Attempt to make an exact match
                // Example: `en-US` === `en-US`
                for(var _iterator2 = availableLocalesMap.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var key = _step2.value;
                    if (reqLocStrLC === key.toLowerCase()) {
                        supportedLocales.add(key);
                        availableLocalesMap["delete"](key);
                        if (strategy === "lookup") return Array.from(supportedLocales);
                        else if (strategy === "filtering") continue;
                        else continue outer;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                        _iterator2["return"]();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                // 2) Attempt to match against the available range
                // This turns `en` into `en-*-*-*` and `en-US` into `en-*-US-*`
                // Example: ['en-US'] * ['en'] = ['en']
                for(var _iterator3 = availableLocalesMap.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _step_value = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step3.value, 2), key1 = _step_value[0], availableLocale = _step_value[1];
                    if (availableLocale.matches(requestedLocale, true, false)) {
                        supportedLocales.add(key1);
                        availableLocalesMap["delete"](key1);
                        if (strategy === "lookup") return Array.from(supportedLocales);
                        else if (strategy === "filtering") continue;
                        else continue outer;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                        _iterator3["return"]();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            // 3) Attempt to retrieve a maximal version of the requested locale ID
            // If data is available, it'll expand `en` into `en-Latn-US` and
            // `zh` into `zh-Hans-CN`.
            // Example: ['en'] * ['en-GB', 'en-US'] = ['en-US']
            if (requestedLocale.addLikelySubtags()) {
                var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                try {
                    for(var _iterator4 = availableLocalesMap.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                        var _step_value1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step4.value, 2), key2 = _step_value1[0], availableLocale1 = _step_value1[1];
                        if (availableLocale1.matches(requestedLocale, true, false)) {
                            supportedLocales.add(key2);
                            availableLocalesMap["delete"](key2);
                            if (strategy === "lookup") return Array.from(supportedLocales);
                            else if (strategy === "filtering") continue;
                            else continue outer;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                            _iterator4["return"]();
                        }
                    } finally{
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            // 4) Attempt to look up for a different variant for the same locale ID
            // Example: ['en-US-mac'] * ['en-US-win'] = ['en-US-win']
            requestedLocale.clearVariants();
            var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
            try {
                for(var _iterator5 = availableLocalesMap.entries()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                    var _step_value2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step5.value, 2), key3 = _step_value2[0], availableLocale2 = _step_value2[1];
                    if (availableLocale2.matches(requestedLocale, true, true)) {
                        supportedLocales.add(key3);
                        availableLocalesMap["delete"](key3);
                        if (strategy === "lookup") return Array.from(supportedLocales);
                        else if (strategy === "filtering") continue;
                        else continue outer;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                        _iterator5["return"]();
                    }
                } finally{
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
            // 5) Attempt to match against the likely subtag without region
            // In the example below, addLikelySubtags will turn
            // `zh-Hant` into `zh-Hant-TW` giving `zh-TW` priority match
            // over `zh-CN`.
            //
            // Example: ['zh-Hant-HK'] * ['zh-TW', 'zh-CN'] = ['zh-TW']
            requestedLocale.clearRegion();
            if (requestedLocale.addLikelySubtags()) {
                var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                try {
                    for(var _iterator6 = availableLocalesMap.entries()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                        var _step_value3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step6.value, 2), key4 = _step_value3[0], availableLocale3 = _step_value3[1];
                        if (availableLocale3.matches(requestedLocale, true, false)) {
                            supportedLocales.add(key4);
                            availableLocalesMap["delete"](key4);
                            if (strategy === "lookup") return Array.from(supportedLocales);
                            else if (strategy === "filtering") continue;
                            else continue outer;
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                            _iterator6["return"]();
                        }
                    } finally{
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
            // 6) Attempt to look up for a different region for the same locale ID
            // Example: ['en-US'] * ['en-AU'] = ['en-AU']
            requestedLocale.clearRegion();
            var _iteratorNormalCompletion7 = true, _didIteratorError7 = false, _iteratorError7 = undefined;
            try {
                for(var _iterator7 = availableLocalesMap.entries()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                    var _step_value4 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_step7.value, 2), key5 = _step_value4[0], availableLocale4 = _step_value4[1];
                    if (availableLocale4.matches(requestedLocale, true, true)) {
                        supportedLocales.add(key5);
                        availableLocalesMap["delete"](key5);
                        if (strategy === "lookup") return Array.from(supportedLocales);
                        else if (strategy === "filtering") continue;
                        else continue outer;
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                        _iterator7["return"]();
                    }
                } finally{
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(supportedLocales);
}


function $00475822f6f9f36c$export$28c63aca0b34941c(requestedLocales, availableLocales) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_strategy = _ref.strategy, strategy = _ref_strategy === void 0 ? "filtering" : _ref_strategy, defaultLocale = _ref.defaultLocale;
    var supportedLocales = (0, $6f1b146e18a6705c$export$1bf6ae6109033cca)(Array.from(requestedLocales !== null && requestedLocales !== void 0 ? requestedLocales : []).map(String), Array.from(availableLocales !== null && availableLocales !== void 0 ? availableLocales : []).map(String), strategy);
    if (strategy === "lookup") {
        if (defaultLocale === undefined) throw new Error("defaultLocale cannot be undefined for strategy `lookup`");
        if (supportedLocales.length === 0) supportedLocales.push(defaultLocale);
    } else if (defaultLocale && !supportedLocales.includes(defaultLocale)) supportedLocales.push(defaultLocale);
    return supportedLocales;
}


function $5f27e07eed495e5b$export$b7166bac60f342af() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof str !== "string") throw new TypeError("Argument must be a string");
    var tokens = str.split(",").map(function(t) {
        return t.trim();
    });
    return tokens.filter(function(t) {
        return t !== "";
    }).map(function(t) {
        return t.split(";")[0];
    });
}





var $995f9b3b1ef38d5a$export$137380d9ce54f7f = new (0, $64051be3b00f8c45$export$ce122eb5f5b1d45d)("metronome = Metronome\r\nmetronome-description = A metronome is a practice tool that produces a steady beat to help musicians play rhythms accurately\r\nopen = Open\r\nplay = Play\r\npause = Pause\r\nback = Back\r\ncreate = Create\r\nsave = Save\r\nupdate = Update\r\ndefault = Default\r\npersonal = Personal\r\nrhythms = Rhythms\r\nno-rhythms = No Rhythms\r\ncreate-rhythm = Create Rhythm\r\nsingle = Single\r\nduplets = Duplets\r\ntriplets = Triplets\r\nadd-measure = Add Measure\r\nremove-measure = Remove Measure\r\nname = Name\r\nplay-settings = Play Settings\r\ninput-name-of-rhythm = Input name of rhythm\r\nrhythm-name-field =\r\n  .placeholder = { input-name-of-rhythm }\r\nadd-beat-btn =\r\n  .title = Add Beat\r\nremove-beat-btn =\r\n  .title = Remove Beat\r\nmeasure-title = Measure { $index }\r\nadd-note-btn =\r\n  .title = Add Note\r\nremove-note-btn =\r\n  .title = Remove Note\r\nno-measures = No Measures\r\nuniform = Uniform\r\nvarying = Varying\r\nbeats = Beats\r\ntempo = Tempo\r\nrepeat = Repeat\r\ntype = Type\r\nspeed = Speed\r\nbegin = Begin\r\nend = End\r\nstep = Step\r\nsettings = Settings\r\nprepratory = Prepratory\r\nsightear = SightEar\r\nsightear-description = Sight singing and Ear learning\r\nsight-singing = Sight Singing\r\near-training = Ear Training\r\nstart = Start\r\nthis-app-needs-to-access-mic-and-speaker = This app needs to access your mic and speaker\r\nchange = Change\r\nshow-note = Show Note\r\nhide-note = Hide Note\r\nsing = Sing\r\ntuner = Tuner\r\ntuner-description = Instrument tuner\r\nguitar = Guitar\r\nbass = Bass");
var $995f9b3b1ef38d5a$export$836e793ad054f4a7 = new (0, $64051be3b00f8c45$export$ce122eb5f5b1d45d)("metronome = \u8282\u62CD\u5668\r\nmetronome-description = \u8282\u62CD\u5668\u7528\u4E8E\u4EA7\u751F\u56FA\u5B9A\u7684\u8282\u62CD\u6765\u8BAD\u7EC3\u8282\u594F\u611F\r\nopen = \u6253\u5F00\r\nplay = \u64AD\u653E\r\npause = \u6682\u505C\r\nback = \u8FD4\u56DE\r\ncreate = \u65B0\u5EFA\r\nsave = \u4FDD\u5B58\r\nupdate = \u66F4\u65B0\r\ndefault = \u9ED8\u8BA4\r\npersonal = \u4E2A\u4EBA\r\nrhythms = \u8282\u594F\u578B\r\nno-rhythms = \u5C1A\u65E0\u8282\u594F\u578B\r\ncreate-rhythm = \u521B\u5EFA\u8282\u594F\u578B\r\nsingle = \u5355\u97F3\r\nduplets = \u4E8C\u8FDE\u97F3\r\ntriplets = \u4E09\u8FDE\u97F3\r\nadd-measure = \u6DFB\u52A0\u5C0F\u8282\r\nremove-measure = \u5220\u9664\u5C0F\u8282\r\nname = \u540D\u79F0\r\nplay-settings = \u64AD\u653E\u8BBE\u7F6E\r\ninput-name-of-rhythm = \u8F93\u5165\u8282\u594F\u540D\u79F0\r\nrhythm-name-field =\r\n  .placeholder = { input-name-of-rhythm }\r\nadd-beat-btn =\r\n  .title = \u6DFB\u52A0\u62CD\r\nremove-beat-btn =\r\n  .title = \u5220\u9664\u62CD\r\nmeasure-title = \u7B2C{ $index }\u5C0F\u8282\r\nadd-note-btn =\r\n  .title = \u6DFB\u52A0\u97F3\u7B26\r\nremove-note-btn =\r\n  .title = \u5220\u9664\u97F3\u7B26\r\nno-measures = \u5C1A\u65E0\u5C0F\u8282\r\nuniform = \u5300\u901F\r\nvarying = \u53D8\u901F\r\nbeats = \u8282\u62CD\r\ntempo = \u901F\u5EA6\r\nrepeat = \u91CD\u590D\r\ntype = \u7C7B\u578B\r\nspeed = \u901F\u5EA6\r\nbegin = \u5F00\u59CB\r\nend = \u7ED3\u675F\r\nstep = \u95F4\u9694\r\nsettings = \u8BBE\u7F6E\r\nprepratory = \u9884\u5907\u62CD\r\nsightear = \u89C6\u5531\u7EC3\u8033\r\nsightear-description = \u89C6\u5531\u7EC3\u8033\u8BAD\u7EC3\r\nsight-singing = \u89C6\u5531\r\near-training = \u7EC3\u8033\r\nstart = \u5F00\u59CB\r\nthis-app-needs-to-access-mic-and-speaker = \u6B64\u5E94\u7528\u9700\u8981\u8BBF\u95EE\u9EA6\u514B\u98CE\u548C\u626C\u58F0\u5668\r\nchange = \u5207\u6362\r\nshow-note = \u663E\u793A\u97F3\u7B26\r\nhide-note = \u9690\u85CF\u97F3\u7B26\r\nsing = \u6F14\u5531\r\ntuner = \u8C03\u97F3\u8868\r\ntuner-description = \u4E50\u5668\u8C03\u97F3\r\nguitar = \u5409\u4ED6\r\nbass = \u8D1D\u65AF");
var $995f9b3b1ef38d5a$export$4e841128923ef26 = {
    en: $995f9b3b1ef38d5a$export$137380d9ce54f7f,
    "en-US": $995f9b3b1ef38d5a$export$137380d9ce54f7f,
    "zh-CN": $995f9b3b1ef38d5a$export$836e793ad054f4a7,
    zh: $995f9b3b1ef38d5a$export$836e793ad054f4a7
};
var $995f9b3b1ef38d5a$export$8873dd238bb2ebe4 = {
    en: "English",
    "en-US": "English",
    "zh-CN": "\u7B80\u4F53\u4E2D\u6587",
    zh: "\u7B80\u4F53\u4E2D\u6587"
};
function $995f9b3b1ef38d5a$export$e0d95663aee8b8f2(locale) {
    var bundle;
    return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                bundle = new (0, $bf7b7a9819372ede$export$dbb69eb03354692e)(locale);
                bundle.addResource($995f9b3b1ef38d5a$export$4e841128923ef26[locale]);
                return [
                    4,
                    bundle
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function $995f9b3b1ef38d5a$export$f09106e7c6677ec5() {
    var currentLocales = (0, $00475822f6f9f36c$export$28c63aca0b34941c)([
        "en-US",
        "zh-CN"
    ], Object.keys($995f9b3b1ef38d5a$export$4e841128923ef26), {
        defaultLocale: "en-US"
    });
    return currentLocales[0];
}



var $6c6c68292fd863a8$export$ecb528a76bca42b0 = "musicalpal.locale";
var $6c6c68292fd863a8$export$122994dc05ba4308 = /*#__PURE__*/ (0, $8SyCD.createContext)({
    locale: "en-US",
    changeLocale: function() {},
    setupAudioContext: function() {}
});
function $6c6c68292fd863a8$export$20d2b7652facc723(props) {
    var children = props.children;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(function() {
        try {
            var locale = window.localStorage.getItem($6c6c68292fd863a8$export$ecb528a76bca42b0);
            if (!locale) return (0, $995f9b3b1ef38d5a$export$f09106e7c6677ec5)();
            else return locale;
        } catch (e) {
            return (0, $995f9b3b1ef38d5a$export$f09106e7c6677ec5)();
        }
    }), 2), locale = _useState[0], setLocale = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(function() {
        return new (0, $7ab6a2f379e810f0$export$d677167801025e9c)((0, $995f9b3b1ef38d5a$export$e0d95663aee8b8f2)(locale));
    }), 2), l10n = _useState1[0], setL10n = _useState1[1];
    var changeLocale = (0, $8SyCD.useCallback)(function(locale) {
        try {
            window.localStorage.setItem($6c6c68292fd863a8$export$ecb528a76bca42b0, locale);
        } finally{
            setLocale(locale);
            setL10n(new (0, $7ab6a2f379e810f0$export$d677167801025e9c)((0, $995f9b3b1ef38d5a$export$e0d95663aee8b8f2)(locale)));
        }
    }, [
        setL10n
    ]);
    var _useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(), 2), audioContext = _useState2[0], setAudioContext = _useState2[1];
    var setupAudioContext = (0, $8SyCD.useCallback)(/*#__PURE__*/ (0, $14480b1fff30b85c$export$7c398597f8905a1)(function() {
        var audioContext;
        return (0, $1e21d28140546eff$export$67ebef60e6f28a6)(this, function(_state) {
            audioContext = new AudioContext();
            setAudioContext(audioContext);
            return [
                2
            ];
        });
    }), [
        setAudioContext
    ]);
    (0, $8SyCD.useEffect)(function() {
        return function() {
            if ((audioContext === null || audioContext === void 0 ? void 0 : audioContext.state) === "running") audioContext === null || audioContext === void 0 ? void 0 : audioContext.close();
        };
    }, [
        audioContext
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)($6c6c68292fd863a8$export$122994dc05ba4308.Provider, {
        value: {
            audioContext: audioContext,
            setupAudioContext: setupAudioContext,
            locale: locale,
            changeLocale: changeLocale
        },
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $cbedd744a85eec5e$export$dc45bdc734ce6f1e), {
            l10n: l10n,
            children: children
        })
    });
}
function $6c6c68292fd863a8$export$fdc397e486fa83e7() {
    return (0, $8SyCD.useContext)($6c6c68292fd863a8$export$122994dc05ba4308);
}




function $0da8ea1c63cdd660$export$36d69433c4f81145() {
    var items = [
        {
            label: (0, $995f9b3b1ef38d5a$export$8873dd238bb2ebe4)["en-US"],
            key: "en-US"
        },
        {
            label: (0, $995f9b3b1ef38d5a$export$8873dd238bb2ebe4)["zh-CN"],
            key: "zh-CN"
        }
    ];
    var _useAppContext = (0, $6c6c68292fd863a8$export$fdc397e486fa83e7)(), locale = _useAppContext.locale, changeLocale = _useAppContext.changeLocale;
    var handleLocaleChanged = (0, $8SyCD.useCallback)(function(param) {
        var key = param.key;
        changeLocale(key);
    }, [
        changeLocale
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "page page--home",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__header",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $1819c5248ff6edcc$export$2e2bcd8739ae039), {
                    menu: {
                        items: items,
                        onClick: handleLocaleChanged
                    },
                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $cca9a1e197770e5b$export$2e2bcd8739ae039), {}),
                        children: (0, $995f9b3b1ef38d5a$export$8873dd238bb2ebe4)[locale]
                    })
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $4717634082efcae4$export$2e2bcd8739ae039), {
                    bordered: true,
                    children: [
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item, {
                            actions: [
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $76b4f75f035f6acf$export$a6c7ac8248d6e38a), {
                                    to: "/metronome",
                                    children: [
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $44e15bb0c0ae7cd4$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                            id: "open",
                                            children: "Open"
                                        })
                                    ]
                                })
                            ],
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item.Meta, {
                                title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "metronome"
                                }),
                                description: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "metronome-description"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item, {
                            actions: [
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $76b4f75f035f6acf$export$a6c7ac8248d6e38a), {
                                    to: "/sightear",
                                    children: [
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $44e15bb0c0ae7cd4$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                            id: "open",
                                            children: "Open"
                                        })
                                    ]
                                })
                            ],
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item.Meta, {
                                title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "sightear"
                                }),
                                description: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "sightear-description"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item, {
                            actions: [
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $76b4f75f035f6acf$export$a6c7ac8248d6e38a), {
                                    to: "/tuner",
                                    children: [
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $44e15bb0c0ae7cd4$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                            id: "open",
                                            children: "Open"
                                        })
                                    ]
                                })
                            ],
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4717634082efcae4$export$2e2bcd8739ae039).Item.Meta, {
                                title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "tuner"
                                }),
                                description: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "tuner-description"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}








var $8SyCD = parcelRequire("8SyCD");








var $8SyCD = parcelRequire("8SyCD");






var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $0176c499cfcaafd6$var$PauseCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            }
        ]
    },
    name: "pause-circle",
    theme: "filled"
};
var $0176c499cfcaafd6$export$2e2bcd8739ae039 = $0176c499cfcaafd6$var$PauseCircleFilled;



var $f356564b4af154e8$var$PauseCircleFilled = function PauseCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0176c499cfcaafd6$export$2e2bcd8739ae039)
    }));
};
var $f356564b4af154e8$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($f356564b4af154e8$var$PauseCircleFilled);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $f3e8b3c012ca5e5d$var$PlayCircleFilled = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z"
                }
            }
        ]
    },
    name: "play-circle",
    theme: "filled"
};
var $f3e8b3c012ca5e5d$export$2e2bcd8739ae039 = $f3e8b3c012ca5e5d$var$PlayCircleFilled;



var $5074ff8a83c1ffcc$var$PlayCircleFilled = function PlayCircleFilled(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f3e8b3c012ca5e5d$export$2e2bcd8739ae039)
    }));
};
var $5074ff8a83c1ffcc$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($5074ff8a83c1ffcc$var$PlayCircleFilled);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $def19b4df6158cdb$var$SaveOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    },
    name: "save",
    theme: "outlined"
};
var $def19b4df6158cdb$export$2e2bcd8739ae039 = $def19b4df6158cdb$var$SaveOutlined;



var $cd1eaa62a0332538$var$SaveOutlined = function SaveOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $def19b4df6158cdb$export$2e2bcd8739ae039)
    }));
};
var $cd1eaa62a0332538$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($cd1eaa62a0332538$var$SaveOutlined);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $618fbd1d64764a2c$var$SettingOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    name: "setting",
    theme: "outlined"
};
var $618fbd1d64764a2c$export$2e2bcd8739ae039 = $618fbd1d64764a2c$var$SettingOutlined;



var $9e059380a1b90939$var$SettingOutlined = function SettingOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $618fbd1d64764a2c$export$2e2bcd8739ae039)
    }));
};
var $9e059380a1b90939$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($9e059380a1b90939$var$SettingOutlined);




function $120adcf1c3a25849$export$4867023e52e26014(props) {
    var children = props.children, onSave = props.onSave;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(false), 2), hasPendingChanges = _useState[0], setHasPendingChanges = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(function() {
        return (0, $e7d0c89ead4e7b91$export$85510b841f5c59b9)(props.rhythm);
    }), 2), rhythm = _useState1[0], setRhythm = _useState1[1];
    (0, $8SyCD.useEffect)(function() {
        setRhythm((0, $e7d0c89ead4e7b91$export$85510b841f5c59b9)(props.rhythm));
    }, [
        props.rhythm,
        setRhythm
    ]);
    var updateRhythm = (0, $8SyCD.useCallback)(function(updater) {
        setRhythm(updater);
        setHasPendingChanges(true);
    }, [
        setRhythm,
        setHasPendingChanges
    ]);
    var handleAddMeasure = (0, $8SyCD.useCallback)(function() {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$8abb4dd589a611d)(rhythm);
        });
    }, [
        updateRhythm
    ]);
    var handleRemoveMeasure = (0, $8SyCD.useCallback)(function(measureIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$21f3df343fa13a46)(rhythm, measureIndex);
        });
    }, [
        updateRhythm
    ]);
    var handleAddBeat = (0, $8SyCD.useCallback)(function(measureIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$830fa49c40093bd5)(rhythm, measureIndex);
        });
    }, [
        updateRhythm
    ]);
    var handleRemoveBeat = (0, $8SyCD.useCallback)(function(measureIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$9387a39c06a193e3)(rhythm, measureIndex);
        });
    }, [
        updateRhythm
    ]);
    var handleAddNote = (0, $8SyCD.useCallback)(function(measureIndex, beatIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$79159e21a6bceab7)(rhythm, measureIndex, beatIndex);
        });
    }, [
        updateRhythm
    ]);
    var handleChangeNote = (0, $8SyCD.useCallback)(function(measureIndex, beatIndex, noteIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$8847734722b7329e)(rhythm, measureIndex, beatIndex, noteIndex);
        });
    }, [
        updateRhythm
    ]);
    var handleRemoveNote = (0, $8SyCD.useCallback)(function(measureIndex, beatIndex) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$84ca89dac13ca70a)(rhythm, measureIndex, beatIndex);
        });
    }, [
        updateRhythm
    ]);
    var _useFlag = (0, $2c9a6289909a7048$export$983b9b54330812cb)(false), isRunning = _useFlag.flag, stop = _useFlag.turnOff, toggle = _useFlag.toggle;
    var handleChangeRepeat = (0, $8SyCD.useCallback)(function(measuerIndex, repeat) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$a2bc369da6b0184b)(rhythm, measuerIndex, repeat);
        });
    }, [
        updateRhythm
    ]);
    var _useFlag1 = (0, $2c9a6289909a7048$export$983b9b54330812cb)(false), isSettingsModalOpened = _useFlag1.flag, openSettingsModal = _useFlag1.turnOn, closeSettingsModal = _useFlag1.turnOff;
    var handleChangePreparatory = (0, $8SyCD.useCallback)(function(pareparatory) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$626701cf3387d96f)(rhythm, pareparatory);
        });
    }, [
        updateRhythm
    ]);
    var handleChangeTempo = (0, $8SyCD.useCallback)(function(tempo) {
        updateRhythm(function(rhythm) {
            return (0, $e7d0c89ead4e7b91$export$14dbe7bbd606b84a)(rhythm, tempo);
        });
    }, [
        updateRhythm
    ]);
    var handleSave = (0, $8SyCD.useCallback)(function() {
        onSave(rhythm);
        setHasPendingChanges(false);
    }, [
        rhythm,
        onSave,
        setHasPendingChanges
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "rhythm__editor",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6cd6357e72a6c21d$export$16de697746054156), {
                rhythm: rhythm,
                isRunning: isRunning,
                onEnd: stop,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $a9168fe7c1f927dc$export$e0269c33dd6199d9), {
                    rhythm: rhythm,
                    onChangeRepeat: handleChangeRepeat,
                    onAddMeasure: handleAddMeasure,
                    onRemoveMeasure: handleRemoveMeasure,
                    onAddBeat: handleAddBeat,
                    onRemoveBeat: handleRemoveBeat,
                    onAddNote: handleAddNote,
                    onChangeNote: handleChangeNote,
                    onRemoveNote: handleRemoveNote
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "rhythm__editor__footer",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
                    className: "toolbar",
                    children: [
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
                            className: "toolbar__main",
                            children: [
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    icon: isRunning ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f356564b4af154e8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $5074ff8a83c1ffcc$export$2e2bcd8739ae039), {}),
                                    onClick: toggle,
                                    children: isRunning ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                        id: "pause",
                                        children: "Pause"
                                    }) : /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                        id: "play",
                                        children: "Play"
                                    })
                                }),
                                /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                    disabled: isRunning,
                                    icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $9e059380a1b90939$export$2e2bcd8739ae039), {}),
                                    onClick: openSettingsModal,
                                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                        id: "play-settings",
                                        children: "Play Settings"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                            className: "toolbar__side",
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                disabled: !hasPendingChanges,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $cd1eaa62a0332538$export$2e2bcd8739ae039), {}),
                                onClick: handleSave,
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "save",
                                    children: "Save"
                                })
                            })
                        })
                    ]
                })
            }),
            children,
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $d7fa675cd1188439$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "play-settings",
                    children: "Play Settings"
                }),
                open: isSettingsModalOpened,
                footer: null,
                onCancel: closeSettingsModal,
                children: [
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $256a356f4461b6e7$export$e15dc023ebc1e95f), {
                        preparatory: rhythm.preparatoryBeats,
                        onChangePreparatory: handleChangePreparatory
                    }),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $10b81a11b890c51d$export$4aa85292d1b0882e), {
                        tempo: rhythm.tempo,
                        onChangeTempo: handleChangeTempo
                    })
                ]
            })
        ]
    });
}



parcelRequire("8SyCD");

function $303680bc5f0d6d37$export$ffffe40bfa0649a3(props) {
    var children = props.children;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
        className: "fill",
        children: children
    });
}



parcelRequire("8SyCD");


var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $98f7aae4abaa0ae7$var$InfoCircleOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    name: "info-circle",
    theme: "outlined"
};
var $98f7aae4abaa0ae7$export$2e2bcd8739ae039 = $98f7aae4abaa0ae7$var$InfoCircleOutlined;



var $da6dfbc8adc40d2a$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $98f7aae4abaa0ae7$export$2e2bcd8739ae039)
    }));
};
var $da6dfbc8adc40d2a$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($da6dfbc8adc40d2a$var$InfoCircleOutlined);




var $8SyCD = parcelRequire("8SyCD");




var $7FyBz = parcelRequire("7FyBz");



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $87f1c959e54c9be0$var$CopyOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    name: "copy",
    theme: "outlined"
};
var $87f1c959e54c9be0$export$2e2bcd8739ae039 = $87f1c959e54c9be0$var$CopyOutlined;



var $c791fa3dc55e353a$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $87f1c959e54c9be0$export$2e2bcd8739ae039)
    }));
};
var $c791fa3dc55e353a$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($c791fa3dc55e353a$var$CopyOutlined);




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $bba426012ab46afe$var$EditOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    name: "edit",
    theme: "outlined"
};
var $bba426012ab46afe$export$2e2bcd8739ae039 = $bba426012ab46afe$var$EditOutlined;



var $5914894978b4ea58$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $bba426012ab46afe$export$2e2bcd8739ae039)
    }));
};
var $5914894978b4ea58$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($5914894978b4ea58$var$EditOutlined);



var $0fb72ed45706c9c5$exports = {};
"use strict";
var $1f51dbdc940783af$exports = {};
$1f51dbdc940783af$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $0fb72ed45706c9c5$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $0fb72ed45706c9c5$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $0fb72ed45706c9c5$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $0fb72ed45706c9c5$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $1f51dbdc940783af$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var _$format = $0fb72ed45706c9c5$var$clipboardToIE11Formatting[options.format] || $0fb72ed45706c9c5$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(_$format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $0fb72ed45706c9c5$var$format("message" in options ? options.message : $0fb72ed45706c9c5$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$0fb72ed45706c9c5$exports = $0fb72ed45706c9c5$var$copy;









var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");
"use client";
var $f2ee2ed679fea447$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f2ee2ed679fea447$var$inlineStyle = {
    border: 0,
    background: "transparent",
    padding: 0,
    lineHeight: "inherit",
    display: "inline-block"
};
var $f2ee2ed679fea447$var$TransButton = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var onKeyDown = function(event) {
        var keyCode = event.keyCode;
        if (keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) event.preventDefault();
    };
    var onKeyUp = function(event) {
        var keyCode = event.keyCode;
        var onClick = props.onClick;
        if (keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER && onClick) onClick();
    };
    var style = props.style, noStyle = props.noStyle, disabled = props.disabled, restProps = $f2ee2ed679fea447$var$__rest(props, [
        "style",
        "noStyle",
        "disabled"
    ]);
    var mergedStyle = {};
    if (!noStyle) mergedStyle = Object.assign({}, $f2ee2ed679fea447$var$inlineStyle);
    if (disabled) mergedStyle.pointerEvents = "none";
    mergedStyle = Object.assign(Object.assign({}, mergedStyle), style);
    return /*#__PURE__*/ $8SyCD.createElement("div", Object.assign({
        role: "button",
        tabIndex: 0,
        ref: ref
    }, restProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        style: mergedStyle
    }));
});
var $f2ee2ed679fea447$export$2e2bcd8739ae039 = $f2ee2ed679fea447$var$TransButton;









var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $effbd10c9fb7d523$var$EnterOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    name: "enter",
    theme: "outlined"
};
var $effbd10c9fb7d523$export$2e2bcd8739ae039 = $effbd10c9fb7d523$var$EnterOutlined;



var $c008c2609ecc269b$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $effbd10c9fb7d523$export$2e2bcd8739ae039)
    }));
};
var $c008c2609ecc269b$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($c008c2609ecc269b$var$EnterOutlined);





var $8SyCD = parcelRequire("8SyCD");





/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
  margin-bottom: @headingMarginBottom;
  color: @headingColor;
  font-weight: @fontWeight;
  fontSize: @fontSize;
  line-height: @lineHeight;
}
*/ 



// eslint-disable-next-line import/prefer-default-export
var $8b6b8c3b5e2a189d$var$getTitleStyle = function(fontSize, lineHeight, color, token) {
    var titleMarginBottom = token.titleMarginBottom, fontWeightStrong = token.fontWeightStrong;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
var $8b6b8c3b5e2a189d$export$83146cf7d1bec659 = function(token) {
    var headings = [
        1,
        2,
        3,
        4,
        5
    ];
    var styles = {};
    headings.forEach(function(headingLevel) {
        styles["\n      h".concat(headingLevel, "&,\n      div&-h").concat(headingLevel, ",\n      div&-h").concat(headingLevel, " > textarea,\n      h").concat(headingLevel, "\n    ")] = $8b6b8c3b5e2a189d$var$getTitleStyle(token["fontSizeHeading".concat(headingLevel)], token["lineHeightHeading".concat(headingLevel)], token.colorTextHeading, token);
    });
    return styles;
};
var $8b6b8c3b5e2a189d$export$566f4066c7caac18 = function(token) {
    var componentCls = token.componentCls;
    return {
        "a&, a": Object.assign(Object.assign({}, (0, $37504622da5ae229$export$9a16e7694a707ab4)(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            textDecoration: token.linkDecoration,
            "&:active, &:hover": {
                textDecoration: token.linkHoverDecoration
            }
        }, "&[disabled], &".concat(componentCls, "-disabled"), {
            color: token.colorTextDisabled,
            cursor: "not-allowed",
            "&:active, &:hover": {
                color: token.colorTextDisabled
            },
            "&:active": {
                pointerEvents: "none"
            }
        }))
    };
};
var $8b6b8c3b5e2a189d$export$977383a86f45014b = function(token) {
    return {
        code: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.2em 0.1em",
            fontSize: "85%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3
        },
        kbd: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.15em 0.1em",
            fontSize: "90%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.06)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $cf51007abaccff76$export$c24201f7fe3571d8)[2]
        },
        "u, ins": {
            textDecoration: "underline",
            textDecorationSkipInk: "auto"
        },
        "s, del": {
            textDecoration: "line-through"
        },
        strong: {
            fontWeight: 600
        },
        // list
        "ul, ol": {
            marginInline: 0,
            marginBlock: "0 1em",
            padding: 0,
            li: {
                marginInline: "20px 0",
                marginBlock: 0,
                paddingInline: "4px 0",
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: "circle",
            ul: {
                listStyleType: "disc"
            }
        },
        ol: {
            listStyleType: "decimal"
        },
        // pre & block
        "pre, blockquote": {
            margin: "1em 0"
        },
        pre: {
            padding: "0.4em 0.6em",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: "inline",
                margin: 0,
                padding: 0,
                fontSize: "inherit",
                fontFamily: "inherit",
                background: "transparent",
                border: 0
            }
        },
        blockquote: {
            paddingInline: "0.6em 0",
            paddingBlock: 0,
            borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
            opacity: 0.85
        }
    };
};
var $8b6b8c3b5e2a189d$export$2667badb03518972 = function(token) {
    var componentCls = token.componentCls, paddingSM = token.paddingSM;
    var inputShift = paddingSM;
    var _obj;
    return {
        "&-edit-content": (_obj = {
            position: "relative",
            "div&": {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                marginTop: token.calc(inputShift).mul(-1).equal(),
                marginBottom: "calc(1em - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(inputShift), ")")
            }
        }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-edit-content-confirm"), {
            position: "absolute",
            insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
            insetBlockEnd: token.marginXS,
            color: token.colorTextDescription,
            // default style
            fontWeight: "normal",
            fontSize: token.fontSize,
            fontStyle: "normal",
            pointerEvents: "none"
        }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "textarea", {
            margin: "0!important",
            // Fix Editable Textarea flash in Firefox
            MozTransition: "none",
            height: "1em"
        }), _obj)
    };
};
var $8b6b8c3b5e2a189d$export$34755446404037a5 = function(token) {
    return {
        "&-copy-success": (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "\n    &,\n    &:hover,\n    &:focus", {
            color: token.colorSuccess
        })
    };
};
var $8b6b8c3b5e2a189d$export$d9556a50eba3003b = function() {
    var _obj;
    return _obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n  a&-ellipsis,\n  span&-ellipsis\n  ", {
        display: "inline-block",
        maxWidth: "100%"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-single-line", {
        whiteSpace: "nowrap"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-ellipsis-single-line", {
        overflow: "hidden",
        textOverflow: "ellipsis",
        // https://blog.csdn.net/iefreer/article/details/50421025
        "a&, span&": {
            verticalAlign: "bottom"
        },
        "> code": {
            paddingBlock: 0,
            maxWidth: "calc(100% - 1.2em)",
            display: "inline-block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "bottom",
            // https://github.com/ant-design/ant-design/issues/45953
            boxSizing: "content-box"
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-ellipsis-multiple-line", {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical"
    }), _obj;
};


var $ed2599c43cbcbe22$var$genTypographyStyle = function(token) {
    var componentCls = token.componentCls, titleMarginTop = token.titleMarginTop;
    var _obj, _obj1;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign((_obj = {
        color: token.colorText,
        wordBreak: "break-word",
        lineHeight: token.lineHeight
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-secondary"), {
        color: token.colorTextDescription
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-success"), {
        color: token.colorSuccess
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-warning"), {
        color: token.colorWarning
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-danger"), {
        color: token.colorError,
        "a&:active, a&:focus": {
            color: token.colorErrorActive
        },
        "a&:hover": {
            color: token.colorErrorHover
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-disabled"), {
        color: token.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "\n        div&,\n        p\n      ", {
        marginBottom: "1em"
    }), _obj), (0, $8b6b8c3b5e2a189d$export$83146cf7d1bec659)(token)), (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "\n      & + h1".concat(componentCls, ",\n      & + h2").concat(componentCls, ",\n      & + h3").concat(componentCls, ",\n      & + h4").concat(componentCls, ",\n      & + h5").concat(componentCls, "\n      "), {
        marginTop: titleMarginTop
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5", (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ", {
        marginTop: titleMarginTop
    })), _obj1)), (0, $8b6b8c3b5e2a189d$export$977383a86f45014b)(token)), (0, $8b6b8c3b5e2a189d$export$566f4066c7caac18)(token)), // Operation
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "\n        ".concat(componentCls, "-expand,\n        ").concat(componentCls, "-edit,\n        ").concat(componentCls, "-copy\n      "), Object.assign(Object.assign({}, (0, $37504622da5ae229$export$9a16e7694a707ab4)(token)), {
        marginInlineStart: token.marginXXS
    }))), (0, $8b6b8c3b5e2a189d$export$2667badb03518972)(token)), (0, $8b6b8c3b5e2a189d$export$34755446404037a5)(token)), (0, $8b6b8c3b5e2a189d$export$d9556a50eba3003b)()), {
        "&-rtl": {
            direction: "rtl"
        }
    }));
};
var $ed2599c43cbcbe22$export$9ca1be8807fe0675 = function() {
    return {
        titleMarginTop: "1.2em",
        titleMarginBottom: "0.5em"
    };
};
var // ============================== Export ==============================
$ed2599c43cbcbe22$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Typography", function(token) {
    return [
        $ed2599c43cbcbe22$var$genTypographyStyle(token)
    ];
}, $ed2599c43cbcbe22$export$9ca1be8807fe0675);


"use client";
var $e1d46155154a2702$var$Editable = function(props) {
    var prefixCls = props.prefixCls, ariaLabel = props["aria-label"], className = props.className, style = props.style, direction = props.direction, maxLength = props.maxLength, _props_autoSize = props.autoSize, autoSize = _props_autoSize === void 0 ? true : _props_autoSize, value = props.value, onSave = props.onSave, onCancel = props.onCancel, onEnd = props.onEnd, component = props.component, _props_enterIcon = props.enterIcon, enterIcon = _props_enterIcon === void 0 ? /*#__PURE__*/ $8SyCD.createElement((0, $c008c2609ecc269b$export$2e2bcd8739ae039), null) : _props_enterIcon;
    var ref = $8SyCD.useRef(null);
    var inComposition = $8SyCD.useRef(false);
    var lastKeyCode = $8SyCD.useRef();
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(value), 2), current = _React_useState[0], setCurrent = _React_useState[1];
    $8SyCD.useEffect(function() {
        setCurrent(value);
    }, [
        value
    ]);
    $8SyCD.useEffect(function() {
        if (ref.current && ref.current.resizableTextArea) {
            var textArea = ref.current.resizableTextArea.textArea;
            textArea.focus();
            var length = textArea.value.length;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    var onChange = function(_ref) {
        var target = _ref.target;
        setCurrent(target.value.replace(/[\n\r]/g, ""));
    };
    var onCompositionStart = function() {
        inComposition.current = true;
    };
    var onCompositionEnd = function() {
        inComposition.current = false;
    };
    var onKeyDown = function(_ref2) {
        var keyCode = _ref2.keyCode;
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    var confirmChange = function() {
        onSave(current.trim());
    };
    var onKeyUp = function(_ref3) {
        var keyCode = _ref3.keyCode, ctrlKey = _ref3.ctrlKey, altKey = _ref3.altKey, metaKey = _ref3.metaKey, shiftKey = _ref3.shiftKey;
        // Check if it's a real key
        if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
            if (keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ENTER) {
                confirmChange();
                onEnd === null || onEnd === void 0 || onEnd();
            } else if (keyCode === (0, $5ebc594569656f88$export$2e2bcd8739ae039).ESC) onCancel();
        }
    };
    var onBlur = function() {
        confirmChange();
    };
    var textClassName = component ? "".concat(prefixCls, "-").concat(component) : "";
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $ed2599c43cbcbe22$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-edit-content"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className, textClassName, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $8SyCD.createElement((0, $dc712ed726ceb2bf$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $70bdd1d9fe5ae128$export$e530037191fcd5d7)(enterIcon, {
        className: "".concat(prefixCls, "-edit-content-confirm")
    }) : null));
};
var $e1d46155154a2702$export$2e2bcd8739ae039 = $e1d46155154a2702$var$Editable;





var $8SyCD = parcelRequire("8SyCD");





"use client";
var $bc3738c6e1980571$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc3738c6e1980571$var$Typography = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, tmp = props.component, Component = tmp === void 0 ? "article" : tmp, className = props.className, rootClassName = props.rootClassName, setContentRef = props.setContentRef, children = props.children, typographyDirection = props.direction, style = props.style, restProps = $bc3738c6e1980571$var$__rest(props, [
        "prefixCls",
        "component",
        "className",
        "rootClassName",
        "setContentRef",
        "children",
        "direction",
        "style"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, contextDirection = _React_useContext.direction, typography = _React_useContext.typography;
    var direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    var mergedRef = ref;
    if (setContentRef) mergedRef = (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(ref, setContentRef);
    var prefixCls = getPrefixCls("typography", customizePrefixCls);
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $ed2599c43cbcbe22$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, typography === null || typography === void 0 ? void 0 : typography.className, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className, rootClassName, hashId);
    var mergedStyle = Object.assign(Object.assign({}, typography === null || typography === void 0 ? void 0 : typography.style), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $8SyCD.createElement(Component, Object.assign({
        className: componentClassName,
        style: mergedStyle,
        ref: mergedRef
    }, restProps), children));
});
var // es default export should use const instead of let
$bc3738c6e1980571$export$2e2bcd8739ae039 = $bc3738c6e1980571$var$Typography;



var $8SyCD = parcelRequire("8SyCD");
function $c289d94de4fc78d3$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $8SyCD.useMemo(function() {
        var support = !!propConfig;
        return [
            support,
            Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === "object" ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $8SyCD = parcelRequire("8SyCD");
/** Similar with `useEffect` but only trigger after mounted */ var $35c6bd3fc003c65e$var$useUpdatedEffect = function(callback, conditions) {
    var mountRef = $8SyCD.useRef(false);
    $8SyCD.useEffect(function() {
        if (mountRef.current) callback();
        else mountRef.current = true;
    }, conditions);
};
var $35c6bd3fc003c65e$export$2e2bcd8739ae039 = $35c6bd3fc003c65e$var$useUpdatedEffect;




var $7FyBz = parcelRequire("7FyBz");

var $8SyCD = parcelRequire("8SyCD");


"use client";
function $9ec3b74e87a0624c$var$cuttable(node) {
    var type = typeof node === "undefined" ? "undefined" : (0, $7FyBz._)(node);
    return type === "string" || type === "number";
}
function $9ec3b74e87a0624c$var$getNodesLen(nodeList) {
    var totalLen = 0;
    nodeList.forEach(function(node) {
        if ($9ec3b74e87a0624c$var$cuttable(node)) totalLen += String(node).length;
        else totalLen += 1;
    });
    return totalLen;
}
function $9ec3b74e87a0624c$var$sliceNodes(nodeList, len) {
    var currLen = 0;
    var currentNodeList = [];
    for(var i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        var node = nodeList[i];
        var canCut = $9ec3b74e87a0624c$var$cuttable(node);
        var nodeLen = canCut ? String(node).length : 1;
        var nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            var restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
var $9ec3b74e87a0624c$var$NONE = 0;
var $9ec3b74e87a0624c$var$PREPARE = 1;
var $9ec3b74e87a0624c$var$WALKING = 2;
var $9ec3b74e87a0624c$var$DONE_WITH_ELLIPSIS = 3;
var $9ec3b74e87a0624c$var$DONE_WITHOUT_ELLIPSIS = 4;
var $9ec3b74e87a0624c$var$Ellipsis = function(_ref) {
    var enabledMeasure = _ref.enabledMeasure, children = _ref.children, text = _ref.text, width = _ref.width, fontSize = _ref.fontSize, rows = _ref.rows, onEllipsis = _ref.onEllipsis;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState([
        0,
        0,
        0
    ]), 2), _React_useState_ = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)(_React_useState[0], 3), startLen = _React_useState_[0], midLen = _React_useState_[1], endLen = _React_useState_[2], setCutLength = _React_useState[1];
    // record last done with ellipsis width
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), lastLen = _React_useState1[0], setLastLen = _React_useState1[1];
    var _React_useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState($9ec3b74e87a0624c$var$NONE), 2), walkingState = _React_useState2[0], setWalkingState = _React_useState2[1];
    var _React_useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), singleRowHeight = _React_useState3[0], setSingleRowHeight = _React_useState3[1];
    var singleRowRef = $8SyCD.useRef(null);
    var midRowRef = $8SyCD.useRef(null);
    var nodeList = $8SyCD.useMemo(function() {
        return (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(text);
    }, [
        text
    ]);
    var totalLen = $8SyCD.useMemo(function() {
        return $9ec3b74e87a0624c$var$getNodesLen(nodeList);
    }, [
        nodeList
    ]);
    var mergedChildren = $8SyCD.useMemo(function() {
        if (!enabledMeasure || walkingState !== $9ec3b74e87a0624c$var$DONE_WITH_ELLIPSIS) {
            // if has lastLen, use it as temporary width to avoid lots of text to squeeze space.
            if (lastLen && walkingState !== $9ec3b74e87a0624c$var$DONE_WITHOUT_ELLIPSIS && enabledMeasure) return children($9ec3b74e87a0624c$var$sliceNodes(nodeList, lastLen), lastLen < totalLen);
            return children(nodeList, false);
        }
        return children($9ec3b74e87a0624c$var$sliceNodes(nodeList, midLen), midLen < totalLen);
    }, [
        enabledMeasure,
        walkingState,
        children,
        nodeList,
        midLen,
        totalLen
    ]);
    // ======================== Walk ========================
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (enabledMeasure && width && fontSize && totalLen) {
            setWalkingState($9ec3b74e87a0624c$var$PREPARE);
            setCutLength([
                0,
                Math.ceil(totalLen / 2),
                totalLen
            ]);
        }
    }, [
        enabledMeasure,
        width,
        fontSize,
        text,
        totalLen,
        rows
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        var _a;
        if (walkingState === $9ec3b74e87a0624c$var$PREPARE) setSingleRowHeight(((_a = singleRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
    }, [
        walkingState
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        var _a, _b;
        if (singleRowHeight) {
            if (walkingState === $9ec3b74e87a0624c$var$PREPARE) {
                // Ignore if position is enough
                var midHeight = ((_a = midRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
                var maxHeight = rows * singleRowHeight;
                if (midHeight <= maxHeight) {
                    setWalkingState($9ec3b74e87a0624c$var$DONE_WITHOUT_ELLIPSIS);
                    onEllipsis(false);
                } else setWalkingState($9ec3b74e87a0624c$var$WALKING);
            } else if (walkingState === $9ec3b74e87a0624c$var$WALKING) {
                if (startLen !== endLen) {
                    var midHeight1 = ((_b = midRowRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
                    var maxHeight1 = rows * singleRowHeight;
                    var nextStartLen = startLen;
                    var nextEndLen = endLen;
                    // We reach the last round
                    if (startLen === endLen - 1) nextEndLen = startLen;
                    else if (midHeight1 <= maxHeight1) nextStartLen = midLen;
                    else nextEndLen = midLen;
                    var nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
                    setCutLength([
                        nextStartLen,
                        nextMidLen,
                        nextEndLen
                    ]);
                } else {
                    setWalkingState($9ec3b74e87a0624c$var$DONE_WITH_ELLIPSIS);
                    setLastLen(midLen);
                    onEllipsis(true);
                }
            }
        }
    }, [
        walkingState,
        startLen,
        endLen,
        rows,
        singleRowHeight
    ]);
    // ======================= Render =======================
    var measureStyle = {
        width: width,
        whiteSpace: "normal",
        margin: 0,
        padding: 0
    };
    var renderMeasure = function(content, ref, style) {
        return /*#__PURE__*/ $8SyCD.createElement("span", {
            "aria-hidden": true,
            ref: ref,
            style: Object.assign({
                position: "fixed",
                display: "block",
                left: 0,
                top: 0,
                zIndex: -9999,
                visibility: "hidden",
                pointerEvents: "none",
                fontSize: Math.ceil(fontSize / 2) * 2
            }, style)
        }, content);
    };
    var renderMeasureSlice = function(len, ref) {
        var sliceNodeList = $9ec3b74e87a0624c$var$sliceNodes(nodeList, len);
        return renderMeasure(children(sliceNodeList, true), ref, measureStyle);
    };
    return /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, mergedChildren, enabledMeasure && walkingState !== $9ec3b74e87a0624c$var$DONE_WITH_ELLIPSIS && walkingState !== $9ec3b74e87a0624c$var$DONE_WITHOUT_ELLIPSIS && /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, renderMeasure("lg", singleRowRef, {
        wordBreak: "keep-all",
        whiteSpace: "nowrap"
    }), walkingState === $9ec3b74e87a0624c$var$PREPARE ? renderMeasure(children(nodeList, false), midRowRef, measureStyle) : renderMeasureSlice(midLen, midRowRef)));
};
var $9ec3b74e87a0624c$export$2e2bcd8739ae039 = $9ec3b74e87a0624c$var$Ellipsis;



var $8SyCD = parcelRequire("8SyCD");

"use client";
var $fbc93a103d0e99ee$var$EllipsisTooltip = function(_ref) {
    var enabledEllipsis = _ref.enabledEllipsis, isEllipsis = _ref.isEllipsis, children = _ref.children, tooltipProps = _ref.tooltipProps;
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enabledEllipsis) return children;
    return /*#__PURE__*/ $8SyCD.createElement((0, $fe25eb7a7ae50d90$export$2e2bcd8739ae039), Object.assign({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
var $fbc93a103d0e99ee$export$2e2bcd8739ae039 = $fbc93a103d0e99ee$var$EllipsisTooltip;


"use client";
var $d49185ac626aaa6f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d49185ac626aaa6f$var$wrapperDecorations(_ref, content) {
    var mark = _ref.mark, code = _ref.code, underline = _ref.underline, del = _ref["delete"], strong = _ref.strong, keyboard = _ref.keyboard, italic = _ref.italic;
    var currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $8SyCD.createElement(tag, {}, currentContent);
    }
    wrap("strong", strong);
    wrap("u", underline);
    wrap("del", del);
    wrap("code", code);
    wrap("mark", mark);
    wrap("kbd", keyboard);
    wrap("i", italic);
    return currentContent;
}
function $d49185ac626aaa6f$var$getNode(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $d49185ac626aaa6f$var$toList(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
var $d49185ac626aaa6f$var$ELLIPSIS_STR = "...";
var $d49185ac626aaa6f$var$Base = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _a, _b, _c;
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, type = props.type, disabled = props.disabled, children = props.children, ellipsis = props.ellipsis, editable = props.editable, copyable = props.copyable, component = props.component, title = props.title, restProps = $d49185ac626aaa6f$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction;
    var _useLocale = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $57e602fd4d8f074b$export$2e2bcd8739ae039)("Text"), 1), textLocale = _useLocale[0];
    var typographyRef = $8SyCD.useRef(null);
    var editIconRef = $8SyCD.useRef(null);
    // ============================ MISC ============================
    var prefixCls = getPrefixCls("typography", customizePrefixCls);
    var textProps = (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(restProps, [
        "mark",
        "code",
        "delete",
        "underline",
        "strong",
        "keyboard",
        "italic"
    ]);
    // ========================== Editable ==========================
    var _useMergedConfig = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $c289d94de4fc78d3$export$2e2bcd8739ae039)(editable), 2), enableEdit = _useMergedConfig[0], editConfig = _useMergedConfig[1];
    var _useMergedState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        value: editConfig.editing
    }), 2), editing = _useMergedState[0], setEditing = _useMergedState[1];
    var _editConfig_triggerType = editConfig.triggerType, triggerType = _editConfig_triggerType === void 0 ? [
        "icon"
    ] : _editConfig_triggerType;
    var triggerEdit = function(edit) {
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    (0, $35c6bd3fc003c65e$export$2e2bcd8739ae039)(function() {
        var _a;
        if (!editing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    var onEditClick = function(e) {
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    var onEditChange = function(value) {
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    var onEditCancel = function() {
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    var _useMergedConfig1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $c289d94de4fc78d3$export$2e2bcd8739ae039)(copyable), 2), enableCopy = _useMergedConfig1[0], copyConfig = _useMergedConfig1[1];
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), copied = _React_useState[0], setCopied = _React_useState[1];
    var copyIdRef = $8SyCD.useRef(null);
    var copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    var cleanCopyId = function() {
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    var onCopyClick = function(e) {
        var _a;
        e === null || e === void 0 || e.preventDefault();
        e === null || e === void 0 || e.stopPropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($0fb72ed45706c9c5$exports)))(copyConfig.text || String(children) || "", copyOptions);
        setCopied(true);
        // Trigger tips update
        cleanCopyId();
        copyIdRef.current = setTimeout(function() {
            setCopied(false);
        }, 3000);
        (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
    };
    $8SyCD.useEffect(function() {
        return cleanCopyId;
    }, []);
    // ========================== Ellipsis ==========================
    var _React_useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), isLineClampSupport = _React_useState1[0], setIsLineClampSupport = _React_useState1[1];
    var _React_useState2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), isTextOverflowSupport = _React_useState2[0], setIsTextOverflowSupport = _React_useState2[1];
    var _React_useState3 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), expanded = _React_useState3[0], setExpanded = _React_useState3[1];
    var _React_useState4 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), isJsEllipsis = _React_useState4[0], setIsJsEllipsis = _React_useState4[1];
    var _React_useState5 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(false), 2), isNativeEllipsis = _React_useState5[0], setIsNativeEllipsis = _React_useState5[1];
    var _React_useState6 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(true), 2), isNativeVisible = _React_useState6[0], setIsNativeVisible = _React_useState6[1];
    var _useMergedConfig2 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $c289d94de4fc78d3$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false
    }), 2), enableEllipsis = _useMergedConfig2[0], ellipsisConfig = _useMergedConfig2[1];
    var mergedEnableEllipsis = enableEllipsis && !expanded;
    // Shared prop to reduce bundle size
    var _ellipsisConfig_rows = ellipsisConfig.rows, rows = _ellipsisConfig_rows === void 0 ? 1 : _ellipsisConfig_rows;
    var needMeasureEllipsis = $8SyCD.useMemo(function() {
        return(// Disable ellipsis
        !mergedEnableEllipsis || // Provide suffix
        ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy);
    }, [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $6a684e1af621c10a$export$2e2bcd8739ae039)(function() {
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $e41b292bbd40113e$export$d616d7831008e86c)("webkitLineClamp"));
            setIsTextOverflowSupport((0, $e41b292bbd40113e$export$d616d7831008e86c)("textOverflow"));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    var cssEllipsis = $8SyCD.useMemo(function() {
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    var isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    var cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    var cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    var onExpandClick = function(e) {
        var _a;
        setExpanded(true);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e);
    };
    var _React_useState7 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), ellipsisWidth = _React_useState7[0], setEllipsisWidth = _React_useState7[1];
    var _React_useState8 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(0), 2), ellipsisFontSize = _React_useState8[0], setEllipsisFontSize = _React_useState8[1];
    var onResize = function(_ref2, element) {
        var offsetWidth = _ref2.offsetWidth;
        var _a;
        setEllipsisWidth(offsetWidth);
        setEllipsisFontSize(parseInt((_a = window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, element).fontSize, 10) || 0);
    };
    // >>>>> JS Ellipsis
    var onJsEllipsis = function(jsEllipsis) {
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $8SyCD.useEffect(function() {
        var textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            var currentEllipsis = cssLineClamp ? textEle.offsetHeight < textEle.scrollHeight : textEle.offsetWidth < textEle.scrollWidth;
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $8SyCD.useEffect(function() {
        var textEle = typographyRef.current;
        if (typeof IntersectionObserver === "undefined" || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ var observer = new IntersectionObserver(function() {
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return function() {
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    var tooltipProps = {};
    if (ellipsisConfig.tooltip === true) tooltipProps = {
        title: (_a = editConfig.text) !== null && _a !== void 0 ? _a : children
    };
    else if (/*#__PURE__*/ $8SyCD.isValidElement(ellipsisConfig.tooltip)) tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    else if (typeof ellipsisConfig.tooltip === "object") tooltipProps = Object.assign({
        title: (_b = editConfig.text) !== null && _b !== void 0 ? _b : children
    }, ellipsisConfig.tooltip);
    else tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    var topAriaLabel = $8SyCD.useMemo(function() {
        var isValid = function(val) {
            return [
                "string",
                "number"
            ].includes(typeof val === "undefined" ? "undefined" : (0, $7FyBz._)(val));
        };
        if (!enableEllipsis || cssEllipsis) return undefined;
        if (isValid(editConfig.text)) return editConfig.text;
        if (isValid(children)) return children;
        if (isValid(title)) return title;
        if (isValid(tooltipProps.title)) return tooltipProps.title;
        return undefined;
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $8SyCD.createElement((0, $e1d46155154a2702$export$2e2bcd8739ae039), {
        value: (_c = editConfig.text) !== null && _c !== void 0 ? _c : typeof children === "string" ? children : "",
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    var renderExpand = function() {
        var expandable = ellipsisConfig.expandable, symbol = ellipsisConfig.symbol;
        if (!expandable) return null;
        var expandContent;
        if (symbol) expandContent = symbol;
        else expandContent = textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand;
        return /*#__PURE__*/ $8SyCD.createElement("a", {
            key: "expand",
            className: "".concat(prefixCls, "-expand"),
            onClick: onExpandClick,
            "aria-label": textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
        }, expandContent);
    };
    // Edit
    var renderEdit = function() {
        if (!enableEdit) return;
        var icon = editConfig.icon, tooltip = editConfig.tooltip;
        var editTitle = (0, $0181a7b922e4e9e8$export$2e2bcd8739ae039)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
        var ariaLabel = typeof editTitle === "string" ? editTitle : "";
        return triggerType.includes("icon") ? /*#__PURE__*/ $8SyCD.createElement((0, $fe25eb7a7ae50d90$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? "" : editTitle
        }, /*#__PURE__*/ $8SyCD.createElement((0, $f2ee2ed679fea447$export$2e2bcd8739ae039), {
            ref: editIconRef,
            className: "".concat(prefixCls, "-edit"),
            onClick: onEditClick,
            "aria-label": ariaLabel
        }, icon || /*#__PURE__*/ $8SyCD.createElement((0, $5914894978b4ea58$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    var renderCopy = function() {
        if (!enableCopy) return;
        var tooltips = copyConfig.tooltips, icon = copyConfig.icon;
        var tooltipNodes = $d49185ac626aaa6f$var$toList(tooltips);
        var iconNodes = $d49185ac626aaa6f$var$toList(icon);
        var copyTitle = copied ? $d49185ac626aaa6f$var$getNode(tooltipNodes[1], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied) : $d49185ac626aaa6f$var$getNode(tooltipNodes[0], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy);
        var systemStr = copied ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied : textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy;
        var ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
        return /*#__PURE__*/ $8SyCD.createElement((0, $fe25eb7a7ae50d90$export$2e2bcd8739ae039), {
            key: "copy",
            title: copyTitle
        }, /*#__PURE__*/ $8SyCD.createElement((0, $f2ee2ed679fea447$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
            onClick: onCopyClick,
            "aria-label": ariaLabel
        }, copied ? $d49185ac626aaa6f$var$getNode(iconNodes[1], /*#__PURE__*/ $8SyCD.createElement((0, $d79b011e1dd73a6b$export$2e2bcd8739ae039), null), true) : $d49185ac626aaa6f$var$getNode(iconNodes[0], /*#__PURE__*/ $8SyCD.createElement((0, $c791fa3dc55e353a$export$2e2bcd8739ae039), null), true)));
    };
    var renderOperations = function(renderExpanded) {
        return [
            renderExpanded && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    };
    var renderEllipsis = function(needEllipsis) {
        return [
            needEllipsis && /*#__PURE__*/ $8SyCD.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $d49185ac626aaa6f$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(needEllipsis)
        ];
    };
    return /*#__PURE__*/ $8SyCD.createElement((0, $5ea1841f7a4a2bc6$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis || cssEllipsis
    }, function(resizeRef) {
        var _obj;
        return /*#__PURE__*/ $8SyCD.createElement((0, $fbc93a103d0e99ee$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enabledEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $8SyCD.createElement((0, $bc3738c6e1980571$export$2e2bcd8739ae039), Object.assign({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))((_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(type), type), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-disabled"), disabled), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-ellipsis"), enableEllipsis), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-single-line"), mergedEnableEllipsis && rows === 1), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _obj), className),
            prefixCls: customizePrefixCls,
            style: Object.assign(Object.assign({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $5a9f4dc5cf4fdd27$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes("text") ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $8SyCD.createElement((0, $9ec3b74e87a0624c$export$2e2bcd8739ae039), {
            enabledMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            fontSize: ellipsisFontSize,
            onEllipsis: onJsEllipsis
        }, function(node, needEllipsis) {
            var renderNode = node;
            if (node.length && needEllipsis && topAriaLabel) renderNode = /*#__PURE__*/ $8SyCD.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, renderNode);
            var wrappedContext = $d49185ac626aaa6f$var$wrapperDecorations(props, /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, renderNode, renderEllipsis(needEllipsis)));
            return wrappedContext;
        })));
    });
});
var $d49185ac626aaa6f$export$2e2bcd8739ae039 = $d49185ac626aaa6f$var$Base;


"use client";
var $1b1d3a0485a9723a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1b1d3a0485a9723a$var$Link = /*#__PURE__*/ $8SyCD.forwardRef(function(_a, ref) {
    var ellipsis = _a.ellipsis, rel = _a.rel, restProps = $1b1d3a0485a9723a$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    var mergedProps = Object.assign(Object.assign({}, restProps), {
        rel: rel === undefined && restProps.target === "_blank" ? "noopener noreferrer" : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $8SyCD.createElement((0, $d49185ac626aaa6f$export$2e2bcd8739ae039), Object.assign({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $1b1d3a0485a9723a$export$2e2bcd8739ae039 = $1b1d3a0485a9723a$var$Link;



var $8SyCD = parcelRequire("8SyCD");

"use client";
var $0ec3e74511767f42$var$Paragraph = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $d49185ac626aaa6f$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        component: "div"
    }));
});
var $0ec3e74511767f42$export$2e2bcd8739ae039 = $0ec3e74511767f42$var$Paragraph;



var $8SyCD = parcelRequire("8SyCD");



"use client";
var $fdd56737bdc18aeb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fdd56737bdc18aeb$var$Text = function(_a, ref) {
    var ellipsis = _a.ellipsis, restProps = $fdd56737bdc18aeb$var$__rest(_a, [
        "ellipsis"
    ]);
    var mergedEllipsis = $8SyCD.useMemo(function() {
        if (ellipsis && typeof ellipsis === "object") return (0, $eac4a3709f8f6581$export$2e2bcd8739ae039)(ellipsis, [
            "expandable",
            "rows"
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $8SyCD.createElement((0, $d49185ac626aaa6f$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $fdd56737bdc18aeb$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($fdd56737bdc18aeb$var$Text);



var $8SyCD = parcelRequire("8SyCD");


"use client";
var $bfc80d13a954cf94$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bfc80d13a954cf94$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
var $bfc80d13a954cf94$var$Title = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var _props_level = props.level, level = _props_level === void 0 ? 1 : _props_level, restProps = $bfc80d13a954cf94$var$__rest(props, [
        "level"
    ]);
    var component;
    if ($bfc80d13a954cf94$var$TITLE_ELE_LIST.includes(level)) component = "h".concat(level);
    else component = "h1";
    return /*#__PURE__*/ $8SyCD.createElement((0, $d49185ac626aaa6f$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $bfc80d13a954cf94$export$2e2bcd8739ae039 = $bfc80d13a954cf94$var$Title;



"use client";
var $0bfbc6d1be8a25ce$var$Typography = (0, $bc3738c6e1980571$export$2e2bcd8739ae039);
$0bfbc6d1be8a25ce$var$Typography.Text = (0, $fdd56737bdc18aeb$export$2e2bcd8739ae039);
$0bfbc6d1be8a25ce$var$Typography.Link = (0, $1b1d3a0485a9723a$export$2e2bcd8739ae039);
$0bfbc6d1be8a25ce$var$Typography.Title = (0, $bfc80d13a954cf94$export$2e2bcd8739ae039);
$0bfbc6d1be8a25ce$var$Typography.Paragraph = (0, $0ec3e74511767f42$export$2e2bcd8739ae039);
var $0bfbc6d1be8a25ce$export$2e2bcd8739ae039 = $0bfbc6d1be8a25ce$var$Typography;





function $426855828ad13772$export$d26b06b1c23125d9(props) {
    var children = props.children;
    var _useAppContext = (0, $6c6c68292fd863a8$export$fdc397e486fa83e7)(), audioContext = _useAppContext.audioContext, setupAudioContext = _useAppContext.setupAudioContext;
    if (!audioContext) return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $58daee52af5fd182$export$2e2bcd8739ae039), {
        className: "audio__context__initializer",
        justify: "center",
        align: "center",
        vertical: true,
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $da6dfbc8adc40d2a$export$2e2bcd8739ae039), {
                className: "icon"
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0bfbc6d1be8a25ce$export$2e2bcd8739ae039).Paragraph, {
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "this-app-needs-to-access-mic-and-speaker",
                    children: "This app needs to access your mic and speaker."
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                type: "primary",
                onClick: setupAudioContext,
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: "start",
                    children: "Start"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6cea99cbdd667b82$export$25289944de7a55e4).Provider, {
        value: {
            audioContext: audioContext
        },
        children: children
    });
}


function $069ffc9d6ca5dd76$export$de8986d3bdd505e5() {
    var id = (0, $b6e23d349026de17$export$99eaa27ddbbb95ef)().id;
    var dexie = (0, $c5efbd2e0c4166b1$export$95809329f49ea9f9)().dexie;
    var rhythm = (0, $1367a51faa32faf0$exports.useLiveQuery)(function() {
        if (id) return dexie.rhythms.get(id);
    }, [
        dexie,
        id
    ]);
    var save = (0, $8SyCD.useCallback)(function(rhythm) {
        dexie.rhythms.update(rhythm.id, (0, $b7a92f42eb46ae39$export$4fa2f4023c9cbda5)((0, $3e6303611e69f27e$export$581ff339ea0ba762)({}, rhythm), {
            updatedTime: new Date()
        }));
    }, [
        dexie
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "page page--metronome-player",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
                className: "page__header",
                children: [
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $eec4795e5e45e013$export$bbadff23f5cd28e2), {}),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $303680bc5f0d6d37$export$ffffe40bfa0649a3), {
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("p", {
                            className: "page__header__title",
                            children: rhythm === null || rhythm === void 0 ? void 0 : rhythm.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $426855828ad13772$export$d26b06b1c23125d9), {
                    children: rhythm ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $120adcf1c3a25849$export$4867023e52e26014), {
                        rhythm: rhythm,
                        onSave: save
                    }) : null
                })
            })
        ]
    });
}



parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");



var $8SyCD = parcelRequire("8SyCD");







var $8SyCD = parcelRequire("8SyCD");



var $f289815c8ce47f04$var$_excluded = [
    "prefixCls",
    "className",
    "checked",
    "defaultChecked",
    "disabled",
    "loadingIcon",
    "checkedChildren",
    "unCheckedChildren",
    "onClick",
    "onChange",
    "onKeyDown"
];
var $f289815c8ce47f04$var$Switch = /*#__PURE__*/ $8SyCD.forwardRef(function(_ref, ref) {
    var _classNames;
    var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = (0, $2c43ba8d26f61a30$export$2e2bcd8739ae039)(_ref, $f289815c8ce47f04$var$_excluded);
    var _useMergedState = (0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        value: checked,
        defaultValue: defaultChecked
    }), _useMergedState2 = (0, $ba942fe2765b61c7$export$2e2bcd8739ae039)(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
    function triggerChange(newChecked, event) {
        var mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 || onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $5ebc594569656f88$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
    function onInternalClick(e) {
        var ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick === null || onClick === void 0 || onClick(ret, e);
    }
    var switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, className, (_classNames = {}, (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0, $54033efc60d3b6a4$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return /*#__PURE__*/ $8SyCD.createElement("button", (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }, /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-inner-checked")
    }, checkedChildren), /*#__PURE__*/ $8SyCD.createElement("span", {
        className: "".concat(prefixCls, "-inner-unchecked")
    }, unCheckedChildren)));
});
$f289815c8ce47f04$var$Switch.displayName = "Switch";
var $f289815c8ce47f04$export$2e2bcd8739ae039 = $f289815c8ce47f04$var$Switch;











var $fe0754825071db3a$var$genSwitchSmallStyle = function(token) {
    var componentCls = token.componentCls, trackHeightSM = token.trackHeightSM, trackPadding = token.trackPadding, trackMinWidthSM = token.trackMinWidthSM, innerMinMarginSM = token.innerMinMarginSM, innerMaxMarginSM = token.innerMaxMarginSM, handleSizeSM = token.handleSizeSM, calc = token.calc;
    var switchInnerCls = "".concat(componentCls, "-inner");
    var trackPaddingCalc = (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    var innerMaxMarginCalc = (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(innerMaxMarginSM).mul(2).equal());
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "&".concat(componentCls, "-small"), (_obj4 = {
        minWidth: trackMinWidthSM,
        height: trackHeightSM,
        lineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(trackHeightSM)
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-inner"), (_obj = {
        paddingInlineStart: innerMaxMarginSM,
        paddingInlineEnd: innerMinMarginSM
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: "calc(-100% + ".concat(trackPaddingCalc, " - ").concat(innerMaxMarginCalc, ")"),
        marginInlineEnd: "calc(100% - ".concat(trackPaddingCalc, " + ").concat(innerMaxMarginCalc, ")")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchInnerCls, "-unchecked"), {
        marginTop: calc(trackHeightSM).mul(-1).equal(),
        marginInlineStart: 0,
        marginInlineEnd: 0
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-handle"), {
        width: handleSizeSM,
        height: handleSizeSM
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "".concat(componentCls, "-loading-icon"), {
        top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
        fontSize: token.switchLoadingIconSize
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "&".concat(componentCls, "-checked"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-inner"), (_obj1 = {
        paddingInlineStart: innerMinMarginSM,
        paddingInlineEnd: innerMaxMarginSM
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: 0,
        marginInlineEnd: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(switchInnerCls, "-unchecked"), {
        marginInlineStart: "calc(100% - ".concat(trackPaddingCalc, " + ").concat(innerMaxMarginCalc, ")"),
        marginInlineEnd: "calc(-100% + ".concat(trackPaddingCalc, " - ").concat(innerMaxMarginCalc, ")")
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-handle"), {
        insetInlineStart: "calc(100% - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(handleSizeSM).add(trackPadding).equal()), ")")
    }), _obj2)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj4, "&:not(".concat(componentCls, "-disabled):active"), (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:not(".concat(componentCls, "-checked) ").concat(switchInnerCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(switchInnerCls, "-unchecked"), {
        marginInlineStart: calc(token.marginXXS).div(2).equal(),
        marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-checked ").concat(switchInnerCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
        marginInlineEnd: calc(token.marginXXS).div(2).equal()
    })), _obj3)), _obj4)));
};
var $fe0754825071db3a$var$genSwitchLoadingStyle = function(token) {
    var componentCls = token.componentCls, handleSize = token.handleSize, calc = token.calc;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(componentCls, "-loading-icon").concat(token.iconCls), {
        position: "relative",
        top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
        color: token.switchLoadingIconColor,
        verticalAlign: "top"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-checked ").concat(componentCls, "-loading-icon"), {
        color: token.switchColor
    }), _obj));
};
var $fe0754825071db3a$var$genSwitchHandleStyle = function(token) {
    var componentCls = token.componentCls, trackPadding = token.trackPadding, handleBg = token.handleBg, handleShadow = token.handleShadow, handleSize = token.handleSize, calc = token.calc;
    var switchHandleCls = "".concat(componentCls, "-handle");
    var _obj, _obj1;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj1 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, switchHandleCls, {
        position: "absolute",
        top: trackPadding,
        insetInlineStart: trackPadding,
        width: handleSize,
        height: handleSize,
        transition: "all ".concat(token.switchDuration, " ease-in-out"),
        "&::before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            backgroundColor: handleBg,
            borderRadius: calc(handleSize).div(2).equal(),
            boxShadow: handleShadow,
            transition: "all ".concat(token.switchDuration, " ease-in-out"),
            content: '""'
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-checked ").concat(switchHandleCls), {
        insetInlineStart: "calc(100% - ".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(handleSize).add(trackPadding).equal()), ")")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&:not(".concat(componentCls, "-disabled):active"), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchHandleCls, "::before"), {
        insetInlineEnd: token.switchHandleActiveInset,
        insetInlineStart: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-checked ").concat(switchHandleCls, "::before"), {
        insetInlineEnd: 0,
        insetInlineStart: token.switchHandleActiveInset
    }), _obj)), _obj1));
};
var $fe0754825071db3a$var$genSwitchInnerStyle = function(token) {
    var componentCls = token.componentCls, trackHeight = token.trackHeight, trackPadding = token.trackPadding, innerMinMargin = token.innerMinMargin, innerMaxMargin = token.innerMaxMargin, handleSize = token.handleSize, calc = token.calc;
    var switchInnerCls = "".concat(componentCls, "-inner");
    var trackPaddingCalc = (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    var innerMaxMarginCalc = (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(innerMaxMargin).mul(2).equal());
    var _obj, _obj1, _obj2, _obj3;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, (_obj3 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, switchInnerCls, (_obj = {
        display: "block",
        overflow: "hidden",
        borderRadius: 100,
        height: "100%",
        paddingInlineStart: innerMaxMargin,
        paddingInlineEnd: innerMinMargin,
        transition: "padding-inline-start ".concat(token.switchDuration, " ease-in-out, padding-inline-end ").concat(token.switchDuration, " ease-in-out")
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchInnerCls, "-checked, ").concat(switchInnerCls, "-unchecked"), {
        display: "block",
        color: token.colorTextLightSolid,
        fontSize: token.fontSizeSM,
        transition: "margin-inline-start ".concat(token.switchDuration, " ease-in-out, margin-inline-end ").concat(token.switchDuration, " ease-in-out"),
        pointerEvents: "none"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: "calc(-100% + ".concat(trackPaddingCalc, " - ").concat(innerMaxMarginCalc, ")"),
        marginInlineEnd: "calc(100% - ".concat(trackPaddingCalc, " + ").concat(innerMaxMarginCalc, ")")
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(switchInnerCls, "-unchecked"), {
        marginTop: calc(trackHeight).mul(-1).equal(),
        marginInlineStart: 0,
        marginInlineEnd: 0
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&".concat(componentCls, "-checked ").concat(switchInnerCls), (_obj1 = {
        paddingInlineStart: innerMinMargin,
        paddingInlineEnd: innerMaxMargin
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: 0,
        marginInlineEnd: 0
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(switchInnerCls, "-unchecked"), {
        marginInlineStart: "calc(100% - ".concat(trackPaddingCalc, " + ").concat(innerMaxMarginCalc, ")"),
        marginInlineEnd: "calc(-100% + ".concat(trackPaddingCalc, " - ").concat(innerMaxMarginCalc, ")")
    }), _obj1)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj3, "&:not(".concat(componentCls, "-disabled):active"), (_obj2 = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&:not(".concat(componentCls, "-checked) ").concat(switchInnerCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(switchInnerCls, "-unchecked"), {
        marginInlineStart: calc(trackPadding).mul(2).equal(),
        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "&".concat(componentCls, "-checked ").concat(switchInnerCls), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(switchInnerCls, "-checked"), {
        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
        marginInlineEnd: calc(trackPadding).mul(2).equal()
    })), _obj2)), _obj3));
};
var $fe0754825071db3a$var$genSwitchStyle = function(token) {
    var componentCls = token.componentCls, trackHeight = token.trackHeight, trackMinWidth = token.trackMinWidth;
    var _obj;
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        position: "relative",
        display: "inline-block",
        boxSizing: "border-box",
        minWidth: trackMinWidth,
        height: trackHeight,
        lineHeight: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(trackHeight)),
        verticalAlign: "middle",
        background: token.colorTextQuaternary,
        border: "0",
        borderRadius: 100,
        cursor: "pointer",
        transition: "all ".concat(token.motionDurationMid),
        userSelect: "none"
    }, "&:hover:not(".concat(componentCls, "-disabled)"), {
        background: token.colorTextTertiary
    })), (0, $7cbb7e49dbe61000$export$a44db842bcb28231)(token)), (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-checked"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        background: token.switchColor
    }, "&:hover:not(".concat(componentCls, "-disabled)"), {
        background: token.colorPrimaryHover
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-loading, &").concat(componentCls, "-disabled"), {
        cursor: "not-allowed",
        opacity: token.switchDisabledOpacity,
        "*": {
            boxShadow: "none",
            cursor: "not-allowed"
        }
    }), // rtl style
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&".concat(componentCls, "-rtl"), {
        direction: "rtl"
    }), _obj)));
};
var $fe0754825071db3a$export$9ca1be8807fe0675 = function(token) {
    var fontSize = token.fontSize, lineHeight = token.lineHeight, controlHeight = token.controlHeight, colorWhite = token.colorWhite;
    var height = fontSize * lineHeight;
    var heightSM = controlHeight / 2;
    var padding = 2; // Fixed value
    var handleSize = height - padding * 2;
    var handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize: handleSize,
        handleSizeSM: handleSizeSM,
        handleShadow: "0 2px 4px 0 ".concat(new (0, $cc3db88804fc55ed$export$d850312fc213f33e)("#00230b").setAlpha(0.2).toRgbString()),
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
var $fe0754825071db3a$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Switch", function(token) {
    var switchToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: "rgba(0, 0, 0, ".concat(token.opacityLoading, ")"),
        switchHandleActiveInset: "-30%"
    });
    return [
        $fe0754825071db3a$var$genSwitchStyle(switchToken),
        // inner style
        $fe0754825071db3a$var$genSwitchInnerStyle(switchToken),
        // handle style
        $fe0754825071db3a$var$genSwitchHandleStyle(switchToken),
        // loading style
        $fe0754825071db3a$var$genSwitchLoadingStyle(switchToken),
        // small style
        $fe0754825071db3a$var$genSwitchSmallStyle(switchToken)
    ];
}, $fe0754825071db3a$export$9ca1be8807fe0675);



"use client";
var $8d875ec2e579349a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8d875ec2e579349a$var$Switch = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeSize = props.size, customDisabled = props.disabled, loading = props.loading, className = props.className, rootClassName = props.rootClassName, style = props.style, checkedProp = props.checked, value = props.value, defaultCheckedProp = props.defaultChecked, defaultValue = props.defaultValue, onChange = props.onChange, restProps = $8d875ec2e579349a$var$__rest(props, [
        "prefixCls",
        "size",
        "disabled",
        "loading",
        "className",
        "rootClassName",
        "style",
        "checked",
        "value",
        "defaultChecked",
        "defaultValue",
        "onChange"
    ]);
    var _useMergedState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $a27c32063ec0d006$export$2e2bcd8739ae039)(false, {
        value: checkedProp !== null && checkedProp !== void 0 ? checkedProp : value,
        defaultValue: defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue
    }), 2), checked = _useMergedState[0], setChecked = _useMergedState[1];
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, SWITCH = _React_useContext["switch"];
    // ===================== Disabled =====================
    var disabled = $8SyCD.useContext((0, $e0eab3dc6b8ab52c$export$2e2bcd8739ae039));
    var mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
    var prefixCls = getPrefixCls("switch", customizePrefixCls);
    var loadingIcon = /*#__PURE__*/ $8SyCD.createElement("div", {
        className: "".concat(prefixCls, "-handle")
    }, loading && /*#__PURE__*/ $8SyCD.createElement((0, $d921af23c702a53c$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-loading-icon")
    }));
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $fe0754825071db3a$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var mergedSize = (0, $57fee9dea752ba29$export$2e2bcd8739ae039)(customizeSize);
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.className, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-small"), mergedSize === "small"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-loading"), loading), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), _obj), className, rootClassName, hashId);
    var mergedStyle = Object.assign(Object.assign({}, SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.style), style);
    var changeHandler = function changeHandler() {
        setChecked(arguments.length <= 0 ? undefined : arguments[0]);
        onChange === null || onChange === void 0 || onChange.apply(void 0, arguments);
    };
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement((0, $1f7e26aa70b888fb$export$2e2bcd8739ae039), {
        component: "Switch"
    }, /*#__PURE__*/ $8SyCD.createElement((0, $f289815c8ce47f04$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }))));
});
$8d875ec2e579349a$var$Switch.__ANT_SWITCH = true;
var $8d875ec2e579349a$export$2e2bcd8739ae039 = $8d875ec2e579349a$var$Switch;





function $037d980eeecf0688$export$47293bb2727f5643() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        octaveRange: {
            min: 0,
            max: 8
        }
    };
    var octaveRange = options.octaveRange;
    var name = Math.floor(Math.random() * 100) % ((0, $c9378659b665be93$export$2050b8129d8cdad6).B + 1);
    var octave = Math.floor(Math.random() * 100) % (octaveRange.max - octaveRange.min) + octaveRange.min;
    return {
        name: name,
        octave: octave,
        dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Accent
    };
}




var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $0738f02a13ab4e63$var$PlayCircleOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                tag: "path",
                attrs: {
                    d: "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"
                }
            }
        ]
    },
    name: "play-circle",
    theme: "outlined"
};
var $0738f02a13ab4e63$export$2e2bcd8739ae039 = $0738f02a13ab4e63$var$PlayCircleOutlined;



var $d7b73e0f545eba2f$var$PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0738f02a13ab4e63$export$2e2bcd8739ae039)
    }));
};
var $d7b73e0f545eba2f$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($d7b73e0f545eba2f$var$PlayCircleOutlined);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $f4af394abe769ec5$var$QuestionOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 00-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z"
                }
            }
        ]
    },
    name: "question",
    theme: "outlined"
};
var $f4af394abe769ec5$export$2e2bcd8739ae039 = $f4af394abe769ec5$var$QuestionOutlined;



var $9d1995cc5ccf16c8$var$QuestionOutlined = function QuestionOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f4af394abe769ec5$export$2e2bcd8739ae039)
    }));
};
var $9d1995cc5ccf16c8$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($9d1995cc5ccf16c8$var$QuestionOutlined);



var $8SyCD = parcelRequire("8SyCD");
// This icon file is generated automatically.
var $e20edb617c30472e$var$SwitcherOutlined = {
    icon: {
        tag: "svg",
        attrs: {
            viewBox: "64 64 896 896",
            focusable: "false"
        },
        children: [
            {
                tag: "path",
                attrs: {
                    d: "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z"
                }
            }
        ]
    },
    name: "switcher",
    theme: "outlined"
};
var $e20edb617c30472e$export$2e2bcd8739ae039 = $e20edb617c30472e$var$SwitcherOutlined;



var $4ca75a2d203c3082$var$SwitcherOutlined = function SwitcherOutlined(props, ref) {
    return /*#__PURE__*/ $8SyCD.createElement((0, $fb00e6bc3d52cbac$export$2e2bcd8739ae039), (0, $b0ab868e4ce1c6e6$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e20edb617c30472e$export$2e2bcd8739ae039)
    }));
};
var $4ca75a2d203c3082$export$2e2bcd8739ae039 = /*#__PURE__*/ $8SyCD.forwardRef($4ca75a2d203c3082$var$SwitcherOutlined);




function $79d3d36ee8e7e641$export$fb8dfd4d9f0aeb2e() {
    var audioContext = (0, $44d27c03f7b7c509$export$d4eec936f80d194a)().audioContext;
    var oscillatorNodeRef = (0, $8SyCD.useRef)(null);
    var streamRef = (0, $8SyCD.useRef)(null);
    var streamSourceNodeRef = (0, $8SyCD.useRef)(null);
    (0, $8SyCD.useEffect)(function() {
        return function() {
            if (oscillatorNodeRef.current) {
                oscillatorNodeRef.current.stop();
                oscillatorNodeRef.current.disconnect();
                oscillatorNodeRef.current = null;
            }
            if (streamSourceNodeRef.current) {
                streamSourceNodeRef.current.disconnect();
                streamSourceNodeRef.current = null;
            }
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(function(track) {
                    track.stop();
                });
                streamRef.current = null;
            }
        };
    }, []);
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)(false), 2), isNoteShown = _useState[0], setIsNoteShown = _useState[1];
    var _useState1 = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)((0, $037d980eeecf0688$export$47293bb2727f5643)), 2), note = _useState1[0], setNote = _useState1[1];
    var changeNote = (0, $8SyCD.useCallback)(function() {
        setNote((0, $037d980eeecf0688$export$47293bb2727f5643)());
    }, [
        setNote,
        setIsNoteShown
    ]);
    var playNote = (0, $8SyCD.useCallback)(function() {
        if (oscillatorNodeRef.current) {
            oscillatorNodeRef.current.stop();
            oscillatorNodeRef.current.disconnect();
            oscillatorNodeRef.current = null;
        }
        var oscillator = new OscillatorNode(audioContext, {
            frequency: (0, $92577b47e3b00856$export$a8f9b7b280712859)(note)
        });
        oscillator.connect(audioContext.destination);
        oscillator.start();
        oscillatorNodeRef.current = oscillator;
    }, [
        audioContext,
        note
    ]);
    var stopNote = (0, $8SyCD.useCallback)(function() {
        if (oscillatorNodeRef.current) {
            oscillatorNodeRef.current.stop();
            oscillatorNodeRef.current.disconnect();
            oscillatorNodeRef.current = null;
        }
    }, []);
    var toggleIsNoteShown = (0, $8SyCD.useCallback)(function() {
        setIsNoteShown(function(isNoteShown) {
            return !isNoteShown;
        });
    }, [
        setIsNoteShown
    ]);
    var _useFlag = (0, $2c9a6289909a7048$export$983b9b54330812cb)(false), isSoundAnalyserModalShown = _useFlag.flag, openSoundAnalyserModal = _useFlag.turnOn, closeSoundAnalyserModal = _useFlag.turnOff;
    var _useSoundAnalyser = (0, $090cd79bb8ac5bb9$export$1e3093a342a0b32b)({
        isRunning: isSoundAnalyserModalShown
    }), soundNote = _useSoundAnalyser.note;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "sight-ear",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)((0, $58daee52af5fd182$export$2e2bcd8739ae039), {
                vertical: true,
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $8d875ec2e579349a$export$2e2bcd8739ae039), {
                            checked: isNoteShown,
                            checkedChildren: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                id: "show-note",
                                children: "Show Note"
                            }),
                            unCheckedChildren: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                id: "hide-note",
                                children: "Hide Note"
                            }),
                            onChange: toggleIsNoteShown
                        })
                    }),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                        children: isNoteShown ? /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0bfbc6d1be8a25ce$export$2e2bcd8739ae039).Title, {
                            className: "note__name",
                            children: (0, $92577b47e3b00856$export$e30cdbfc5f0ca703)(note)
                        }) : /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0bfbc6d1be8a25ce$export$2e2bcd8739ae039).Title, {
                            className: "note__name",
                            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $9d1995cc5ccf16c8$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $a99de091e3782250$export$2e2bcd8739ae039), {}),
                                onClick: openSoundAnalyserModal,
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "sing",
                                    children: "Sing"
                                })
                            }),
                            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d7b73e0f545eba2f$export$2e2bcd8739ae039), {}),
                                onPointerDown: playNote,
                                onPointerLeave: stopNote,
                                onPointerUp: stopNote,
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "play",
                                    children: "Play"
                                })
                            }),
                            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $7095a40e3141dc69$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $4ca75a2d203c3082$export$2e2bcd8739ae039), {}),
                                onClick: changeNote,
                                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                                    id: "change",
                                    children: "Change"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d7fa675cd1188439$export$2e2bcd8739ae039), {
                open: isSoundAnalyserModalShown,
                destroyOnClose: true,
                onCancel: closeSoundAnalyserModal,
                footer: null,
                className: "sound__analyser__modal",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                    className: "sound__analyser__panel",
                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0bfbc6d1be8a25ce$export$2e2bcd8739ae039).Title, {
                        className: "note__name",
                        children: soundNote ? (0, $92577b47e3b00856$export$e30cdbfc5f0ca703)(soundNote) : "-"
                    })
                })
            })
        ]
    });
}





function $ed2aa53936f12502$export$80bd160dda242578() {
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "page page--sightear",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__header",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $eec4795e5e45e013$export$bbadff23f5cd28e2), {})
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $426855828ad13772$export$d26b06b1c23125d9), {
                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $79d3d36ee8e7e641$export$fb8dfd4d9f0aeb2e), {})
                })
            })
        ]
    });
}



parcelRequire("8SyCD");





var $8SyCD = parcelRequire("8SyCD");


var $51d0a65addd69998$var$guitar = {
    name: "guitar",
    notes: [
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).E,
            octave: 2,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).A,
            octave: 2,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).D,
            octave: 3,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).G,
            octave: 3,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).B,
            octave: 3,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).E,
            octave: 4,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        }
    ]
};
var $51d0a65addd69998$var$bass = {
    name: "bass",
    notes: [
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).E,
            octave: 1,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).A,
            octave: 1,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).D,
            octave: 2,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        },
        {
            name: (0, $c9378659b665be93$export$2050b8129d8cdad6).G,
            octave: 2,
            dynamics: (0, $c9378659b665be93$export$df409b90d2c1a310).Light
        }
    ]
};
var $51d0a65addd69998$export$b2f1d8d9f77f27e2 = [
    $51d0a65addd69998$var$guitar,
    $51d0a65addd69998$var$bass
];





var $8SyCD = parcelRequire("8SyCD");










var $8SyCD = parcelRequire("8SyCD");







// ============================== Styles ==============================
var $122a972167d12b96$var$genBaseStyle = function(token) {
    var paddingXXS = token.paddingXXS, lineWidth = token.lineWidth, tagPaddingHorizontal = token.tagPaddingHorizontal, componentCls = token.componentCls, calc = token.calc;
    var paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    var iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    var _obj, _obj1, _obj2;
    return _obj2 = {}, // Result
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, componentCls, Object.assign(Object.assign({}, (0, $7cbb7e49dbe61000$export$23997c3e44cc1c59)(token)), (_obj1 = {
        display: "inline-block",
        height: "auto",
        marginInlineEnd: token.marginXS,
        paddingInline: paddingInline,
        fontSize: token.tagFontSize,
        lineHeight: token.tagLineHeight,
        whiteSpace: "nowrap",
        background: token.defaultBg,
        border: "".concat((0, $d345e6062a3ed2bd$export$523c0b569236b342)(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
        borderRadius: token.borderRadiusSM,
        opacity: 1,
        transition: "all ".concat(token.motionDurationMid),
        textAlign: "start",
        position: "relative"
    }, // RTL
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-rtl"), {
        direction: "rtl"
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&, a, a:hover", {
        color: token.defaultColor
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "".concat(componentCls, "-close-icon"), {
        marginInlineStart: iconMarginInline,
        fontSize: token.tagIconSize,
        color: token.colorTextDescription,
        cursor: "pointer",
        transition: "all ".concat(token.motionDurationMid),
        "&:hover": {
            color: token.colorTextHeading
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&".concat(componentCls, "-has-color"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        borderColor: "transparent"
    }, "&, a, a:hover, ".concat(token.iconCls, "-close, ").concat(token.iconCls, "-close:hover"), {
        color: token.colorTextLightSolid
    })), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-checkable", (_obj = {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer"
    }, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:not(".concat(componentCls, "-checkable-checked):hover"), {
        color: token.colorPrimary,
        backgroundColor: token.colorFillSecondary
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:active, &-checked", {
        color: token.colorTextLightSolid
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&-checked", {
        backgroundColor: token.colorPrimary,
        "&:hover": {
            backgroundColor: token.colorPrimaryHover
        }
    }), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "&:active", {
        backgroundColor: token.colorPrimaryActive
    }), _obj)), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "&-hidden", {
        display: "none"
    }), // To ensure that a space will be placed between character and `Icon`.
    (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj1, "> ".concat(token.iconCls, " + span, > span + ").concat(token.iconCls), {
        marginInlineStart: paddingInline
    }), _obj1))), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj2, "".concat(componentCls, "-borderless"), {
        borderColor: "transparent",
        background: token.tagBorderlessBg
    }), _obj2;
};
var $122a972167d12b96$export$362fb92a8f81bbf9 = function(token) {
    var lineWidth = token.lineWidth, fontSizeIcon = token.fontSizeIcon, calc = token.calc;
    var tagFontSize = token.fontSizeSM;
    var tagToken = (0, $abce1a6f0eeaf31d$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $d345e6062a3ed2bd$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.colorFillTertiary
    });
    return tagToken;
};
var $122a972167d12b96$export$9ca1be8807fe0675 = function(token) {
    return {
        defaultBg: new (0, $cc3db88804fc55ed$export$d850312fc213f33e)(token.colorFillQuaternary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText
    };
};
var $122a972167d12b96$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$51ec95de45185b42)("Tag", function(token) {
    var tagToken = $122a972167d12b96$export$362fb92a8f81bbf9(token);
    return $122a972167d12b96$var$genBaseStyle(tagToken);
}, $122a972167d12b96$export$9ca1be8807fe0675);


"use client";
var $82cdd4c3db0eb503$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $82cdd4c3db0eb503$var$CheckableTag = /*#__PURE__*/ $8SyCD.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, style = props.style, className = props.className, checked = props.checked, onChange = props.onChange, onClick = props.onClick, restProps = $82cdd4c3db0eb503$var$__rest(props, [
        "prefixCls",
        "style",
        "className",
        "checked",
        "onChange",
        "onClick"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, tag = _React_useContext.tag;
    var handleClick = function(e) {
        onChange === null || onChange === void 0 || onChange(!checked);
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls("tag", customizePrefixCls);
    // Style
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $122a972167d12b96$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, "".concat(prefixCls, "-checkable"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(prefixCls, "-checkable-checked"), checked), tag === null || tag === void 0 ? void 0 : tag.className, className, hashId);
    return wrapCSSVar(/*#__PURE__*/ $8SyCD.createElement("span", Object.assign({}, restProps, {
        ref: ref,
        style: Object.assign(Object.assign({}, style), tag === null || tag === void 0 ? void 0 : tag.style),
        className: cls,
        onClick: handleClick
    })));
});
var $82cdd4c3db0eb503$export$2e2bcd8739ae039 = $82cdd4c3db0eb503$var$CheckableTag;



// Style as status component



// ============================== Preset ==============================
var $6ccb491efe08b125$var$genPresetStyle = function(token) {
    return (0, $a97bc39a850ed8f0$export$2e2bcd8739ae039)(token, function(colorKey, _ref) {
        var textColor = _ref.textColor, lightBorderColor = _ref.lightBorderColor, lightColor = _ref.lightColor, darkColor = _ref.darkColor;
        return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(token.componentCls, "-").concat(colorKey), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
            color: textColor,
            background: lightColor,
            borderColor: lightBorderColor,
            // Inverse color
            "&-inverse": {
                color: token.colorTextLightSolid,
                background: darkColor,
                borderColor: darkColor
            }
        }, "&".concat(token.componentCls, "-borderless"), {
            borderColor: "transparent"
        }));
    });
};
var // ============================== Export ==============================
$6ccb491efe08b125$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$1537386bc155ea56)([
    "Tag",
    "preset"
], function(token) {
    var tagToken = (0, $122a972167d12b96$export$362fb92a8f81bbf9)(token);
    return $6ccb491efe08b125$var$genPresetStyle(tagToken);
}, (0, $122a972167d12b96$export$9ca1be8807fe0675));




function $af4fe3260f8b4d2c$export$2e2bcd8739ae039(str) {
    if (typeof str !== "string") return str;
    var ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



var $32d3843133883a1f$var$genTagStatusStyle = function(token, status, cssVariableType) {
    var capitalizedCssVariableType = (0, $af4fe3260f8b4d2c$export$2e2bcd8739ae039)(cssVariableType);
    return (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({}, "".concat(token.componentCls, "-").concat(status), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)({
        color: token["color".concat(cssVariableType)],
        background: token["color".concat(capitalizedCssVariableType, "Bg")],
        borderColor: token["color".concat(capitalizedCssVariableType, "Border")]
    }, "&".concat(token.componentCls, "-borderless"), {
        borderColor: "transparent"
    }));
};
var // ============================== Export ==============================
$32d3843133883a1f$export$2e2bcd8739ae039 = (0, $bc22d80d69885d2a$export$1537386bc155ea56)([
    "Tag",
    "status"
], function(token) {
    var tagToken = (0, $122a972167d12b96$export$362fb92a8f81bbf9)(token);
    return [
        $32d3843133883a1f$var$genTagStatusStyle(tagToken, "success", "Success"),
        $32d3843133883a1f$var$genTagStatusStyle(tagToken, "processing", "Info"),
        $32d3843133883a1f$var$genTagStatusStyle(tagToken, "error", "Error"),
        $32d3843133883a1f$var$genTagStatusStyle(tagToken, "warning", "Warning")
    ];
}, (0, $122a972167d12b96$export$9ca1be8807fe0675));


"use client";
var $47201b4cec400453$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $47201b4cec400453$var$InternalTag = function(tagProps, ref) {
    var customizePrefixCls = tagProps.prefixCls, className = tagProps.className, rootClassName = tagProps.rootClassName, style = tagProps.style, children = tagProps.children, icon = tagProps.icon, color = tagProps.color, onClose = tagProps.onClose, closeIcon = tagProps.closeIcon, closable = tagProps.closable, _tagProps_bordered = tagProps.bordered, bordered = _tagProps_bordered === void 0 ? true : _tagProps_bordered, props = $47201b4cec400453$var$__rest(tagProps, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "children",
        "icon",
        "color",
        "onClose",
        "closeIcon",
        "closable",
        "bordered"
    ]);
    var _React_useContext = $8SyCD.useContext((0, $d263e45406476254$export$a92f85ab3e9ad68b)), getPrefixCls = _React_useContext.getPrefixCls, direction = _React_useContext.direction, tag = _React_useContext.tag;
    var _React_useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)($8SyCD.useState(true), 2), visible = _React_useState[0], setVisible = _React_useState[1];
    $8SyCD.useEffect(function() {
        if ("visible" in props) setVisible(props.visible);
    }, [
        props.visible
    ]);
    var isPreset = (0, $35809625a0bf139d$export$ee62ebd6a58c4884)(color);
    var isStatus = (0, $35809625a0bf139d$export$88a0ba1f7d1ea40e)(color);
    var isInternalColor = isPreset || isStatus;
    var tagStyle = Object.assign(Object.assign({
        backgroundColor: color && !isInternalColor ? color : undefined
    }, tag === null || tag === void 0 ? void 0 : tag.style), style);
    var prefixCls = getPrefixCls("tag", customizePrefixCls);
    var _useStyle = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $122a972167d12b96$export$2e2bcd8739ae039)(prefixCls), 2), wrapCSSVar = _useStyle[0], hashId = _useStyle[1];
    var _obj;
    // Style
    var tagClassName = (0, (/*@__PURE__*/$parcel$interopDefault($72d4b339b8bd94c3$exports)))(prefixCls, tag === null || tag === void 0 ? void 0 : tag.className, (_obj = {}, (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-").concat(color), isInternalColor), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-has-color"), color && !isInternalColor), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-hidden"), !visible), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $60e59d78a798167e$export$1e71eb4bef00f6b0)(_obj, "".concat(prefixCls, "-borderless"), !bordered), _obj), className, rootClassName, hashId);
    var handleCloseClick = function(e) {
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
        if (e.defaultPrevented) return;
        setVisible(false);
    };
    var _useClosable = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $67b4ef833bd34470$export$2e2bcd8739ae039)(closable, closeIcon, function(iconNode) {
        return iconNode === null ? /*#__PURE__*/ $8SyCD.createElement((0, $12df9fef8659bd8e$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        }) : /*#__PURE__*/ $8SyCD.createElement("span", {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        }, iconNode);
    }, null, false), 2), mergedCloseIcon = _useClosable[1];
    var isNeedWave = typeof props.onClick === "function" || children && children.type === "a";
    var iconNode = icon || null;
    var kids = iconNode ? /*#__PURE__*/ $8SyCD.createElement($8SyCD.Fragment, null, iconNode, children && /*#__PURE__*/ $8SyCD.createElement("span", null, children)) : children;
    var tagNode = /*#__PURE__*/ $8SyCD.createElement("span", Object.assign({}, props, {
        ref: ref,
        className: tagClassName,
        style: tagStyle
    }), kids, mergedCloseIcon, isPreset && /*#__PURE__*/ $8SyCD.createElement((0, $6ccb491efe08b125$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $8SyCD.createElement((0, $32d3843133883a1f$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return wrapCSSVar(isNeedWave ? /*#__PURE__*/ $8SyCD.createElement((0, $1f7e26aa70b888fb$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode);
};
var $47201b4cec400453$var$Tag = /*#__PURE__*/ $8SyCD.forwardRef($47201b4cec400453$var$InternalTag);
$47201b4cec400453$var$Tag.CheckableTag = (0, $82cdd4c3db0eb503$export$2e2bcd8739ae039);
var $47201b4cec400453$export$2e2bcd8739ae039 = $47201b4cec400453$var$Tag;





function $498f92cc015a2474$export$e3dfad9aac8625a9() {
    var note = (0, $090cd79bb8ac5bb9$export$1e3093a342a0b32b)({
        isRunning: true
    }).note;
    var _useState = (0, $d7028e800eea0566$export$fdf2a89c76341bbf)((0, $8SyCD.useState)((0, $51d0a65addd69998$export$b2f1d8d9f77f27e2)[0]), 2), instrument = _useState[0], setInstrument = _useState[1];
    var options = (0, $8SyCD.useMemo)(function() {
        return (0, $51d0a65addd69998$export$b2f1d8d9f77f27e2).map(function(instrument) {
            return {
                value: instrument.name,
                label: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $f89bf6c25edcb21d$export$83669d75c31e40c5), {
                    id: instrument.name,
                    children: instrument.name
                })
            };
        });
    }, [
        (0, $51d0a65addd69998$export$b2f1d8d9f77f27e2)
    ]);
    var changeInstrument = (0, $8SyCD.useCallback)(function(instrumentName) {
        var instrument = (0, $51d0a65addd69998$export$b2f1d8d9f77f27e2).find(function(instrument) {
            return instrument.name === instrumentName;
        });
        if (instrument) setInstrument(instrument);
    }, [
        (0, $51d0a65addd69998$export$b2f1d8d9f77f27e2)
    ]);
    var closest = (0, $8SyCD.useMemo)(function() {
        if (!note) return undefined;
        var closestNote = instrument.notes[0];
        var closestInterval = (0, $92577b47e3b00856$export$791af547312e0674)(note, closestNote);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = instrument.notes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var currNote = _step.value;
                var interval = (0, $92577b47e3b00856$export$791af547312e0674)(note, currNote);
                if (Math.abs(interval) < Math.abs(closestInterval)) {
                    closestInterval = interval;
                    closestNote = currNote;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            note: closestNote,
            interval: closestInterval
        };
    }, [
        note,
        instrument
    ]);
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "tuner",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "input",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0bfbc6d1be8a25ce$export$2e2bcd8739ae039).Title, {
                    className: "note__name",
                    children: note ? (0, $92577b47e3b00856$export$e30cdbfc5f0ca703)(note) : "-"
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $58daee52af5fd182$export$2e2bcd8739ae039), {
                className: "notes",
                align: "center",
                justify: "space-evenly",
                children: instrument.notes.map(function(note, index) {
                    var color = undefined;
                    if (closest) {
                        var isClosest = note === closest.note;
                        if (isClosest) {
                            if (closest.interval === 0) color = "green";
                            else if (closest.interval > 0) color = "red";
                            else if (closest.interval < 0) color = "yellow";
                        }
                    }
                    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $47201b4cec400453$export$2e2bcd8739ae039), {
                        className: "note",
                        color: color,
                        children: (0, $92577b47e3b00856$export$e30cdbfc5f0ca703)(note)
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "instruments",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $5a3a55b7970e77bf$export$2e2bcd8739ae039), {
                    defaultValue: instrument.name,
                    options: options,
                    onChange: changeInstrument
                })
            })
        ]
    });
}





function $909818b8100c123f$export$9436c6ab8004a19b() {
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsxs)("div", {
        className: "page page--tuner",
        children: [
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__header",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $eec4795e5e45e013$export$bbadff23f5cd28e2), {})
            }),
            /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $426855828ad13772$export$d26b06b1c23125d9), {
                    children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $498f92cc015a2474$export$e3dfad9aac8625a9), {})
                })
            })
        ]
    });
}


var $d24667451fca8b14$var$router = (0, $76b4f75f035f6acf$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $0da8ea1c63cdd660$export$36d69433c4f81145), {})
    },
    {
        path: "/metronome",
        element: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $bea7d613d13dc0e9$export$e7dc8da1baeb1d74), {})
    },
    {
        path: "/metronome/:id",
        element: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $069ffc9d6ca5dd76$export$de8986d3bdd505e5), {})
    },
    {
        path: "/sightear",
        element: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $ed2aa53936f12502$export$80bd160dda242578), {})
    },
    {
        path: "/tuner",
        element: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $909818b8100c123f$export$9436c6ab8004a19b), {})
    }
], {
    basename: "/MusicPal"
});
function $d24667451fca8b14$export$86fbec116b87613f(props) {
    var dexie = props.dexie;
    return /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $c5efbd2e0c4166b1$export$391446ce2f0d1557), {
        dexie: dexie,
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $6c6c68292fd863a8$export$20d2b7652facc723), {
            children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $76b4f75f035f6acf$export$323e4fc2fa4753fb), {
                router: $d24667451fca8b14$var$router
            })
        })
    });
}




var $7FyBz = parcelRequire("7FyBz");
!function(e) {
    function t(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
            exports: {},
            id: n,
            loaded: !1
        };
        return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.p = "", t(0);
}([
    function(e, t, r) {
        "use strict";
        function n(e) {
            return e && e.__esModule ? e : {
                "default": e
            };
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var o = r(4), i = n(o);
        if ("undefined" == typeof Intl) try {
            window.Intl = i["default"];
        } catch (a) {
            console.error(a.message);
        }
        t["default"] = i["default"];
    },
    function(e, t, r) {
        "use strict";
        function n(e) {
            return e && e.__esModule ? e : {
                "default": e
            };
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.Record = t.getOption = t.getNumberOption = t.getInternalProperties = t.internals = t.defineInternal = t.dateTimeComponents = void 0;
        var o = r(6), i = n(o), a = r(8), u = n(a), l = r(7), c = r(5), s = n(c);
        t.dateTimeComponents = i["default"], t.defineInternal = a.defineInternal, t.internals = u["default"], t.getInternalProperties = a.getInternalProperties, t.getNumberOption = l.getNumberOption, t.getOption = l.getOption, t.Record = s["default"];
    },
    function(e, t, r) {
        "use strict";
        function n(e) {
            var _$t = {}, _$r = null;
            return "undefined" != typeof e ? Object.keys(e).forEach(function(n) {
                _$t[n] = e[n], "all" !== _$r && (m.has(n) ? _$r = _$r && "time" === _$r ? "all" : "date" : b.has(n) && (_$r = _$r && "date" === _$r ? "all" : "time"));
            }) : _$r = "all", "date" !== _$r && "all" !== _$r || (_$t.month = _$t.month || "numeric", _$t.day = _$t.day || "numeric"), "time" !== _$r && "all" !== _$r || (_$t.hour = _$t.hour || "numeric", _$t.minute = _$t.minute || "numeric"), _$t;
        }
        function o(e) {
            var _$t = [];
            if (e.year && _$t.push("y"), e.month) switch(e.month){
                case "short":
                    _$t.push("MMM");
                    break;
                case "long":
                    _$t.push("MMMM");
                    break;
                default:
                    _$t.push("M");
            }
            return e.weekday && ("long" === e.weekday ? _$t.push("EEEE") : _$t.push("E")), e.day && ("2-digit" === e.day ? _$t.push("dd") : _$t.push("d")), e.hour && ("2-digit" === e.hour ? _$t.push("hh") : _$t.push("h")), e.minute && ("2-digit" === e.minute ? _$t.push("mm") : _$t.push("m")), e.second && ("2-digit" === e.second ? _$t.push("ss") : _$t.push("s")), _$t.join("");
        }
        function i() {
            var e = arguments.length <= 0 ? void 0 : arguments[0], _$t = arguments.length <= 1 ? void 0 : arguments[1], _$r = Object(this), _$i = window.IntlLocaleData && window.IntlLocaleData[e];
            if ("undefined" == typeof _$i) throw new Error("IntlLocaleData[" + e + "] is not defined");
            var a = (0, d.getInternalProperties)(_$r);
            (0, d.defineInternal)(_$r, a), a["[[initializedIntlObject]]"] = !0;
            var u = n(_$t);
            return a["[[locale]]"] = e, a["[[numberingSystem]]"] = "arab", a["[[calendar]]"] = "gregory", a["[[style]]"] = "decimal", a["[[timeZone]]"] = "UTC", a["[[pattern]]"] = o(u), a["[[localeData]]"] = _$i, _$r;
        }
        function a(e) {
            var _$t = parseInt(e, 10);
            return _$t < 10 ? "0" + _$t : e;
        }
        function u(e, t, r) {
            switch(e){
                case "a":
                    return r.dayPeriods[t.getHours() < 12 ? "am" : "pm"];
                case "d":
                    return t.getDate().toString();
                case "dd":
                    return a(t.getDate());
                case "h":
                    return t.getHours() % 12 === 0 ? "12" : (t.getHours() % 12).toString();
                case "hh":
                    return t.getHours() % 12 === 0 ? "12" : a(t.getHours() % 12);
                case "H":
                    return t.getHours().toString();
                case "HH":
                    return a(t.getHours());
                case "m":
                    return t.getMinutes().toString();
                case "mm":
                    return a(t.getMinutes());
                case "MMM":
                    return r.months["short"][t.getMonth()];
                case "MMMM":
                    return r.months["long"][t.getMonth()];
                case "y":
                    return t.getFullYear().toString();
                default:
                    throw new Error("getPart: no pattern for " + e);
            }
        }
        function l(e, t, r) {
            var n = r.date.formats[t];
            if (!n) throw new Error("no pattern defined for " + t);
            for(var o = [], _$i = 0, a = 0; a < n.length; ++a){
                var l = n[a];
                y.indexOf(l) === -1 ? (a && n[a - 1] !== l && _$i !== -1 && (o.push(u(n.substring(_$i, a), e, r)), _$i = -1), a && o.push(l)) : _$i === -1 && (_$i = a);
            }
            return _$i !== -1 && o.push(u(n.substring(_$i, n.length), e, r)), o.join("").replace(/'/g, "");
        }
        function c() {
            var e = null !== this && "object" === s(this) && (0, d.getInternalProperties)(this);
            if (!e || !e["[[initializedIntlObject]]"]) throw new TypeError("`this` value for format() is not an initialized Intl.DateTimeFormat object.");
            if ("undefined" == typeof e["[[boundFormat]]"]) {
                var _$t = function t(t) {
                    return l(new Date(t || Date.now()), e["[[pattern]]"], e["[[localeData]]"]);
                }, _$r = Function.prototype.bind.call(_$t, this);
                e["[[boundFormat]]"] = _$r;
            }
            return e["[[boundFormat]]"];
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var s = "function" == typeof Symbol && "symbol" == (0, $7FyBz._)(Symbol.iterator) ? function s(e) {
            return typeof e === "undefined" ? "undefined" : (0, $7FyBz._)(e);
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $7FyBz._)(e);
        };
        t["default"] = i, t.getFormatDateTime = c;
        var d = r(1), f = [
            "year",
            "month",
            "weekday",
            "day"
        ], p = [
            "hour",
            "minute",
            "second"
        ], m = new Map;
        f.forEach(function(e) {
            return m.set(e, !0);
        });
        var b = new Map;
        p.forEach(function(e) {
            return b.set(e, !0);
        });
        var y = [
            "y",
            "Y",
            "E",
            "M",
            "m",
            "a",
            "d"
        ];
    },
    function(e, t, r) {
        "use strict";
        function n() {
            var e = Object(this), _$t = (0, a.getInternalProperties)(e);
            return (0, a.defineInternal)(e, _$t), _$t["[[initializedIntlObject]]"] = !0, e;
        }
        function o() {
            var e = null !== this && "object" === i(this) && (0, a.getInternalProperties)(this);
            if (!e || !e["[[initializedIntlObject]]"]) throw new TypeError("`this` value for format() is not an initialized Intl.DateTimeFormat object.");
            if ("undefined" == typeof e["[[boundFormat]]"]) {
                var _$t = function t(e) {
                    return e;
                }, _$r = Function.prototype.bind.call(_$t, this);
                e["[[boundFormat]]"] = _$r;
            }
            return e["[[boundFormat]]"];
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var i = "function" == typeof Symbol && "symbol" == (0, $7FyBz._)(Symbol.iterator) ? function i(e) {
            return typeof e === "undefined" ? "undefined" : (0, $7FyBz._)(e);
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $7FyBz._)(e);
        };
        t["default"] = n, t.getFormattedNumber = o;
        var a = r(1);
    },
    function(e, t, r) {
        "use strict";
        function n(e) {
            return e && e.__esModule ? e : {
                "default": e
            };
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var o = r(2), i = n(o), a = r(3), u = n(a), l = {};
        Object.defineProperty(l, "DateTimeFormat", {
            configurable: !0,
            writable: !0,
            value: i["default"]
        }), Object.defineProperty(l.DateTimeFormat.prototype, "format", {
            configurable: !0,
            get: o.getFormatDateTime
        }), Object.defineProperty(l, "NumberFormat", {
            configurable: !0,
            writable: !0,
            value: u["default"]
        }), Object.defineProperty(l.NumberFormat.prototype, "format", {
            configurable: !0,
            get: a.getFormattedNumber
        }), Object.defineProperty(l.DateTimeFormat, "prototype", {
            writable: !1
        }), Object.defineProperty(l.NumberFormat, "prototype", {
            writable: !1
        }), t["default"] = l;
    },
    function(e, t) {
        "use strict";
        function r(e) {
            var _$t = this;
            Object.keys(e).forEach(function(n) {
                (e instanceof r || Object.prototype.hasOwnProperty.call(e, n)) && Object.defineProperty(_$t, n, {
                    value: e[n],
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                });
            });
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), r.prototype = Object(null), t["default"] = r;
    },
    function(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var r = {
            year: [
                "2-digit",
                "numeric"
            ],
            month: [
                "2-digit",
                "numeric",
                "short",
                "long"
            ],
            day: [
                "2-digit",
                "numeric"
            ],
            hour: [
                "2-digit",
                "numeric"
            ],
            minute: [
                "2-digit",
                "numeric"
            ],
            second: [
                "2-digit",
                "numeric"
            ],
            weekday: [
                "short",
                "long"
            ]
        };
        t["default"] = r;
    },
    function(e, t) {
        "use strict";
        function r(e, t, r, n, o) {
            var i = e[t];
            if ("undefined" != typeof i) {
                if (i = Number(i), isNaN(i) || i < r || i > n) throw new RangeError("Value is not a number or outside accepted range");
                return Math.floor(i);
            }
            return o;
        }
        function n(e, t, r, n, o) {
            var i = e[t];
            if ("undefined" != typeof i) {
                if ("boolean" === r ? i = Boolean(i) : "string" === r && (i = String(i)), "undefined" != typeof n && n.indexOf(i) === -1) throw new RangeError("'" + i + "' is not an allowed value for \"" + t + '"');
                return i;
            }
            return o;
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.getNumberOption = r, t.getOption = n;
    },
    function(e, t) {
        "use strict";
        function r(e, t) {
            if (t["[[initializedIntlObject]]"] === !0) throw new TypeError("`this` object has already been initialized as an Intl object");
            var _$r = function r() {
                if ((arguments.length <= 0 ? void 0 : arguments[0]) === i) return t;
            };
            Object.defineProperty(e, "__getInternalProperties", {
                value: _$r
            });
        }
        function n(e) {
            return Object.prototype.hasOwnProperty.call(e, "__getInternalProperties") ? e.__getInternalProperties(i) : Object.create(null);
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.defineInternal = r, t.getInternalProperties = n;
        var o = Object(null), i = Math.random();
        t["default"] = o;
    }
]);



var $7df20cd61637f0aa$var$container = document.getElementById("app");
var $7df20cd61637f0aa$var$root = (0, $09dc9bbe6193c50d$export$882461b6382ed46c)($7df20cd61637f0aa$var$container);
var $7df20cd61637f0aa$var$dexie = new (0, $c5efbd2e0c4166b1$export$426b5a85803d33b1)();
$7df20cd61637f0aa$var$dexie.rhythms.toArray().then(function(rhythms) {
    if (rhythms.length === 0) return $7df20cd61637f0aa$var$dexie.init();
}).then(function() {
    $7df20cd61637f0aa$var$root.render(/*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8SyCD))).StrictMode, {
        children: /*#__PURE__*/ (0, $79ec79cf06303d09$exports.jsx)((0, $d24667451fca8b14$export$86fbec116b87613f), {
            dexie: $7df20cd61637f0aa$var$dexie
        })
    }));
});

})();
//# sourceMappingURL=index.9b090ff7.js.map
